export const SeaRegions = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [22.927, 58.978],
              [22.904, 59.815],
              [22.905, 59.814],
              [22.908, 59.813],
              [22.911, 59.813],
              [22.915, 59.814],
              [22.919, 59.814],
              [22.927, 59.817],
              [22.937, 59.819],
              [22.943, 59.819],
              [22.96, 59.82],
              [22.966, 59.821],
              [22.985, 59.823],
              [22.991, 59.824],
              [23.045, 59.824],
              [23.055, 59.825],
              [23.058, 59.826],
              [23.063, 59.827],
              [23.067, 59.828],
              [23.079, 59.829],
              [23.089, 59.83],
              [23.1, 59.83],
              [23.104, 59.829],
              [23.109, 59.829],
              [23.114, 59.828],
              [23.125, 59.828],
              [23.131, 59.829],
              [23.143, 59.829],
              [23.162, 59.832],
              [23.169, 59.832],
              [23.182, 59.833],
              [23.212, 59.838],
              [23.227, 59.841],
              [23.231, 59.842],
              [23.234, 59.843],
              [23.237, 59.845],
              [23.237, 59.846],
              [23.236, 59.847],
              [23.229, 59.848],
              [23.228, 59.848],
              [23.228, 59.85],
              [23.23, 59.853],
              [23.232, 59.857],
              [23.233, 59.86],
              [23.233, 59.863],
              [23.231, 59.869],
              [23.231, 59.882],
              [23.233, 59.885],
              [23.236, 59.889],
              [23.24, 59.892],
              [23.25, 59.896],
              [23.256, 59.899],
              [23.262, 59.9],
              [23.281, 59.906],
              [23.293, 59.91],
              [23.3, 59.913],
              [23.315, 59.919],
              [23.322, 59.922],
              [23.353, 59.933],
              [23.36, 59.936],
              [23.366, 59.939],
              [23.371, 59.942],
              [23.377, 59.945],
              [23.382, 59.949],
              [23.404, 59.971],
              [23.408, 59.974],
              [23.413, 59.978],
              [23.424, 59.984],
              [23.429, 59.988],
              [23.434, 59.991],
              [23.444, 59.999],
              [23.448, 60.003],
              [23.452, 60.008],
              [23.456, 60.012],
              [23.459, 60.017],
              [23.462, 60.023],
              [23.466, 60.034],
              [23.468, 60.039],
              [23.471, 60.043],
              [23.474, 60.046],
              [23.477, 60.048],
              [23.485, 60.053],
              [23.489, 60.055],
              [23.495, 60.06],
              [23.509, 60.071],
              [23.513, 60.074],
              [23.521, 60.082],
              [23.526, 60.085],
              [23.53, 60.088],
              [23.535, 60.09],
              [23.54, 60.091],
              [23.544, 60.092],
              [23.548, 60.092],
              [23.55, 60.091],
              [23.551, 60.089],
              [23.551, 60.087],
              [23.549, 60.084],
              [23.545, 60.076],
              [23.542, 60.071],
              [23.541, 60.066],
              [23.537, 60.057],
              [23.535, 60.052],
              [23.533, 60.048],
              [23.529, 60.045],
              [23.519, 60.039],
              [23.508, 60.034],
              [23.502, 60.031],
              [23.497, 60.028],
              [23.493, 60.025],
              [23.49, 60.022],
              [23.487, 60.018],
              [23.485, 60.015],
              [23.481, 60.008],
              [23.475, 60.002],
              [23.472, 60],
              [23.464, 59.995],
              [23.46, 59.992],
              [23.449, 59.984],
              [23.445, 59.982],
              [23.441, 59.976],
              [23.44, 59.973],
              [23.441, 59.971],
              [23.443, 59.969],
              [23.457, 59.969],
              [23.463, 59.97],
              [23.469, 59.972],
              [23.475, 59.973],
              [23.491, 59.979],
              [23.509, 59.982],
              [23.534, 59.985],
              [23.552, 59.988],
              [23.563, 59.988],
              [23.564, 59.987],
              [23.562, 59.986],
              [23.559, 59.985],
              [23.555, 59.984],
              [23.55, 59.982],
              [23.538, 59.979],
              [23.503, 59.972],
              [23.49, 59.968],
              [23.484, 59.967],
              [23.478, 59.965],
              [23.47, 59.961],
              [23.467, 59.958],
              [23.466, 59.956],
              [23.467, 59.954],
              [23.467, 59.953],
              [23.469, 59.951],
              [23.473, 59.948],
              [23.474, 59.947],
              [23.474, 59.946],
              [23.472, 59.945],
              [23.469, 59.944],
              [23.467, 59.943],
              [23.455, 59.943],
              [23.444, 59.944],
              [23.425, 59.947],
              [23.411, 59.947],
              [23.407, 59.946],
              [23.402, 59.944],
              [23.398, 59.942],
              [23.395, 59.94],
              [23.393, 59.938],
              [23.392, 59.935],
              [23.393, 59.932],
              [23.395, 59.929],
              [23.399, 59.926],
              [23.409, 59.922],
              [23.421, 59.92],
              [23.428, 59.92],
              [23.435, 59.921],
              [23.441, 59.921],
              [23.455, 59.923],
              [23.473, 59.926],
              [23.489, 59.93],
              [23.499, 59.931],
              [23.521, 59.935],
              [23.527, 59.936],
              [23.534, 59.937],
              [23.541, 59.937],
              [23.555, 59.938],
              [23.576, 59.938],
              [23.647, 59.937],
              [23.679, 59.937],
              [23.685, 59.938],
              [23.689, 59.938],
              [23.692, 59.939],
              [23.694, 59.939],
              [23.697, 59.941],
              [23.703, 59.943],
              [23.71, 59.944],
              [23.713, 59.944],
              [23.716, 59.945],
              [23.717, 59.947],
              [23.715, 59.951],
              [23.707, 59.955],
              [23.705, 59.957],
              [23.704, 59.959],
              [23.699, 59.964],
              [23.693, 59.966],
              [23.688, 59.966],
              [23.683, 59.964],
              [23.675, 59.964],
              [23.663, 59.963],
              [23.648, 59.963],
              [23.648, 59.964],
              [23.649, 59.966],
              [23.651, 59.968],
              [23.656, 59.971],
              [23.657, 59.972],
              [23.66, 59.973],
              [23.664, 59.973],
              [23.678, 59.975],
              [23.687, 59.975],
              [23.692, 59.974],
              [23.709, 59.972],
              [23.711, 59.972],
              [23.715, 59.971],
              [23.723, 59.968],
              [23.728, 59.968],
              [23.732, 59.967],
              [23.737, 59.968],
              [23.748, 59.969],
              [23.754, 59.97],
              [23.793, 59.97],
              [23.8, 59.971],
              [23.806, 59.972],
              [23.818, 59.976],
              [23.828, 59.982],
              [23.837, 59.991],
              [23.84, 59.992],
              [23.847, 59.996],
              [23.857, 60],
              [23.863, 60.002],
              [23.874, 60.005],
              [23.878, 60.006],
              [23.884, 60.009],
              [23.885, 60.011],
              [23.884, 60.012],
              [23.881, 60.013],
              [23.873, 60.015],
              [23.856, 60.017],
              [23.853, 60.018],
              [23.852, 60.018],
              [23.853, 60.019],
              [23.855, 60.019],
              [23.858, 60.02],
              [23.879, 60.02],
              [23.886, 60.019],
              [23.893, 60.019],
              [23.906, 60.018],
              [23.926, 60.016],
              [23.939, 60.015],
              [23.955, 60.015],
              [23.958, 60.016],
              [23.96, 60.016],
              [23.963, 60.017],
              [23.973, 60.022],
              [23.984, 60.026],
              [23.994, 60.03],
              [24.005, 60.034],
              [24.009, 60.035],
              [24.014, 60.036],
              [24.019, 60.036],
              [24.023, 60.034],
              [24.033, 60.031],
              [24.048, 60.028],
              [24.054, 60.026],
              [24.059, 60.026],
              [24.063, 60.025],
              [24.068, 60.024],
              [24.076, 60.024],
              [24.08, 60.025],
              [24.082, 60.025],
              [24.083, 60.026],
              [24.084, 60.026],
              [24.084, 60.028],
              [24.083, 60.03],
              [24.083, 60.032],
              [24.087, 60.034],
              [24.088, 60.034],
              [24.098, 60.032],
              [24.111, 60.032],
              [24.115, 60.033],
              [24.121, 60.035],
              [24.127, 60.039],
              [24.13, 60.042],
              [24.134, 60.043],
              [24.137, 60.045],
              [24.144, 60.045],
              [24.146, 60.041],
              [24.149, 60.039],
              [24.152, 60.036],
              [24.155, 60.034],
              [24.16, 60.032],
              [24.17, 60.03],
              [24.179, 60.03],
              [24.187, 60.032],
              [24.189, 60.033],
              [24.189, 60.037],
              [24.187, 60.038],
              [24.185, 60.041],
              [24.178, 60.048],
              [24.177, 60.05],
              [24.178, 60.052],
              [24.18, 60.054],
              [24.188, 60.056],
              [24.198, 60.056],
              [24.203, 60.055],
              [24.207, 60.054],
              [24.214, 60.052],
              [24.222, 60.05],
              [24.229, 60.05],
              [24.24, 60.048],
              [24.245, 60.047],
              [24.255, 60.046],
              [24.262, 60.045],
              [24.266, 60.045],
              [24.269, 60.046],
              [24.271, 60.047],
              [24.278, 60.051],
              [24.281, 60.053],
              [24.285, 60.054],
              [24.297, 60.058],
              [24.3, 60.06],
              [24.303, 60.061],
              [24.305, 60.063],
              [24.306, 60.065],
              [24.306, 60.075],
              [24.307, 60.078],
              [24.313, 60.082],
              [24.316, 60.083],
              [24.324, 60.085],
              [24.329, 60.086],
              [24.336, 60.088],
              [24.34, 60.089],
              [24.345, 60.09],
              [24.35, 60.09],
              [24.356, 60.089],
              [24.361, 60.089],
              [24.367, 60.087],
              [24.371, 60.086],
              [24.377, 60.083],
              [24.378, 60.081],
              [24.377, 60.079],
              [24.375, 60.071],
              [24.373, 60.064],
              [24.373, 60.062],
              [24.372, 60.06],
              [24.37, 60.057],
              [24.36, 60.043],
              [24.353, 60.036],
              [24.346, 60.03],
              [24.339, 60.023],
              [24.336, 60.019],
              [24.334, 60.016],
              [24.333, 60.013],
              [24.333, 60.011],
              [24.334, 60.01],
              [24.339, 60.01],
              [24.342, 60.012],
              [24.345, 60.013],
              [24.348, 60.015],
              [24.353, 60.02],
              [24.356, 60.021],
              [24.36, 60.023],
              [24.363, 60.024],
              [24.37, 60.026],
              [24.376, 60.026],
              [24.38, 60.025],
              [24.383, 60.024],
              [24.391, 60.022],
              [24.395, 60.023],
              [24.4, 60.023],
              [24.405, 60.024],
              [24.409, 60.026],
              [24.434, 60.038],
              [24.449, 60.045],
              [24.454, 60.048],
              [24.458, 60.05],
              [24.466, 60.055],
              [24.469, 60.057],
              [24.471, 60.058],
              [24.471, 60.057],
              [24.472, 60.056],
              [24.472, 60.05],
              [24.471, 60.048],
              [24.46, 60.037],
              [24.46, 60.036],
              [24.465, 60.036],
              [24.465, 60.035],
              [24.464, 60.033],
              [24.459, 60.028],
              [24.44, 60.013],
              [24.437, 60.011],
              [24.432, 60.006],
              [24.429, 60.001],
              [24.421, 59.993],
              [24.417, 59.99],
              [24.406, 59.982],
              [24.402, 59.978],
              [24.402, 59.977],
              [24.403, 59.975],
              [24.405, 59.975],
              [24.408, 59.976],
              [24.418, 59.979],
              [24.422, 59.98],
              [24.43, 59.981],
              [24.435, 59.982],
              [24.439, 59.983],
              [24.447, 59.987],
              [24.449, 59.99],
              [24.451, 59.994],
              [24.451, 59.996],
              [24.45, 59.999],
              [24.45, 60.001],
              [24.449, 60.003],
              [24.448, 60.004],
              [24.453, 60.004],
              [24.458, 60.001],
              [24.461, 60],
              [24.471, 59.997],
              [24.481, 59.997],
              [24.485, 59.998],
              [24.499, 60.002],
              [24.503, 60.003],
              [24.512, 60.009],
              [24.515, 60.014],
              [24.518, 60.016],
              [24.521, 60.019],
              [24.524, 60.021],
              [24.532, 60.026],
              [24.537, 60.029],
              [24.553, 60.045],
              [24.558, 60.048],
              [24.564, 60.052],
              [24.57, 60.055],
              [24.576, 60.059],
              [24.593, 60.069],
              [24.604, 60.075],
              [24.609, 60.078],
              [24.613, 60.081],
              [24.618, 60.085],
              [24.621, 60.087],
              [24.624, 60.088],
              [24.628, 60.09],
              [24.631, 60.092],
              [24.634, 60.093],
              [24.636, 60.095],
              [24.637, 60.097],
              [24.638, 60.098],
              [24.636, 60.099],
              [24.633, 60.1],
              [24.629, 60.1],
              [24.625, 60.099],
              [24.611, 60.097],
              [24.602, 60.097],
              [24.602, 60.099],
              [24.605, 60.101],
              [24.608, 60.102],
              [24.616, 60.106],
              [24.628, 60.11],
              [24.632, 60.112],
              [24.632, 60.115],
              [24.63, 60.116],
              [24.627, 60.117],
              [24.614, 60.117],
              [24.609, 60.116],
              [24.603, 60.114],
              [24.598, 60.113],
              [24.585, 60.109],
              [24.583, 60.108],
              [24.582, 60.108],
              [24.582, 60.109],
              [24.597, 60.119],
              [24.602, 60.122],
              [24.613, 60.133],
              [24.615, 60.137],
              [24.614, 60.141],
              [24.612, 60.145],
              [24.609, 60.149],
              [24.604, 60.152],
              [24.6, 60.154],
              [24.595, 60.156],
              [24.589, 60.157],
              [24.569, 60.162],
              [24.566, 60.163],
              [24.564, 60.165],
              [24.564, 60.166],
              [24.565, 60.168],
              [24.567, 60.169],
              [24.57, 60.17],
              [24.573, 60.169],
              [24.576, 60.169],
              [24.585, 60.166],
              [24.597, 60.163],
              [24.61, 60.158],
              [24.616, 60.156],
              [24.628, 60.15],
              [24.64, 60.143],
              [24.649, 60.138],
              [24.654, 60.136],
              [24.657, 60.134],
              [24.671, 60.128],
              [24.675, 60.126],
              [24.681, 60.126],
              [24.683, 60.127],
              [24.686, 60.128],
              [24.688, 60.129],
              [24.691, 60.131],
              [24.693, 60.132],
              [24.696, 60.135],
              [24.697, 60.137],
              [24.705, 60.141],
              [24.709, 60.142],
              [24.715, 60.144],
              [24.72, 60.145],
              [24.726, 60.145],
              [24.737, 60.146],
              [24.741, 60.147],
              [24.746, 60.147],
              [24.75, 60.148],
              [24.755, 60.149],
              [24.769, 60.154],
              [24.787, 60.157],
              [24.792, 60.159],
              [24.797, 60.16],
              [24.807, 60.164],
              [24.811, 60.166],
              [24.818, 60.169],
              [24.827, 60.172],
              [24.829, 60.173],
              [24.831, 60.177],
              [24.831, 60.186],
              [24.825, 60.192],
              [24.824, 60.194],
              [24.824, 60.196],
              [24.826, 60.198],
              [24.829, 60.2],
              [24.832, 60.201],
              [24.836, 60.202],
              [24.844, 60.202],
              [24.85, 60.201],
              [24.855, 60.2],
              [24.866, 60.196],
              [24.871, 60.194],
              [24.873, 60.194],
              [24.88, 60.193],
              [24.883, 60.192],
              [24.893, 60.187],
              [24.896, 60.185],
              [24.899, 60.184],
              [24.902, 60.182],
              [24.904, 60.18],
              [24.906, 60.176],
              [24.906, 60.173],
              [24.908, 60.17],
              [24.908, 60.167],
              [24.907, 60.166],
              [24.907, 60.164],
              [24.908, 60.163],
              [24.908, 60.162],
              [24.911, 60.16],
              [24.912, 60.159],
              [24.912, 60.156],
              [24.913, 60.155],
              [24.917, 60.153],
              [24.919, 60.153],
              [24.922, 60.154],
              [24.925, 60.154],
              [24.929, 60.153],
              [24.934, 60.153],
              [24.946, 60.156],
              [24.95, 60.158],
              [24.953, 60.16],
              [24.956, 60.163],
              [24.958, 60.168],
              [24.958, 60.17],
              [24.959, 60.172],
              [24.958, 60.173],
              [24.957, 60.175],
              [24.955, 60.176],
              [24.955, 60.179],
              [24.956, 60.18],
              [24.959, 60.182],
              [24.967, 60.185],
              [24.971, 60.187],
              [24.974, 60.19],
              [24.977, 60.194],
              [24.984, 60.205],
              [24.989, 60.21],
              [24.995, 60.213],
              [25.002, 60.213],
              [25.006, 60.212],
              [25.009, 60.211],
              [25.012, 60.209],
              [25.014, 60.206],
              [25.015, 60.204],
              [25.015, 60.201],
              [25.013, 60.197],
              [25.013, 60.195],
              [25.014, 60.193],
              [25.017, 60.192],
              [25.025, 60.19],
              [25.036, 60.19],
              [25.042, 60.191],
              [25.049, 60.193],
              [25.069, 60.197],
              [25.085, 60.201],
              [25.09, 60.202],
              [25.095, 60.204],
              [25.1, 60.205],
              [25.108, 60.208],
              [25.111, 60.209],
              [25.112, 60.209],
              [25.112, 60.207],
              [25.111, 60.205],
              [25.106, 60.2],
              [25.104, 60.196],
              [25.103, 60.195],
              [25.103, 60.193],
              [25.105, 60.193],
              [25.107, 60.192],
              [25.118, 60.193],
              [25.123, 60.192],
              [25.127, 60.192],
              [25.136, 60.19],
              [25.139, 60.189],
              [25.144, 60.189],
              [25.146, 60.191],
              [25.146, 60.196],
              [25.147, 60.197],
              [25.149, 60.198],
              [25.153, 60.198],
              [25.157, 60.199],
              [25.173, 60.199],
              [25.177, 60.2],
              [25.179, 60.201],
              [25.189, 60.211],
              [25.191, 60.212],
              [25.191, 60.213],
              [25.192, 60.215],
              [25.192, 60.218],
              [25.19, 60.219],
              [25.188, 60.221],
              [25.182, 60.225],
              [25.179, 60.228],
              [25.181, 60.23],
              [25.191, 60.234],
              [25.193, 60.234],
              [25.202, 60.237],
              [25.203, 60.238],
              [25.204, 60.238],
              [25.205, 60.24],
              [25.206, 60.243],
              [25.206, 60.246],
              [25.205, 60.247],
              [25.204, 60.249],
              [25.204, 60.25],
              [25.206, 60.252],
              [25.209, 60.254],
              [25.213, 60.255],
              [25.223, 60.257],
              [25.241, 60.257],
              [25.246, 60.256],
              [25.257, 60.254],
              [25.263, 60.253],
              [25.289, 60.253],
              [25.295, 60.254],
              [25.301, 60.254],
              [25.313, 60.256],
              [25.317, 60.257],
              [25.322, 60.259],
              [25.326, 60.26],
              [25.329, 60.261],
              [25.332, 60.263],
              [25.334, 60.264],
              [25.335, 60.266],
              [25.336, 60.269],
              [25.336, 60.271],
              [25.337, 60.273],
              [25.338, 60.274],
              [25.343, 60.274],
              [25.35, 60.271],
              [25.354, 60.271],
              [25.359, 60.27],
              [25.368, 60.269],
              [25.372, 60.269],
              [25.377, 60.267],
              [25.387, 60.262],
              [25.389, 60.26],
              [25.399, 60.258],
              [25.404, 60.258],
              [25.42, 60.257],
              [25.425, 60.257],
              [25.428, 60.256],
              [25.433, 60.255],
              [25.437, 60.255],
              [25.439, 60.257],
              [25.439, 60.258],
              [25.44, 60.259],
              [25.444, 60.259],
              [25.45, 60.258],
              [25.452, 60.257],
              [25.456, 60.256],
              [25.465, 60.256],
              [25.472, 60.257],
              [25.474, 60.257],
              [25.479, 60.258],
              [25.489, 60.258],
              [25.49, 60.257],
              [25.494, 60.257],
              [25.496, 60.258],
              [25.499, 60.26],
              [25.519, 60.28],
              [25.524, 60.284],
              [25.526, 60.285],
              [25.532, 60.289],
              [25.534, 60.29],
              [25.537, 60.293],
              [25.539, 60.296],
              [25.541, 60.3],
              [25.542, 60.304],
              [25.543, 60.307],
              [25.542, 60.311],
              [25.541, 60.313],
              [25.537, 60.319],
              [25.53, 60.326],
              [25.53, 60.33],
              [25.533, 60.331],
              [25.536, 60.333],
              [25.544, 60.335],
              [25.552, 60.335],
              [25.557, 60.334],
              [25.561, 60.334],
              [25.568, 60.333],
              [25.571, 60.332],
              [25.58, 60.326],
              [25.583, 60.325],
              [25.585, 60.324],
              [25.588, 60.325],
              [25.59, 60.326],
              [25.599, 60.332],
              [25.601, 60.334],
              [25.604, 60.335],
              [25.61, 60.336],
              [25.613, 60.337],
              [25.619, 60.341],
              [25.629, 60.351],
              [25.634, 60.355],
              [25.638, 60.358],
              [25.643, 60.362],
              [25.658, 60.371],
              [25.664, 60.373],
              [25.669, 60.375],
              [25.674, 60.376],
              [25.676, 60.377],
              [25.682, 60.377],
              [25.686, 60.376],
              [25.689, 60.375],
              [25.695, 60.371],
              [25.697, 60.369],
              [25.7, 60.363],
              [25.707, 60.356],
              [25.709, 60.353],
              [25.71, 60.35],
              [25.711, 60.348],
              [25.71, 60.346],
              [25.707, 60.343],
              [25.703, 60.341],
              [25.699, 60.34],
              [25.686, 60.348],
              [25.677, 60.353],
              [25.673, 60.355],
              [25.67, 60.357],
              [25.668, 60.357],
              [25.665, 60.358],
              [25.663, 60.359],
              [25.66, 60.359],
              [25.658, 60.358],
              [25.656, 60.358],
              [25.653, 60.357],
              [25.645, 60.353],
              [25.643, 60.349],
              [25.643, 60.343],
              [25.645, 60.339],
              [25.648, 60.336],
              [25.65, 60.336],
              [25.653, 60.335],
              [25.663, 60.335],
              [25.672, 60.336],
              [25.69, 60.337],
              [25.685, 60.337],
              [25.665, 60.333],
              [25.659, 60.331],
              [25.653, 60.33],
              [25.643, 60.326],
              [25.639, 60.32],
              [25.64, 60.317],
              [25.641, 60.313],
              [25.642, 60.311],
              [25.646, 60.307],
              [25.647, 60.304],
              [25.649, 60.301],
              [25.652, 60.298],
              [25.662, 60.29],
              [25.668, 60.284],
              [25.676, 60.28],
              [25.682, 60.279],
              [25.698, 60.275],
              [25.703, 60.273],
              [25.707, 60.272],
              [25.713, 60.268],
              [25.715, 60.266],
              [25.719, 60.263],
              [25.723, 60.261],
              [25.728, 60.258],
              [25.732, 60.256],
              [25.742, 60.252],
              [25.75, 60.25],
              [25.76, 60.25],
              [25.763, 60.249],
              [25.771, 60.247],
              [25.775, 60.247],
              [25.78, 60.246],
              [25.784, 60.247],
              [25.787, 60.248],
              [25.79, 60.25],
              [25.795, 60.256],
              [25.798, 60.259],
              [25.803, 60.261],
              [25.807, 60.262],
              [25.823, 60.265],
              [25.828, 60.266],
              [25.832, 60.268],
              [25.835, 60.27],
              [25.837, 60.272],
              [25.838, 60.274],
              [25.836, 60.275],
              [25.833, 60.277],
              [25.829, 60.278],
              [25.806, 60.282],
              [25.8, 60.283],
              [25.794, 60.285],
              [25.788, 60.288],
              [25.783, 60.29],
              [25.777, 60.294],
              [25.772, 60.297],
              [25.763, 60.304],
              [25.759, 60.307],
              [25.751, 60.311],
              [25.751, 60.314],
              [25.754, 60.314],
              [25.758, 60.313],
              [25.763, 60.311],
              [25.785, 60.299],
              [25.791, 60.297],
              [25.798, 60.294],
              [25.804, 60.292],
              [25.811, 60.291],
              [25.818, 60.289],
              [25.837, 60.287],
              [25.843, 60.286],
              [25.849, 60.284],
              [25.853, 60.282],
              [25.856, 60.28],
              [25.867, 60.269],
              [25.87, 60.265],
              [25.873, 60.26],
              [25.875, 60.257],
              [25.877, 60.255],
              [25.881, 60.254],
              [25.885, 60.252],
              [25.89, 60.251],
              [25.894, 60.25],
              [25.899, 60.25],
              [25.905, 60.251],
              [25.91, 60.252],
              [25.914, 60.253],
              [25.918, 60.255],
              [25.921, 60.257],
              [25.923, 60.259],
              [25.922, 60.261],
              [25.916, 60.267],
              [25.909, 60.275],
              [25.9, 60.284],
              [25.896, 60.29],
              [25.894, 60.297],
              [25.89, 60.305],
              [25.888, 60.308],
              [25.882, 60.315],
              [25.878, 60.321],
              [25.877, 60.323],
              [25.877, 60.326],
              [25.88, 60.332],
              [25.882, 60.334],
              [25.883, 60.336],
              [25.886, 60.337],
              [25.893, 60.34],
              [25.897, 60.342],
              [25.903, 60.346],
              [25.906, 60.349],
              [25.907, 60.353],
              [25.907, 60.356],
              [25.905, 60.364],
              [25.902, 60.368],
              [25.898, 60.372],
              [25.888, 60.379],
              [25.884, 60.383],
              [25.879, 60.387],
              [25.871, 60.395],
              [25.869, 60.399],
              [25.867, 60.401],
              [25.867, 60.403],
              [25.868, 60.404],
              [25.874, 60.402],
              [25.879, 60.4],
              [25.883, 60.398],
              [25.888, 60.395],
              [25.893, 60.391],
              [25.902, 60.384],
              [25.907, 60.38],
              [25.917, 60.374],
              [25.923, 60.372],
              [25.944, 60.362],
              [25.949, 60.36],
              [25.954, 60.359],
              [25.958, 60.358],
              [25.972, 60.358],
              [25.976, 60.359],
              [25.982, 60.363],
              [25.984, 60.364],
              [25.987, 60.365],
              [25.99, 60.364],
              [25.992, 60.362],
              [25.996, 60.355],
              [26, 60.351],
              [26.011, 60.338],
              [26.015, 60.334],
              [26.021, 60.324],
              [26.026, 60.314],
              [26.028, 60.311],
              [26.03, 60.309],
              [26.034, 60.307],
              [26.044, 60.305],
              [26.05, 60.306],
              [26.076, 60.309],
              [26.081, 60.31],
              [26.091, 60.314],
              [26.095, 60.316],
              [26.1, 60.319],
              [26.106, 60.323],
              [26.107, 60.326],
              [26.107, 60.328],
              [26.106, 60.331],
              [26.105, 60.333],
              [26.101, 60.339],
              [26.098, 60.341],
              [26.094, 60.343],
              [26.09, 60.346],
              [26.081, 60.35],
              [26.077, 60.352],
              [26.056, 60.366],
              [26.04, 60.378],
              [26.034, 60.381],
              [26.029, 60.384],
              [26.015, 60.393],
              [26.011, 60.395],
              [26.007, 60.399],
              [26.007, 60.4],
              [26.008, 60.401],
              [26.01, 60.401],
              [26.014, 60.403],
              [26.017, 60.404],
              [26.019, 60.405],
              [26.022, 60.407],
              [26.025, 60.41],
              [26.026, 60.413],
              [26.026, 60.416],
              [26.025, 60.419],
              [26.022, 60.422],
              [26.018, 60.424],
              [26.009, 60.43],
              [26.004, 60.433],
              [25.995, 60.44],
              [25.991, 60.443],
              [25.986, 60.445],
              [25.982, 60.446],
              [25.977, 60.447],
              [25.974, 60.449],
              [25.972, 60.45],
              [25.971, 60.451],
              [25.971, 60.452],
              [25.974, 60.455],
              [25.975, 60.457],
              [25.976, 60.458],
              [25.976, 60.459],
              [25.975, 60.46],
              [25.973, 60.461],
              [25.969, 60.465],
              [25.964, 60.469],
              [25.961, 60.471],
              [25.957, 60.473],
              [25.942, 60.476],
              [25.939, 60.478],
              [25.935, 60.479],
              [25.933, 60.48],
              [25.93, 60.483],
              [25.932, 60.485],
              [25.938, 60.485],
              [25.942, 60.484],
              [25.962, 60.48],
              [25.974, 60.476],
              [25.986, 60.47],
              [25.998, 60.462],
              [26.009, 60.454],
              [26.03, 60.437],
              [26.041, 60.43],
              [26.045, 60.427],
              [26.05, 60.424],
              [26.054, 60.422],
              [26.057, 60.421],
              [26.06, 60.421],
              [26.061, 60.422],
              [26.065, 60.424],
              [26.068, 60.425],
              [26.074, 60.425],
              [26.078, 60.424],
              [26.082, 60.422],
              [26.087, 60.42],
              [26.096, 60.415],
              [26.102, 60.413],
              [26.106, 60.411],
              [26.111, 60.409],
              [26.115, 60.408],
              [26.137, 60.4],
              [26.142, 60.399],
              [26.154, 60.396],
              [26.156, 60.395],
              [26.157, 60.393],
              [26.159, 60.388],
              [26.16, 60.386],
              [26.162, 60.384],
              [26.167, 60.378],
              [26.168, 60.377],
              [26.168, 60.376],
              [26.167, 60.375],
              [26.167, 60.374],
              [26.169, 60.374],
              [26.172, 60.372],
              [26.18, 60.37],
              [26.185, 60.37],
              [26.189, 60.369],
              [26.193, 60.37],
              [26.195, 60.371],
              [26.197, 60.373],
              [26.198, 60.375],
              [26.198, 60.38],
              [26.199, 60.381],
              [26.2, 60.383],
              [26.206, 60.386],
              [26.206, 60.39],
              [26.19, 60.398],
              [26.187, 60.4],
              [26.183, 60.403],
              [26.182, 60.405],
              [26.181, 60.408],
              [26.18, 60.41],
              [26.181, 60.411],
              [26.183, 60.412],
              [26.186, 60.411],
              [26.19, 60.411],
              [26.204, 60.406],
              [26.214, 60.404],
              [26.218, 60.403],
              [26.225, 60.4],
              [26.229, 60.399],
              [26.239, 60.397],
              [26.258, 60.397],
              [26.258, 60.398],
              [26.259, 60.399],
              [26.258, 60.401],
              [26.257, 60.406],
              [26.255, 60.412],
              [26.249, 60.424],
              [26.244, 60.432],
              [26.242, 60.435],
              [26.242, 60.446],
              [26.245, 60.449],
              [26.248, 60.449],
              [26.252, 60.448],
              [26.253, 60.447],
              [26.257, 60.445],
              [26.266, 60.44],
              [26.27, 60.437],
              [26.279, 60.433],
              [26.283, 60.431],
              [26.286, 60.429],
              [26.287, 60.427],
              [26.288, 60.421],
              [26.29, 60.419],
              [26.291, 60.416],
              [26.293, 60.413],
              [26.296, 60.403],
              [26.3, 60.395],
              [26.303, 60.391],
              [26.306, 60.388],
              [26.309, 60.384],
              [26.313, 60.382],
              [26.316, 60.379],
              [26.321, 60.378],
              [26.325, 60.377],
              [26.329, 60.378],
              [26.332, 60.379],
              [26.334, 60.381],
              [26.336, 60.382],
              [26.339, 60.385],
              [26.34, 60.387],
              [26.342, 60.392],
              [26.343, 60.394],
              [26.345, 60.396],
              [26.348, 60.398],
              [26.352, 60.399],
              [26.355, 60.4],
              [26.367, 60.403],
              [26.374, 60.405],
              [26.377, 60.406],
              [26.381, 60.407],
              [26.389, 60.405],
              [26.394, 60.404],
              [26.406, 60.398],
              [26.409, 60.397],
              [26.411, 60.398],
              [26.412, 60.399],
              [26.413, 60.402],
              [26.413, 60.412],
              [26.414, 60.414],
              [26.415, 60.417],
              [26.417, 60.417],
              [26.42, 60.418],
              [26.427, 60.417],
              [26.434, 60.417],
              [26.436, 60.418],
              [26.439, 60.419],
              [26.442, 60.422],
              [26.448, 60.424],
              [26.45, 60.426],
              [26.452, 60.429],
              [26.454, 60.437],
              [26.454, 60.442],
              [26.452, 60.452],
              [26.451, 60.456],
              [26.451, 60.461],
              [26.452, 60.465],
              [26.458, 60.474],
              [26.459, 60.476],
              [26.462, 60.478],
              [26.464, 60.478],
              [26.467, 60.479],
              [26.47, 60.478],
              [26.474, 60.477],
              [26.479, 60.474],
              [26.483, 60.471],
              [26.497, 60.462],
              [26.503, 60.459],
              [26.513, 60.453],
              [26.519, 60.452],
              [26.533, 60.447],
              [26.538, 60.446],
              [26.549, 60.442],
              [26.554, 60.44],
              [26.562, 60.44],
              [26.565, 60.441],
              [26.568, 60.444],
              [26.571, 60.446],
              [26.574, 60.449],
              [26.582, 60.453],
              [26.592, 60.455],
              [26.607, 60.455],
              [26.612, 60.454],
              [26.617, 60.454],
              [26.625, 60.452],
              [26.63, 60.45],
              [26.635, 60.447],
              [26.649, 60.439],
              [26.654, 60.436],
              [26.659, 60.434],
              [26.664, 60.433],
              [26.668, 60.432],
              [26.673, 60.431],
              [26.677, 60.432],
              [26.692, 60.433],
              [26.698, 60.434],
              [26.704, 60.436],
              [26.709, 60.438],
              [26.713, 60.44],
              [26.718, 60.442],
              [26.726, 60.448],
              [26.733, 60.452],
              [26.736, 60.454],
              [26.739, 60.457],
              [26.741, 60.461],
              [26.743, 60.464],
              [26.744, 60.468],
              [26.746, 60.472],
              [26.748, 60.475],
              [26.751, 60.477],
              [26.754, 60.478],
              [26.766, 60.481],
              [26.774, 60.485],
              [26.777, 60.486],
              [26.78, 60.486],
              [26.782, 60.485],
              [26.783, 60.484],
              [26.783, 60.482],
              [26.781, 60.481],
              [26.778, 60.476],
              [26.777, 60.474],
              [26.777, 60.471],
              [26.778, 60.469],
              [26.781, 60.467],
              [26.784, 60.464],
              [26.792, 60.462],
              [26.798, 60.461],
              [26.81, 60.461],
              [26.827, 60.463],
              [26.832, 60.463],
              [26.837, 60.464],
              [26.842, 60.466],
              [26.846, 60.467],
              [26.856, 60.471],
              [26.861, 60.472],
              [26.874, 60.474],
              [26.877, 60.475],
              [26.885, 60.477],
              [26.89, 60.478],
              [26.895, 60.478],
              [26.9, 60.477],
              [26.915, 60.473],
              [26.92, 60.472],
              [26.928, 60.472],
              [26.931, 60.473],
              [26.933, 60.474],
              [26.936, 60.477],
              [26.937, 60.479],
              [26.937, 60.483],
              [26.936, 60.484],
              [26.935, 60.486],
              [26.933, 60.488],
              [26.927, 60.491],
              [26.925, 60.493],
              [26.925, 60.495],
              [26.927, 60.495],
              [26.932, 60.496],
              [26.935, 60.497],
              [26.938, 60.497],
              [26.942, 60.496],
              [26.949, 60.494],
              [26.957, 60.492],
              [26.967, 60.492],
              [26.969, 60.493],
              [26.975, 60.495],
              [26.977, 60.496],
              [26.98, 60.499],
              [26.983, 60.505],
              [26.986, 60.508],
              [26.998, 60.511],
              [27.006, 60.515],
              [27.012, 60.521],
              [27.014, 60.529],
              [27.014, 60.536],
              [27.016, 60.54],
              [27.021, 60.54],
              [27.024, 60.538],
              [27.03, 60.533],
              [27.033, 60.531],
              [27.037, 60.529],
              [27.041, 60.528],
              [27.05, 60.528],
              [27.053, 60.53],
              [27.055, 60.531],
              [27.055, 60.536],
              [27.054, 60.538],
              [27.05, 60.542],
              [27.05, 60.544],
              [27.051, 60.545],
              [27.051, 60.546],
              [27.055, 60.546],
              [27.057, 60.545],
              [27.06, 60.544],
              [27.07, 60.539],
              [27.073, 60.539],
              [27.077, 60.538],
              [27.081, 60.538],
              [27.087, 60.54],
              [27.089, 60.542],
              [27.09, 60.544],
              [27.093, 60.549],
              [27.094, 60.551],
              [27.095, 60.552],
              [27.097, 60.552],
              [27.1, 60.55],
              [27.101, 60.548],
              [27.105, 60.545],
              [27.107, 60.543],
              [27.119, 60.537],
              [27.123, 60.536],
              [27.129, 60.535],
              [27.134, 60.534],
              [27.146, 60.534],
              [27.148, 60.532],
              [27.146, 60.528],
              [27.146, 60.524],
              [27.147, 60.523],
              [27.153, 60.521],
              [27.16, 60.521],
              [27.169, 60.524],
              [27.173, 60.526],
              [27.174, 60.527],
              [27.175, 60.529],
              [27.175, 60.532],
              [27.174, 60.538],
              [27.173, 60.542],
              [27.172, 60.554],
              [27.171, 60.564],
              [27.171, 60.572],
              [27.175, 60.578],
              [27.178, 60.581],
              [27.179, 60.581],
              [27.18, 60.58],
              [27.18, 60.576],
              [27.181, 60.574],
              [27.183, 60.571],
              [27.188, 60.566],
              [27.192, 60.565],
              [27.195, 60.564],
              [27.209, 60.56],
              [27.214, 60.558],
              [27.22, 60.556],
              [27.237, 60.549],
              [27.26, 60.539],
              [27.264, 60.538],
              [27.267, 60.536],
              [27.268, 60.535],
              [27.268, 60.534],
              [27.264, 60.534],
              [27.26, 60.535],
              [27.24, 60.543],
              [27.234, 60.544],
              [27.229, 60.546],
              [27.217, 60.548],
              [27.212, 60.547],
              [27.208, 60.547],
              [27.204, 60.545],
              [27.203, 60.543],
              [27.202, 60.54],
              [27.202, 60.533],
              [27.203, 60.53],
              [27.203, 60.526],
              [27.207, 60.522],
              [27.211, 60.521],
              [27.218, 60.521],
              [27.23, 60.524],
              [27.24, 60.524],
              [27.246, 60.523],
              [27.251, 60.522],
              [27.257, 60.52],
              [27.272, 60.516],
              [27.276, 60.515],
              [27.297, 60.515],
              [27.312, 60.512],
              [27.318, 60.511],
              [27.323, 60.51],
              [27.333, 60.51],
              [27.339, 60.509],
              [27.344, 60.509],
              [27.358, 60.507],
              [27.362, 60.506],
              [27.369, 60.506],
              [27.373, 60.505],
              [27.381, 60.501],
              [27.385, 60.498],
              [27.389, 60.494],
              [27.404, 60.484],
              [27.411, 60.478],
              [27.419, 60.474],
              [27.429, 60.47],
              [27.434, 60.47],
              [27.44, 60.469],
              [27.451, 60.468],
              [27.465, 60.467],
              [27.47, 60.466],
              [27.474, 60.466],
              [27.48, 60.468],
              [27.481, 60.47],
              [27.481, 60.472],
              [27.48, 60.475],
              [27.479, 60.477],
              [27.469, 60.487],
              [27.469, 60.489],
              [27.468, 60.491],
              [27.468, 60.497],
              [27.47, 60.499],
              [27.474, 60.502],
              [27.475, 60.503],
              [27.477, 60.507],
              [27.478, 60.507],
              [27.48, 60.508],
              [27.483, 60.507],
              [27.49, 60.506],
              [27.494, 60.506],
              [27.509, 60.501],
              [27.515, 60.5],
              [27.539, 60.494],
              [27.546, 60.492],
              [27.552, 60.491],
              [27.558, 60.489],
              [27.563, 60.486],
              [27.577, 60.48],
              [27.582, 60.477],
              [27.587, 60.476],
              [27.592, 60.474],
              [27.596, 60.473],
              [27.601, 60.472],
              [27.607, 60.472],
              [27.608, 60.473],
              [27.608, 60.475],
              [27.604, 60.479],
              [27.591, 60.487],
              [27.587, 60.49],
              [27.581, 60.496],
              [27.581, 60.502],
              [27.582, 60.505],
              [27.584, 60.507],
              [27.59, 60.511],
              [27.594, 60.513],
              [27.609, 60.518],
              [27.614, 60.519],
              [27.619, 60.521],
              [27.63, 60.521],
              [27.631, 60.52],
              [27.63, 60.519],
              [27.628, 60.519],
              [27.619, 60.516],
              [27.615, 60.514],
              [27.608, 60.509],
              [27.602, 60.505],
              [27.6, 60.502],
              [27.6, 60.499],
              [27.601, 60.496],
              [27.603, 60.494],
              [27.606, 60.492],
              [27.614, 60.488],
              [27.618, 60.487],
              [27.627, 60.487],
              [27.635, 60.488],
              [27.646, 60.488],
              [27.67, 60.487],
              [27.676, 60.487],
              [27.682, 60.488],
              [27.688, 60.488],
              [27.7, 60.49],
              [27.706, 60.49],
              [27.721, 60.491],
              [27.726, 60.491],
              [27.729, 60.492],
              [27.732, 60.494],
              [27.734, 60.496],
              [27.735, 60.499],
              [27.735, 60.502],
              [27.734, 60.505],
              [27.732, 60.508],
              [27.726, 60.515],
              [27.725, 60.517],
              [27.725, 60.519],
              [27.726, 60.52],
              [27.727, 60.522],
              [27.732, 60.524],
              [27.734, 60.526],
              [27.733, 60.528],
              [27.732, 60.531],
              [27.727, 60.538],
              [27.724, 60.542],
              [27.722, 60.546],
              [27.722, 60.557],
              [27.723, 60.56],
              [27.725, 60.564],
              [27.727, 60.566],
              [27.733, 60.574],
              [27.735, 60.576],
              [27.738, 60.577],
              [27.742, 60.578],
              [27.747, 60.579],
              [27.762, 60.576],
              [27.766, 60.574],
              [27.77, 60.57],
              [27.774, 60.567],
              [27.777, 60.563],
              [27.781, 60.556],
              [27.782, 60.554],
              [27.785, 60.551],
              [27.788, 60.549],
              [27.794, 60.544],
              [27.796, 60.542],
              [27.797, 60.54],
              [27.797, 60.537],
              [27.796, 60.535],
              [27.795, 60.534],
              [27.795, 60.53],
              [27.796, 60.528],
              [27.799, 60.523],
              [27.8, 60.519],
              [27.801, 60.517],
              [27.804, 60.515],
              [27.807, 60.512],
              [27.815, 60.506],
              [27.82, 60.504],
              [27.828, 60.5],
              [27.832, 60.5],
              [27.834, 60.501],
              [27.835, 60.502],
              [27.835, 60.504],
              [27.833, 60.511],
              [27.833, 60.513],
              [27.832, 60.518],
              [27.831, 60.524],
              [27.831, 60.527],
              [27.832, 60.53],
              [27.833, 60.532],
              [27.836, 60.537],
              [27.838, 60.54],
              [27.841, 60.543],
              [27.843, 60.544],
              [27.846, 60.544],
              [27.851, 60.545],
              [27.853, 60.546],
              [27.857, 60.544],
              [27.858, 60.543],
              [27.859, 60.54],
              [27.86, 60.535],
              [27.861, 60.532],
              [27.865, 60.524],
              [27.869, 60.52],
              [27.877, 60.514],
              [27.887, 60.51],
              [27.902, 60.51],
              [27.914, 60.513],
              [27.943, 60.513],
              [27.96, 60.512],
              [27.964, 60.511],
              [27.969, 60.51],
              [27.984, 60.506],
              [27.988, 60.505],
              [27.994, 60.505],
              [27.996, 60.506],
              [28.002, 60.508],
              [28.007, 60.513],
              [28.008, 60.515],
              [28.011, 60.517],
              [28.014, 60.518],
              [28.018, 60.519],
              [28.027, 60.519],
              [28.032, 60.518],
              [28.053, 60.511],
              [28.057, 60.509],
              [28.061, 60.508],
              [28.065, 60.508],
              [28.069, 60.51],
              [28.069, 60.511],
              [28.07, 60.514],
              [28.07, 60.515],
              [28.072, 60.518],
              [28.075, 60.519],
              [28.079, 60.521],
              [28.094, 60.521],
              [28.104, 60.52],
              [28.109, 60.519],
              [28.114, 60.519],
              [28.129, 60.516],
              [28.133, 60.515],
              [28.137, 60.515],
              [28.14, 60.516],
              [28.142, 60.518],
              [28.144, 60.519],
              [28.146, 60.522],
              [28.148, 60.526],
              [28.149, 60.529],
              [28.151, 60.53],
              [28.154, 60.532],
              [28.16, 60.534],
              [28.168, 60.534],
              [28.178, 60.532],
              [28.184, 60.53],
              [28.201, 60.525],
              [28.206, 60.523],
              [28.216, 60.521],
              [28.219, 60.521],
              [28.222, 60.522],
              [28.226, 60.528],
              [28.227, 60.532],
              [28.228, 60.542],
              [28.23, 60.552],
              [28.234, 60.56],
              [28.237, 60.563],
              [28.241, 60.566],
              [28.244, 60.568],
              [28.264, 60.573],
              [28.273, 60.576],
              [28.276, 60.578],
              [28.278, 60.58],
              [28.28, 60.583],
              [28.282, 60.589],
              [28.284, 60.591],
              [28.287, 60.593],
              [28.291, 60.594],
              [28.296, 60.595],
              [28.318, 60.595],
              [28.322, 60.596],
              [28.326, 60.596],
              [28.328, 60.598],
              [28.329, 60.6],
              [28.329, 60.602],
              [28.324, 60.607],
              [28.315, 60.614],
              [28.313, 60.616],
              [28.313, 60.618],
              [28.326, 60.618],
              [28.34, 60.616],
              [28.352, 60.613],
              [28.364, 60.611],
              [28.369, 60.611],
              [28.379, 60.613],
              [28.383, 60.617],
              [28.385, 60.623],
              [28.385, 60.627],
              [28.384, 60.634],
              [28.384, 60.638],
              [28.385, 60.641],
              [28.387, 60.644],
              [28.389, 60.646],
              [28.392, 60.648],
              [28.398, 60.651],
              [28.401, 60.653],
              [28.404, 60.653],
              [28.407, 60.654],
              [28.411, 60.654],
              [28.42, 60.653],
              [28.431, 60.653],
              [28.449, 60.654],
              [28.469, 60.654],
              [28.472, 60.655],
              [28.476, 60.658],
              [28.48, 60.66],
              [28.484, 60.661],
              [28.494, 60.664],
              [28.499, 60.665],
              [28.503, 60.667],
              [28.506, 60.668],
              [28.513, 60.672],
              [28.519, 60.672],
              [28.521, 60.671],
              [28.529, 60.668],
              [28.531, 60.667],
              [28.534, 60.667],
              [28.535, 60.669],
              [28.54, 60.672],
              [28.548, 60.676],
              [28.55, 60.676],
              [28.558, 60.675],
              [28.573, 60.675],
              [28.577, 60.676],
              [28.579, 60.677],
              [28.581, 60.677],
              [28.586, 60.68],
              [28.588, 60.681],
              [28.592, 60.684],
              [28.594, 60.685],
              [28.597, 60.686],
              [28.601, 60.687],
              [28.61, 60.687],
              [28.614, 60.686],
              [28.617, 60.685],
              [28.621, 60.683],
              [28.624, 60.682],
              [28.626, 60.68],
              [28.627, 60.678],
              [28.628, 60.674],
              [28.631, 60.674],
              [28.633, 60.675],
              [28.636, 60.676],
              [28.639, 60.678],
              [28.641, 60.681],
              [28.643, 60.683],
              [28.643, 60.688],
              [28.641, 60.69],
              [28.639, 60.693],
              [28.634, 60.697],
              [28.633, 60.699],
              [28.632, 60.7],
              [28.633, 60.701],
              [28.635, 60.702],
              [28.641, 60.704],
              [28.645, 60.705],
              [28.647, 60.707],
              [28.649, 60.708],
              [28.652, 60.712],
              [28.656, 60.716],
              [28.66, 60.722],
              [28.661, 60.725],
              [28.663, 60.728],
              [28.665, 60.73],
              [28.669, 60.733],
              [28.677, 60.735],
              [28.68, 60.735],
              [28.684, 60.733],
              [28.687, 60.732],
              [28.689, 60.731],
              [28.692, 60.731],
              [28.695, 60.73],
              [28.698, 60.73],
              [28.703, 60.729],
              [28.705, 60.729],
              [28.709, 60.727],
              [28.712, 60.725],
              [28.715, 60.72],
              [28.717, 60.718],
              [28.72, 60.716],
              [28.723, 60.715],
              [28.728, 60.712],
              [28.73, 60.71],
              [28.733, 60.708],
              [28.737, 60.702],
              [28.737, 60.698],
              [28.733, 60.69],
              [28.732, 60.686],
              [28.732, 60.669],
              [28.731, 60.666],
              [28.73, 60.665],
              [28.728, 60.664],
              [28.723, 60.662],
              [28.721, 60.661],
              [28.716, 60.658],
              [28.713, 60.655],
              [28.712, 60.652],
              [28.712, 60.643],
              [28.711, 60.641],
              [28.71, 60.64],
              [28.708, 60.64],
              [28.705, 60.641],
              [28.702, 60.643],
              [28.691, 60.652],
              [28.687, 60.654],
              [28.682, 60.657],
              [28.679, 60.658],
              [28.672, 60.66],
              [28.664, 60.662],
              [28.656, 60.662],
              [28.654, 60.661],
              [28.653, 60.659],
              [28.651, 60.656],
              [28.65, 60.654],
              [28.65, 60.649],
              [28.652, 60.647],
              [28.653, 60.644],
              [28.658, 60.638],
              [28.659, 60.636],
              [28.66, 60.635],
              [28.66, 60.631],
              [28.661, 60.63],
              [28.663, 60.626],
              [28.665, 60.624],
              [28.668, 60.623],
              [28.67, 60.622],
              [28.671, 60.622],
              [28.674, 60.623],
              [28.676, 60.623],
              [28.678, 60.624],
              [28.681, 60.623],
              [28.687, 60.62],
              [28.688, 60.618],
              [28.688, 60.616],
              [28.687, 60.613],
              [28.686, 60.611],
              [28.686, 60.609],
              [28.688, 60.601],
              [28.688, 60.599],
              [28.687, 60.597],
              [28.685, 60.596],
              [28.677, 60.596],
              [28.673, 60.595],
              [28.669, 60.595],
              [28.665, 60.593],
              [28.662, 60.592],
              [28.657, 60.587],
              [28.656, 60.583],
              [28.658, 60.575],
              [28.66, 60.571],
              [28.662, 60.568],
              [28.665, 60.563],
              [28.667, 60.56],
              [28.667, 60.556],
              [28.666, 60.555],
              [28.662, 60.552],
              [28.661, 60.551],
              [28.661, 60.549],
              [28.662, 60.544],
              [28.661, 60.54],
              [28.661, 60.535],
              [28.662, 60.531],
              [28.663, 60.528],
              [28.666, 60.524],
              [28.669, 60.519],
              [28.673, 60.515],
              [28.686, 60.5],
              [28.698, 60.485],
              [28.704, 60.467],
              [28.705, 60.461],
              [28.705, 60.45],
              [28.701, 60.442],
              [28.698, 60.439],
              [28.694, 60.436],
              [28.69, 60.435],
              [28.685, 60.434],
              [28.675, 60.434],
              [28.669, 60.435],
              [28.663, 60.437],
              [28.657, 60.44],
              [28.651, 60.442],
              [28.645, 60.445],
              [28.621, 60.458],
              [28.609, 60.464],
              [28.603, 60.466],
              [28.597, 60.469],
              [28.577, 60.475],
              [28.565, 60.479],
              [28.558, 60.482],
              [28.552, 60.485],
              [28.54, 60.493],
              [28.535, 60.496],
              [28.529, 60.5],
              [28.524, 60.504],
              [28.52, 60.509],
              [28.512, 60.517],
              [28.511, 60.521],
              [28.507, 60.529],
              [28.504, 60.532],
              [28.498, 60.54],
              [28.494, 60.543],
              [28.49, 60.545],
              [28.485, 60.547],
              [28.481, 60.549],
              [28.476, 60.55],
              [28.46, 60.55],
              [28.455, 60.548],
              [28.452, 60.546],
              [28.45, 60.544],
              [28.449, 60.541],
              [28.453, 60.533],
              [28.456, 60.528],
              [28.459, 60.524],
              [28.463, 60.519],
              [28.468, 60.514],
              [28.486, 60.494],
              [28.506, 60.474],
              [28.511, 60.47],
              [28.516, 60.465],
              [28.522, 60.461],
              [28.548, 60.441],
              [28.554, 60.436],
              [28.559, 60.432],
              [28.572, 60.419],
              [28.584, 60.399],
              [28.586, 60.395],
              [28.59, 60.386],
              [28.592, 60.381],
              [28.6, 60.373],
              [28.604, 60.37],
              [28.608, 60.366],
              [28.617, 60.361],
              [28.623, 60.357],
              [28.627, 60.355],
              [28.631, 60.354],
              [28.636, 60.354],
              [28.646, 60.352],
              [28.653, 60.351],
              [28.666, 60.348],
              [28.68, 60.344],
              [28.722, 60.333],
              [28.736, 60.329],
              [28.742, 60.327],
              [28.756, 60.325],
              [28.767, 60.325],
              [28.772, 60.326],
              [28.777, 60.328],
              [28.781, 60.329],
              [28.784, 60.331],
              [28.786, 60.333],
              [28.788, 60.336],
              [28.789, 60.34],
              [28.791, 60.347],
              [28.792, 60.35],
              [28.794, 60.352],
              [28.796, 60.353],
              [28.798, 60.353],
              [28.801, 60.352],
              [28.804, 60.35],
              [28.808, 60.348],
              [28.816, 60.34],
              [28.824, 60.33],
              [28.84, 60.309],
              [28.844, 60.303],
              [28.848, 60.298],
              [28.853, 60.294],
              [28.858, 60.289],
              [28.863, 60.285],
              [28.868, 60.282],
              [28.88, 60.276],
              [28.886, 60.274],
              [28.892, 60.271],
              [28.898, 60.27],
              [28.904, 60.268],
              [28.91, 60.267],
              [28.916, 60.267],
              [28.922, 60.266],
              [28.928, 60.266],
              [28.933, 60.265],
              [28.937, 60.264],
              [28.942, 60.262],
              [28.946, 60.26],
              [28.952, 60.256],
              [28.957, 60.251],
              [28.963, 60.248],
              [28.972, 60.241],
              [28.976, 60.238],
              [28.982, 60.235],
              [28.985, 60.233],
              [28.989, 60.229],
              [28.991, 60.224],
              [28.994, 60.214],
              [28.996, 60.21],
              [29.002, 60.2],
              [29.005, 60.196],
              [29.009, 60.192],
              [29.014, 60.188],
              [29.018, 60.185],
              [29.024, 60.183],
              [29.029, 60.181],
              [29.047, 60.178],
              [29.06, 60.177],
              [29.067, 60.177],
              [29.073, 60.176],
              [29.087, 60.174],
              [29.114, 60.168],
              [29.127, 60.166],
              [29.134, 60.165],
              [29.14, 60.164],
              [29.169, 60.164],
              [29.183, 60.165],
              [29.211, 60.165],
              [29.261, 60.163],
              [29.374, 60.16],
              [29.409, 60.16],
              [29.423, 60.162],
              [29.435, 60.164],
              [29.442, 60.166],
              [29.467, 60.173],
              [29.473, 60.174],
              [29.486, 60.177],
              [29.505, 60.181],
              [29.518, 60.184],
              [29.542, 60.192],
              [29.566, 60.196],
              [29.606, 60.196],
              [29.62, 60.195],
              [29.634, 60.193],
              [29.727, 60.185],
              [29.742, 60.183],
              [29.777, 60.178],
              [29.783, 60.176],
              [29.81, 60.17],
              [29.823, 60.167],
              [29.858, 60.162],
              [29.866, 60.161],
              [29.873, 60.16],
              [29.879, 60.159],
              [29.885, 60.157],
              [29.892, 60.155],
              [29.91, 60.149],
              [29.92, 60.143],
              [29.924, 60.139],
              [29.928, 60.136],
              [29.931, 60.132],
              [29.933, 60.128],
              [29.935, 60.123],
              [29.937, 60.119],
              [29.938, 60.114],
              [29.938, 60.106],
              [29.937, 60.102],
              [29.934, 60.096],
              [29.933, 60.093],
              [29.933, 60.09],
              [29.934, 60.087],
              [29.943, 60.078],
              [29.944, 60.076],
              [29.944, 60.068],
              [29.946, 60.065],
              [29.951, 60.059],
              [29.955, 60.055],
              [29.958, 60.05],
              [29.96, 60.046],
              [29.961, 60.041],
              [29.964, 60.03],
              [29.968, 60.02],
              [29.97, 60.016],
              [29.974, 60.012],
              [29.984, 60.006],
              [29.99, 60.004],
              [30.004, 59.999],
              [30.008, 59.998],
              [30.011, 59.997],
              [30.014, 59.997],
              [30.025, 59.996],
              [30.065, 59.996],
              [30.072, 59.995],
              [30.086, 59.994],
              [30.129, 59.989],
              [30.157, 59.987],
              [30.175, 59.986],
              [30.18, 59.985],
              [30.184, 59.984],
              [30.19, 59.983],
              [30.195, 59.981],
              [30.203, 59.975],
              [30.207, 59.969],
              [30.207, 59.961],
              [30.205, 59.958],
              [30.2, 59.953],
              [30.195, 59.951],
              [30.193, 59.95],
              [30.191, 59.946],
              [30.19, 59.945],
              [30.192, 59.941],
              [30.194, 59.94],
              [30.199, 59.937],
              [30.202, 59.935],
              [30.214, 59.931],
              [30.218, 59.93],
              [30.224, 59.926],
              [30.226, 59.922],
              [30.226, 59.919],
              [30.225, 59.915],
              [30.223, 59.911],
              [30.216, 59.904],
              [30.212, 59.901],
              [30.207, 59.898],
              [30.201, 59.895],
              [30.196, 59.892],
              [30.181, 59.886],
              [30.176, 59.883],
              [30.173, 59.881],
              [30.171, 59.879],
              [30.166, 59.875],
              [30.163, 59.873],
              [30.16, 59.872],
              [30.157, 59.87],
              [30.148, 59.868],
              [30.136, 59.865],
              [30.118, 59.862],
              [30.04, 59.862],
              [30.033, 59.863],
              [30.027, 59.864],
              [30.02, 59.865],
              [30.014, 59.866],
              [30.008, 59.868],
              [30.001, 59.87],
              [29.97, 59.88],
              [29.958, 59.884],
              [29.93, 59.888],
              [29.902, 59.891],
              [29.895, 59.892],
              [29.882, 59.894],
              [29.868, 59.896],
              [29.848, 59.9],
              [29.828, 59.905],
              [29.815, 59.908],
              [29.803, 59.911],
              [29.797, 59.913],
              [29.792, 59.915],
              [29.787, 59.916],
              [29.783, 59.918],
              [29.78, 59.92],
              [29.777, 59.923],
              [29.775, 59.923],
              [29.773, 59.924],
              [29.772, 59.925],
              [29.77, 59.928],
              [29.769, 59.929],
              [29.768, 59.929],
              [29.765, 59.93],
              [29.761, 59.931],
              [29.756, 59.932],
              [29.745, 59.933],
              [29.719, 59.935],
              [29.682, 59.935],
              [29.669, 59.934],
              [29.651, 59.934],
              [29.644, 59.933],
              [29.638, 59.934],
              [29.631, 59.934],
              [29.625, 59.935],
              [29.611, 59.939],
              [29.605, 59.941],
              [29.578, 59.949],
              [29.564, 59.953],
              [29.529, 59.958],
              [29.508, 59.958],
              [29.486, 59.959],
              [29.472, 59.959],
              [29.458, 59.96],
              [29.444, 59.962],
              [29.431, 59.964],
              [29.397, 59.97],
              [29.376, 59.973],
              [29.369, 59.973],
              [29.355, 59.975],
              [29.341, 59.975],
              [29.299, 59.977],
              [29.285, 59.978],
              [29.264, 59.981],
              [29.234, 59.986],
              [29.229, 59.987],
              [29.223, 59.988],
              [29.214, 59.988],
              [29.211, 59.987],
              [29.203, 59.986],
              [29.198, 59.985],
              [29.181, 59.984],
              [29.175, 59.984],
              [29.156, 59.982],
              [29.139, 59.981],
              [29.135, 59.98],
              [29.13, 59.979],
              [29.118, 59.973],
              [29.108, 59.969],
              [29.084, 59.962],
              [29.078, 59.96],
              [29.073, 59.957],
              [29.068, 59.955],
              [29.06, 59.947],
              [29.052, 59.938],
              [29.049, 59.934],
              [29.045, 59.93],
              [29.037, 59.924],
              [29.032, 59.921],
              [29.017, 59.915],
              [29.006, 59.911],
              [29.004, 59.91],
              [29.003, 59.909],
              [29.003, 59.908],
              [29.007, 59.906],
              [29.011, 59.905],
              [29.016, 59.903],
              [29.033, 59.899],
              [29.038, 59.897],
              [29.044, 59.895],
              [29.048, 59.893],
              [29.053, 59.889],
              [29.056, 59.885],
              [29.058, 59.877],
              [29.057, 59.872],
              [29.055, 59.868],
              [29.052, 59.865],
              [29.049, 59.861],
              [29.045, 59.858],
              [29.035, 59.849],
              [29.033, 59.847],
              [29.003, 59.829],
              [28.998, 59.825],
              [28.992, 59.823],
              [28.98, 59.817],
              [28.973, 59.815],
              [28.967, 59.813],
              [28.96, 59.812],
              [28.954, 59.81],
              [28.933, 59.807],
              [28.926, 59.807],
              [28.92, 59.806],
              [28.9, 59.806],
              [28.894, 59.805],
              [28.887, 59.804],
              [28.881, 59.803],
              [28.876, 59.801],
              [28.87, 59.799],
              [28.854, 59.791],
              [28.849, 59.789],
              [28.843, 59.787],
              [28.838, 59.785],
              [28.832, 59.784],
              [28.816, 59.784],
              [28.811, 59.785],
              [28.805, 59.786],
              [28.795, 59.79],
              [28.791, 59.791],
              [28.787, 59.791],
              [28.782, 59.789],
              [28.774, 59.784],
              [28.769, 59.782],
              [28.757, 59.778],
              [28.751, 59.777],
              [28.733, 59.777],
              [28.728, 59.778],
              [28.722, 59.779],
              [28.716, 59.782],
              [28.699, 59.79],
              [28.684, 59.797],
              [28.679, 59.799],
              [28.674, 59.802],
              [28.668, 59.805],
              [28.663, 59.808],
              [28.658, 59.81],
              [28.652, 59.812],
              [28.641, 59.815],
              [28.631, 59.818],
              [28.627, 59.819],
              [28.622, 59.82],
              [28.604, 59.823],
              [28.592, 59.826],
              [28.586, 59.827],
              [28.574, 59.831],
              [28.569, 59.833],
              [28.559, 59.838],
              [28.553, 59.84],
              [28.543, 59.842],
              [28.537, 59.842],
              [28.531, 59.841],
              [28.526, 59.84],
              [28.52, 59.839],
              [28.496, 59.832],
              [28.484, 59.828],
              [28.479, 59.826],
              [28.473, 59.823],
              [28.468, 59.82],
              [28.464, 59.816],
              [28.459, 59.812],
              [28.455, 59.808],
              [28.449, 59.798],
              [28.446, 59.792],
              [28.444, 59.786],
              [28.443, 59.779],
              [28.442, 59.773],
              [28.44, 59.753],
              [28.439, 59.746],
              [28.427, 59.71],
              [28.426, 59.704],
              [28.423, 59.689],
              [28.422, 59.685],
              [28.42, 59.682],
              [28.417, 59.679],
              [28.413, 59.676],
              [28.408, 59.674],
              [28.403, 59.673],
              [28.397, 59.671],
              [28.391, 59.67],
              [28.386, 59.669],
              [28.375, 59.668],
              [28.369, 59.667],
              [28.36, 59.667],
              [28.342, 59.67],
              [28.323, 59.673],
              [28.316, 59.675],
              [28.309, 59.676],
              [28.303, 59.676],
              [28.296, 59.677],
              [28.289, 59.677],
              [28.268, 59.678],
              [28.262, 59.679],
              [28.255, 59.679],
              [28.249, 59.68],
              [28.243, 59.682],
              [28.238, 59.684],
              [28.234, 59.686],
              [28.226, 59.692],
              [28.222, 59.7],
              [28.221, 59.704],
              [28.22, 59.713],
              [28.219, 59.719],
              [28.217, 59.725],
              [28.214, 59.73],
              [28.212, 59.736],
              [28.209, 59.742],
              [28.205, 59.748],
              [28.202, 59.754],
              [28.198, 59.759],
              [28.194, 59.765],
              [28.19, 59.77],
              [28.18, 59.778],
              [28.175, 59.781],
              [28.169, 59.784],
              [28.163, 59.786],
              [28.157, 59.787],
              [28.15, 59.788],
              [28.144, 59.789],
              [28.137, 59.789],
              [28.13, 59.79],
              [28.124, 59.79],
              [28.117, 59.789],
              [28.11, 59.789],
              [28.104, 59.787],
              [28.098, 59.786],
              [28.086, 59.78],
              [28.081, 59.776],
              [28.065, 59.765],
              [28.059, 59.761],
              [28.048, 59.755],
              [28.043, 59.752],
              [28.039, 59.749],
              [28.035, 59.745],
              [28.033, 59.742],
              [28.032, 59.738],
              [28.03, 59.734],
              [28.029, 59.73],
              [28.026, 59.726],
              [28.023, 59.721],
              [28.013, 59.706],
              [28.01, 59.702],
              [28.008, 59.697],
              [28.007, 59.692],
              [28.007, 59.688],
              [28.011, 59.68],
              [28.017, 59.672],
              [28.02, 59.666],
              [28.023, 59.663],
              [28.029, 59.655],
              [28.041, 59.646],
              [28.046, 59.643],
              [28.049, 59.639],
              [28.06, 59.628],
              [28.074, 59.615],
              [28.078, 59.611],
              [28.082, 59.606],
              [28.088, 59.596],
              [28.09, 59.589],
              [28.091, 59.583],
              [28.092, 59.576],
              [28.092, 59.57],
              [28.09, 59.556],
              [28.088, 59.55],
              [28.086, 59.543],
              [28.084, 59.537],
              [28.081, 59.53],
              [28.078, 59.524],
              [28.074, 59.518],
              [28.07, 59.513],
              [28.067, 59.507],
              [28.062, 59.502],
              [28.058, 59.497],
              [28.049, 59.486],
              [28.036, 59.471],
              [28.027, 59.461],
              [28.022, 59.456],
              [28.017, 59.452],
              [28.012, 59.447],
              [28.007, 59.443],
              [28.002, 59.44],
              [27.997, 59.436],
              [27.992, 59.433],
              [27.986, 59.43],
              [27.98, 59.426],
              [27.975, 59.424],
              [27.963, 59.418],
              [27.933, 59.408],
              [27.926, 59.406],
              [27.914, 59.404],
              [27.907, 59.403],
              [27.901, 59.403],
              [27.894, 59.402],
              [27.868, 59.401],
              [27.861, 59.401],
              [27.847, 59.4],
              [27.826, 59.398],
              [27.819, 59.397],
              [27.805, 59.397],
              [27.799, 59.398],
              [27.792, 59.398],
              [27.78, 59.4],
              [27.774, 59.402],
              [27.768, 59.403],
              [27.758, 59.407],
              [27.753, 59.41],
              [27.744, 59.415],
              [27.738, 59.418],
              [27.732, 59.418],
              [27.725, 59.419],
              [27.718, 59.419],
              [27.704, 59.417],
              [27.698, 59.416],
              [27.691, 59.415],
              [27.685, 59.415],
              [27.671, 59.414],
              [27.629, 59.414],
              [27.615, 59.415],
              [27.601, 59.415],
              [27.594, 59.416],
              [27.588, 59.417],
              [27.581, 59.418],
              [27.575, 59.419],
              [27.548, 59.425],
              [27.522, 59.429],
              [27.508, 59.431],
              [27.474, 59.436],
              [27.419, 59.442],
              [27.398, 59.444],
              [27.385, 59.445],
              [27.378, 59.445],
              [27.371, 59.446],
              [27.356, 59.446],
              [27.335, 59.445],
              [27.098, 59.435],
              [27.069, 59.434],
              [27.027, 59.434],
              [26.964, 59.437],
              [26.95, 59.438],
              [26.943, 59.439],
              [26.937, 59.439],
              [26.931, 59.44],
              [26.919, 59.443],
              [26.914, 59.444],
              [26.908, 59.446],
              [26.903, 59.448],
              [26.898, 59.449],
              [26.89, 59.453],
              [26.881, 59.457],
              [26.877, 59.459],
              [26.861, 59.464],
              [26.843, 59.47],
              [26.817, 59.479],
              [26.798, 59.486],
              [26.785, 59.491],
              [26.779, 59.493],
              [26.773, 59.496],
              [26.768, 59.498],
              [26.762, 59.501],
              [26.757, 59.504],
              [26.749, 59.51],
              [26.746, 59.512],
              [26.742, 59.515],
              [26.734, 59.519],
              [26.725, 59.522],
              [26.721, 59.524],
              [26.713, 59.527],
              [26.707, 59.529],
              [26.701, 59.532],
              [26.694, 59.534],
              [26.688, 59.536],
              [26.675, 59.54],
              [26.661, 59.543],
              [26.654, 59.545],
              [26.647, 59.546],
              [26.641, 59.547],
              [26.634, 59.548],
              [26.621, 59.549],
              [26.609, 59.55],
              [26.584, 59.55],
              [26.581, 59.547],
              [26.581, 59.54],
              [26.579, 59.537],
              [26.578, 59.535],
              [26.573, 59.53],
              [26.568, 59.527],
              [26.564, 59.525],
              [26.549, 59.522],
              [26.543, 59.522],
              [26.528, 59.52],
              [26.506, 59.518],
              [26.498, 59.518],
              [26.494, 59.52],
              [26.489, 59.522],
              [26.478, 59.527],
              [26.473, 59.53],
              [26.467, 59.532],
              [26.456, 59.536],
              [26.442, 59.541],
              [26.437, 59.543],
              [26.431, 59.544],
              [26.424, 59.546],
              [26.418, 59.547],
              [26.411, 59.549],
              [26.404, 59.55],
              [26.391, 59.552],
              [26.377, 59.554],
              [26.371, 59.555],
              [26.364, 59.556],
              [26.345, 59.557],
              [26.339, 59.558],
              [26.332, 59.559],
              [26.326, 59.56],
              [26.314, 59.564],
              [26.307, 59.567],
              [26.283, 59.577],
              [26.265, 59.583],
              [26.244, 59.586],
              [26.164, 59.586],
              [26.143, 59.585],
              [26.129, 59.586],
              [26.122, 59.586],
              [26.11, 59.588],
              [26.105, 59.589],
              [26.101, 59.591],
              [26.098, 59.593],
              [26.093, 59.598],
              [26.091, 59.599],
              [26.088, 59.601],
              [26.084, 59.603],
              [26.072, 59.608],
              [26.068, 59.609],
              [26.064, 59.611],
              [26.058, 59.615],
              [26.055, 59.618],
              [26.051, 59.621],
              [26.049, 59.622],
              [26.043, 59.624],
              [26.026, 59.624],
              [26.02, 59.623],
              [26.01, 59.621],
              [25.996, 59.621],
              [25.993, 59.622],
              [25.99, 59.624],
              [25.985, 59.627],
              [25.981, 59.629],
              [25.976, 59.629],
              [25.974, 59.628],
              [25.972, 59.624],
              [25.971, 59.62],
              [25.971, 59.601],
              [25.969, 59.597],
              [25.967, 59.592],
              [25.964, 59.589],
              [25.96, 59.586],
              [25.95, 59.582],
              [25.939, 59.582],
              [25.934, 59.583],
              [25.929, 59.585],
              [25.925, 59.588],
              [25.923, 59.592],
              [25.918, 59.6],
              [25.912, 59.608],
              [25.908, 59.611],
              [25.904, 59.613],
              [25.9, 59.614],
              [25.895, 59.615],
              [25.891, 59.616],
              [25.878, 59.616],
              [25.872, 59.612],
              [25.871, 59.608],
              [25.869, 59.604],
              [25.866, 59.589],
              [25.864, 59.584],
              [25.861, 59.58],
              [25.857, 59.576],
              [25.852, 59.573],
              [25.847, 59.571],
              [25.841, 59.569],
              [25.834, 59.568],
              [25.828, 59.567],
              [25.821, 59.566],
              [25.815, 59.566],
              [25.803, 59.568],
              [25.793, 59.572],
              [25.788, 59.575],
              [25.785, 59.578],
              [25.783, 59.581],
              [25.781, 59.585],
              [25.78, 59.59],
              [25.776, 59.606],
              [25.776, 59.614],
              [25.775, 59.618],
              [25.772, 59.624],
              [25.766, 59.631],
              [25.76, 59.639],
              [25.756, 59.642],
              [25.751, 59.646],
              [25.746, 59.649],
              [25.741, 59.651],
              [25.735, 59.654],
              [25.73, 59.656],
              [25.719, 59.659],
              [25.714, 59.661],
              [25.706, 59.664],
              [25.702, 59.666],
              [25.696, 59.666],
              [25.693, 59.665],
              [25.687, 59.661],
              [25.683, 59.657],
              [25.682, 59.655],
              [25.682, 59.649],
              [25.684, 59.642],
              [25.685, 59.634],
              [25.687, 59.626],
              [25.689, 59.623],
              [25.69, 59.619],
              [25.693, 59.614],
              [25.699, 59.606],
              [25.703, 59.598],
              [25.703, 59.591],
              [25.702, 59.588],
              [25.701, 59.584],
              [25.699, 59.582],
              [25.698, 59.579],
              [25.695, 59.576],
              [25.691, 59.574],
              [25.681, 59.57],
              [25.676, 59.569],
              [25.67, 59.568],
              [25.664, 59.568],
              [25.652, 59.57],
              [25.64, 59.574],
              [25.635, 59.576],
              [25.629, 59.578],
              [25.624, 59.581],
              [25.617, 59.586],
              [25.612, 59.59],
              [25.607, 59.592],
              [25.602, 59.595],
              [25.582, 59.603],
              [25.578, 59.604],
              [25.572, 59.607],
              [25.566, 59.609],
              [25.561, 59.61],
              [25.547, 59.613],
              [25.542, 59.614],
              [25.538, 59.616],
              [25.533, 59.618],
              [25.53, 59.62],
              [25.525, 59.623],
              [25.522, 59.626],
              [25.516, 59.634],
              [25.514, 59.637],
              [25.511, 59.639],
              [25.504, 59.639],
              [25.502, 59.638],
              [25.498, 59.632],
              [25.497, 59.627],
              [25.497, 59.618],
              [25.498, 59.612],
              [25.5, 59.607],
              [25.502, 59.601],
              [25.505, 59.596],
              [25.509, 59.591],
              [25.513, 59.585],
              [25.518, 59.58],
              [25.531, 59.565],
              [25.539, 59.555],
              [25.542, 59.55],
              [25.544, 59.546],
              [25.544, 59.541],
              [25.543, 59.537],
              [25.541, 59.533],
              [25.538, 59.53],
              [25.53, 59.524],
              [25.525, 59.522],
              [25.519, 59.521],
              [25.513, 59.519],
              [25.507, 59.518],
              [25.488, 59.516],
              [25.476, 59.514],
              [25.466, 59.51],
              [25.458, 59.504],
              [25.453, 59.502],
              [25.449, 59.5],
              [25.444, 59.497],
              [25.439, 59.496],
              [25.433, 59.494],
              [25.426, 59.494],
              [25.419, 59.493],
              [25.391, 59.493],
              [25.377, 59.494],
              [25.356, 59.495],
              [25.341, 59.496],
              [25.32, 59.499],
              [25.314, 59.501],
              [25.308, 59.502],
              [25.284, 59.51],
              [25.271, 59.516],
              [25.267, 59.517],
              [25.262, 59.517],
              [25.257, 59.516],
              [25.241, 59.512],
              [25.223, 59.509],
              [25.211, 59.509],
              [25.207, 59.51],
              [25.202, 59.511],
              [25.198, 59.513],
              [25.193, 59.516],
              [25.184, 59.522],
              [25.174, 59.528],
              [25.169, 59.53],
              [25.163, 59.532],
              [25.159, 59.534],
              [25.154, 59.536],
              [25.146, 59.536],
              [25.145, 59.535],
              [25.145, 59.533],
              [25.146, 59.528],
              [25.15, 59.522],
              [25.153, 59.519],
              [25.159, 59.512],
              [25.162, 59.508],
              [25.164, 59.505],
              [25.165, 59.501],
              [25.164, 59.498],
              [25.162, 59.494],
              [25.16, 59.491],
              [25.156, 59.488],
              [25.152, 59.486],
              [25.147, 59.484],
              [25.142, 59.483],
              [25.136, 59.484],
              [25.13, 59.484],
              [25.124, 59.486],
              [25.118, 59.487],
              [25.106, 59.491],
              [25.09, 59.498],
              [25.085, 59.499],
              [25.078, 59.5],
              [25.072, 59.501],
              [25.065, 59.501],
              [25.052, 59.502],
              [25.045, 59.502],
              [25.025, 59.503],
              [25.019, 59.504],
              [25.013, 59.504],
              [25.003, 59.502],
              [25, 59.501],
              [24.993, 59.498],
              [24.988, 59.497],
              [24.98, 59.495],
              [24.972, 59.494],
              [24.961, 59.494],
              [24.957, 59.495],
              [24.946, 59.496],
              [24.943, 59.497],
              [24.935, 59.499],
              [24.932, 59.5],
              [24.928, 59.501],
              [24.924, 59.503],
              [24.916, 59.509],
              [24.909, 59.517],
              [24.906, 59.521],
              [24.89, 59.536],
              [24.886, 59.54],
              [24.882, 59.543],
              [24.877, 59.546],
              [24.871, 59.548],
              [24.864, 59.55],
              [24.858, 59.552],
              [24.837, 59.557],
              [24.819, 59.561],
              [24.814, 59.562],
              [24.81, 59.563],
              [24.802, 59.561],
              [24.8, 59.558],
              [24.798, 59.554],
              [24.797, 59.549],
              [24.797, 59.544],
              [24.799, 59.532],
              [24.801, 59.527],
              [24.804, 59.522],
              [24.809, 59.512],
              [24.813, 59.505],
              [24.815, 59.502],
              [24.818, 59.498],
              [24.823, 59.49],
              [24.825, 59.486],
              [24.825, 59.479],
              [24.823, 59.474],
              [24.82, 59.47],
              [24.812, 59.462],
              [24.802, 59.454],
              [24.792, 59.448],
              [24.787, 59.446],
              [24.777, 59.444],
              [24.77, 59.444],
              [24.764, 59.447],
              [24.761, 59.447],
              [24.746, 59.449],
              [24.741, 59.451],
              [24.736, 59.452],
              [24.732, 59.454],
              [24.719, 59.458],
              [24.716, 59.459],
              [24.714, 59.46],
              [24.714, 59.465],
              [24.715, 59.467],
              [24.716, 59.47],
              [24.716, 59.473],
              [24.715, 59.475],
              [24.712, 59.477],
              [24.71, 59.479],
              [24.707, 59.48],
              [24.697, 59.48],
              [24.694, 59.479],
              [24.687, 59.472],
              [24.684, 59.471],
              [24.681, 59.469],
              [24.673, 59.467],
              [24.663, 59.465],
              [24.661, 59.465],
              [24.66, 59.463],
              [24.659, 59.462],
              [24.66, 59.46],
              [24.662, 59.457],
              [24.667, 59.452],
              [24.671, 59.446],
              [24.67, 59.443],
              [24.668, 59.44],
              [24.665, 59.438],
              [24.661, 59.437],
              [24.656, 59.436],
              [24.651, 59.437],
              [24.639, 59.439],
              [24.633, 59.441],
              [24.608, 59.449],
              [24.602, 59.451],
              [24.59, 59.453],
              [24.579, 59.453],
              [24.576, 59.452],
              [24.569, 59.449],
              [24.559, 59.445],
              [24.541, 59.442],
              [24.535, 59.442],
              [24.514, 59.445],
              [24.508, 59.447],
              [24.494, 59.451],
              [24.488, 59.453],
              [24.471, 59.461],
              [24.465, 59.464],
              [24.459, 59.466],
              [24.452, 59.468],
              [24.424, 59.472],
              [24.417, 59.472],
              [24.41, 59.473],
              [24.396, 59.473],
              [24.389, 59.472],
              [24.382, 59.472],
              [24.376, 59.471],
              [24.37, 59.469],
              [24.36, 59.463],
              [24.356, 59.459],
              [24.353, 59.454],
              [24.346, 59.444],
              [24.342, 59.439],
              [24.339, 59.434],
              [24.329, 59.426],
              [24.324, 59.423],
              [24.312, 59.417],
              [24.306, 59.415],
              [24.299, 59.413],
              [24.293, 59.411],
              [24.279, 59.407],
              [24.266, 59.403],
              [24.259, 59.402],
              [24.252, 59.4],
              [24.245, 59.399],
              [24.239, 59.398],
              [24.232, 59.398],
              [24.225, 59.397],
              [24.219, 59.398],
              [24.212, 59.398],
              [24.202, 59.399],
              [24.195, 59.399],
              [24.193, 59.398],
              [24.193, 59.396],
              [24.194, 59.394],
              [24.198, 59.392],
              [24.202, 59.389],
              [24.212, 59.384],
              [24.218, 59.38],
              [24.223, 59.377],
              [24.228, 59.373],
              [24.231, 59.37],
              [24.234, 59.366],
              [24.236, 59.363],
              [24.237, 59.359],
              [24.237, 59.356],
              [24.236, 59.353],
              [24.234, 59.35],
              [24.226, 59.346],
              [24.221, 59.345],
              [24.203, 59.345],
              [24.196, 59.347],
              [24.19, 59.349],
              [24.183, 59.351],
              [24.156, 59.361],
              [24.149, 59.364],
              [24.143, 59.366],
              [24.129, 59.37],
              [24.116, 59.373],
              [24.102, 59.376],
              [24.089, 59.379],
              [24.075, 59.381],
              [24.063, 59.383],
              [24.052, 59.383],
              [24.047, 59.382],
              [24.044, 59.38],
              [24.041, 59.377],
              [24.04, 59.373],
              [24.04, 59.368],
              [24.041, 59.363],
              [24.044, 59.359],
              [24.047, 59.354],
              [24.051, 59.35],
              [24.056, 59.347],
              [24.061, 59.343],
              [24.073, 59.337],
              [24.089, 59.328],
              [24.094, 59.326],
              [24.099, 59.323],
              [24.102, 59.319],
              [24.105, 59.316],
              [24.109, 59.308],
              [24.109, 59.298],
              [24.107, 59.293],
              [24.104, 59.288],
              [24.101, 59.284],
              [24.093, 59.278],
              [24.089, 59.277],
              [24.083, 59.277],
              [24.079, 59.278],
              [24.073, 59.28],
              [24.052, 59.284],
              [24.046, 59.285],
              [24.039, 59.286],
              [24.026, 59.286],
              [24.005, 59.283],
              [23.985, 59.279],
              [23.957, 59.275],
              [23.943, 59.275],
              [23.922, 59.276],
              [23.908, 59.276],
              [23.892, 59.275],
              [23.88, 59.275],
              [23.874, 59.276],
              [23.867, 59.277],
              [23.861, 59.279],
              [23.842, 59.283],
              [23.836, 59.284],
              [23.829, 59.285],
              [23.823, 59.286],
              [23.81, 59.286],
              [23.804, 59.285],
              [23.797, 59.284],
              [23.785, 59.282],
              [23.78, 59.28],
              [23.766, 59.275],
              [23.755, 59.272],
              [23.75, 59.271],
              [23.745, 59.269],
              [23.742, 59.266],
              [23.74, 59.263],
              [23.734, 59.251],
              [23.731, 59.247],
              [23.723, 59.241],
              [23.717, 59.239],
              [23.712, 59.237],
              [23.706, 59.235],
              [23.687, 59.235],
              [23.681, 59.236],
              [23.665, 59.24],
              [23.647, 59.24],
              [23.64, 59.239],
              [23.634, 59.237],
              [23.627, 59.235],
              [23.621, 59.233],
              [23.6, 59.227],
              [23.587, 59.223],
              [23.58, 59.221],
              [23.573, 59.22],
              [23.561, 59.218],
              [23.549, 59.218],
              [23.543, 59.219],
              [23.538, 59.219],
              [23.527, 59.221],
              [23.512, 59.221],
              [23.509, 59.219],
              [23.506, 59.216],
              [23.5, 59.212],
              [23.497, 59.209],
              [23.495, 59.206],
              [23.493, 59.201],
              [23.492, 59.197],
              [23.492, 59.191],
              [23.493, 59.187],
              [23.494, 59.182],
              [23.498, 59.174],
              [23.504, 59.166],
              [23.506, 59.162],
              [23.509, 59.157],
              [23.515, 59.145],
              [23.518, 59.14],
              [23.522, 59.133],
              [23.525, 59.129],
              [23.526, 59.126],
              [23.527, 59.122],
              [23.531, 59.109],
              [23.532, 59.104],
              [23.532, 59.101],
              [23.531, 59.097],
              [23.529, 59.095],
              [23.525, 59.093],
              [23.516, 59.091],
              [23.511, 59.089],
              [23.499, 59.084],
              [23.494, 59.082],
              [23.488, 59.08],
              [23.483, 59.079],
              [23.477, 59.077],
              [23.47, 59.076],
              [23.457, 59.075],
              [23.452, 59.074],
              [23.446, 59.072],
              [23.442, 59.07],
              [23.439, 59.067],
              [23.437, 59.063],
              [23.435, 59.06],
              [23.435, 59.048],
              [23.436, 59.046],
              [23.439, 59.041],
              [23.441, 59.037],
              [23.44, 59.035],
              [23.44, 59.032],
              [23.439, 59.03],
              [23.435, 59.026],
              [23.432, 59.025],
              [23.421, 59.022],
              [23.418, 59.02],
              [23.417, 59.018],
              [23.417, 59.016],
              [23.418, 59.012],
              [23.429, 59.001],
              [23.434, 58.998],
              [22.927, 58.978],
            ],
          ],
        ],
      },
      properties: {
        id: 47,
        name: 'Finska viken',
        latlon: [59.770779, 25.022534],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [22.565, 58.634],
              [22.565, 58.687],
              [22.566, 58.688],
              [22.57, 58.687],
              [22.584, 58.688],
              [22.591, 58.688],
              [22.619, 58.69],
              [22.626, 58.691],
              [22.632, 58.692],
              [22.639, 58.693],
              [22.646, 58.695],
              [22.658, 58.699],
              [22.664, 58.702],
              [22.67, 58.706],
              [22.68, 58.714],
              [22.684, 58.719],
              [22.689, 58.724],
              [22.693, 58.729],
              [22.698, 58.735],
              [22.706, 58.745],
              [22.715, 58.76],
              [22.717, 58.765],
              [22.718, 58.769],
              [22.719, 58.772],
              [22.718, 58.776],
              [22.719, 58.779],
              [22.72, 58.783],
              [22.722, 58.787],
              [22.724, 58.79],
              [22.727, 58.794],
              [22.735, 58.8],
              [22.738, 58.802],
              [22.741, 58.803],
              [22.748, 58.806],
              [22.754, 58.808],
              [22.765, 58.814],
              [22.771, 58.816],
              [22.776, 58.817],
              [22.782, 58.818],
              [22.787, 58.819],
              [22.796, 58.82],
              [22.804, 58.821],
              [22.81, 58.821],
              [22.813, 58.82],
              [22.814, 58.818],
              [22.813, 58.816],
              [22.811, 58.813],
              [22.808, 58.81],
              [22.805, 58.808],
              [22.801, 58.805],
              [22.796, 58.802],
              [22.792, 58.8],
              [22.787, 58.798],
              [22.782, 58.797],
              [22.774, 58.796],
              [22.77, 58.794],
              [22.77, 58.792],
              [22.772, 58.789],
              [22.778, 58.783],
              [22.782, 58.78],
              [22.787, 58.778],
              [22.795, 58.774],
              [22.798, 58.773],
              [22.8, 58.771],
              [22.801, 58.769],
              [22.801, 58.767],
              [22.8, 58.765],
              [22.8, 58.763],
              [22.801, 58.762],
              [22.805, 58.762],
              [22.809, 58.763],
              [22.812, 58.764],
              [22.817, 58.766],
              [22.821, 58.768],
              [22.83, 58.774],
              [22.835, 58.777],
              [22.838, 58.779],
              [22.846, 58.782],
              [22.855, 58.787],
              [22.863, 58.79],
              [22.867, 58.792],
              [22.873, 58.796],
              [22.874, 58.798],
              [22.874, 58.801],
              [22.875, 58.808],
              [22.877, 58.813],
              [22.877, 58.818],
              [22.875, 58.82],
              [22.872, 58.821],
              [22.852, 58.821],
              [22.846, 58.823],
              [22.845, 58.824],
              [22.846, 58.826],
              [22.849, 58.827],
              [22.853, 58.828],
              [22.857, 58.83],
              [22.879, 58.83],
              [22.889, 58.828],
              [22.894, 58.828],
              [22.903, 58.827],
              [22.907, 58.827],
              [22.916, 58.83],
              [22.921, 58.833],
              [22.924, 58.834],
              [22.928, 58.834],
              [22.938, 58.833],
              [22.941, 58.832],
              [22.945, 58.833],
              [22.949, 58.835],
              [22.954, 58.84],
              [22.96, 58.842],
              [22.965, 58.843],
              [22.975, 58.843],
              [22.998, 58.84],
              [23.008, 58.839],
              [23.013, 58.839],
              [23.017, 58.838],
              [23.02, 58.836],
              [23.028, 58.833],
              [23.031, 58.832],
              [23.036, 58.831],
              [23.04, 58.832],
              [23.045, 58.833],
              [23.049, 58.834],
              [23.053, 58.836],
              [23.056, 58.839],
              [23.058, 58.842],
              [23.058, 58.846],
              [23.057, 58.85],
              [23.055, 58.855],
              [23.052, 58.859],
              [23.049, 58.864],
              [23.045, 58.867],
              [23.035, 58.878],
              [23.031, 58.881],
              [23.027, 58.887],
              [23.023, 58.892],
              [23.018, 58.896],
              [23.014, 58.901],
              [23.008, 58.905],
              [23.003, 58.908],
              [22.997, 58.911],
              [22.986, 58.916],
              [22.98, 58.918],
              [22.975, 58.921],
              [22.969, 58.924],
              [22.964, 58.928],
              [22.96, 58.932],
              [22.955, 58.935],
              [22.949, 58.943],
              [22.947, 58.947],
              [22.946, 58.95],
              [22.946, 58.953],
              [22.945, 58.956],
              [22.945, 58.958],
              [22.944, 58.961],
              [22.942, 58.965],
              [22.938, 58.971],
              [22.936, 58.973],
              [22.935, 58.975],
              [22.933, 58.976],
              [22.927, 58.978],
              [23.434, 58.998],
              [23.44, 58.995],
              [23.445, 58.991],
              [23.451, 58.989],
              [23.458, 58.986],
              [23.47, 58.982],
              [23.482, 58.98],
              [23.501, 58.979],
              [23.519, 58.976],
              [23.541, 58.972],
              [23.545, 58.971],
              [23.553, 58.971],
              [23.557, 58.972],
              [23.561, 58.974],
              [23.565, 58.977],
              [23.568, 58.979],
              [23.571, 58.983],
              [23.575, 58.99],
              [23.578, 58.993],
              [23.581, 58.995],
              [23.587, 58.997],
              [23.591, 58.997],
              [23.594, 58.996],
              [23.598, 58.996],
              [23.602, 58.995],
              [23.611, 58.992],
              [23.615, 58.991],
              [23.619, 58.991],
              [23.621, 58.993],
              [23.622, 58.995],
              [23.623, 58.996],
              [23.625, 58.997],
              [23.629, 58.998],
              [23.633, 58.997],
              [23.637, 58.995],
              [23.642, 58.993],
              [23.646, 58.99],
              [23.649, 58.987],
              [23.652, 58.983],
              [23.653, 58.98],
              [23.653, 58.976],
              [23.652, 58.974],
              [23.65, 58.972],
              [23.646, 58.971],
              [23.642, 58.971],
              [23.626, 58.972],
              [23.622, 58.972],
              [23.608, 58.971],
              [23.604, 58.971],
              [23.598, 58.969],
              [23.596, 58.968],
              [23.593, 58.964],
              [23.592, 58.962],
              [23.589, 58.96],
              [23.585, 58.957],
              [23.58, 58.956],
              [23.575, 58.954],
              [23.569, 58.953],
              [23.564, 58.952],
              [23.552, 58.952],
              [23.547, 58.953],
              [23.537, 58.954],
              [23.526, 58.954],
              [23.524, 58.952],
              [23.521, 58.948],
              [23.519, 58.946],
              [23.516, 58.944],
              [23.512, 58.943],
              [23.508, 58.943],
              [23.492, 58.94],
              [23.486, 58.939],
              [23.468, 58.939],
              [23.458, 58.94],
              [23.453, 58.941],
              [23.447, 58.941],
              [23.442, 58.94],
              [23.437, 58.938],
              [23.434, 58.936],
              [23.431, 58.932],
              [23.428, 58.92],
              [23.428, 58.912],
              [23.43, 58.909],
              [23.434, 58.906],
              [23.441, 58.901],
              [23.444, 58.899],
              [23.446, 58.896],
              [23.447, 58.893],
              [23.449, 58.89],
              [23.451, 58.888],
              [23.453, 58.885],
              [23.457, 58.882],
              [23.471, 58.872],
              [23.476, 58.868],
              [23.482, 58.864],
              [23.497, 58.85],
              [23.502, 58.846],
              [23.512, 58.839],
              [23.52, 58.831],
              [23.522, 58.828],
              [23.524, 58.824],
              [23.525, 58.821],
              [23.525, 58.817],
              [23.523, 58.814],
              [23.52, 58.812],
              [23.516, 58.81],
              [23.508, 58.808],
              [23.504, 58.808],
              [23.5, 58.809],
              [23.49, 58.81],
              [23.488, 58.81],
              [23.486, 58.809],
              [23.479, 58.802],
              [23.465, 58.793],
              [23.458, 58.79],
              [23.456, 58.788],
              [23.455, 58.785],
              [23.453, 58.78],
              [23.452, 58.774],
              [23.451, 58.772],
              [23.454, 58.769],
              [23.459, 58.769],
              [23.463, 58.77],
              [23.481, 58.772],
              [23.494, 58.773],
              [23.501, 58.774],
              [23.521, 58.774],
              [23.54, 58.773],
              [23.559, 58.773],
              [23.566, 58.774],
              [23.573, 58.776],
              [23.593, 58.78],
              [23.614, 58.783],
              [23.634, 58.783],
              [23.641, 58.782],
              [23.669, 58.78],
              [23.696, 58.78],
              [23.702, 58.781],
              [23.72, 58.783],
              [23.726, 58.783],
              [23.732, 58.784],
              [23.737, 58.783],
              [23.741, 58.782],
              [23.744, 58.781],
              [23.746, 58.78],
              [23.749, 58.778],
              [23.751, 58.774],
              [23.751, 58.772],
              [23.743, 58.76],
              [23.741, 58.758],
              [23.739, 58.757],
              [23.736, 58.755],
              [23.724, 58.751],
              [23.709, 58.748],
              [23.703, 58.747],
              [23.679, 58.744],
              [23.674, 58.744],
              [23.669, 58.743],
              [23.664, 58.741],
              [23.661, 58.74],
              [23.657, 58.738],
              [23.653, 58.737],
              [23.65, 58.736],
              [23.637, 58.734],
              [23.626, 58.732],
              [23.614, 58.73],
              [23.607, 58.73],
              [23.601, 58.729],
              [23.588, 58.729],
              [23.582, 58.73],
              [23.575, 58.73],
              [23.551, 58.733],
              [23.539, 58.733],
              [23.538, 58.731],
              [23.538, 58.73],
              [23.539, 58.728],
              [23.54, 58.725],
              [23.543, 58.723],
              [23.547, 58.721],
              [23.558, 58.714],
              [23.56, 58.713],
              [23.561, 58.711],
              [23.56, 58.709],
              [23.557, 58.708],
              [23.549, 58.706],
              [23.539, 58.704],
              [23.528, 58.702],
              [23.524, 58.702],
              [23.52, 58.7],
              [23.517, 58.699],
              [23.502, 58.689],
              [23.501, 58.686],
              [23.5, 58.682],
              [23.501, 58.679],
              [23.502, 58.67],
              [23.506, 58.65],
              [23.509, 58.644],
              [23.511, 58.639],
              [23.52, 58.623],
              [23.522, 58.617],
              [23.524, 58.612],
              [23.526, 58.609],
              [23.528, 58.597],
              [23.529, 58.595],
              [23.528, 58.593],
              [23.527, 58.59],
              [23.521, 58.581],
              [23.518, 58.578],
              [23.514, 58.573],
              [23.513, 58.571],
              [23.513, 58.569],
              [23.515, 58.565],
              [23.517, 58.564],
              [23.521, 58.563],
              [23.526, 58.562],
              [23.53, 58.562],
              [23.54, 58.561],
              [23.544, 58.561],
              [23.55, 58.563],
              [23.56, 58.573],
              [23.566, 58.575],
              [23.569, 58.575],
              [23.571, 58.574],
              [23.572, 58.573],
              [23.574, 58.565],
              [23.575, 58.563],
              [23.581, 58.553],
              [23.582, 58.551],
              [23.592, 58.546],
              [23.595, 58.544],
              [23.6, 58.54],
              [23.603, 58.539],
              [23.61, 58.536],
              [23.618, 58.533],
              [23.648, 58.521],
              [23.653, 58.521],
              [23.658, 58.52],
              [23.668, 58.521],
              [23.675, 58.521],
              [23.678, 58.519],
              [23.682, 58.515],
              [23.685, 58.509],
              [23.687, 58.501],
              [23.687, 58.492],
              [23.688, 58.484],
              [23.688, 58.475],
              [23.687, 58.469],
              [23.685, 58.458],
              [23.685, 58.452],
              [23.684, 58.447],
              [23.686, 58.437],
              [23.687, 58.434],
              [23.689, 58.431],
              [23.692, 58.427],
              [23.705, 58.409],
              [23.709, 58.403],
              [23.722, 58.382],
              [23.729, 58.372],
              [23.733, 58.367],
              [23.741, 58.358],
              [23.75, 58.346],
              [23.756, 58.342],
              [23.759, 58.341],
              [23.76, 58.342],
              [23.761, 58.342],
              [23.762, 58.343],
              [23.762, 58.346],
              [23.763, 58.347],
              [23.765, 58.347],
              [23.768, 58.348],
              [23.77, 58.349],
              [23.777, 58.349],
              [23.791, 58.348],
              [23.798, 58.347],
              [23.812, 58.346],
              [23.82, 58.346],
              [23.826, 58.348],
              [23.834, 58.35],
              [23.839, 58.35],
              [23.844, 58.348],
              [23.848, 58.346],
              [23.853, 58.344],
              [23.857, 58.34],
              [23.877, 58.328],
              [23.882, 58.326],
              [23.886, 58.324],
              [23.896, 58.322],
              [23.905, 58.322],
              [23.915, 58.324],
              [23.926, 58.324],
              [23.932, 58.323],
              [23.944, 58.322],
              [23.949, 58.321],
              [23.955, 58.32],
              [23.96, 58.318],
              [23.97, 58.315],
              [23.974, 58.313],
              [23.982, 58.312],
              [23.984, 58.311],
              [23.991, 58.309],
              [23.994, 58.308],
              [23.999, 58.308],
              [24.003, 58.311],
              [24.006, 58.312],
              [24.009, 58.312],
              [24.012, 58.311],
              [24.016, 58.309],
              [24.021, 58.306],
              [24.025, 58.302],
              [24.035, 58.294],
              [24.054, 58.273],
              [24.059, 58.268],
              [24.064, 58.264],
              [24.07, 58.259],
              [24.075, 58.255],
              [24.081, 58.252],
              [24.086, 58.249],
              [24.092, 58.246],
              [24.098, 58.244],
              [24.108, 58.24],
              [24.113, 58.239],
              [24.117, 58.238],
              [24.121, 58.239],
              [24.126, 58.241],
              [24.136, 58.246],
              [24.147, 58.251],
              [24.153, 58.253],
              [24.164, 58.259],
              [24.174, 58.263],
              [24.194, 58.267],
              [24.212, 58.268],
              [24.219, 58.269],
              [24.232, 58.271],
              [24.245, 58.274],
              [24.251, 58.275],
              [24.256, 58.276],
              [24.261, 58.278],
              [24.263, 58.278],
              [24.268, 58.283],
              [24.269, 58.285],
              [24.284, 58.318],
              [24.286, 58.324],
              [24.288, 58.329],
              [24.289, 58.335],
              [24.292, 58.346],
              [24.293, 58.351],
              [24.297, 58.361],
              [24.3, 58.365],
              [24.307, 58.372],
              [24.312, 58.375],
              [24.316, 58.377],
              [24.328, 58.381],
              [24.335, 58.382],
              [24.341, 58.383],
              [24.348, 58.383],
              [24.362, 58.384],
              [24.431, 58.384],
              [24.437, 58.383],
              [24.443, 58.383],
              [24.449, 58.382],
              [24.454, 58.38],
              [24.458, 58.378],
              [24.462, 58.377],
              [24.465, 58.375],
              [24.467, 58.374],
              [24.471, 58.373],
              [24.473, 58.373],
              [24.474, 58.372],
              [24.484, 58.373],
              [24.489, 58.373],
              [24.494, 58.372],
              [24.512, 58.369],
              [24.519, 58.367],
              [24.525, 58.365],
              [24.531, 58.362],
              [24.538, 58.36],
              [24.543, 58.357],
              [24.549, 58.353],
              [24.559, 58.345],
              [24.567, 58.337],
              [24.571, 58.332],
              [24.574, 58.327],
              [24.576, 58.322],
              [24.577, 58.317],
              [24.577, 58.307],
              [24.575, 58.302],
              [24.572, 58.298],
              [24.564, 58.29],
              [24.558, 58.286],
              [24.54, 58.277],
              [24.514, 58.266],
              [24.49, 58.254],
              [24.482, 58.248],
              [24.478, 58.244],
              [24.477, 58.241],
              [24.474, 58.233],
              [24.473, 58.229],
              [24.466, 58.214],
              [24.464, 58.209],
              [24.462, 58.199],
              [24.462, 58.194],
              [24.461, 58.185],
              [24.461, 58.181],
              [24.462, 58.176],
              [24.463, 58.174],
              [24.467, 58.168],
              [24.469, 58.164],
              [24.471, 58.159],
              [24.473, 58.155],
              [24.474, 58.15],
              [24.476, 58.145],
              [24.477, 58.14],
              [24.477, 58.132],
              [24.476, 58.126],
              [24.476, 58.121],
              [24.474, 58.115],
              [24.473, 58.113],
              [24.471, 58.107],
              [24.47, 58.105],
              [24.471, 58.102],
              [24.474, 58.095],
              [24.476, 58.085],
              [24.476, 58.074],
              [24.474, 58.068],
              [24.472, 58.063],
              [24.47, 58.057],
              [24.464, 58.045],
              [24.461, 58.04],
              [24.458, 58.034],
              [24.454, 58.028],
              [24.45, 58.023],
              [24.447, 58.017],
              [24.442, 58.012],
              [24.438, 58.007],
              [24.416, 57.985],
              [24.404, 57.97],
              [24.396, 57.958],
              [24.39, 57.946],
              [24.38, 57.928],
              [24.362, 57.89],
              [24.353, 57.872],
              [24.347, 57.859],
              [24.345, 57.853],
              [24.343, 57.846],
              [24.34, 57.84],
              [24.338, 57.828],
              [24.338, 57.816],
              [24.339, 57.81],
              [24.34, 57.805],
              [24.341, 57.799],
              [24.344, 57.79],
              [24.344, 57.788],
              [24.345, 57.786],
              [24.345, 57.75],
              [24.344, 57.746],
              [24.344, 57.72],
              [24.347, 57.702],
              [24.351, 57.69],
              [24.354, 57.684],
              [24.356, 57.677],
              [24.368, 57.653],
              [24.37, 57.647],
              [24.373, 57.641],
              [24.377, 57.629],
              [24.378, 57.623],
              [24.378, 57.611],
              [24.377, 57.606],
              [24.367, 57.576],
              [24.366, 57.569],
              [24.366, 57.562],
              [24.365, 57.556],
              [24.367, 57.542],
              [24.368, 57.536],
              [24.37, 57.53],
              [24.375, 57.518],
              [24.377, 57.512],
              [24.378, 57.505],
              [24.38, 57.498],
              [24.381, 57.492],
              [24.386, 57.457],
              [24.393, 57.38],
              [24.395, 57.366],
              [24.399, 57.34],
              [24.4, 57.334],
              [24.402, 57.324],
              [24.404, 57.321],
              [24.405, 57.317],
              [24.405, 57.31],
              [24.406, 57.306],
              [24.407, 57.296],
              [24.408, 57.291],
              [24.408, 57.28],
              [24.407, 57.274],
              [24.405, 57.267],
              [24.401, 57.255],
              [24.397, 57.249],
              [24.393, 57.244],
              [24.389, 57.238],
              [24.374, 57.223],
              [24.368, 57.219],
              [24.363, 57.214],
              [24.357, 57.209],
              [24.352, 57.205],
              [24.334, 57.193],
              [24.327, 57.189],
              [24.315, 57.182],
              [24.24, 57.141],
              [24.227, 57.134],
              [24.215, 57.127],
              [24.202, 57.121],
              [24.196, 57.118],
              [24.183, 57.113],
              [24.17, 57.107],
              [24.144, 57.097],
              [24.124, 57.09],
              [24.111, 57.085],
              [24.098, 57.081],
              [24.091, 57.079],
              [24.085, 57.077],
              [24.078, 57.075],
              [24.064, 57.072],
              [24.051, 57.07],
              [24.039, 57.068],
              [24.028, 57.066],
              [24.026, 57.066],
              [24.024, 57.065],
              [24.018, 57.061],
              [24.016, 57.06],
              [24.013, 57.056],
              [24.011, 57.053],
              [24.008, 57.05],
              [23.996, 57.041],
              [23.991, 57.037],
              [23.985, 57.034],
              [23.98, 57.031],
              [23.962, 57.022],
              [23.95, 57.017],
              [23.943, 57.014],
              [23.931, 57.01],
              [23.925, 57.007],
              [23.911, 57.003],
              [23.898, 57],
              [23.795, 56.978],
              [23.775, 56.974],
              [23.754, 56.971],
              [23.747, 56.971],
              [23.705, 56.968],
              [23.663, 56.966],
              [23.622, 56.966],
              [23.587, 56.971],
              [23.581, 56.973],
              [23.574, 56.974],
              [23.567, 56.976],
              [23.561, 56.979],
              [23.555, 56.981],
              [23.537, 56.99],
              [23.531, 56.994],
              [23.521, 57.002],
              [23.506, 57.015],
              [23.491, 57.027],
              [23.485, 57.03],
              [23.473, 57.034],
              [23.466, 57.036],
              [23.46, 57.037],
              [23.446, 57.039],
              [23.433, 57.04],
              [23.391, 57.044],
              [23.378, 57.045],
              [23.364, 57.047],
              [23.357, 57.049],
              [23.351, 57.05],
              [23.338, 57.054],
              [23.324, 57.058],
              [23.312, 57.062],
              [23.305, 57.065],
              [23.299, 57.068],
              [23.294, 57.07],
              [23.282, 57.076],
              [23.277, 57.08],
              [23.272, 57.083],
              [23.266, 57.087],
              [23.262, 57.09],
              [23.252, 57.1],
              [23.248, 57.105],
              [23.242, 57.115],
              [23.24, 57.121],
              [23.239, 57.127],
              [23.238, 57.132],
              [23.234, 57.156],
              [23.23, 57.168],
              [23.227, 57.174],
              [23.223, 57.18],
              [23.219, 57.185],
              [23.215, 57.191],
              [23.202, 57.208],
              [23.197, 57.213],
              [23.193, 57.219],
              [23.19, 57.225],
              [23.186, 57.231],
              [23.183, 57.237],
              [23.182, 57.242],
              [23.18, 57.247],
              [23.177, 57.258],
              [23.176, 57.263],
              [23.174, 57.27],
              [23.171, 57.276],
              [23.169, 57.283],
              [23.166, 57.289],
              [23.162, 57.295],
              [23.159, 57.301],
              [23.151, 57.311],
              [23.144, 57.319],
              [23.141, 57.323],
              [23.139, 57.327],
              [23.136, 57.331],
              [23.134, 57.334],
              [23.133, 57.335],
              [23.133, 57.339],
              [23.132, 57.341],
              [23.129, 57.346],
              [23.126, 57.353],
              [23.12, 57.359],
              [23.11, 57.363],
              [23.098, 57.367],
              [23.091, 57.368],
              [23.057, 57.375],
              [23.043, 57.379],
              [23.036, 57.38],
              [23.029, 57.382],
              [23.023, 57.385],
              [23.016, 57.387],
              [23.003, 57.392],
              [22.983, 57.399],
              [22.97, 57.405],
              [22.964, 57.407],
              [22.957, 57.41],
              [22.945, 57.416],
              [22.939, 57.42],
              [22.933, 57.423],
              [22.927, 57.427],
              [22.922, 57.431],
              [22.916, 57.435],
              [22.905, 57.444],
              [22.873, 57.47],
              [22.862, 57.479],
              [22.852, 57.487],
              [22.846, 57.491],
              [22.836, 57.497],
              [22.831, 57.499],
              [22.827, 57.502],
              [22.822, 57.504],
              [22.818, 57.505],
              [22.812, 57.508],
              [22.809, 57.509],
              [22.804, 57.512],
              [22.8, 57.514],
              [22.79, 57.518],
              [22.778, 57.522],
              [22.738, 57.536],
              [22.724, 57.54],
              [22.711, 57.545],
              [22.704, 57.548],
              [22.698, 57.551],
              [22.691, 57.554],
              [22.685, 57.557],
              [22.673, 57.564],
              [22.655, 57.576],
              [22.644, 57.583],
              [22.638, 57.587],
              [22.633, 57.592],
              [22.627, 57.596],
              [22.622, 57.6],
              [22.617, 57.605],
              [22.613, 57.611],
              [22.609, 57.616],
              [22.605, 57.622],
              [22.602, 57.628],
              [22.598, 57.634],
              [22.586, 57.658],
              [22.584, 57.665],
              [22.58, 57.677],
              [22.579, 57.684],
              [22.579, 57.697],
              [22.581, 57.711],
              [22.587, 57.729],
              [22.591, 57.74],
              [22.593, 57.745],
              [22.594, 57.749],
              [22.593, 57.752],
              [22.591, 57.754],
              [22.587, 57.755],
              [22.582, 57.755],
              [22.576, 57.754],
              [22.57, 57.754],
              [22.557, 57.752],
              [22.536, 57.748],
              [22.508, 57.743],
              [22.494, 57.74],
              [22.48, 57.736],
              [22.466, 57.733],
              [22.445, 57.727],
              [22.362, 57.704],
              [22.155, 57.646],
              [22.065, 57.621],
              [22.051, 57.618],
              [22.037, 57.614],
              [22.039, 57.914],
              [22.044, 57.914],
              [22.049, 57.913],
              [22.052, 57.913],
              [22.055, 57.914],
              [22.056, 57.914],
              [22.059, 57.915],
              [22.063, 57.917],
              [22.068, 57.919],
              [22.082, 57.926],
              [22.107, 57.939],
              [22.12, 57.946],
              [22.131, 57.952],
              [22.143, 57.958],
              [22.168, 57.969],
              [22.173, 57.972],
              [22.179, 57.975],
              [22.183, 57.978],
              [22.187, 57.982],
              [22.19, 57.986],
              [22.192, 57.99],
              [22.192, 57.995],
              [22.193, 58.004],
              [22.194, 58.009],
              [22.196, 58.014],
              [22.199, 58.019],
              [22.202, 58.023],
              [22.216, 58.042],
              [22.219, 58.046],
              [22.222, 58.051],
              [22.224, 58.056],
              [22.227, 58.065],
              [22.229, 58.069],
              [22.232, 58.074],
              [22.242, 58.088],
              [22.245, 58.092],
              [22.247, 58.097],
              [22.254, 58.115],
              [22.256, 58.12],
              [22.258, 58.13],
              [22.258, 58.135],
              [22.257, 58.145],
              [22.257, 58.156],
              [22.258, 58.161],
              [22.262, 58.171],
              [22.265, 58.176],
              [22.273, 58.184],
              [22.283, 58.192],
              [22.289, 58.196],
              [22.294, 58.199],
              [22.3, 58.202],
              [22.307, 58.205],
              [22.313, 58.208],
              [22.334, 58.214],
              [22.341, 58.215],
              [22.348, 58.217],
              [22.355, 58.218],
              [22.361, 58.219],
              [22.391, 58.219],
              [22.398, 58.22],
              [22.412, 58.22],
              [22.417, 58.221],
              [22.423, 58.221],
              [22.428, 58.222],
              [22.44, 58.226],
              [22.457, 58.234],
              [22.462, 58.236],
              [22.472, 58.238],
              [22.475, 58.238],
              [22.478, 58.237],
              [22.48, 58.236],
              [22.483, 58.235],
              [22.486, 58.233],
              [22.489, 58.232],
              [22.498, 58.226],
              [22.504, 58.224],
              [22.508, 58.224],
              [22.516, 58.228],
              [22.528, 58.238],
              [22.532, 58.24],
              [22.536, 58.241],
              [22.539, 58.242],
              [22.542, 58.241],
              [22.544, 58.239],
              [22.547, 58.237],
              [22.549, 58.234],
              [22.551, 58.232],
              [22.554, 58.23],
              [22.558, 58.229],
              [22.579, 58.229],
              [22.584, 58.23],
              [22.591, 58.229],
              [22.595, 58.229],
              [22.6, 58.23],
              [22.604, 58.232],
              [22.609, 58.234],
              [22.613, 58.236],
              [22.622, 58.244],
              [22.626, 58.246],
              [22.63, 58.247],
              [22.637, 58.247],
              [22.64, 58.246],
              [22.643, 58.244],
              [22.644, 58.242],
              [22.644, 58.241],
              [22.643, 58.235],
              [22.646, 58.229],
              [22.648, 58.228],
              [22.649, 58.227],
              [22.66, 58.227],
              [22.664, 58.226],
              [22.669, 58.225],
              [22.68, 58.221],
              [22.685, 58.219],
              [22.691, 58.218],
              [22.699, 58.216],
              [22.705, 58.216],
              [22.711, 58.215],
              [22.721, 58.215],
              [22.726, 58.217],
              [22.73, 58.218],
              [22.736, 58.222],
              [22.738, 58.228],
              [22.737, 58.232],
              [22.736, 58.235],
              [22.734, 58.238],
              [22.731, 58.242],
              [22.717, 58.256],
              [22.714, 58.26],
              [22.713, 58.263],
              [22.713, 58.267],
              [22.714, 58.27],
              [22.716, 58.272],
              [22.72, 58.274],
              [22.724, 58.275],
              [22.729, 58.276],
              [22.739, 58.276],
              [22.746, 58.275],
              [22.765, 58.273],
              [22.792, 58.27],
              [22.81, 58.267],
              [22.815, 58.266],
              [22.819, 58.266],
              [22.825, 58.268],
              [22.829, 58.27],
              [22.831, 58.272],
              [22.833, 58.275],
              [22.836, 58.282],
              [22.84, 58.288],
              [22.843, 58.291],
              [22.852, 58.298],
              [22.854, 58.3],
              [22.855, 58.3],
              [22.855, 58.301],
              [22.856, 58.303],
              [22.856, 58.304],
              [22.857, 58.306],
              [22.862, 58.31],
              [22.866, 58.312],
              [22.871, 58.312],
              [22.873, 58.311],
              [22.876, 58.308],
              [22.878, 58.305],
              [22.879, 58.304],
              [22.88, 58.304],
              [22.883, 58.303],
              [22.887, 58.302],
              [22.89, 58.301],
              [22.904, 58.301],
              [22.909, 58.303],
              [22.914, 58.304],
              [22.919, 58.307],
              [22.922, 58.31],
              [22.928, 58.317],
              [22.931, 58.319],
              [22.935, 58.325],
              [22.936, 58.327],
              [22.938, 58.33],
              [22.939, 58.332],
              [22.948, 58.341],
              [22.95, 58.344],
              [22.956, 58.349],
              [22.958, 58.351],
              [22.96, 58.354],
              [22.96, 58.36],
              [22.959, 58.363],
              [22.957, 58.367],
              [22.956, 58.37],
              [22.956, 58.373],
              [22.957, 58.375],
              [22.959, 58.377],
              [22.962, 58.378],
              [22.967, 58.378],
              [22.973, 58.376],
              [22.977, 58.373],
              [22.981, 58.371],
              [22.995, 58.366],
              [23, 58.365],
              [23.006, 58.364],
              [23.01, 58.363],
              [23.021, 58.362],
              [23.027, 58.362],
              [23.03, 58.363],
              [23.032, 58.364],
              [23.038, 58.37],
              [23.039, 58.373],
              [23.042, 58.378],
              [23.044, 58.381],
              [23.046, 58.383],
              [23.052, 58.387],
              [23.056, 58.387],
              [23.058, 58.388],
              [23.06, 58.388],
              [23.06, 58.387],
              [23.059, 58.386],
              [23.059, 58.385],
              [23.06, 58.384],
              [23.062, 58.383],
              [23.07, 58.383],
              [23.074, 58.384],
              [23.08, 58.386],
              [23.082, 58.388],
              [23.083, 58.391],
              [23.083, 58.394],
              [23.081, 58.396],
              [23.078, 58.4],
              [23.076, 58.403],
              [23.075, 58.405],
              [23.074, 58.409],
              [23.074, 58.415],
              [23.075, 58.417],
              [23.076, 58.418],
              [23.079, 58.42],
              [23.082, 58.421],
              [23.092, 58.423],
              [23.097, 58.422],
              [23.101, 58.422],
              [23.109, 58.42],
              [23.113, 58.42],
              [23.121, 58.422],
              [23.123, 58.423],
              [23.13, 58.429],
              [23.135, 58.432],
              [23.14, 58.437],
              [23.145, 58.441],
              [23.147, 58.443],
              [23.148, 58.445],
              [23.149, 58.448],
              [23.149, 58.453],
              [23.15, 58.456],
              [23.152, 58.46],
              [23.153, 58.463],
              [23.155, 58.465],
              [23.158, 58.467],
              [23.16, 58.467],
              [23.162, 58.466],
              [23.168, 58.462],
              [23.176, 58.457],
              [23.179, 58.455],
              [23.183, 58.453],
              [23.187, 58.452],
              [23.192, 58.45],
              [23.204, 58.442],
              [23.213, 58.438],
              [23.218, 58.436],
              [23.228, 58.434],
              [23.237, 58.432],
              [23.243, 58.432],
              [23.245, 58.433],
              [23.246, 58.434],
              [23.246, 58.435],
              [23.245, 58.437],
              [23.243, 58.44],
              [23.237, 58.445],
              [23.235, 58.447],
              [23.234, 58.45],
              [23.234, 58.452],
              [23.238, 58.454],
              [23.241, 58.455],
              [23.254, 58.455],
              [23.259, 58.454],
              [23.271, 58.452],
              [23.276, 58.451],
              [23.28, 58.45],
              [23.292, 58.446],
              [23.296, 58.443],
              [23.302, 58.438],
              [23.305, 58.437],
              [23.307, 58.436],
              [23.308, 58.436],
              [23.311, 58.438],
              [23.313, 58.44],
              [23.314, 58.443],
              [23.316, 58.446],
              [23.316, 58.452],
              [23.314, 58.456],
              [23.312, 58.458],
              [23.307, 58.464],
              [23.303, 58.47],
              [23.3, 58.472],
              [23.297, 58.475],
              [23.289, 58.48],
              [23.286, 58.482],
              [23.285, 58.483],
              [23.272, 58.488],
              [23.267, 58.49],
              [23.261, 58.491],
              [23.255, 58.493],
              [23.229, 58.499],
              [23.222, 58.501],
              [23.203, 58.506],
              [23.197, 58.507],
              [23.191, 58.509],
              [23.185, 58.51],
              [23.168, 58.513],
              [23.158, 58.515],
              [23.148, 58.521],
              [23.143, 58.525],
              [23.135, 58.533],
              [23.128, 58.544],
              [23.125, 58.548],
              [23.121, 58.551],
              [23.106, 58.557],
              [23.1, 58.559],
              [23.082, 58.563],
              [23.07, 58.567],
              [23.058, 58.572],
              [23.047, 58.575],
              [23.041, 58.578],
              [23.031, 58.582],
              [23.016, 58.59],
              [22.998, 58.599],
              [22.991, 58.601],
              [22.978, 58.606],
              [22.972, 58.608],
              [22.965, 58.61],
              [22.959, 58.612],
              [22.952, 58.613],
              [22.946, 58.615],
              [22.939, 58.616],
              [22.933, 58.616],
              [22.907, 58.618],
              [22.901, 58.619],
              [22.881, 58.621],
              [22.875, 58.622],
              [22.868, 58.622],
              [22.862, 58.621],
              [22.85, 58.62],
              [22.837, 58.62],
              [22.817, 58.621],
              [22.804, 58.621],
              [22.798, 58.62],
              [22.792, 58.618],
              [22.786, 58.615],
              [22.781, 58.612],
              [22.775, 58.608],
              [22.756, 58.589],
              [22.752, 58.586],
              [22.747, 58.584],
              [22.743, 58.582],
              [22.733, 58.582],
              [22.729, 58.583],
              [22.724, 58.584],
              [22.716, 58.588],
              [22.711, 58.59],
              [22.699, 58.592],
              [22.684, 58.589],
              [22.675, 58.586],
              [22.67, 58.584],
              [22.658, 58.582],
              [22.652, 58.582],
              [22.646, 58.583],
              [22.64, 58.585],
              [22.635, 58.587],
              [22.623, 58.593],
              [22.613, 58.601],
              [22.592, 58.618],
              [22.586, 58.622],
              [22.581, 58.626],
              [22.575, 58.629],
              [22.57, 58.632],
              [22.565, 58.634],
            ],
          ],
        ],
      },
      properties: {
        id: 50,
        name: 'Rigabukten',
        latlon: [57.883321, 23.331441],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [11.776, 57.971],
              [10.643, 57.741],
              [10.644, 57.743],
              [10.643, 57.745],
              [10.64, 57.746],
              [10.636, 57.747],
              [10.626, 57.749],
              [10.62, 57.75],
              [10.607, 57.75],
              [10.6, 57.749],
              [10.593, 57.749],
              [10.579, 57.747],
              [10.572, 57.745],
              [10.565, 57.744],
              [10.559, 57.742],
              [10.552, 57.739],
              [10.545, 57.737],
              [10.538, 57.734],
              [10.525, 57.729],
              [10.505, 57.72],
              [10.363, 57.654],
              [10.35, 57.648],
              [10.337, 57.643],
              [10.323, 57.637],
              [10.317, 57.635],
              [10.31, 57.632],
              [10.303, 57.63],
              [10.283, 57.624],
              [10.256, 57.617],
              [10.216, 57.606],
              [10.195, 57.601],
              [10.182, 57.598],
              [10.175, 57.596],
              [10.162, 57.594],
              [10.156, 57.593],
              [10.143, 57.591],
              [10.13, 57.59],
              [10.123, 57.59],
              [10.109, 57.589],
              [10.067, 57.589],
              [10.046, 57.59],
              [10.032, 57.59],
              [10.025, 57.591],
              [10.012, 57.592],
              [9.98, 57.595],
              [9.976, 57.596],
              [9.973, 57.596],
              [9.971, 57.594],
              [9.97, 57.594],
              [9.958, 57.592],
              [9.956, 57.592],
              [9.953, 57.591],
              [9.945, 57.587],
              [9.94, 57.583],
              [9.936, 57.579],
              [9.926, 57.57],
              [9.9, 57.546],
              [9.895, 57.542],
              [9.889, 57.537],
              [9.884, 57.533],
              [9.872, 57.525],
              [9.867, 57.521],
              [9.855, 57.513],
              [9.825, 57.495],
              [9.813, 57.488],
              [9.808, 57.484],
              [9.802, 57.479],
              [9.797, 57.475],
              [9.777, 57.455],
              [9.768, 57.444],
              [9.741, 57.41],
              [9.732, 57.399],
              [9.723, 57.389],
              [9.718, 57.383],
              [9.703, 57.368],
              [9.687, 57.354],
              [9.603, 57.278],
              [9.581, 57.259],
              [9.571, 57.25],
              [9.565, 57.246],
              [9.559, 57.241],
              [9.554, 57.237],
              [9.542, 57.229],
              [9.536, 57.226],
              [9.53, 57.222],
              [9.524, 57.219],
              [9.518, 57.215],
              [9.511, 57.212],
              [9.499, 57.206],
              [9.485, 57.201],
              [9.459, 57.189],
              [9.433, 57.178],
              [9.42, 57.173],
              [9.413, 57.171],
              [9.407, 57.168],
              [9.386, 57.162],
              [9.38, 57.16],
              [9.359, 57.157],
              [9.339, 57.153],
              [9.297, 57.147],
              [9.283, 57.146],
              [9.277, 57.145],
              [9.263, 57.144],
              [9.235, 57.141],
              [9.207, 57.14],
              [9.193, 57.139],
              [9.166, 57.139],
              [9.153, 57.14],
              [9.133, 57.141],
              [9.119, 57.142],
              [9.113, 57.143],
              [9.106, 57.144],
              [9.093, 57.146],
              [9.08, 57.149],
              [9.06, 57.153],
              [9.047, 57.155],
              [9.041, 57.156],
              [9.034, 57.157],
              [9.028, 57.158],
              [9.021, 57.158],
              [9.013, 57.159],
              [9.006, 57.158],
              [8.992, 57.158],
              [8.978, 57.156],
              [8.972, 57.154],
              [8.965, 57.153],
              [8.958, 57.151],
              [8.952, 57.148],
              [8.939, 57.144],
              [8.906, 57.132],
              [8.893, 57.127],
              [8.88, 57.123],
              [8.866, 57.119],
              [8.853, 57.116],
              [8.839, 57.113],
              [8.824, 57.111],
              [8.803, 57.107],
              [8.768, 57.102],
              [8.747, 57.102],
              [8.719, 57.106],
              [8.705, 57.109],
              [8.669, 57.117],
              [8.655, 57.12],
              [8.642, 57.122],
              [8.645, 58.346],
              [8.649, 58.348],
              [8.659, 58.354],
              [8.667, 58.358],
              [8.67, 58.36],
              [8.675, 58.364],
              [8.677, 58.366],
              [8.689, 58.369],
              [8.692, 58.371],
              [8.695, 58.372],
              [8.706, 58.378],
              [8.708, 58.38],
              [8.711, 58.382],
              [8.715, 58.386],
              [8.716, 58.388],
              [8.717, 58.389],
              [8.717, 58.391],
              [8.716, 58.393],
              [8.714, 58.396],
              [8.714, 58.402],
              [8.715, 58.406],
              [8.719, 58.418],
              [8.72, 58.423],
              [8.722, 58.431],
              [8.723, 58.434],
              [8.726, 58.438],
              [8.73, 58.441],
              [8.735, 58.445],
              [8.74, 58.448],
              [8.752, 58.454],
              [8.759, 58.456],
              [8.772, 58.462],
              [8.778, 58.464],
              [8.785, 58.466],
              [8.791, 58.468],
              [8.798, 58.47],
              [8.806, 58.471],
              [8.811, 58.473],
              [8.815, 58.474],
              [8.82, 58.476],
              [8.824, 58.478],
              [8.829, 58.481],
              [8.838, 58.486],
              [8.841, 58.489],
              [8.848, 58.492],
              [8.851, 58.494],
              [8.856, 58.499],
              [8.86, 58.506],
              [8.862, 58.509],
              [8.868, 58.515],
              [8.869, 58.515],
              [8.87, 58.516],
              [8.87, 58.514],
              [8.869, 58.511],
              [8.869, 58.507],
              [8.87, 58.506],
              [8.874, 58.504],
              [8.877, 58.504],
              [8.881, 58.506],
              [8.889, 58.514],
              [8.892, 58.516],
              [8.896, 58.522],
              [8.899, 58.524],
              [8.902, 58.525],
              [8.906, 58.527],
              [8.92, 58.533],
              [8.93, 58.536],
              [8.934, 58.538],
              [8.939, 58.54],
              [8.944, 58.543],
              [8.949, 58.547],
              [8.953, 58.55],
              [8.957, 58.555],
              [8.96, 58.56],
              [8.962, 58.565],
              [8.963, 58.57],
              [8.963, 58.579],
              [8.962, 58.583],
              [8.961, 58.586],
              [8.958, 58.588],
              [8.946, 58.588],
              [8.944, 58.587],
              [8.942, 58.587],
              [8.94, 58.586],
              [8.935, 58.584],
              [8.934, 58.583],
              [8.933, 58.583],
              [8.932, 58.584],
              [8.933, 58.585],
              [8.936, 58.594],
              [8.937, 58.596],
              [8.937, 58.6],
              [8.938, 58.609],
              [8.938, 58.612],
              [8.939, 58.615],
              [8.941, 58.617],
              [8.943, 58.618],
              [8.947, 58.618],
              [8.956, 58.609],
              [8.974, 58.598],
              [8.98, 58.596],
              [8.984, 58.595],
              [8.987, 58.594],
              [8.991, 58.594],
              [8.999, 58.596],
              [9.004, 58.599],
              [9.008, 58.602],
              [9.017, 58.609],
              [9.022, 58.612],
              [9.031, 58.615],
              [9.04, 58.616],
              [9.045, 58.617],
              [9.049, 58.619],
              [9.053, 58.62],
              [9.061, 58.623],
              [9.067, 58.624],
              [9.07, 58.625],
              [9.074, 58.627],
              [9.085, 58.631],
              [9.091, 58.633],
              [9.122, 58.645],
              [9.14, 58.651],
              [9.145, 58.654],
              [9.15, 58.656],
              [9.154, 58.658],
              [9.157, 58.66],
              [9.16, 58.661],
              [9.164, 58.662],
              [9.175, 58.662],
              [9.18, 58.663],
              [9.186, 58.664],
              [9.191, 58.666],
              [9.197, 58.668],
              [9.202, 58.67],
              [9.207, 58.673],
              [9.215, 58.679],
              [9.219, 58.685],
              [9.218, 58.687],
              [9.216, 58.689],
              [9.213, 58.69],
              [9.209, 58.692],
              [9.199, 58.694],
              [9.185, 58.694],
              [9.178, 58.693],
              [9.164, 58.692],
              [9.149, 58.691],
              [9.112, 58.687],
              [9.099, 58.685],
              [9.085, 58.685],
              [9.083, 58.686],
              [9.085, 58.687],
              [9.088, 58.688],
              [9.093, 58.689],
              [9.108, 58.693],
              [9.12, 58.695],
              [9.127, 58.695],
              [9.148, 58.696],
              [9.154, 58.697],
              [9.168, 58.698],
              [9.182, 58.7],
              [9.188, 58.701],
              [9.195, 58.702],
              [9.201, 58.703],
              [9.208, 58.705],
              [9.213, 58.707],
              [9.219, 58.709],
              [9.223, 58.711],
              [9.227, 58.714],
              [9.23, 58.716],
              [9.232, 58.719],
              [9.232, 58.721],
              [9.23, 58.723],
              [9.218, 58.723],
              [9.202, 58.721],
              [9.196, 58.72],
              [9.178, 58.72],
              [9.146, 58.719],
              [9.13, 58.719],
              [9.125, 58.72],
              [9.122, 58.72],
              [9.116, 58.722],
              [9.112, 58.723],
              [9.108, 58.723],
              [9.093, 58.725],
              [9.088, 58.726],
              [9.083, 58.726],
              [9.075, 58.728],
              [9.073, 58.73],
              [9.073, 58.734],
              [9.075, 58.739],
              [9.075, 58.744],
              [9.074, 58.748],
              [9.074, 58.75],
              [9.075, 58.751],
              [9.076, 58.753],
              [9.081, 58.753],
              [9.089, 58.751],
              [9.105, 58.751],
              [9.111, 58.75],
              [9.118, 58.749],
              [9.124, 58.748],
              [9.145, 58.745],
              [9.151, 58.744],
              [9.158, 58.743],
              [9.168, 58.743],
              [9.172, 58.744],
              [9.178, 58.745],
              [9.191, 58.745],
              [9.204, 58.746],
              [9.238, 58.746],
              [9.251, 58.747],
              [9.258, 58.747],
              [9.263, 58.746],
              [9.267, 58.745],
              [9.291, 58.745],
              [9.297, 58.746],
              [9.304, 58.748],
              [9.316, 58.75],
              [9.341, 58.757],
              [9.344, 58.758],
              [9.348, 58.759],
              [9.353, 58.761],
              [9.357, 58.764],
              [9.379, 58.776],
              [9.389, 58.782],
              [9.393, 58.784],
              [9.407, 58.79],
              [9.415, 58.794],
              [9.419, 58.797],
              [9.423, 58.801],
              [9.423, 58.802],
              [9.422, 58.804],
              [9.41, 58.804],
              [9.39, 58.8],
              [9.386, 58.799],
              [9.383, 58.799],
              [9.382, 58.8],
              [9.382, 58.801],
              [9.386, 58.803],
              [9.393, 58.806],
              [9.396, 58.808],
              [9.404, 58.813],
              [9.408, 58.815],
              [9.413, 58.817],
              [9.419, 58.819],
              [9.441, 58.826],
              [9.445, 58.827],
              [9.449, 58.829],
              [9.452, 58.831],
              [9.454, 58.833],
              [9.453, 58.836],
              [9.452, 58.838],
              [9.449, 58.84],
              [9.441, 58.844],
              [9.436, 58.846],
              [9.431, 58.847],
              [9.413, 58.85],
              [9.393, 58.85],
              [9.385, 58.849],
              [9.378, 58.849],
              [9.364, 58.847],
              [9.357, 58.845],
              [9.35, 58.844],
              [9.343, 58.842],
              [9.337, 58.841],
              [9.327, 58.837],
              [9.314, 58.833],
              [9.311, 58.832],
              [9.308, 58.832],
              [9.307, 58.833],
              [9.307, 58.834],
              [9.306, 58.835],
              [9.304, 58.835],
              [9.301, 58.836],
              [9.288, 58.836],
              [9.286, 58.838],
              [9.287, 58.839],
              [9.288, 58.841],
              [9.293, 58.848],
              [9.296, 58.857],
              [9.302, 58.869],
              [9.306, 58.875],
              [9.307, 58.877],
              [9.309, 58.878],
              [9.316, 58.878],
              [9.324, 58.875],
              [9.328, 58.873],
              [9.333, 58.872],
              [9.337, 58.872],
              [9.341, 58.871],
              [9.345, 58.872],
              [9.35, 58.873],
              [9.352, 58.873],
              [9.36, 58.869],
              [9.363, 58.868],
              [9.365, 58.867],
              [9.375, 58.865],
              [9.391, 58.865],
              [9.396, 58.866],
              [9.404, 58.868],
              [9.406, 58.87],
              [9.407, 58.872],
              [9.407, 58.874],
              [9.405, 58.875],
              [9.404, 58.877],
              [9.401, 58.878],
              [9.401, 58.88],
              [9.403, 58.881],
              [9.404, 58.882],
              [9.409, 58.884],
              [9.411, 58.885],
              [9.413, 58.887],
              [9.413, 58.891],
              [9.411, 58.895],
              [9.408, 58.896],
              [9.397, 58.896],
              [9.393, 58.895],
              [9.382, 58.892],
              [9.379, 58.891],
              [9.379, 58.894],
              [9.381, 58.896],
              [9.384, 58.897],
              [9.387, 58.899],
              [9.391, 58.9],
              [9.396, 58.902],
              [9.402, 58.903],
              [9.408, 58.903],
              [9.414, 58.904],
              [9.419, 58.903],
              [9.427, 58.902],
              [9.431, 58.902],
              [9.44, 58.899],
              [9.453, 58.895],
              [9.456, 58.895],
              [9.458, 58.896],
              [9.46, 58.898],
              [9.461, 58.9],
              [9.462, 58.901],
              [9.464, 58.902],
              [9.465, 58.903],
              [9.467, 58.904],
              [9.471, 58.905],
              [9.472, 58.905],
              [9.475, 58.907],
              [9.477, 58.91],
              [9.48, 58.912],
              [9.484, 58.915],
              [9.494, 58.921],
              [9.497, 58.922],
              [9.497, 58.925],
              [9.495, 58.926],
              [9.492, 58.928],
              [9.489, 58.928],
              [9.484, 58.93],
              [9.481, 58.93],
              [9.479, 58.931],
              [9.474, 58.935],
              [9.473, 58.935],
              [9.473, 58.936],
              [9.474, 58.937],
              [9.48, 58.937],
              [9.485, 58.936],
              [9.51, 58.932],
              [9.517, 58.932],
              [9.523, 58.931],
              [9.551, 58.93],
              [9.569, 58.929],
              [9.586, 58.929],
              [9.592, 58.93],
              [9.597, 58.931],
              [9.601, 58.932],
              [9.603, 58.932],
              [9.606, 58.933],
              [9.607, 58.935],
              [9.608, 58.936],
              [9.607, 58.937],
              [9.605, 58.94],
              [9.604, 58.942],
              [9.604, 58.944],
              [9.606, 58.946],
              [9.609, 58.948],
              [9.613, 58.95],
              [9.618, 58.952],
              [9.633, 58.957],
              [9.643, 58.961],
              [9.647, 58.963],
              [9.654, 58.966],
              [9.657, 58.967],
              [9.661, 58.968],
              [9.685, 58.972],
              [9.687, 58.972],
              [9.691, 58.974],
              [9.692, 58.976],
              [9.692, 58.977],
              [9.691, 58.979],
              [9.689, 58.981],
              [9.686, 58.983],
              [9.682, 58.984],
              [9.675, 58.987],
              [9.672, 58.99],
              [9.673, 58.991],
              [9.676, 58.992],
              [9.679, 58.992],
              [9.691, 58.993],
              [9.695, 58.993],
              [9.698, 58.994],
              [9.701, 58.996],
              [9.707, 58.999],
              [9.713, 59.001],
              [9.729, 59.001],
              [9.737, 58.999],
              [9.74, 58.999],
              [9.743, 58.998],
              [9.745, 58.999],
              [9.746, 59.002],
              [9.746, 59.005],
              [9.745, 59.009],
              [9.743, 59.013],
              [9.74, 59.017],
              [9.732, 59.025],
              [9.727, 59.029],
              [9.722, 59.032],
              [9.716, 59.035],
              [9.711, 59.038],
              [9.705, 59.041],
              [9.699, 59.043],
              [9.694, 59.045],
              [9.688, 59.047],
              [9.683, 59.048],
              [9.677, 59.049],
              [9.662, 59.051],
              [9.657, 59.052],
              [9.652, 59.054],
              [9.644, 59.058],
              [9.636, 59.064],
              [9.629, 59.071],
              [9.626, 59.075],
              [9.618, 59.083],
              [9.613, 59.087],
              [9.607, 59.091],
              [9.601, 59.094],
              [9.596, 59.097],
              [9.589, 59.1],
              [9.583, 59.103],
              [9.567, 59.109],
              [9.562, 59.112],
              [9.55, 59.118],
              [9.545, 59.119],
              [9.54, 59.121],
              [9.528, 59.124],
              [9.526, 59.125],
              [9.525, 59.126],
              [9.526, 59.127],
              [9.528, 59.127],
              [9.532, 59.128],
              [9.536, 59.128],
              [9.541, 59.127],
              [9.546, 59.127],
              [9.569, 59.123],
              [9.579, 59.121],
              [9.586, 59.121],
              [9.598, 59.123],
              [9.602, 59.124],
              [9.607, 59.125],
              [9.611, 59.127],
              [9.616, 59.129],
              [9.624, 59.133],
              [9.629, 59.135],
              [9.633, 59.138],
              [9.636, 59.141],
              [9.64, 59.147],
              [9.64, 59.156],
              [9.638, 59.162],
              [9.635, 59.167],
              [9.633, 59.172],
              [9.63, 59.177],
              [9.622, 59.19],
              [9.621, 59.193],
              [9.62, 59.194],
              [9.623, 59.191],
              [9.626, 59.189],
              [9.632, 59.181],
              [9.638, 59.171],
              [9.641, 59.167],
              [9.643, 59.162],
              [9.645, 59.158],
              [9.646, 59.154],
              [9.646, 59.145],
              [9.644, 59.142],
              [9.642, 59.136],
              [9.641, 59.134],
              [9.64, 59.131],
              [9.64, 59.126],
              [9.638, 59.124],
              [9.631, 59.124],
              [9.629, 59.123],
              [9.628, 59.122],
              [9.628, 59.12],
              [9.629, 59.117],
              [9.631, 59.114],
              [9.637, 59.107],
              [9.64, 59.103],
              [9.642, 59.098],
              [9.644, 59.095],
              [9.647, 59.086],
              [9.649, 59.082],
              [9.655, 59.072],
              [9.659, 59.067],
              [9.664, 59.063],
              [9.668, 59.06],
              [9.678, 59.056],
              [9.687, 59.056],
              [9.69, 59.057],
              [9.693, 59.059],
              [9.694, 59.061],
              [9.694, 59.064],
              [9.695, 59.075],
              [9.695, 59.079],
              [9.697, 59.087],
              [9.699, 59.092],
              [9.701, 59.096],
              [9.703, 59.098],
              [9.706, 59.099],
              [9.709, 59.099],
              [9.711, 59.098],
              [9.713, 59.096],
              [9.715, 59.093],
              [9.723, 59.077],
              [9.726, 59.075],
              [9.729, 59.072],
              [9.731, 59.071],
              [9.738, 59.067],
              [9.741, 59.066],
              [9.744, 59.063],
              [9.755, 59.056],
              [9.759, 59.053],
              [9.763, 59.051],
              [9.767, 59.05],
              [9.773, 59.05],
              [9.776, 59.052],
              [9.782, 59.061],
              [9.784, 59.065],
              [9.787, 59.068],
              [9.791, 59.074],
              [9.795, 59.076],
              [9.796, 59.074],
              [9.798, 59.068],
              [9.802, 59.058],
              [9.805, 59.054],
              [9.808, 59.049],
              [9.811, 59.045],
              [9.815, 59.043],
              [9.818, 59.041],
              [9.822, 59.039],
              [9.826, 59.038],
              [9.833, 59.035],
              [9.836, 59.034],
              [9.839, 59.031],
              [9.845, 59.023],
              [9.847, 59.018],
              [9.849, 59.008],
              [9.849, 58.999],
              [9.847, 58.995],
              [9.844, 58.991],
              [9.836, 58.982],
              [9.834, 58.979],
              [9.832, 58.977],
              [9.831, 58.974],
              [9.832, 58.972],
              [9.835, 58.97],
              [9.838, 58.969],
              [9.842, 58.967],
              [9.854, 58.964],
              [9.858, 58.965],
              [9.861, 58.965],
              [9.864, 58.966],
              [9.874, 58.969],
              [9.879, 58.97],
              [9.915, 58.97],
              [9.921, 58.971],
              [9.927, 58.971],
              [9.933, 58.969],
              [9.939, 58.968],
              [9.953, 58.968],
              [9.956, 58.969],
              [9.96, 58.969],
              [9.963, 58.971],
              [9.971, 58.974],
              [9.974, 58.975],
              [9.978, 58.976],
              [9.981, 58.976],
              [9.989, 58.975],
              [10.006, 58.975],
              [10.011, 58.976],
              [10.02, 58.978],
              [10.025, 58.98],
              [10.029, 58.981],
              [10.032, 58.983],
              [10.035, 58.986],
              [10.037, 58.989],
              [10.039, 58.993],
              [10.04, 58.996],
              [10.041, 59],
              [10.041, 59.003],
              [10.04, 59.005],
              [10.034, 59.018],
              [10.029, 59.026],
              [10.027, 59.031],
              [10.027, 59.037],
              [10.029, 59.041],
              [10.031, 59.043],
              [10.04, 59.043],
              [10.042, 59.042],
              [10.054, 59.039],
              [10.056, 59.038],
              [10.057, 59.037],
              [10.06, 59.035],
              [10.061, 59.033],
              [10.064, 59.031],
              [10.071, 59.028],
              [10.079, 59.024],
              [10.084, 59.024],
              [10.089, 59.025],
              [10.095, 59.026],
              [10.113, 59.032],
              [10.132, 59.039],
              [10.15, 59.045],
              [10.158, 59.045],
              [10.161, 59.044],
              [10.163, 59.043],
              [10.163, 59.041],
              [10.158, 59.036],
              [10.146, 59.028],
              [10.142, 59.025],
              [10.139, 59.022],
              [10.138, 59.02],
              [10.138, 59.017],
              [10.14, 59.013],
              [10.146, 59.011],
              [10.155, 59.011],
              [10.161, 59.012],
              [10.166, 59.013],
              [10.178, 59.017],
              [10.189, 59.021],
              [10.202, 59.026],
              [10.206, 59.028],
              [10.211, 59.03],
              [10.219, 59.036],
              [10.222, 59.04],
              [10.224, 59.044],
              [10.226, 59.052],
              [10.226, 59.06],
              [10.219, 59.074],
              [10.218, 59.077],
              [10.223, 59.092],
              [10.225, 59.102],
              [10.227, 59.111],
              [10.228, 59.115],
              [10.229, 59.118],
              [10.23, 59.12],
              [10.233, 59.12],
              [10.233, 59.119],
              [10.234, 59.114],
              [10.235, 59.112],
              [10.241, 59.103],
              [10.245, 59.099],
              [10.25, 59.093],
              [10.257, 59.079],
              [10.259, 59.068],
              [10.26, 59.063],
              [10.262, 59.06],
              [10.264, 59.056],
              [10.268, 59.052],
              [10.27, 59.052],
              [10.274, 59.054],
              [10.274, 59.057],
              [10.275, 59.064],
              [10.276, 59.07],
              [10.276, 59.074],
              [10.275, 59.078],
              [10.274, 59.083],
              [10.27, 59.098],
              [10.268, 59.106],
              [10.268, 59.109],
              [10.269, 59.111],
              [10.27, 59.112],
              [10.276, 59.11],
              [10.279, 59.107],
              [10.282, 59.103],
              [10.285, 59.098],
              [10.288, 59.094],
              [10.291, 59.089],
              [10.3, 59.071],
              [10.304, 59.067],
              [10.306, 59.067],
              [10.307, 59.069],
              [10.307, 59.075],
              [10.306, 59.081],
              [10.306, 59.085],
              [10.305, 59.09],
              [10.304, 59.094],
              [10.294, 59.119],
              [10.292, 59.123],
              [10.292, 59.13],
              [10.294, 59.131],
              [10.296, 59.133],
              [10.299, 59.133],
              [10.302, 59.134],
              [10.305, 59.134],
              [10.312, 59.133],
              [10.315, 59.134],
              [10.317, 59.134],
              [10.319, 59.136],
              [10.319, 59.143],
              [10.318, 59.147],
              [10.318, 59.151],
              [10.319, 59.154],
              [10.32, 59.158],
              [10.322, 59.162],
              [10.326, 59.171],
              [10.329, 59.176],
              [10.331, 59.182],
              [10.335, 59.193],
              [10.339, 59.203],
              [10.341, 59.207],
              [10.344, 59.211],
              [10.348, 59.214],
              [10.356, 59.219],
              [10.36, 59.222],
              [10.366, 59.228],
              [10.369, 59.232],
              [10.371, 59.237],
              [10.372, 59.243],
              [10.375, 59.254],
              [10.376, 59.259],
              [10.378, 59.263],
              [10.381, 59.267],
              [10.387, 59.271],
              [10.391, 59.272],
              [10.395, 59.271],
              [10.4, 59.271],
              [10.413, 59.267],
              [10.418, 59.265],
              [10.438, 59.261],
              [10.447, 59.256],
              [10.451, 59.254],
              [10.457, 59.252],
              [10.462, 59.251],
              [10.468, 59.252],
              [10.473, 59.253],
              [10.478, 59.255],
              [10.49, 59.259],
              [10.493, 59.261],
              [10.496, 59.262],
              [10.497, 59.264],
              [10.5, 59.273],
              [10.502, 59.276],
              [10.503, 59.279],
              [10.509, 59.288],
              [10.514, 59.295],
              [10.517, 59.298],
              [10.519, 59.301],
              [10.52, 59.305],
              [10.52, 59.309],
              [10.519, 59.312],
              [10.515, 59.318],
              [10.512, 59.32],
              [10.508, 59.323],
              [10.5, 59.328],
              [10.496, 59.331],
              [10.487, 59.34],
              [10.484, 59.344],
              [10.48, 59.349],
              [10.477, 59.354],
              [10.473, 59.364],
              [10.472, 59.37],
              [10.474, 59.38],
              [10.476, 59.385],
              [10.483, 59.4],
              [10.485, 59.405],
              [10.486, 59.409],
              [10.484, 59.417],
              [10.472, 59.426],
              [10.462, 59.432],
              [10.45, 59.441],
              [10.448, 59.443],
              [10.446, 59.446],
              [10.444, 59.448],
              [10.441, 59.449],
              [10.436, 59.449],
              [10.433, 59.448],
              [10.427, 59.447],
              [10.391, 59.447],
              [10.386, 59.448],
              [10.376, 59.452],
              [10.372, 59.456],
              [10.358, 59.466],
              [10.35, 59.472],
              [10.345, 59.474],
              [10.341, 59.476],
              [10.337, 59.477],
              [10.333, 59.48],
              [10.329, 59.482],
              [10.322, 59.488],
              [10.313, 59.494],
              [10.309, 59.497],
              [10.304, 59.501],
              [10.3, 59.506],
              [10.286, 59.519],
              [10.281, 59.523],
              [10.277, 59.527],
              [10.262, 59.537],
              [10.257, 59.541],
              [10.25, 59.548],
              [10.244, 59.556],
              [10.243, 59.559],
              [10.243, 59.561],
              [10.244, 59.563],
              [10.247, 59.564],
              [10.252, 59.564],
              [10.26, 59.562],
              [10.266, 59.561],
              [10.278, 59.557],
              [10.29, 59.552],
              [10.309, 59.543],
              [10.316, 59.541],
              [10.322, 59.538],
              [10.329, 59.536],
              [10.335, 59.535],
              [10.342, 59.533],
              [10.368, 59.533],
              [10.374, 59.535],
              [10.379, 59.537],
              [10.385, 59.54],
              [10.389, 59.543],
              [10.393, 59.548],
              [10.396, 59.552],
              [10.399, 59.557],
              [10.401, 59.561],
              [10.401, 59.578],
              [10.403, 59.582],
              [10.406, 59.589],
              [10.407, 59.593],
              [10.407, 59.596],
              [10.408, 59.61],
              [10.407, 59.616],
              [10.407, 59.622],
              [10.405, 59.628],
              [10.401, 59.638],
              [10.398, 59.644],
              [10.394, 59.649],
              [10.391, 59.654],
              [10.387, 59.659],
              [10.378, 59.668],
              [10.373, 59.672],
              [10.361, 59.68],
              [10.355, 59.683],
              [10.349, 59.685],
              [10.307, 59.697],
              [10.301, 59.699],
              [10.287, 59.705],
              [10.281, 59.709],
              [10.262, 59.719],
              [10.244, 59.728],
              [10.231, 59.732],
              [10.227, 59.734],
              [10.227, 59.736],
              [10.236, 59.739],
              [10.244, 59.742],
              [10.248, 59.743],
              [10.258, 59.745],
              [10.269, 59.745],
              [10.274, 59.744],
              [10.28, 59.743],
              [10.286, 59.741],
              [10.291, 59.738],
              [10.297, 59.735],
              [10.308, 59.728],
              [10.32, 59.722],
              [10.325, 59.719],
              [10.331, 59.718],
              [10.337, 59.716],
              [10.349, 59.713],
              [10.364, 59.71],
              [10.368, 59.709],
              [10.383, 59.703],
              [10.392, 59.697],
              [10.397, 59.695],
              [10.415, 59.686],
              [10.418, 59.683],
              [10.422, 59.681],
              [10.425, 59.678],
              [10.429, 59.668],
              [10.43, 59.663],
              [10.432, 59.651],
              [10.433, 59.635],
              [10.433, 59.627],
              [10.432, 59.624],
              [10.428, 59.618],
              [10.427, 59.615],
              [10.426, 59.613],
              [10.428, 59.609],
              [10.429, 59.606],
              [10.431, 59.603],
              [10.432, 59.6],
              [10.432, 59.591],
              [10.431, 59.586],
              [10.43, 59.58],
              [10.425, 59.562],
              [10.424, 59.557],
              [10.422, 59.545],
              [10.423, 59.54],
              [10.424, 59.536],
              [10.427, 59.532],
              [10.43, 59.529],
              [10.435, 59.526],
              [10.44, 59.524],
              [10.446, 59.522],
              [10.451, 59.521],
              [10.457, 59.52],
              [10.464, 59.519],
              [10.47, 59.519],
              [10.477, 59.52],
              [10.483, 59.521],
              [10.49, 59.522],
              [10.506, 59.524],
              [10.514, 59.526],
              [10.555, 59.539],
              [10.569, 59.543],
              [10.587, 59.552],
              [10.593, 59.556],
              [10.608, 59.568],
              [10.611, 59.573],
              [10.613, 59.578],
              [10.615, 59.584],
              [10.616, 59.59],
              [10.616, 59.602],
              [10.615, 59.609],
              [10.614, 59.615],
              [10.612, 59.621],
              [10.611, 59.628],
              [10.607, 59.64],
              [10.603, 59.65],
              [10.6, 59.655],
              [10.597, 59.659],
              [10.594, 59.662],
              [10.592, 59.663],
              [10.589, 59.665],
              [10.586, 59.666],
              [10.584, 59.667],
              [10.575, 59.668],
              [10.572, 59.669],
              [10.567, 59.671],
              [10.561, 59.673],
              [10.546, 59.679],
              [10.538, 59.683],
              [10.535, 59.684],
              [10.526, 59.693],
              [10.523, 59.697],
              [10.519, 59.709],
              [10.517, 59.721],
              [10.514, 59.74],
              [10.512, 59.752],
              [10.51, 59.757],
              [10.504, 59.769],
              [10.503, 59.774],
              [10.501, 59.779],
              [10.5, 59.79],
              [10.499, 59.795],
              [10.495, 59.805],
              [10.489, 59.817],
              [10.489, 59.823],
              [10.491, 59.826],
              [10.494, 59.831],
              [10.495, 59.833],
              [10.496, 59.834],
              [10.492, 59.836],
              [10.489, 59.836],
              [10.486, 59.837],
              [10.484, 59.838],
              [10.484, 59.841],
              [10.486, 59.844],
              [10.492, 59.849],
              [10.502, 59.861],
              [10.508, 59.87],
              [10.514, 59.876],
              [10.518, 59.879],
              [10.521, 59.881],
              [10.525, 59.883],
              [10.53, 59.885],
              [10.534, 59.887],
              [10.544, 59.889],
              [10.55, 59.889],
              [10.58, 59.894],
              [10.594, 59.897],
              [10.598, 59.898],
              [10.6, 59.898],
              [10.601, 59.897],
              [10.601, 59.894],
              [10.602, 59.89],
              [10.605, 59.887],
              [10.605, 59.884],
              [10.609, 59.883],
              [10.61, 59.882],
              [10.611, 59.882],
              [10.612, 59.881],
              [10.613, 59.882],
              [10.619, 59.884],
              [10.623, 59.886],
              [10.627, 59.889],
              [10.63, 59.892],
              [10.634, 59.895],
              [10.645, 59.906],
              [10.653, 59.91],
              [10.657, 59.911],
              [10.66, 59.912],
              [10.663, 59.912],
              [10.666, 59.911],
              [10.671, 59.907],
              [10.677, 59.903],
              [10.688, 59.903],
              [10.691, 59.904],
              [10.692, 59.905],
              [10.694, 59.908],
              [10.696, 59.909],
              [10.697, 59.91],
              [10.704, 59.91],
              [10.713, 59.909],
              [10.724, 59.908],
              [10.73, 59.907],
              [10.734, 59.907],
              [10.737, 59.906],
              [10.744, 59.903],
              [10.747, 59.902],
              [10.749, 59.9],
              [10.752, 59.898],
              [10.753, 59.895],
              [10.756, 59.891],
              [10.757, 59.889],
              [10.762, 59.884],
              [10.766, 59.881],
              [10.769, 59.878],
              [10.772, 59.874],
              [10.776, 59.864],
              [10.777, 59.859],
              [10.777, 59.855],
              [10.776, 59.85],
              [10.772, 59.84],
              [10.769, 59.835],
              [10.765, 59.829],
              [10.761, 59.824],
              [10.748, 59.809],
              [10.74, 59.799],
              [10.737, 59.793],
              [10.734, 59.786],
              [10.731, 59.78],
              [10.729, 59.773],
              [10.728, 59.766],
              [10.726, 59.76],
              [10.725, 59.753],
              [10.725, 59.747],
              [10.724, 59.736],
              [10.724, 59.731],
              [10.723, 59.728],
              [10.722, 59.726],
              [10.721, 59.725],
              [10.72, 59.725],
              [10.719, 59.727],
              [10.718, 59.732],
              [10.715, 59.744],
              [10.713, 59.749],
              [10.712, 59.754],
              [10.712, 59.773],
              [10.711, 59.78],
              [10.71, 59.786],
              [10.708, 59.793],
              [10.707, 59.8],
              [10.703, 59.814],
              [10.697, 59.828],
              [10.691, 59.84],
              [10.687, 59.845],
              [10.683, 59.849],
              [10.678, 59.853],
              [10.674, 59.857],
              [10.669, 59.859],
              [10.665, 59.861],
              [10.659, 59.861],
              [10.655, 59.859],
              [10.647, 59.851],
              [10.639, 59.841],
              [10.621, 59.82],
              [10.616, 59.815],
              [10.604, 59.797],
              [10.601, 59.792],
              [10.592, 59.774],
              [10.59, 59.768],
              [10.588, 59.761],
              [10.586, 59.755],
              [10.585, 59.749],
              [10.585, 59.743],
              [10.587, 59.731],
              [10.588, 59.726],
              [10.591, 59.72],
              [10.593, 59.715],
              [10.597, 59.71],
              [10.6, 59.705],
              [10.604, 59.701],
              [10.608, 59.698],
              [10.612, 59.696],
              [10.615, 59.695],
              [10.619, 59.695],
              [10.631, 59.699],
              [10.632, 59.699],
              [10.632, 59.698],
              [10.629, 59.692],
              [10.627, 59.684],
              [10.627, 59.674],
              [10.628, 59.669],
              [10.629, 59.663],
              [10.631, 59.658],
              [10.634, 59.652],
              [10.641, 59.634],
              [10.644, 59.629],
              [10.646, 59.623],
              [10.647, 59.616],
              [10.649, 59.61],
              [10.649, 59.604],
              [10.65, 59.597],
              [10.651, 59.578],
              [10.651, 59.572],
              [10.653, 59.56],
              [10.655, 59.554],
              [10.658, 59.548],
              [10.661, 59.543],
              [10.664, 59.537],
              [10.667, 59.533],
              [10.671, 59.529],
              [10.678, 59.523],
              [10.681, 59.52],
              [10.682, 59.517],
              [10.683, 59.513],
              [10.684, 59.503],
              [10.684, 59.497],
              [10.685, 59.491],
              [10.683, 59.479],
              [10.681, 59.473],
              [10.678, 59.467],
              [10.675, 59.462],
              [10.664, 59.444],
              [10.658, 59.432],
              [10.656, 59.426],
              [10.653, 59.408],
              [10.653, 59.402],
              [10.652, 59.396],
              [10.653, 59.39],
              [10.653, 59.385],
              [10.654, 59.381],
              [10.655, 59.378],
              [10.659, 59.372],
              [10.66, 59.369],
              [10.663, 59.361],
              [10.664, 59.358],
              [10.664, 59.356],
              [10.663, 59.352],
              [10.662, 59.35],
              [10.662, 59.346],
              [10.663, 59.342],
              [10.665, 59.337],
              [10.667, 59.333],
              [10.67, 59.329],
              [10.676, 59.323],
              [10.68, 59.321],
              [10.685, 59.317],
              [10.691, 59.315],
              [10.699, 59.317],
              [10.703, 59.319],
              [10.723, 59.331],
              [10.727, 59.333],
              [10.732, 59.335],
              [10.736, 59.337],
              [10.739, 59.337],
              [10.742, 59.336],
              [10.744, 59.335],
              [10.745, 59.333],
              [10.745, 59.33],
              [10.744, 59.327],
              [10.742, 59.325],
              [10.739, 59.323],
              [10.733, 59.318],
              [10.73, 59.317],
              [10.729, 59.315],
              [10.729, 59.314],
              [10.73, 59.312],
              [10.732, 59.31],
              [10.741, 59.31],
              [10.752, 59.313],
              [10.762, 59.314],
              [10.767, 59.315],
              [10.771, 59.316],
              [10.78, 59.319],
              [10.785, 59.32],
              [10.79, 59.322],
              [10.794, 59.323],
              [10.798, 59.323],
              [10.798, 59.322],
              [10.797, 59.321],
              [10.783, 59.313],
              [10.773, 59.307],
              [10.762, 59.3],
              [10.758, 59.297],
              [10.753, 59.293],
              [10.741, 59.281],
              [10.735, 59.278],
              [10.734, 59.277],
              [10.733, 59.275],
              [10.732, 59.274],
              [10.732, 59.273],
              [10.734, 59.271],
              [10.737, 59.27],
              [10.738, 59.268],
              [10.739, 59.267],
              [10.739, 59.263],
              [10.736, 59.26],
              [10.734, 59.259],
              [10.733, 59.257],
              [10.733, 59.252],
              [10.734, 59.246],
              [10.736, 59.24],
              [10.737, 59.238],
              [10.738, 59.238],
              [10.741, 59.237],
              [10.744, 59.237],
              [10.749, 59.238],
              [10.753, 59.239],
              [10.758, 59.24],
              [10.763, 59.243],
              [10.767, 59.245],
              [10.78, 59.253],
              [10.781, 59.253],
              [10.781, 59.252],
              [10.778, 59.247],
              [10.776, 59.244],
              [10.775, 59.24],
              [10.775, 59.236],
              [10.776, 59.232],
              [10.778, 59.228],
              [10.781, 59.225],
              [10.791, 59.214],
              [10.793, 59.21],
              [10.795, 59.207],
              [10.797, 59.203],
              [10.799, 59.197],
              [10.8, 59.195],
              [10.802, 59.193],
              [10.805, 59.191],
              [10.813, 59.187],
              [10.816, 59.184],
              [10.823, 59.178],
              [10.835, 59.172],
              [10.84, 59.171],
              [10.844, 59.172],
              [10.847, 59.173],
              [10.855, 59.175],
              [10.861, 59.178],
              [10.864, 59.179],
              [10.868, 59.18],
              [10.875, 59.18],
              [10.888, 59.178],
              [10.893, 59.178],
              [10.896, 59.177],
              [10.899, 59.175],
              [10.901, 59.174],
              [10.903, 59.171],
              [10.906, 59.169],
              [10.908, 59.163],
              [10.908, 59.156],
              [10.91, 59.152],
              [10.914, 59.148],
              [10.916, 59.147],
              [10.918, 59.145],
              [10.921, 59.144],
              [10.927, 59.144],
              [10.93, 59.145],
              [10.934, 59.146],
              [10.942, 59.152],
              [10.945, 59.156],
              [10.952, 59.165],
              [10.955, 59.169],
              [10.959, 59.172],
              [10.962, 59.174],
              [10.97, 59.178],
              [10.975, 59.181],
              [10.98, 59.183],
              [10.984, 59.183],
              [10.988, 59.184],
              [10.992, 59.183],
              [10.999, 59.182],
              [11.003, 59.181],
              [11.005, 59.18],
              [11.007, 59.178],
              [11.01, 59.173],
              [11.013, 59.169],
              [11.016, 59.166],
              [11.019, 59.162],
              [11.023, 59.159],
              [11.026, 59.158],
              [11.03, 59.156],
              [11.033, 59.155],
              [11.035, 59.153],
              [11.037, 59.147],
              [11.038, 59.143],
              [11.039, 59.14],
              [11.041, 59.137],
              [11.044, 59.136],
              [11.048, 59.135],
              [11.053, 59.134],
              [11.062, 59.133],
              [11.067, 59.132],
              [11.074, 59.13],
              [11.078, 59.129],
              [11.082, 59.129],
              [11.086, 59.13],
              [11.091, 59.131],
              [11.094, 59.133],
              [11.098, 59.135],
              [11.101, 59.139],
              [11.102, 59.142],
              [11.103, 59.146],
              [11.103, 59.154],
              [11.101, 59.158],
              [11.099, 59.163],
              [11.096, 59.169],
              [11.092, 59.174],
              [11.084, 59.185],
              [11.08, 59.19],
              [11.077, 59.195],
              [11.075, 59.199],
              [11.073, 59.202],
              [11.072, 59.205],
              [11.071, 59.207],
              [11.072, 59.208],
              [11.073, 59.207],
              [11.075, 59.206],
              [11.076, 59.203],
              [11.08, 59.197],
              [11.084, 59.192],
              [11.088, 59.188],
              [11.102, 59.175],
              [11.114, 59.163],
              [11.117, 59.159],
              [11.125, 59.155],
              [11.129, 59.154],
              [11.135, 59.154],
              [11.145, 59.156],
              [11.153, 59.162],
              [11.155, 59.165],
              [11.156, 59.169],
              [11.156, 59.172],
              [11.155, 59.176],
              [11.154, 59.183],
              [11.154, 59.186],
              [11.155, 59.189],
              [11.157, 59.19],
              [11.16, 59.191],
              [11.164, 59.19],
              [11.168, 59.19],
              [11.172, 59.189],
              [11.175, 59.188],
              [11.177, 59.187],
              [11.179, 59.184],
              [11.18, 59.181],
              [11.182, 59.168],
              [11.183, 59.164],
              [11.185, 59.16],
              [11.191, 59.154],
              [11.198, 59.15],
              [11.201, 59.147],
              [11.203, 59.143],
              [11.202, 59.141],
              [11.2, 59.139],
              [11.199, 59.139],
              [11.197, 59.14],
              [11.194, 59.14],
              [11.188, 59.138],
              [11.186, 59.136],
              [11.186, 59.13],
              [11.187, 59.127],
              [11.189, 59.124],
              [11.191, 59.123],
              [11.194, 59.122],
              [11.196, 59.121],
              [11.206, 59.121],
              [11.212, 59.123],
              [11.218, 59.127],
              [11.222, 59.129],
              [11.222, 59.128],
              [11.223, 59.128],
              [11.223, 59.126],
              [11.222, 59.124],
              [11.22, 59.121],
              [11.214, 59.11],
              [11.212, 59.106],
              [11.211, 59.103],
              [11.21, 59.101],
              [11.212, 59.099],
              [11.214, 59.099],
              [11.215, 59.098],
              [11.217, 59.097],
              [11.217, 59.096],
              [11.218, 59.094],
              [11.219, 59.093],
              [11.22, 59.093],
              [11.223, 59.092],
              [11.227, 59.092],
              [11.232, 59.093],
              [11.237, 59.093],
              [11.249, 59.095],
              [11.262, 59.097],
              [11.268, 59.098],
              [11.275, 59.1],
              [11.282, 59.101],
              [11.324, 59.115],
              [11.338, 59.117],
              [11.344, 59.118],
              [11.363, 59.118],
              [11.368, 59.117],
              [11.372, 59.117],
              [11.374, 59.116],
              [11.378, 59.113],
              [11.38, 59.112],
              [11.381, 59.111],
              [11.382, 59.109],
              [11.384, 59.103],
              [11.385, 59.099],
              [11.389, 59.091],
              [11.393, 59.087],
              [11.403, 59.075],
              [11.406, 59.071],
              [11.41, 59.066],
              [11.414, 59.062],
              [11.418, 59.06],
              [11.422, 59.059],
              [11.424, 59.058],
              [11.425, 59.056],
              [11.426, 59.053],
              [11.427, 59.046],
              [11.428, 59.042],
              [11.431, 59.039],
              [11.433, 59.035],
              [11.44, 59.026],
              [11.461, 58.998],
              [11.463, 58.995],
              [11.464, 58.992],
              [11.465, 58.99],
              [11.464, 58.989],
              [11.461, 58.989],
              [11.458, 58.99],
              [11.455, 58.992],
              [11.451, 58.995],
              [11.447, 58.999],
              [11.442, 59.003],
              [11.429, 59.018],
              [11.425, 59.022],
              [11.416, 59.03],
              [11.411, 59.034],
              [11.403, 59.044],
              [11.392, 59.059],
              [11.388, 59.063],
              [11.382, 59.07],
              [11.379, 59.073],
              [11.376, 59.077],
              [11.371, 59.085],
              [11.368, 59.088],
              [11.364, 59.093],
              [11.359, 59.097],
              [11.349, 59.103],
              [11.337, 59.107],
              [11.325, 59.107],
              [11.311, 59.105],
              [11.305, 59.103],
              [11.284, 59.098],
              [11.271, 59.095],
              [11.23, 59.085],
              [11.217, 59.082],
              [11.211, 59.08],
              [11.204, 59.078],
              [11.198, 59.076],
              [11.186, 59.07],
              [11.181, 59.067],
              [11.176, 59.063],
              [11.167, 59.056],
              [11.147, 59.04],
              [11.142, 59.035],
              [11.137, 59.031],
              [11.134, 59.027],
              [11.13, 59.023],
              [11.128, 59.018],
              [11.125, 59.014],
              [11.124, 59.01],
              [11.124, 59.003],
              [11.127, 59.001],
              [11.131, 58.999],
              [11.136, 58.997],
              [11.142, 58.997],
              [11.148, 58.996],
              [11.155, 58.996],
              [11.161, 58.997],
              [11.168, 58.998],
              [11.174, 58.999],
              [11.181, 59],
              [11.194, 59.002],
              [11.206, 59.005],
              [11.217, 59.008],
              [11.221, 59.008],
              [11.224, 59.009],
              [11.226, 59.007],
              [11.225, 59.005],
              [11.224, 59.005],
              [11.219, 59.003],
              [11.216, 59.002],
              [11.211, 59.002],
              [11.203, 59],
              [11.181, 58.993],
              [11.164, 58.989],
              [11.158, 58.988],
              [11.153, 58.986],
              [11.149, 58.983],
              [11.144, 58.981],
              [11.136, 58.975],
              [11.13, 58.969],
              [11.129, 58.965],
              [11.129, 58.962],
              [11.133, 58.956],
              [11.141, 58.95],
              [11.145, 58.948],
              [11.15, 58.946],
              [11.163, 58.942],
              [11.166, 58.941],
              [11.169, 58.939],
              [11.174, 58.935],
              [11.176, 58.933],
              [11.179, 58.931],
              [11.182, 58.93],
              [11.188, 58.929],
              [11.189, 58.929],
              [11.189, 58.928],
              [11.186, 58.925],
              [11.186, 58.924],
              [11.187, 58.923],
              [11.191, 58.92],
              [11.195, 58.916],
              [11.196, 58.913],
              [11.196, 58.904],
              [11.198, 58.895],
              [11.198, 58.89],
              [11.199, 58.884],
              [11.199, 58.881],
              [11.201, 58.875],
              [11.203, 58.873],
              [11.206, 58.869],
              [11.206, 58.867],
              [11.207, 58.866],
              [11.208, 58.864],
              [11.21, 58.862],
              [11.215, 58.858],
              [11.218, 58.856],
              [11.229, 58.845],
              [11.231, 58.841],
              [11.232, 58.837],
              [11.237, 58.821],
              [11.237, 58.813],
              [11.235, 58.809],
              [11.228, 58.802],
              [11.225, 58.8],
              [11.223, 58.797],
              [11.221, 58.789],
              [11.221, 58.781],
              [11.223, 58.777],
              [11.225, 58.774],
              [11.23, 58.769],
              [11.226, 58.769],
              [11.223, 58.77],
              [11.219, 58.772],
              [11.216, 58.773],
              [11.209, 58.777],
              [11.205, 58.779],
              [11.202, 58.78],
              [11.198, 58.779],
              [11.196, 58.779],
              [11.195, 58.777],
              [11.195, 58.775],
              [11.197, 58.772],
              [11.2, 58.768],
              [11.204, 58.765],
              [11.214, 58.757],
              [11.219, 58.754],
              [11.236, 58.743],
              [11.241, 58.74],
              [11.245, 58.736],
              [11.249, 58.73],
              [11.25, 58.728],
              [11.249, 58.726],
              [11.247, 58.726],
              [11.245, 58.727],
              [11.236, 58.733],
              [11.232, 58.735],
              [11.223, 58.739],
              [11.219, 58.741],
              [11.218, 58.743],
              [11.215, 58.746],
              [11.213, 58.747],
              [11.21, 58.749],
              [11.207, 58.75],
              [11.196, 58.752],
              [11.193, 58.753],
              [11.186, 58.753],
              [11.185, 58.752],
              [11.183, 58.752],
              [11.182, 58.751],
              [11.18, 58.747],
              [11.178, 58.742],
              [11.176, 58.736],
              [11.176, 58.729],
              [11.178, 58.726],
              [11.18, 58.722],
              [11.188, 58.718],
              [11.193, 58.716],
              [11.198, 58.715],
              [11.201, 58.714],
              [11.208, 58.713],
              [11.215, 58.711],
              [11.219, 58.709],
              [11.221, 58.707],
              [11.222, 58.705],
              [11.222, 58.703],
              [11.224, 58.7],
              [11.226, 58.696],
              [11.231, 58.691],
              [11.245, 58.684],
              [11.25, 58.682],
              [11.252, 58.68],
              [11.255, 58.678],
              [11.257, 58.674],
              [11.264, 58.662],
              [11.267, 58.658],
              [11.276, 58.647],
              [11.278, 58.643],
              [11.278, 58.639],
              [11.277, 58.636],
              [11.274, 58.628],
              [11.273, 58.625],
              [11.274, 58.622],
              [11.275, 58.62],
              [11.277, 58.619],
              [11.282, 58.616],
              [11.285, 58.614],
              [11.289, 58.613],
              [11.289, 58.609],
              [11.286, 58.603],
              [11.285, 58.599],
              [11.285, 58.595],
              [11.286, 58.592],
              [11.288, 58.589],
              [11.291, 58.587],
              [11.294, 58.586],
              [11.3, 58.583],
              [11.302, 58.581],
              [11.304, 58.58],
              [11.304, 58.577],
              [11.303, 58.576],
              [11.297, 58.573],
              [11.291, 58.571],
              [11.287, 58.569],
              [11.279, 58.567],
              [11.276, 58.566],
              [11.27, 58.562],
              [11.268, 58.556],
              [11.268, 58.552],
              [11.27, 58.543],
              [11.27, 58.536],
              [11.268, 58.529],
              [11.268, 58.523],
              [11.272, 58.517],
              [11.275, 58.515],
              [11.287, 58.503],
              [11.288, 58.501],
              [11.288, 58.498],
              [11.289, 58.496],
              [11.29, 58.495],
              [11.296, 58.492],
              [11.301, 58.492],
              [11.309, 58.49],
              [11.314, 58.487],
              [11.317, 58.486],
              [11.325, 58.484],
              [11.33, 58.484],
              [11.342, 58.485],
              [11.345, 58.485],
              [11.346, 58.484],
              [11.345, 58.484],
              [11.343, 58.483],
              [11.333, 58.479],
              [11.324, 58.473],
              [11.322, 58.471],
              [11.321, 58.469],
              [11.319, 58.467],
              [11.317, 58.466],
              [11.308, 58.463],
              [11.306, 58.462],
              [11.302, 58.459],
              [11.299, 58.457],
              [11.298, 58.456],
              [11.297, 58.454],
              [11.296, 58.451],
              [11.294, 58.448],
              [11.289, 58.438],
              [11.287, 58.435],
              [11.286, 58.433],
              [11.283, 58.432],
              [11.277, 58.429],
              [11.274, 58.426],
              [11.27, 58.423],
              [11.262, 58.415],
              [11.256, 58.407],
              [11.253, 58.402],
              [11.251, 58.398],
              [11.25, 58.393],
              [11.25, 58.386],
              [11.252, 58.378],
              [11.252, 58.375],
              [11.251, 58.367],
              [11.251, 58.361],
              [11.253, 58.359],
              [11.256, 58.357],
              [11.259, 58.356],
              [11.268, 58.356],
              [11.27, 58.357],
              [11.275, 58.359],
              [11.278, 58.36],
              [11.281, 58.362],
              [11.283, 58.363],
              [11.285, 58.365],
              [11.286, 58.368],
              [11.286, 58.376],
              [11.285, 58.377],
              [11.286, 58.379],
              [11.288, 58.381],
              [11.289, 58.38],
              [11.291, 58.379],
              [11.294, 58.378],
              [11.3, 58.378],
              [11.306, 58.38],
              [11.31, 58.382],
              [11.313, 58.382],
              [11.315, 58.38],
              [11.318, 58.379],
              [11.322, 58.375],
              [11.325, 58.373],
              [11.328, 58.372],
              [11.336, 58.37],
              [11.341, 58.369],
              [11.35, 58.369],
              [11.354, 58.37],
              [11.358, 58.372],
              [11.37, 58.381],
              [11.395, 58.399],
              [11.405, 58.407],
              [11.411, 58.412],
              [11.416, 58.416],
              [11.445, 58.443],
              [11.448, 58.446],
              [11.451, 58.448],
              [11.453, 58.449],
              [11.452, 58.447],
              [11.444, 58.437],
              [11.44, 58.433],
              [11.434, 58.425],
              [11.426, 58.417],
              [11.417, 58.409],
              [11.412, 58.405],
              [11.404, 58.395],
              [11.399, 58.391],
              [11.396, 58.386],
              [11.392, 58.382],
              [11.39, 58.377],
              [11.388, 58.374],
              [11.385, 58.371],
              [11.383, 58.368],
              [11.372, 58.36],
              [11.369, 58.357],
              [11.365, 58.351],
              [11.365, 58.346],
              [11.366, 58.343],
              [11.367, 58.342],
              [11.368, 58.342],
              [11.37, 58.341],
              [11.372, 58.341],
              [11.384, 58.345],
              [11.388, 58.346],
              [11.392, 58.348],
              [11.395, 58.349],
              [11.399, 58.353],
              [11.402, 58.357],
              [11.404, 58.358],
              [11.406, 58.36],
              [11.413, 58.364],
              [11.417, 58.367],
              [11.421, 58.371],
              [11.43, 58.379],
              [11.435, 58.383],
              [11.439, 58.387],
              [11.443, 58.389],
              [11.447, 58.39],
              [11.45, 58.391],
              [11.452, 58.39],
              [11.452, 58.387],
              [11.451, 58.38],
              [11.451, 58.372],
              [11.453, 58.362],
              [11.456, 58.353],
              [11.456, 58.351],
              [11.452, 58.349],
              [11.431, 58.349],
              [11.423, 58.347],
              [11.419, 58.345],
              [11.414, 58.342],
              [11.41, 58.338],
              [11.407, 58.334],
              [11.405, 58.33],
              [11.404, 58.325],
              [11.405, 58.321],
              [11.407, 58.318],
              [11.41, 58.315],
              [11.414, 58.313],
              [11.419, 58.311],
              [11.429, 58.309],
              [11.435, 58.308],
              [11.445, 58.308],
              [11.453, 58.309],
              [11.456, 58.309],
              [11.457, 58.308],
              [11.457, 58.307],
              [11.452, 58.302],
              [11.436, 58.288],
              [11.433, 58.284],
              [11.43, 58.281],
              [11.428, 58.278],
              [11.427, 58.275],
              [11.428, 58.274],
              [11.432, 58.272],
              [11.439, 58.272],
              [11.444, 58.273],
              [11.451, 58.274],
              [11.454, 58.275],
              [11.458, 58.277],
              [11.473, 58.283],
              [11.477, 58.285],
              [11.487, 58.291],
              [11.496, 58.297],
              [11.501, 58.3],
              [11.511, 58.307],
              [11.516, 58.31],
              [11.521, 58.314],
              [11.526, 58.319],
              [11.531, 58.323],
              [11.544, 58.338],
              [11.557, 58.351],
              [11.56, 58.356],
              [11.563, 58.36],
              [11.564, 58.366],
              [11.565, 58.371],
              [11.567, 58.383],
              [11.568, 58.388],
              [11.578, 58.418],
              [11.579, 58.424],
              [11.579, 58.444],
              [11.578, 58.459],
              [11.578, 58.464],
              [11.579, 58.463],
              [11.58, 58.461],
              [11.588, 58.444],
              [11.59, 58.439],
              [11.593, 58.434],
              [11.599, 58.426],
              [11.604, 58.419],
              [11.607, 58.416],
              [11.611, 58.414],
              [11.614, 58.412],
              [11.618, 58.411],
              [11.623, 58.411],
              [11.628, 58.412],
              [11.633, 58.414],
              [11.638, 58.417],
              [11.649, 58.423],
              [11.654, 58.426],
              [11.66, 58.429],
              [11.665, 58.431],
              [11.675, 58.433],
              [11.679, 58.434],
              [11.683, 58.434],
              [11.686, 58.433],
              [11.687, 58.433],
              [11.688, 58.432],
              [11.687, 58.431],
              [11.684, 58.429],
              [11.671, 58.423],
              [11.666, 58.421],
              [11.656, 58.415],
              [11.648, 58.409],
              [11.645, 58.406],
              [11.642, 58.4],
              [11.642, 58.398],
              [11.644, 58.394],
              [11.646, 58.392],
              [11.647, 58.39],
              [11.647, 58.387],
              [11.645, 58.386],
              [11.642, 58.385],
              [11.635, 58.383],
              [11.631, 58.381],
              [11.626, 58.379],
              [11.62, 58.376],
              [11.605, 58.364],
              [11.599, 58.36],
              [11.595, 58.355],
              [11.581, 58.342],
              [11.577, 58.337],
              [11.572, 58.333],
              [11.568, 58.329],
              [11.563, 58.325],
              [11.548, 58.314],
              [11.536, 58.302],
              [11.532, 58.297],
              [11.525, 58.289],
              [11.522, 58.285],
              [11.514, 58.277],
              [11.512, 58.274],
              [11.51, 58.27],
              [11.51, 58.266],
              [11.509, 58.259],
              [11.509, 58.254],
              [11.511, 58.251],
              [11.513, 58.249],
              [11.521, 58.245],
              [11.531, 58.243],
              [11.537, 58.242],
              [11.551, 58.242],
              [11.557, 58.245],
              [11.559, 58.247],
              [11.559, 58.251],
              [11.558, 58.253],
              [11.556, 58.256],
              [11.555, 58.258],
              [11.554, 58.261],
              [11.555, 58.262],
              [11.557, 58.263],
              [11.56, 58.262],
              [11.569, 58.261],
              [11.575, 58.261],
              [11.58, 58.26],
              [11.587, 58.26],
              [11.593, 58.261],
              [11.612, 58.262],
              [11.632, 58.262],
              [11.636, 58.263],
              [11.638, 58.263],
              [11.647, 58.266],
              [11.654, 58.266],
              [11.656, 58.267],
              [11.659, 58.267],
              [11.661, 58.268],
              [11.662, 58.27],
              [11.662, 58.273],
              [11.661, 58.274],
              [11.66, 58.276],
              [11.66, 58.28],
              [11.662, 58.284],
              [11.67, 58.294],
              [11.674, 58.298],
              [11.678, 58.301],
              [11.682, 58.303],
              [11.687, 58.305],
              [11.692, 58.306],
              [11.708, 58.31],
              [11.713, 58.311],
              [11.72, 58.312],
              [11.723, 58.313],
              [11.726, 58.313],
              [11.727, 58.315],
              [11.729, 58.317],
              [11.729, 58.318],
              [11.727, 58.321],
              [11.727, 58.323],
              [11.723, 58.327],
              [11.716, 58.331],
              [11.713, 58.333],
              [11.712, 58.335],
              [11.711, 58.336],
              [11.713, 58.338],
              [11.716, 58.339],
              [11.72, 58.339],
              [11.725, 58.34],
              [11.731, 58.339],
              [11.743, 58.339],
              [11.761, 58.336],
              [11.768, 58.334],
              [11.786, 58.33],
              [11.791, 58.328],
              [11.797, 58.327],
              [11.803, 58.327],
              [11.808, 58.326],
              [11.813, 58.326],
              [11.825, 58.328],
              [11.832, 58.328],
              [11.838, 58.329],
              [11.845, 58.331],
              [11.851, 58.332],
              [11.873, 58.34],
              [11.883, 58.342],
              [11.898, 58.346],
              [11.902, 58.346],
              [11.904, 58.345],
              [11.904, 58.341],
              [11.903, 58.339],
              [11.897, 58.335],
              [11.892, 58.334],
              [11.881, 58.33],
              [11.875, 58.329],
              [11.869, 58.327],
              [11.853, 58.324],
              [11.847, 58.323],
              [11.835, 58.319],
              [11.83, 58.317],
              [11.826, 58.315],
              [11.823, 58.312],
              [11.822, 58.308],
              [11.821, 58.305],
              [11.821, 58.295],
              [11.822, 58.291],
              [11.824, 58.287],
              [11.827, 58.284],
              [11.834, 58.276],
              [11.837, 58.272],
              [11.842, 58.266],
              [11.844, 58.262],
              [11.847, 58.259],
              [11.854, 58.253],
              [11.874, 58.233],
              [11.878, 58.23],
              [11.883, 58.228],
              [11.887, 58.226],
              [11.902, 58.221],
              [11.903, 58.219],
              [11.903, 58.217],
              [11.902, 58.215],
              [11.9, 58.212],
              [11.897, 58.209],
              [11.889, 58.205],
              [11.879, 58.201],
              [11.875, 58.199],
              [11.872, 58.196],
              [11.869, 58.194],
              [11.863, 58.182],
              [11.86, 58.168],
              [11.859, 58.163],
              [11.857, 58.158],
              [11.854, 58.154],
              [11.849, 58.145],
              [11.843, 58.13],
              [11.839, 58.122],
              [11.833, 58.116],
              [11.83, 58.114],
              [11.827, 58.111],
              [11.821, 58.108],
              [11.819, 58.106],
              [11.817, 58.105],
              [11.817, 58.104],
              [11.818, 58.103],
              [11.819, 58.101],
              [11.82, 58.1],
              [11.82, 58.096],
              [11.818, 58.092],
              [11.813, 58.087],
              [11.812, 58.085],
              [11.811, 58.082],
              [11.811, 58.079],
              [11.814, 58.073],
              [11.815, 58.069],
              [11.815, 58.065],
              [11.816, 58.061],
              [11.816, 58.034],
              [11.815, 58.03],
              [11.813, 58.025],
              [11.81, 58.017],
              [11.808, 58.009],
              [11.808, 58.005],
              [11.806, 57.997],
              [11.804, 57.994],
              [11.788, 57.978],
              [11.784, 57.976],
              [11.776, 57.971],
            ],
          ],
        ],
      },
      properties: { id: 57, name: 'Skagerrak', latlon: [58.178234, 9.7891] },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [21.574, 60.522],
              [18.008, 60.52],
              [18.013, 60.525],
              [18.016, 60.527],
              [18.017, 60.529],
              [18.018, 60.532],
              [18.018, 60.534],
              [18.017, 60.535],
              [18.014, 60.541],
              [18.014, 60.545],
              [18.015, 60.551],
              [18.015, 60.555],
              [18.012, 60.562],
              [18.012, 60.563],
              [18.01, 60.566],
              [18.009, 60.567],
              [18.009, 60.569],
              [18.01, 60.571],
              [18.011, 60.572],
              [18.013, 60.575],
              [18.014, 60.576],
              [18.014, 60.578],
              [18.013, 60.58],
              [18.012, 60.581],
              [18.008, 60.586],
              [18.006, 60.59],
              [18.004, 60.592],
              [18.002, 60.593],
              [18.001, 60.594],
              [17.989, 60.599],
              [17.986, 60.6],
              [17.976, 60.602],
              [17.951, 60.602],
              [17.944, 60.601],
              [17.938, 60.6],
              [17.922, 60.597],
              [17.894, 60.593],
              [17.88, 60.59],
              [17.847, 60.584],
              [17.84, 60.582],
              [17.834, 60.581],
              [17.827, 60.579],
              [17.803, 60.571],
              [17.785, 60.567],
              [17.78, 60.566],
              [17.775, 60.564],
              [17.762, 60.558],
              [17.747, 60.551],
              [17.744, 60.55],
              [17.734, 60.55],
              [17.732, 60.549],
              [17.731, 60.547],
              [17.729, 60.544],
              [17.727, 60.54],
              [17.727, 60.536],
              [17.726, 60.531],
              [17.727, 60.527],
              [17.727, 60.524],
              [17.728, 60.52],
              [17.727, 60.516],
              [17.726, 60.513],
              [17.724, 60.511],
              [17.722, 60.51],
              [17.72, 60.51],
              [17.717, 60.511],
              [17.715, 60.512],
              [17.714, 60.514],
              [17.711, 60.517],
              [17.701, 60.522],
              [17.7, 60.524],
              [17.696, 60.528],
              [17.696, 60.53],
              [17.697, 60.53],
              [17.699, 60.533],
              [17.7, 60.534],
              [17.7, 60.537],
              [17.699, 60.537],
              [17.697, 60.538],
              [17.696, 60.538],
              [17.693, 60.536],
              [17.691, 60.536],
              [17.685, 60.535],
              [17.684, 60.535],
              [17.682, 60.533],
              [17.68, 60.529],
              [17.678, 60.523],
              [17.677, 60.521],
              [17.677, 60.52],
              [17.678, 60.519],
              [17.678, 60.517],
              [17.681, 60.514],
              [17.68, 60.513],
              [17.678, 60.512],
              [17.675, 60.512],
              [17.667, 60.514],
              [17.663, 60.516],
              [17.658, 60.518],
              [17.654, 60.521],
              [17.648, 60.527],
              [17.645, 60.532],
              [17.641, 60.536],
              [17.636, 60.54],
              [17.633, 60.541],
              [17.631, 60.543],
              [17.631, 60.545],
              [17.63, 60.547],
              [17.631, 60.549],
              [17.631, 60.555],
              [17.63, 60.557],
              [17.619, 60.568],
              [17.615, 60.571],
              [17.605, 60.581],
              [17.603, 60.584],
              [17.602, 60.587],
              [17.603, 60.59],
              [17.606, 60.593],
              [17.609, 60.595],
              [17.613, 60.597],
              [17.622, 60.601],
              [17.626, 60.604],
              [17.635, 60.609],
              [17.639, 60.612],
              [17.643, 60.614],
              [17.647, 60.615],
              [17.651, 60.617],
              [17.657, 60.618],
              [17.66, 60.621],
              [17.66, 60.622],
              [17.659, 60.624],
              [17.653, 60.628],
              [17.648, 60.629],
              [17.632, 60.634],
              [17.626, 60.636],
              [17.617, 60.64],
              [17.612, 60.642],
              [17.606, 60.644],
              [17.599, 60.646],
              [17.593, 60.647],
              [17.574, 60.65],
              [17.564, 60.652],
              [17.561, 60.653],
              [17.559, 60.655],
              [17.553, 60.658],
              [17.55, 60.657],
              [17.547, 60.657],
              [17.539, 60.655],
              [17.534, 60.653],
              [17.53, 60.652],
              [17.515, 60.649],
              [17.501, 60.649],
              [17.5, 60.65],
              [17.5, 60.652],
              [17.499, 60.653],
              [17.497, 60.652],
              [17.486, 60.648],
              [17.482, 60.646],
              [17.477, 60.644],
              [17.459, 60.641],
              [17.447, 60.641],
              [17.442, 60.642],
              [17.434, 60.644],
              [17.429, 60.645],
              [17.415, 60.648],
              [17.411, 60.649],
              [17.407, 60.649],
              [17.399, 60.65],
              [17.392, 60.65],
              [17.38, 60.654],
              [17.377, 60.654],
              [17.373, 60.655],
              [17.368, 60.655],
              [17.364, 60.656],
              [17.345, 60.656],
              [17.34, 60.657],
              [17.33, 60.658],
              [17.32, 60.66],
              [17.315, 60.66],
              [17.31, 60.662],
              [17.306, 60.663],
              [17.303, 60.664],
              [17.293, 60.67],
              [17.29, 60.671],
              [17.286, 60.675],
              [17.286, 60.676],
              [17.287, 60.677],
              [17.287, 60.679],
              [17.288, 60.68],
              [17.287, 60.682],
              [17.287, 60.683],
              [17.285, 60.685],
              [17.283, 60.686],
              [17.28, 60.687],
              [17.276, 60.687],
              [17.268, 60.688],
              [17.259, 60.689],
              [17.246, 60.689],
              [17.24, 60.688],
              [17.233, 60.687],
              [17.221, 60.685],
              [17.209, 60.682],
              [17.203, 60.68],
              [17.197, 60.679],
              [17.192, 60.679],
              [17.186, 60.678],
              [17.182, 60.679],
              [17.175, 60.679],
              [17.173, 60.68],
              [17.172, 60.682],
              [17.169, 60.685],
              [17.168, 60.687],
              [17.168, 60.688],
              [17.169, 60.688],
              [17.171, 60.689],
              [17.176, 60.689],
              [17.179, 60.688],
              [17.184, 60.688],
              [17.189, 60.687],
              [17.194, 60.687],
              [17.198, 60.688],
              [17.213, 60.691],
              [17.219, 60.694],
              [17.226, 60.696],
              [17.232, 60.699],
              [17.245, 60.706],
              [17.264, 60.716],
              [17.276, 60.722],
              [17.283, 60.724],
              [17.289, 60.727],
              [17.294, 60.728],
              [17.303, 60.731],
              [17.307, 60.732],
              [17.31, 60.733],
              [17.32, 60.739],
              [17.328, 60.743],
              [17.333, 60.746],
              [17.337, 60.748],
              [17.34, 60.751],
              [17.342, 60.754],
              [17.343, 60.756],
              [17.342, 60.759],
              [17.341, 60.761],
              [17.339, 60.763],
              [17.336, 60.765],
              [17.322, 60.77],
              [17.318, 60.771],
              [17.309, 60.773],
              [17.305, 60.774],
              [17.294, 60.778],
              [17.292, 60.779],
              [17.291, 60.78],
              [17.292, 60.781],
              [17.294, 60.782],
              [17.297, 60.784],
              [17.301, 60.785],
              [17.313, 60.786],
              [17.325, 60.788],
              [17.33, 60.789],
              [17.335, 60.791],
              [17.339, 60.792],
              [17.342, 60.793],
              [17.344, 60.794],
              [17.343, 60.796],
              [17.342, 60.797],
              [17.34, 60.798],
              [17.333, 60.803],
              [17.327, 60.805],
              [17.323, 60.806],
              [17.319, 60.806],
              [17.315, 60.805],
              [17.306, 60.803],
              [17.301, 60.802],
              [17.295, 60.802],
              [17.289, 60.804],
              [17.285, 60.805],
              [17.271, 60.807],
              [17.266, 60.808],
              [17.262, 60.809],
              [17.259, 60.81],
              [17.257, 60.811],
              [17.255, 60.811],
              [17.253, 60.813],
              [17.252, 60.816],
              [17.252, 60.818],
              [17.256, 60.822],
              [17.258, 60.825],
              [17.266, 60.829],
              [17.279, 60.833],
              [17.282, 60.834],
              [17.285, 60.837],
              [17.285, 60.838],
              [17.284, 60.843],
              [17.284, 60.845],
              [17.282, 60.848],
              [17.278, 60.853],
              [17.276, 60.855],
              [17.275, 60.857],
              [17.274, 60.862],
              [17.274, 60.866],
              [17.277, 60.867],
              [17.28, 60.867],
              [17.29, 60.868],
              [17.295, 60.869],
              [17.301, 60.87],
              [17.306, 60.871],
              [17.311, 60.873],
              [17.314, 60.875],
              [17.316, 60.877],
              [17.318, 60.878],
              [17.318, 60.88],
              [17.317, 60.881],
              [17.314, 60.882],
              [17.307, 60.882],
              [17.293, 60.881],
              [17.288, 60.88],
              [17.283, 60.881],
              [17.272, 60.881],
              [17.266, 60.882],
              [17.259, 60.882],
              [17.254, 60.884],
              [17.248, 60.886],
              [17.243, 60.888],
              [17.233, 60.891],
              [17.225, 60.895],
              [17.222, 60.897],
              [17.217, 60.902],
              [17.211, 60.906],
              [17.205, 60.909],
              [17.203, 60.911],
              [17.2, 60.913],
              [17.199, 60.916],
              [17.197, 60.921],
              [17.196, 60.923],
              [17.194, 60.924],
              [17.186, 60.926],
              [17.172, 60.929],
              [17.169, 60.93],
              [17.167, 60.931],
              [17.166, 60.932],
              [17.166, 60.933],
              [17.167, 60.936],
              [17.166, 60.937],
              [17.153, 60.937],
              [17.153, 60.939],
              [17.152, 60.94],
              [17.153, 60.941],
              [17.153, 60.942],
              [17.157, 60.943],
              [17.159, 60.945],
              [17.159, 60.946],
              [17.157, 60.948],
              [17.153, 60.949],
              [17.152, 60.95],
              [17.15, 60.951],
              [17.149, 60.952],
              [17.149, 60.954],
              [17.15, 60.956],
              [17.154, 60.962],
              [17.161, 60.971],
              [17.163, 60.974],
              [17.166, 60.976],
              [17.17, 60.978],
              [17.173, 60.98],
              [17.179, 60.986],
              [17.182, 60.987],
              [17.186, 60.988],
              [17.201, 60.991],
              [17.206, 60.993],
              [17.216, 60.996],
              [17.224, 60.998],
              [17.23, 61],
              [17.234, 61.003],
              [17.236, 61.005],
              [17.236, 61.006],
              [17.234, 61.007],
              [17.231, 61.009],
              [17.227, 61.01],
              [17.195, 61.01],
              [17.188, 61.009],
              [17.182, 61.009],
              [17.176, 61.008],
              [17.155, 61.005],
              [17.153, 61.004],
              [17.151, 61.004],
              [17.154, 61.007],
              [17.161, 61.01],
              [17.165, 61.013],
              [17.168, 61.015],
              [17.171, 61.018],
              [17.172, 61.021],
              [17.172, 61.025],
              [17.171, 61.028],
              [17.169, 61.032],
              [17.165, 61.039],
              [17.163, 61.043],
              [17.162, 61.046],
              [17.162, 61.051],
              [17.163, 61.056],
              [17.164, 61.058],
              [17.167, 61.061],
              [17.172, 61.065],
              [17.175, 61.067],
              [17.176, 61.069],
              [17.177, 61.072],
              [17.177, 61.075],
              [17.175, 61.078],
              [17.175, 61.08],
              [17.177, 61.08],
              [17.181, 61.081],
              [17.187, 61.083],
              [17.19, 61.083],
              [17.192, 61.084],
              [17.193, 61.085],
              [17.193, 61.086],
              [17.194, 61.087],
              [17.194, 61.09],
              [17.192, 61.091],
              [17.188, 61.095],
              [17.181, 61.099],
              [17.17, 61.107],
              [17.168, 61.111],
              [17.17, 61.115],
              [17.174, 61.119],
              [17.176, 61.125],
              [17.175, 61.129],
              [17.175, 61.132],
              [17.173, 61.136],
              [17.17, 61.14],
              [17.164, 61.146],
              [17.162, 61.149],
              [17.161, 61.151],
              [17.163, 61.155],
              [17.165, 61.156],
              [17.17, 61.163],
              [17.172, 61.166],
              [17.173, 61.169],
              [17.175, 61.172],
              [17.178, 61.177],
              [17.179, 61.179],
              [17.179, 61.183],
              [17.174, 61.188],
              [17.159, 61.194],
              [17.142, 61.2],
              [17.137, 61.202],
              [17.133, 61.203],
              [17.13, 61.205],
              [17.129, 61.206],
              [17.13, 61.207],
              [17.132, 61.208],
              [17.136, 61.209],
              [17.149, 61.212],
              [17.154, 61.213],
              [17.159, 61.215],
              [17.168, 61.218],
              [17.172, 61.22],
              [17.176, 61.221],
              [17.18, 61.221],
              [17.189, 61.222],
              [17.192, 61.222],
              [17.196, 61.223],
              [17.202, 61.225],
              [17.205, 61.228],
              [17.205, 61.229],
              [17.203, 61.231],
              [17.201, 61.232],
              [17.199, 61.234],
              [17.197, 61.237],
              [17.192, 61.243],
              [17.191, 61.245],
              [17.19, 61.246],
              [17.191, 61.247],
              [17.193, 61.248],
              [17.197, 61.249],
              [17.199, 61.249],
              [17.199, 61.25],
              [17.198, 61.251],
              [17.195, 61.252],
              [17.178, 61.258],
              [17.173, 61.26],
              [17.169, 61.262],
              [17.166, 61.264],
              [17.164, 61.267],
              [17.152, 61.279],
              [17.142, 61.287],
              [17.136, 61.291],
              [17.131, 61.294],
              [17.125, 61.297],
              [17.12, 61.3],
              [17.114, 61.303],
              [17.104, 61.307],
              [17.092, 61.31],
              [17.091, 61.311],
              [17.092, 61.311],
              [17.094, 61.312],
              [17.097, 61.311],
              [17.102, 61.311],
              [17.107, 61.31],
              [17.113, 61.308],
              [17.118, 61.306],
              [17.125, 61.304],
              [17.131, 61.301],
              [17.15, 61.291],
              [17.156, 61.288],
              [17.163, 61.286],
              [17.17, 61.283],
              [17.176, 61.282],
              [17.183, 61.28],
              [17.189, 61.28],
              [17.196, 61.279],
              [17.242, 61.279],
              [17.255, 61.278],
              [17.266, 61.278],
              [17.266, 61.279],
              [17.26, 61.281],
              [17.251, 61.283],
              [17.236, 61.287],
              [17.223, 61.289],
              [17.195, 61.296],
              [17.189, 61.298],
              [17.184, 61.299],
              [17.179, 61.301],
              [17.169, 61.304],
              [17.16, 61.307],
              [17.156, 61.308],
              [17.152, 61.31],
              [17.149, 61.311],
              [17.146, 61.314],
              [17.146, 61.316],
              [17.15, 61.318],
              [17.153, 61.317],
              [17.164, 61.314],
              [17.167, 61.313],
              [17.176, 61.311],
              [17.187, 61.309],
              [17.191, 61.308],
              [17.195, 61.308],
              [17.211, 61.306],
              [17.216, 61.306],
              [17.227, 61.304],
              [17.232, 61.303],
              [17.236, 61.303],
              [17.24, 61.304],
              [17.243, 61.306],
              [17.244, 61.307],
              [17.244, 61.31],
              [17.241, 61.312],
              [17.238, 61.315],
              [17.234, 61.317],
              [17.229, 61.32],
              [17.224, 61.322],
              [17.21, 61.327],
              [17.206, 61.328],
              [17.203, 61.33],
              [17.202, 61.332],
              [17.201, 61.333],
              [17.201, 61.335],
              [17.202, 61.337],
              [17.2, 61.339],
              [17.197, 61.341],
              [17.194, 61.341],
              [17.18, 61.343],
              [17.174, 61.344],
              [17.169, 61.345],
              [17.163, 61.347],
              [17.157, 61.348],
              [17.142, 61.354],
              [17.131, 61.361],
              [17.13, 61.363],
              [17.129, 61.364],
              [17.129, 61.367],
              [17.127, 61.371],
              [17.127, 61.372],
              [17.115, 61.376],
              [17.113, 61.377],
              [17.111, 61.379],
              [17.108, 61.381],
              [17.101, 61.388],
              [17.097, 61.394],
              [17.096, 61.398],
              [17.095, 61.4],
              [17.094, 61.407],
              [17.094, 61.409],
              [17.096, 61.413],
              [17.097, 61.414],
              [17.103, 61.416],
              [17.111, 61.417],
              [17.115, 61.418],
              [17.119, 61.418],
              [17.122, 61.419],
              [17.123, 61.42],
              [17.126, 61.422],
              [17.128, 61.423],
              [17.131, 61.424],
              [17.135, 61.424],
              [17.14, 61.423],
              [17.151, 61.421],
              [17.157, 61.42],
              [17.162, 61.42],
              [17.168, 61.421],
              [17.196, 61.423],
              [17.205, 61.424],
              [17.208, 61.425],
              [17.21, 61.426],
              [17.211, 61.427],
              [17.209, 61.429],
              [17.208, 61.431],
              [17.208, 61.432],
              [17.209, 61.435],
              [17.207, 61.439],
              [17.205, 61.44],
              [17.203, 61.442],
              [17.201, 61.443],
              [17.199, 61.443],
              [17.196, 61.444],
              [17.185, 61.444],
              [17.181, 61.443],
              [17.174, 61.443],
              [17.173, 61.442],
              [17.173, 61.44],
              [17.176, 61.437],
              [17.176, 61.436],
              [17.175, 61.435],
              [17.169, 61.435],
              [17.166, 61.436],
              [17.163, 61.438],
              [17.16, 61.439],
              [17.147, 61.448],
              [17.144, 61.45],
              [17.143, 61.452],
              [17.14, 61.456],
              [17.139, 61.458],
              [17.139, 61.462],
              [17.14, 61.464],
              [17.142, 61.467],
              [17.144, 61.469],
              [17.155, 61.477],
              [17.158, 61.479],
              [17.16, 61.481],
              [17.16, 61.484],
              [17.159, 61.487],
              [17.157, 61.489],
              [17.149, 61.495],
              [17.144, 61.498],
              [17.125, 61.508],
              [17.121, 61.511],
              [17.119, 61.512],
              [17.118, 61.514],
              [17.119, 61.515],
              [17.131, 61.515],
              [17.137, 61.514],
              [17.145, 61.514],
              [17.147, 61.515],
              [17.147, 61.518],
              [17.145, 61.52],
              [17.137, 61.524],
              [17.122, 61.53],
              [17.106, 61.534],
              [17.091, 61.54],
              [17.085, 61.541],
              [17.08, 61.542],
              [17.067, 61.546],
              [17.064, 61.546],
              [17.063, 61.547],
              [17.064, 61.548],
              [17.066, 61.548],
              [17.082, 61.549],
              [17.091, 61.549],
              [17.095, 61.55],
              [17.102, 61.551],
              [17.106, 61.551],
              [17.111, 61.552],
              [17.123, 61.551],
              [17.137, 61.551],
              [17.165, 61.549],
              [17.178, 61.548],
              [17.191, 61.548],
              [17.197, 61.549],
              [17.201, 61.549],
              [17.205, 61.55],
              [17.207, 61.55],
              [17.208, 61.551],
              [17.207, 61.552],
              [17.204, 61.553],
              [17.2, 61.553],
              [17.195, 61.554],
              [17.176, 61.556],
              [17.115, 61.561],
              [17.105, 61.563],
              [17.102, 61.563],
              [17.101, 61.564],
              [17.101, 61.565],
              [17.103, 61.565],
              [17.104, 61.566],
              [17.112, 61.567],
              [17.114, 61.567],
              [17.115, 61.568],
              [17.115, 61.569],
              [17.113, 61.569],
              [17.11, 61.57],
              [17.084, 61.57],
              [17.078, 61.571],
              [17.072, 61.571],
              [17.062, 61.572],
              [17.058, 61.573],
              [17.055, 61.574],
              [17.054, 61.575],
              [17.055, 61.575],
              [17.058, 61.576],
              [17.062, 61.577],
              [17.106, 61.581],
              [17.119, 61.582],
              [17.124, 61.583],
              [17.128, 61.584],
              [17.131, 61.585],
              [17.133, 61.586],
              [17.135, 61.588],
              [17.137, 61.589],
              [17.138, 61.59],
              [17.14, 61.591],
              [17.141, 61.592],
              [17.14, 61.593],
              [17.134, 61.597],
              [17.131, 61.6],
              [17.127, 61.601],
              [17.122, 61.602],
              [17.11, 61.604],
              [17.087, 61.606],
              [17.082, 61.607],
              [17.078, 61.608],
              [17.075, 61.609],
              [17.074, 61.61],
              [17.074, 61.611],
              [17.076, 61.612],
              [17.079, 61.613],
              [17.083, 61.613],
              [17.089, 61.614],
              [17.115, 61.614],
              [17.129, 61.613],
              [17.142, 61.613],
              [17.154, 61.612],
              [17.16, 61.612],
              [17.165, 61.611],
              [17.169, 61.61],
              [17.171, 61.61],
              [17.175, 61.608],
              [17.178, 61.607],
              [17.183, 61.606],
              [17.209, 61.6],
              [17.217, 61.598],
              [17.225, 61.598],
              [17.227, 61.599],
              [17.228, 61.599],
              [17.228, 61.601],
              [17.231, 61.604],
              [17.233, 61.605],
              [17.233, 61.607],
              [17.229, 61.611],
              [17.225, 61.613],
              [17.22, 61.614],
              [17.215, 61.616],
              [17.209, 61.617],
              [17.202, 61.618],
              [17.196, 61.619],
              [17.169, 61.619],
              [17.155, 61.618],
              [17.149, 61.617],
              [17.136, 61.617],
              [17.131, 61.618],
              [17.126, 61.618],
              [17.121, 61.619],
              [17.117, 61.619],
              [17.114, 61.62],
              [17.112, 61.621],
              [17.112, 61.622],
              [17.116, 61.625],
              [17.117, 61.626],
              [17.116, 61.628],
              [17.11, 61.634],
              [17.109, 61.637],
              [17.109, 61.639],
              [17.111, 61.643],
              [17.112, 61.644],
              [17.113, 61.644],
              [17.113, 61.64],
              [17.114, 61.638],
              [17.116, 61.636],
              [17.12, 61.635],
              [17.124, 61.633],
              [17.128, 61.632],
              [17.138, 61.63],
              [17.146, 61.63],
              [17.157, 61.632],
              [17.16, 61.632],
              [17.162, 61.633],
              [17.165, 61.634],
              [17.172, 61.638],
              [17.173, 61.639],
              [17.174, 61.641],
              [17.17, 61.643],
              [17.157, 61.647],
              [17.155, 61.648],
              [17.154, 61.649],
              [17.155, 61.65],
              [17.158, 61.651],
              [17.167, 61.651],
              [17.173, 61.652],
              [17.179, 61.651],
              [17.191, 61.65],
              [17.198, 61.65],
              [17.211, 61.649],
              [17.229, 61.649],
              [17.233, 61.65],
              [17.236, 61.65],
              [17.237, 61.651],
              [17.236, 61.652],
              [17.233, 61.653],
              [17.229, 61.654],
              [17.214, 61.657],
              [17.203, 61.658],
              [17.202, 61.658],
              [17.203, 61.658],
              [17.205, 61.659],
              [17.218, 61.659],
              [17.234, 61.66],
              [17.243, 61.66],
              [17.246, 61.661],
              [17.247, 61.663],
              [17.247, 61.665],
              [17.248, 61.67],
              [17.248, 61.672],
              [17.247, 61.674],
              [17.242, 61.679],
              [17.238, 61.681],
              [17.233, 61.684],
              [17.228, 61.686],
              [17.222, 61.689],
              [17.204, 61.695],
              [17.197, 61.696],
              [17.19, 61.698],
              [17.169, 61.701],
              [17.141, 61.704],
              [17.123, 61.707],
              [17.117, 61.709],
              [17.113, 61.71],
              [17.109, 61.712],
              [17.108, 61.714],
              [17.108, 61.716],
              [17.109, 61.718],
              [17.113, 61.72],
              [17.117, 61.721],
              [17.122, 61.722],
              [17.134, 61.722],
              [17.161, 61.72],
              [17.181, 61.72],
              [17.199, 61.722],
              [17.206, 61.723],
              [17.226, 61.723],
              [17.238, 61.721],
              [17.242, 61.719],
              [17.253, 61.713],
              [17.256, 61.711],
              [17.26, 61.709],
              [17.264, 61.708],
              [17.27, 61.708],
              [17.272, 61.71],
              [17.274, 61.71],
              [17.275, 61.709],
              [17.277, 61.708],
              [17.283, 61.704],
              [17.288, 61.701],
              [17.29, 61.699],
              [17.291, 61.697],
              [17.291, 61.695],
              [17.287, 61.691],
              [17.286, 61.689],
              [17.285, 61.686],
              [17.285, 61.684],
              [17.287, 61.682],
              [17.293, 61.678],
              [17.304, 61.675],
              [17.307, 61.674],
              [17.309, 61.673],
              [17.312, 61.67],
              [17.314, 61.669],
              [17.327, 61.669],
              [17.33, 61.67],
              [17.332, 61.672],
              [17.332, 61.675],
              [17.331, 61.678],
              [17.327, 61.686],
              [17.321, 61.695],
              [17.32, 61.697],
              [17.321, 61.7],
              [17.324, 61.706],
              [17.324, 61.709],
              [17.323, 61.713],
              [17.323, 61.715],
              [17.324, 61.716],
              [17.326, 61.716],
              [17.329, 61.715],
              [17.333, 61.713],
              [17.338, 61.711],
              [17.348, 61.705],
              [17.353, 61.7],
              [17.358, 61.696],
              [17.362, 61.691],
              [17.367, 61.686],
              [17.38, 61.67],
              [17.384, 61.665],
              [17.397, 61.652],
              [17.406, 61.644],
              [17.414, 61.637],
              [17.418, 61.633],
              [17.422, 61.631],
              [17.427, 61.628],
              [17.433, 61.625],
              [17.438, 61.623],
              [17.456, 61.62],
              [17.462, 61.621],
              [17.468, 61.621],
              [17.474, 61.623],
              [17.48, 61.624],
              [17.485, 61.627],
              [17.489, 61.631],
              [17.497, 61.641],
              [17.503, 61.653],
              [17.507, 61.665],
              [17.509, 61.672],
              [17.511, 61.678],
              [17.512, 61.684],
              [17.512, 61.69],
              [17.511, 61.696],
              [17.509, 61.701],
              [17.506, 61.706],
              [17.5, 61.712],
              [17.492, 61.716],
              [17.476, 61.722],
              [17.469, 61.724],
              [17.463, 61.726],
              [17.457, 61.727],
              [17.45, 61.728],
              [17.437, 61.728],
              [17.43, 61.727],
              [17.423, 61.725],
              [17.417, 61.724],
              [17.41, 61.722],
              [17.4, 61.718],
              [17.392, 61.715],
              [17.39, 61.715],
              [17.388, 61.717],
              [17.389, 61.719],
              [17.389, 61.722],
              [17.39, 61.725],
              [17.39, 61.728],
              [17.389, 61.731],
              [17.387, 61.734],
              [17.384, 61.741],
              [17.382, 61.744],
              [17.381, 61.749],
              [17.38, 61.757],
              [17.379, 61.762],
              [17.377, 61.766],
              [17.373, 61.772],
              [17.367, 61.777],
              [17.365, 61.781],
              [17.365, 61.782],
              [17.369, 61.784],
              [17.374, 61.786],
              [17.376, 61.787],
              [17.377, 61.789],
              [17.379, 61.792],
              [17.38, 61.793],
              [17.382, 61.794],
              [17.388, 61.795],
              [17.391, 61.796],
              [17.393, 61.797],
              [17.394, 61.799],
              [17.396, 61.802],
              [17.397, 61.804],
              [17.399, 61.805],
              [17.404, 61.807],
              [17.406, 61.808],
              [17.407, 61.81],
              [17.407, 61.812],
              [17.405, 61.813],
              [17.399, 61.815],
              [17.395, 61.816],
              [17.366, 61.816],
              [17.362, 61.817],
              [17.358, 61.817],
              [17.354, 61.818],
              [17.347, 61.82],
              [17.34, 61.821],
              [17.336, 61.823],
              [17.336, 61.828],
              [17.337, 61.831],
              [17.338, 61.833],
              [17.338, 61.836],
              [17.337, 61.838],
              [17.334, 61.841],
              [17.33, 61.843],
              [17.321, 61.846],
              [17.32, 61.848],
              [17.319, 61.849],
              [17.319, 61.853],
              [17.321, 61.855],
              [17.325, 61.856],
              [17.343, 61.863],
              [17.347, 61.865],
              [17.351, 61.868],
              [17.353, 61.87],
              [17.356, 61.874],
              [17.357, 61.875],
              [17.358, 61.877],
              [17.359, 61.88],
              [17.358, 61.883],
              [17.356, 61.886],
              [17.347, 61.892],
              [17.345, 61.895],
              [17.344, 61.897],
              [17.345, 61.9],
              [17.343, 61.904],
              [17.342, 61.907],
              [17.34, 61.91],
              [17.338, 61.917],
              [17.336, 61.922],
              [17.335, 61.924],
              [17.335, 61.926],
              [17.336, 61.927],
              [17.339, 61.931],
              [17.343, 61.936],
              [17.344, 61.938],
              [17.346, 61.944],
              [17.347, 61.946],
              [17.349, 61.949],
              [17.355, 61.951],
              [17.363, 61.952],
              [17.367, 61.953],
              [17.37, 61.954],
              [17.373, 61.956],
              [17.375, 61.957],
              [17.377, 61.959],
              [17.38, 61.964],
              [17.383, 61.968],
              [17.388, 61.974],
              [17.391, 61.977],
              [17.393, 61.98],
              [17.394, 61.984],
              [17.398, 61.988],
              [17.401, 61.989],
              [17.405, 61.99],
              [17.41, 61.991],
              [17.421, 61.992],
              [17.426, 61.992],
              [17.436, 61.994],
              [17.439, 61.996],
              [17.442, 61.997],
              [17.444, 61.999],
              [17.445, 62.001],
              [21.293, 62.002],
              [21.292, 61.999],
              [21.292, 61.997],
              [21.293, 61.995],
              [21.295, 61.994],
              [21.299, 61.993],
              [21.303, 61.994],
              [21.319, 61.996],
              [21.33, 61.996],
              [21.332, 61.995],
              [21.334, 61.993],
              [21.335, 61.991],
              [21.336, 61.99],
              [21.336, 61.989],
              [21.335, 61.988],
              [21.334, 61.988],
              [21.332, 61.987],
              [21.324, 61.987],
              [21.322, 61.986],
              [21.32, 61.984],
              [21.321, 61.977],
              [21.321, 61.966],
              [21.323, 61.963],
              [21.326, 61.96],
              [21.334, 61.954],
              [21.339, 61.951],
              [21.354, 61.945],
              [21.359, 61.944],
              [21.365, 61.943],
              [21.37, 61.943],
              [21.373, 61.944],
              [21.39, 61.948],
              [21.399, 61.951],
              [21.408, 61.951],
              [21.411, 61.95],
              [21.413, 61.948],
              [21.412, 61.946],
              [21.412, 61.94],
              [21.413, 61.939],
              [21.414, 61.937],
              [21.417, 61.935],
              [21.424, 61.93],
              [21.427, 61.927],
              [21.429, 61.924],
              [21.43, 61.922],
              [21.43, 61.917],
              [21.429, 61.914],
              [21.429, 61.912],
              [21.431, 61.908],
              [21.437, 61.901],
              [21.439, 61.899],
              [21.442, 61.897],
              [21.453, 61.888],
              [21.457, 61.885],
              [21.46, 61.881],
              [21.462, 61.878],
              [21.464, 61.874],
              [21.466, 61.871],
              [21.469, 61.862],
              [21.471, 61.859],
              [21.477, 61.853],
              [21.481, 61.847],
              [21.483, 61.845],
              [21.483, 61.842],
              [21.481, 61.841],
              [21.48, 61.841],
              [21.479, 61.84],
              [21.479, 61.835],
              [21.482, 61.832],
              [21.486, 61.83],
              [21.494, 61.825],
              [21.506, 61.816],
              [21.509, 61.812],
              [21.51, 61.809],
              [21.51, 61.802],
              [21.508, 61.799],
              [21.506, 61.797],
              [21.503, 61.795],
              [21.5, 61.794],
              [21.497, 61.794],
              [21.495, 61.795],
              [21.491, 61.8],
              [21.488, 61.801],
              [21.485, 61.803],
              [21.481, 61.805],
              [21.477, 61.806],
              [21.467, 61.808],
              [21.458, 61.808],
              [21.443, 61.807],
              [21.439, 61.806],
              [21.436, 61.805],
              [21.435, 61.804],
              [21.438, 61.801],
              [21.444, 61.796],
              [21.449, 61.792],
              [21.457, 61.786],
              [21.475, 61.776],
              [21.479, 61.775],
              [21.483, 61.773],
              [21.49, 61.773],
              [21.491, 61.775],
              [21.492, 61.775],
              [21.495, 61.776],
              [21.5, 61.776],
              [21.505, 61.775],
              [21.507, 61.775],
              [21.517, 61.771],
              [21.523, 61.769],
              [21.528, 61.766],
              [21.564, 61.745],
              [21.579, 61.736],
              [21.587, 61.73],
              [21.589, 61.728],
              [21.589, 61.727],
              [21.585, 61.727],
              [21.566, 61.73],
              [21.556, 61.73],
              [21.552, 61.729],
              [21.548, 61.727],
              [21.544, 61.724],
              [21.542, 61.722],
              [21.539, 61.72],
              [21.536, 61.719],
              [21.532, 61.718],
              [21.52, 61.718],
              [21.523, 61.715],
              [21.532, 61.707],
              [21.534, 61.705],
              [21.536, 61.702],
              [21.537, 61.701],
              [21.538, 61.698],
              [21.541, 61.695],
              [21.541, 61.691],
              [21.54, 61.69],
              [21.541, 61.689],
              [21.542, 61.686],
              [21.554, 61.674],
              [21.56, 61.669],
              [21.563, 61.666],
              [21.568, 61.662],
              [21.572, 61.659],
              [21.587, 61.651],
              [21.591, 61.649],
              [21.595, 61.645],
              [21.598, 61.641],
              [21.6, 61.639],
              [21.602, 61.636],
              [21.605, 61.634],
              [21.609, 61.631],
              [21.621, 61.623],
              [21.622, 61.622],
              [21.62, 61.62],
              [21.616, 61.619],
              [21.614, 61.617],
              [21.615, 61.616],
              [21.618, 61.612],
              [21.621, 61.61],
              [21.622, 61.608],
              [21.624, 61.605],
              [21.628, 61.601],
              [21.631, 61.599],
              [21.64, 61.594],
              [21.643, 61.591],
              [21.644, 61.589],
              [21.646, 61.588],
              [21.653, 61.582],
              [21.66, 61.575],
              [21.661, 61.573],
              [21.662, 61.572],
              [21.66, 61.57],
              [21.656, 61.568],
              [21.656, 61.566],
              [21.658, 61.565],
              [21.662, 61.564],
              [21.664, 61.563],
              [21.664, 61.562],
              [21.663, 61.562],
              [21.66, 61.561],
              [21.651, 61.561],
              [21.646, 61.562],
              [21.64, 61.562],
              [21.634, 61.564],
              [21.628, 61.565],
              [21.616, 61.569],
              [21.609, 61.571],
              [21.603, 61.572],
              [21.587, 61.575],
              [21.581, 61.577],
              [21.576, 61.578],
              [21.564, 61.582],
              [21.553, 61.586],
              [21.547, 61.588],
              [21.542, 61.59],
              [21.537, 61.593],
              [21.528, 61.598],
              [21.524, 61.6],
              [21.519, 61.602],
              [21.514, 61.603],
              [21.509, 61.603],
              [21.504, 61.602],
              [21.491, 61.6],
              [21.482, 61.599],
              [21.478, 61.598],
              [21.475, 61.597],
              [21.473, 61.597],
              [21.469, 61.595],
              [21.469, 61.593],
              [21.471, 61.592],
              [21.473, 61.59],
              [21.479, 61.588],
              [21.485, 61.584],
              [21.49, 61.574],
              [21.493, 61.572],
              [21.496, 61.571],
              [21.503, 61.568],
              [21.511, 61.564],
              [21.514, 61.562],
              [21.519, 61.558],
              [21.531, 61.547],
              [21.536, 61.543],
              [21.54, 61.54],
              [21.55, 61.536],
              [21.556, 61.535],
              [21.566, 61.533],
              [21.583, 61.533],
              [21.587, 61.532],
              [21.59, 61.532],
              [21.593, 61.53],
              [21.615, 61.519],
              [21.621, 61.515],
              [21.623, 61.511],
              [21.621, 61.509],
              [21.618, 61.507],
              [21.614, 61.506],
              [21.597, 61.502],
              [21.585, 61.5],
              [21.578, 61.499],
              [21.565, 61.499],
              [21.558, 61.5],
              [21.552, 61.501],
              [21.545, 61.502],
              [21.518, 61.507],
              [21.504, 61.509],
              [21.498, 61.51],
              [21.469, 61.51],
              [21.466, 61.509],
              [21.465, 61.508],
              [21.465, 61.507],
              [21.471, 61.503],
              [21.476, 61.502],
              [21.497, 61.493],
              [21.517, 61.485],
              [21.541, 61.477],
              [21.546, 61.475],
              [21.552, 61.472],
              [21.557, 61.469],
              [21.561, 61.467],
              [21.572, 61.456],
              [21.575, 61.454],
              [21.582, 61.449],
              [21.587, 61.444],
              [21.588, 61.442],
              [21.588, 61.439],
              [21.584, 61.435],
              [21.581, 61.433],
              [21.577, 61.432],
              [21.574, 61.431],
              [21.569, 61.43],
              [21.53, 61.43],
              [21.524, 61.431],
              [21.517, 61.432],
              [21.478, 61.438],
              [21.474, 61.438],
              [21.47, 61.439],
              [21.468, 61.438],
              [21.467, 61.438],
              [21.467, 61.437],
              [21.468, 61.435],
              [21.468, 61.434],
              [21.467, 61.434],
              [21.462, 61.432],
              [21.461, 61.431],
              [21.46, 61.431],
              [21.463, 61.428],
              [21.466, 61.427],
              [21.47, 61.425],
              [21.475, 61.424],
              [21.493, 61.418],
              [21.498, 61.416],
              [21.504, 61.414],
              [21.51, 61.411],
              [21.515, 61.409],
              [21.524, 61.404],
              [21.527, 61.402],
              [21.532, 61.399],
              [21.542, 61.392],
              [21.544, 61.39],
              [21.545, 61.388],
              [21.544, 61.387],
              [21.542, 61.386],
              [21.532, 61.382],
              [21.528, 61.381],
              [21.517, 61.38],
              [21.514, 61.379],
              [21.512, 61.377],
              [21.512, 61.375],
              [21.514, 61.371],
              [21.516, 61.369],
              [21.519, 61.367],
              [21.526, 61.362],
              [21.529, 61.359],
              [21.531, 61.358],
              [21.534, 61.357],
              [21.538, 61.355],
              [21.55, 61.351],
              [21.554, 61.349],
              [21.558, 61.348],
              [21.561, 61.346],
              [21.566, 61.341],
              [21.566, 61.34],
              [21.561, 61.335],
              [21.56, 61.332],
              [21.559, 61.331],
              [21.557, 61.33],
              [21.55, 61.327],
              [21.545, 61.324],
              [21.538, 61.321],
              [21.533, 61.319],
              [21.526, 61.316],
              [21.522, 61.315],
              [21.512, 61.309],
              [21.509, 61.307],
              [21.507, 61.305],
              [21.506, 61.302],
              [21.507, 61.3],
              [21.508, 61.297],
              [21.511, 61.295],
              [21.514, 61.292],
              [21.516, 61.291],
              [21.521, 61.288],
              [21.522, 61.287],
              [21.522, 61.285],
              [21.521, 61.284],
              [21.517, 61.283],
              [21.504, 61.281],
              [21.499, 61.28],
              [21.495, 61.278],
              [21.492, 61.276],
              [21.491, 61.274],
              [21.491, 61.272],
              [21.493, 61.269],
              [21.495, 61.267],
              [21.498, 61.265],
              [21.502, 61.262],
              [21.507, 61.26],
              [21.523, 61.254],
              [21.529, 61.251],
              [21.534, 61.249],
              [21.539, 61.248],
              [21.545, 61.246],
              [21.577, 61.238],
              [21.589, 61.234],
              [21.593, 61.233],
              [21.599, 61.23],
              [21.599, 61.228],
              [21.596, 61.225],
              [21.594, 61.224],
              [21.591, 61.222],
              [21.589, 61.222],
              [21.585, 61.221],
              [21.575, 61.223],
              [21.564, 61.226],
              [21.557, 61.227],
              [21.551, 61.228],
              [21.54, 61.228],
              [21.534, 61.227],
              [21.529, 61.225],
              [21.526, 61.224],
              [21.521, 61.219],
              [21.518, 61.217],
              [21.517, 61.215],
              [21.517, 61.212],
              [21.518, 61.211],
              [21.518, 61.208],
              [21.516, 61.205],
              [21.516, 61.201],
              [21.517, 61.199],
              [21.52, 61.195],
              [21.521, 61.193],
              [21.52, 61.192],
              [21.511, 61.192],
              [21.496, 61.194],
              [21.49, 61.195],
              [21.472, 61.195],
              [21.467, 61.194],
              [21.462, 61.194],
              [21.458, 61.193],
              [21.455, 61.192],
              [21.454, 61.191],
              [21.454, 61.19],
              [21.456, 61.189],
              [21.464, 61.187],
              [21.469, 61.187],
              [21.488, 61.186],
              [21.477, 61.185],
              [21.473, 61.185],
              [21.469, 61.184],
              [21.464, 61.183],
              [21.461, 61.182],
              [21.458, 61.18],
              [21.456, 61.178],
              [21.453, 61.174],
              [21.446, 61.167],
              [21.445, 61.165],
              [21.446, 61.163],
              [21.452, 61.157],
              [21.454, 61.156],
              [21.458, 61.152],
              [21.459, 61.15],
              [21.462, 61.149],
              [21.464, 61.147],
              [21.467, 61.146],
              [21.472, 61.143],
              [21.474, 61.142],
              [21.474, 61.141],
              [21.473, 61.14],
              [21.471, 61.139],
              [21.465, 61.137],
              [21.461, 61.136],
              [21.451, 61.135],
              [21.449, 61.134],
              [21.448, 61.134],
              [21.446, 61.132],
              [21.444, 61.132],
              [21.44, 61.131],
              [21.439, 61.131],
              [21.439, 61.13],
              [21.44, 61.129],
              [21.443, 61.129],
              [21.447, 61.128],
              [21.459, 61.127],
              [21.463, 61.127],
              [21.464, 61.126],
              [21.465, 61.126],
              [21.463, 61.124],
              [21.463, 61.122],
              [21.464, 61.121],
              [21.465, 61.119],
              [21.463, 61.117],
              [21.459, 61.114],
              [21.455, 61.112],
              [21.454, 61.11],
              [21.455, 61.103],
              [21.455, 61.101],
              [21.457, 61.099],
              [21.46, 61.097],
              [21.466, 61.092],
              [21.469, 61.09],
              [21.474, 61.084],
              [21.476, 61.083],
              [21.48, 61.08],
              [21.482, 61.079],
              [21.482, 61.078],
              [21.481, 61.077],
              [21.479, 61.076],
              [21.475, 61.076],
              [21.471, 61.077],
              [21.466, 61.077],
              [21.46, 61.079],
              [21.444, 61.083],
              [21.432, 61.085],
              [21.413, 61.087],
              [21.397, 61.089],
              [21.39, 61.089],
              [21.388, 61.088],
              [21.387, 61.087],
              [21.387, 61.085],
              [21.391, 61.081],
              [21.394, 61.08],
              [21.398, 61.079],
              [21.409, 61.075],
              [21.413, 61.073],
              [21.422, 61.067],
              [21.425, 61.066],
              [21.427, 61.062],
              [21.427, 61.06],
              [21.426, 61.059],
              [21.424, 61.056],
              [21.42, 61.054],
              [21.416, 61.054],
              [21.413, 61.055],
              [21.403, 61.057],
              [21.387, 61.063],
              [21.35, 61.075],
              [21.33, 61.082],
              [21.326, 61.083],
              [21.321, 61.084],
              [21.317, 61.084],
              [21.313, 61.083],
              [21.31, 61.082],
              [21.308, 61.08],
              [21.307, 61.078],
              [21.307, 61.075],
              [21.308, 61.071],
              [21.309, 61.068],
              [21.315, 61.062],
              [21.319, 61.059],
              [21.327, 61.055],
              [21.333, 61.051],
              [21.335, 61.047],
              [21.334, 61.045],
              [21.334, 61.043],
              [21.332, 61.039],
              [21.332, 61.037],
              [21.334, 61.035],
              [21.336, 61.034],
              [21.34, 61.033],
              [21.344, 61.031],
              [21.348, 61.031],
              [21.364, 61.027],
              [21.367, 61.026],
              [21.368, 61.025],
              [21.363, 61.023],
              [21.357, 61.021],
              [21.355, 61.019],
              [21.354, 61.017],
              [21.355, 61.015],
              [21.357, 61.013],
              [21.366, 61.003],
              [21.374, 60.995],
              [21.379, 60.992],
              [21.384, 60.988],
              [21.394, 60.981],
              [21.399, 60.977],
              [21.403, 60.974],
              [21.41, 60.967],
              [21.422, 60.957],
              [21.425, 60.953],
              [21.431, 60.943],
              [21.433, 60.938],
              [21.434, 60.934],
              [21.434, 60.926],
              [21.433, 60.923],
              [21.431, 60.922],
              [21.427, 60.922],
              [21.419, 60.924],
              [21.413, 60.926],
              [21.398, 60.926],
              [21.394, 60.927],
              [21.391, 60.927],
              [21.389, 60.928],
              [21.385, 60.929],
              [21.382, 60.93],
              [21.381, 60.931],
              [21.383, 60.933],
              [21.387, 60.935],
              [21.39, 60.936],
              [21.391, 60.937],
              [21.393, 60.941],
              [21.392, 60.943],
              [21.388, 60.947],
              [21.385, 60.949],
              [21.38, 60.952],
              [21.37, 60.956],
              [21.36, 60.962],
              [21.356, 60.966],
              [21.347, 60.974],
              [21.337, 60.982],
              [21.332, 60.985],
              [21.327, 60.989],
              [21.321, 60.992],
              [21.316, 60.995],
              [21.31, 60.998],
              [21.305, 61.001],
              [21.29, 61.004],
              [21.286, 61.003],
              [21.283, 61.002],
              [21.276, 60.998],
              [21.264, 60.991],
              [21.258, 60.987],
              [21.255, 60.984],
              [21.257, 60.981],
              [21.259, 60.979],
              [21.274, 60.973],
              [21.292, 60.966],
              [21.298, 60.964],
              [21.308, 60.959],
              [21.312, 60.956],
              [21.315, 60.953],
              [21.317, 60.947],
              [21.317, 60.946],
              [21.316, 60.945],
              [21.315, 60.945],
              [21.312, 60.944],
              [21.31, 60.942],
              [21.31, 60.934],
              [21.308, 60.93],
              [21.3, 60.926],
              [21.298, 60.924],
              [21.296, 60.92],
              [21.298, 60.916],
              [21.303, 60.911],
              [21.303, 60.91],
              [21.301, 60.91],
              [21.299, 60.911],
              [21.295, 60.912],
              [21.29, 60.913],
              [21.279, 60.917],
              [21.267, 60.921],
              [21.255, 60.923],
              [21.245, 60.923],
              [21.235, 60.921],
              [21.227, 60.919],
              [21.224, 60.917],
              [21.221, 60.916],
              [21.219, 60.914],
              [21.217, 60.911],
              [21.217, 60.908],
              [21.222, 60.903],
              [21.23, 60.899],
              [21.235, 60.898],
              [21.253, 60.895],
              [21.271, 60.894],
              [21.276, 60.894],
              [21.28, 60.893],
              [21.289, 60.89],
              [21.295, 60.89],
              [21.303, 60.893],
              [21.307, 60.895],
              [21.307, 60.896],
              [21.306, 60.897],
              [21.303, 60.898],
              [21.299, 60.899],
              [21.284, 60.902],
              [21.282, 60.903],
              [21.281, 60.903],
              [21.288, 60.903],
              [21.298, 60.902],
              [21.309, 60.901],
              [21.32, 60.899],
              [21.325, 60.899],
              [21.336, 60.897],
              [21.339, 60.896],
              [21.348, 60.896],
              [21.354, 60.897],
              [21.372, 60.898],
              [21.378, 60.899],
              [21.403, 60.899],
              [21.408, 60.898],
              [21.413, 60.898],
              [21.418, 60.897],
              [21.421, 60.896],
              [21.423, 60.894],
              [21.424, 60.894],
              [21.424, 60.893],
              [21.423, 60.891],
              [21.419, 60.889],
              [21.411, 60.887],
              [21.402, 60.887],
              [21.392, 60.886],
              [21.387, 60.886],
              [21.373, 60.885],
              [21.352, 60.885],
              [21.346, 60.884],
              [21.341, 60.882],
              [21.335, 60.88],
              [21.325, 60.876],
              [21.318, 60.874],
              [21.315, 60.873],
              [21.314, 60.872],
              [21.314, 60.871],
              [21.316, 60.87],
              [21.317, 60.87],
              [21.323, 60.869],
              [21.326, 60.868],
              [21.331, 60.866],
              [21.343, 60.862],
              [21.345, 60.86],
              [21.347, 60.859],
              [21.348, 60.857],
              [21.347, 60.855],
              [21.346, 60.851],
              [21.347, 60.849],
              [21.347, 60.847],
              [21.353, 60.841],
              [21.354, 60.838],
              [21.356, 60.835],
              [21.357, 60.832],
              [21.359, 60.829],
              [21.361, 60.828],
              [21.367, 60.826],
              [21.37, 60.826],
              [21.375, 60.825],
              [21.377, 60.824],
              [21.383, 60.82],
              [21.385, 60.817],
              [21.386, 60.814],
              [21.385, 60.812],
              [21.385, 60.809],
              [21.383, 60.805],
              [21.383, 60.803],
              [21.385, 60.801],
              [21.391, 60.799],
              [21.394, 60.799],
              [21.404, 60.798],
              [21.405, 60.797],
              [21.406, 60.797],
              [21.404, 60.794],
              [21.404, 60.79],
              [21.402, 60.787],
              [21.402, 60.783],
              [21.401, 60.782],
              [21.399, 60.779],
              [21.398, 60.777],
              [21.398, 60.776],
              [21.403, 60.771],
              [21.407, 60.769],
              [21.411, 60.766],
              [21.439, 60.752],
              [21.444, 60.747],
              [21.444, 60.744],
              [21.442, 60.74],
              [21.442, 60.737],
              [21.443, 60.735],
              [21.446, 60.731],
              [21.448, 60.728],
              [21.454, 60.721],
              [21.457, 60.718],
              [21.459, 60.715],
              [21.459, 60.713],
              [21.457, 60.711],
              [21.455, 60.71],
              [21.447, 60.71],
              [21.435, 60.713],
              [21.432, 60.713],
              [21.428, 60.714],
              [21.423, 60.714],
              [21.421, 60.716],
              [21.419, 60.72],
              [21.419, 60.735],
              [21.417, 60.739],
              [21.411, 60.747],
              [21.407, 60.751],
              [21.399, 60.757],
              [21.395, 60.759],
              [21.391, 60.76],
              [21.388, 60.761],
              [21.386, 60.761],
              [21.385, 60.759],
              [21.384, 60.758],
              [21.384, 60.755],
              [21.383, 60.752],
              [21.383, 60.746],
              [21.381, 60.743],
              [21.381, 60.74],
              [21.382, 60.738],
              [21.382, 60.735],
              [21.38, 60.734],
              [21.378, 60.732],
              [21.372, 60.728],
              [21.365, 60.723],
              [21.355, 60.717],
              [21.353, 60.716],
              [21.352, 60.714],
              [21.352, 60.71],
              [21.351, 60.706],
              [21.351, 60.703],
              [21.353, 60.7],
              [21.354, 60.699],
              [21.354, 60.697],
              [21.35, 60.695],
              [21.341, 60.695],
              [21.339, 60.693],
              [21.341, 60.69],
              [21.343, 60.688],
              [21.344, 60.686],
              [21.347, 60.684],
              [21.351, 60.682],
              [21.355, 60.679],
              [21.376, 60.67],
              [21.385, 60.666],
              [21.395, 60.662],
              [21.399, 60.66],
              [21.408, 60.656],
              [21.412, 60.654],
              [21.424, 60.649],
              [21.43, 60.646],
              [21.432, 60.646],
              [21.437, 60.644],
              [21.439, 60.643],
              [21.44, 60.642],
              [21.44, 60.641],
              [21.439, 60.639],
              [21.433, 60.636],
              [21.426, 60.636],
              [21.423, 60.637],
              [21.418, 60.639],
              [21.409, 60.639],
              [21.407, 60.638],
              [21.404, 60.635],
              [21.404, 60.633],
              [21.405, 60.631],
              [21.407, 60.629],
              [21.413, 60.625],
              [21.42, 60.621],
              [21.423, 60.619],
              [21.429, 60.613],
              [21.43, 60.611],
              [21.432, 60.606],
              [21.436, 60.6],
              [21.44, 60.597],
              [21.443, 60.595],
              [21.448, 60.592],
              [21.452, 60.59],
              [21.462, 60.586],
              [21.468, 60.585],
              [21.473, 60.584],
              [21.482, 60.582],
              [21.49, 60.581],
              [21.494, 60.58],
              [21.5, 60.58],
              [21.502, 60.581],
              [21.503, 60.582],
              [21.502, 60.585],
              [21.504, 60.587],
              [21.506, 60.588],
              [21.515, 60.591],
              [21.518, 60.593],
              [21.528, 60.593],
              [21.53, 60.592],
              [21.53, 60.591],
              [21.527, 60.587],
              [21.526, 60.585],
              [21.526, 60.583],
              [21.528, 60.581],
              [21.53, 60.578],
              [21.533, 60.576],
              [21.537, 60.574],
              [21.542, 60.572],
              [21.555, 60.567],
              [21.559, 60.565],
              [21.562, 60.564],
              [21.564, 60.562],
              [21.568, 60.557],
              [21.571, 60.554],
              [21.574, 60.55],
              [21.587, 60.54],
              [21.594, 60.533],
              [21.596, 60.53],
              [21.597, 60.528],
              [21.597, 60.524],
              [21.593, 60.524],
              [21.59, 60.525],
              [21.587, 60.529],
              [21.581, 60.533],
              [21.578, 60.534],
              [21.576, 60.535],
              [21.573, 60.535],
              [21.572, 60.534],
              [21.571, 60.532],
              [21.572, 60.529],
              [21.573, 60.525],
              [21.574, 60.522],
            ],
          ],
        ],
      },
      properties: {
        id: 44,
        name: 'Södra Bottenhavet',
        latlon: [61.441919, 19.181431],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [22.044, 58.21],
              [16.816, 58.204],
              [16.816, 58.205],
              [16.818, 58.21],
              [16.818, 58.213],
              [16.815, 58.216],
              [16.809, 58.219],
              [16.808, 58.22],
              [16.806, 58.224],
              [16.806, 58.232],
              [16.805, 58.234],
              [16.795, 58.239],
              [16.785, 58.241],
              [16.779, 58.242],
              [16.774, 58.243],
              [16.756, 58.243],
              [16.753, 58.244],
              [16.751, 58.245],
              [16.747, 58.248],
              [16.745, 58.249],
              [16.743, 58.251],
              [16.74, 58.252],
              [16.735, 58.254],
              [16.731, 58.256],
              [16.717, 58.26],
              [16.713, 58.262],
              [16.71, 58.263],
              [16.709, 58.265],
              [16.708, 58.266],
              [16.71, 58.268],
              [16.72, 58.268],
              [16.726, 58.265],
              [16.731, 58.265],
              [16.735, 58.264],
              [16.744, 58.267],
              [16.745, 58.268],
              [16.747, 58.271],
              [16.751, 58.273],
              [16.754, 58.274],
              [16.761, 58.275],
              [16.765, 58.275],
              [16.768, 58.276],
              [16.775, 58.279],
              [16.779, 58.28],
              [16.787, 58.281],
              [16.793, 58.283],
              [16.795, 58.285],
              [16.796, 58.287],
              [16.796, 58.29],
              [16.797, 58.292],
              [16.799, 58.294],
              [16.811, 58.302],
              [16.813, 58.304],
              [16.813, 58.308],
              [16.811, 58.31],
              [16.809, 58.311],
              [16.805, 58.312],
              [16.802, 58.313],
              [16.792, 58.314],
              [16.782, 58.316],
              [16.775, 58.316],
              [16.768, 58.315],
              [16.733, 58.315],
              [16.726, 58.316],
              [16.72, 58.317],
              [16.706, 58.321],
              [16.7, 58.323],
              [16.674, 58.333],
              [16.662, 58.337],
              [16.651, 58.342],
              [16.641, 58.347],
              [16.641, 58.348],
              [16.645, 58.348],
              [16.658, 58.345],
              [16.663, 58.343],
              [16.668, 58.342],
              [16.691, 58.339],
              [16.702, 58.337],
              [16.706, 58.336],
              [16.72, 58.336],
              [16.724, 58.337],
              [16.735, 58.339],
              [16.74, 58.34],
              [16.749, 58.34],
              [16.753, 58.339],
              [16.762, 58.337],
              [16.767, 58.336],
              [16.772, 58.336],
              [16.777, 58.337],
              [16.782, 58.337],
              [16.786, 58.338],
              [16.789, 58.338],
              [16.792, 58.34],
              [16.792, 58.341],
              [16.793, 58.343],
              [16.792, 58.346],
              [16.791, 58.352],
              [16.79, 58.356],
              [16.789, 58.358],
              [16.788, 58.361],
              [16.786, 58.363],
              [16.784, 58.366],
              [16.778, 58.372],
              [16.776, 58.373],
              [16.772, 58.373],
              [16.757, 58.371],
              [16.749, 58.369],
              [16.745, 58.367],
              [16.74, 58.364],
              [16.738, 58.363],
              [16.735, 58.362],
              [16.732, 58.362],
              [16.727, 58.363],
              [16.719, 58.363],
              [16.718, 58.364],
              [16.717, 58.366],
              [16.717, 58.368],
              [16.721, 58.376],
              [16.721, 58.377],
              [16.719, 58.382],
              [16.718, 58.384],
              [16.717, 58.387],
              [16.715, 58.389],
              [16.713, 58.392],
              [16.707, 58.396],
              [16.699, 58.4],
              [16.693, 58.402],
              [16.688, 58.404],
              [16.671, 58.409],
              [16.666, 58.411],
              [16.655, 58.415],
              [16.649, 58.417],
              [16.638, 58.421],
              [16.628, 58.425],
              [16.618, 58.43],
              [16.608, 58.434],
              [16.573, 58.434],
              [16.569, 58.436],
              [16.566, 58.437],
              [16.564, 58.439],
              [16.56, 58.44],
              [16.557, 58.442],
              [16.552, 58.444],
              [16.548, 58.445],
              [16.543, 58.446],
              [16.526, 58.45],
              [16.498, 58.458],
              [16.457, 58.471],
              [16.444, 58.474],
              [16.439, 58.476],
              [16.431, 58.477],
              [16.429, 58.478],
              [16.428, 58.479],
              [16.428, 58.48],
              [16.429, 58.48],
              [16.431, 58.481],
              [16.445, 58.481],
              [16.461, 58.479],
              [16.474, 58.479],
              [16.481, 58.48],
              [16.487, 58.48],
              [16.497, 58.478],
              [16.509, 58.474],
              [16.522, 58.469],
              [16.541, 58.462],
              [16.555, 58.457],
              [16.561, 58.455],
              [16.582, 58.449],
              [16.596, 58.447],
              [16.624, 58.445],
              [16.631, 58.444],
              [16.638, 58.442],
              [16.645, 58.441],
              [16.651, 58.439],
              [16.685, 58.431],
              [16.692, 58.429],
              [16.71, 58.426],
              [16.716, 58.426],
              [16.73, 58.427],
              [16.741, 58.427],
              [16.746, 58.428],
              [16.751, 58.43],
              [16.768, 58.436],
              [16.774, 58.438],
              [16.78, 58.439],
              [16.794, 58.441],
              [16.821, 58.444],
              [16.827, 58.445],
              [16.834, 58.446],
              [16.84, 58.448],
              [16.845, 58.45],
              [16.849, 58.453],
              [16.853, 58.455],
              [16.856, 58.458],
              [16.86, 58.464],
              [16.863, 58.468],
              [16.865, 58.47],
              [16.868, 58.472],
              [16.878, 58.474],
              [16.883, 58.474],
              [16.889, 58.475],
              [16.902, 58.475],
              [16.917, 58.476],
              [16.926, 58.476],
              [16.93, 58.477],
              [16.933, 58.479],
              [16.936, 58.48],
              [16.938, 58.484],
              [16.936, 58.487],
              [16.934, 58.489],
              [16.932, 58.49],
              [16.92, 58.494],
              [16.918, 58.495],
              [16.915, 58.498],
              [16.907, 58.502],
              [16.898, 58.506],
              [16.878, 58.514],
              [16.869, 58.519],
              [16.861, 58.521],
              [16.85, 58.524],
              [16.847, 58.525],
              [16.845, 58.527],
              [16.847, 58.528],
              [16.851, 58.529],
              [16.853, 58.531],
              [16.852, 58.532],
              [16.851, 58.534],
              [16.848, 58.535],
              [16.846, 58.536],
              [16.843, 58.538],
              [16.837, 58.539],
              [16.834, 58.54],
              [16.832, 58.542],
              [16.835, 58.545],
              [16.835, 58.547],
              [16.833, 58.549],
              [16.83, 58.551],
              [16.826, 58.553],
              [16.821, 58.555],
              [16.816, 58.556],
              [16.804, 58.559],
              [16.798, 58.56],
              [16.788, 58.564],
              [16.785, 58.567],
              [16.782, 58.569],
              [16.78, 58.573],
              [16.78, 58.575],
              [16.781, 58.577],
              [16.782, 58.578],
              [16.782, 58.58],
              [16.779, 58.583],
              [16.77, 58.587],
              [16.769, 58.589],
              [16.768, 58.59],
              [16.769, 58.591],
              [16.771, 58.591],
              [16.78, 58.593],
              [16.784, 58.595],
              [16.786, 58.597],
              [16.784, 58.599],
              [16.781, 58.6],
              [16.777, 58.601],
              [16.772, 58.602],
              [16.766, 58.603],
              [16.761, 58.604],
              [16.745, 58.604],
              [16.741, 58.603],
              [16.737, 58.603],
              [16.734, 58.602],
              [16.733, 58.601],
              [16.733, 58.599],
              [16.735, 58.597],
              [16.738, 58.595],
              [16.741, 58.592],
              [16.749, 58.587],
              [16.75, 58.587],
              [16.749, 58.587],
              [16.746, 58.588],
              [16.733, 58.593],
              [16.722, 58.596],
              [16.716, 58.598],
              [16.709, 58.6],
              [16.689, 58.606],
              [16.682, 58.608],
              [16.663, 58.614],
              [16.657, 58.616],
              [16.65, 58.618],
              [16.637, 58.621],
              [16.625, 58.624],
              [16.612, 58.626],
              [16.598, 58.628],
              [16.585, 58.629],
              [16.579, 58.63],
              [16.563, 58.63],
              [16.559, 58.629],
              [16.556, 58.626],
              [16.554, 58.625],
              [16.553, 58.624],
              [16.551, 58.623],
              [16.545, 58.621],
              [16.541, 58.62],
              [16.529, 58.62],
              [16.523, 58.621],
              [16.518, 58.622],
              [16.512, 58.623],
              [16.499, 58.626],
              [16.493, 58.628],
              [16.486, 58.629],
              [16.48, 58.631],
              [16.468, 58.633],
              [16.462, 58.633],
              [16.456, 58.634],
              [16.451, 58.634],
              [16.446, 58.633],
              [16.443, 58.632],
              [16.441, 58.631],
              [16.438, 58.63],
              [16.436, 58.628],
              [16.434, 58.627],
              [16.433, 58.625],
              [16.433, 58.622],
              [16.432, 58.616],
              [16.43, 58.61],
              [16.427, 58.605],
              [16.427, 58.6],
              [16.426, 58.598],
              [16.42, 58.595],
              [16.412, 58.593],
              [16.407, 58.594],
              [16.403, 58.595],
              [16.395, 58.599],
              [16.387, 58.605],
              [16.383, 58.611],
              [16.38, 58.614],
              [16.376, 58.617],
              [16.371, 58.62],
              [16.367, 58.622],
              [16.362, 58.624],
              [16.357, 58.625],
              [16.353, 58.626],
              [16.349, 58.626],
              [16.346, 58.625],
              [16.337, 58.619],
              [16.333, 58.617],
              [16.33, 58.617],
              [16.321, 58.615],
              [16.318, 58.614],
              [16.311, 58.611],
              [16.307, 58.61],
              [16.302, 58.61],
              [16.297, 58.609],
              [16.248, 58.609],
              [16.238, 58.607],
              [16.223, 58.602],
              [16.219, 58.6],
              [16.215, 58.599],
              [16.211, 58.599],
              [16.208, 58.598],
              [16.206, 58.598],
              [16.204, 58.6],
              [16.203, 58.603],
              [16.201, 58.604],
              [16.199, 58.607],
              [16.194, 58.611],
              [16.191, 58.613],
              [16.19, 58.614],
              [16.188, 58.617],
              [16.187, 58.619],
              [16.187, 58.622],
              [16.189, 58.628],
              [16.191, 58.63],
              [16.195, 58.632],
              [16.198, 58.633],
              [16.238, 58.633],
              [16.248, 58.635],
              [16.252, 58.636],
              [16.255, 58.638],
              [16.257, 58.641],
              [16.258, 58.644],
              [16.257, 58.647],
              [16.252, 58.652],
              [16.244, 58.656],
              [16.241, 58.657],
              [16.239, 58.659],
              [16.239, 58.661],
              [16.24, 58.662],
              [16.246, 58.665],
              [16.25, 58.665],
              [16.256, 58.666],
              [16.262, 58.666],
              [16.275, 58.667],
              [16.33, 58.667],
              [16.344, 58.666],
              [16.351, 58.666],
              [16.365, 58.665],
              [16.38, 58.663],
              [16.408, 58.66],
              [16.564, 58.641],
              [16.592, 58.638],
              [16.634, 58.634],
              [16.683, 58.63],
              [16.725, 58.627],
              [16.746, 58.626],
              [16.767, 58.624],
              [16.794, 58.624],
              [16.8, 58.623],
              [16.818, 58.621],
              [16.825, 58.621],
              [16.852, 58.619],
              [16.866, 58.618],
              [16.873, 58.617],
              [16.896, 58.614],
              [16.902, 58.613],
              [16.926, 58.613],
              [16.932, 58.614],
              [16.939, 58.615],
              [16.951, 58.617],
              [16.964, 58.62],
              [16.974, 58.622],
              [16.98, 58.624],
              [16.985, 58.624],
              [17.002, 58.626],
              [17.012, 58.628],
              [17.016, 58.629],
              [17.019, 58.63],
              [17.021, 58.632],
              [17.023, 58.633],
              [17.024, 58.634],
              [17.03, 58.638],
              [17.031, 58.639],
              [17.031, 58.646],
              [17.032, 58.647],
              [17.034, 58.65],
              [17.034, 58.652],
              [17.03, 58.656],
              [17.026, 58.658],
              [17.023, 58.66],
              [17.018, 58.661],
              [17.014, 58.663],
              [17.009, 58.663],
              [17.006, 58.664],
              [16.987, 58.664],
              [16.975, 58.665],
              [16.965, 58.667],
              [16.961, 58.668],
              [16.958, 58.669],
              [16.956, 58.67],
              [16.956, 58.672],
              [16.957, 58.673],
              [16.959, 58.674],
              [16.962, 58.675],
              [16.966, 58.676],
              [16.971, 58.677],
              [16.989, 58.679],
              [16.995, 58.679],
              [16.999, 58.678],
              [17.003, 58.678],
              [17.017, 58.677],
              [17.022, 58.677],
              [17.028, 58.676],
              [17.035, 58.676],
              [17.042, 58.675],
              [17.048, 58.673],
              [17.055, 58.672],
              [17.061, 58.67],
              [17.071, 58.666],
              [17.077, 58.662],
              [17.083, 58.656],
              [17.086, 58.655],
              [17.094, 58.653],
              [17.104, 58.653],
              [17.108, 58.655],
              [17.108, 58.656],
              [17.109, 58.659],
              [17.112, 58.662],
              [17.116, 58.663],
              [17.125, 58.665],
              [17.133, 58.669],
              [17.136, 58.672],
              [17.141, 58.678],
              [17.153, 58.686],
              [17.156, 58.689],
              [17.155, 58.691],
              [17.149, 58.693],
              [17.141, 58.695],
              [17.136, 58.696],
              [17.131, 58.696],
              [17.125, 58.695],
              [17.12, 58.695],
              [17.104, 58.692],
              [17.098, 58.691],
              [17.065, 58.691],
              [17.06, 58.692],
              [17.056, 58.692],
              [17.05, 58.694],
              [17.051, 58.695],
              [17.053, 58.696],
              [17.066, 58.697],
              [17.071, 58.698],
              [17.076, 58.698],
              [17.08, 58.699],
              [17.083, 58.701],
              [17.087, 58.703],
              [17.089, 58.705],
              [17.092, 58.706],
              [17.096, 58.707],
              [17.107, 58.709],
              [17.109, 58.709],
              [17.11, 58.71],
              [17.11, 58.711],
              [17.109, 58.712],
              [17.104, 58.714],
              [17.103, 58.715],
              [17.102, 58.717],
              [17.102, 58.719],
              [17.104, 58.722],
              [17.105, 58.724],
              [17.105, 58.726],
              [17.104, 58.728],
              [17.098, 58.732],
              [17.094, 58.733],
              [17.089, 58.735],
              [17.065, 58.735],
              [17.059, 58.736],
              [17.053, 58.736],
              [17.046, 58.737],
              [17.036, 58.739],
              [17.032, 58.74],
              [17.029, 58.741],
              [17.028, 58.742],
              [17.03, 58.743],
              [17.052, 58.743],
              [17.058, 58.744],
              [17.074, 58.747],
              [17.079, 58.748],
              [17.085, 58.752],
              [17.089, 58.756],
              [17.093, 58.758],
              [17.096, 58.758],
              [17.099, 58.757],
              [17.107, 58.753],
              [17.11, 58.75],
              [17.122, 58.739],
              [17.126, 58.736],
              [17.131, 58.732],
              [17.136, 58.729],
              [17.146, 58.725],
              [17.15, 58.724],
              [17.159, 58.724],
              [17.163, 58.725],
              [17.176, 58.725],
              [17.181, 58.726],
              [17.185, 58.726],
              [17.201, 58.73],
              [17.204, 58.731],
              [17.208, 58.731],
              [17.212, 58.73],
              [17.227, 58.728],
              [17.233, 58.727],
              [17.238, 58.726],
              [17.25, 58.726],
              [17.256, 58.725],
              [17.261, 58.726],
              [17.267, 58.726],
              [17.271, 58.727],
              [17.276, 58.729],
              [17.279, 58.731],
              [17.282, 58.734],
              [17.283, 58.736],
              [17.284, 58.74],
              [17.287, 58.743],
              [17.292, 58.746],
              [17.295, 58.747],
              [17.297, 58.748],
              [17.3, 58.752],
              [17.304, 58.754],
              [17.312, 58.754],
              [17.317, 58.753],
              [17.327, 58.752],
              [17.333, 58.751],
              [17.343, 58.751],
              [17.349, 58.752],
              [17.359, 58.752],
              [17.363, 58.751],
              [17.372, 58.749],
              [17.377, 58.748],
              [17.386, 58.748],
              [17.389, 58.751],
              [17.391, 58.76],
              [17.391, 58.763],
              [17.392, 58.767],
              [17.392, 58.771],
              [17.391, 58.774],
              [17.39, 58.778],
              [17.389, 58.781],
              [17.387, 58.785],
              [17.387, 58.787],
              [17.388, 58.789],
              [17.392, 58.791],
              [17.396, 58.791],
              [17.4, 58.792],
              [17.422, 58.792],
              [17.427, 58.791],
              [17.433, 58.791],
              [17.449, 58.788],
              [17.453, 58.787],
              [17.465, 58.787],
              [17.478, 58.784],
              [17.482, 58.783],
              [17.496, 58.783],
              [17.5, 58.784],
              [17.502, 58.784],
              [17.503, 58.785],
              [17.503, 58.786],
              [17.502, 58.787],
              [17.49, 58.795],
              [17.486, 58.797],
              [17.477, 58.801],
              [17.473, 58.803],
              [17.467, 58.807],
              [17.467, 58.815],
              [17.468, 58.817],
              [17.468, 58.818],
              [17.476, 58.822],
              [17.479, 58.825],
              [17.48, 58.83],
              [17.484, 58.834],
              [17.486, 58.835],
              [17.49, 58.835],
              [17.494, 58.836],
              [17.496, 58.836],
              [17.498, 58.838],
              [17.497, 58.84],
              [17.496, 58.841],
              [17.493, 58.845],
              [17.491, 58.847],
              [17.49, 58.85],
              [17.489, 58.852],
              [17.487, 58.855],
              [17.485, 58.857],
              [17.483, 58.86],
              [17.477, 58.865],
              [17.474, 58.868],
              [17.471, 58.872],
              [17.468, 58.875],
              [17.466, 58.878],
              [17.465, 58.88],
              [17.465, 58.882],
              [17.466, 58.883],
              [17.469, 58.883],
              [17.475, 58.881],
              [17.482, 58.877],
              [17.487, 58.875],
              [17.493, 58.872],
              [17.498, 58.869],
              [17.515, 58.859],
              [17.52, 58.855],
              [17.527, 58.852],
              [17.533, 58.849],
              [17.539, 58.847],
              [17.545, 58.844],
              [17.551, 58.842],
              [17.557, 58.841],
              [17.562, 58.84],
              [17.569, 58.84],
              [17.572, 58.843],
              [17.571, 58.846],
              [17.57, 58.851],
              [17.57, 58.854],
              [17.572, 58.855],
              [17.573, 58.856],
              [17.573, 58.857],
              [17.572, 58.859],
              [17.569, 58.861],
              [17.563, 58.864],
              [17.56, 58.866],
              [17.558, 58.869],
              [17.556, 58.871],
              [17.554, 58.874],
              [17.544, 58.882],
              [17.542, 58.885],
              [17.54, 58.887],
              [17.54, 58.889],
              [17.541, 58.89],
              [17.583, 58.89],
              [17.592, 58.889],
              [17.616, 58.889],
              [17.618, 58.89],
              [17.619, 58.892],
              [17.62, 58.895],
              [17.62, 58.897],
              [17.617, 58.906],
              [17.613, 58.91],
              [17.609, 58.913],
              [17.602, 58.917],
              [17.599, 58.918],
              [17.597, 58.92],
              [17.596, 58.922],
              [17.597, 58.925],
              [17.598, 58.927],
              [17.598, 58.932],
              [17.597, 58.934],
              [17.588, 58.94],
              [17.584, 58.944],
              [17.584, 58.948],
              [17.586, 58.949],
              [17.588, 58.951],
              [17.59, 58.952],
              [17.593, 58.953],
              [17.608, 58.953],
              [17.61, 58.954],
              [17.613, 58.956],
              [17.615, 58.962],
              [17.619, 58.981],
              [17.621, 58.987],
              [17.622, 58.993],
              [17.622, 59],
              [17.623, 59.006],
              [17.622, 59.011],
              [17.621, 59.022],
              [17.621, 59.033],
              [17.622, 59.037],
              [17.623, 59.04],
              [17.626, 59.048],
              [17.627, 59.052],
              [17.628, 59.057],
              [17.628, 59.065],
              [17.627, 59.072],
              [17.627, 59.075],
              [17.628, 59.078],
              [17.629, 59.08],
              [17.631, 59.082],
              [17.634, 59.084],
              [17.644, 59.091],
              [17.65, 59.097],
              [17.65, 59.099],
              [17.654, 59.103],
              [17.658, 59.105],
              [17.67, 59.108],
              [17.674, 59.11],
              [17.678, 59.116],
              [17.678, 59.121],
              [17.677, 59.126],
              [17.675, 59.131],
              [17.673, 59.137],
              [17.671, 59.142],
              [17.668, 59.147],
              [17.666, 59.15],
              [17.661, 59.157],
              [17.659, 59.159],
              [17.659, 59.161],
              [17.656, 59.168],
              [17.654, 59.172],
              [17.65, 59.178],
              [17.643, 59.185],
              [17.641, 59.186],
              [17.641, 59.187],
              [17.642, 59.187],
              [17.647, 59.184],
              [17.651, 59.183],
              [17.654, 59.18],
              [17.658, 59.178],
              [17.661, 59.175],
              [17.665, 59.172],
              [17.668, 59.168],
              [17.672, 59.163],
              [17.68, 59.151],
              [17.683, 59.145],
              [17.687, 59.139],
              [17.69, 59.133],
              [17.692, 59.128],
              [17.694, 59.122],
              [17.696, 59.117],
              [17.697, 59.112],
              [17.697, 59.108],
              [17.695, 59.104],
              [17.691, 59.098],
              [17.69, 59.095],
              [17.689, 59.093],
              [17.689, 59.075],
              [17.69, 59.071],
              [17.692, 59.067],
              [17.698, 59.061],
              [17.702, 59.06],
              [17.71, 59.06],
              [17.72, 59.062],
              [17.724, 59.063],
              [17.728, 59.065],
              [17.731, 59.068],
              [17.734, 59.072],
              [17.736, 59.076],
              [17.739, 59.085],
              [17.741, 59.089],
              [17.743, 59.094],
              [17.746, 59.098],
              [17.75, 59.101],
              [17.755, 59.104],
              [17.759, 59.107],
              [17.763, 59.108],
              [17.766, 59.108],
              [17.77, 59.106],
              [17.771, 59.104],
              [17.773, 59.102],
              [17.774, 59.1],
              [17.773, 59.099],
              [17.772, 59.096],
              [17.77, 59.094],
              [17.76, 59.087],
              [17.758, 59.085],
              [17.756, 59.082],
              [17.756, 59.077],
              [17.757, 59.072],
              [17.757, 59.069],
              [17.756, 59.066],
              [17.753, 59.059],
              [17.751, 59.051],
              [17.751, 59.04],
              [17.752, 59.034],
              [17.755, 59.01],
              [17.755, 59.004],
              [17.756, 58.999],
              [17.754, 58.991],
              [17.753, 58.988],
              [17.747, 58.979],
              [17.744, 58.97],
              [17.744, 58.966],
              [17.745, 58.962],
              [17.745, 58.958],
              [17.744, 58.955],
              [17.743, 58.945],
              [17.741, 58.935],
              [17.743, 58.925],
              [17.745, 58.921],
              [17.748, 58.916],
              [17.751, 58.913],
              [17.754, 58.909],
              [17.757, 58.907],
              [17.766, 58.904],
              [17.771, 58.899],
              [17.773, 58.896],
              [17.778, 58.887],
              [17.78, 58.883],
              [17.783, 58.88],
              [17.787, 58.878],
              [17.79, 58.876],
              [17.794, 58.876],
              [17.8, 58.88],
              [17.802, 58.883],
              [17.804, 58.887],
              [17.805, 58.891],
              [17.805, 58.895],
              [17.804, 58.899],
              [17.802, 58.904],
              [17.799, 58.909],
              [17.795, 58.913],
              [17.788, 58.923],
              [17.784, 58.927],
              [17.781, 58.932],
              [17.778, 58.936],
              [17.776, 58.944],
              [17.778, 58.948],
              [17.78, 58.947],
              [17.783, 58.945],
              [17.79, 58.938],
              [17.803, 58.924],
              [17.812, 58.915],
              [17.82, 58.909],
              [17.823, 58.907],
              [17.826, 58.906],
              [17.83, 58.905],
              [17.841, 58.905],
              [17.849, 58.907],
              [17.856, 58.907],
              [17.858, 58.906],
              [17.86, 58.904],
              [17.862, 58.901],
              [17.865, 58.898],
              [17.868, 58.894],
              [17.87, 58.891],
              [17.871, 58.887],
              [17.872, 58.884],
              [17.871, 58.882],
              [17.871, 58.881],
              [17.869, 58.876],
              [17.866, 58.867],
              [17.868, 58.861],
              [17.87, 58.856],
              [17.871, 58.854],
              [17.873, 58.852],
              [17.875, 58.852],
              [17.877, 58.854],
              [17.878, 58.858],
              [17.88, 58.86],
              [17.883, 58.86],
              [17.887, 58.858],
              [17.889, 58.858],
              [17.892, 58.859],
              [17.894, 58.862],
              [17.897, 58.865],
              [17.899, 58.869],
              [17.901, 58.874],
              [17.909, 58.895],
              [17.911, 58.899],
              [17.913, 58.902],
              [17.914, 58.904],
              [17.917, 58.904],
              [17.92, 58.902],
              [17.922, 58.901],
              [17.922, 58.897],
              [17.921, 58.894],
              [17.916, 58.884],
              [17.914, 58.881],
              [17.914, 58.879],
              [17.913, 58.877],
              [17.913, 58.869],
              [17.914, 58.867],
              [17.914, 58.865],
              [17.915, 58.864],
              [17.917, 58.864],
              [17.919, 58.865],
              [17.922, 58.866],
              [17.925, 58.869],
              [17.928, 58.871],
              [17.93, 58.874],
              [17.936, 58.882],
              [17.956, 58.907],
              [17.96, 58.913],
              [17.966, 58.923],
              [17.968, 58.927],
              [17.969, 58.932],
              [17.969, 58.936],
              [17.968, 58.94],
              [17.966, 58.944],
              [17.965, 58.947],
              [17.965, 58.95],
              [17.964, 58.953],
              [17.965, 58.956],
              [17.969, 58.964],
              [17.976, 58.973],
              [17.977, 58.976],
              [17.978, 58.977],
              [17.978, 58.98],
              [17.98, 58.982],
              [17.981, 58.984],
              [17.986, 58.989],
              [17.992, 58.998],
              [17.994, 59],
              [17.995, 59],
              [17.996, 59.001],
              [17.997, 59],
              [18, 58.998],
              [18.003, 58.998],
              [18.007, 59],
              [18.009, 59.002],
              [18.011, 59.006],
              [18.012, 59.011],
              [18.012, 59.017],
              [18.011, 59.02],
              [18.009, 59.024],
              [18.007, 59.026],
              [18.004, 59.03],
              [18.004, 59.033],
              [18.006, 59.033],
              [18.008, 59.032],
              [18.015, 59.029],
              [18.023, 59.027],
              [18.026, 59.026],
              [18.03, 59.026],
              [18.034, 59.028],
              [18.037, 59.03],
              [18.046, 59.039],
              [18.054, 59.045],
              [18.059, 59.046],
              [18.065, 59.048],
              [18.071, 59.049],
              [18.088, 59.052],
              [18.098, 59.054],
              [18.102, 59.056],
              [18.106, 59.059],
              [18.112, 59.063],
              [18.116, 59.066],
              [18.126, 59.07],
              [18.132, 59.072],
              [18.145, 59.076],
              [18.171, 59.082],
              [18.183, 59.085],
              [18.19, 59.087],
              [18.195, 59.089],
              [18.201, 59.091],
              [18.206, 59.093],
              [18.21, 59.096],
              [18.213, 59.098],
              [18.215, 59.1],
              [18.215, 59.101],
              [18.214, 59.104],
              [18.216, 59.108],
              [18.219, 59.109],
              [18.223, 59.111],
              [18.227, 59.112],
              [18.232, 59.113],
              [18.235, 59.114],
              [18.238, 59.114],
              [18.24, 59.113],
              [18.241, 59.112],
              [18.24, 59.108],
              [18.239, 59.105],
              [18.239, 59.103],
              [18.235, 59.097],
              [18.23, 59.092],
              [18.229, 59.089],
              [18.229, 59.088],
              [18.228, 59.085],
              [18.228, 59.084],
              [18.226, 59.083],
              [18.223, 59.081],
              [18.213, 59.077],
              [18.21, 59.075],
              [18.208, 59.074],
              [18.207, 59.072],
              [18.207, 59.069],
              [18.208, 59.068],
              [18.21, 59.067],
              [18.213, 59.066],
              [18.226, 59.066],
              [18.231, 59.067],
              [18.237, 59.069],
              [18.239, 59.069],
              [18.239, 59.07],
              [18.236, 59.071],
              [18.235, 59.072],
              [18.237, 59.074],
              [18.245, 59.076],
              [18.25, 59.078],
              [18.316, 59.089],
              [18.327, 59.091],
              [18.331, 59.092],
              [18.334, 59.093],
              [18.336, 59.095],
              [18.335, 59.095],
              [18.333, 59.096],
              [18.323, 59.1],
              [18.32, 59.101],
              [18.315, 59.102],
              [18.31, 59.102],
              [18.305, 59.101],
              [18.29, 59.099],
              [18.281, 59.099],
              [18.28, 59.1],
              [18.28, 59.101],
              [18.284, 59.109],
              [18.286, 59.111],
              [18.289, 59.113],
              [18.297, 59.117],
              [18.302, 59.118],
              [18.307, 59.12],
              [18.312, 59.121],
              [18.318, 59.123],
              [18.323, 59.124],
              [18.329, 59.124],
              [18.334, 59.125],
              [18.339, 59.125],
              [18.348, 59.124],
              [18.351, 59.124],
              [18.355, 59.125],
              [18.359, 59.125],
              [18.365, 59.127],
              [18.381, 59.131],
              [18.386, 59.133],
              [18.391, 59.134],
              [18.406, 59.134],
              [18.41, 59.135],
              [18.415, 59.136],
              [18.419, 59.138],
              [18.429, 59.142],
              [18.439, 59.148],
              [18.443, 59.151],
              [18.447, 59.155],
              [18.451, 59.158],
              [18.454, 59.16],
              [18.456, 59.164],
              [18.455, 59.165],
              [18.45, 59.165],
              [18.446, 59.164],
              [18.44, 59.16],
              [18.438, 59.159],
              [18.433, 59.155],
              [18.431, 59.152],
              [18.428, 59.151],
              [18.424, 59.149],
              [18.422, 59.15],
              [18.419, 59.156],
              [18.416, 59.157],
              [18.414, 59.159],
              [18.411, 59.16],
              [18.407, 59.161],
              [18.401, 59.162],
              [18.4, 59.162],
              [18.399, 59.163],
              [18.398, 59.165],
              [18.396, 59.168],
              [18.393, 59.171],
              [18.391, 59.172],
              [18.385, 59.172],
              [18.378, 59.171],
              [18.376, 59.171],
              [18.374, 59.172],
              [18.374, 59.173],
              [18.376, 59.176],
              [18.377, 59.178],
              [18.378, 59.181],
              [18.38, 59.184],
              [18.382, 59.188],
              [18.382, 59.192],
              [18.379, 59.195],
              [18.375, 59.197],
              [18.365, 59.201],
              [18.347, 59.207],
              [18.335, 59.21],
              [18.326, 59.212],
              [18.323, 59.213],
              [18.319, 59.214],
              [18.315, 59.218],
              [18.314, 59.22],
              [18.314, 59.221],
              [18.317, 59.224],
              [18.317, 59.228],
              [18.318, 59.23],
              [18.319, 59.23],
              [18.32, 59.231],
              [18.322, 59.23],
              [18.326, 59.229],
              [18.329, 59.227],
              [18.333, 59.225],
              [18.338, 59.222],
              [18.351, 59.214],
              [18.355, 59.211],
              [18.375, 59.203],
              [18.381, 59.201],
              [18.386, 59.199],
              [18.391, 59.196],
              [18.395, 59.194],
              [18.399, 59.19],
              [18.401, 59.189],
              [18.403, 59.189],
              [18.405, 59.19],
              [18.406, 59.191],
              [18.407, 59.193],
              [18.406, 59.196],
              [18.404, 59.2],
              [18.401, 59.204],
              [18.397, 59.207],
              [18.387, 59.215],
              [18.381, 59.219],
              [18.369, 59.225],
              [18.363, 59.227],
              [18.303, 59.248],
              [18.291, 59.253],
              [18.28, 59.258],
              [18.275, 59.26],
              [18.269, 59.263],
              [18.268, 59.264],
              [18.269, 59.265],
              [18.272, 59.266],
              [18.277, 59.266],
              [18.282, 59.265],
              [18.288, 59.265],
              [18.312, 59.261],
              [18.332, 59.261],
              [18.338, 59.262],
              [18.343, 59.263],
              [18.348, 59.263],
              [18.351, 59.264],
              [18.353, 59.265],
              [18.352, 59.266],
              [18.35, 59.267],
              [18.348, 59.267],
              [18.345, 59.268],
              [18.342, 59.268],
              [18.335, 59.267],
              [18.329, 59.267],
              [18.321, 59.269],
              [18.318, 59.27],
              [18.315, 59.273],
              [18.31, 59.277],
              [18.307, 59.279],
              [18.303, 59.281],
              [18.3, 59.281],
              [18.297, 59.284],
              [18.297, 59.286],
              [18.298, 59.288],
              [18.298, 59.291],
              [18.297, 59.293],
              [18.294, 59.296],
              [18.292, 59.297],
              [18.29, 59.299],
              [18.283, 59.299],
              [18.274, 59.298],
              [18.25, 59.298],
              [18.238, 59.299],
              [18.232, 59.299],
              [18.222, 59.301],
              [18.216, 59.303],
              [18.215, 59.305],
              [18.215, 59.31],
              [18.214, 59.313],
              [18.208, 59.322],
              [18.205, 59.324],
              [18.196, 59.324],
              [18.19, 59.323],
              [18.154, 59.316],
              [18.139, 59.313],
              [18.132, 59.313],
              [18.133, 59.314],
              [18.124, 59.314],
              [18.112, 59.311],
              [18.105, 59.308],
              [18.101, 59.307],
              [18.098, 59.306],
              [18.091, 59.306],
              [18.09, 59.307],
              [18.091, 59.309],
              [18.092, 59.31],
              [18.092, 59.312],
              [18.093, 59.314],
              [18.086, 59.321],
              [18.085, 59.323],
              [18.087, 59.327],
              [18.095, 59.329],
              [18.1, 59.33],
              [18.106, 59.33],
              [18.129, 59.331],
              [18.134, 59.331],
              [18.138, 59.332],
              [18.14, 59.333],
              [18.14, 59.335],
              [18.138, 59.336],
              [18.136, 59.338],
              [18.129, 59.342],
              [18.124, 59.345],
              [18.112, 59.351],
              [18.097, 59.36],
              [18.091, 59.363],
              [18.086, 59.365],
              [18.08, 59.367],
              [18.069, 59.371],
              [18.065, 59.373],
              [18.062, 59.375],
              [18.06, 59.376],
              [18.059, 59.378],
              [18.06, 59.379],
              [18.063, 59.38],
              [18.07, 59.382],
              [18.073, 59.384],
              [18.077, 59.385],
              [18.08, 59.387],
              [18.082, 59.389],
              [18.086, 59.392],
              [18.088, 59.396],
              [18.09, 59.399],
              [18.091, 59.402],
              [18.091, 59.406],
              [18.09, 59.412],
              [18.09, 59.415],
              [18.091, 59.418],
              [18.093, 59.42],
              [18.099, 59.424],
              [18.108, 59.431],
              [18.112, 59.434],
              [18.116, 59.436],
              [18.12, 59.437],
              [18.129, 59.441],
              [18.134, 59.443],
              [18.139, 59.444],
              [18.159, 59.44],
              [18.165, 59.439],
              [18.171, 59.439],
              [18.187, 59.44],
              [18.195, 59.44],
              [18.197, 59.439],
              [18.198, 59.438],
              [18.198, 59.436],
              [18.197, 59.435],
              [18.196, 59.433],
              [18.192, 59.429],
              [18.19, 59.428],
              [18.187, 59.427],
              [18.176, 59.427],
              [18.172, 59.426],
              [18.169, 59.424],
              [18.167, 59.423],
              [18.165, 59.42],
              [18.16, 59.412],
              [18.159, 59.41],
              [18.159, 59.407],
              [18.16, 59.405],
              [18.162, 59.402],
              [18.165, 59.4],
              [18.169, 59.397],
              [18.173, 59.396],
              [18.179, 59.394],
              [18.184, 59.392],
              [18.19, 59.391],
              [18.197, 59.39],
              [18.209, 59.388],
              [18.216, 59.387],
              [18.224, 59.387],
              [18.238, 59.386],
              [18.28, 59.384],
              [18.312, 59.384],
              [18.314, 59.385],
              [18.315, 59.385],
              [18.314, 59.387],
              [18.315, 59.387],
              [18.321, 59.389],
              [18.323, 59.389],
              [18.324, 59.39],
              [18.323, 59.392],
              [18.321, 59.393],
              [18.318, 59.394],
              [18.309, 59.396],
              [18.302, 59.398],
              [18.297, 59.399],
              [18.285, 59.403],
              [18.283, 59.404],
              [18.282, 59.405],
              [18.282, 59.408],
              [18.281, 59.411],
              [18.28, 59.413],
              [18.278, 59.415],
              [18.272, 59.42],
              [18.272, 59.422],
              [18.274, 59.424],
              [18.274, 59.425],
              [18.273, 59.426],
              [18.271, 59.427],
              [18.267, 59.428],
              [18.263, 59.428],
              [18.248, 59.43],
              [18.243, 59.431],
              [18.239, 59.432],
              [18.236, 59.433],
              [18.234, 59.434],
              [18.234, 59.435],
              [18.236, 59.436],
              [18.239, 59.437],
              [18.248, 59.437],
              [18.266, 59.436],
              [18.277, 59.436],
              [18.282, 59.437],
              [18.286, 59.439],
              [18.289, 59.44],
              [18.292, 59.442],
              [18.294, 59.443],
              [18.294, 59.448],
              [18.291, 59.45],
              [18.288, 59.453],
              [18.285, 59.455],
              [18.279, 59.46],
              [18.276, 59.462],
              [18.275, 59.463],
              [18.289, 59.463],
              [18.291, 59.464],
              [18.292, 59.465],
              [18.297, 59.465],
              [18.304, 59.463],
              [18.308, 59.462],
              [18.313, 59.462],
              [18.317, 59.463],
              [18.322, 59.463],
              [18.328, 59.461],
              [18.335, 59.458],
              [18.339, 59.456],
              [18.344, 59.455],
              [18.35, 59.455],
              [18.355, 59.454],
              [18.361, 59.454],
              [18.367, 59.455],
              [18.373, 59.455],
              [18.378, 59.456],
              [18.384, 59.458],
              [18.389, 59.46],
              [18.394, 59.463],
              [18.402, 59.469],
              [18.408, 59.474],
              [18.41, 59.476],
              [18.414, 59.477],
              [18.417, 59.479],
              [18.426, 59.481],
              [18.43, 59.482],
              [18.436, 59.485],
              [18.442, 59.487],
              [18.447, 59.49],
              [18.459, 59.496],
              [18.481, 59.51],
              [18.492, 59.516],
              [18.498, 59.519],
              [18.503, 59.522],
              [18.508, 59.524],
              [18.512, 59.526],
              [18.523, 59.528],
              [18.527, 59.53],
              [18.532, 59.532],
              [18.537, 59.533],
              [18.545, 59.537],
              [18.555, 59.541],
              [18.571, 59.548],
              [18.577, 59.55],
              [18.584, 59.553],
              [18.596, 59.557],
              [18.623, 59.565],
              [18.636, 59.569],
              [18.642, 59.572],
              [18.648, 59.574],
              [18.654, 59.577],
              [18.664, 59.583],
              [18.668, 59.587],
              [18.671, 59.591],
              [18.675, 59.599],
              [18.675, 59.603],
              [18.671, 59.611],
              [18.665, 59.619],
              [18.655, 59.628],
              [18.653, 59.63],
              [18.652, 59.632],
              [18.654, 59.633],
              [18.66, 59.631],
              [18.662, 59.63],
              [18.666, 59.626],
              [18.678, 59.618],
              [18.686, 59.616],
              [18.689, 59.615],
              [18.693, 59.615],
              [18.696, 59.613],
              [18.701, 59.613],
              [18.704, 59.614],
              [18.71, 59.618],
              [18.714, 59.619],
              [18.717, 59.62],
              [18.722, 59.621],
              [18.73, 59.62],
              [18.734, 59.62],
              [18.737, 59.621],
              [18.74, 59.623],
              [18.741, 59.624],
              [18.741, 59.628],
              [18.74, 59.632],
              [18.739, 59.634],
              [18.738, 59.635],
              [18.735, 59.637],
              [18.73, 59.638],
              [18.72, 59.638],
              [18.704, 59.639],
              [18.697, 59.639],
              [18.695, 59.64],
              [18.698, 59.643],
              [18.705, 59.647],
              [18.709, 59.65],
              [18.715, 59.655],
              [18.721, 59.658],
              [18.723, 59.658],
              [18.733, 59.66],
              [18.737, 59.662],
              [18.741, 59.663],
              [18.747, 59.669],
              [18.75, 59.673],
              [18.752, 59.675],
              [18.755, 59.677],
              [18.763, 59.681],
              [18.768, 59.683],
              [18.773, 59.684],
              [18.78, 59.686],
              [18.786, 59.687],
              [18.792, 59.687],
              [18.819, 59.691],
              [18.826, 59.692],
              [18.832, 59.693],
              [18.839, 59.694],
              [18.859, 59.7],
              [18.864, 59.701],
              [18.88, 59.704],
              [18.885, 59.704],
              [18.889, 59.706],
              [18.892, 59.707],
              [18.896, 59.711],
              [18.9, 59.713],
              [18.902, 59.713],
              [18.911, 59.714],
              [18.914, 59.714],
              [18.923, 59.715],
              [18.927, 59.716],
              [18.932, 59.715],
              [18.938, 59.715],
              [18.951, 59.712],
              [18.956, 59.711],
              [18.965, 59.71],
              [18.974, 59.707],
              [18.979, 59.706],
              [18.991, 59.704],
              [19.011, 59.704],
              [19.017, 59.705],
              [19.024, 59.705],
              [19.03, 59.706],
              [19.035, 59.708],
              [19.04, 59.709],
              [19.045, 59.711],
              [19.056, 59.715],
              [19.064, 59.719],
              [19.068, 59.722],
              [19.072, 59.726],
              [19.074, 59.729],
              [19.078, 59.737],
              [19.078, 59.747],
              [19.077, 59.751],
              [19.074, 59.755],
              [19.07, 59.758],
              [19.065, 59.761],
              [19.06, 59.763],
              [19.054, 59.765],
              [19.019, 59.77],
              [18.997, 59.772],
              [18.983, 59.774],
              [18.968, 59.774],
              [18.961, 59.775],
              [18.954, 59.775],
              [18.947, 59.774],
              [18.934, 59.774],
              [18.915, 59.773],
              [18.903, 59.771],
              [18.898, 59.77],
              [18.894, 59.769],
              [18.89, 59.766],
              [18.888, 59.764],
              [18.887, 59.76],
              [18.887, 59.75],
              [18.888, 59.747],
              [18.889, 59.743],
              [18.889, 59.742],
              [18.888, 59.741],
              [18.881, 59.741],
              [18.873, 59.742],
              [18.869, 59.743],
              [18.858, 59.744],
              [18.854, 59.744],
              [18.856, 59.746],
              [18.858, 59.747],
              [18.861, 59.748],
              [18.868, 59.75],
              [18.874, 59.753],
              [18.875, 59.755],
              [18.875, 59.758],
              [18.873, 59.764],
              [18.87, 59.766],
              [18.866, 59.767],
              [18.863, 59.768],
              [18.819, 59.768],
              [18.812, 59.767],
              [18.806, 59.766],
              [18.799, 59.764],
              [18.773, 59.758],
              [18.766, 59.756],
              [18.759, 59.755],
              [18.753, 59.753],
              [18.74, 59.752],
              [18.734, 59.751],
              [18.723, 59.751],
              [18.722, 59.752],
              [18.721, 59.752],
              [18.722, 59.755],
              [18.726, 59.759],
              [18.732, 59.761],
              [18.736, 59.762],
              [18.742, 59.763],
              [18.754, 59.764],
              [18.761, 59.765],
              [18.768, 59.767],
              [18.802, 59.773],
              [18.817, 59.776],
              [18.824, 59.777],
              [18.842, 59.779],
              [18.854, 59.781],
              [18.866, 59.785],
              [18.872, 59.788],
              [18.877, 59.791],
              [18.883, 59.794],
              [18.888, 59.798],
              [18.894, 59.803],
              [18.904, 59.811],
              [18.914, 59.821],
              [19.054, 59.821],
              [19.055, 59.82],
              [19.059, 59.82],
              [19.061, 59.821],
              [22.904, 59.815],
              [22.927, 58.978],
              [22.923, 58.978],
              [22.914, 58.979],
              [22.909, 58.979],
              [22.906, 58.98],
              [22.9, 58.981],
              [22.892, 58.982],
              [22.888, 58.984],
              [22.883, 58.985],
              [22.878, 58.987],
              [22.869, 58.992],
              [22.863, 58.994],
              [22.858, 58.995],
              [22.853, 58.997],
              [22.848, 58.998],
              [22.817, 58.998],
              [22.81, 58.999],
              [22.803, 58.999],
              [22.776, 59.002],
              [22.759, 59.004],
              [22.741, 59.006],
              [22.737, 59.006],
              [22.727, 59.008],
              [22.72, 59.01],
              [22.713, 59.013],
              [22.707, 59.016],
              [22.702, 59.02],
              [22.699, 59.024],
              [22.697, 59.027],
              [22.696, 59.029],
              [22.696, 59.032],
              [22.692, 59.048],
              [22.692, 59.056],
              [22.693, 59.066],
              [22.692, 59.068],
              [22.692, 59.069],
              [22.691, 59.071],
              [22.689, 59.073],
              [22.685, 59.075],
              [22.681, 59.078],
              [22.676, 59.08],
              [22.67, 59.082],
              [22.658, 59.084],
              [22.651, 59.085],
              [22.625, 59.085],
              [22.618, 59.086],
              [22.598, 59.086],
              [22.593, 59.085],
              [22.59, 59.083],
              [22.586, 59.08],
              [22.584, 59.076],
              [22.58, 59.066],
              [22.576, 59.055],
              [22.574, 59.05],
              [22.571, 59.045],
              [22.568, 59.041],
              [22.56, 59.035],
              [22.555, 59.032],
              [22.55, 59.031],
              [22.54, 59.027],
              [22.524, 59.023],
              [22.518, 59.023],
              [22.5, 59.025],
              [22.492, 59.025],
              [22.488, 59.024],
              [22.484, 59.02],
              [22.484, 59.007],
              [22.483, 59.004],
              [22.481, 59.001],
              [22.475, 58.997],
              [22.471, 58.995],
              [22.468, 58.993],
              [22.465, 58.992],
              [22.457, 58.991],
              [22.454, 58.99],
              [22.452, 58.989],
              [22.45, 58.987],
              [22.45, 58.985],
              [22.451, 58.982],
              [22.457, 58.973],
              [22.458, 58.97],
              [22.458, 58.968],
              [22.456, 58.966],
              [22.454, 58.965],
              [22.445, 58.963],
              [22.441, 58.962],
              [22.437, 58.962],
              [22.429, 58.961],
              [22.426, 58.961],
              [22.422, 58.96],
              [22.416, 58.954],
              [22.408, 58.948],
              [22.404, 58.946],
              [22.399, 58.943],
              [22.394, 58.941],
              [22.376, 58.938],
              [22.363, 58.938],
              [22.357, 58.939],
              [22.35, 58.939],
              [22.344, 58.941],
              [22.323, 58.944],
              [22.317, 58.945],
              [22.31, 58.946],
              [22.296, 58.946],
              [22.289, 58.945],
              [22.275, 58.944],
              [22.234, 58.938],
              [22.22, 58.937],
              [22.213, 58.936],
              [22.185, 58.936],
              [22.171, 58.937],
              [22.158, 58.939],
              [22.116, 58.943],
              [22.088, 58.945],
              [22.075, 58.945],
              [22.069, 58.944],
              [22.063, 58.944],
              [22.058, 58.942],
              [22.054, 58.941],
              [22.051, 58.939],
              [22.049, 58.938],
              [22.049, 58.936],
              [22.048, 58.934],
              [22.048, 58.932],
              [22.049, 58.93],
              [22.051, 58.928],
              [22.055, 58.926],
              [22.06, 58.924],
              [22.066, 58.922],
              [22.072, 58.921],
              [22.099, 58.914],
              [22.113, 58.91],
              [22.119, 58.908],
              [22.126, 58.905],
              [22.131, 58.903],
              [22.142, 58.896],
              [22.148, 58.893],
              [22.154, 58.891],
              [22.161, 58.888],
              [22.167, 58.886],
              [22.174, 58.884],
              [22.18, 58.883],
              [22.187, 58.883],
              [22.193, 58.882],
              [22.2, 58.882],
              [22.207, 58.881],
              [22.213, 58.881],
              [22.227, 58.882],
              [22.247, 58.882],
              [22.253, 58.883],
              [22.26, 58.884],
              [22.279, 58.887],
              [22.285, 58.887],
              [22.291, 58.888],
              [22.309, 58.888],
              [22.314, 58.889],
              [22.33, 58.892],
              [22.348, 58.895],
              [22.366, 58.895],
              [22.371, 58.894],
              [22.377, 58.893],
              [22.382, 58.892],
              [22.388, 58.89],
              [22.393, 58.888],
              [22.399, 58.885],
              [22.404, 58.882],
              [22.41, 58.878],
              [22.43, 58.862],
              [22.439, 58.853],
              [22.443, 58.848],
              [22.447, 58.844],
              [22.451, 58.834],
              [22.452, 58.83],
              [22.453, 58.825],
              [22.453, 58.821],
              [22.452, 58.818],
              [22.451, 58.814],
              [22.448, 58.81],
              [22.447, 58.808],
              [22.448, 58.806],
              [22.451, 58.803],
              [22.452, 58.801],
              [22.453, 58.8],
              [22.454, 58.798],
              [22.454, 58.795],
              [22.455, 58.79],
              [22.456, 58.788],
              [22.457, 58.785],
              [22.46, 58.782],
              [22.466, 58.777],
              [22.469, 58.774],
              [22.472, 58.768],
              [22.473, 58.765],
              [22.473, 58.762],
              [22.474, 58.756],
              [22.475, 58.754],
              [22.477, 58.751],
              [22.483, 58.746],
              [22.485, 58.743],
              [22.488, 58.74],
              [22.49, 58.734],
              [22.49, 58.732],
              [22.489, 58.73],
              [22.486, 58.728],
              [22.484, 58.726],
              [22.477, 58.723],
              [22.473, 58.721],
              [22.473, 58.717],
              [22.474, 58.715],
              [22.475, 58.714],
              [22.478, 58.712],
              [22.481, 58.709],
              [22.486, 58.707],
              [22.491, 58.704],
              [22.496, 58.702],
              [22.502, 58.699],
              [22.508, 58.697],
              [22.515, 58.695],
              [22.521, 58.693],
              [22.528, 58.692],
              [22.535, 58.69],
              [22.542, 58.689],
              [22.549, 58.689],
              [22.556, 58.688],
              [22.566, 58.688],
              [22.565, 58.687],
              [22.565, 58.634],
              [22.559, 58.635],
              [22.554, 58.636],
              [22.541, 58.636],
              [22.538, 58.634],
              [22.532, 58.631],
              [22.521, 58.62],
              [22.516, 58.613],
              [22.511, 58.607],
              [22.507, 58.601],
              [22.502, 58.593],
              [22.501, 58.592],
              [22.492, 58.59],
              [22.479, 58.586],
              [22.455, 58.58],
              [22.446, 58.578],
              [22.432, 58.576],
              [22.425, 58.576],
              [22.419, 58.575],
              [22.406, 58.575],
              [22.392, 58.574],
              [22.367, 58.575],
              [22.36, 58.575],
              [22.339, 58.572],
              [22.307, 58.567],
              [22.302, 58.566],
              [22.297, 58.564],
              [22.294, 58.562],
              [22.291, 58.559],
              [22.289, 58.555],
              [22.287, 58.547],
              [22.287, 58.543],
              [22.289, 58.54],
              [22.29, 58.538],
              [22.296, 58.535],
              [22.302, 58.529],
              [22.304, 58.526],
              [22.305, 58.522],
              [22.305, 58.513],
              [22.303, 58.509],
              [22.297, 58.501],
              [22.294, 58.498],
              [22.29, 58.495],
              [22.285, 58.492],
              [22.275, 58.49],
              [22.269, 58.491],
              [22.259, 58.493],
              [22.254, 58.495],
              [22.25, 58.498],
              [22.247, 58.502],
              [22.244, 58.507],
              [22.242, 58.511],
              [22.236, 58.526],
              [22.233, 58.53],
              [22.229, 58.534],
              [22.226, 58.536],
              [22.222, 58.538],
              [22.217, 58.539],
              [22.213, 58.539],
              [22.21, 58.537],
              [22.206, 58.535],
              [22.197, 58.523],
              [22.185, 58.514],
              [22.153, 58.498],
              [22.145, 58.495],
              [22.141, 58.493],
              [22.136, 58.49],
              [22.128, 58.482],
              [22.125, 58.478],
              [22.123, 58.473],
              [22.121, 58.467],
              [22.12, 58.461],
              [22.117, 58.444],
              [22.115, 58.438],
              [22.113, 58.433],
              [22.111, 58.429],
              [22.108, 58.426],
              [22.105, 58.424],
              [22.102, 58.423],
              [22.097, 58.422],
              [22.091, 58.422],
              [22.086, 58.423],
              [22.081, 58.425],
              [22.076, 58.428],
              [22.071, 58.432],
              [22.067, 58.436],
              [22.063, 58.441],
              [22.058, 58.446],
              [22.054, 58.452],
              [22.042, 58.468],
              [22.038, 58.474],
              [22.034, 58.479],
              [22.029, 58.484],
              [22.025, 58.489],
              [22.015, 58.497],
              [22.01, 58.5],
              [22.004, 58.503],
              [21.998, 58.505],
              [21.98, 58.508],
              [21.949, 58.511],
              [21.933, 58.511],
              [21.928, 58.51],
              [21.924, 58.509],
              [21.921, 58.507],
              [21.919, 58.505],
              [21.917, 58.502],
              [21.914, 58.496],
              [21.912, 58.493],
              [21.909, 58.49],
              [21.901, 58.486],
              [21.896, 58.485],
              [21.879, 58.485],
              [21.861, 58.488],
              [21.848, 58.488],
              [21.846, 58.487],
              [21.845, 58.485],
              [21.845, 58.483],
              [21.846, 58.481],
              [21.852, 58.477],
              [21.856, 58.475],
              [21.861, 58.474],
              [21.866, 58.472],
              [21.87, 58.472],
              [21.881, 58.47],
              [21.886, 58.469],
              [21.89, 58.468],
              [21.898, 58.464],
              [21.906, 58.458],
              [21.913, 58.451],
              [21.931, 58.436],
              [21.938, 58.429],
              [21.941, 58.425],
              [21.946, 58.419],
              [21.952, 58.411],
              [21.956, 58.408],
              [21.961, 58.404],
              [21.966, 58.402],
              [21.97, 58.399],
              [21.982, 58.395],
              [21.984, 58.393],
              [21.986, 58.392],
              [21.99, 58.388],
              [21.995, 58.384],
              [21.998, 58.38],
              [22.006, 58.373],
              [22.009, 58.37],
              [22.008, 58.368],
              [22.005, 58.367],
              [21.999, 58.366],
              [21.996, 58.365],
              [21.994, 58.363],
              [21.993, 58.361],
              [21.994, 58.356],
              [21.993, 58.353],
              [21.991, 58.351],
              [21.989, 58.348],
              [21.986, 58.347],
              [21.983, 58.345],
              [21.973, 58.345],
              [21.968, 58.346],
              [21.959, 58.347],
              [21.951, 58.347],
              [21.949, 58.346],
              [21.948, 58.344],
              [21.948, 58.341],
              [21.949, 58.338],
              [21.951, 58.331],
              [21.951, 58.32],
              [21.948, 58.317],
              [21.947, 58.315],
              [21.943, 58.313],
              [21.936, 58.313],
              [21.928, 58.315],
              [21.924, 58.318],
              [21.921, 58.32],
              [21.915, 58.326],
              [21.91, 58.33],
              [21.905, 58.333],
              [21.899, 58.336],
              [21.889, 58.342],
              [21.884, 58.344],
              [21.88, 58.346],
              [21.876, 58.347],
              [21.874, 58.347],
              [21.876, 58.344],
              [21.877, 58.342],
              [21.878, 58.338],
              [21.881, 58.332],
              [21.884, 58.329],
              [21.893, 58.317],
              [21.895, 58.313],
              [21.896, 58.31],
              [21.895, 58.307],
              [21.893, 58.305],
              [21.89, 58.303],
              [21.885, 58.302],
              [21.874, 58.302],
              [21.856, 58.304],
              [21.851, 58.304],
              [21.846, 58.303],
              [21.842, 58.302],
              [21.839, 58.3],
              [21.838, 58.298],
              [21.837, 58.295],
              [21.837, 58.293],
              [21.838, 58.288],
              [21.839, 58.285],
              [21.84, 58.283],
              [21.845, 58.278],
              [21.859, 58.268],
              [21.862, 58.266],
              [21.868, 58.263],
              [21.875, 58.26],
              [21.879, 58.258],
              [21.889, 58.255],
              [21.901, 58.251],
              [21.906, 58.249],
              [21.919, 58.246],
              [21.932, 58.244],
              [21.945, 58.241],
              [21.951, 58.24],
              [21.958, 58.24],
              [21.964, 58.239],
              [21.975, 58.239],
              [21.98, 58.24],
              [21.984, 58.24],
              [21.987, 58.241],
              [21.993, 58.244],
              [22.001, 58.244],
              [22.004, 58.243],
              [22.009, 58.242],
              [22.013, 58.239],
              [22.023, 58.233],
              [22.027, 58.23],
              [22.039, 58.218],
              [22.041, 58.215],
              [22.044, 58.212],
              [22.044, 58.21],
            ],
          ],
        ],
      },
      properties: {
        id: 48,
        name: 'Norra Östersjön',
        latlon: [58.930736, 20.015143],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [22.3, 63.514],
              [20.9, 64.035],
              [20.899, 64.037],
              [20.895, 64.041],
              [20.889, 64.045],
              [20.889, 64.046],
              [20.893, 64.046],
              [20.904, 64.045],
              [20.911, 64.045],
              [20.918, 64.046],
              [20.92, 64.047],
              [20.924, 64.048],
              [20.933, 64.054],
              [20.937, 64.06],
              [20.939, 64.068],
              [20.941, 64.072],
              [20.945, 64.078],
              [20.951, 64.083],
              [20.954, 64.086],
              [20.955, 64.089],
              [20.957, 64.097],
              [20.958, 64.106],
              [20.959, 64.112],
              [20.959, 64.117],
              [20.958, 64.12],
              [20.955, 64.126],
              [20.955, 64.129],
              [20.956, 64.132],
              [20.958, 64.136],
              [20.976, 64.154],
              [20.978, 64.154],
              [20.98, 64.155],
              [20.989, 64.155],
              [20.991, 64.156],
              [20.999, 64.157],
              [21.014, 64.161],
              [21.018, 64.163],
              [21.023, 64.165],
              [21.029, 64.168],
              [21.034, 64.171],
              [21.038, 64.174],
              [21.043, 64.178],
              [21.047, 64.182],
              [21.052, 64.188],
              [21.059, 64.195],
              [21.067, 64.201],
              [21.07, 64.203],
              [21.076, 64.209],
              [21.078, 64.212],
              [21.081, 64.213],
              [21.089, 64.213],
              [21.105, 64.208],
              [21.11, 64.207],
              [21.125, 64.207],
              [21.13, 64.208],
              [21.139, 64.214],
              [21.141, 64.216],
              [21.147, 64.22],
              [21.154, 64.223],
              [21.157, 64.224],
              [21.16, 64.226],
              [21.166, 64.231],
              [21.17, 64.234],
              [21.172, 64.237],
              [21.178, 64.244],
              [21.181, 64.247],
              [21.185, 64.25],
              [21.197, 64.257],
              [21.201, 64.26],
              [21.207, 64.269],
              [21.211, 64.273],
              [21.216, 64.276],
              [21.223, 64.281],
              [21.226, 64.284],
              [21.238, 64.291],
              [21.242, 64.293],
              [21.245, 64.295],
              [21.25, 64.3],
              [21.254, 64.302],
              [21.257, 64.302],
              [21.26, 64.301],
              [21.267, 64.297],
              [21.27, 64.296],
              [21.275, 64.294],
              [21.284, 64.294],
              [21.294, 64.295],
              [21.303, 64.296],
              [21.307, 64.296],
              [21.314, 64.298],
              [21.318, 64.298],
              [21.327, 64.299],
              [21.331, 64.299],
              [21.334, 64.3],
              [21.337, 64.302],
              [21.349, 64.314],
              [21.352, 64.316],
              [21.356, 64.318],
              [21.368, 64.326],
              [21.37, 64.327],
              [21.376, 64.327],
              [21.384, 64.326],
              [21.392, 64.326],
              [21.395, 64.327],
              [21.401, 64.328],
              [21.404, 64.329],
              [21.413, 64.335],
              [21.415, 64.339],
              [21.417, 64.342],
              [21.419, 64.346],
              [21.422, 64.349],
              [21.425, 64.351],
              [21.428, 64.352],
              [21.432, 64.352],
              [21.435, 64.353],
              [21.447, 64.353],
              [21.45, 64.354],
              [21.454, 64.356],
              [21.458, 64.357],
              [21.461, 64.36],
              [21.465, 64.363],
              [21.471, 64.371],
              [21.474, 64.374],
              [21.48, 64.378],
              [21.491, 64.384],
              [21.495, 64.388],
              [21.501, 64.397],
              [21.511, 64.406],
              [21.514, 64.408],
              [21.518, 64.41],
              [21.526, 64.413],
              [21.53, 64.415],
              [21.534, 64.416],
              [21.548, 64.419],
              [21.553, 64.421],
              [21.556, 64.422],
              [21.563, 64.425],
              [21.567, 64.427],
              [21.577, 64.43],
              [21.585, 64.433],
              [21.595, 64.436],
              [21.6, 64.437],
              [21.606, 64.441],
              [21.608, 64.443],
              [21.608, 64.449],
              [21.607, 64.453],
              [21.604, 64.457],
              [21.601, 64.462],
              [21.597, 64.465],
              [21.593, 64.469],
              [21.585, 64.473],
              [21.582, 64.473],
              [21.579, 64.472],
              [21.577, 64.471],
              [21.574, 64.467],
              [21.572, 64.465],
              [21.568, 64.463],
              [21.559, 64.463],
              [21.555, 64.464],
              [21.548, 64.466],
              [21.544, 64.466],
              [21.539, 64.467],
              [21.534, 64.466],
              [21.526, 64.464],
              [21.523, 64.462],
              [21.519, 64.46],
              [21.515, 64.457],
              [21.511, 64.455],
              [21.506, 64.453],
              [21.502, 64.452],
              [21.497, 64.451],
              [21.492, 64.452],
              [21.488, 64.453],
              [21.483, 64.455],
              [21.477, 64.461],
              [21.475, 64.464],
              [21.475, 64.479],
              [21.472, 64.494],
              [21.47, 64.499],
              [21.467, 64.503],
              [21.463, 64.507],
              [21.459, 64.51],
              [21.454, 64.512],
              [21.449, 64.513],
              [21.443, 64.514],
              [21.433, 64.515],
              [21.428, 64.515],
              [21.42, 64.517],
              [21.417, 64.518],
              [21.415, 64.52],
              [21.415, 64.523],
              [21.418, 64.526],
              [21.42, 64.529],
              [21.422, 64.531],
              [21.425, 64.533],
              [21.428, 64.534],
              [21.432, 64.535],
              [21.441, 64.538],
              [21.454, 64.538],
              [21.457, 64.537],
              [21.461, 64.535],
              [21.464, 64.533],
              [21.466, 64.53],
              [21.47, 64.525],
              [21.476, 64.521],
              [21.485, 64.518],
              [21.49, 64.516],
              [21.505, 64.513],
              [21.51, 64.513],
              [21.515, 64.514],
              [21.528, 64.518],
              [21.532, 64.519],
              [21.538, 64.52],
              [21.541, 64.521],
              [21.543, 64.523],
              [21.542, 64.526],
              [21.539, 64.528],
              [21.535, 64.53],
              [21.525, 64.532],
              [21.512, 64.534],
              [21.494, 64.54],
              [21.489, 64.542],
              [21.484, 64.545],
              [21.48, 64.547],
              [21.478, 64.55],
              [21.476, 64.552],
              [21.475, 64.554],
              [21.475, 64.556],
              [21.476, 64.561],
              [21.476, 64.566],
              [21.475, 64.568],
              [21.466, 64.574],
              [21.462, 64.575],
              [21.458, 64.575],
              [21.45, 64.573],
              [21.443, 64.569],
              [21.439, 64.567],
              [21.435, 64.566],
              [21.431, 64.566],
              [21.426, 64.568],
              [21.421, 64.569],
              [21.396, 64.584],
              [21.388, 64.59],
              [21.383, 64.595],
              [21.381, 64.598],
              [21.377, 64.6],
              [21.374, 64.601],
              [21.366, 64.601],
              [21.352, 64.6],
              [21.349, 64.6],
              [21.345, 64.599],
              [21.337, 64.599],
              [21.336, 64.598],
              [21.335, 64.596],
              [21.335, 64.595],
              [21.336, 64.593],
              [21.34, 64.589],
              [21.341, 64.587],
              [21.341, 64.585],
              [21.34, 64.583],
              [21.34, 64.58],
              [21.333, 64.58],
              [21.329, 64.581],
              [21.325, 64.583],
              [21.315, 64.587],
              [21.304, 64.593],
              [21.299, 64.596],
              [21.293, 64.599],
              [21.287, 64.601],
              [21.28, 64.603],
              [21.274, 64.604],
              [21.255, 64.607],
              [21.245, 64.609],
              [21.241, 64.611],
              [21.238, 64.612],
              [21.235, 64.614],
              [21.234, 64.615],
              [21.234, 64.616],
              [21.235, 64.617],
              [21.237, 64.618],
              [21.238, 64.62],
              [21.239, 64.621],
              [21.239, 64.622],
              [21.24, 64.625],
              [21.241, 64.627],
              [21.24, 64.63],
              [21.238, 64.634],
              [21.232, 64.642],
              [21.228, 64.646],
              [21.223, 64.649],
              [21.219, 64.651],
              [21.214, 64.652],
              [21.192, 64.658],
              [21.178, 64.661],
              [21.158, 64.667],
              [21.138, 64.672],
              [21.127, 64.676],
              [21.117, 64.68],
              [21.114, 64.681],
              [21.112, 64.682],
              [21.112, 64.683],
              [21.113, 64.684],
              [21.115, 64.684],
              [21.119, 64.686],
              [21.122, 64.686],
              [21.125, 64.685],
              [21.133, 64.681],
              [21.138, 64.679],
              [21.144, 64.677],
              [21.151, 64.675],
              [21.157, 64.673],
              [21.171, 64.671],
              [21.183, 64.669],
              [21.19, 64.669],
              [21.193, 64.67],
              [21.194, 64.67],
              [21.196, 64.672],
              [21.196, 64.673],
              [21.195, 64.675],
              [21.192, 64.678],
              [21.189, 64.68],
              [21.184, 64.683],
              [21.18, 64.685],
              [21.17, 64.687],
              [21.161, 64.688],
              [21.157, 64.688],
              [21.153, 64.69],
              [21.149, 64.694],
              [21.149, 64.695],
              [21.15, 64.697],
              [21.152, 64.699],
              [21.153, 64.702],
              [21.153, 64.703],
              [21.157, 64.705],
              [21.169, 64.702],
              [21.184, 64.695],
              [21.208, 64.687],
              [21.213, 64.686],
              [21.223, 64.683],
              [21.227, 64.682],
              [21.242, 64.677],
              [21.257, 64.671],
              [21.265, 64.669],
              [21.271, 64.669],
              [21.269, 64.671],
              [21.266, 64.673],
              [21.256, 64.678],
              [21.255, 64.68],
              [21.256, 64.68],
              [21.259, 64.681],
              [21.262, 64.681],
              [21.27, 64.68],
              [21.277, 64.68],
              [21.28, 64.681],
              [21.281, 64.682],
              [21.281, 64.684],
              [21.28, 64.686],
              [21.278, 64.689],
              [21.274, 64.692],
              [21.265, 64.698],
              [21.26, 64.702],
              [21.25, 64.709],
              [21.24, 64.717],
              [21.229, 64.728],
              [21.228, 64.732],
              [21.228, 64.735],
              [21.229, 64.737],
              [21.232, 64.739],
              [21.24, 64.743],
              [21.25, 64.745],
              [21.274, 64.749],
              [21.282, 64.751],
              [21.284, 64.753],
              [21.284, 64.755],
              [21.283, 64.758],
              [21.281, 64.761],
              [21.278, 64.764],
              [21.274, 64.766],
              [21.269, 64.769],
              [21.259, 64.773],
              [21.253, 64.775],
              [21.248, 64.777],
              [21.234, 64.779],
              [21.2, 64.779],
              [21.182, 64.777],
              [21.175, 64.776],
              [21.167, 64.776],
              [21.16, 64.777],
              [21.153, 64.777],
              [21.139, 64.778],
              [21.118, 64.78],
              [21.104, 64.782],
              [21.098, 64.783],
              [21.088, 64.785],
              [21.082, 64.788],
              [21.082, 64.789],
              [21.083, 64.79],
              [21.086, 64.791],
              [21.09, 64.791],
              [21.098, 64.792],
              [21.102, 64.792],
              [21.106, 64.793],
              [21.108, 64.794],
              [21.109, 64.795],
              [21.109, 64.798],
              [21.107, 64.802],
              [21.106, 64.803],
              [21.104, 64.804],
              [21.101, 64.806],
              [21.098, 64.807],
              [21.09, 64.808],
              [21.084, 64.81],
              [21.079, 64.812],
              [21.06, 64.819],
              [21.053, 64.821],
              [21.047, 64.823],
              [21.03, 64.828],
              [21.02, 64.832],
              [21.014, 64.835],
              [21.009, 64.84],
              [21.008, 64.842],
              [21.011, 64.845],
              [21.013, 64.846],
              [21.015, 64.848],
              [21.02, 64.852],
              [21.022, 64.854],
              [21.025, 64.856],
              [21.037, 64.86],
              [21.042, 64.862],
              [21.046, 64.862],
              [21.05, 64.863],
              [21.056, 64.861],
              [21.058, 64.859],
              [21.06, 64.853],
              [21.063, 64.849],
              [21.066, 64.846],
              [21.069, 64.842],
              [21.084, 64.833],
              [21.09, 64.831],
              [21.097, 64.829],
              [21.109, 64.825],
              [21.116, 64.824],
              [21.122, 64.822],
              [21.129, 64.821],
              [21.135, 64.821],
              [21.14, 64.82],
              [21.145, 64.821],
              [21.149, 64.822],
              [21.152, 64.824],
              [21.158, 64.829],
              [21.17, 64.837],
              [21.172, 64.841],
              [21.171, 64.843],
              [21.168, 64.852],
              [21.169, 64.854],
              [21.17, 64.857],
              [21.172, 64.859],
              [21.174, 64.86],
              [21.178, 64.861],
              [21.181, 64.862],
              [21.194, 64.862],
              [21.199, 64.863],
              [21.207, 64.864],
              [21.21, 64.865],
              [21.212, 64.866],
              [21.212, 64.87],
              [21.211, 64.872],
              [21.212, 64.874],
              [21.212, 64.881],
              [21.21, 64.887],
              [21.209, 64.889],
              [21.21, 64.891],
              [21.212, 64.893],
              [21.214, 64.893],
              [21.218, 64.894],
              [21.228, 64.894],
              [21.23, 64.895],
              [21.232, 64.901],
              [21.233, 64.903],
              [21.233, 64.905],
              [21.232, 64.907],
              [21.232, 64.909],
              [21.233, 64.911],
              [21.235, 64.913],
              [21.237, 64.916],
              [21.242, 64.921],
              [21.244, 64.925],
              [21.244, 64.927],
              [21.24, 64.935],
              [21.241, 64.938],
              [21.243, 64.94],
              [21.246, 64.942],
              [21.25, 64.944],
              [21.26, 64.948],
              [21.277, 64.952],
              [21.282, 64.954],
              [21.287, 64.955],
              [21.292, 64.955],
              [21.305, 64.957],
              [21.309, 64.957],
              [21.314, 64.958],
              [21.317, 64.958],
              [21.329, 64.96],
              [21.34, 64.96],
              [21.356, 64.958],
              [21.363, 64.958],
              [21.368, 64.959],
              [21.371, 64.959],
              [21.373, 64.96],
              [21.374, 64.961],
              [21.368, 64.967],
              [21.358, 64.974],
              [21.355, 64.976],
              [21.353, 64.98],
              [21.353, 64.981],
              [21.354, 64.982],
              [21.355, 64.985],
              [21.356, 64.987],
              [21.358, 64.988],
              [21.361, 64.988],
              [21.368, 64.99],
              [21.372, 64.991],
              [21.378, 64.992],
              [21.38, 64.992],
              [21.382, 64.994],
              [21.384, 64.995],
              [21.389, 65],
              [21.389, 65.001],
              [21.391, 65.004],
              [21.392, 65.006],
              [21.394, 65.008],
              [21.397, 65.014],
              [21.398, 65.015],
              [21.401, 65.016],
              [21.405, 65.016],
              [21.414, 65.015],
              [21.419, 65.015],
              [21.44, 65.016],
              [21.446, 65.016],
              [21.456, 65.018],
              [21.46, 65.02],
              [21.462, 65.022],
              [21.463, 65.024],
              [21.464, 65.027],
              [21.466, 65.031],
              [21.466, 65.033],
              [21.465, 65.036],
              [21.461, 65.042],
              [21.457, 65.046],
              [21.455, 65.05],
              [21.453, 65.058],
              [21.454, 65.061],
              [21.457, 65.063],
              [21.461, 65.065],
              [21.466, 65.066],
              [21.475, 65.066],
              [21.491, 65.064],
              [21.507, 65.064],
              [21.519, 65.062],
              [21.529, 65.062],
              [21.532, 65.063],
              [21.535, 65.065],
              [21.536, 65.067],
              [21.536, 65.069],
              [21.532, 65.075],
              [21.523, 65.084],
              [21.521, 65.087],
              [21.521, 65.092],
              [21.525, 65.097],
              [21.526, 65.1],
              [21.528, 65.103],
              [21.528, 65.105],
              [21.529, 65.111],
              [21.53, 65.114],
              [21.53, 65.117],
              [21.529, 65.119],
              [21.528, 65.124],
              [21.528, 65.126],
              [21.526, 65.128],
              [21.521, 65.135],
              [21.52, 65.137],
              [21.52, 65.139],
              [21.522, 65.14],
              [21.525, 65.141],
              [21.535, 65.141],
              [21.559, 65.14],
              [21.565, 65.14],
              [21.571, 65.141],
              [21.576, 65.141],
              [21.582, 65.145],
              [21.583, 65.148],
              [21.582, 65.152],
              [21.58, 65.156],
              [21.578, 65.161],
              [21.575, 65.167],
              [21.571, 65.172],
              [21.568, 65.177],
              [21.564, 65.183],
              [21.56, 65.188],
              [21.555, 65.192],
              [21.551, 65.197],
              [21.542, 65.206],
              [21.539, 65.208],
              [21.536, 65.213],
              [21.534, 65.217],
              [21.531, 65.221],
              [21.525, 65.227],
              [21.512, 65.237],
              [21.506, 65.242],
              [21.502, 65.244],
              [21.49, 65.252],
              [21.487, 65.255],
              [21.484, 65.257],
              [21.478, 65.266],
              [21.475, 65.27],
              [21.471, 65.273],
              [21.468, 65.277],
              [21.464, 65.28],
              [21.459, 65.283],
              [21.45, 65.287],
              [21.446, 65.29],
              [21.436, 65.296],
              [21.431, 65.298],
              [21.426, 65.301],
              [21.414, 65.306],
              [21.408, 65.308],
              [21.376, 65.324],
              [21.372, 65.325],
              [21.369, 65.326],
              [21.367, 65.326],
              [21.361, 65.322],
              [21.349, 65.319],
              [21.344, 65.319],
              [21.338, 65.318],
              [21.312, 65.318],
              [21.305, 65.319],
              [21.299, 65.32],
              [21.292, 65.321],
              [21.287, 65.322],
              [21.272, 65.324],
              [21.267, 65.325],
              [21.264, 65.326],
              [21.258, 65.329],
              [21.255, 65.33],
              [21.246, 65.332],
              [21.244, 65.334],
              [21.248, 65.336],
              [21.252, 65.337],
              [21.257, 65.338],
              [21.262, 65.34],
              [21.268, 65.341],
              [21.283, 65.344],
              [21.287, 65.345],
              [21.295, 65.349],
              [21.297, 65.352],
              [21.297, 65.36],
              [21.296, 65.365],
              [21.294, 65.373],
              [21.293, 65.376],
              [21.294, 65.378],
              [21.296, 65.379],
              [21.3, 65.38],
              [21.304, 65.379],
              [21.309, 65.378],
              [21.319, 65.374],
              [21.329, 65.369],
              [21.334, 65.366],
              [21.336, 65.363],
              [21.342, 65.357],
              [21.346, 65.355],
              [21.35, 65.352],
              [21.359, 65.348],
              [21.364, 65.344],
              [21.394, 65.328],
              [21.4, 65.324],
              [21.406, 65.321],
              [21.418, 65.317],
              [21.425, 65.315],
              [21.437, 65.313],
              [21.444, 65.313],
              [21.461, 65.312],
              [21.466, 65.311],
              [21.47, 65.311],
              [21.472, 65.31],
              [21.475, 65.304],
              [21.476, 65.301],
              [21.48, 65.295],
              [21.484, 65.288],
              [21.486, 65.285],
              [21.489, 65.282],
              [21.497, 65.276],
              [21.506, 65.27],
              [21.511, 65.267],
              [21.515, 65.264],
              [21.518, 65.261],
              [21.52, 65.258],
              [21.522, 65.25],
              [21.522, 65.243],
              [21.524, 65.237],
              [21.527, 65.235],
              [21.53, 65.234],
              [21.534, 65.233],
              [21.54, 65.233],
              [21.573, 65.239],
              [21.58, 65.24],
              [21.586, 65.241],
              [21.593, 65.242],
              [21.606, 65.242],
              [21.612, 65.241],
              [21.622, 65.239],
              [21.626, 65.237],
              [21.644, 65.232],
              [21.668, 65.22],
              [21.674, 65.216],
              [21.686, 65.21],
              [21.693, 65.208],
              [21.699, 65.206],
              [21.706, 65.204],
              [21.718, 65.2],
              [21.724, 65.199],
              [21.734, 65.197],
              [21.738, 65.198],
              [21.74, 65.199],
              [21.741, 65.201],
              [21.74, 65.205],
              [21.738, 65.208],
              [21.735, 65.212],
              [21.727, 65.218],
              [21.722, 65.221],
              [21.717, 65.223],
              [21.711, 65.225],
              [21.706, 65.227],
              [21.7, 65.229],
              [21.69, 65.231],
              [21.688, 65.232],
              [21.672, 65.234],
              [21.663, 65.234],
              [21.658, 65.235],
              [21.654, 65.237],
              [21.65, 65.238],
              [21.647, 65.24],
              [21.645, 65.241],
              [21.644, 65.242],
              [21.645, 65.244],
              [21.645, 65.249],
              [21.647, 65.253],
              [21.65, 65.256],
              [21.653, 65.258],
              [21.66, 65.264],
              [21.664, 65.267],
              [21.673, 65.279],
              [21.683, 65.289],
              [21.687, 65.292],
              [21.693, 65.296],
              [21.698, 65.301],
              [21.699, 65.304],
              [21.699, 65.307],
              [21.698, 65.309],
              [21.696, 65.312],
              [21.69, 65.316],
              [21.686, 65.318],
              [21.682, 65.319],
              [21.679, 65.32],
              [21.676, 65.32],
              [21.674, 65.319],
              [21.673, 65.318],
              [21.674, 65.316],
              [21.674, 65.311],
              [21.673, 65.31],
              [21.67, 65.303],
              [21.666, 65.299],
              [21.662, 65.297],
              [21.658, 65.296],
              [21.647, 65.296],
              [21.641, 65.297],
              [21.611, 65.307],
              [21.601, 65.312],
              [21.596, 65.314],
              [21.593, 65.316],
              [21.59, 65.317],
              [21.589, 65.318],
              [21.591, 65.319],
              [21.614, 65.319],
              [21.619, 65.32],
              [21.622, 65.321],
              [21.624, 65.322],
              [21.626, 65.326],
              [21.625, 65.328],
              [21.624, 65.329],
              [21.621, 65.331],
              [21.616, 65.333],
              [21.612, 65.333],
              [21.606, 65.334],
              [21.592, 65.333],
              [21.581, 65.333],
              [21.569, 65.335],
              [21.552, 65.335],
              [21.547, 65.334],
              [21.531, 65.328],
              [21.526, 65.327],
              [21.52, 65.325],
              [21.515, 65.324],
              [21.509, 65.323],
              [21.504, 65.323],
              [21.5, 65.324],
              [21.498, 65.325],
              [21.495, 65.326],
              [21.49, 65.33],
              [21.487, 65.333],
              [21.483, 65.335],
              [21.47, 65.343],
              [21.462, 65.347],
              [21.457, 65.352],
              [21.456, 65.354],
              [21.452, 65.358],
              [21.454, 65.359],
              [21.457, 65.36],
              [21.471, 65.361],
              [21.476, 65.362],
              [21.48, 65.363],
              [21.483, 65.365],
              [21.484, 65.366],
              [21.484, 65.368],
              [21.482, 65.37],
              [21.48, 65.371],
              [21.477, 65.372],
              [21.47, 65.375],
              [21.468, 65.376],
              [21.463, 65.381],
              [21.464, 65.383],
              [21.465, 65.384],
              [21.468, 65.385],
              [21.472, 65.385],
              [21.477, 65.386],
              [21.482, 65.385],
              [21.493, 65.385],
              [21.523, 65.38],
              [21.527, 65.379],
              [21.53, 65.379],
              [21.53, 65.38],
              [21.531, 65.38],
              [21.53, 65.381],
              [21.522, 65.385],
              [21.519, 65.386],
              [21.515, 65.39],
              [21.513, 65.394],
              [21.508, 65.399],
              [21.509, 65.4],
              [21.517, 65.4],
              [21.521, 65.399],
              [21.531, 65.397],
              [21.542, 65.394],
              [21.548, 65.392],
              [21.553, 65.39],
              [21.565, 65.384],
              [21.577, 65.375],
              [21.58, 65.372],
              [21.583, 65.368],
              [21.587, 65.362],
              [21.59, 65.359],
              [21.594, 65.356],
              [21.599, 65.353],
              [21.604, 65.351],
              [21.61, 65.349],
              [21.615, 65.348],
              [21.627, 65.346],
              [21.646, 65.346],
              [21.656, 65.344],
              [21.669, 65.342],
              [21.671, 65.342],
              [21.672, 65.343],
              [21.671, 65.344],
              [21.668, 65.345],
              [21.66, 65.35],
              [21.623, 65.367],
              [21.61, 65.374],
              [21.603, 65.377],
              [21.591, 65.385],
              [21.585, 65.388],
              [21.581, 65.393],
              [21.576, 65.397],
              [21.573, 65.402],
              [21.57, 65.406],
              [21.568, 65.414],
              [21.569, 65.417],
              [21.571, 65.419],
              [21.574, 65.42],
              [21.579, 65.42],
              [21.589, 65.418],
              [21.595, 65.417],
              [21.614, 65.411],
              [21.62, 65.409],
              [21.627, 65.408],
              [21.633, 65.407],
              [21.645, 65.407],
              [21.65, 65.408],
              [21.658, 65.41],
              [21.661, 65.412],
              [21.665, 65.416],
              [21.671, 65.418],
              [21.674, 65.418],
              [21.684, 65.416],
              [21.69, 65.415],
              [21.695, 65.413],
              [21.714, 65.407],
              [21.72, 65.406],
              [21.726, 65.404],
              [21.732, 65.403],
              [21.753, 65.399],
              [21.758, 65.399],
              [21.764, 65.398],
              [21.795, 65.398],
              [21.812, 65.396],
              [21.821, 65.396],
              [21.825, 65.397],
              [21.831, 65.4],
              [21.834, 65.401],
              [21.842, 65.404],
              [21.846, 65.406],
              [21.851, 65.408],
              [21.854, 65.409],
              [21.858, 65.409],
              [21.862, 65.408],
              [21.877, 65.405],
              [21.891, 65.405],
              [21.902, 65.404],
              [21.911, 65.404],
              [21.915, 65.405],
              [21.919, 65.409],
              [21.92, 65.412],
              [21.919, 65.415],
              [21.911, 65.427],
              [21.909, 65.429],
              [21.909, 65.432],
              [21.91, 65.434],
              [21.912, 65.435],
              [21.914, 65.437],
              [21.924, 65.442],
              [21.926, 65.444],
              [21.932, 65.444],
              [21.947, 65.438],
              [21.952, 65.435],
              [21.974, 65.422],
              [21.982, 65.418],
              [21.985, 65.417],
              [21.986, 65.417],
              [21.988, 65.419],
              [21.993, 65.422],
              [21.995, 65.424],
              [21.999, 65.43],
              [22.005, 65.442],
              [22.008, 65.447],
              [22.012, 65.451],
              [22.015, 65.455],
              [22.024, 65.463],
              [22.025, 65.465],
              [22.023, 65.467],
              [22.02, 65.468],
              [22.016, 65.469],
              [22.011, 65.47],
              [22, 65.471],
              [21.994, 65.471],
              [21.988, 65.472],
              [21.981, 65.474],
              [21.975, 65.476],
              [21.968, 65.478],
              [21.956, 65.484],
              [21.949, 65.488],
              [21.924, 65.502],
              [21.918, 65.505],
              [21.913, 65.508],
              [21.907, 65.51],
              [21.902, 65.512],
              [21.898, 65.513],
              [21.889, 65.513],
              [21.887, 65.512],
              [21.886, 65.511],
              [21.887, 65.509],
              [21.896, 65.5],
              [21.897, 65.498],
              [21.898, 65.497],
              [21.896, 65.497],
              [21.893, 65.498],
              [21.885, 65.501],
              [21.874, 65.506],
              [21.863, 65.51],
              [21.849, 65.517],
              [21.846, 65.519],
              [21.845, 65.52],
              [21.846, 65.522],
              [21.849, 65.522],
              [21.852, 65.523],
              [21.861, 65.524],
              [21.865, 65.524],
              [21.868, 65.525],
              [21.873, 65.528],
              [21.875, 65.529],
              [21.882, 65.529],
              [21.904, 65.526],
              [21.952, 65.522],
              [21.965, 65.521],
              [21.979, 65.519],
              [21.992, 65.517],
              [21.999, 65.516],
              [22.029, 65.516],
              [22.035, 65.515],
              [22.04, 65.515],
              [22.055, 65.513],
              [22.064, 65.513],
              [22.068, 65.514],
              [22.077, 65.518],
              [22.081, 65.52],
              [22.086, 65.521],
              [22.103, 65.521],
              [22.109, 65.52],
              [22.114, 65.519],
              [22.125, 65.517],
              [22.13, 65.516],
              [22.134, 65.516],
              [22.137, 65.517],
              [22.139, 65.517],
              [22.144, 65.519],
              [22.152, 65.523],
              [22.156, 65.526],
              [22.171, 65.538],
              [22.174, 65.541],
              [22.175, 65.543],
              [22.175, 65.545],
              [22.169, 65.548],
              [22.163, 65.549],
              [22.159, 65.55],
              [22.154, 65.552],
              [22.15, 65.554],
              [22.146, 65.558],
              [22.141, 65.561],
              [22.137, 65.564],
              [22.117, 65.576],
              [22.111, 65.578],
              [22.104, 65.58],
              [22.098, 65.581],
              [22.077, 65.584],
              [22.049, 65.587],
              [22.036, 65.588],
              [22.029, 65.589],
              [22.022, 65.591],
              [22.015, 65.592],
              [21.997, 65.598],
              [21.992, 65.601],
              [21.986, 65.603],
              [21.981, 65.606],
              [21.975, 65.609],
              [21.97, 65.613],
              [21.954, 65.624],
              [21.948, 65.627],
              [21.943, 65.631],
              [21.925, 65.64],
              [21.918, 65.642],
              [21.893, 65.65],
              [21.882, 65.653],
              [21.878, 65.655],
              [21.873, 65.656],
              [21.859, 65.659],
              [21.853, 65.66],
              [21.835, 65.666],
              [21.83, 65.668],
              [21.824, 65.671],
              [21.818, 65.675],
              [21.813, 65.679],
              [21.807, 65.683],
              [21.802, 65.687],
              [21.791, 65.696],
              [21.781, 65.705],
              [21.776, 65.71],
              [21.771, 65.714],
              [21.767, 65.719],
              [21.762, 65.724],
              [21.755, 65.733],
              [21.752, 65.737],
              [21.748, 65.741],
              [21.733, 65.75],
              [21.709, 65.761],
              [21.704, 65.764],
              [21.699, 65.768],
              [21.694, 65.771],
              [21.691, 65.774],
              [21.687, 65.777],
              [21.681, 65.785],
              [21.679, 65.788],
              [21.678, 65.792],
              [21.677, 65.794],
              [21.678, 65.795],
              [21.679, 65.795],
              [21.683, 65.793],
              [21.689, 65.787],
              [21.696, 65.779],
              [21.7, 65.775],
              [21.705, 65.771],
              [21.71, 65.768],
              [21.734, 65.756],
              [21.745, 65.752],
              [21.751, 65.749],
              [21.766, 65.74],
              [21.778, 65.728],
              [21.788, 65.72],
              [21.794, 65.716],
              [21.816, 65.7],
              [21.826, 65.692],
              [21.838, 65.683],
              [21.843, 65.68],
              [21.849, 65.677],
              [21.861, 65.673],
              [21.868, 65.672],
              [21.888, 65.668],
              [21.902, 65.664],
              [21.908, 65.662],
              [21.915, 65.66],
              [21.934, 65.653],
              [21.94, 65.651],
              [21.947, 65.649],
              [21.952, 65.648],
              [21.969, 65.645],
              [21.975, 65.644],
              [21.98, 65.643],
              [21.992, 65.639],
              [21.997, 65.637],
              [22.007, 65.631],
              [22.015, 65.623],
              [22.018, 65.618],
              [22.024, 65.609],
              [22.027, 65.604],
              [22.039, 65.595],
              [22.044, 65.593],
              [22.054, 65.591],
              [22.059, 65.591],
              [22.069, 65.593],
              [22.073, 65.594],
              [22.076, 65.596],
              [22.078, 65.597],
              [22.078, 65.599],
              [22.077, 65.601],
              [22.074, 65.605],
              [22.073, 65.606],
              [22.072, 65.608],
              [22.073, 65.609],
              [22.075, 65.61],
              [22.078, 65.611],
              [22.082, 65.611],
              [22.092, 65.609],
              [22.098, 65.607],
              [22.103, 65.606],
              [22.115, 65.602],
              [22.125, 65.598],
              [22.129, 65.596],
              [22.133, 65.593],
              [22.136, 65.59],
              [22.136, 65.588],
              [22.135, 65.586],
              [22.135, 65.584],
              [22.139, 65.582],
              [22.147, 65.58],
              [22.162, 65.577],
              [22.174, 65.573],
              [22.192, 65.564],
              [22.199, 65.561],
              [22.205, 65.558],
              [22.219, 65.554],
              [22.226, 65.553],
              [22.233, 65.551],
              [22.247, 65.549],
              [22.26, 65.548],
              [22.284, 65.548],
              [22.288, 65.549],
              [22.29, 65.55],
              [22.291, 65.551],
              [22.292, 65.553],
              [22.291, 65.556],
              [22.292, 65.557],
              [22.294, 65.557],
              [22.296, 65.558],
              [22.319, 65.558],
              [22.325, 65.557],
              [22.332, 65.556],
              [22.338, 65.554],
              [22.345, 65.552],
              [22.365, 65.547],
              [22.371, 65.545],
              [22.383, 65.543],
              [22.387, 65.543],
              [22.391, 65.545],
              [22.393, 65.547],
              [22.393, 65.553],
              [22.392, 65.556],
              [22.39, 65.56],
              [22.387, 65.564],
              [22.383, 65.567],
              [22.379, 65.571],
              [22.374, 65.574],
              [22.356, 65.583],
              [22.349, 65.586],
              [22.324, 65.594],
              [22.318, 65.596],
              [22.314, 65.598],
              [22.311, 65.599],
              [22.31, 65.601],
              [22.31, 65.602],
              [22.312, 65.604],
              [22.319, 65.607],
              [22.323, 65.608],
              [22.328, 65.613],
              [22.33, 65.616],
              [22.331, 65.618],
              [22.332, 65.622],
              [22.333, 65.623],
              [22.341, 65.623],
              [22.353, 65.621],
              [22.358, 65.62],
              [22.365, 65.62],
              [22.369, 65.621],
              [22.371, 65.622],
              [22.372, 65.624],
              [22.372, 65.626],
              [22.371, 65.628],
              [22.369, 65.63],
              [22.365, 65.633],
              [22.355, 65.637],
              [22.35, 65.638],
              [22.344, 65.64],
              [22.323, 65.64],
              [22.32, 65.641],
              [22.318, 65.642],
              [22.316, 65.646],
              [22.316, 65.647],
              [22.317, 65.649],
              [22.317, 65.651],
              [22.314, 65.654],
              [22.306, 65.658],
              [22.301, 65.659],
              [22.296, 65.661],
              [22.291, 65.662],
              [22.285, 65.663],
              [22.281, 65.663],
              [22.273, 65.661],
              [22.272, 65.658],
              [22.271, 65.654],
              [22.271, 65.65],
              [22.273, 65.642],
              [22.275, 65.639],
              [22.279, 65.634],
              [22.281, 65.632],
              [22.281, 65.631],
              [22.279, 65.629],
              [22.276, 65.629],
              [22.267, 65.632],
              [22.262, 65.635],
              [22.254, 65.643],
              [22.251, 65.648],
              [22.247, 65.653],
              [22.245, 65.657],
              [22.243, 65.662],
              [22.243, 65.668],
              [22.244, 65.67],
              [22.246, 65.673],
              [22.249, 65.676],
              [22.255, 65.68],
              [22.257, 65.682],
              [22.259, 65.685],
              [22.26, 65.687],
              [22.261, 65.69],
              [22.263, 65.692],
              [22.272, 65.698],
              [22.275, 65.698],
              [22.278, 65.699],
              [22.281, 65.698],
              [22.285, 65.695],
              [22.29, 65.693],
              [22.294, 65.689],
              [22.314, 65.673],
              [22.324, 65.667],
              [22.328, 65.665],
              [22.333, 65.664],
              [22.344, 65.664],
              [22.35, 65.666],
              [22.354, 65.667],
              [22.357, 65.669],
              [22.36, 65.67],
              [22.362, 65.672],
              [22.362, 65.678],
              [22.36, 65.687],
              [22.359, 65.69],
              [22.357, 65.693],
              [22.354, 65.696],
              [22.351, 65.698],
              [22.344, 65.703],
              [22.34, 65.705],
              [22.328, 65.715],
              [22.325, 65.717],
              [22.323, 65.72],
              [22.323, 65.723],
              [22.325, 65.729],
              [22.334, 65.738],
              [22.336, 65.741],
              [22.337, 65.745],
              [22.337, 65.748],
              [22.335, 65.752],
              [22.331, 65.756],
              [22.328, 65.76],
              [22.323, 65.763],
              [22.313, 65.771],
              [22.311, 65.773],
              [22.31, 65.775],
              [22.311, 65.776],
              [22.314, 65.778],
              [22.317, 65.779],
              [22.325, 65.781],
              [22.338, 65.784],
              [22.341, 65.784],
              [22.342, 65.786],
              [22.342, 65.788],
              [22.341, 65.79],
              [22.339, 65.792],
              [22.332, 65.8],
              [22.331, 65.801],
              [22.33, 65.803],
              [22.334, 65.803],
              [22.346, 65.8],
              [22.357, 65.8],
              [22.359, 65.801],
              [22.36, 65.803],
              [22.359, 65.807],
              [22.358, 65.81],
              [22.355, 65.815],
              [22.352, 65.819],
              [22.348, 65.823],
              [22.344, 65.826],
              [22.34, 65.83],
              [22.335, 65.833],
              [22.323, 65.84],
              [22.32, 65.841],
              [22.32, 65.843],
              [22.326, 65.843],
              [22.335, 65.842],
              [22.34, 65.841],
              [22.344, 65.842],
              [22.348, 65.842],
              [22.352, 65.843],
              [22.356, 65.845],
              [22.357, 65.848],
              [22.357, 65.858],
              [22.358, 65.86],
              [22.376, 65.866],
              [22.379, 65.866],
              [22.399, 65.862],
              [22.405, 65.862],
              [22.43, 65.861],
              [22.437, 65.861],
              [22.442, 65.86],
              [22.448, 65.859],
              [22.453, 65.858],
              [22.458, 65.858],
              [22.464, 65.856],
              [22.466, 65.855],
              [22.466, 65.854],
              [22.462, 65.852],
              [22.461, 65.851],
              [22.461, 65.85],
              [22.462, 65.848],
              [22.465, 65.846],
              [22.469, 65.843],
              [22.473, 65.841],
              [22.49, 65.831],
              [22.495, 65.828],
              [22.501, 65.825],
              [22.506, 65.821],
              [22.51, 65.818],
              [22.513, 65.814],
              [22.515, 65.81],
              [22.515, 65.803],
              [22.513, 65.799],
              [22.511, 65.796],
              [22.51, 65.794],
              [22.508, 65.791],
              [22.508, 65.787],
              [22.512, 65.783],
              [22.516, 65.781],
              [22.524, 65.779],
              [22.534, 65.779],
              [22.538, 65.78],
              [22.542, 65.78],
              [22.55, 65.782],
              [22.559, 65.785],
              [22.566, 65.788],
              [22.57, 65.789],
              [22.574, 65.791],
              [22.589, 65.794],
              [22.597, 65.796],
              [22.601, 65.798],
              [22.602, 65.801],
              [22.606, 65.803],
              [22.614, 65.803],
              [22.624, 65.801],
              [22.63, 65.798],
              [22.635, 65.796],
              [22.641, 65.793],
              [22.661, 65.782],
              [22.665, 65.78],
              [22.668, 65.778],
              [22.669, 65.776],
              [22.669, 65.771],
              [22.668, 65.769],
              [22.666, 65.767],
              [22.664, 65.763],
              [22.664, 65.761],
              [22.668, 65.757],
              [22.671, 65.756],
              [22.681, 65.756],
              [22.685, 65.757],
              [22.688, 65.758],
              [22.691, 65.76],
              [22.693, 65.762],
              [22.694, 65.764],
              [22.695, 65.77],
              [22.695, 65.778],
              [22.696, 65.78],
              [22.697, 65.783],
              [22.702, 65.787],
              [22.707, 65.792],
              [22.707, 65.796],
              [22.708, 65.799],
              [22.707, 65.806],
              [22.707, 65.809],
              [22.708, 65.812],
              [22.711, 65.818],
              [22.711, 65.82],
              [22.71, 65.823],
              [22.708, 65.826],
              [22.697, 65.839],
              [22.682, 65.864],
              [22.678, 65.869],
              [22.675, 65.874],
              [22.667, 65.882],
              [22.662, 65.886],
              [22.657, 65.889],
              [22.648, 65.894],
              [22.645, 65.896],
              [22.643, 65.898],
              [22.642, 65.9],
              [22.642, 65.901],
              [22.644, 65.903],
              [22.65, 65.903],
              [22.663, 65.902],
              [22.671, 65.9],
              [22.676, 65.898],
              [22.686, 65.893],
              [22.694, 65.891],
              [22.704, 65.888],
              [22.709, 65.887],
              [22.715, 65.885],
              [22.72, 65.882],
              [22.726, 65.88],
              [22.749, 65.869],
              [22.755, 65.867],
              [22.76, 65.865],
              [22.767, 65.863],
              [22.777, 65.857],
              [22.783, 65.854],
              [22.798, 65.844],
              [22.815, 65.834],
              [22.82, 65.831],
              [22.824, 65.828],
              [22.827, 65.824],
              [22.829, 65.82],
              [22.832, 65.812],
              [22.834, 65.808],
              [22.839, 65.803],
              [22.842, 65.801],
              [22.847, 65.799],
              [22.851, 65.798],
              [22.857, 65.797],
              [22.877, 65.794],
              [22.881, 65.793],
              [22.885, 65.793],
              [22.887, 65.794],
              [22.89, 65.795],
              [22.892, 65.795],
              [22.894, 65.796],
              [22.896, 65.795],
              [22.899, 65.794],
              [22.901, 65.793],
              [22.906, 65.789],
              [22.91, 65.787],
              [22.94, 65.775],
              [22.946, 65.771],
              [22.951, 65.769],
              [22.956, 65.768],
              [22.962, 65.766],
              [22.98, 65.762],
              [22.996, 65.757],
              [23.006, 65.755],
              [23.012, 65.754],
              [23.022, 65.754],
              [23.026, 65.755],
              [23.029, 65.756],
              [23.031, 65.758],
              [23.033, 65.761],
              [23.035, 65.763],
              [23.04, 65.763],
              [23.044, 65.762],
              [23.048, 65.76],
              [23.063, 65.75],
              [23.075, 65.743],
              [23.078, 65.741],
              [23.08, 65.738],
              [23.08, 65.736],
              [23.079, 65.73],
              [23.079, 65.726],
              [23.081, 65.718],
              [23.083, 65.715],
              [23.088, 65.71],
              [23.091, 65.708],
              [23.098, 65.708],
              [23.106, 65.71],
              [23.11, 65.712],
              [23.124, 65.715],
              [23.129, 65.716],
              [23.133, 65.717],
              [23.145, 65.723],
              [23.148, 65.726],
              [23.149, 65.73],
              [23.15, 65.732],
              [23.152, 65.734],
              [23.153, 65.736],
              [23.157, 65.738],
              [23.158, 65.739],
              [23.161, 65.739],
              [23.163, 65.74],
              [23.165, 65.742],
              [23.165, 65.743],
              [23.163, 65.745],
              [23.157, 65.747],
              [23.147, 65.75],
              [23.145, 65.751],
              [23.144, 65.751],
              [23.148, 65.755],
              [23.151, 65.756],
              [23.163, 65.757],
              [23.168, 65.758],
              [23.174, 65.759],
              [23.182, 65.761],
              [23.193, 65.763],
              [23.197, 65.764],
              [23.207, 65.764],
              [23.215, 65.766],
              [23.219, 65.768],
              [23.221, 65.77],
              [23.222, 65.772],
              [23.222, 65.774],
              [23.216, 65.78],
              [23.209, 65.785],
              [23.206, 65.789],
              [23.202, 65.792],
              [23.2, 65.795],
              [23.196, 65.803],
              [23.195, 65.807],
              [23.192, 65.811],
              [23.19, 65.815],
              [23.187, 65.819],
              [23.182, 65.823],
              [23.178, 65.827],
              [23.172, 65.831],
              [23.167, 65.834],
              [23.153, 65.843],
              [23.149, 65.845],
              [23.146, 65.848],
              [23.147, 65.849],
              [23.15, 65.849],
              [23.154, 65.848],
              [23.164, 65.846],
              [23.188, 65.838],
              [23.195, 65.836],
              [23.201, 65.833],
              [23.208, 65.829],
              [23.233, 65.816],
              [23.239, 65.813],
              [23.245, 65.811],
              [23.251, 65.808],
              [23.271, 65.804],
              [23.274, 65.802],
              [23.276, 65.802],
              [23.282, 65.799],
              [23.285, 65.797],
              [23.293, 65.795],
              [23.298, 65.795],
              [23.308, 65.797],
              [23.312, 65.799],
              [23.317, 65.802],
              [23.321, 65.805],
              [23.324, 65.808],
              [23.327, 65.81],
              [23.329, 65.813],
              [23.33, 65.815],
              [23.33, 65.816],
              [23.333, 65.819],
              [23.335, 65.82],
              [23.338, 65.821],
              [23.342, 65.821],
              [23.345, 65.822],
              [23.348, 65.822],
              [23.351, 65.821],
              [23.353, 65.82],
              [23.353, 65.81],
              [23.355, 65.801],
              [23.356, 65.794],
              [23.357, 65.791],
              [23.363, 65.788],
              [23.366, 65.788],
              [23.369, 65.786],
              [23.374, 65.781],
              [23.377, 65.775],
              [23.379, 65.773],
              [23.381, 65.772],
              [23.388, 65.772],
              [23.39, 65.771],
              [23.392, 65.771],
              [23.394, 65.77],
              [23.395, 65.768],
              [23.395, 65.767],
              [23.396, 65.765],
              [23.397, 65.764],
              [23.399, 65.763],
              [23.398, 65.762],
              [23.397, 65.76],
              [23.395, 65.759],
              [23.392, 65.759],
              [23.385, 65.757],
              [23.383, 65.757],
              [23.384, 65.755],
              [23.386, 65.754],
              [23.389, 65.753],
              [23.398, 65.753],
              [23.403, 65.755],
              [23.407, 65.756],
              [23.412, 65.758],
              [23.423, 65.765],
              [23.425, 65.766],
              [23.427, 65.768],
              [23.427, 65.771],
              [23.424, 65.774],
              [23.421, 65.776],
              [23.42, 65.778],
              [23.42, 65.781],
              [23.421, 65.784],
              [23.422, 65.785],
              [23.421, 65.787],
              [23.419, 65.794],
              [23.418, 65.797],
              [23.418, 65.801],
              [23.422, 65.809],
              [23.426, 65.812],
              [23.43, 65.814],
              [23.435, 65.816],
              [23.439, 65.817],
              [23.444, 65.818],
              [23.453, 65.82],
              [23.457, 65.821],
              [23.461, 65.823],
              [23.462, 65.826],
              [23.463, 65.828],
              [23.464, 65.829],
              [23.466, 65.83],
              [23.468, 65.829],
              [23.471, 65.828],
              [23.474, 65.826],
              [23.476, 65.824],
              [23.477, 65.821],
              [23.477, 65.815],
              [23.475, 65.809],
              [23.475, 65.803],
              [23.476, 65.8],
              [23.477, 65.799],
              [23.48, 65.799],
              [23.486, 65.802],
              [23.491, 65.805],
              [23.494, 65.806],
              [23.498, 65.807],
              [23.503, 65.808],
              [23.549, 65.808],
              [23.555, 65.806],
              [23.557, 65.804],
              [23.558, 65.802],
              [23.561, 65.795],
              [23.562, 65.792],
              [23.565, 65.79],
              [23.568, 65.789],
              [23.576, 65.787],
              [23.596, 65.787],
              [23.6, 65.788],
              [23.603, 65.79],
              [23.604, 65.792],
              [23.606, 65.794],
              [23.608, 65.799],
              [23.609, 65.801],
              [23.612, 65.802],
              [23.616, 65.803],
              [23.62, 65.802],
              [23.629, 65.8],
              [23.643, 65.8],
              [23.648, 65.801],
              [23.656, 65.805],
              [23.662, 65.811],
              [23.668, 65.819],
              [23.676, 65.825],
              [23.68, 65.827],
              [23.685, 65.83],
              [23.695, 65.832],
              [23.702, 65.833],
              [23.709, 65.833],
              [23.715, 65.832],
              [23.722, 65.831],
              [23.728, 65.829],
              [23.74, 65.823],
              [23.745, 65.82],
              [23.76, 65.809],
              [23.765, 65.805],
              [23.77, 65.802],
              [23.782, 65.798],
              [23.789, 65.796],
              [23.795, 65.794],
              [23.802, 65.793],
              [23.808, 65.792],
              [23.814, 65.792],
              [23.82, 65.791],
              [23.826, 65.791],
              [23.831, 65.792],
              [23.835, 65.792],
              [23.837, 65.793],
              [23.842, 65.795],
              [23.845, 65.796],
              [23.853, 65.796],
              [23.857, 65.795],
              [23.862, 65.794],
              [23.867, 65.791],
              [23.872, 65.789],
              [23.888, 65.779],
              [23.893, 65.777],
              [23.898, 65.774],
              [23.908, 65.772],
              [23.917, 65.772],
              [23.925, 65.774],
              [23.928, 65.775],
              [23.931, 65.777],
              [23.935, 65.781],
              [23.936, 65.786],
              [23.937, 65.789],
              [23.939, 65.791],
              [23.941, 65.792],
              [23.947, 65.794],
              [23.951, 65.796],
              [23.955, 65.796],
              [23.962, 65.797],
              [23.965, 65.797],
              [23.971, 65.799],
              [23.982, 65.799],
              [23.987, 65.798],
              [23.99, 65.797],
              [23.994, 65.796],
              [23.998, 65.796],
              [24.002, 65.797],
              [24.007, 65.797],
              [24.011, 65.798],
              [24.016, 65.798],
              [24.021, 65.797],
              [24.03, 65.796],
              [24.035, 65.796],
              [24.036, 65.797],
              [24.036, 65.801],
              [24.037, 65.803],
              [24.038, 65.807],
              [24.04, 65.81],
              [24.043, 65.812],
              [24.051, 65.814],
              [24.056, 65.815],
              [24.069, 65.816],
              [24.126, 65.816],
              [24.131, 65.817],
              [24.135, 65.818],
              [24.139, 65.82],
              [24.142, 65.821],
              [24.145, 65.824],
              [24.149, 65.83],
              [24.152, 65.832],
              [24.156, 65.833],
              [24.161, 65.834],
              [24.166, 65.833],
              [24.183, 65.831],
              [24.189, 65.831],
              [24.201, 65.83],
              [24.23, 65.829],
              [24.235, 65.829],
              [24.24, 65.828],
              [24.246, 65.826],
              [24.251, 65.823],
              [24.257, 65.82],
              [24.262, 65.817],
              [24.272, 65.81],
              [24.277, 65.807],
              [24.283, 65.804],
              [24.293, 65.8],
              [24.299, 65.798],
              [24.304, 65.797],
              [24.309, 65.797],
              [24.318, 65.798],
              [24.328, 65.796],
              [24.333, 65.794],
              [24.35, 65.788],
              [24.362, 65.784],
              [24.409, 65.774],
              [24.431, 65.77],
              [24.436, 65.769],
              [24.446, 65.765],
              [24.45, 65.762],
              [24.459, 65.758],
              [24.462, 65.756],
              [24.464, 65.755],
              [24.47, 65.754],
              [24.482, 65.75],
              [24.492, 65.75],
              [24.495, 65.751],
              [24.498, 65.751],
              [24.5, 65.749],
              [24.505, 65.749],
              [24.507, 65.75],
              [24.51, 65.752],
              [24.513, 65.752],
              [24.514, 65.75],
              [24.516, 65.749],
              [24.521, 65.749],
              [24.524, 65.75],
              [24.528, 65.752],
              [24.531, 65.755],
              [24.534, 65.755],
              [24.545, 65.744],
              [24.559, 65.734],
              [24.562, 65.731],
              [24.566, 65.729],
              [24.575, 65.726],
              [24.592, 65.719],
              [24.597, 65.717],
              [24.603, 65.715],
              [24.614, 65.712],
              [24.622, 65.71],
              [24.626, 65.708],
              [24.629, 65.706],
              [24.631, 65.704],
              [24.632, 65.702],
              [24.632, 65.7],
              [24.628, 65.698],
              [24.625, 65.698],
              [24.621, 65.696],
              [24.62, 65.695],
              [24.62, 65.693],
              [24.621, 65.691],
              [24.626, 65.686],
              [24.63, 65.684],
              [24.639, 65.681],
              [24.643, 65.678],
              [24.645, 65.677],
              [24.651, 65.672],
              [24.659, 65.666],
              [24.662, 65.663],
              [24.665, 65.657],
              [24.665, 65.649],
              [24.666, 65.647],
              [24.667, 65.644],
              [24.669, 65.642],
              [24.672, 65.64],
              [24.676, 65.637],
              [24.686, 65.635],
              [24.698, 65.633],
              [24.703, 65.634],
              [24.707, 65.634],
              [24.71, 65.635],
              [24.714, 65.636],
              [24.717, 65.637],
              [24.721, 65.64],
              [24.726, 65.643],
              [24.738, 65.652],
              [24.742, 65.654],
              [24.749, 65.657],
              [24.752, 65.659],
              [24.753, 65.66],
              [24.756, 65.661],
              [24.76, 65.661],
              [24.764, 65.66],
              [24.784, 65.656],
              [24.793, 65.656],
              [24.797, 65.657],
              [24.804, 65.659],
              [24.81, 65.661],
              [24.813, 65.664],
              [24.815, 65.665],
              [24.852, 65.665],
              [24.863, 65.664],
              [24.868, 65.664],
              [24.873, 65.663],
              [24.879, 65.661],
              [24.886, 65.658],
              [24.892, 65.656],
              [24.91, 65.646],
              [24.917, 65.643],
              [24.923, 65.64],
              [24.93, 65.638],
              [24.936, 65.636],
              [24.95, 65.634],
              [24.957, 65.634],
              [24.963, 65.633],
              [24.976, 65.633],
              [24.982, 65.634],
              [24.998, 65.634],
              [25, 65.633],
              [25.005, 65.631],
              [25.009, 65.629],
              [25.014, 65.628],
              [25.031, 65.623],
              [25.049, 65.617],
              [25.054, 65.614],
              [25.059, 65.612],
              [25.071, 65.603],
              [25.075, 65.597],
              [25.075, 65.591],
              [25.076, 65.589],
              [25.082, 65.584],
              [25.087, 65.578],
              [25.09, 65.575],
              [25.093, 65.573],
              [25.097, 65.57],
              [25.11, 65.564],
              [25.116, 65.561],
              [25.124, 65.559],
              [25.134, 65.561],
              [25.15, 65.566],
              [25.157, 65.568],
              [25.16, 65.569],
              [25.164, 65.572],
              [25.171, 65.576],
              [25.174, 65.578],
              [25.176, 65.578],
              [25.178, 65.577],
              [25.18, 65.575],
              [25.181, 65.573],
              [25.187, 65.567],
              [25.191, 65.565],
              [25.201, 65.559],
              [25.205, 65.556],
              [25.216, 65.546],
              [25.226, 65.54],
              [25.243, 65.531],
              [25.249, 65.528],
              [25.254, 65.524],
              [25.259, 65.521],
              [25.264, 65.517],
              [25.269, 65.514],
              [25.285, 65.498],
              [25.288, 65.494],
              [25.296, 65.488],
              [25.306, 65.484],
              [25.314, 65.48],
              [25.318, 65.479],
              [25.322, 65.477],
              [25.325, 65.475],
              [25.335, 65.465],
              [25.337, 65.462],
              [25.338, 65.46],
              [25.338, 65.457],
              [25.337, 65.455],
              [25.336, 65.451],
              [25.336, 65.449],
              [25.337, 65.447],
              [25.34, 65.444],
              [25.341, 65.442],
              [25.342, 65.441],
              [25.342, 65.438],
              [25.344, 65.437],
              [25.349, 65.431],
              [25.351, 65.43],
              [25.351, 65.428],
              [25.35, 65.427],
              [25.346, 65.425],
              [25.344, 65.425],
              [25.336, 65.424],
              [25.333, 65.424],
              [25.331, 65.422],
              [25.332, 65.421],
              [25.332, 65.42],
              [25.328, 65.416],
              [25.32, 65.412],
              [25.315, 65.41],
              [25.309, 65.409],
              [25.299, 65.407],
              [25.286, 65.408],
              [25.28, 65.408],
              [25.272, 65.406],
              [25.268, 65.404],
              [25.266, 65.398],
              [25.267, 65.395],
              [25.271, 65.389],
              [25.275, 65.385],
              [25.276, 65.383],
              [25.275, 65.382],
              [25.274, 65.38],
              [25.272, 65.379],
              [25.271, 65.377],
              [25.27, 65.376],
              [25.27, 65.374],
              [25.271, 65.373],
              [25.273, 65.372],
              [25.281, 65.37],
              [25.298, 65.368],
              [25.304, 65.368],
              [25.316, 65.365],
              [25.318, 65.364],
              [25.319, 65.363],
              [25.32, 65.363],
              [25.319, 65.362],
              [25.317, 65.361],
              [25.312, 65.361],
              [25.307, 65.362],
              [25.304, 65.362],
              [25.302, 65.361],
              [25.299, 65.36],
              [25.297, 65.359],
              [25.294, 65.355],
              [25.29, 65.352],
              [25.288, 65.348],
              [25.289, 65.346],
              [25.291, 65.344],
              [25.295, 65.339],
              [25.297, 65.337],
              [25.298, 65.335],
              [25.298, 65.333],
              [25.296, 65.326],
              [25.293, 65.321],
              [25.292, 65.318],
              [25.291, 65.316],
              [25.29, 65.311],
              [25.289, 65.309],
              [25.289, 65.307],
              [25.291, 65.304],
              [25.3, 65.295],
              [25.302, 65.291],
              [25.301, 65.29],
              [25.3, 65.288],
              [25.295, 65.286],
              [25.292, 65.284],
              [25.289, 65.281],
              [25.284, 65.277],
              [25.281, 65.275],
              [25.28, 65.274],
              [25.28, 65.272],
              [25.281, 65.271],
              [25.284, 65.27],
              [25.288, 65.269],
              [25.308, 65.265],
              [25.316, 65.263],
              [25.319, 65.262],
              [25.321, 65.261],
              [25.321, 65.259],
              [25.319, 65.258],
              [25.315, 65.255],
              [25.312, 65.253],
              [25.31, 65.251],
              [25.309, 65.249],
              [25.309, 65.247],
              [25.31, 65.245],
              [25.313, 65.244],
              [25.317, 65.242],
              [25.33, 65.238],
              [25.336, 65.236],
              [25.337, 65.235],
              [25.337, 65.234],
              [25.336, 65.233],
              [25.323, 65.233],
              [25.306, 65.234],
              [25.3, 65.235],
              [25.295, 65.235],
              [25.29, 65.234],
              [25.288, 65.233],
              [25.285, 65.232],
              [25.284, 65.231],
              [25.284, 65.228],
              [25.285, 65.226],
              [25.286, 65.223],
              [25.286, 65.216],
              [25.284, 65.21],
              [25.273, 65.199],
              [25.271, 65.193],
              [25.271, 65.187],
              [25.27, 65.184],
              [25.268, 65.181],
              [25.266, 65.179],
              [25.262, 65.177],
              [25.247, 65.171],
              [25.243, 65.169],
              [25.239, 65.166],
              [25.236, 65.163],
              [25.234, 65.16],
              [25.233, 65.156],
              [25.233, 65.148],
              [25.234, 65.144],
              [25.235, 65.137],
              [25.237, 65.133],
              [25.24, 65.13],
              [25.244, 65.129],
              [25.249, 65.127],
              [25.261, 65.125],
              [25.281, 65.123],
              [25.302, 65.12],
              [25.31, 65.119],
              [25.317, 65.117],
              [25.33, 65.113],
              [25.344, 65.11],
              [25.35, 65.107],
              [25.357, 65.105],
              [25.362, 65.103],
              [25.368, 65.101],
              [25.376, 65.095],
              [25.379, 65.092],
              [25.381, 65.089],
              [25.384, 65.086],
              [25.396, 65.071],
              [25.4, 65.065],
              [25.4, 65.062],
              [25.401, 65.06],
              [25.401, 65.059],
              [25.402, 65.057],
              [25.405, 65.054],
              [25.408, 65.052],
              [25.412, 65.049],
              [25.417, 65.046],
              [25.423, 65.044],
              [25.439, 65.036],
              [25.454, 65.027],
              [25.457, 65.025],
              [25.46, 65.022],
              [25.46, 65.02],
              [25.459, 65.018],
              [25.456, 65.016],
              [25.448, 65.012],
              [25.443, 65.01],
              [25.427, 65.004],
              [25.422, 65.002],
              [25.418, 65],
              [25.415, 64.997],
              [25.416, 64.995],
              [25.419, 64.993],
              [25.423, 64.991],
              [25.453, 64.981],
              [25.46, 64.978],
              [25.465, 64.976],
              [25.47, 64.973],
              [25.474, 64.97],
              [25.476, 64.964],
              [25.475, 64.961],
              [25.473, 64.958],
              [25.469, 64.956],
              [25.464, 64.954],
              [25.458, 64.952],
              [25.446, 64.95],
              [25.439, 64.95],
              [25.432, 64.951],
              [25.426, 64.952],
              [25.419, 64.953],
              [25.412, 64.955],
              [25.405, 64.958],
              [25.392, 64.963],
              [25.366, 64.974],
              [25.352, 64.979],
              [25.346, 64.981],
              [25.339, 64.984],
              [25.333, 64.986],
              [25.326, 64.988],
              [25.319, 64.989],
              [25.313, 64.99],
              [25.287, 64.993],
              [25.281, 64.994],
              [25.274, 64.996],
              [25.267, 64.997],
              [25.254, 65.001],
              [25.247, 65.002],
              [25.24, 65.004],
              [25.233, 65.005],
              [25.221, 65.006],
              [25.215, 65.007],
              [25.207, 65.007],
              [25.205, 65.006],
              [25.205, 65.004],
              [25.207, 65.002],
              [25.207, 65],
              [25.208, 64.997],
              [25.208, 64.994],
              [25.206, 64.988],
              [25.203, 64.983],
              [25.201, 64.977],
              [25.202, 64.973],
              [25.204, 64.969],
              [25.207, 64.964],
              [25.211, 64.96],
              [25.215, 64.955],
              [25.225, 64.947],
              [25.23, 64.944],
              [25.236, 64.94],
              [25.242, 64.938],
              [25.249, 64.935],
              [25.255, 64.932],
              [25.262, 64.93],
              [25.275, 64.925],
              [25.301, 64.917],
              [25.315, 64.913],
              [25.321, 64.911],
              [25.335, 64.909],
              [25.341, 64.909],
              [25.355, 64.908],
              [25.361, 64.907],
              [25.371, 64.905],
              [25.375, 64.904],
              [25.381, 64.9],
              [25.382, 64.898],
              [25.382, 64.896],
              [25.38, 64.892],
              [25.372, 64.882],
              [25.359, 64.869],
              [25.355, 64.866],
              [25.352, 64.862],
              [25.347, 64.855],
              [25.343, 64.851],
              [25.339, 64.848],
              [25.335, 64.844],
              [25.325, 64.838],
              [25.319, 64.836],
              [25.314, 64.835],
              [25.31, 64.834],
              [25.306, 64.834],
              [25.303, 64.835],
              [25.3, 64.837],
              [25.297, 64.84],
              [25.295, 64.843],
              [25.29, 64.852],
              [25.287, 64.856],
              [25.283, 64.86],
              [25.279, 64.863],
              [25.273, 64.866],
              [25.255, 64.872],
              [25.225, 64.877],
              [25.219, 64.879],
              [25.214, 64.882],
              [25.208, 64.885],
              [25.198, 64.892],
              [25.193, 64.896],
              [25.188, 64.899],
              [25.183, 64.901],
              [25.177, 64.902],
              [25.172, 64.903],
              [25.16, 64.904],
              [25.154, 64.905],
              [25.149, 64.906],
              [25.134, 64.912],
              [25.128, 64.914],
              [25.123, 64.916],
              [25.117, 64.917],
              [25.11, 64.918],
              [25.091, 64.918],
              [25.049, 64.912],
              [25.035, 64.911],
              [25, 64.908],
              [24.993, 64.908],
              [24.987, 64.907],
              [24.98, 64.906],
              [24.975, 64.905],
              [24.969, 64.903],
              [24.965, 64.901],
              [24.962, 64.899],
              [24.957, 64.895],
              [24.953, 64.892],
              [24.948, 64.89],
              [24.944, 64.888],
              [24.938, 64.886],
              [24.933, 64.885],
              [24.926, 64.884],
              [24.906, 64.884],
              [24.892, 64.885],
              [24.857, 64.887],
              [24.843, 64.888],
              [24.83, 64.888],
              [24.823, 64.887],
              [24.816, 64.887],
              [24.81, 64.885],
              [24.804, 64.884],
              [24.791, 64.879],
              [24.785, 64.878],
              [24.778, 64.876],
              [24.771, 64.875],
              [24.765, 64.874],
              [24.746, 64.872],
              [24.74, 64.871],
              [24.734, 64.869],
              [24.729, 64.868],
              [24.725, 64.866],
              [24.722, 64.864],
              [24.717, 64.861],
              [24.713, 64.859],
              [24.709, 64.858],
              [24.701, 64.855],
              [24.697, 64.853],
              [24.694, 64.852],
              [24.691, 64.85],
              [24.68, 64.839],
              [24.674, 64.831],
              [24.669, 64.823],
              [24.667, 64.819],
              [24.664, 64.816],
              [24.661, 64.814],
              [24.659, 64.813],
              [24.653, 64.813],
              [24.651, 64.815],
              [24.648, 64.817],
              [24.641, 64.824],
              [24.631, 64.828],
              [24.625, 64.829],
              [24.619, 64.829],
              [24.612, 64.83],
              [24.606, 64.829],
              [24.6, 64.829],
              [24.593, 64.828],
              [24.581, 64.826],
              [24.575, 64.824],
              [24.569, 64.823],
              [24.559, 64.819],
              [24.556, 64.817],
              [24.553, 64.814],
              [24.552, 64.811],
              [24.553, 64.807],
              [24.557, 64.801],
              [24.565, 64.791],
              [24.568, 64.788],
              [24.569, 64.784],
              [24.569, 64.78],
              [24.568, 64.777],
              [24.566, 64.77],
              [24.565, 64.767],
              [24.564, 64.763],
              [24.562, 64.747],
              [24.562, 64.742],
              [24.56, 64.738],
              [24.554, 64.73],
              [24.546, 64.724],
              [24.536, 64.718],
              [24.526, 64.714],
              [24.511, 64.71],
              [24.505, 64.707],
              [24.501, 64.706],
              [24.499, 64.704],
              [24.496, 64.703],
              [24.488, 64.701],
              [24.483, 64.7],
              [24.472, 64.699],
              [24.462, 64.697],
              [24.457, 64.695],
              [24.454, 64.694],
              [24.453, 64.693],
              [24.453, 64.691],
              [24.454, 64.69],
              [24.455, 64.688],
              [24.456, 64.687],
              [24.456, 64.685],
              [24.455, 64.683],
              [24.453, 64.681],
              [24.441, 64.675],
              [24.436, 64.674],
              [24.421, 64.669],
              [24.413, 64.665],
              [24.41, 64.663],
              [24.406, 64.659],
              [24.401, 64.655],
              [24.399, 64.653],
              [24.397, 64.65],
              [24.395, 64.643],
              [24.392, 64.637],
              [24.391, 64.633],
              [24.39, 64.63],
              [24.39, 64.627],
              [24.388, 64.621],
              [24.382, 64.612],
              [24.375, 64.606],
              [24.371, 64.6],
              [24.37, 64.597],
              [24.371, 64.593],
              [24.371, 64.581],
              [24.367, 64.57],
              [24.366, 64.567],
              [24.366, 64.563],
              [24.367, 64.557],
              [24.367, 64.554],
              [24.366, 64.551],
              [24.364, 64.547],
              [24.358, 64.541],
              [24.354, 64.539],
              [24.35, 64.536],
              [24.338, 64.532],
              [24.331, 64.531],
              [24.325, 64.53],
              [24.318, 64.529],
              [24.298, 64.529],
              [24.28, 64.533],
              [24.27, 64.533],
              [24.264, 64.531],
              [24.263, 64.53],
              [24.262, 64.527],
              [24.263, 64.524],
              [24.265, 64.52],
              [24.267, 64.518],
              [24.272, 64.514],
              [24.275, 64.512],
              [24.276, 64.51],
              [24.279, 64.507],
              [24.28, 64.505],
              [24.28, 64.504],
              [24.279, 64.503],
              [24.276, 64.502],
              [24.272, 64.502],
              [24.268, 64.501],
              [24.257, 64.501],
              [24.251, 64.5],
              [24.243, 64.498],
              [24.238, 64.497],
              [24.228, 64.493],
              [24.205, 64.482],
              [24.201, 64.48],
              [24.196, 64.476],
              [24.188, 64.472],
              [24.173, 64.463],
              [24.171, 64.462],
              [24.166, 64.46],
              [24.161, 64.459],
              [24.155, 64.457],
              [24.138, 64.453],
              [24.133, 64.452],
              [24.119, 64.448],
              [24.109, 64.444],
              [24.105, 64.442],
              [24.097, 64.44],
              [24.094, 64.439],
              [24.092, 64.437],
              [24.091, 64.435],
              [24.091, 64.429],
              [24.09, 64.426],
              [24.089, 64.424],
              [24.086, 64.421],
              [24.083, 64.419],
              [24.079, 64.418],
              [24.074, 64.416],
              [24.069, 64.415],
              [24.052, 64.413],
              [24.046, 64.412],
              [24.036, 64.41],
              [24.032, 64.408],
              [24.025, 64.404],
              [24.021, 64.402],
              [24.014, 64.397],
              [24.006, 64.391],
              [24.002, 64.389],
              [23.999, 64.385],
              [23.995, 64.382],
              [23.989, 64.374],
              [23.981, 64.363],
              [23.978, 64.36],
              [23.973, 64.356],
              [23.968, 64.353],
              [23.962, 64.35],
              [23.944, 64.343],
              [23.938, 64.34],
              [23.933, 64.337],
              [23.928, 64.333],
              [23.924, 64.328],
              [23.921, 64.323],
              [23.919, 64.318],
              [23.917, 64.312],
              [23.917, 64.307],
              [23.916, 64.301],
              [23.916, 64.296],
              [23.918, 64.286],
              [23.919, 64.279],
              [23.92, 64.277],
              [23.919, 64.275],
              [23.918, 64.275],
              [23.912, 64.277],
              [23.905, 64.28],
              [23.902, 64.282],
              [23.897, 64.283],
              [23.885, 64.285],
              [23.862, 64.285],
              [23.852, 64.283],
              [23.842, 64.279],
              [23.834, 64.275],
              [23.831, 64.273],
              [23.829, 64.271],
              [23.825, 64.265],
              [23.825, 64.263],
              [23.824, 64.256],
              [23.823, 64.254],
              [23.821, 64.251],
              [23.818, 64.247],
              [23.814, 64.243],
              [23.804, 64.237],
              [23.798, 64.235],
              [23.792, 64.232],
              [23.778, 64.228],
              [23.772, 64.227],
              [23.765, 64.226],
              [23.753, 64.224],
              [23.729, 64.222],
              [23.724, 64.222],
              [23.714, 64.223],
              [23.711, 64.223],
              [23.708, 64.222],
              [23.705, 64.222],
              [23.702, 64.221],
              [23.7, 64.22],
              [23.698, 64.218],
              [23.698, 64.217],
              [23.699, 64.215],
              [23.701, 64.21],
              [23.707, 64.201],
              [23.708, 64.198],
              [23.71, 64.195],
              [23.71, 64.189],
              [23.709, 64.187],
              [23.708, 64.184],
              [23.702, 64.178],
              [23.696, 64.173],
              [23.693, 64.17],
              [23.69, 64.168],
              [23.677, 64.159],
              [23.662, 64.149],
              [23.657, 64.146],
              [23.653, 64.144],
              [23.642, 64.139],
              [23.638, 64.135],
              [23.635, 64.13],
              [23.633, 64.127],
              [23.632, 64.126],
              [23.628, 64.124],
              [23.624, 64.124],
              [23.61, 64.122],
              [23.605, 64.122],
              [23.601, 64.121],
              [23.598, 64.119],
              [23.594, 64.115],
              [23.593, 64.112],
              [23.594, 64.11],
              [23.594, 64.107],
              [23.596, 64.101],
              [23.598, 64.098],
              [23.605, 64.091],
              [23.609, 64.088],
              [23.627, 64.077],
              [23.63, 64.074],
              [23.633, 64.072],
              [23.634, 64.07],
              [23.634, 64.068],
              [23.632, 64.067],
              [23.628, 64.063],
              [23.622, 64.058],
              [23.619, 64.055],
              [23.611, 64.051],
              [23.607, 64.05],
              [23.603, 64.05],
              [23.594, 64.049],
              [23.591, 64.049],
              [23.584, 64.047],
              [23.58, 64.046],
              [23.575, 64.046],
              [23.57, 64.045],
              [23.565, 64.045],
              [23.559, 64.046],
              [23.554, 64.046],
              [23.542, 64.048],
              [23.523, 64.053],
              [23.505, 64.056],
              [23.497, 64.057],
              [23.491, 64.058],
              [23.484, 64.06],
              [23.478, 64.062],
              [23.471, 64.064],
              [23.465, 64.067],
              [23.452, 64.074],
              [23.446, 64.076],
              [23.44, 64.079],
              [23.434, 64.081],
              [23.427, 64.082],
              [23.421, 64.083],
              [23.415, 64.082],
              [23.41, 64.081],
              [23.405, 64.079],
              [23.4, 64.076],
              [23.396, 64.073],
              [23.393, 64.069],
              [23.39, 64.064],
              [23.388, 64.059],
              [23.386, 64.053],
              [23.386, 64.047],
              [23.385, 64.028],
              [23.385, 64.022],
              [23.384, 64.018],
              [23.382, 64.009],
              [23.382, 63.997],
              [23.383, 63.994],
              [23.383, 63.992],
              [23.382, 63.99],
              [23.382, 63.988],
              [23.383, 63.986],
              [23.383, 63.984],
              [23.384, 63.982],
              [23.384, 63.98],
              [23.383, 63.977],
              [23.379, 63.972],
              [23.377, 63.97],
              [23.377, 63.967],
              [23.378, 63.964],
              [23.382, 63.958],
              [23.388, 63.952],
              [23.392, 63.946],
              [23.392, 63.941],
              [23.389, 63.938],
              [23.387, 63.935],
              [23.378, 63.929],
              [23.376, 63.925],
              [23.375, 63.924],
              [23.371, 63.922],
              [23.366, 63.92],
              [23.363, 63.92],
              [23.355, 63.922],
              [23.35, 63.924],
              [23.327, 63.933],
              [23.322, 63.935],
              [23.314, 63.938],
              [23.31, 63.939],
              [23.305, 63.942],
              [23.302, 63.942],
              [23.299, 63.943],
              [23.296, 63.943],
              [23.294, 63.941],
              [23.294, 63.939],
              [23.295, 63.938],
              [23.302, 63.932],
              [23.309, 63.924],
              [23.31, 63.922],
              [23.31, 63.921],
              [23.309, 63.919],
              [23.303, 63.916],
              [23.295, 63.914],
              [23.286, 63.914],
              [23.276, 63.913],
              [23.272, 63.913],
              [23.262, 63.912],
              [23.252, 63.912],
              [23.246, 63.911],
              [23.237, 63.911],
              [23.233, 63.912],
              [23.222, 63.913],
              [23.22, 63.913],
              [23.214, 63.911],
              [23.206, 63.909],
              [23.201, 63.909],
              [23.19, 63.91],
              [23.18, 63.91],
              [23.166, 63.911],
              [23.141, 63.911],
              [23.139, 63.91],
              [23.138, 63.909],
              [23.138, 63.907],
              [23.137, 63.905],
              [23.137, 63.903],
              [23.136, 63.901],
              [23.132, 63.897],
              [23.13, 63.896],
              [23.123, 63.896],
              [23.118, 63.897],
              [23.113, 63.899],
              [23.095, 63.908],
              [23.089, 63.91],
              [23.086, 63.91],
              [23.086, 63.908],
              [23.089, 63.906],
              [23.096, 63.899],
              [23.11, 63.888],
              [23.114, 63.885],
              [23.117, 63.881],
              [23.12, 63.878],
              [23.121, 63.876],
              [23.121, 63.874],
              [23.12, 63.872],
              [23.113, 63.865],
              [23.11, 63.864],
              [23.108, 63.863],
              [23.102, 63.865],
              [23.099, 63.867],
              [23.095, 63.87],
              [23.091, 63.872],
              [23.086, 63.874],
              [23.08, 63.875],
              [23.075, 63.876],
              [23.07, 63.876],
              [23.066, 63.875],
              [23.055, 63.874],
              [23.045, 63.872],
              [23.037, 63.87],
              [23.033, 63.866],
              [23.03, 63.861],
              [23.029, 63.859],
              [23.02, 63.853],
              [23.019, 63.851],
              [23.019, 63.85],
              [23.02, 63.849],
              [23.021, 63.847],
              [23.026, 63.843],
              [23.029, 63.841],
              [23.031, 63.837],
              [23.031, 63.834],
              [23.027, 63.83],
              [23.024, 63.828],
              [23.02, 63.827],
              [23.014, 63.825],
              [23.011, 63.823],
              [23.01, 63.822],
              [23.01, 63.82],
              [23.011, 63.817],
              [23.012, 63.815],
              [23.012, 63.812],
              [23.013, 63.809],
              [23.012, 63.803],
              [23.012, 63.8],
              [23.013, 63.796],
              [23.013, 63.793],
              [23.012, 63.792],
              [23.01, 63.792],
              [23.008, 63.791],
              [23.005, 63.79],
              [22.999, 63.792],
              [22.995, 63.794],
              [22.993, 63.797],
              [22.987, 63.804],
              [22.985, 63.808],
              [22.981, 63.811],
              [22.977, 63.815],
              [22.967, 63.819],
              [22.961, 63.821],
              [22.955, 63.822],
              [22.95, 63.823],
              [22.945, 63.823],
              [22.94, 63.822],
              [22.936, 63.82],
              [22.933, 63.817],
              [22.931, 63.814],
              [22.93, 63.81],
              [22.93, 63.802],
              [22.931, 63.798],
              [22.933, 63.793],
              [22.942, 63.784],
              [22.944, 63.781],
              [22.945, 63.779],
              [22.944, 63.778],
              [22.942, 63.777],
              [22.939, 63.778],
              [22.936, 63.78],
              [22.932, 63.783],
              [22.929, 63.786],
              [22.925, 63.791],
              [22.923, 63.795],
              [22.921, 63.8],
              [22.92, 63.804],
              [22.919, 63.809],
              [22.921, 63.817],
              [22.923, 63.821],
              [22.926, 63.823],
              [22.93, 63.826],
              [22.934, 63.827],
              [22.939, 63.829],
              [22.948, 63.831],
              [22.952, 63.832],
              [22.954, 63.833],
              [22.957, 63.836],
              [22.958, 63.838],
              [22.958, 63.841],
              [22.954, 63.845],
              [22.955, 63.845],
              [22.956, 63.846],
              [22.958, 63.847],
              [22.96, 63.847],
              [22.96, 63.85],
              [22.957, 63.856],
              [22.956, 63.859],
              [22.956, 63.86],
              [22.957, 63.862],
              [22.959, 63.865],
              [22.959, 63.867],
              [22.958, 63.869],
              [22.956, 63.87],
              [22.945, 63.877],
              [22.941, 63.88],
              [22.936, 63.885],
              [22.933, 63.887],
              [22.923, 63.891],
              [22.913, 63.894],
              [22.908, 63.895],
              [22.902, 63.896],
              [22.897, 63.897],
              [22.891, 63.898],
              [22.854, 63.898],
              [22.845, 63.9],
              [22.834, 63.9],
              [22.831, 63.899],
              [22.828, 63.897],
              [22.822, 63.892],
              [22.82, 63.89],
              [22.82, 63.887],
              [22.821, 63.886],
              [22.822, 63.884],
              [22.825, 63.882],
              [22.83, 63.877],
              [22.834, 63.875],
              [22.839, 63.873],
              [22.844, 63.87],
              [22.85, 63.869],
              [22.862, 63.865],
              [22.874, 63.863],
              [22.879, 63.862],
              [22.888, 63.861],
              [22.892, 63.86],
              [22.895, 63.859],
              [22.897, 63.858],
              [22.899, 63.856],
              [22.9, 63.854],
              [22.9, 63.853],
              [22.899, 63.851],
              [22.898, 63.85],
              [22.896, 63.846],
              [22.896, 63.844],
              [22.895, 63.842],
              [22.893, 63.84],
              [22.887, 63.837],
              [22.87, 63.837],
              [22.865, 63.838],
              [22.859, 63.84],
              [22.847, 63.845],
              [22.841, 63.848],
              [22.835, 63.85],
              [22.825, 63.852],
              [22.816, 63.853],
              [22.798, 63.856],
              [22.794, 63.856],
              [22.793, 63.855],
              [22.793, 63.854],
              [22.795, 63.852],
              [22.797, 63.851],
              [22.807, 63.847],
              [22.809, 63.846],
              [22.81, 63.844],
              [22.809, 63.843],
              [22.807, 63.842],
              [22.804, 63.842],
              [22.8, 63.841],
              [22.775, 63.841],
              [22.771, 63.842],
              [22.756, 63.844],
              [22.744, 63.846],
              [22.733, 63.846],
              [22.73, 63.845],
              [22.724, 63.844],
              [22.72, 63.843],
              [22.711, 63.84],
              [22.707, 63.838],
              [22.706, 63.837],
              [22.703, 63.833],
              [22.702, 63.832],
              [22.693, 63.826],
              [22.68, 63.813],
              [22.679, 63.81],
              [22.68, 63.808],
              [22.682, 63.805],
              [22.685, 63.803],
              [22.689, 63.801],
              [22.693, 63.8],
              [22.697, 63.798],
              [22.708, 63.795],
              [22.713, 63.794],
              [22.717, 63.793],
              [22.722, 63.793],
              [22.724, 63.794],
              [22.727, 63.795],
              [22.729, 63.796],
              [22.736, 63.796],
              [22.74, 63.797],
              [22.755, 63.797],
              [22.76, 63.798],
              [22.777, 63.8],
              [22.793, 63.8],
              [22.801, 63.799],
              [22.807, 63.798],
              [22.812, 63.798],
              [22.828, 63.797],
              [22.833, 63.797],
              [22.841, 63.799],
              [22.845, 63.801],
              [22.848, 63.801],
              [22.851, 63.802],
              [22.855, 63.803],
              [22.858, 63.802],
              [22.867, 63.802],
              [22.879, 63.8],
              [22.884, 63.798],
              [22.89, 63.796],
              [22.902, 63.79],
              [22.907, 63.787],
              [22.912, 63.783],
              [22.916, 63.78],
              [22.92, 63.776],
              [22.924, 63.77],
              [22.925, 63.768],
              [22.925, 63.765],
              [22.923, 63.763],
              [22.92, 63.762],
              [22.916, 63.761],
              [22.907, 63.759],
              [22.904, 63.758],
              [22.902, 63.756],
              [22.894, 63.752],
              [22.881, 63.748],
              [22.877, 63.747],
              [22.874, 63.745],
              [22.873, 63.743],
              [22.873, 63.742],
              [22.874, 63.74],
              [22.876, 63.738],
              [22.879, 63.736],
              [22.889, 63.733],
              [22.902, 63.73],
              [22.907, 63.729],
              [22.91, 63.727],
              [22.913, 63.726],
              [22.914, 63.724],
              [22.914, 63.722],
              [22.91, 63.72],
              [22.901, 63.719],
              [22.899, 63.718],
              [22.898, 63.716],
              [22.898, 63.71],
              [22.897, 63.706],
              [22.896, 63.703],
              [22.894, 63.701],
              [22.888, 63.697],
              [22.882, 63.694],
              [22.875, 63.69],
              [22.873, 63.689],
              [22.869, 63.685],
              [22.866, 63.684],
              [22.865, 63.685],
              [22.863, 63.685],
              [22.861, 63.686],
              [22.857, 63.69],
              [22.856, 63.692],
              [22.854, 63.694],
              [22.854, 63.696],
              [22.853, 63.698],
              [22.853, 63.7],
              [22.851, 63.701],
              [22.844, 63.701],
              [22.841, 63.7],
              [22.839, 63.699],
              [22.838, 63.696],
              [22.838, 63.692],
              [22.839, 63.689],
              [22.84, 63.684],
              [22.842, 63.681],
              [22.847, 63.673],
              [22.849, 63.67],
              [22.851, 63.666],
              [22.851, 63.66],
              [22.849, 63.657],
              [22.847, 63.656],
              [22.844, 63.655],
              [22.84, 63.656],
              [22.837, 63.656],
              [22.826, 63.66],
              [22.823, 63.662],
              [22.815, 63.668],
              [22.812, 63.671],
              [22.808, 63.674],
              [22.804, 63.676],
              [22.799, 63.677],
              [22.791, 63.679],
              [22.787, 63.679],
              [22.784, 63.678],
              [22.778, 63.674],
              [22.776, 63.672],
              [22.771, 63.672],
              [22.768, 63.673],
              [22.766, 63.674],
              [22.765, 63.676],
              [22.763, 63.678],
              [22.764, 63.681],
              [22.764, 63.683],
              [22.763, 63.686],
              [22.763, 63.689],
              [22.761, 63.691],
              [22.759, 63.692],
              [22.756, 63.693],
              [22.746, 63.693],
              [22.74, 63.695],
              [22.736, 63.697],
              [22.726, 63.707],
              [22.723, 63.708],
              [22.72, 63.71],
              [22.716, 63.711],
              [22.708, 63.711],
              [22.705, 63.71],
              [22.703, 63.709],
              [22.7, 63.707],
              [22.698, 63.704],
              [22.693, 63.698],
              [22.69, 63.695],
              [22.687, 63.693],
              [22.684, 63.692],
              [22.68, 63.692],
              [22.676, 63.693],
              [22.668, 63.696],
              [22.663, 63.697],
              [22.655, 63.699],
              [22.64, 63.699],
              [22.639, 63.7],
              [22.637, 63.701],
              [22.636, 63.703],
              [22.636, 63.71],
              [22.635, 63.711],
              [22.632, 63.713],
              [22.629, 63.714],
              [22.623, 63.714],
              [22.62, 63.713],
              [22.616, 63.707],
              [22.612, 63.7],
              [22.607, 63.692],
              [22.604, 63.685],
              [22.602, 63.682],
              [22.599, 63.679],
              [22.595, 63.676],
              [22.591, 63.674],
              [22.581, 63.672],
              [22.571, 63.671],
              [22.565, 63.671],
              [22.559, 63.67],
              [22.554, 63.668],
              [22.548, 63.666],
              [22.538, 63.66],
              [22.53, 63.654],
              [22.526, 63.65],
              [22.523, 63.646],
              [22.521, 63.641],
              [22.518, 63.632],
              [22.516, 63.629],
              [22.51, 63.623],
              [22.506, 63.621],
              [22.5, 63.617],
              [22.494, 63.615],
              [22.487, 63.613],
              [22.479, 63.61],
              [22.475, 63.608],
              [22.465, 63.606],
              [22.46, 63.606],
              [22.451, 63.605],
              [22.447, 63.604],
              [22.444, 63.604],
              [22.44, 63.602],
              [22.437, 63.599],
              [22.437, 63.597],
              [22.439, 63.596],
              [22.442, 63.595],
              [22.446, 63.594],
              [22.454, 63.593],
              [22.466, 63.59],
              [22.479, 63.59],
              [22.494, 63.593],
              [22.498, 63.594],
              [22.501, 63.594],
              [22.504, 63.593],
              [22.506, 63.592],
              [22.507, 63.591],
              [22.507, 63.589],
              [22.503, 63.583],
              [22.5, 63.581],
              [22.497, 63.578],
              [22.493, 63.576],
              [22.486, 63.573],
              [22.483, 63.572],
              [22.475, 63.564],
              [22.473, 63.558],
              [22.475, 63.55],
              [22.475, 63.542],
              [22.474, 63.537],
              [22.472, 63.533],
              [22.469, 63.529],
              [22.46, 63.515],
              [22.454, 63.505],
              [22.446, 63.489],
              [22.444, 63.487],
              [22.438, 63.485],
              [22.425, 63.483],
              [22.421, 63.483],
              [22.415, 63.485],
              [22.413, 63.487],
              [22.41, 63.489],
              [22.405, 63.497],
              [22.403, 63.5],
              [22.4, 63.502],
              [22.396, 63.504],
              [22.393, 63.506],
              [22.388, 63.508],
              [22.385, 63.509],
              [22.377, 63.511],
              [22.373, 63.513],
              [22.373, 63.515],
              [22.374, 63.517],
              [22.375, 63.52],
              [22.376, 63.522],
              [22.376, 63.525],
              [22.375, 63.529],
              [22.373, 63.532],
              [22.371, 63.534],
              [22.369, 63.537],
              [22.366, 63.539],
              [22.361, 63.543],
              [22.36, 63.544],
              [22.358, 63.548],
              [22.359, 63.55],
              [22.363, 63.554],
              [22.364, 63.557],
              [22.366, 63.56],
              [22.367, 63.564],
              [22.367, 63.567],
              [22.366, 63.57],
              [22.364, 63.573],
              [22.361, 63.576],
              [22.353, 63.58],
              [22.349, 63.581],
              [22.344, 63.582],
              [22.337, 63.582],
              [22.334, 63.581],
              [22.332, 63.577],
              [22.332, 63.574],
              [22.331, 63.57],
              [22.328, 63.566],
              [22.325, 63.561],
              [22.322, 63.557],
              [22.302, 63.532],
              [22.3, 63.527],
              [22.299, 63.522],
              [22.299, 63.518],
              [22.3, 63.514],
            ],
          ],
        ],
      },
      properties: {
        id: 41,
        name: 'Bottenviken',
        latlon: [64.926335, 22.958937],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [21.209, 62.814],
              [19.697, 63.445],
              [19.705, 63.449],
              [19.708, 63.451],
              [19.711, 63.452],
              [19.731, 63.457],
              [19.737, 63.457],
              [19.743, 63.459],
              [19.75, 63.464],
              [19.753, 63.466],
              [19.757, 63.472],
              [19.757, 63.476],
              [19.756, 63.48],
              [19.752, 63.488],
              [19.746, 63.496],
              [19.739, 63.503],
              [19.736, 63.507],
              [19.734, 63.51],
              [19.732, 63.514],
              [19.731, 63.518],
              [19.731, 63.521],
              [19.732, 63.524],
              [19.736, 63.526],
              [19.743, 63.529],
              [19.746, 63.531],
              [19.754, 63.535],
              [19.758, 63.536],
              [19.761, 63.538],
              [19.768, 63.539],
              [19.772, 63.54],
              [19.784, 63.545],
              [19.787, 63.546],
              [19.792, 63.549],
              [19.795, 63.551],
              [19.799, 63.551],
              [19.805, 63.553],
              [19.809, 63.554],
              [19.816, 63.556],
              [19.818, 63.557],
              [19.821, 63.558],
              [19.825, 63.56],
              [19.834, 63.568],
              [19.837, 63.57],
              [19.843, 63.575],
              [19.848, 63.579],
              [19.851, 63.582],
              [19.856, 63.588],
              [19.859, 63.59],
              [19.861, 63.592],
              [19.864, 63.593],
              [19.869, 63.595],
              [19.872, 63.597],
              [19.876, 63.598],
              [19.879, 63.599],
              [19.884, 63.602],
              [19.888, 63.604],
              [19.895, 63.607],
              [19.898, 63.609],
              [19.904, 63.609],
              [19.907, 63.61],
              [19.911, 63.61],
              [19.921, 63.615],
              [19.925, 63.616],
              [19.942, 63.616],
              [19.952, 63.614],
              [19.956, 63.613],
              [19.968, 63.612],
              [19.973, 63.611],
              [19.977, 63.611],
              [19.988, 63.612],
              [19.994, 63.612],
              [19.999, 63.613],
              [20.001, 63.615],
              [20.001, 63.617],
              [19.999, 63.628],
              [19.999, 63.638],
              [20, 63.643],
              [20.001, 63.647],
              [20.003, 63.652],
              [20.006, 63.656],
              [20.012, 63.662],
              [20.016, 63.665],
              [20.028, 63.669],
              [20.04, 63.671],
              [20.047, 63.672],
              [20.054, 63.672],
              [20.06, 63.671],
              [20.067, 63.67],
              [20.073, 63.668],
              [20.08, 63.666],
              [20.092, 63.661],
              [20.098, 63.659],
              [20.105, 63.658],
              [20.111, 63.656],
              [20.117, 63.656],
              [20.123, 63.655],
              [20.146, 63.655],
              [20.161, 63.657],
              [20.171, 63.658],
              [20.187, 63.659],
              [20.204, 63.659],
              [20.218, 63.661],
              [20.223, 63.662],
              [20.227, 63.663],
              [20.23, 63.665],
              [20.234, 63.671],
              [20.236, 63.677],
              [20.236, 63.681],
              [20.235, 63.683],
              [20.235, 63.69],
              [20.236, 63.694],
              [20.238, 63.698],
              [20.241, 63.702],
              [20.243, 63.706],
              [20.252, 63.715],
              [20.256, 63.718],
              [20.262, 63.724],
              [20.266, 63.729],
              [20.267, 63.731],
              [20.271, 63.734],
              [20.274, 63.738],
              [20.279, 63.743],
              [20.281, 63.744],
              [20.298, 63.75],
              [20.303, 63.752],
              [20.313, 63.754],
              [20.323, 63.754],
              [20.333, 63.752],
              [20.346, 63.747],
              [20.351, 63.745],
              [20.355, 63.743],
              [20.36, 63.74],
              [20.368, 63.734],
              [20.371, 63.731],
              [20.373, 63.728],
              [20.374, 63.725],
              [20.373, 63.723],
              [20.369, 63.719],
              [20.362, 63.715],
              [20.354, 63.709],
              [20.351, 63.705],
              [20.347, 63.702],
              [20.344, 63.698],
              [20.342, 63.694],
              [20.34, 63.691],
              [20.34, 63.687],
              [20.341, 63.686],
              [20.343, 63.685],
              [20.349, 63.687],
              [20.354, 63.688],
              [20.358, 63.689],
              [20.362, 63.689],
              [20.367, 63.688],
              [20.375, 63.685],
              [20.379, 63.684],
              [20.385, 63.681],
              [20.388, 63.68],
              [20.391, 63.68],
              [20.393, 63.681],
              [20.395, 63.683],
              [20.398, 63.685],
              [20.402, 63.691],
              [20.404, 63.693],
              [20.41, 63.695],
              [20.416, 63.698],
              [20.419, 63.701],
              [20.423, 63.704],
              [20.426, 63.709],
              [20.429, 63.713],
              [20.431, 63.718],
              [20.432, 63.723],
              [20.433, 63.727],
              [20.435, 63.737],
              [20.436, 63.741],
              [20.437, 63.746],
              [20.441, 63.754],
              [20.444, 63.757],
              [20.447, 63.759],
              [20.45, 63.762],
              [20.454, 63.765],
              [20.464, 63.774],
              [20.467, 63.776],
              [20.471, 63.779],
              [20.474, 63.781],
              [20.477, 63.784],
              [20.48, 63.786],
              [20.483, 63.789],
              [20.487, 63.797],
              [20.488, 63.803],
              [20.492, 63.818],
              [20.494, 63.822],
              [20.496, 63.825],
              [20.498, 63.826],
              [20.501, 63.826],
              [20.504, 63.825],
              [20.51, 63.819],
              [20.513, 63.817],
              [20.515, 63.814],
              [20.518, 63.811],
              [20.522, 63.801],
              [20.524, 63.794],
              [20.525, 63.788],
              [20.528, 63.768],
              [20.529, 63.762],
              [20.531, 63.756],
              [20.533, 63.751],
              [20.535, 63.747],
              [20.537, 63.744],
              [20.54, 63.742],
              [20.552, 63.738],
              [20.554, 63.736],
              [20.554, 63.731],
              [20.555, 63.73],
              [20.557, 63.73],
              [20.56, 63.729],
              [20.567, 63.729],
              [20.57, 63.732],
              [20.571, 63.735],
              [20.571, 63.744],
              [20.569, 63.754],
              [20.568, 63.758],
              [20.564, 63.766],
              [20.562, 63.774],
              [20.561, 63.779],
              [20.561, 63.783],
              [20.562, 63.787],
              [20.564, 63.791],
              [20.568, 63.797],
              [20.571, 63.798],
              [20.578, 63.801],
              [20.582, 63.802],
              [20.597, 63.808],
              [20.603, 63.809],
              [20.607, 63.81],
              [20.611, 63.809],
              [20.62, 63.807],
              [20.627, 63.806],
              [20.631, 63.805],
              [20.644, 63.801],
              [20.652, 63.799],
              [20.656, 63.799],
              [20.66, 63.8],
              [20.665, 63.802],
              [20.669, 63.804],
              [20.685, 63.814],
              [20.691, 63.818],
              [20.693, 63.82],
              [20.693, 63.823],
              [20.691, 63.825],
              [20.688, 63.826],
              [20.683, 63.828],
              [20.681, 63.829],
              [20.674, 63.831],
              [20.671, 63.832],
              [20.669, 63.834],
              [20.668, 63.836],
              [20.667, 63.839],
              [20.668, 63.842],
              [20.672, 63.846],
              [20.676, 63.848],
              [20.684, 63.85],
              [20.688, 63.85],
              [20.698, 63.848],
              [20.705, 63.845],
              [20.707, 63.844],
              [20.71, 63.843],
              [20.712, 63.841],
              [20.715, 63.84],
              [20.719, 63.84],
              [20.722, 63.842],
              [20.723, 63.842],
              [20.724, 63.843],
              [20.725, 63.845],
              [20.726, 63.848],
              [20.729, 63.851],
              [20.731, 63.852],
              [20.736, 63.854],
              [20.738, 63.855],
              [20.74, 63.859],
              [20.742, 63.86],
              [20.745, 63.862],
              [20.759, 63.869],
              [20.764, 63.871],
              [20.779, 63.883],
              [20.791, 63.898],
              [20.794, 63.903],
              [20.797, 63.909],
              [20.799, 63.915],
              [20.801, 63.926],
              [20.803, 63.931],
              [20.805, 63.935],
              [20.807, 63.938],
              [20.81, 63.94],
              [20.814, 63.942],
              [20.824, 63.945],
              [20.828, 63.946],
              [20.832, 63.948],
              [20.839, 63.952],
              [20.842, 63.954],
              [20.85, 63.96],
              [20.857, 63.967],
              [20.865, 63.973],
              [20.87, 63.975],
              [20.879, 63.979],
              [20.884, 63.981],
              [20.892, 63.987],
              [20.895, 63.991],
              [20.905, 64.008],
              [20.906, 64.012],
              [20.907, 64.015],
              [20.907, 64.019],
              [20.905, 64.025],
              [20.9, 64.035],
              [22.3, 63.514],
              [22.306, 63.504],
              [22.321, 63.492],
              [22.339, 63.48],
              [22.374, 63.457],
              [22.383, 63.451],
              [22.387, 63.449],
              [22.39, 63.446],
              [22.389, 63.446],
              [22.386, 63.447],
              [22.373, 63.452],
              [22.358, 63.458],
              [22.35, 63.46],
              [22.34, 63.464],
              [22.335, 63.467],
              [22.32, 63.475],
              [22.314, 63.478],
              [22.309, 63.481],
              [22.303, 63.483],
              [22.297, 63.484],
              [22.283, 63.486],
              [22.27, 63.486],
              [22.263, 63.485],
              [22.256, 63.485],
              [22.249, 63.484],
              [22.243, 63.483],
              [22.236, 63.482],
              [22.23, 63.481],
              [22.224, 63.479],
              [22.22, 63.477],
              [22.216, 63.474],
              [22.213, 63.47],
              [22.211, 63.466],
              [22.211, 63.458],
              [22.217, 63.448],
              [22.221, 63.444],
              [22.226, 63.44],
              [22.238, 63.432],
              [22.243, 63.428],
              [22.25, 63.425],
              [22.268, 63.416],
              [22.279, 63.412],
              [22.284, 63.409],
              [22.289, 63.407],
              [22.294, 63.404],
              [22.297, 63.401],
              [22.3, 63.399],
              [22.303, 63.396],
              [22.308, 63.393],
              [22.312, 63.39],
              [22.318, 63.388],
              [22.335, 63.381],
              [22.34, 63.378],
              [22.346, 63.376],
              [22.351, 63.372],
              [22.356, 63.369],
              [22.361, 63.365],
              [22.365, 63.361],
              [22.37, 63.358],
              [22.373, 63.354],
              [22.377, 63.349],
              [22.379, 63.345],
              [22.381, 63.342],
              [22.381, 63.335],
              [22.379, 63.331],
              [22.376, 63.329],
              [22.369, 63.324],
              [22.365, 63.321],
              [22.363, 63.319],
              [22.363, 63.309],
              [22.362, 63.305],
              [22.361, 63.302],
              [22.359, 63.299],
              [22.356, 63.297],
              [22.352, 63.296],
              [22.343, 63.296],
              [22.337, 63.297],
              [22.317, 63.305],
              [22.312, 63.306],
              [22.307, 63.308],
              [22.302, 63.309],
              [22.293, 63.309],
              [22.289, 63.308],
              [22.285, 63.306],
              [22.272, 63.3],
              [22.267, 63.298],
              [22.263, 63.296],
              [22.258, 63.293],
              [22.254, 63.29],
              [22.25, 63.286],
              [22.247, 63.282],
              [22.244, 63.279],
              [22.235, 63.267],
              [22.231, 63.264],
              [22.227, 63.262],
              [22.223, 63.261],
              [22.213, 63.26],
              [22.203, 63.258],
              [22.191, 63.252],
              [22.188, 63.25],
              [22.185, 63.247],
              [22.182, 63.245],
              [22.179, 63.244],
              [22.175, 63.243],
              [22.144, 63.243],
              [22.134, 63.241],
              [22.131, 63.24],
              [22.12, 63.236],
              [22.107, 63.232],
              [22.096, 63.228],
              [22.091, 63.228],
              [22.09, 63.229],
              [22.09, 63.238],
              [22.089, 63.24],
              [22.088, 63.243],
              [22.086, 63.246],
              [22.082, 63.25],
              [22.074, 63.252],
              [22.07, 63.252],
              [22.065, 63.251],
              [22.049, 63.25],
              [22.039, 63.25],
              [22.037, 63.249],
              [22.036, 63.248],
              [22.036, 63.242],
              [22.033, 63.237],
              [22.032, 63.236],
              [22.032, 63.232],
              [22.035, 63.226],
              [22.036, 63.222],
              [22.036, 63.216],
              [22.034, 63.213],
              [22.033, 63.21],
              [22.021, 63.207],
              [22.011, 63.206],
              [22.007, 63.206],
              [21.992, 63.203],
              [21.986, 63.201],
              [21.985, 63.199],
              [21.985, 63.193],
              [21.991, 63.184],
              [21.997, 63.178],
              [22.001, 63.172],
              [22.001, 63.169],
              [22, 63.167],
              [21.998, 63.165],
              [21.995, 63.164],
              [21.984, 63.164],
              [21.976, 63.165],
              [21.97, 63.166],
              [21.967, 63.166],
              [21.965, 63.167],
              [21.963, 63.169],
              [21.963, 63.172],
              [21.962, 63.175],
              [21.962, 63.18],
              [21.963, 63.184],
              [21.964, 63.187],
              [21.966, 63.195],
              [21.965, 63.203],
              [21.967, 63.209],
              [21.97, 63.211],
              [21.974, 63.213],
              [21.979, 63.214],
              [21.984, 63.214],
              [22.001, 63.216],
              [22.006, 63.216],
              [22.014, 63.218],
              [22.016, 63.22],
              [22.017, 63.222],
              [22.016, 63.224],
              [22.015, 63.227],
              [22.01, 63.232],
              [22.009, 63.234],
              [22.009, 63.249],
              [22.007, 63.252],
              [22.004, 63.254],
              [22, 63.255],
              [21.993, 63.258],
              [21.99, 63.259],
              [21.986, 63.26],
              [21.978, 63.26],
              [21.974, 63.259],
              [21.965, 63.256],
              [21.961, 63.256],
              [21.953, 63.255],
              [21.949, 63.254],
              [21.946, 63.253],
              [21.943, 63.251],
              [21.938, 63.247],
              [21.935, 63.246],
              [21.933, 63.246],
              [21.929, 63.25],
              [21.927, 63.253],
              [21.926, 63.257],
              [21.924, 63.264],
              [21.923, 63.267],
              [21.921, 63.269],
              [21.915, 63.273],
              [21.911, 63.274],
              [21.906, 63.275],
              [21.901, 63.275],
              [21.891, 63.273],
              [21.888, 63.271],
              [21.88, 63.268],
              [21.875, 63.266],
              [21.87, 63.265],
              [21.864, 63.265],
              [21.852, 63.264],
              [21.842, 63.262],
              [21.831, 63.26],
              [21.826, 63.259],
              [21.822, 63.258],
              [21.818, 63.259],
              [21.814, 63.259],
              [21.805, 63.263],
              [21.803, 63.264],
              [21.803, 63.27],
              [21.799, 63.27],
              [21.796, 63.269],
              [21.79, 63.265],
              [21.788, 63.263],
              [21.787, 63.261],
              [21.786, 63.26],
              [21.787, 63.258],
              [21.787, 63.255],
              [21.785, 63.254],
              [21.782, 63.252],
              [21.778, 63.25],
              [21.769, 63.247],
              [21.764, 63.245],
              [21.756, 63.241],
              [21.753, 63.238],
              [21.751, 63.235],
              [21.748, 63.229],
              [21.746, 63.227],
              [21.745, 63.227],
              [21.743, 63.226],
              [21.74, 63.226],
              [21.736, 63.227],
              [21.727, 63.229],
              [21.723, 63.23],
              [21.718, 63.23],
              [21.713, 63.231],
              [21.708, 63.231],
              [21.702, 63.23],
              [21.697, 63.228],
              [21.691, 63.226],
              [21.681, 63.222],
              [21.675, 63.22],
              [21.67, 63.219],
              [21.665, 63.219],
              [21.655, 63.221],
              [21.642, 63.222],
              [21.638, 63.223],
              [21.631, 63.225],
              [21.628, 63.226],
              [21.622, 63.229],
              [21.619, 63.23],
              [21.615, 63.233],
              [21.603, 63.237],
              [21.601, 63.239],
              [21.593, 63.245],
              [21.59, 63.248],
              [21.588, 63.251],
              [21.586, 63.253],
              [21.582, 63.264],
              [21.581, 63.268],
              [21.58, 63.271],
              [21.579, 63.277],
              [21.578, 63.279],
              [21.577, 63.28],
              [21.575, 63.28],
              [21.573, 63.279],
              [21.562, 63.275],
              [21.558, 63.273],
              [21.555, 63.27],
              [21.552, 63.268],
              [21.549, 63.265],
              [21.548, 63.262],
              [21.547, 63.258],
              [21.547, 63.255],
              [21.546, 63.252],
              [21.545, 63.248],
              [21.539, 63.242],
              [21.535, 63.239],
              [21.531, 63.235],
              [21.528, 63.231],
              [21.525, 63.226],
              [21.523, 63.216],
              [21.523, 63.212],
              [21.524, 63.207],
              [21.528, 63.199],
              [21.53, 63.197],
              [21.545, 63.192],
              [21.547, 63.191],
              [21.548, 63.19],
              [21.547, 63.189],
              [21.545, 63.188],
              [21.539, 63.187],
              [21.535, 63.186],
              [21.532, 63.185],
              [21.528, 63.183],
              [21.526, 63.181],
              [21.518, 63.175],
              [21.516, 63.173],
              [21.515, 63.171],
              [21.515, 63.169],
              [21.519, 63.165],
              [21.522, 63.164],
              [21.524, 63.163],
              [21.527, 63.162],
              [21.53, 63.162],
              [21.532, 63.163],
              [21.534, 63.163],
              [21.536, 63.162],
              [21.537, 63.16],
              [21.539, 63.157],
              [21.541, 63.153],
              [21.543, 63.148],
              [21.546, 63.145],
              [21.552, 63.137],
              [21.564, 63.128],
              [21.568, 63.126],
              [21.572, 63.125],
              [21.577, 63.124],
              [21.585, 63.122],
              [21.587, 63.12],
              [21.59, 63.119],
              [21.591, 63.118],
              [21.592, 63.116],
              [21.593, 63.113],
              [21.593, 63.111],
              [21.595, 63.109],
              [21.597, 63.108],
              [21.6, 63.108],
              [21.602, 63.107],
              [21.605, 63.106],
              [21.606, 63.105],
              [21.607, 63.103],
              [21.609, 63.098],
              [21.61, 63.094],
              [21.615, 63.089],
              [21.618, 63.087],
              [21.628, 63.081],
              [21.644, 63.075],
              [21.649, 63.072],
              [21.66, 63.066],
              [21.667, 63.062],
              [21.67, 63.06],
              [21.672, 63.058],
              [21.673, 63.056],
              [21.673, 63.054],
              [21.671, 63.052],
              [21.663, 63.048],
              [21.658, 63.047],
              [21.653, 63.047],
              [21.643, 63.049],
              [21.637, 63.05],
              [21.632, 63.052],
              [21.623, 63.054],
              [21.611, 63.057],
              [21.599, 63.061],
              [21.594, 63.063],
              [21.585, 63.068],
              [21.58, 63.07],
              [21.576, 63.072],
              [21.571, 63.074],
              [21.557, 63.077],
              [21.553, 63.078],
              [21.548, 63.079],
              [21.523, 63.079],
              [21.52, 63.078],
              [21.519, 63.078],
              [21.517, 63.076],
              [21.518, 63.072],
              [21.518, 63.07],
              [21.517, 63.067],
              [21.515, 63.065],
              [21.512, 63.063],
              [21.508, 63.062],
              [21.498, 63.062],
              [21.493, 63.063],
              [21.48, 63.067],
              [21.476, 63.067],
              [21.475, 63.066],
              [21.473, 63.065],
              [21.472, 63.063],
              [21.472, 63.058],
              [21.47, 63.053],
              [21.469, 63.05],
              [21.469, 63.045],
              [21.468, 63.042],
              [21.467, 63.04],
              [21.465, 63.035],
              [21.463, 63.031],
              [21.463, 63.029],
              [21.457, 63.023],
              [21.456, 63.021],
              [21.456, 63.019],
              [21.458, 63.017],
              [21.464, 63.014],
              [21.473, 63.009],
              [21.477, 63.007],
              [21.48, 63.005],
              [21.482, 63.002],
              [21.483, 62.999],
              [21.483, 62.996],
              [21.482, 62.99],
              [21.482, 62.987],
              [21.483, 62.984],
              [21.484, 62.978],
              [21.484, 62.975],
              [21.483, 62.973],
              [21.483, 62.972],
              [21.481, 62.97],
              [21.478, 62.969],
              [21.464, 62.964],
              [21.459, 62.962],
              [21.444, 62.953],
              [21.439, 62.948],
              [21.435, 62.943],
              [21.432, 62.938],
              [21.428, 62.932],
              [21.418, 62.914],
              [21.415, 62.908],
              [21.409, 62.898],
              [21.405, 62.894],
              [21.401, 62.891],
              [21.397, 62.89],
              [21.39, 62.89],
              [21.388, 62.891],
              [21.383, 62.894],
              [21.38, 62.895],
              [21.378, 62.896],
              [21.375, 62.896],
              [21.373, 62.895],
              [21.372, 62.893],
              [21.372, 62.888],
              [21.373, 62.884],
              [21.373, 62.88],
              [21.369, 62.878],
              [21.365, 62.877],
              [21.356, 62.877],
              [21.351, 62.878],
              [21.346, 62.878],
              [21.34, 62.879],
              [21.335, 62.88],
              [21.329, 62.882],
              [21.324, 62.883],
              [21.315, 62.886],
              [21.313, 62.886],
              [21.3, 62.889],
              [21.294, 62.89],
              [21.289, 62.891],
              [21.275, 62.891],
              [21.271, 62.89],
              [21.268, 62.889],
              [21.264, 62.888],
              [21.261, 62.887],
              [21.26, 62.886],
              [21.258, 62.883],
              [21.257, 62.876],
              [21.257, 62.874],
              [21.256, 62.871],
              [21.253, 62.867],
              [21.251, 62.864],
              [21.249, 62.86],
              [21.248, 62.856],
              [21.246, 62.847],
              [21.244, 62.843],
              [21.242, 62.838],
              [21.239, 62.834],
              [21.235, 62.83],
              [21.231, 62.827],
              [21.226, 62.824],
              [21.218, 62.819],
              [21.209, 62.814],
            ],
          ],
        ],
      },
      properties: {
        id: 42,
        name: 'Norra Kvarken',
        latlon: [63.443633, 20.806637],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [19.697, 63.445],
              [21.209, 62.814],
              [21.205, 62.812],
              [21.201, 62.811],
              [21.196, 62.81],
              [21.186, 62.81],
              [21.177, 62.812],
              [21.161, 62.812],
              [21.155, 62.811],
              [21.145, 62.807],
              [21.143, 62.805],
              [21.14, 62.803],
              [21.135, 62.798],
              [21.132, 62.796],
              [21.131, 62.793],
              [21.13, 62.789],
              [21.131, 62.784],
              [21.135, 62.774],
              [21.138, 62.769],
              [21.142, 62.764],
              [21.145, 62.76],
              [21.15, 62.756],
              [21.154, 62.753],
              [21.163, 62.748],
              [21.169, 62.742],
              [21.17, 62.738],
              [21.17, 62.734],
              [21.169, 62.731],
              [21.168, 62.727],
              [21.162, 62.721],
              [21.158, 62.719],
              [21.146, 62.711],
              [21.142, 62.708],
              [21.138, 62.706],
              [21.133, 62.705],
              [21.122, 62.701],
              [21.116, 62.699],
              [21.111, 62.697],
              [21.106, 62.696],
              [21.098, 62.695],
              [21.094, 62.693],
              [21.091, 62.69],
              [21.091, 62.685],
              [21.094, 62.679],
              [21.094, 62.676],
              [21.09, 62.667],
              [21.089, 62.662],
              [21.087, 62.657],
              [21.086, 62.652],
              [21.086, 62.628],
              [21.084, 62.626],
              [21.082, 62.625],
              [21.079, 62.623],
              [21.072, 62.621],
              [21.071, 62.621],
              [21.071, 62.62],
              [21.072, 62.619],
              [21.073, 62.619],
              [21.076, 62.618],
              [21.083, 62.616],
              [21.088, 62.615],
              [21.093, 62.615],
              [21.098, 62.616],
              [21.102, 62.617],
              [21.107, 62.619],
              [21.111, 62.622],
              [21.12, 62.627],
              [21.124, 62.63],
              [21.132, 62.632],
              [21.135, 62.631],
              [21.139, 62.63],
              [21.146, 62.627],
              [21.15, 62.625],
              [21.16, 62.623],
              [21.165, 62.623],
              [21.175, 62.622],
              [21.181, 62.622],
              [21.185, 62.621],
              [21.19, 62.62],
              [21.193, 62.618],
              [21.2, 62.615],
              [21.206, 62.611],
              [21.208, 62.609],
              [21.209, 62.607],
              [21.208, 62.604],
              [21.205, 62.602],
              [21.202, 62.599],
              [21.198, 62.597],
              [21.184, 62.588],
              [21.176, 62.582],
              [21.168, 62.574],
              [21.164, 62.569],
              [21.162, 62.567],
              [21.162, 62.564],
              [21.163, 62.561],
              [21.165, 62.558],
              [21.168, 62.555],
              [21.174, 62.55],
              [21.176, 62.547],
              [21.178, 62.545],
              [21.176, 62.541],
              [21.174, 62.54],
              [21.169, 62.537],
              [21.158, 62.526],
              [21.143, 62.507],
              [21.139, 62.502],
              [21.135, 62.499],
              [21.132, 62.495],
              [21.126, 62.491],
              [21.124, 62.489],
              [21.123, 62.487],
              [21.125, 62.483],
              [21.128, 62.481],
              [21.13, 62.48],
              [21.133, 62.479],
              [21.135, 62.478],
              [21.14, 62.477],
              [21.144, 62.477],
              [21.147, 62.476],
              [21.15, 62.477],
              [21.153, 62.477],
              [21.156, 62.479],
              [21.162, 62.481],
              [21.164, 62.482],
              [21.167, 62.483],
              [21.169, 62.484],
              [21.17, 62.484],
              [21.171, 62.483],
              [21.17, 62.48],
              [21.17, 62.479],
              [21.172, 62.475],
              [21.176, 62.473],
              [21.182, 62.475],
              [21.185, 62.477],
              [21.194, 62.482],
              [21.196, 62.483],
              [21.198, 62.483],
              [21.198, 62.481],
              [21.197, 62.478],
              [21.185, 62.454],
              [21.183, 62.449],
              [21.18, 62.444],
              [21.179, 62.439],
              [21.178, 62.435],
              [21.178, 62.432],
              [21.179, 62.43],
              [21.18, 62.429],
              [21.182, 62.428],
              [21.183, 62.428],
              [21.187, 62.427],
              [21.191, 62.428],
              [21.196, 62.429],
              [21.201, 62.431],
              [21.217, 62.436],
              [21.222, 62.437],
              [21.226, 62.438],
              [21.23, 62.438],
              [21.232, 62.437],
              [21.234, 62.433],
              [21.233, 62.429],
              [21.233, 62.414],
              [21.235, 62.41],
              [21.244, 62.398],
              [21.248, 62.395],
              [21.252, 62.391],
              [21.256, 62.389],
              [21.259, 62.387],
              [21.262, 62.386],
              [21.267, 62.386],
              [21.265, 62.388],
              [21.265, 62.389],
              [21.266, 62.39],
              [21.269, 62.391],
              [21.271, 62.392],
              [21.274, 62.393],
              [21.285, 62.395],
              [21.287, 62.396],
              [21.289, 62.394],
              [21.289, 62.39],
              [21.29, 62.387],
              [21.29, 62.384],
              [21.293, 62.376],
              [21.295, 62.373],
              [21.296, 62.372],
              [21.3, 62.371],
              [21.303, 62.37],
              [21.305, 62.368],
              [21.311, 62.36],
              [21.314, 62.358],
              [21.316, 62.357],
              [21.319, 62.358],
              [21.323, 62.359],
              [21.33, 62.363],
              [21.334, 62.365],
              [21.338, 62.366],
              [21.343, 62.367],
              [21.347, 62.367],
              [21.351, 62.366],
              [21.354, 62.365],
              [21.356, 62.363],
              [21.357, 62.36],
              [21.357, 62.351],
              [21.355, 62.346],
              [21.353, 62.342],
              [21.35, 62.337],
              [21.347, 62.333],
              [21.344, 62.33],
              [21.341, 62.329],
              [21.338, 62.327],
              [21.335, 62.326],
              [21.327, 62.324],
              [21.32, 62.323],
              [21.318, 62.323],
              [21.315, 62.321],
              [21.313, 62.317],
              [21.313, 62.315],
              [21.314, 62.313],
              [21.315, 62.31],
              [21.317, 62.308],
              [21.323, 62.305],
              [21.326, 62.303],
              [21.328, 62.302],
              [21.331, 62.301],
              [21.337, 62.301],
              [21.343, 62.302],
              [21.345, 62.303],
              [21.347, 62.302],
              [21.349, 62.302],
              [21.351, 62.3],
              [21.351, 62.294],
              [21.345, 62.282],
              [21.343, 62.277],
              [21.34, 62.273],
              [21.336, 62.27],
              [21.334, 62.268],
              [21.325, 62.261],
              [21.322, 62.259],
              [21.321, 62.256],
              [21.32, 62.255],
              [21.325, 62.25],
              [21.331, 62.248],
              [21.336, 62.249],
              [21.341, 62.249],
              [21.347, 62.251],
              [21.352, 62.253],
              [21.357, 62.256],
              [21.361, 62.259],
              [21.37, 62.266],
              [21.373, 62.269],
              [21.377, 62.27],
              [21.379, 62.271],
              [21.382, 62.269],
              [21.384, 62.263],
              [21.385, 62.258],
              [21.385, 62.254],
              [21.386, 62.245],
              [21.386, 62.241],
              [21.388, 62.235],
              [21.39, 62.232],
              [21.397, 62.225],
              [21.399, 62.224],
              [21.404, 62.222],
              [21.405, 62.221],
              [21.407, 62.22],
              [21.407, 62.217],
              [21.408, 62.213],
              [21.409, 62.212],
              [21.411, 62.211],
              [21.413, 62.211],
              [21.417, 62.212],
              [21.418, 62.212],
              [21.419, 62.211],
              [21.418, 62.21],
              [21.417, 62.208],
              [21.414, 62.207],
              [21.41, 62.205],
              [21.405, 62.203],
              [21.394, 62.199],
              [21.384, 62.195],
              [21.38, 62.193],
              [21.372, 62.188],
              [21.368, 62.184],
              [21.366, 62.181],
              [21.365, 62.179],
              [21.365, 62.177],
              [21.364, 62.174],
              [21.363, 62.17],
              [21.362, 62.161],
              [21.362, 62.156],
              [21.36, 62.148],
              [21.356, 62.144],
              [21.353, 62.143],
              [21.349, 62.142],
              [21.345, 62.142],
              [21.342, 62.143],
              [21.338, 62.144],
              [21.335, 62.146],
              [21.329, 62.151],
              [21.327, 62.152],
              [21.324, 62.152],
              [21.322, 62.151],
              [21.319, 62.151],
              [21.317, 62.15],
              [21.315, 62.148],
              [21.314, 62.146],
              [21.314, 62.142],
              [21.315, 62.131],
              [21.317, 62.12],
              [21.318, 62.108],
              [21.318, 62.079],
              [21.317, 62.074],
              [21.315, 62.071],
              [21.313, 62.065],
              [21.311, 62.061],
              [21.308, 62.044],
              [21.3, 62.02],
              [21.293, 62.002],
              [17.445, 62.001],
              [17.444, 62.004],
              [17.442, 62.006],
              [17.433, 62.014],
              [17.43, 62.016],
              [17.429, 62.019],
              [17.43, 62.021],
              [17.432, 62.024],
              [17.434, 62.026],
              [17.449, 62.036],
              [17.451, 62.038],
              [17.453, 62.044],
              [17.452, 62.048],
              [17.45, 62.054],
              [17.446, 62.059],
              [17.445, 62.061],
              [17.445, 62.063],
              [17.446, 62.066],
              [17.448, 62.068],
              [17.455, 62.074],
              [17.461, 62.082],
              [17.463, 62.087],
              [17.465, 62.093],
              [17.47, 62.104],
              [17.472, 62.11],
              [17.475, 62.116],
              [17.481, 62.126],
              [17.504, 62.149],
              [17.506, 62.153],
              [17.507, 62.157],
              [17.509, 62.166],
              [17.509, 62.17],
              [17.511, 62.172],
              [17.515, 62.174],
              [17.517, 62.174],
              [17.519, 62.173],
              [17.522, 62.172],
              [17.524, 62.171],
              [17.527, 62.172],
              [17.529, 62.172],
              [17.53, 62.174],
              [17.531, 62.175],
              [17.531, 62.178],
              [17.529, 62.18],
              [17.527, 62.183],
              [17.524, 62.185],
              [17.517, 62.189],
              [17.511, 62.195],
              [17.505, 62.204],
              [17.504, 62.208],
              [17.504, 62.214],
              [17.505, 62.218],
              [17.507, 62.22],
              [17.511, 62.223],
              [17.515, 62.225],
              [17.52, 62.227],
              [17.525, 62.228],
              [17.531, 62.229],
              [17.537, 62.229],
              [17.542, 62.228],
              [17.548, 62.228],
              [17.553, 62.227],
              [17.557, 62.226],
              [17.559, 62.226],
              [17.561, 62.224],
              [17.564, 62.223],
              [17.565, 62.221],
              [17.564, 62.219],
              [17.563, 62.218],
              [17.562, 62.216],
              [17.554, 62.212],
              [17.545, 62.209],
              [17.54, 62.207],
              [17.537, 62.205],
              [17.535, 62.203],
              [17.534, 62.201],
              [17.534, 62.198],
              [17.536, 62.196],
              [17.539, 62.194],
              [17.547, 62.192],
              [17.552, 62.191],
              [17.557, 62.191],
              [17.562, 62.192],
              [17.568, 62.193],
              [17.573, 62.194],
              [17.582, 62.197],
              [17.587, 62.199],
              [17.597, 62.202],
              [17.601, 62.204],
              [17.604, 62.205],
              [17.61, 62.211],
              [17.612, 62.212],
              [17.616, 62.213],
              [17.619, 62.214],
              [17.623, 62.214],
              [17.628, 62.215],
              [17.632, 62.217],
              [17.636, 62.218],
              [17.64, 62.221],
              [17.646, 62.225],
              [17.648, 62.228],
              [17.648, 62.23],
              [17.647, 62.232],
              [17.644, 62.234],
              [17.629, 62.24],
              [17.623, 62.241],
              [17.616, 62.243],
              [17.603, 62.245],
              [17.589, 62.248],
              [17.583, 62.249],
              [17.562, 62.252],
              [17.524, 62.252],
              [17.519, 62.253],
              [17.485, 62.261],
              [17.473, 62.264],
              [17.471, 62.266],
              [17.471, 62.267],
              [17.472, 62.269],
              [17.473, 62.269],
              [17.478, 62.271],
              [17.48, 62.272],
              [17.48, 62.275],
              [17.479, 62.277],
              [17.477, 62.279],
              [17.471, 62.282],
              [17.468, 62.284],
              [17.464, 62.286],
              [17.461, 62.288],
              [17.459, 62.291],
              [17.459, 62.294],
              [17.458, 62.3],
              [17.457, 62.303],
              [17.455, 62.306],
              [17.448, 62.313],
              [17.443, 62.316],
              [17.439, 62.319],
              [17.434, 62.322],
              [17.424, 62.326],
              [17.418, 62.328],
              [17.413, 62.329],
              [17.409, 62.329],
              [17.406, 62.328],
              [17.402, 62.328],
              [17.399, 62.327],
              [17.397, 62.326],
              [17.395, 62.324],
              [17.391, 62.319],
              [17.389, 62.317],
              [17.386, 62.315],
              [17.384, 62.314],
              [17.382, 62.314],
              [17.381, 62.315],
              [17.379, 62.318],
              [17.378, 62.322],
              [17.376, 62.327],
              [17.372, 62.35],
              [17.371, 62.355],
              [17.369, 62.361],
              [17.363, 62.371],
              [17.36, 62.375],
              [17.345, 62.384],
              [17.333, 62.389],
              [17.33, 62.391],
              [17.329, 62.392],
              [17.333, 62.394],
              [17.336, 62.395],
              [17.363, 62.395],
              [17.378, 62.398],
              [17.382, 62.4],
              [17.385, 62.402],
              [17.388, 62.405],
              [17.389, 62.409],
              [17.389, 62.413],
              [17.388, 62.418],
              [17.387, 62.427],
              [17.386, 62.43],
              [17.385, 62.434],
              [17.382, 62.439],
              [17.379, 62.443],
              [17.374, 62.448],
              [17.364, 62.456],
              [17.358, 62.46],
              [17.353, 62.462],
              [17.347, 62.465],
              [17.338, 62.469],
              [17.334, 62.47],
              [17.332, 62.472],
              [17.332, 62.473],
              [17.333, 62.475],
              [17.336, 62.478],
              [17.338, 62.481],
              [17.339, 62.482],
              [17.342, 62.484],
              [17.344, 62.485],
              [17.349, 62.487],
              [17.363, 62.489],
              [17.366, 62.49],
              [17.369, 62.49],
              [17.371, 62.491],
              [17.374, 62.494],
              [17.38, 62.497],
              [17.384, 62.498],
              [17.396, 62.5],
              [17.409, 62.502],
              [17.437, 62.506],
              [17.451, 62.507],
              [17.458, 62.508],
              [17.464, 62.508],
              [17.471, 62.507],
              [17.478, 62.507],
              [17.49, 62.503],
              [17.495, 62.5],
              [17.501, 62.496],
              [17.506, 62.492],
              [17.515, 62.483],
              [17.531, 62.463],
              [17.535, 62.459],
              [17.545, 62.451],
              [17.55, 62.449],
              [17.556, 62.446],
              [17.562, 62.445],
              [17.574, 62.441],
              [17.58, 62.44],
              [17.587, 62.439],
              [17.593, 62.438],
              [17.599, 62.438],
              [17.616, 62.437],
              [17.626, 62.436],
              [17.632, 62.436],
              [17.642, 62.437],
              [17.66, 62.437],
              [17.679, 62.435],
              [17.685, 62.435],
              [17.69, 62.434],
              [17.695, 62.435],
              [17.699, 62.436],
              [17.701, 62.437],
              [17.702, 62.439],
              [17.702, 62.44],
              [17.7, 62.442],
              [17.697, 62.444],
              [17.693, 62.446],
              [17.688, 62.448],
              [17.684, 62.451],
              [17.68, 62.453],
              [17.676, 62.456],
              [17.673, 62.46],
              [17.671, 62.463],
              [17.67, 62.467],
              [17.67, 62.471],
              [17.671, 62.475],
              [17.677, 62.483],
              [17.685, 62.491],
              [17.689, 62.494],
              [17.699, 62.498],
              [17.704, 62.499],
              [17.721, 62.504],
              [17.725, 62.505],
              [17.73, 62.506],
              [17.751, 62.506],
              [17.772, 62.503],
              [17.777, 62.502],
              [17.783, 62.5],
              [17.787, 62.499],
              [17.798, 62.494],
              [17.806, 62.491],
              [17.811, 62.489],
              [17.815, 62.488],
              [17.821, 62.488],
              [17.825, 62.489],
              [17.834, 62.492],
              [17.839, 62.493],
              [17.844, 62.495],
              [17.848, 62.497],
              [17.861, 62.506],
              [17.866, 62.509],
              [17.87, 62.513],
              [17.874, 62.516],
              [17.876, 62.52],
              [17.877, 62.524],
              [17.877, 62.543],
              [17.879, 62.545],
              [17.882, 62.545],
              [17.888, 62.546],
              [17.891, 62.547],
              [17.893, 62.548],
              [17.894, 62.549],
              [17.897, 62.551],
              [17.904, 62.558],
              [17.907, 62.562],
              [17.909, 62.566],
              [17.911, 62.571],
              [17.914, 62.58],
              [17.915, 62.582],
              [17.916, 62.585],
              [17.919, 62.589],
              [17.92, 62.591],
              [17.92, 62.594],
              [17.921, 62.597],
              [17.92, 62.6],
              [17.919, 62.602],
              [17.917, 62.604],
              [17.916, 62.606],
              [17.914, 62.608],
              [17.914, 62.612],
              [17.915, 62.614],
              [17.927, 62.626],
              [17.929, 62.63],
              [17.93, 62.634],
              [17.93, 62.639],
              [17.929, 62.644],
              [17.926, 62.648],
              [17.923, 62.651],
              [17.918, 62.654],
              [17.908, 62.658],
              [17.902, 62.66],
              [17.878, 62.664],
              [17.873, 62.665],
              [17.868, 62.667],
              [17.864, 62.668],
              [17.861, 62.67],
              [17.86, 62.672],
              [17.861, 62.673],
              [17.862, 62.673],
              [17.865, 62.674],
              [17.868, 62.674],
              [17.881, 62.672],
              [17.897, 62.672],
              [17.903, 62.673],
              [17.92, 62.673],
              [17.926, 62.672],
              [17.932, 62.67],
              [17.938, 62.669],
              [17.95, 62.665],
              [17.955, 62.663],
              [17.961, 62.662],
              [17.966, 62.661],
              [17.97, 62.661],
              [17.976, 62.663],
              [17.977, 62.664],
              [17.978, 62.666],
              [17.978, 62.679],
              [17.981, 62.688],
              [17.981, 62.696],
              [17.979, 62.706],
              [17.975, 62.714],
              [17.964, 62.725],
              [17.96, 62.731],
              [17.96, 62.736],
              [17.961, 62.739],
              [17.961, 62.744],
              [17.96, 62.748],
              [17.954, 62.756],
              [17.942, 62.768],
              [17.938, 62.773],
              [17.931, 62.783],
              [17.922, 62.792],
              [17.917, 62.795],
              [17.911, 62.798],
              [17.905, 62.802],
              [17.883, 62.812],
              [17.878, 62.815],
              [17.874, 62.817],
              [17.871, 62.82],
              [17.871, 62.824],
              [17.872, 62.827],
              [17.872, 62.828],
              [17.874, 62.83],
              [17.878, 62.833],
              [17.881, 62.835],
              [17.883, 62.837],
              [17.884, 62.84],
              [17.884, 62.843],
              [17.886, 62.853],
              [17.886, 62.856],
              [17.884, 62.862],
              [17.878, 62.868],
              [17.874, 62.876],
              [17.862, 62.892],
              [17.858, 62.896],
              [17.847, 62.91],
              [17.843, 62.915],
              [17.839, 62.919],
              [17.835, 62.924],
              [17.82, 62.933],
              [17.814, 62.936],
              [17.808, 62.938],
              [17.803, 62.94],
              [17.788, 62.943],
              [17.778, 62.947],
              [17.772, 62.95],
              [17.767, 62.954],
              [17.757, 62.961],
              [17.752, 62.965],
              [17.747, 62.968],
              [17.741, 62.971],
              [17.736, 62.973],
              [17.73, 62.975],
              [17.713, 62.98],
              [17.703, 62.984],
              [17.699, 62.987],
              [17.694, 62.992],
              [17.693, 62.994],
              [17.693, 62.996],
              [17.698, 62.996],
              [17.702, 62.995],
              [17.72, 62.99],
              [17.726, 62.988],
              [17.732, 62.987],
              [17.741, 62.987],
              [17.745, 62.988],
              [17.748, 62.989],
              [17.752, 62.99],
              [17.758, 62.995],
              [17.762, 62.998],
              [17.765, 63.001],
              [17.766, 63.005],
              [17.768, 63.009],
              [17.77, 63.017],
              [17.77, 63.025],
              [17.769, 63.03],
              [17.767, 63.035],
              [17.762, 63.046],
              [17.759, 63.052],
              [17.757, 63.057],
              [17.756, 63.063],
              [17.756, 63.069],
              [17.758, 63.079],
              [17.76, 63.083],
              [17.762, 63.085],
              [17.766, 63.085],
              [17.769, 63.083],
              [17.771, 63.079],
              [17.773, 63.074],
              [17.776, 63.069],
              [17.784, 63.043],
              [17.79, 63.031],
              [17.796, 63.021],
              [17.8, 63.016],
              [17.804, 63.013],
              [17.811, 63.007],
              [17.813, 63.005],
              [17.814, 63.003],
              [17.814, 63.002],
              [17.802, 62.996],
              [17.8, 62.994],
              [17.798, 62.991],
              [17.798, 62.985],
              [17.8, 62.982],
              [17.803, 62.979],
              [17.806, 62.977],
              [17.814, 62.972],
              [17.817, 62.969],
              [17.824, 62.963],
              [17.828, 62.96],
              [17.835, 62.955],
              [17.839, 62.952],
              [17.843, 62.95],
              [17.851, 62.941],
              [17.859, 62.933],
              [17.864, 62.929],
              [17.87, 62.926],
              [17.875, 62.922],
              [17.881, 62.92],
              [17.886, 62.918],
              [17.892, 62.917],
              [17.901, 62.917],
              [17.907, 62.918],
              [17.91, 62.918],
              [17.914, 62.916],
              [17.915, 62.914],
              [17.916, 62.911],
              [17.916, 62.904],
              [17.91, 62.892],
              [17.908, 62.886],
              [17.906, 62.881],
              [17.906, 62.869],
              [17.907, 62.863],
              [17.908, 62.856],
              [17.909, 62.85],
              [17.911, 62.844],
              [17.917, 62.834],
              [17.92, 62.83],
              [17.924, 62.827],
              [17.931, 62.82],
              [17.94, 62.81],
              [17.942, 62.808],
              [17.945, 62.802],
              [17.949, 62.8],
              [17.952, 62.8],
              [17.956, 62.801],
              [17.959, 62.803],
              [17.963, 62.807],
              [17.964, 62.809],
              [17.965, 62.81],
              [17.966, 62.815],
              [17.967, 62.817],
              [17.975, 62.825],
              [17.979, 62.828],
              [17.987, 62.832],
              [17.997, 62.835],
              [18.009, 62.841],
              [18.015, 62.843],
              [18.018, 62.845],
              [18.02, 62.846],
              [18.025, 62.851],
              [18.028, 62.853],
              [18.031, 62.854],
              [18.035, 62.855],
              [18.041, 62.855],
              [18.043, 62.854],
              [18.047, 62.851],
              [18.056, 62.848],
              [18.068, 62.843],
              [18.073, 62.841],
              [18.079, 62.839],
              [18.096, 62.835],
              [18.102, 62.833],
              [18.117, 62.827],
              [18.126, 62.825],
              [18.132, 62.823],
              [18.137, 62.82],
              [18.146, 62.817],
              [18.148, 62.816],
              [18.148, 62.814],
              [18.146, 62.813],
              [18.143, 62.812],
              [18.138, 62.812],
              [18.133, 62.811],
              [18.109, 62.811],
              [18.103, 62.812],
              [18.096, 62.812],
              [18.079, 62.814],
              [18.074, 62.815],
              [18.066, 62.815],
              [18.056, 62.817],
              [18.051, 62.817],
              [18.046, 62.818],
              [18.03, 62.817],
              [18.019, 62.817],
              [18.009, 62.819],
              [18, 62.819],
              [17.997, 62.818],
              [17.995, 62.816],
              [17.994, 62.814],
              [17.994, 62.812],
              [17.995, 62.81],
              [17.998, 62.808],
              [18.002, 62.806],
              [18.012, 62.802],
              [18.018, 62.801],
              [18.023, 62.8],
              [18.03, 62.799],
              [18.036, 62.798],
              [18.055, 62.797],
              [18.06, 62.797],
              [18.065, 62.796],
              [18.069, 62.795],
              [18.073, 62.793],
              [18.081, 62.785],
              [18.084, 62.783],
              [18.092, 62.78],
              [18.096, 62.779],
              [18.101, 62.777],
              [18.107, 62.776],
              [18.112, 62.775],
              [18.123, 62.775],
              [18.128, 62.776],
              [18.132, 62.778],
              [18.137, 62.779],
              [18.141, 62.782],
              [18.151, 62.789],
              [18.154, 62.792],
              [18.158, 62.795],
              [18.161, 62.799],
              [18.174, 62.812],
              [18.176, 62.812],
              [18.18, 62.81],
              [18.184, 62.804],
              [18.187, 62.801],
              [18.19, 62.799],
              [18.198, 62.797],
              [18.208, 62.797],
              [18.214, 62.798],
              [18.219, 62.799],
              [18.224, 62.801],
              [18.236, 62.807],
              [18.246, 62.811],
              [18.251, 62.814],
              [18.256, 62.816],
              [18.261, 62.82],
              [18.265, 62.823],
              [18.269, 62.827],
              [18.273, 62.835],
              [18.274, 62.839],
              [18.273, 62.842],
              [18.271, 62.845],
              [18.268, 62.847],
              [18.258, 62.849],
              [18.253, 62.848],
              [18.247, 62.847],
              [18.242, 62.846],
              [18.237, 62.844],
              [18.228, 62.839],
              [18.224, 62.838],
              [18.216, 62.838],
              [18.213, 62.839],
              [18.21, 62.842],
              [18.208, 62.846],
              [18.206, 62.851],
              [18.203, 62.865],
              [18.201, 62.87],
              [18.201, 62.872],
              [18.203, 62.876],
              [18.207, 62.879],
              [18.21, 62.883],
              [18.211, 62.884],
              [18.214, 62.885],
              [18.216, 62.886],
              [18.22, 62.886],
              [18.228, 62.887],
              [18.232, 62.888],
              [18.24, 62.888],
              [18.244, 62.89],
              [18.245, 62.893],
              [18.246, 62.895],
              [18.248, 62.897],
              [18.256, 62.899],
              [18.26, 62.899],
              [18.264, 62.9],
              [18.269, 62.9],
              [18.284, 62.899],
              [18.286, 62.899],
              [18.288, 62.898],
              [18.29, 62.896],
              [18.292, 62.892],
              [18.293, 62.889],
              [18.295, 62.884],
              [18.298, 62.881],
              [18.301, 62.877],
              [18.304, 62.875],
              [18.308, 62.873],
              [18.313, 62.872],
              [18.317, 62.872],
              [18.326, 62.875],
              [18.33, 62.875],
              [18.33, 62.874],
              [18.329, 62.871],
              [18.326, 62.865],
              [18.324, 62.857],
              [18.324, 62.854],
              [18.325, 62.851],
              [18.326, 62.849],
              [18.328, 62.847],
              [18.331, 62.846],
              [18.336, 62.844],
              [18.341, 62.841],
              [18.345, 62.84],
              [18.354, 62.84],
              [18.359, 62.841],
              [18.365, 62.842],
              [18.37, 62.844],
              [18.376, 62.846],
              [18.381, 62.848],
              [18.387, 62.851],
              [18.392, 62.853],
              [18.407, 62.862],
              [18.415, 62.866],
              [18.42, 62.867],
              [18.428, 62.869],
              [18.438, 62.873],
              [18.442, 62.875],
              [18.445, 62.878],
              [18.447, 62.881],
              [18.448, 62.884],
              [18.448, 62.888],
              [18.447, 62.891],
              [18.444, 62.894],
              [18.44, 62.897],
              [18.434, 62.9],
              [18.429, 62.903],
              [18.423, 62.905],
              [18.408, 62.911],
              [18.405, 62.912],
              [18.404, 62.913],
              [18.407, 62.913],
              [18.414, 62.912],
              [18.419, 62.911],
              [18.425, 62.911],
              [18.442, 62.91],
              [18.452, 62.909],
              [18.461, 62.909],
              [18.468, 62.908],
              [18.472, 62.908],
              [18.476, 62.909],
              [18.488, 62.915],
              [18.492, 62.918],
              [18.498, 62.924],
              [18.499, 62.927],
              [18.499, 62.93],
              [18.498, 62.932],
              [18.496, 62.935],
              [18.493, 62.937],
              [18.489, 62.938],
              [18.484, 62.939],
              [18.479, 62.938],
              [18.473, 62.938],
              [18.462, 62.936],
              [18.457, 62.935],
              [18.452, 62.935],
              [18.444, 62.937],
              [18.438, 62.942],
              [18.434, 62.943],
              [18.43, 62.945],
              [18.417, 62.949],
              [18.412, 62.95],
              [18.409, 62.951],
              [18.405, 62.952],
              [18.401, 62.952],
              [18.397, 62.953],
              [18.393, 62.952],
              [18.39, 62.952],
              [18.387, 62.951],
              [18.384, 62.949],
              [18.38, 62.947],
              [18.379, 62.948],
              [18.379, 62.949],
              [18.38, 62.951],
              [18.386, 62.955],
              [18.39, 62.957],
              [18.403, 62.963],
              [18.407, 62.964],
              [18.414, 62.969],
              [18.418, 62.97],
              [18.423, 62.97],
              [18.431, 62.968],
              [18.442, 62.967],
              [18.448, 62.967],
              [18.462, 62.966],
              [18.468, 62.966],
              [18.483, 62.964],
              [18.499, 62.962],
              [18.506, 62.961],
              [18.509, 62.961],
              [18.515, 62.963],
              [18.517, 62.964],
              [18.52, 62.966],
              [18.522, 62.967],
              [18.528, 62.967],
              [18.535, 62.965],
              [18.542, 62.965],
              [18.545, 62.966],
              [18.546, 62.968],
              [18.546, 62.97],
              [18.545, 62.972],
              [18.539, 62.981],
              [18.535, 62.984],
              [18.531, 62.986],
              [18.527, 62.989],
              [18.522, 62.991],
              [18.516, 62.993],
              [18.51, 62.994],
              [18.504, 62.996],
              [18.483, 62.999],
              [18.47, 63],
              [18.442, 63.002],
              [18.421, 63.004],
              [18.4, 63.004],
              [18.394, 63.003],
              [18.387, 63.003],
              [18.381, 63.002],
              [18.368, 63],
              [18.35, 62.997],
              [18.344, 62.995],
              [18.333, 62.992],
              [18.327, 62.99],
              [18.322, 62.989],
              [18.313, 62.989],
              [18.309, 62.99],
              [18.3, 62.992],
              [18.295, 62.993],
              [18.285, 62.994],
              [18.271, 62.996],
              [18.243, 62.999],
              [18.237, 63],
              [18.231, 63.002],
              [18.225, 63.003],
              [18.221, 63.004],
              [18.218, 63.006],
              [18.215, 63.007],
              [18.215, 63.008],
              [18.219, 63.008],
              [18.232, 63.007],
              [18.237, 63.006],
              [18.264, 63.006],
              [18.278, 63.008],
              [18.285, 63.01],
              [18.291, 63.011],
              [18.303, 63.015],
              [18.317, 63.018],
              [18.321, 63.019],
              [18.324, 63.021],
              [18.325, 63.023],
              [18.326, 63.024],
              [18.327, 63.027],
              [18.327, 63.032],
              [18.328, 63.035],
              [18.33, 63.038],
              [18.336, 63.042],
              [18.34, 63.041],
              [18.345, 63.04],
              [18.35, 63.038],
              [18.361, 63.032],
              [18.366, 63.029],
              [18.373, 63.026],
              [18.379, 63.025],
              [18.385, 63.023],
              [18.392, 63.022],
              [18.398, 63.022],
              [18.404, 63.021],
              [18.413, 63.021],
              [18.416, 63.022],
              [18.418, 63.023],
              [18.415, 63.026],
              [18.412, 63.028],
              [18.405, 63.033],
              [18.401, 63.036],
              [18.389, 63.046],
              [18.382, 63.051],
              [18.377, 63.056],
              [18.377, 63.058],
              [18.378, 63.06],
              [18.38, 63.061],
              [18.384, 63.062],
              [18.393, 63.062],
              [18.408, 63.061],
              [18.413, 63.061],
              [18.423, 63.059],
              [18.433, 63.055],
              [18.438, 63.052],
              [18.453, 63.037],
              [18.456, 63.035],
              [18.459, 63.034],
              [18.463, 63.033],
              [18.467, 63.034],
              [18.47, 63.036],
              [18.474, 63.038],
              [18.477, 63.042],
              [18.488, 63.054],
              [18.506, 63.072],
              [18.508, 63.075],
              [18.509, 63.078],
              [18.509, 63.085],
              [18.511, 63.088],
              [18.517, 63.092],
              [18.521, 63.095],
              [18.524, 63.097],
              [18.531, 63.105],
              [18.534, 63.107],
              [18.536, 63.109],
              [18.537, 63.112],
              [18.537, 63.113],
              [18.536, 63.115],
              [18.534, 63.12],
              [18.533, 63.124],
              [18.531, 63.139],
              [18.53, 63.143],
              [18.529, 63.145],
              [18.527, 63.151],
              [18.527, 63.152],
              [18.528, 63.154],
              [18.53, 63.155],
              [18.534, 63.155],
              [18.537, 63.154],
              [18.541, 63.153],
              [18.545, 63.151],
              [18.548, 63.148],
              [18.554, 63.141],
              [18.558, 63.137],
              [18.566, 63.131],
              [18.571, 63.128],
              [18.576, 63.127],
              [18.58, 63.126],
              [18.585, 63.127],
              [18.588, 63.128],
              [18.591, 63.131],
              [18.593, 63.135],
              [18.595, 63.138],
              [18.597, 63.146],
              [18.597, 63.157],
              [18.598, 63.163],
              [18.598, 63.165],
              [18.597, 63.167],
              [18.594, 63.172],
              [18.593, 63.174],
              [18.593, 63.176],
              [18.595, 63.178],
              [18.603, 63.18],
              [18.609, 63.181],
              [18.614, 63.182],
              [18.634, 63.182],
              [18.64, 63.181],
              [18.647, 63.179],
              [18.665, 63.173],
              [18.677, 63.171],
              [18.689, 63.17],
              [18.695, 63.169],
              [18.704, 63.167],
              [18.708, 63.166],
              [18.711, 63.167],
              [18.713, 63.168],
              [18.713, 63.169],
              [18.712, 63.172],
              [18.707, 63.181],
              [18.705, 63.185],
              [18.704, 63.19],
              [18.702, 63.195],
              [18.701, 63.199],
              [18.699, 63.204],
              [18.696, 63.208],
              [18.691, 63.216],
              [18.684, 63.223],
              [18.68, 63.226],
              [18.673, 63.231],
              [18.669, 63.235],
              [18.67, 63.237],
              [18.674, 63.241],
              [18.678, 63.243],
              [18.682, 63.243],
              [18.687, 63.244],
              [18.699, 63.242],
              [18.719, 63.238],
              [18.733, 63.235],
              [18.774, 63.228],
              [18.785, 63.226],
              [18.789, 63.225],
              [18.791, 63.224],
              [18.792, 63.223],
              [18.791, 63.223],
              [18.788, 63.222],
              [18.766, 63.222],
              [18.76, 63.223],
              [18.75, 63.224],
              [18.74, 63.224],
              [18.736, 63.223],
              [18.731, 63.223],
              [18.727, 63.221],
              [18.724, 63.219],
              [18.721, 63.216],
              [18.719, 63.212],
              [18.718, 63.207],
              [18.718, 63.203],
              [18.72, 63.197],
              [18.722, 63.194],
              [18.728, 63.19],
              [18.737, 63.185],
              [18.74, 63.183],
              [18.742, 63.183],
              [18.745, 63.182],
              [18.748, 63.183],
              [18.75, 63.184],
              [18.753, 63.185],
              [18.763, 63.189],
              [18.766, 63.191],
              [18.767, 63.193],
              [18.768, 63.194],
              [18.767, 63.195],
              [18.766, 63.197],
              [18.761, 63.201],
              [18.76, 63.202],
              [18.76, 63.203],
              [18.767, 63.203],
              [18.782, 63.2],
              [18.788, 63.199],
              [18.799, 63.199],
              [18.805, 63.2],
              [18.811, 63.202],
              [18.822, 63.205],
              [18.828, 63.207],
              [18.839, 63.207],
              [18.856, 63.206],
              [18.862, 63.206],
              [18.866, 63.207],
              [18.871, 63.208],
              [18.875, 63.209],
              [18.879, 63.211],
              [18.882, 63.213],
              [18.885, 63.216],
              [18.889, 63.222],
              [18.89, 63.225],
              [18.889, 63.227],
              [18.887, 63.229],
              [18.884, 63.231],
              [18.879, 63.233],
              [18.874, 63.234],
              [18.868, 63.235],
              [18.847, 63.238],
              [18.819, 63.241],
              [18.804, 63.243],
              [18.797, 63.244],
              [18.79, 63.246],
              [18.783, 63.247],
              [18.769, 63.251],
              [18.749, 63.258],
              [18.731, 63.263],
              [18.721, 63.267],
              [18.716, 63.272],
              [18.715, 63.274],
              [18.715, 63.277],
              [18.719, 63.279],
              [18.724, 63.279],
              [18.734, 63.277],
              [18.74, 63.276],
              [18.746, 63.274],
              [18.769, 63.266],
              [18.775, 63.265],
              [18.786, 63.265],
              [18.792, 63.266],
              [18.798, 63.268],
              [18.804, 63.269],
              [18.819, 63.275],
              [18.823, 63.276],
              [18.83, 63.276],
              [18.832, 63.275],
              [18.832, 63.271],
              [18.833, 63.27],
              [18.834, 63.268],
              [18.836, 63.267],
              [18.842, 63.265],
              [18.845, 63.265],
              [18.848, 63.266],
              [18.853, 63.271],
              [18.854, 63.273],
              [18.857, 63.282],
              [18.858, 63.284],
              [18.86, 63.286],
              [18.866, 63.286],
              [18.869, 63.285],
              [18.877, 63.281],
              [18.881, 63.277],
              [18.895, 63.266],
              [18.905, 63.258],
              [18.91, 63.255],
              [18.916, 63.251],
              [18.921, 63.248],
              [18.926, 63.246],
              [18.931, 63.243],
              [18.936, 63.241],
              [18.947, 63.238],
              [18.949, 63.236],
              [18.949, 63.234],
              [18.948, 63.232],
              [18.948, 63.23],
              [18.95, 63.224],
              [18.954, 63.22],
              [18.963, 63.214],
              [18.966, 63.213],
              [18.97, 63.211],
              [18.98, 63.207],
              [18.984, 63.205],
              [18.993, 63.2],
              [18.997, 63.198],
              [19.01, 63.193],
              [19.014, 63.192],
              [19.022, 63.192],
              [19.026, 63.193],
              [19.028, 63.194],
              [19.031, 63.196],
              [19.033, 63.2],
              [19.034, 63.203],
              [19.033, 63.205],
              [19.033, 63.206],
              [19.034, 63.208],
              [19.036, 63.209],
              [19.039, 63.21],
              [19.043, 63.211],
              [19.051, 63.211],
              [19.061, 63.213],
              [19.067, 63.214],
              [19.072, 63.216],
              [19.076, 63.218],
              [19.08, 63.222],
              [19.081, 63.224],
              [19.081, 63.226],
              [19.079, 63.228],
              [19.076, 63.229],
              [19.072, 63.231],
              [19.067, 63.231],
              [19.062, 63.232],
              [19.051, 63.233],
              [19.047, 63.234],
              [19.043, 63.234],
              [19.039, 63.233],
              [19.031, 63.232],
              [19.028, 63.232],
              [19.025, 63.233],
              [19.023, 63.234],
              [19.018, 63.237],
              [19.016, 63.238],
              [19.01, 63.24],
              [19.008, 63.241],
              [19.004, 63.244],
              [19.002, 63.245],
              [18.998, 63.246],
              [18.997, 63.247],
              [18.998, 63.248],
              [19.001, 63.249],
              [19.016, 63.252],
              [19.026, 63.255],
              [19.032, 63.256],
              [19.044, 63.256],
              [19.051, 63.255],
              [19.057, 63.252],
              [19.058, 63.251],
              [19.059, 63.248],
              [19.06, 63.247],
              [19.062, 63.246],
              [19.065, 63.245],
              [19.069, 63.244],
              [19.073, 63.244],
              [19.085, 63.243],
              [19.09, 63.244],
              [19.094, 63.245],
              [19.104, 63.249],
              [19.115, 63.254],
              [19.118, 63.257],
              [19.118, 63.258],
              [19.115, 63.264],
              [19.112, 63.268],
              [19.111, 63.27],
              [19.112, 63.272],
              [19.115, 63.279],
              [19.119, 63.287],
              [19.124, 63.299],
              [19.125, 63.301],
              [19.125, 63.305],
              [19.124, 63.311],
              [19.124, 63.314],
              [19.125, 63.317],
              [19.129, 63.321],
              [19.131, 63.324],
              [19.133, 63.326],
              [19.136, 63.327],
              [19.14, 63.328],
              [19.144, 63.328],
              [19.152, 63.326],
              [19.159, 63.324],
              [19.167, 63.322],
              [19.172, 63.323],
              [19.18, 63.325],
              [19.186, 63.328],
              [19.189, 63.33],
              [19.198, 63.333],
              [19.202, 63.335],
              [19.206, 63.338],
              [19.209, 63.34],
              [19.211, 63.342],
              [19.214, 63.342],
              [19.219, 63.337],
              [19.222, 63.335],
              [19.225, 63.334],
              [19.229, 63.333],
              [19.234, 63.333],
              [19.238, 63.334],
              [19.244, 63.34],
              [19.247, 63.345],
              [19.248, 63.351],
              [19.25, 63.357],
              [19.251, 63.363],
              [19.252, 63.37],
              [19.252, 63.377],
              [19.255, 63.406],
              [19.259, 63.434],
              [19.263, 63.446],
              [19.266, 63.451],
              [19.27, 63.454],
              [19.273, 63.457],
              [19.277, 63.46],
              [19.282, 63.463],
              [19.286, 63.466],
              [19.291, 63.468],
              [19.295, 63.469],
              [19.299, 63.469],
              [19.302, 63.468],
              [19.305, 63.466],
              [19.309, 63.463],
              [19.313, 63.461],
              [19.318, 63.459],
              [19.334, 63.455],
              [19.337, 63.454],
              [19.339, 63.453],
              [19.342, 63.45],
              [19.344, 63.449],
              [19.347, 63.448],
              [19.349, 63.448],
              [19.352, 63.449],
              [19.354, 63.451],
              [19.356, 63.454],
              [19.356, 63.461],
              [19.355, 63.465],
              [19.353, 63.469],
              [19.351, 63.472],
              [19.348, 63.476],
              [19.345, 63.478],
              [19.341, 63.481],
              [19.337, 63.482],
              [19.331, 63.484],
              [19.329, 63.485],
              [19.328, 63.486],
              [19.328, 63.488],
              [19.329, 63.489],
              [19.332, 63.491],
              [19.334, 63.491],
              [19.337, 63.492],
              [19.348, 63.492],
              [19.354, 63.49],
              [19.357, 63.488],
              [19.359, 63.485],
              [19.369, 63.475],
              [19.369, 63.472],
              [19.37, 63.467],
              [19.37, 63.465],
              [19.371, 63.463],
              [19.372, 63.463],
              [19.374, 63.462],
              [19.391, 63.462],
              [19.398, 63.461],
              [19.412, 63.461],
              [19.416, 63.46],
              [19.422, 63.459],
              [19.427, 63.457],
              [19.435, 63.453],
              [19.438, 63.451],
              [19.44, 63.448],
              [19.441, 63.446],
              [19.441, 63.441],
              [19.443, 63.437],
              [19.445, 63.436],
              [19.447, 63.434],
              [19.451, 63.432],
              [19.456, 63.429],
              [19.458, 63.428],
              [19.46, 63.426],
              [19.462, 63.425],
              [19.464, 63.423],
              [19.482, 63.417],
              [19.486, 63.416],
              [19.493, 63.414],
              [19.498, 63.413],
              [19.5, 63.413],
              [19.502, 63.414],
              [19.502, 63.425],
              [19.504, 63.429],
              [19.505, 63.43],
              [19.506, 63.432],
              [19.507, 63.433],
              [19.505, 63.435],
              [19.502, 63.437],
              [19.495, 63.442],
              [19.487, 63.448],
              [19.484, 63.452],
              [19.48, 63.456],
              [19.476, 63.464],
              [19.475, 63.467],
              [19.475, 63.468],
              [19.476, 63.47],
              [19.477, 63.471],
              [19.478, 63.473],
              [19.481, 63.475],
              [19.484, 63.478],
              [19.492, 63.482],
              [19.495, 63.484],
              [19.497, 63.486],
              [19.498, 63.488],
              [19.498, 63.49],
              [19.496, 63.492],
              [19.493, 63.493],
              [19.488, 63.495],
              [19.477, 63.497],
              [19.467, 63.501],
              [19.462, 63.504],
              [19.458, 63.507],
              [19.453, 63.51],
              [19.446, 63.515],
              [19.443, 63.517],
              [19.44, 63.52],
              [19.439, 63.522],
              [19.439, 63.525],
              [19.44, 63.527],
              [19.444, 63.533],
              [19.445, 63.536],
              [19.445, 63.539],
              [19.444, 63.545],
              [19.444, 63.548],
              [19.445, 63.551],
              [19.447, 63.556],
              [19.45, 63.561],
              [19.451, 63.564],
              [19.453, 63.566],
              [19.461, 63.568],
              [19.466, 63.569],
              [19.471, 63.568],
              [19.477, 63.567],
              [19.482, 63.566],
              [19.497, 63.56],
              [19.502, 63.557],
              [19.507, 63.553],
              [19.517, 63.546],
              [19.527, 63.54],
              [19.534, 63.537],
              [19.543, 63.533],
              [19.548, 63.532],
              [19.559, 63.529],
              [19.564, 63.528],
              [19.572, 63.524],
              [19.576, 63.521],
              [19.58, 63.519],
              [19.588, 63.51],
              [19.598, 63.5],
              [19.599, 63.497],
              [19.601, 63.492],
              [19.604, 63.488],
              [19.606, 63.484],
              [19.612, 63.476],
              [19.615, 63.471],
              [19.62, 63.462],
              [19.623, 63.458],
              [19.626, 63.455],
              [19.63, 63.452],
              [19.633, 63.449],
              [19.641, 63.444],
              [19.647, 63.439],
              [19.651, 63.437],
              [19.659, 63.435],
              [19.666, 63.435],
              [19.669, 63.436],
              [19.674, 63.438],
              [19.682, 63.439],
              [19.684, 63.44],
              [19.697, 63.445],
            ],
          ],
        ],
      },
      properties: {
        id: 43,
        name: 'Norra Bottenhavet',
        latlon: [62.51536, 19.708525],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [17, 54.639],
              [16.997, 56.298],
              [20.981, 56.302],
              [20.982, 56.295],
              [20.982, 56.288],
              [20.983, 56.281],
              [20.983, 56.274],
              [20.984, 56.246],
              [20.984, 56.239],
              [20.986, 56.225],
              [20.987, 56.219],
              [20.989, 56.213],
              [20.992, 56.207],
              [20.994, 56.201],
              [20.998, 56.195],
              [21.004, 56.183],
              [21.025, 56.148],
              [21.032, 56.137],
              [21.035, 56.131],
              [21.039, 56.125],
              [21.044, 56.112],
              [21.05, 56.099],
              [21.055, 56.087],
              [21.06, 56.074],
              [21.062, 56.067],
              [21.064, 56.061],
              [21.066, 56.054],
              [21.068, 56.048],
              [21.07, 56.034],
              [21.071, 56.028],
              [21.071, 56],
              [21.07, 55.993],
              [21.07, 55.986],
              [21.068, 55.972],
              [21.066, 55.966],
              [21.064, 55.959],
              [21.058, 55.939],
              [21.056, 55.932],
              [21.055, 55.926],
              [21.053, 55.912],
              [21.053, 55.906],
              [21.054, 55.899],
              [21.054, 55.892],
              [21.055, 55.885],
              [21.058, 55.872],
              [21.07, 55.81],
              [21.079, 55.763],
              [21.082, 55.75],
              [21.083, 55.745],
              [21.085, 55.74],
              [21.086, 55.736],
              [21.087, 55.733],
              [21.093, 55.727],
              [21.097, 55.725],
              [21.109, 55.716],
              [21.114, 55.712],
              [21.118, 55.709],
              [21.122, 55.705],
              [21.127, 55.701],
              [21.131, 55.696],
              [21.135, 55.69],
              [21.143, 55.68],
              [21.146, 55.674],
              [21.149, 55.669],
              [21.152, 55.665],
              [21.154, 55.661],
              [21.155, 55.657],
              [21.155, 55.654],
              [21.154, 55.653],
              [21.152, 55.652],
              [21.151, 55.651],
              [21.15, 55.649],
              [21.151, 55.646],
              [21.152, 55.642],
              [21.156, 55.632],
              [21.159, 55.627],
              [21.165, 55.615],
              [21.168, 55.61],
              [21.172, 55.604],
              [21.175, 55.598],
              [21.179, 55.593],
              [21.191, 55.577],
              [21.194, 55.572],
              [21.198, 55.567],
              [21.201, 55.562],
              [21.209, 55.545],
              [21.212, 55.539],
              [21.215, 55.534],
              [21.219, 55.529],
              [21.227, 55.518],
              [21.231, 55.513],
              [21.235, 55.507],
              [21.241, 55.495],
              [21.243, 55.489],
              [21.246, 55.482],
              [21.248, 55.476],
              [21.249, 55.469],
              [21.25, 55.463],
              [21.251, 55.456],
              [21.251, 55.45],
              [21.25, 55.443],
              [21.25, 55.437],
              [21.249, 55.431],
              [21.247, 55.424],
              [21.243, 55.412],
              [21.239, 55.406],
              [21.236, 55.4],
              [21.232, 55.395],
              [21.228, 55.389],
              [21.211, 55.367],
              [21.208, 55.362],
              [21.205, 55.358],
              [21.203, 55.353],
              [21.202, 55.35],
              [21.202, 55.347],
              [21.204, 55.345],
              [21.207, 55.344],
              [21.216, 55.344],
              [21.226, 55.346],
              [21.234, 55.35],
              [21.242, 55.355],
              [21.251, 55.358],
              [21.254, 55.357],
              [21.255, 55.356],
              [21.256, 55.356],
              [21.255, 55.351],
              [21.255, 55.348],
              [21.257, 55.346],
              [21.26, 55.345],
              [21.264, 55.345],
              [21.269, 55.344],
              [21.275, 55.345],
              [21.294, 55.346],
              [21.301, 55.347],
              [21.315, 55.347],
              [21.322, 55.346],
              [21.328, 55.346],
              [21.342, 55.344],
              [21.348, 55.342],
              [21.355, 55.34],
              [21.36, 55.338],
              [21.366, 55.335],
              [21.371, 55.331],
              [21.375, 55.327],
              [21.378, 55.323],
              [21.381, 55.318],
              [21.382, 55.313],
              [21.382, 55.308],
              [21.381, 55.303],
              [21.379, 55.298],
              [21.376, 55.293],
              [21.372, 55.29],
              [21.362, 55.284],
              [21.356, 55.281],
              [21.354, 55.281],
              [21.357, 55.282],
              [21.363, 55.285],
              [21.371, 55.293],
              [21.374, 55.297],
              [21.378, 55.307],
              [21.378, 55.316],
              [21.377, 55.32],
              [21.375, 55.324],
              [21.367, 55.332],
              [21.363, 55.335],
              [21.358, 55.338],
              [21.346, 55.342],
              [21.334, 55.344],
              [21.327, 55.345],
              [21.301, 55.345],
              [21.294, 55.344],
              [21.288, 55.344],
              [21.282, 55.343],
              [21.276, 55.341],
              [21.271, 55.34],
              [21.267, 55.338],
              [21.264, 55.336],
              [21.263, 55.333],
              [21.265, 55.329],
              [21.269, 55.325],
              [21.279, 55.316],
              [21.283, 55.313],
              [21.289, 55.307],
              [21.289, 55.298],
              [21.295, 55.283],
              [21.299, 55.278],
              [21.303, 55.274],
              [21.308, 55.272],
              [21.315, 55.27],
              [21.321, 55.269],
              [21.328, 55.27],
              [21.329, 55.271],
              [21.325, 55.269],
              [21.313, 55.264],
              [21.307, 55.261],
              [21.292, 55.252],
              [21.288, 55.249],
              [21.285, 55.246],
              [21.283, 55.243],
              [21.282, 55.239],
              [21.282, 55.224],
              [21.28, 55.219],
              [21.279, 55.214],
              [21.277, 55.21],
              [21.272, 55.201],
              [21.272, 55.196],
              [21.273, 55.195],
              [21.274, 55.192],
              [21.27, 55.192],
              [21.254, 55.196],
              [21.236, 55.199],
              [21.231, 55.2],
              [21.226, 55.202],
              [21.221, 55.203],
              [21.21, 55.203],
              [21.205, 55.202],
              [21.195, 55.198],
              [21.191, 55.196],
              [21.188, 55.192],
              [21.186, 55.187],
              [21.185, 55.182],
              [21.186, 55.176],
              [21.186, 55.17],
              [21.187, 55.163],
              [21.188, 55.157],
              [21.191, 55.143],
              [21.205, 55.087],
              [21.216, 55.039],
              [21.219, 55.028],
              [21.221, 55.024],
              [21.222, 55.021],
              [21.225, 55.018],
              [21.228, 55.016],
              [21.232, 55.015],
              [21.237, 55.015],
              [21.243, 55.016],
              [21.248, 55.017],
              [21.264, 55.02],
              [21.265, 55.02],
              [21.264, 55.019],
              [21.262, 55.018],
              [21.245, 55.012],
              [21.24, 55.011],
              [21.235, 55.009],
              [21.229, 55.005],
              [21.228, 55.003],
              [21.227, 54.999],
              [21.229, 54.991],
              [21.236, 54.977],
              [21.238, 54.972],
              [21.239, 54.967],
              [21.24, 54.961],
              [21.24, 54.956],
              [21.239, 54.951],
              [21.237, 54.947],
              [21.234, 54.942],
              [21.231, 54.938],
              [21.226, 54.935],
              [21.222, 54.931],
              [21.217, 54.928],
              [21.211, 54.926],
              [21.204, 54.924],
              [21.198, 54.922],
              [21.191, 54.92],
              [21.177, 54.918],
              [21.136, 54.911],
              [21.122, 54.908],
              [21.116, 54.907],
              [21.109, 54.905],
              [21.094, 54.9],
              [21.084, 54.898],
              [21.078, 54.897],
              [21.053, 54.897],
              [21.036, 54.896],
              [21.031, 54.895],
              [21.013, 54.895],
              [21.002, 54.894],
              [20.982, 54.894],
              [20.976, 54.895],
              [20.969, 54.895],
              [20.955, 54.897],
              [20.926, 54.901],
              [20.912, 54.903],
              [20.899, 54.904],
              [20.881, 54.905],
              [20.876, 54.905],
              [20.87, 54.906],
              [20.865, 54.908],
              [20.859, 54.91],
              [20.853, 54.913],
              [20.848, 54.916],
              [20.831, 54.926],
              [20.826, 54.929],
              [20.82, 54.932],
              [20.815, 54.935],
              [20.803, 54.939],
              [20.798, 54.94],
              [20.792, 54.942],
              [20.786, 54.942],
              [20.78, 54.943],
              [20.774, 54.943],
              [20.769, 54.942],
              [20.763, 54.941],
              [20.745, 54.937],
              [20.739, 54.936],
              [20.732, 54.935],
              [20.726, 54.934],
              [20.719, 54.934],
              [20.713, 54.933],
              [20.7, 54.933],
              [20.693, 54.934],
              [20.688, 54.934],
              [20.677, 54.936],
              [20.67, 54.937],
              [20.663, 54.937],
              [20.656, 54.938],
              [20.642, 54.939],
              [20.622, 54.939],
              [20.615, 54.938],
              [20.594, 54.937],
              [20.58, 54.937],
              [20.573, 54.938],
              [20.555, 54.941],
              [20.549, 54.943],
              [20.534, 54.949],
              [20.527, 54.952],
              [20.523, 54.954],
              [20.523, 54.956],
              [20.524, 54.958],
              [20.526, 54.96],
              [20.531, 54.964],
              [20.538, 54.97],
              [20.542, 54.973],
              [20.547, 54.975],
              [20.552, 54.978],
              [20.571, 54.985],
              [20.589, 54.994],
              [20.594, 54.997],
              [20.606, 55.005],
              [20.628, 55.02],
              [20.633, 55.023],
              [20.639, 55.027],
              [20.657, 55.036],
              [20.682, 55.047],
              [20.694, 55.053],
              [20.7, 55.057],
              [20.712, 55.063],
              [20.717, 55.067],
              [20.723, 55.071],
              [20.734, 55.079],
              [20.762, 55.101],
              [20.773, 55.109],
              [20.785, 55.117],
              [20.79, 55.12],
              [20.796, 55.124],
              [20.808, 55.13],
              [20.831, 55.141],
              [20.837, 55.144],
              [20.842, 55.146],
              [20.85, 55.152],
              [20.853, 55.156],
              [20.855, 55.159],
              [20.858, 55.167],
              [20.861, 55.171],
              [20.864, 55.176],
              [20.868, 55.181],
              [20.892, 55.205],
              [20.898, 55.209],
              [20.903, 55.214],
              [20.909, 55.218],
              [20.914, 55.222],
              [20.932, 55.234],
              [20.938, 55.237],
              [20.948, 55.245],
              [20.953, 55.248],
              [20.975, 55.259],
              [20.98, 55.262],
              [20.984, 55.265],
              [20.987, 55.268],
              [20.99, 55.277],
              [20.992, 55.282],
              [20.995, 55.287],
              [20.998, 55.291],
              [21.002, 55.296],
              [21.014, 55.308],
              [21.024, 55.316],
              [21.038, 55.325],
              [21.043, 55.329],
              [21.047, 55.332],
              [21.05, 55.336],
              [21.053, 55.341],
              [21.055, 55.346],
              [21.059, 55.358],
              [21.065, 55.368],
              [21.068, 55.374],
              [21.072, 55.378],
              [21.083, 55.392],
              [21.086, 55.397],
              [21.089, 55.401],
              [21.092, 55.407],
              [21.097, 55.415],
              [21.099, 55.419],
              [21.1, 55.422],
              [21.1, 55.426],
              [21.099, 55.436],
              [21.099, 55.441],
              [21.101, 55.451],
              [21.103, 55.457],
              [21.106, 55.463],
              [21.111, 55.476],
              [21.113, 55.482],
              [21.116, 55.488],
              [21.118, 55.495],
              [21.119, 55.502],
              [21.121, 55.509],
              [21.122, 55.515],
              [21.123, 55.522],
              [21.126, 55.536],
              [21.131, 55.571],
              [21.133, 55.592],
              [21.135, 55.607],
              [21.135, 55.64],
              [21.134, 55.647],
              [21.134, 55.654],
              [21.133, 55.66],
              [21.132, 55.667],
              [21.13, 55.673],
              [21.129, 55.68],
              [21.127, 55.686],
              [21.121, 55.696],
              [21.113, 55.706],
              [21.109, 55.71],
              [21.106, 55.714],
              [21.102, 55.717],
              [21.092, 55.722],
              [21.09, 55.722],
              [21.09, 55.721],
              [21.092, 55.711],
              [21.094, 55.706],
              [21.095, 55.7],
              [21.097, 55.687],
              [21.101, 55.659],
              [21.102, 55.645],
              [21.104, 55.631],
              [21.104, 55.596],
              [21.103, 55.582],
              [21.1, 55.562],
              [21.098, 55.548],
              [21.097, 55.542],
              [21.095, 55.528],
              [21.093, 55.522],
              [21.089, 55.508],
              [21.087, 55.502],
              [21.082, 55.488],
              [21.076, 55.471],
              [21.06, 55.43],
              [21.028, 55.379],
              [21.016, 55.36],
              [21.008, 55.349],
              [21, 55.337],
              [20.996, 55.332],
              [20.988, 55.321],
              [20.979, 55.311],
              [20.966, 55.296],
              [20.952, 55.281],
              [20.943, 55.271],
              [20.929, 55.257],
              [20.907, 55.239],
              [20.891, 55.225],
              [20.819, 55.167],
              [20.748, 55.109],
              [20.731, 55.096],
              [20.72, 55.087],
              [20.715, 55.083],
              [20.697, 55.071],
              [20.685, 55.064],
              [20.661, 55.049],
              [20.618, 55.024],
              [20.6, 55.013],
              [20.588, 55.006],
              [20.582, 55.003],
              [20.575, 55],
              [20.569, 54.997],
              [20.563, 54.995],
              [20.537, 54.985],
              [20.511, 54.976],
              [20.473, 54.962],
              [20.46, 54.958],
              [20.446, 54.954],
              [20.44, 54.952],
              [20.426, 54.949],
              [20.413, 54.946],
              [20.406, 54.944],
              [20.378, 54.94],
              [20.372, 54.939],
              [20.352, 54.939],
              [20.345, 54.94],
              [20.332, 54.941],
              [20.326, 54.942],
              [20.319, 54.943],
              [20.307, 54.945],
              [20.301, 54.947],
              [20.294, 54.949],
              [20.282, 54.954],
              [20.276, 54.956],
              [20.269, 54.958],
              [20.263, 54.959],
              [20.242, 54.959],
              [20.235, 54.958],
              [20.228, 54.958],
              [20.214, 54.956],
              [20.165, 54.95],
              [20.151, 54.948],
              [20.136, 54.946],
              [20.129, 54.946],
              [20.122, 54.945],
              [20.095, 54.945],
              [20.055, 54.947],
              [20.041, 54.948],
              [20.028, 54.95],
              [20.021, 54.951],
              [20.003, 54.954],
              [19.997, 54.954],
              [19.992, 54.955],
              [19.986, 54.955],
              [19.981, 54.954],
              [19.975, 54.952],
              [19.965, 54.946],
              [19.96, 54.942],
              [19.955, 54.937],
              [19.943, 54.922],
              [19.94, 54.916],
              [19.938, 54.911],
              [19.934, 54.899],
              [19.934, 54.892],
              [19.933, 54.886],
              [19.933, 54.88],
              [19.934, 54.873],
              [19.935, 54.867],
              [19.937, 54.86],
              [19.939, 54.854],
              [19.942, 54.847],
              [19.95, 54.828],
              [19.953, 54.821],
              [19.955, 54.815],
              [19.957, 54.808],
              [19.958, 54.802],
              [19.959, 54.795],
              [19.96, 54.789],
              [19.96, 54.783],
              [19.959, 54.776],
              [19.958, 54.77],
              [19.952, 54.752],
              [19.949, 54.746],
              [19.943, 54.733],
              [19.934, 54.715],
              [19.93, 54.71],
              [19.926, 54.704],
              [19.923, 54.698],
              [19.915, 54.688],
              [19.906, 54.678],
              [19.894, 54.665],
              [19.887, 54.657],
              [19.883, 54.651],
              [19.882, 54.649],
              [19.883, 54.647],
              [19.885, 54.646],
              [19.887, 54.644],
              [19.89, 54.644],
              [19.893, 54.643],
              [19.905, 54.643],
              [19.906, 54.642],
              [19.907, 54.64],
              [19.908, 54.64],
              [19.91, 54.639],
              [19.914, 54.638],
              [19.918, 54.636],
              [19.92, 54.636],
              [19.922, 54.635],
              [19.929, 54.635],
              [19.945, 54.639],
              [19.948, 54.641],
              [19.949, 54.643],
              [19.95, 54.646],
              [19.949, 54.65],
              [19.947, 54.654],
              [19.945, 54.664],
              [19.945, 54.674],
              [19.947, 54.686],
              [19.951, 54.696],
              [19.954, 54.701],
              [19.959, 54.706],
              [19.969, 54.714],
              [19.975, 54.718],
              [19.981, 54.72],
              [19.987, 54.723],
              [19.993, 54.724],
              [20, 54.725],
              [20.013, 54.725],
              [20.025, 54.723],
              [20.037, 54.719],
              [20.042, 54.717],
              [20.05, 54.709],
              [20.054, 54.704],
              [20.057, 54.699],
              [20.06, 54.693],
              [20.065, 54.681],
              [20.071, 54.671],
              [20.079, 54.663],
              [20.084, 54.661],
              [20.089, 54.658],
              [20.094, 54.657],
              [20.104, 54.657],
              [20.109, 54.658],
              [20.114, 54.66],
              [20.127, 54.664],
              [20.133, 54.667],
              [20.139, 54.669],
              [20.15, 54.675],
              [20.168, 54.684],
              [20.173, 54.687],
              [20.178, 54.689],
              [20.184, 54.691],
              [20.19, 54.692],
              [20.217, 54.692],
              [20.231, 54.691],
              [20.274, 54.689],
              [20.295, 54.687],
              [20.324, 54.687],
              [20.331, 54.688],
              [20.337, 54.688],
              [20.357, 54.691],
              [20.371, 54.693],
              [20.384, 54.694],
              [20.411, 54.696],
              [20.418, 54.696],
              [20.425, 54.697],
              [20.431, 54.698],
              [20.438, 54.699],
              [20.456, 54.703],
              [20.462, 54.705],
              [20.468, 54.705],
              [20.472, 54.706],
              [20.483, 54.706],
              [20.484, 54.705],
              [20.482, 54.704],
              [20.476, 54.703],
              [20.468, 54.702],
              [20.467, 54.701],
              [20.465, 54.701],
              [20.46, 54.699],
              [20.458, 54.698],
              [20.452, 54.697],
              [20.448, 54.696],
              [20.445, 54.695],
              [20.441, 54.694],
              [20.424, 54.691],
              [20.418, 54.69],
              [20.4, 54.688],
              [20.395, 54.687],
              [20.391, 54.686],
              [20.389, 54.685],
              [20.388, 54.685],
              [20.388, 54.684],
              [20.389, 54.683],
              [20.395, 54.68],
              [20.398, 54.677],
              [20.398, 54.675],
              [20.397, 54.672],
              [20.395, 54.67],
              [20.391, 54.668],
              [20.387, 54.665],
              [20.381, 54.663],
              [20.376, 54.661],
              [20.37, 54.659],
              [20.358, 54.657],
              [20.353, 54.656],
              [20.348, 54.656],
              [20.343, 54.657],
              [20.339, 54.657],
              [20.333, 54.659],
              [20.33, 54.658],
              [20.327, 54.658],
              [20.324, 54.657],
              [20.319, 54.655],
              [20.314, 54.652],
              [20.309, 54.65],
              [20.303, 54.646],
              [20.28, 54.632],
              [20.275, 54.629],
              [20.268, 54.626],
              [20.262, 54.623],
              [20.256, 54.621],
              [20.249, 54.618],
              [20.242, 54.616],
              [20.229, 54.613],
              [20.201, 54.606],
              [20.187, 54.603],
              [20.181, 54.601],
              [20.167, 54.597],
              [20.161, 54.594],
              [20.155, 54.592],
              [20.149, 54.589],
              [20.137, 54.582],
              [20.114, 54.569],
              [20.096, 54.56],
              [20.084, 54.556],
              [20.072, 54.554],
              [20.066, 54.554],
              [20.06, 54.555],
              [20.048, 54.559],
              [20.031, 54.566],
              [20.025, 54.568],
              [20.02, 54.57],
              [20.013, 54.571],
              [20.001, 54.571],
              [19.989, 54.567],
              [19.984, 54.564],
              [19.975, 54.555],
              [19.971, 54.549],
              [19.967, 54.544],
              [19.955, 54.526],
              [19.951, 54.521],
              [19.947, 54.515],
              [19.943, 54.51],
              [19.938, 54.505],
              [19.928, 54.497],
              [19.922, 54.495],
              [19.916, 54.492],
              [19.904, 54.488],
              [19.897, 54.486],
              [19.871, 54.479],
              [19.858, 54.475],
              [19.851, 54.473],
              [19.839, 54.469],
              [19.833, 54.466],
              [19.827, 54.462],
              [19.821, 54.459],
              [19.804, 54.448],
              [19.799, 54.444],
              [19.793, 54.441],
              [19.763, 54.431],
              [19.753, 54.425],
              [19.741, 54.416],
              [19.737, 54.412],
              [19.723, 54.401],
              [19.718, 54.397],
              [19.712, 54.392],
              [19.692, 54.374],
              [19.687, 54.369],
              [19.682, 54.365],
              [19.676, 54.361],
              [19.658, 54.352],
              [19.646, 54.348],
              [19.639, 54.346],
              [19.618, 54.343],
              [19.59, 54.341],
              [19.569, 54.338],
              [19.563, 54.337],
              [19.549, 54.334],
              [19.543, 54.333],
              [19.53, 54.33],
              [19.517, 54.326],
              [19.51, 54.324],
              [19.504, 54.322],
              [19.498, 54.319],
              [19.491, 54.316],
              [19.485, 54.313],
              [19.478, 54.31],
              [19.466, 54.303],
              [19.453, 54.296],
              [19.441, 54.289],
              [19.428, 54.281],
              [19.422, 54.277],
              [19.417, 54.273],
              [19.411, 54.269],
              [19.405, 54.264],
              [19.4, 54.26],
              [19.396, 54.255],
              [19.391, 54.249],
              [19.381, 54.235],
              [19.378, 54.231],
              [19.375, 54.229],
              [19.372, 54.229],
              [19.372, 54.232],
              [19.374, 54.234],
              [19.378, 54.24],
              [19.383, 54.246],
              [19.389, 54.254],
              [19.391, 54.259],
              [19.394, 54.263],
              [19.396, 54.269],
              [19.395, 54.271],
              [19.394, 54.272],
              [19.391, 54.272],
              [19.383, 54.271],
              [19.378, 54.27],
              [19.359, 54.27],
              [19.346, 54.271],
              [19.303, 54.276],
              [19.296, 54.276],
              [19.279, 54.278],
              [19.273, 54.278],
              [19.269, 54.28],
              [19.264, 54.282],
              [19.26, 54.285],
              [19.257, 54.288],
              [19.255, 54.292],
              [19.255, 54.295],
              [19.254, 54.302],
              [19.254, 54.306],
              [19.252, 54.309],
              [19.251, 54.312],
              [19.243, 54.324],
              [19.239, 54.329],
              [19.237, 54.332],
              [19.237, 54.334],
              [19.239, 54.337],
              [19.242, 54.339],
              [19.247, 54.341],
              [19.252, 54.342],
              [19.257, 54.344],
              [19.263, 54.345],
              [19.269, 54.347],
              [19.283, 54.349],
              [19.289, 54.35],
              [19.296, 54.351],
              [19.31, 54.352],
              [19.331, 54.353],
              [19.345, 54.354],
              [19.352, 54.355],
              [19.358, 54.355],
              [19.365, 54.356],
              [19.372, 54.358],
              [19.379, 54.359],
              [19.386, 54.361],
              [19.399, 54.365],
              [19.42, 54.372],
              [19.487, 54.393],
              [19.582, 54.424],
              [19.595, 54.428],
              [19.608, 54.433],
              [19.615, 54.436],
              [19.621, 54.439],
              [19.628, 54.442],
              [19.64, 54.448],
              [19.666, 54.46],
              [19.691, 54.473],
              [19.71, 54.483],
              [19.722, 54.49],
              [19.734, 54.498],
              [19.739, 54.501],
              [19.744, 54.505],
              [19.748, 54.509],
              [19.753, 54.513],
              [19.762, 54.521],
              [19.766, 54.525],
              [19.777, 54.537],
              [19.781, 54.541],
              [19.786, 54.544],
              [19.791, 54.548],
              [19.801, 54.555],
              [19.806, 54.558],
              [19.811, 54.562],
              [19.821, 54.571],
              [19.836, 54.583],
              [19.846, 54.592],
              [19.85, 54.596],
              [19.855, 54.599],
              [19.864, 54.606],
              [19.868, 54.609],
              [19.874, 54.615],
              [19.876, 54.618],
              [19.877, 54.621],
              [19.879, 54.625],
              [19.88, 54.628],
              [19.88, 54.631],
              [19.879, 54.634],
              [19.878, 54.636],
              [19.874, 54.638],
              [19.873, 54.637],
              [19.871, 54.634],
              [19.869, 54.63],
              [19.866, 54.627],
              [19.862, 54.622],
              [19.858, 54.618],
              [19.853, 54.614],
              [19.843, 54.604],
              [19.838, 54.6],
              [19.827, 54.591],
              [19.815, 54.582],
              [19.798, 54.569],
              [19.712, 54.506],
              [19.695, 54.494],
              [19.683, 54.486],
              [19.677, 54.483],
              [19.66, 54.472],
              [19.637, 54.459],
              [19.595, 54.438],
              [19.556, 54.423],
              [19.536, 54.416],
              [19.523, 54.411],
              [19.51, 54.407],
              [19.503, 54.405],
              [19.497, 54.403],
              [19.483, 54.399],
              [19.47, 54.396],
              [19.449, 54.391],
              [19.395, 54.379],
              [19.382, 54.376],
              [19.368, 54.373],
              [19.333, 54.368],
              [19.306, 54.364],
              [19.257, 54.358],
              [19.243, 54.357],
              [19.229, 54.355],
              [19.222, 54.355],
              [19.208, 54.354],
              [19.18, 54.353],
              [19.053, 54.348],
              [19.032, 54.347],
              [19.004, 54.347],
              [18.997, 54.348],
              [18.991, 54.348],
              [18.985, 54.349],
              [18.979, 54.351],
              [18.959, 54.356],
              [18.955, 54.356],
              [18.952, 54.357],
              [18.949, 54.357],
              [18.946, 54.356],
              [18.943, 54.356],
              [18.939, 54.355],
              [18.926, 54.352],
              [18.922, 54.351],
              [18.916, 54.35],
              [18.91, 54.35],
              [18.904, 54.349],
              [18.886, 54.349],
              [18.88, 54.35],
              [18.873, 54.35],
              [18.852, 54.353],
              [18.831, 54.357],
              [18.782, 54.366],
              [18.761, 54.37],
              [18.748, 54.373],
              [18.742, 54.375],
              [18.736, 54.376],
              [18.731, 54.378],
              [18.728, 54.38],
              [18.725, 54.381],
              [18.715, 54.388],
              [18.707, 54.394],
              [18.706, 54.396],
              [18.703, 54.399],
              [18.703, 54.4],
              [18.705, 54.401],
              [18.71, 54.403],
              [18.712, 54.404],
              [18.711, 54.405],
              [18.697, 54.405],
              [18.661, 54.411],
              [18.649, 54.411],
              [18.639, 54.413],
              [18.632, 54.415],
              [18.62, 54.419],
              [18.613, 54.422],
              [18.607, 54.425],
              [18.601, 54.429],
              [18.595, 54.432],
              [18.59, 54.436],
              [18.584, 54.44],
              [18.576, 54.448],
              [18.57, 54.458],
              [18.566, 54.468],
              [18.563, 54.485],
              [18.562, 54.491],
              [18.557, 54.507],
              [18.556, 54.511],
              [18.554, 54.52],
              [18.553, 54.522],
              [18.551, 54.527],
              [18.548, 54.53],
              [18.542, 54.532],
              [18.535, 54.532],
              [18.527, 54.534],
              [18.524, 54.536],
              [18.521, 54.537],
              [18.517, 54.54],
              [18.517, 54.541],
              [18.519, 54.541],
              [18.53, 54.54],
              [18.54, 54.54],
              [18.545, 54.541],
              [18.548, 54.542],
              [18.552, 54.544],
              [18.554, 54.546],
              [18.555, 54.549],
              [18.556, 54.551],
              [18.555, 54.553],
              [18.554, 54.557],
              [18.553, 54.562],
              [18.547, 54.572],
              [18.544, 54.578],
              [18.541, 54.583],
              [18.537, 54.589],
              [18.528, 54.599],
              [18.525, 54.605],
              [18.521, 54.61],
              [18.519, 54.615],
              [18.514, 54.624],
              [18.512, 54.627],
              [18.509, 54.63],
              [18.506, 54.632],
              [18.502, 54.633],
              [18.493, 54.635],
              [18.489, 54.636],
              [18.481, 54.64],
              [18.478, 54.642],
              [18.475, 54.646],
              [18.473, 54.651],
              [18.472, 54.656],
              [18.469, 54.673],
              [18.468, 54.679],
              [18.466, 54.685],
              [18.464, 54.69],
              [18.46, 54.694],
              [18.45, 54.702],
              [18.444, 54.706],
              [18.438, 54.709],
              [18.426, 54.716],
              [18.42, 54.719],
              [18.415, 54.723],
              [18.41, 54.726],
              [18.406, 54.73],
              [18.403, 54.735],
              [18.402, 54.74],
              [18.403, 54.745],
              [18.404, 54.751],
              [18.408, 54.761],
              [18.411, 54.767],
              [18.419, 54.775],
              [18.423, 54.778],
              [18.435, 54.78],
              [18.447, 54.778],
              [18.461, 54.774],
              [18.474, 54.77],
              [18.488, 54.766],
              [18.53, 54.752],
              [18.604, 54.726],
              [18.611, 54.724],
              [18.618, 54.721],
              [18.624, 54.718],
              [18.637, 54.712],
              [18.656, 54.703],
              [18.668, 54.698],
              [18.674, 54.695],
              [18.692, 54.688],
              [18.697, 54.686],
              [18.703, 54.683],
              [18.709, 54.679],
              [18.715, 54.676],
              [18.72, 54.672],
              [18.726, 54.668],
              [18.737, 54.659],
              [18.747, 54.65],
              [18.752, 54.646],
              [18.758, 54.641],
              [18.762, 54.636],
              [18.775, 54.624],
              [18.783, 54.616],
              [18.787, 54.614],
              [18.791, 54.611],
              [18.799, 54.607],
              [18.804, 54.605],
              [18.808, 54.603],
              [18.812, 54.603],
              [18.816, 54.604],
              [18.819, 54.606],
              [18.82, 54.609],
              [18.821, 54.613],
              [18.82, 54.617],
              [18.818, 54.621],
              [18.815, 54.626],
              [18.811, 54.63],
              [18.806, 54.634],
              [18.8, 54.638],
              [18.795, 54.642],
              [18.783, 54.65],
              [18.77, 54.657],
              [18.752, 54.668],
              [18.739, 54.675],
              [18.733, 54.679],
              [18.72, 54.685],
              [18.708, 54.691],
              [18.689, 54.699],
              [18.676, 54.704],
              [18.67, 54.707],
              [18.65, 54.714],
              [18.462, 54.779],
              [18.448, 54.784],
              [18.422, 54.794],
              [18.403, 54.802],
              [18.372, 54.816],
              [18.36, 54.821],
              [18.354, 54.824],
              [18.348, 54.826],
              [18.341, 54.828],
              [18.329, 54.832],
              [18.315, 54.834],
              [18.308, 54.834],
              [18.301, 54.835],
              [18.265, 54.835],
              [18.201, 54.834],
              [18.08, 54.834],
              [18.066, 54.833],
              [18.052, 54.833],
              [17.946, 54.827],
              [17.932, 54.827],
              [17.917, 54.825],
              [17.91, 54.825],
              [17.896, 54.823],
              [17.875, 54.819],
              [17.664, 54.783],
              [17.643, 54.779],
              [17.601, 54.773],
              [17.573, 54.77],
              [17.395, 54.75],
              [17.303, 54.739],
              [17.254, 54.732],
              [17.24, 54.728],
              [17.226, 54.725],
              [17.213, 54.721],
              [17.098, 54.684],
              [17.077, 54.678],
              [17.064, 54.673],
              [17.057, 54.67],
              [17.051, 54.668],
              [17.045, 54.665],
              [17.038, 54.661],
              [17.032, 54.658],
              [17.02, 54.651],
              [17, 54.639],
            ],
          ],
        ],
      },
      properties: {
        id: 51,
        name: 'Sydöstra Östersjön',
        latlon: [55.470136, 18.873106],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [13.703, 59.379],
              [13.713, 59.379],
              [13.726, 59.381],
              [13.762, 59.381],
              [13.777, 59.378],
              [13.785, 59.374],
              [13.789, 59.37],
              [13.788, 59.368],
              [13.787, 59.367],
              [13.785, 59.366],
              [13.782, 59.365],
              [13.773, 59.364],
              [13.769, 59.363],
              [13.764, 59.362],
              [13.759, 59.36],
              [13.755, 59.358],
              [13.75, 59.353],
              [13.749, 59.35],
              [13.748, 59.348],
              [13.749, 59.346],
              [13.752, 59.335],
              [13.752, 59.323],
              [13.754, 59.322],
              [13.757, 59.321],
              [13.761, 59.32],
              [13.769, 59.319],
              [13.778, 59.319],
              [13.783, 59.32],
              [13.798, 59.322],
              [13.803, 59.322],
              [13.811, 59.323],
              [13.815, 59.324],
              [13.818, 59.325],
              [13.82, 59.327],
              [13.821, 59.329],
              [13.821, 59.332],
              [13.819, 59.335],
              [13.816, 59.337],
              [13.81, 59.342],
              [13.808, 59.345],
              [13.806, 59.347],
              [13.808, 59.353],
              [13.81, 59.355],
              [13.813, 59.357],
              [13.817, 59.359],
              [13.822, 59.36],
              [13.826, 59.36],
              [13.831, 59.359],
              [13.835, 59.357],
              [13.851, 59.345],
              [13.859, 59.341],
              [13.863, 59.34],
              [13.871, 59.34],
              [13.884, 59.343],
              [13.892, 59.343],
              [13.896, 59.341],
              [13.896, 59.339],
              [13.895, 59.337],
              [13.893, 59.335],
              [13.89, 59.331],
              [13.888, 59.33],
              [13.886, 59.327],
              [13.885, 59.323],
              [13.885, 59.319],
              [13.887, 59.316],
              [13.889, 59.314],
              [13.892, 59.312],
              [13.896, 59.31],
              [13.911, 59.304],
              [13.915, 59.303],
              [13.92, 59.303],
              [13.923, 59.304],
              [13.924, 59.305],
              [13.924, 59.306],
              [13.923, 59.308],
              [13.923, 59.31],
              [13.924, 59.311],
              [13.925, 59.313],
              [13.927, 59.314],
              [13.929, 59.314],
              [13.931, 59.313],
              [13.934, 59.312],
              [13.943, 59.303],
              [13.947, 59.302],
              [13.952, 59.301],
              [13.956, 59.301],
              [13.961, 59.302],
              [13.965, 59.303],
              [13.969, 59.305],
              [13.972, 59.307],
              [13.974, 59.31],
              [13.976, 59.314],
              [13.977, 59.317],
              [13.977, 59.32],
              [13.976, 59.327],
              [13.976, 59.33],
              [13.977, 59.333],
              [13.979, 59.337],
              [13.981, 59.34],
              [13.984, 59.342],
              [13.988, 59.343],
              [13.995, 59.343],
              [13.998, 59.342],
              [14.001, 59.34],
              [14.003, 59.336],
              [14.003, 59.325],
              [14.004, 59.32],
              [14.004, 59.315],
              [14.005, 59.311],
              [14.009, 59.305],
              [14.012, 59.303],
              [14.015, 59.302],
              [14.028, 59.3],
              [14.037, 59.299],
              [14.042, 59.298],
              [14.046, 59.299],
              [14.049, 59.301],
              [14.052, 59.304],
              [14.058, 59.312],
              [14.067, 59.325],
              [14.069, 59.328],
              [14.072, 59.331],
              [14.074, 59.332],
              [14.077, 59.332],
              [14.079, 59.33],
              [14.08, 59.328],
              [14.081, 59.324],
              [14.079, 59.318],
              [14.073, 59.312],
              [14.07, 59.308],
              [14.064, 59.298],
              [14.062, 59.293],
              [14.06, 59.283],
              [14.06, 59.276],
              [14.061, 59.273],
              [14.065, 59.266],
              [14.066, 59.262],
              [14.069, 59.253],
              [14.071, 59.248],
              [14.074, 59.245],
              [14.078, 59.239],
              [14.079, 59.236],
              [14.079, 59.234],
              [14.078, 59.227],
              [14.078, 59.219],
              [14.077, 59.217],
              [14.075, 59.214],
              [14.073, 59.21],
              [14.061, 59.194],
              [14.054, 59.187],
              [14.042, 59.177],
              [14.038, 59.174],
              [14.035, 59.17],
              [14.03, 59.163],
              [14.027, 59.16],
              [14.024, 59.158],
              [14.013, 59.147],
              [14.01, 59.146],
              [14.007, 59.144],
              [13.999, 59.142],
              [13.995, 59.14],
              [13.985, 59.136],
              [13.98, 59.133],
              [13.97, 59.125],
              [13.966, 59.121],
              [13.962, 59.116],
              [13.959, 59.111],
              [13.955, 59.106],
              [13.953, 59.101],
              [13.95, 59.096],
              [13.949, 59.091],
              [13.948, 59.087],
              [13.948, 59.083],
              [13.949, 59.079],
              [13.95, 59.076],
              [13.95, 59.072],
              [13.954, 59.064],
              [13.966, 59.046],
              [13.968, 59.044],
              [13.97, 59.044],
              [13.976, 59.043],
              [13.98, 59.043],
              [13.982, 59.044],
              [13.984, 59.046],
              [13.989, 59.05],
              [13.992, 59.051],
              [13.996, 59.053],
              [14, 59.053],
              [14.014, 59.055],
              [14.019, 59.055],
              [14.023, 59.057],
              [14.026, 59.058],
              [14.032, 59.062],
              [14.035, 59.063],
              [14.043, 59.065],
              [14.05, 59.066],
              [14.053, 59.066],
              [14.056, 59.067],
              [14.058, 59.069],
              [14.061, 59.073],
              [14.064, 59.075],
              [14.069, 59.079],
              [14.075, 59.088],
              [14.076, 59.091],
              [14.077, 59.097],
              [14.078, 59.1],
              [14.084, 59.106],
              [14.09, 59.108],
              [14.094, 59.107],
              [14.097, 59.105],
              [14.1, 59.102],
              [14.102, 59.099],
              [14.104, 59.091],
              [14.104, 59.081],
              [14.102, 59.072],
              [14.101, 59.067],
              [14.101, 59.057],
              [14.103, 59.053],
              [14.105, 59.052],
              [14.114, 59.052],
              [14.118, 59.054],
              [14.127, 59.06],
              [14.131, 59.062],
              [14.134, 59.063],
              [14.136, 59.064],
              [14.138, 59.064],
              [14.14, 59.062],
              [14.141, 59.059],
              [14.141, 59.057],
              [14.139, 59.053],
              [14.135, 59.047],
              [14.129, 59.041],
              [14.123, 59.039],
              [14.117, 59.038],
              [14.113, 59.038],
              [14.103, 59.036],
              [14.099, 59.035],
              [14.088, 59.024],
              [14.085, 59.022],
              [14.082, 59.021],
              [14.079, 59.019],
              [14.072, 59.017],
              [14.07, 59.016],
              [14.069, 59.015],
              [14.068, 59.013],
              [14.065, 59.01],
              [14.061, 59.009],
              [14.057, 59.007],
              [14.053, 59.006],
              [14.048, 59.006],
              [14.042, 59.005],
              [14.036, 59.005],
              [14.024, 59.007],
              [14.012, 59.007],
              [14.007, 59.006],
              [14.003, 59.005],
              [13.999, 59.003],
              [13.996, 59.001],
              [13.994, 58.997],
              [13.994, 58.993],
              [13.996, 58.991],
              [13.999, 58.989],
              [14.001, 58.988],
              [14.003, 58.986],
              [14.003, 58.984],
              [14.004, 58.982],
              [14.004, 58.979],
              [14.005, 58.976],
              [14.008, 58.969],
              [14.01, 58.965],
              [14.011, 58.96],
              [14.011, 58.958],
              [14.012, 58.956],
              [14.014, 58.955],
              [14.019, 58.952],
              [14.025, 58.948],
              [14.028, 58.945],
              [14.029, 58.942],
              [14.03, 58.938],
              [14.03, 58.933],
              [14.029, 58.928],
              [14.023, 58.91],
              [14.02, 58.904],
              [14.018, 58.898],
              [14.015, 58.892],
              [14.012, 58.887],
              [14.011, 58.886],
              [14.008, 58.881],
              [14, 58.871],
              [13.988, 58.862],
              [13.981, 58.858],
              [13.977, 58.854],
              [13.975, 58.851],
              [13.973, 58.844],
              [13.972, 58.84],
              [13.97, 58.837],
              [13.968, 58.835],
              [13.965, 58.833],
              [13.962, 58.832],
              [13.954, 58.828],
              [13.951, 58.826],
              [13.947, 58.821],
              [13.944, 58.819],
              [13.942, 58.817],
              [13.939, 58.816],
              [13.936, 58.816],
              [13.929, 58.817],
              [13.924, 58.816],
              [13.909, 58.815],
              [13.905, 58.814],
              [13.9, 58.813],
              [13.895, 58.811],
              [13.891, 58.809],
              [13.883, 58.803],
              [13.881, 58.8],
              [13.878, 58.796],
              [13.877, 58.793],
              [13.876, 58.789],
              [13.876, 58.786],
              [13.878, 58.783],
              [13.889, 58.772],
              [13.891, 58.769],
              [13.893, 58.763],
              [13.891, 58.76],
              [13.884, 58.753],
              [13.879, 58.75],
              [13.869, 58.743],
              [13.842, 58.725],
              [13.837, 58.723],
              [13.833, 58.721],
              [13.822, 58.717],
              [13.818, 58.715],
              [13.814, 58.714],
              [13.808, 58.714],
              [13.8, 58.713],
              [13.796, 58.713],
              [13.784, 58.709],
              [13.772, 58.706],
              [13.766, 58.704],
              [13.76, 58.701],
              [13.755, 58.699],
              [13.75, 58.696],
              [13.739, 58.69],
              [13.729, 58.684],
              [13.725, 58.683],
              [13.715, 58.679],
              [13.7, 58.676],
              [13.695, 58.676],
              [13.691, 58.677],
              [13.686, 58.679],
              [13.682, 58.681],
              [13.679, 58.683],
              [13.677, 58.687],
              [13.675, 58.69],
              [13.674, 58.693],
              [13.672, 58.696],
              [13.67, 58.697],
              [13.667, 58.698],
              [13.664, 58.697],
              [13.655, 58.696],
              [13.644, 58.694],
              [13.638, 58.693],
              [13.633, 58.693],
              [13.627, 58.692],
              [13.612, 58.693],
              [13.604, 58.693],
              [13.596, 58.694],
              [13.591, 58.694],
              [13.589, 58.69],
              [13.587, 58.685],
              [13.586, 58.682],
              [13.579, 58.675],
              [13.575, 58.673],
              [13.567, 58.668],
              [13.558, 58.664],
              [13.553, 58.662],
              [13.549, 58.661],
              [13.544, 58.66],
              [13.535, 58.66],
              [13.53, 58.661],
              [13.521, 58.664],
              [13.516, 58.665],
              [13.501, 58.665],
              [13.495, 58.664],
              [13.49, 58.662],
              [13.484, 58.66],
              [13.479, 58.658],
              [13.469, 58.652],
              [13.461, 58.646],
              [13.456, 58.641],
              [13.453, 58.639],
              [13.441, 58.636],
              [13.43, 58.636],
              [13.412, 58.633],
              [13.405, 58.632],
              [13.399, 58.63],
              [13.392, 58.628],
              [13.38, 58.624],
              [13.374, 58.621],
              [13.369, 58.619],
              [13.363, 58.615],
              [13.358, 58.612],
              [13.353, 58.608],
              [13.344, 58.599],
              [13.336, 58.587],
              [13.326, 58.57],
              [13.323, 58.564],
              [13.319, 58.559],
              [13.311, 58.548],
              [13.309, 58.544],
              [13.291, 58.526],
              [13.288, 58.521],
              [13.282, 58.512],
              [13.278, 58.507],
              [13.274, 58.504],
              [13.269, 58.501],
              [13.264, 58.499],
              [13.258, 58.497],
              [13.253, 58.496],
              [13.247, 58.495],
              [13.234, 58.495],
              [13.227, 58.496],
              [13.221, 58.496],
              [13.207, 58.498],
              [13.201, 58.499],
              [13.195, 58.501],
              [13.188, 58.503],
              [13.169, 58.51],
              [13.151, 58.516],
              [13.145, 58.52],
              [13.143, 58.523],
              [13.142, 58.525],
              [13.141, 58.528],
              [13.141, 58.531],
              [13.142, 58.536],
              [13.145, 58.54],
              [13.149, 58.544],
              [13.153, 58.549],
              [13.167, 58.563],
              [13.175, 58.573],
              [13.178, 58.579],
              [13.181, 58.584],
              [13.184, 58.59],
              [13.186, 58.595],
              [13.187, 58.601],
              [13.187, 58.606],
              [13.185, 58.61],
              [13.183, 58.613],
              [13.179, 58.616],
              [13.175, 58.618],
              [13.169, 58.619],
              [13.163, 58.621],
              [13.145, 58.624],
              [13.125, 58.624],
              [13.119, 58.623],
              [13.107, 58.619],
              [13.09, 58.613],
              [13.085, 58.611],
              [13.079, 58.61],
              [13.075, 58.609],
              [13.06, 58.607],
              [13.054, 58.607],
              [13.048, 58.606],
              [13.012, 58.606],
              [13.008, 58.605],
              [13.003, 58.602],
              [13, 58.599],
              [12.992, 58.593],
              [12.989, 58.591],
              [12.983, 58.586],
              [12.98, 58.584],
              [12.978, 58.582],
              [12.976, 58.578],
              [12.975, 58.575],
              [12.973, 58.574],
              [12.97, 58.572],
              [12.965, 58.571],
              [12.954, 58.571],
              [12.947, 58.572],
              [12.941, 58.572],
              [12.934, 58.573],
              [12.919, 58.575],
              [12.88, 58.581],
              [12.873, 58.582],
              [12.872, 58.582],
              [12.873, 58.582],
              [12.876, 58.581],
              [12.891, 58.577],
              [12.904, 58.573],
              [12.911, 58.571],
              [12.923, 58.567],
              [12.929, 58.564],
              [12.932, 58.562],
              [12.935, 58.559],
              [12.941, 58.555],
              [12.945, 58.551],
              [12.945, 58.546],
              [12.943, 58.544],
              [12.936, 58.539],
              [12.933, 58.536],
              [12.931, 58.533],
              [12.93, 58.531],
              [12.93, 58.528],
              [12.931, 58.525],
              [12.931, 58.523],
              [12.93, 58.521],
              [12.924, 58.518],
              [12.917, 58.516],
              [12.91, 58.513],
              [12.907, 58.512],
              [12.9, 58.511],
              [12.898, 58.511],
              [12.896, 58.509],
              [12.896, 58.508],
              [12.897, 58.506],
              [12.9, 58.504],
              [12.901, 58.502],
              [12.902, 58.501],
              [12.899, 58.498],
              [12.897, 58.497],
              [12.894, 58.496],
              [12.859, 58.496],
              [12.855, 58.495],
              [12.852, 58.495],
              [12.84, 58.492],
              [12.824, 58.486],
              [12.819, 58.484],
              [12.809, 58.482],
              [12.786, 58.482],
              [12.778, 58.48],
              [12.773, 58.479],
              [12.769, 58.477],
              [12.761, 58.471],
              [12.756, 58.468],
              [12.751, 58.466],
              [12.745, 58.464],
              [12.721, 58.457],
              [12.689, 58.448],
              [12.685, 58.447],
              [12.683, 58.445],
              [12.681, 58.444],
              [12.681, 58.438],
              [12.685, 58.428],
              [12.686, 58.425],
              [12.686, 58.422],
              [12.685, 58.42],
              [12.683, 58.418],
              [12.68, 58.416],
              [12.676, 58.414],
              [12.671, 58.413],
              [12.661, 58.41],
              [12.656, 58.408],
              [12.652, 58.407],
              [12.648, 58.404],
              [12.645, 58.401],
              [12.643, 58.398],
              [12.639, 58.391],
              [12.637, 58.388],
              [12.634, 58.385],
              [12.631, 58.383],
              [12.626, 58.38],
              [12.607, 58.37],
              [12.602, 58.368],
              [12.597, 58.365],
              [12.592, 58.363],
              [12.585, 58.362],
              [12.579, 58.361],
              [12.572, 58.36],
              [12.559, 58.36],
              [12.553, 58.361],
              [12.548, 58.363],
              [12.54, 58.367],
              [12.537, 58.37],
              [12.535, 58.376],
              [12.536, 58.379],
              [12.539, 58.381],
              [12.543, 58.384],
              [12.548, 58.387],
              [12.558, 58.391],
              [12.568, 58.394],
              [12.574, 58.397],
              [12.593, 58.404],
              [12.613, 58.412],
              [12.616, 58.414],
              [12.619, 58.417],
              [12.62, 58.42],
              [12.62, 58.424],
              [12.621, 58.428],
              [12.621, 58.433],
              [12.625, 58.443],
              [12.627, 58.449],
              [12.63, 58.454],
              [12.633, 58.46],
              [12.636, 58.465],
              [12.642, 58.473],
              [12.643, 58.476],
              [12.644, 58.478],
              [12.643, 58.48],
              [12.641, 58.481],
              [12.638, 58.481],
              [12.634, 58.48],
              [12.62, 58.477],
              [12.615, 58.476],
              [12.612, 58.475],
              [12.608, 58.474],
              [12.6, 58.47],
              [12.594, 58.466],
              [12.59, 58.464],
              [12.587, 58.462],
              [12.577, 58.454],
              [12.573, 58.451],
              [12.569, 58.446],
              [12.557, 58.433],
              [12.547, 58.421],
              [12.544, 58.419],
              [12.54, 58.416],
              [12.531, 58.409],
              [12.526, 58.406],
              [12.514, 58.4],
              [12.508, 58.398],
              [12.498, 58.396],
              [12.481, 58.396],
              [12.463, 58.399],
              [12.452, 58.399],
              [12.44, 58.397],
              [12.433, 58.395],
              [12.421, 58.391],
              [12.414, 58.39],
              [12.408, 58.389],
              [12.401, 58.388],
              [12.381, 58.386],
              [12.375, 58.385],
              [12.37, 58.384],
              [12.366, 58.382],
              [12.361, 58.381],
              [12.347, 58.381],
              [12.322, 58.384],
              [12.312, 58.385],
              [12.308, 58.385],
              [12.309, 58.389],
              [12.317, 58.405],
              [12.321, 58.411],
              [12.331, 58.425],
              [12.342, 58.436],
              [12.348, 58.441],
              [12.353, 58.444],
              [12.364, 58.45],
              [12.368, 58.454],
              [12.375, 58.459],
              [12.379, 58.462],
              [12.384, 58.465],
              [12.396, 58.471],
              [12.42, 58.481],
              [12.426, 58.484],
              [12.432, 58.485],
              [12.438, 58.487],
              [12.444, 58.487],
              [12.455, 58.488],
              [12.46, 58.489],
              [12.464, 58.49],
              [12.467, 58.491],
              [12.47, 58.493],
              [12.474, 58.499],
              [12.48, 58.505],
              [12.484, 58.508],
              [12.489, 58.511],
              [12.495, 58.514],
              [12.513, 58.522],
              [12.519, 58.526],
              [12.525, 58.529],
              [12.53, 58.532],
              [12.534, 58.536],
              [12.539, 58.54],
              [12.546, 58.547],
              [12.55, 58.553],
              [12.551, 58.556],
              [12.553, 58.56],
              [12.554, 58.563],
              [12.566, 58.572],
              [12.582, 58.583],
              [12.588, 58.587],
              [12.593, 58.591],
              [12.604, 58.601],
              [12.608, 58.605],
              [12.625, 58.618],
              [12.634, 58.625],
              [12.638, 58.628],
              [12.642, 58.63],
              [12.65, 58.635],
              [12.654, 58.637],
              [12.657, 58.639],
              [12.659, 58.641],
              [12.66, 58.643],
              [12.66, 58.648],
              [12.659, 58.65],
              [12.657, 58.652],
              [12.654, 58.653],
              [12.65, 58.655],
              [12.635, 58.658],
              [12.621, 58.658],
              [12.601, 58.657],
              [12.587, 58.657],
              [12.58, 58.658],
              [12.573, 58.66],
              [12.566, 58.661],
              [12.56, 58.663],
              [12.553, 58.666],
              [12.547, 58.669],
              [12.542, 58.672],
              [12.536, 58.675],
              [12.532, 58.679],
              [12.529, 58.683],
              [12.519, 58.694],
              [12.516, 58.698],
              [12.514, 58.701],
              [12.511, 58.707],
              [12.51, 58.71],
              [12.509, 58.714],
              [12.507, 58.725],
              [12.506, 58.729],
              [12.506, 58.737],
              [12.507, 58.742],
              [12.513, 58.754],
              [12.516, 58.762],
              [12.518, 58.767],
              [12.521, 58.773],
              [12.531, 58.789],
              [12.534, 58.794],
              [12.539, 58.804],
              [12.542, 58.809],
              [12.544, 58.813],
              [12.547, 58.817],
              [12.551, 58.819],
              [12.554, 58.821],
              [12.559, 58.822],
              [12.567, 58.82],
              [12.574, 58.818],
              [12.577, 58.817],
              [12.582, 58.817],
              [12.586, 58.818],
              [12.592, 58.819],
              [12.594, 58.82],
              [12.597, 58.821],
              [12.603, 58.83],
              [12.605, 58.835],
              [12.607, 58.843],
              [12.609, 58.847],
              [12.611, 58.85],
              [12.613, 58.852],
              [12.616, 58.854],
              [12.624, 58.858],
              [12.636, 58.862],
              [12.639, 58.864],
              [12.641, 58.866],
              [12.643, 58.867],
              [12.644, 58.869],
              [12.646, 58.872],
              [12.647, 58.874],
              [12.647, 58.877],
              [12.645, 58.883],
              [12.644, 58.887],
              [12.644, 58.898],
              [12.646, 58.906],
              [12.646, 58.915],
              [12.647, 58.925],
              [12.647, 58.927],
              [12.648, 58.93],
              [12.651, 58.936],
              [12.652, 58.939],
              [12.655, 58.947],
              [12.657, 58.952],
              [12.659, 58.955],
              [12.663, 58.959],
              [12.667, 58.962],
              [12.68, 58.969],
              [12.684, 58.972],
              [12.687, 58.975],
              [12.688, 58.978],
              [12.689, 58.982],
              [12.689, 58.985],
              [12.69, 58.989],
              [12.692, 58.992],
              [12.693, 58.995],
              [12.696, 58.997],
              [12.701, 59.003],
              [12.705, 59.007],
              [12.715, 59.02],
              [12.717, 59.023],
              [12.719, 59.027],
              [12.721, 59.035],
              [12.721, 59.039],
              [12.72, 59.043],
              [12.719, 59.05],
              [12.719, 59.052],
              [12.72, 59.054],
              [12.722, 59.056],
              [12.725, 59.057],
              [12.733, 59.057],
              [12.736, 59.056],
              [12.74, 59.055],
              [12.745, 59.052],
              [12.747, 59.052],
              [12.751, 59.048],
              [12.752, 59.046],
              [12.754, 59.045],
              [12.765, 59.045],
              [12.773, 59.047],
              [12.778, 59.048],
              [12.786, 59.052],
              [12.789, 59.054],
              [12.795, 59.06],
              [12.797, 59.063],
              [12.799, 59.068],
              [12.801, 59.071],
              [12.804, 59.074],
              [12.81, 59.078],
              [12.823, 59.078],
              [12.832, 59.081],
              [12.835, 59.083],
              [12.836, 59.085],
              [12.839, 59.089],
              [12.841, 59.091],
              [12.847, 59.095],
              [12.85, 59.096],
              [12.857, 59.096],
              [12.863, 59.094],
              [12.869, 59.09],
              [12.873, 59.088],
              [12.878, 59.086],
              [12.886, 59.084],
              [12.894, 59.084],
              [12.898, 59.082],
              [12.899, 59.081],
              [12.899, 59.075],
              [12.897, 59.069],
              [12.893, 59.064],
              [12.892, 59.062],
              [12.892, 59.06],
              [12.893, 59.059],
              [12.894, 59.056],
              [12.895, 59.054],
              [12.897, 59.052],
              [12.901, 59.049],
              [12.903, 59.047],
              [12.905, 59.046],
              [12.907, 59.044],
              [12.911, 59.043],
              [12.924, 59.043],
              [12.929, 59.045],
              [12.946, 59.049],
              [12.956, 59.051],
              [12.961, 59.051],
              [12.966, 59.05],
              [12.971, 59.05],
              [12.975, 59.049],
              [12.98, 59.049],
              [12.984, 59.05],
              [12.993, 59.052],
              [12.997, 59.053],
              [13.004, 59.053],
              [13.01, 59.052],
              [13.014, 59.05],
              [13.015, 59.049],
              [13.015, 59.044],
              [13.016, 59.043],
              [13.017, 59.041],
              [13.022, 59.038],
              [13.028, 59.032],
              [13.031, 59.03],
              [13.045, 59.022],
              [13.048, 59.02],
              [13.051, 59.019],
              [13.064, 59.017],
              [13.072, 59.015],
              [13.075, 59.014],
              [13.082, 59.009],
              [13.084, 59.008],
              [13.09, 59.006],
              [13.092, 59.004],
              [13.094, 59.003],
              [13.095, 59.001],
              [13.095, 58.996],
              [13.093, 58.994],
              [13.088, 58.991],
              [13.086, 58.989],
              [13.085, 58.987],
              [13.084, 58.983],
              [13.081, 58.98],
              [13.078, 58.978],
              [13.069, 58.974],
              [13.066, 58.972],
              [13.065, 58.971],
              [13.065, 58.969],
              [13.069, 58.965],
              [13.077, 58.963],
              [13.087, 58.961],
              [13.091, 58.96],
              [13.095, 58.958],
              [13.098, 58.956],
              [13.1, 58.954],
              [13.105, 58.95],
              [13.107, 58.948],
              [13.109, 58.945],
              [13.112, 58.939],
              [13.116, 58.933],
              [13.129, 58.92],
              [13.132, 58.918],
              [13.141, 58.913],
              [13.149, 58.911],
              [13.162, 58.91],
              [13.167, 58.909],
              [13.182, 58.905],
              [13.186, 58.905],
              [13.193, 58.904],
              [13.195, 58.903],
              [13.196, 58.902],
              [13.199, 58.896],
              [13.2, 58.893],
              [13.203, 58.89],
              [13.206, 58.889],
              [13.21, 58.888],
              [13.214, 58.889],
              [13.223, 58.89],
              [13.228, 58.891],
              [13.242, 58.891],
              [13.246, 58.893],
              [13.256, 58.897],
              [13.26, 58.9],
              [13.263, 58.903],
              [13.265, 58.907],
              [13.267, 58.912],
              [13.266, 58.917],
              [13.266, 58.922],
              [13.262, 58.934],
              [13.26, 58.939],
              [13.257, 58.945],
              [13.255, 58.95],
              [13.252, 58.955],
              [13.247, 58.962],
              [13.245, 58.97],
              [13.244, 58.987],
              [13.244, 58.991],
              [13.245, 58.998],
              [13.245, 59.008],
              [13.243, 59.02],
              [13.241, 59.026],
              [13.24, 59.032],
              [13.238, 59.038],
              [13.233, 59.05],
              [13.233, 59.051],
              [13.231, 59.056],
              [13.222, 59.074],
              [13.218, 59.081],
              [13.213, 59.091],
              [13.209, 59.103],
              [13.2, 59.121],
              [13.197, 59.126],
              [13.193, 59.132],
              [13.189, 59.137],
              [13.185, 59.143],
              [13.181, 59.148],
              [13.172, 59.157],
              [13.164, 59.163],
              [13.161, 59.166],
              [13.157, 59.168],
              [13.154, 59.17],
              [13.152, 59.173],
              [13.152, 59.186],
              [13.151, 59.189],
              [13.149, 59.192],
              [13.147, 59.196],
              [13.145, 59.199],
              [13.14, 59.204],
              [13.134, 59.208],
              [13.133, 59.21],
              [13.132, 59.211],
              [13.133, 59.212],
              [13.138, 59.215],
              [13.141, 59.217],
              [13.143, 59.22],
              [13.144, 59.223],
              [13.144, 59.226],
              [13.143, 59.23],
              [13.141, 59.234],
              [13.138, 59.238],
              [13.134, 59.241],
              [13.13, 59.245],
              [13.125, 59.248],
              [13.111, 59.256],
              [13.107, 59.259],
              [13.098, 59.263],
              [13.094, 59.265],
              [13.091, 59.268],
              [13.088, 59.27],
              [13.086, 59.276],
              [13.087, 59.277],
              [13.091, 59.279],
              [13.094, 59.279],
              [13.096, 59.278],
              [13.103, 59.275],
              [13.113, 59.271],
              [13.118, 59.27],
              [13.124, 59.269],
              [13.129, 59.269],
              [13.135, 59.27],
              [13.143, 59.272],
              [13.146, 59.274],
              [13.147, 59.275],
              [13.147, 59.282],
              [13.148, 59.284],
              [13.15, 59.287],
              [13.15, 59.289],
              [13.151, 59.292],
              [13.149, 59.295],
              [13.145, 59.303],
              [13.14, 59.31],
              [13.138, 59.314],
              [13.131, 59.321],
              [13.12, 59.33],
              [13.118, 59.332],
              [13.117, 59.335],
              [13.118, 59.337],
              [13.12, 59.339],
              [13.128, 59.343],
              [13.138, 59.345],
              [13.15, 59.347],
              [13.156, 59.349],
              [13.161, 59.351],
              [13.17, 59.355],
              [13.175, 59.357],
              [13.178, 59.357],
              [13.181, 59.356],
              [13.184, 59.354],
              [13.186, 59.351],
              [13.188, 59.349],
              [13.19, 59.346],
              [13.191, 59.342],
              [13.192, 59.332],
              [13.193, 59.327],
              [13.195, 59.321],
              [13.197, 59.317],
              [13.2, 59.313],
              [13.204, 59.31],
              [13.208, 59.306],
              [13.212, 59.304],
              [13.217, 59.302],
              [13.221, 59.301],
              [13.227, 59.3],
              [13.232, 59.299],
              [13.25, 59.3],
              [13.262, 59.3],
              [13.267, 59.299],
              [13.272, 59.299],
              [13.277, 59.298],
              [13.293, 59.294],
              [13.299, 59.294],
              [13.302, 59.295],
              [13.304, 59.296],
              [13.306, 59.298],
              [13.306, 59.303],
              [13.303, 59.305],
              [13.3, 59.308],
              [13.285, 59.32],
              [13.282, 59.323],
              [13.274, 59.328],
              [13.271, 59.33],
              [13.269, 59.333],
              [13.268, 59.335],
              [13.268, 59.338],
              [13.269, 59.34],
              [13.269, 59.343],
              [13.27, 59.346],
              [13.273, 59.349],
              [13.277, 59.352],
              [13.282, 59.355],
              [13.287, 59.357],
              [13.293, 59.359],
              [13.3, 59.361],
              [13.306, 59.362],
              [13.313, 59.363],
              [13.333, 59.363],
              [13.353, 59.362],
              [13.37, 59.362],
              [13.374, 59.364],
              [13.377, 59.365],
              [13.382, 59.368],
              [13.385, 59.37],
              [13.39, 59.371],
              [13.394, 59.372],
              [13.399, 59.373],
              [13.404, 59.373],
              [13.409, 59.371],
              [13.413, 59.369],
              [13.417, 59.366],
              [13.42, 59.363],
              [13.426, 59.355],
              [13.428, 59.349],
              [13.431, 59.339],
              [13.433, 59.334],
              [13.436, 59.331],
              [13.44, 59.325],
              [13.442, 59.323],
              [13.446, 59.321],
              [13.45, 59.32],
              [13.471, 59.316],
              [13.487, 59.314],
              [13.491, 59.312],
              [13.495, 59.311],
              [13.501, 59.307],
              [13.502, 59.304],
              [13.502, 59.302],
              [13.5, 59.291],
              [13.499, 59.287],
              [13.499, 59.283],
              [13.5, 59.278],
              [13.501, 59.274],
              [13.503, 59.27],
              [13.506, 59.266],
              [13.51, 59.264],
              [13.513, 59.262],
              [13.52, 59.262],
              [13.528, 59.264],
              [13.536, 59.267],
              [13.539, 59.268],
              [13.551, 59.271],
              [13.561, 59.275],
              [13.567, 59.279],
              [13.569, 59.282],
              [13.569, 59.284],
              [13.57, 59.288],
              [13.573, 59.297],
              [13.585, 59.305],
              [13.591, 59.311],
              [13.593, 59.316],
              [13.594, 59.32],
              [13.594, 59.325],
              [13.593, 59.329],
              [13.591, 59.333],
              [13.589, 59.335],
              [13.586, 59.337],
              [13.582, 59.339],
              [13.575, 59.342],
              [13.571, 59.344],
              [13.568, 59.346],
              [13.564, 59.347],
              [13.559, 59.347],
              [13.554, 59.346],
              [13.549, 59.344],
              [13.539, 59.342],
              [13.529, 59.344],
              [13.525, 59.345],
              [13.518, 59.349],
              [13.513, 59.351],
              [13.512, 59.352],
              [13.51, 59.353],
              [13.51, 59.356],
              [13.512, 59.357],
              [13.516, 59.361],
              [13.519, 59.363],
              [13.521, 59.364],
              [13.525, 59.365],
              [13.53, 59.367],
              [13.551, 59.367],
              [13.556, 59.368],
              [13.569, 59.373],
              [13.573, 59.374],
              [13.579, 59.377],
              [13.596, 59.384],
              [13.602, 59.387],
              [13.614, 59.391],
              [13.621, 59.392],
              [13.627, 59.393],
              [13.646, 59.397],
              [13.658, 59.399],
              [13.663, 59.401],
              [13.669, 59.403],
              [13.678, 59.407],
              [13.686, 59.409],
              [13.689, 59.409],
              [13.693, 59.407],
              [13.693, 59.405],
              [13.689, 59.397],
              [13.688, 59.394],
              [13.688, 59.388],
              [13.689, 59.385],
              [13.691, 59.383],
              [13.694, 59.381],
              [13.698, 59.379],
              [13.703, 59.379],
            ],
          ],
        ],
      },
      properties: { id: 58, name: 'Vänern', latlon: [58.970685, 13.518143] },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [17.661, 59.734],
              [17.664, 59.732],
              [17.666, 59.73],
              [17.667, 59.728],
              [17.666, 59.726],
              [17.664, 59.724],
              [17.658, 59.72],
              [17.649, 59.711],
              [17.647, 59.707],
              [17.645, 59.702],
              [17.643, 59.698],
              [17.641, 59.688],
              [17.641, 59.678],
              [17.64, 59.674],
              [17.638, 59.671],
              [17.635, 59.668],
              [17.631, 59.666],
              [17.626, 59.665],
              [17.62, 59.664],
              [17.604, 59.661],
              [17.599, 59.66],
              [17.595, 59.659],
              [17.593, 59.657],
              [17.593, 59.655],
              [17.594, 59.653],
              [17.597, 59.65],
              [17.6, 59.648],
              [17.605, 59.645],
              [17.61, 59.643],
              [17.635, 59.636],
              [17.641, 59.634],
              [17.648, 59.631],
              [17.661, 59.626],
              [17.667, 59.623],
              [17.673, 59.621],
              [17.68, 59.619],
              [17.686, 59.617],
              [17.692, 59.616],
              [17.699, 59.615],
              [17.727, 59.615],
              [17.732, 59.614],
              [17.736, 59.613],
              [17.759, 59.604],
              [17.767, 59.602],
              [17.774, 59.601],
              [17.777, 59.601],
              [17.78, 59.6],
              [17.787, 59.598],
              [17.79, 59.597],
              [17.794, 59.596],
              [17.802, 59.596],
              [17.806, 59.595],
              [17.809, 59.594],
              [17.811, 59.593],
              [17.819, 59.585],
              [17.827, 59.579],
              [17.83, 59.576],
              [17.838, 59.572],
              [17.839, 59.57],
              [17.837, 59.568],
              [17.832, 59.565],
              [17.829, 59.563],
              [17.825, 59.557],
              [17.824, 59.553],
              [17.824, 59.549],
              [17.826, 59.541],
              [17.83, 59.533],
              [17.836, 59.524],
              [17.836, 59.522],
              [17.834, 59.519],
              [17.832, 59.517],
              [17.82, 59.51],
              [17.815, 59.506],
              [17.811, 59.503],
              [17.808, 59.498],
              [17.804, 59.493],
              [17.8, 59.483],
              [17.798, 59.477],
              [17.795, 59.466],
              [17.794, 59.46],
              [17.791, 59.455],
              [17.785, 59.443],
              [17.781, 59.438],
              [17.776, 59.431],
              [17.774, 59.428],
              [17.77, 59.418],
              [17.769, 59.413],
              [17.769, 59.403],
              [17.772, 59.398],
              [17.775, 59.394],
              [17.778, 59.389],
              [17.783, 59.385],
              [17.787, 59.382],
              [17.792, 59.378],
              [17.798, 59.374],
              [17.803, 59.371],
              [17.821, 59.362],
              [17.835, 59.356],
              [17.848, 59.351],
              [17.882, 59.339],
              [17.902, 59.332],
              [17.915, 59.327],
              [17.929, 59.323],
              [17.935, 59.322],
              [17.949, 59.32],
              [17.962, 59.32],
              [17.967, 59.321],
              [17.972, 59.323],
              [17.975, 59.325],
              [17.979, 59.327],
              [17.981, 59.33],
              [17.982, 59.333],
              [17.982, 59.336],
              [17.98, 59.338],
              [17.979, 59.34],
              [17.977, 59.342],
              [17.975, 59.343],
              [17.974, 59.345],
              [17.974, 59.35],
              [17.979, 59.35],
              [17.991, 59.346],
              [17.996, 59.345],
              [18.04, 59.334],
              [18.045, 59.332],
              [18.05, 59.331],
              [18.054, 59.329],
              [18.057, 59.326],
              [18.058, 59.324],
              [18.055, 59.321],
              [18.052, 59.32],
              [18.047, 59.318],
              [18.045, 59.317],
              [18.044, 59.315],
              [18.047, 59.312],
              [18.05, 59.311],
              [18.059, 59.307],
              [18.061, 59.306],
              [18.062, 59.305],
              [18.055, 59.305],
              [18.05, 59.306],
              [18.046, 59.306],
              [18.04, 59.308],
              [18.021, 59.312],
              [18.015, 59.314],
              [18.009, 59.314],
              [18.005, 59.315],
              [18.001, 59.315],
              [17.997, 59.314],
              [17.993, 59.314],
              [17.99, 59.313],
              [17.979, 59.31],
              [17.973, 59.309],
              [17.962, 59.306],
              [17.937, 59.302],
              [17.924, 59.299],
              [17.906, 59.293],
              [17.901, 59.291],
              [17.895, 59.288],
              [17.89, 59.286],
              [17.886, 59.282],
              [17.882, 59.279],
              [17.874, 59.271],
              [17.871, 59.267],
              [17.867, 59.264],
              [17.857, 59.26],
              [17.852, 59.26],
              [17.84, 59.258],
              [17.821, 59.256],
              [17.808, 59.255],
              [17.781, 59.255],
              [17.746, 59.26],
              [17.725, 59.264],
              [17.669, 59.274],
              [17.654, 59.276],
              [17.633, 59.279],
              [17.627, 59.28],
              [17.614, 59.28],
              [17.608, 59.279],
              [17.603, 59.278],
              [17.595, 59.274],
              [17.593, 59.271],
              [17.592, 59.268],
              [17.592, 59.265],
              [17.594, 59.259],
              [17.598, 59.254],
              [17.599, 59.251],
              [17.599, 59.245],
              [17.601, 59.239],
              [17.603, 59.234],
              [17.606, 59.23],
              [17.609, 59.225],
              [17.62, 59.208],
              [17.622, 59.204],
              [17.618, 59.206],
              [17.607, 59.217],
              [17.596, 59.231],
              [17.592, 59.236],
              [17.588, 59.24],
              [17.573, 59.252],
              [17.568, 59.255],
              [17.561, 59.258],
              [17.555, 59.261],
              [17.548, 59.263],
              [17.542, 59.265],
              [17.535, 59.267],
              [17.501, 59.278],
              [17.495, 59.28],
              [17.488, 59.282],
              [17.482, 59.285],
              [17.475, 59.288],
              [17.456, 59.297],
              [17.449, 59.3],
              [17.437, 59.304],
              [17.431, 59.305],
              [17.413, 59.309],
              [17.407, 59.311],
              [17.402, 59.312],
              [17.391, 59.316],
              [17.386, 59.318],
              [17.381, 59.319],
              [17.373, 59.319],
              [17.369, 59.317],
              [17.365, 59.313],
              [17.365, 59.293],
              [17.366, 59.289],
              [17.368, 59.284],
              [17.371, 59.28],
              [17.375, 59.275],
              [17.379, 59.271],
              [17.393, 59.255],
              [17.397, 59.252],
              [17.401, 59.248],
              [17.406, 59.245],
              [17.414, 59.24],
              [17.417, 59.238],
              [17.418, 59.237],
              [17.417, 59.236],
              [17.411, 59.236],
              [17.406, 59.237],
              [17.395, 59.239],
              [17.368, 59.244],
              [17.355, 59.247],
              [17.348, 59.247],
              [17.341, 59.248],
              [17.335, 59.249],
              [17.306, 59.249],
              [17.301, 59.25],
              [17.296, 59.25],
              [17.287, 59.252],
              [17.283, 59.253],
              [17.272, 59.253],
              [17.27, 59.252],
              [17.269, 59.252],
              [17.269, 59.249],
              [17.268, 59.248],
              [17.266, 59.247],
              [17.263, 59.247],
              [17.259, 59.246],
              [17.245, 59.246],
              [17.229, 59.245],
              [17.195, 59.245],
              [17.191, 59.246],
              [17.19, 59.246],
              [17.19, 59.247],
              [17.192, 59.249],
              [17.195, 59.25],
              [17.198, 59.25],
              [17.205, 59.252],
              [17.224, 59.256],
              [17.23, 59.257],
              [17.237, 59.258],
              [17.243, 59.259],
              [17.262, 59.26],
              [17.272, 59.262],
              [17.276, 59.264],
              [17.279, 59.266],
              [17.281, 59.268],
              [17.281, 59.273],
              [17.279, 59.276],
              [17.277, 59.278],
              [17.274, 59.28],
              [17.266, 59.284],
              [17.264, 59.286],
              [17.261, 59.291],
              [17.259, 59.293],
              [17.254, 59.299],
              [17.252, 59.303],
              [17.254, 59.304],
              [17.256, 59.306],
              [17.264, 59.308],
              [17.269, 59.309],
              [17.277, 59.311],
              [17.302, 59.311],
              [17.307, 59.312],
              [17.311, 59.312],
              [17.315, 59.313],
              [17.317, 59.314],
              [17.318, 59.315],
              [17.319, 59.315],
              [17.319, 59.316],
              [17.316, 59.319],
              [17.316, 59.32],
              [17.317, 59.32],
              [17.322, 59.322],
              [17.324, 59.323],
              [17.327, 59.325],
              [17.328, 59.327],
              [17.327, 59.329],
              [17.326, 59.332],
              [17.324, 59.335],
              [17.32, 59.337],
              [17.315, 59.34],
              [17.309, 59.342],
              [17.304, 59.344],
              [17.297, 59.347],
              [17.291, 59.348],
              [17.285, 59.35],
              [17.278, 59.352],
              [17.271, 59.353],
              [17.265, 59.355],
              [17.258, 59.356],
              [17.224, 59.356],
              [17.219, 59.357],
              [17.214, 59.359],
              [17.202, 59.362],
              [17.196, 59.364],
              [17.191, 59.365],
              [17.184, 59.366],
              [17.178, 59.366],
              [17.172, 59.367],
              [17.166, 59.367],
              [17.152, 59.368],
              [17.145, 59.368],
              [17.126, 59.37],
              [17.12, 59.371],
              [17.107, 59.371],
              [17.101, 59.37],
              [17.095, 59.37],
              [17.065, 59.365],
              [17.06, 59.364],
              [17.05, 59.364],
              [17.046, 59.366],
              [17.043, 59.368],
              [17.035, 59.373],
              [17.031, 59.375],
              [17.026, 59.378],
              [17.012, 59.385],
              [17.008, 59.388],
              [17.002, 59.392],
              [16.999, 59.395],
              [16.985, 59.404],
              [16.979, 59.407],
              [16.969, 59.415],
              [16.947, 59.433],
              [16.935, 59.441],
              [16.93, 59.445],
              [16.924, 59.449],
              [16.918, 59.452],
              [16.905, 59.459],
              [16.893, 59.465],
              [16.88, 59.471],
              [16.868, 59.477],
              [16.856, 59.481],
              [16.849, 59.483],
              [16.846, 59.483],
              [16.843, 59.484],
              [16.833, 59.484],
              [16.829, 59.483],
              [16.824, 59.482],
              [16.821, 59.481],
              [16.817, 59.479],
              [16.811, 59.474],
              [16.807, 59.473],
              [16.803, 59.471],
              [16.798, 59.47],
              [16.793, 59.47],
              [16.782, 59.469],
              [16.776, 59.469],
              [16.757, 59.467],
              [16.751, 59.466],
              [16.745, 59.466],
              [16.734, 59.468],
              [16.718, 59.468],
              [16.715, 59.467],
              [16.714, 59.466],
              [16.715, 59.464],
              [16.718, 59.462],
              [16.722, 59.46],
              [16.727, 59.458],
              [16.732, 59.455],
              [16.744, 59.45],
              [16.757, 59.444],
              [16.811, 59.421],
              [16.837, 59.41],
              [16.85, 59.405],
              [16.857, 59.403],
              [16.874, 59.397],
              [16.879, 59.396],
              [16.883, 59.393],
              [16.885, 59.392],
              [16.889, 59.387],
              [16.898, 59.381],
              [16.902, 59.377],
              [16.902, 59.375],
              [16.901, 59.374],
              [16.899, 59.373],
              [16.895, 59.372],
              [16.89, 59.371],
              [16.879, 59.371],
              [16.865, 59.372],
              [16.837, 59.375],
              [16.803, 59.379],
              [16.792, 59.38],
              [16.787, 59.381],
              [16.784, 59.381],
              [16.783, 59.382],
              [16.784, 59.383],
              [16.789, 59.385],
              [16.793, 59.387],
              [16.796, 59.389],
              [16.798, 59.392],
              [16.801, 59.394],
              [16.803, 59.397],
              [16.804, 59.399],
              [16.803, 59.401],
              [16.802, 59.404],
              [16.8, 59.407],
              [16.797, 59.41],
              [16.794, 59.412],
              [16.791, 59.415],
              [16.779, 59.422],
              [16.771, 59.428],
              [16.761, 59.434],
              [16.749, 59.441],
              [16.719, 59.456],
              [16.713, 59.458],
              [16.707, 59.461],
              [16.695, 59.463],
              [16.684, 59.463],
              [16.679, 59.462],
              [16.662, 59.46],
              [16.657, 59.459],
              [16.651, 59.458],
              [16.634, 59.453],
              [16.629, 59.452],
              [16.617, 59.45],
              [16.607, 59.448],
              [16.591, 59.448],
              [16.573, 59.45],
              [16.567, 59.45],
              [16.561, 59.451],
              [16.555, 59.451],
              [16.549, 59.45],
              [16.531, 59.449],
              [16.511, 59.449],
              [16.493, 59.45],
              [16.489, 59.451],
              [16.478, 59.453],
              [16.472, 59.453],
              [16.462, 59.455],
              [16.452, 59.455],
              [16.44, 59.454],
              [16.436, 59.453],
              [16.432, 59.453],
              [16.429, 59.451],
              [16.427, 59.45],
              [16.426, 59.449],
              [16.426, 59.447],
              [16.427, 59.446],
              [16.433, 59.442],
              [16.44, 59.439],
              [16.441, 59.439],
              [16.439, 59.438],
              [16.433, 59.438],
              [16.429, 59.439],
              [16.424, 59.439],
              [16.419, 59.44],
              [16.411, 59.442],
              [16.408, 59.443],
              [16.403, 59.448],
              [16.401, 59.449],
              [16.399, 59.451],
              [16.384, 59.454],
              [16.351, 59.454],
              [16.323, 59.452],
              [16.317, 59.451],
              [16.31, 59.45],
              [16.291, 59.448],
              [16.285, 59.447],
              [16.266, 59.445],
              [16.256, 59.444],
              [16.243, 59.443],
              [16.237, 59.443],
              [16.231, 59.442],
              [16.205, 59.438],
              [16.196, 59.437],
              [16.19, 59.436],
              [16.183, 59.435],
              [16.177, 59.434],
              [16.157, 59.433],
              [16.113, 59.433],
              [16.108, 59.434],
              [16.102, 59.435],
              [16.097, 59.437],
              [16.092, 59.44],
              [16.088, 59.443],
              [16.084, 59.448],
              [16.079, 59.452],
              [16.068, 59.468],
              [16.063, 59.473],
              [16.059, 59.478],
              [16.053, 59.483],
              [16.047, 59.487],
              [16.039, 59.492],
              [16.032, 59.496],
              [16.025, 59.499],
              [16.017, 59.502],
              [16.011, 59.504],
              [16.006, 59.506],
              [16.001, 59.507],
              [16.002, 59.507],
              [16.005, 59.506],
              [16.014, 59.504],
              [16.029, 59.499],
              [16.046, 59.493],
              [16.076, 59.481],
              [16.083, 59.479],
              [16.089, 59.477],
              [16.096, 59.475],
              [16.102, 59.473],
              [16.109, 59.472],
              [16.115, 59.471],
              [16.128, 59.471],
              [16.147, 59.472],
              [16.153, 59.473],
              [16.159, 59.472],
              [16.165, 59.472],
              [16.176, 59.47],
              [16.181, 59.47],
              [16.186, 59.469],
              [16.191, 59.47],
              [16.199, 59.471],
              [16.204, 59.471],
              [16.208, 59.472],
              [16.211, 59.471],
              [16.215, 59.471],
              [16.219, 59.47],
              [16.228, 59.47],
              [16.232, 59.471],
              [16.238, 59.473],
              [16.24, 59.475],
              [16.241, 59.477],
              [16.238, 59.48],
              [16.235, 59.481],
              [16.231, 59.483],
              [16.222, 59.486],
              [16.221, 59.487],
              [16.221, 59.489],
              [16.222, 59.491],
              [16.234, 59.499],
              [16.238, 59.501],
              [16.242, 59.504],
              [16.247, 59.506],
              [16.263, 59.511],
              [16.269, 59.514],
              [16.274, 59.517],
              [16.295, 59.527],
              [16.298, 59.529],
              [16.301, 59.53],
              [16.303, 59.53],
              [16.303, 59.529],
              [16.297, 59.523],
              [16.294, 59.521],
              [16.289, 59.518],
              [16.279, 59.513],
              [16.274, 59.51],
              [16.261, 59.504],
              [16.258, 59.502],
              [16.257, 59.5],
              [16.256, 59.499],
              [16.257, 59.497],
              [16.263, 59.493],
              [16.288, 59.483],
              [16.294, 59.482],
              [16.299, 59.481],
              [16.321, 59.477],
              [16.326, 59.477],
              [16.333, 59.476],
              [16.338, 59.475],
              [16.351, 59.475],
              [16.355, 59.477],
              [16.36, 59.479],
              [16.363, 59.481],
              [16.367, 59.482],
              [16.377, 59.484],
              [16.393, 59.489],
              [16.398, 59.49],
              [16.402, 59.491],
              [16.409, 59.492],
              [16.417, 59.492],
              [16.425, 59.49],
              [16.431, 59.488],
              [16.44, 59.488],
              [16.447, 59.489],
              [16.451, 59.489],
              [16.456, 59.488],
              [16.459, 59.487],
              [16.463, 59.486],
              [16.468, 59.486],
              [16.478, 59.488],
              [16.483, 59.49],
              [16.487, 59.493],
              [16.49, 59.495],
              [16.492, 59.498],
              [16.493, 59.501],
              [16.491, 59.507],
              [16.486, 59.512],
              [16.478, 59.516],
              [16.477, 59.517],
              [16.477, 59.518],
              [16.478, 59.52],
              [16.481, 59.521],
              [16.485, 59.522],
              [16.489, 59.522],
              [16.494, 59.523],
              [16.499, 59.523],
              [16.504, 59.522],
              [16.508, 59.522],
              [16.513, 59.521],
              [16.516, 59.519],
              [16.519, 59.518],
              [16.521, 59.516],
              [16.522, 59.514],
              [16.524, 59.513],
              [16.53, 59.511],
              [16.533, 59.511],
              [16.537, 59.512],
              [16.539, 59.513],
              [16.54, 59.514],
              [16.542, 59.518],
              [16.548, 59.527],
              [16.549, 59.53],
              [16.55, 59.534],
              [16.55, 59.543],
              [16.548, 59.546],
              [16.546, 59.55],
              [16.538, 59.56],
              [16.531, 59.572],
              [16.529, 59.575],
              [16.528, 59.579],
              [16.528, 59.582],
              [16.529, 59.586],
              [16.531, 59.589],
              [16.534, 59.592],
              [16.538, 59.595],
              [16.553, 59.601],
              [16.559, 59.601],
              [16.565, 59.602],
              [16.571, 59.601],
              [16.577, 59.599],
              [16.584, 59.597],
              [16.59, 59.595],
              [16.614, 59.583],
              [16.62, 59.579],
              [16.625, 59.575],
              [16.631, 59.572],
              [16.637, 59.567],
              [16.642, 59.563],
              [16.658, 59.548],
              [16.664, 59.544],
              [16.669, 59.539],
              [16.675, 59.535],
              [16.68, 59.531],
              [16.685, 59.529],
              [16.691, 59.526],
              [16.696, 59.525],
              [16.701, 59.523],
              [16.707, 59.522],
              [16.712, 59.521],
              [16.741, 59.518],
              [16.751, 59.518],
              [16.756, 59.519],
              [16.76, 59.52],
              [16.763, 59.521],
              [16.765, 59.522],
              [16.765, 59.524],
              [16.767, 59.528],
              [16.771, 59.532],
              [16.781, 59.537],
              [16.786, 59.54],
              [16.79, 59.543],
              [16.794, 59.547],
              [16.798, 59.55],
              [16.802, 59.554],
              [16.809, 59.563],
              [16.817, 59.569],
              [16.827, 59.571],
              [16.832, 59.571],
              [16.85, 59.57],
              [16.88, 59.57],
              [16.883, 59.571],
              [16.889, 59.571],
              [16.896, 59.57],
              [16.908, 59.568],
              [16.914, 59.565],
              [16.919, 59.562],
              [16.925, 59.559],
              [16.935, 59.551],
              [16.94, 59.548],
              [16.946, 59.545],
              [16.951, 59.542],
              [16.956, 59.541],
              [16.96, 59.54],
              [16.965, 59.539],
              [16.984, 59.536],
              [17.004, 59.533],
              [17.017, 59.531],
              [17.044, 59.531],
              [17.05, 59.532],
              [17.057, 59.533],
              [17.069, 59.535],
              [17.074, 59.537],
              [17.08, 59.539],
              [17.081, 59.541],
              [17.081, 59.543],
              [17.08, 59.546],
              [17.073, 59.553],
              [17.069, 59.556],
              [17.064, 59.559],
              [17.058, 59.562],
              [17.042, 59.571],
              [17.037, 59.574],
              [17.033, 59.576],
              [17.03, 59.579],
              [17.029, 59.581],
              [17.029, 59.583],
              [17.031, 59.585],
              [17.035, 59.587],
              [17.051, 59.591],
              [17.055, 59.59],
              [17.063, 59.586],
              [17.076, 59.574],
              [17.086, 59.566],
              [17.092, 59.562],
              [17.097, 59.558],
              [17.109, 59.55],
              [17.127, 59.541],
              [17.141, 59.537],
              [17.147, 59.535],
              [17.154, 59.534],
              [17.167, 59.531],
              [17.174, 59.53],
              [17.186, 59.528],
              [17.192, 59.528],
              [17.197, 59.527],
              [17.202, 59.527],
              [17.206, 59.526],
              [17.218, 59.52],
              [17.222, 59.516],
              [17.226, 59.513],
              [17.232, 59.505],
              [17.234, 59.501],
              [17.236, 59.496],
              [17.238, 59.488],
              [17.239, 59.485],
              [17.242, 59.481],
              [17.244, 59.478],
              [17.248, 59.476],
              [17.254, 59.474],
              [17.258, 59.475],
              [17.26, 59.476],
              [17.262, 59.478],
              [17.262, 59.483],
              [17.26, 59.487],
              [17.26, 59.49],
              [17.262, 59.491],
              [17.265, 59.491],
              [17.269, 59.49],
              [17.284, 59.487],
              [17.294, 59.486],
              [17.298, 59.485],
              [17.303, 59.483],
              [17.309, 59.482],
              [17.314, 59.48],
              [17.319, 59.477],
              [17.324, 59.475],
              [17.328, 59.472],
              [17.337, 59.466],
              [17.343, 59.463],
              [17.348, 59.461],
              [17.354, 59.458],
              [17.374, 59.451],
              [17.378, 59.449],
              [17.381, 59.447],
              [17.384, 59.447],
              [17.385, 59.448],
              [17.386, 59.45],
              [17.386, 59.452],
              [17.384, 59.455],
              [17.381, 59.459],
              [17.367, 59.473],
              [17.365, 59.476],
              [17.364, 59.479],
              [17.364, 59.481],
              [17.365, 59.483],
              [17.372, 59.483],
              [17.375, 59.482],
              [17.382, 59.48],
              [17.4, 59.471],
              [17.404, 59.468],
              [17.408, 59.467],
              [17.413, 59.466],
              [17.417, 59.466],
              [17.42, 59.468],
              [17.424, 59.474],
              [17.424, 59.478],
              [17.425, 59.482],
              [17.421, 59.498],
              [17.42, 59.504],
              [17.419, 59.507],
              [17.417, 59.51],
              [17.415, 59.512],
              [17.413, 59.515],
              [17.412, 59.516],
              [17.411, 59.518],
              [17.417, 59.521],
              [17.42, 59.522],
              [17.423, 59.524],
              [17.424, 59.526],
              [17.424, 59.531],
              [17.423, 59.535],
              [17.413, 59.545],
              [17.399, 59.556],
              [17.394, 59.56],
              [17.39, 59.565],
              [17.387, 59.568],
              [17.382, 59.576],
              [17.378, 59.581],
              [17.368, 59.593],
              [17.365, 59.597],
              [17.363, 59.601],
              [17.361, 59.604],
              [17.361, 59.607],
              [17.362, 59.609],
              [17.364, 59.612],
              [17.37, 59.617],
              [17.373, 59.62],
              [17.378, 59.627],
              [17.388, 59.637],
              [17.391, 59.639],
              [17.393, 59.64],
              [17.394, 59.64],
              [17.394, 59.636],
              [17.391, 59.629],
              [17.39, 59.624],
              [17.39, 59.614],
              [17.391, 59.609],
              [17.395, 59.599],
              [17.398, 59.594],
              [17.406, 59.584],
              [17.416, 59.574],
              [17.421, 59.57],
              [17.426, 59.565],
              [17.431, 59.561],
              [17.437, 59.557],
              [17.442, 59.553],
              [17.448, 59.549],
              [17.46, 59.543],
              [17.478, 59.537],
              [17.484, 59.536],
              [17.491, 59.535],
              [17.497, 59.534],
              [17.515, 59.534],
              [17.52, 59.536],
              [17.525, 59.537],
              [17.53, 59.54],
              [17.536, 59.544],
              [17.54, 59.546],
              [17.546, 59.546],
              [17.548, 59.544],
              [17.549, 59.542],
              [17.55, 59.539],
              [17.549, 59.536],
              [17.544, 59.531],
              [17.537, 59.527],
              [17.528, 59.518],
              [17.526, 59.514],
              [17.525, 59.51],
              [17.525, 59.506],
              [17.526, 59.503],
              [17.532, 59.495],
              [17.536, 59.492],
              [17.543, 59.486],
              [17.548, 59.481],
              [17.55, 59.477],
              [17.551, 59.477],
              [17.553, 59.476],
              [17.556, 59.477],
              [17.558, 59.478],
              [17.561, 59.48],
              [17.566, 59.486],
              [17.569, 59.489],
              [17.575, 59.492],
              [17.578, 59.493],
              [17.581, 59.492],
              [17.585, 59.491],
              [17.589, 59.485],
              [17.589, 59.482],
              [17.588, 59.478],
              [17.587, 59.475],
              [17.585, 59.472],
              [17.581, 59.467],
              [17.58, 59.465],
              [17.581, 59.463],
              [17.583, 59.462],
              [17.586, 59.46],
              [17.588, 59.46],
              [17.591, 59.461],
              [17.6, 59.462],
              [17.604, 59.463],
              [17.616, 59.467],
              [17.618, 59.468],
              [17.619, 59.469],
              [17.619, 59.47],
              [17.617, 59.472],
              [17.613, 59.475],
              [17.608, 59.48],
              [17.608, 59.482],
              [17.607, 59.485],
              [17.607, 59.49],
              [17.608, 59.491],
              [17.609, 59.493],
              [17.617, 59.493],
              [17.625, 59.492],
              [17.634, 59.491],
              [17.638, 59.491],
              [17.644, 59.489],
              [17.659, 59.483],
              [17.663, 59.48],
              [17.667, 59.478],
              [17.67, 59.476],
              [17.687, 59.459],
              [17.693, 59.452],
              [17.701, 59.446],
              [17.716, 59.44],
              [17.724, 59.438],
              [17.728, 59.438],
              [17.732, 59.439],
              [17.735, 59.441],
              [17.738, 59.442],
              [17.741, 59.445],
              [17.743, 59.448],
              [17.744, 59.451],
              [17.745, 59.455],
              [17.747, 59.461],
              [17.747, 59.464],
              [17.749, 59.467],
              [17.751, 59.469],
              [17.754, 59.471],
              [17.758, 59.472],
              [17.76, 59.473],
              [17.762, 59.473],
              [17.766, 59.472],
              [17.773, 59.47],
              [17.778, 59.47],
              [17.781, 59.471],
              [17.785, 59.473],
              [17.787, 59.475],
              [17.787, 59.483],
              [17.786, 59.486],
              [17.782, 59.49],
              [17.777, 59.492],
              [17.777, 59.495],
              [17.779, 59.498],
              [17.785, 59.504],
              [17.789, 59.507],
              [17.793, 59.511],
              [17.8, 59.516],
              [17.802, 59.518],
              [17.805, 59.52],
              [17.806, 59.523],
              [17.808, 59.531],
              [17.807, 59.536],
              [17.805, 59.542],
              [17.803, 59.547],
              [17.801, 59.553],
              [17.797, 59.558],
              [17.794, 59.563],
              [17.782, 59.578],
              [17.772, 59.584],
              [17.766, 59.586],
              [17.761, 59.589],
              [17.731, 59.594],
              [17.713, 59.6],
              [17.696, 59.607],
              [17.684, 59.611],
              [17.67, 59.615],
              [17.664, 59.618],
              [17.657, 59.62],
              [17.645, 59.625],
              [17.638, 59.627],
              [17.628, 59.63],
              [17.623, 59.632],
              [17.619, 59.633],
              [17.601, 59.641],
              [17.596, 59.644],
              [17.588, 59.648],
              [17.585, 59.651],
              [17.582, 59.653],
              [17.581, 59.656],
              [17.581, 59.658],
              [17.582, 59.66],
              [17.585, 59.663],
              [17.588, 59.665],
              [17.596, 59.67],
              [17.601, 59.673],
              [17.605, 59.676],
              [17.61, 59.68],
              [17.614, 59.684],
              [17.617, 59.688],
              [17.62, 59.691],
              [17.624, 59.698],
              [17.629, 59.707],
              [17.632, 59.711],
              [17.634, 59.715],
              [17.635, 59.719],
              [17.635, 59.722],
              [17.632, 59.725],
              [17.629, 59.727],
              [17.624, 59.729],
              [17.619, 59.73],
              [17.607, 59.732],
              [17.581, 59.732],
              [17.575, 59.731],
              [17.57, 59.731],
              [17.565, 59.73],
              [17.561, 59.729],
              [17.558, 59.728],
              [17.556, 59.726],
              [17.556, 59.724],
              [17.557, 59.721],
              [17.558, 59.719],
              [17.557, 59.717],
              [17.555, 59.715],
              [17.552, 59.713],
              [17.539, 59.706],
              [17.531, 59.7],
              [17.525, 59.694],
              [17.521, 59.678],
              [17.519, 59.669],
              [17.517, 59.658],
              [17.515, 59.653],
              [17.513, 59.644],
              [17.512, 59.64],
              [17.513, 59.636],
              [17.514, 59.633],
              [17.516, 59.631],
              [17.52, 59.626],
              [17.522, 59.623],
              [17.523, 59.62],
              [17.526, 59.61],
              [17.527, 59.605],
              [17.529, 59.6],
              [17.535, 59.589],
              [17.535, 59.584],
              [17.534, 59.584],
              [17.532, 59.585],
              [17.526, 59.589],
              [17.52, 59.595],
              [17.518, 59.599],
              [17.515, 59.604],
              [17.51, 59.61],
              [17.508, 59.613],
              [17.504, 59.621],
              [17.503, 59.626],
              [17.501, 59.634],
              [17.501, 59.641],
              [17.5, 59.645],
              [17.499, 59.648],
              [17.497, 59.651],
              [17.493, 59.656],
              [17.492, 59.658],
              [17.493, 59.66],
              [17.495, 59.663],
              [17.495, 59.666],
              [17.491, 59.668],
              [17.488, 59.669],
              [17.486, 59.669],
              [17.481, 59.668],
              [17.476, 59.668],
              [17.475, 59.67],
              [17.475, 59.672],
              [17.477, 59.674],
              [17.479, 59.677],
              [17.484, 59.682],
              [17.492, 59.687],
              [17.495, 59.689],
              [17.497, 59.691],
              [17.5, 59.696],
              [17.506, 59.701],
              [17.507, 59.703],
              [17.509, 59.704],
              [17.51, 59.707],
              [17.515, 59.716],
              [17.517, 59.718],
              [17.517, 59.723],
              [17.515, 59.725],
              [17.512, 59.727],
              [17.502, 59.729],
              [17.496, 59.73],
              [17.475, 59.73],
              [17.447, 59.729],
              [17.426, 59.729],
              [17.414, 59.731],
              [17.409, 59.732],
              [17.405, 59.733],
              [17.402, 59.734],
              [17.401, 59.734],
              [17.403, 59.735],
              [17.406, 59.736],
              [17.41, 59.736],
              [17.421, 59.737],
              [17.449, 59.737],
              [17.507, 59.739],
              [17.528, 59.74],
              [17.542, 59.741],
              [17.548, 59.741],
              [17.555, 59.742],
              [17.56, 59.744],
              [17.566, 59.745],
              [17.57, 59.748],
              [17.573, 59.75],
              [17.576, 59.753],
              [17.576, 59.756],
              [17.577, 59.76],
              [17.578, 59.762],
              [17.58, 59.763],
              [17.59, 59.767],
              [17.594, 59.769],
              [17.597, 59.771],
              [17.61, 59.784],
              [17.614, 59.786],
              [17.618, 59.786],
              [17.621, 59.787],
              [17.625, 59.786],
              [17.636, 59.785],
              [17.642, 59.783],
              [17.643, 59.782],
              [17.644, 59.78],
              [17.64, 59.768],
              [17.639, 59.764],
              [17.639, 59.756],
              [17.64, 59.752],
              [17.646, 59.744],
              [17.649, 59.741],
              [17.653, 59.738],
              [17.661, 59.734],
            ],
          ],
        ],
      },
      properties: { id: 62, name: 'Mälaren', latlon: [59.401973, 17.403722] },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [16.816, 58.204],
              [22.044, 58.21],
              [22.045, 58.209],
              [22.048, 58.201],
              [22.05, 58.197],
              [22.052, 58.194],
              [22.058, 58.188],
              [22.062, 58.185],
              [22.068, 58.181],
              [22.072, 58.18],
              [22.076, 58.18],
              [22.082, 58.179],
              [22.086, 58.179],
              [22.091, 58.178],
              [22.107, 58.175],
              [22.113, 58.174],
              [22.12, 58.173],
              [22.132, 58.171],
              [22.137, 58.169],
              [22.143, 58.168],
              [22.154, 58.163],
              [22.16, 58.161],
              [22.172, 58.159],
              [22.19, 58.157],
              [22.2, 58.155],
              [22.205, 58.153],
              [22.209, 58.15],
              [22.211, 58.148],
              [22.213, 58.144],
              [22.213, 58.141],
              [22.212, 58.138],
              [22.21, 58.135],
              [22.207, 58.132],
              [22.199, 58.125],
              [22.195, 58.12],
              [22.19, 58.115],
              [22.186, 58.11],
              [22.181, 58.105],
              [22.178, 58.099],
              [22.174, 58.094],
              [22.169, 58.085],
              [22.167, 58.081],
              [22.161, 58.075],
              [22.157, 58.073],
              [22.149, 58.071],
              [22.144, 58.072],
              [22.136, 58.074],
              [22.128, 58.078],
              [22.123, 58.08],
              [22.117, 58.081],
              [22.105, 58.081],
              [22.102, 58.08],
              [22.094, 58.078],
              [22.09, 58.076],
              [22.086, 58.073],
              [22.081, 58.07],
              [22.077, 58.066],
              [22.074, 58.062],
              [22.07, 58.057],
              [22.064, 58.047],
              [22.062, 58.043],
              [22.056, 58.036],
              [22.052, 58.03],
              [22.046, 58.023],
              [22.043, 58.02],
              [22.038, 58.013],
              [22.036, 58.01],
              [22.033, 58.006],
              [22.022, 57.997],
              [22.012, 57.987],
              [22.008, 57.984],
              [22.003, 57.982],
              [21.993, 57.976],
              [21.99, 57.974],
              [21.987, 57.97],
              [21.985, 57.967],
              [21.985, 57.959],
              [21.986, 57.955],
              [21.988, 57.951],
              [21.99, 57.948],
              [22.011, 57.927],
              [22.015, 57.924],
              [22.02, 57.921],
              [22.024, 57.918],
              [22.029, 57.916],
              [22.039, 57.914],
              [22.037, 57.614],
              [22.03, 57.613],
              [22.023, 57.611],
              [22.002, 57.608],
              [21.989, 57.607],
              [21.961, 57.605],
              [21.891, 57.601],
              [21.863, 57.599],
              [21.842, 57.597],
              [21.835, 57.597],
              [21.82, 57.595],
              [21.799, 57.592],
              [21.778, 57.588],
              [21.764, 57.586],
              [21.756, 57.584],
              [21.749, 57.583],
              [21.743, 57.581],
              [21.729, 57.577],
              [21.723, 57.574],
              [21.717, 57.572],
              [21.711, 57.569],
              [21.705, 57.565],
              [21.7, 57.561],
              [21.685, 57.546],
              [21.681, 57.541],
              [21.672, 57.53],
              [21.628, 57.474],
              [21.615, 57.457],
              [21.606, 57.446],
              [21.601, 57.441],
              [21.597, 57.436],
              [21.592, 57.431],
              [21.587, 57.427],
              [21.581, 57.422],
              [21.576, 57.418],
              [21.571, 57.415],
              [21.565, 57.411],
              [21.56, 57.408],
              [21.554, 57.404],
              [21.549, 57.401],
              [21.544, 57.399],
              [21.532, 57.393],
              [21.527, 57.39],
              [21.523, 57.386],
              [21.518, 57.382],
              [21.514, 57.377],
              [21.5, 57.362],
              [21.495, 57.357],
              [21.49, 57.353],
              [21.479, 57.343],
              [21.452, 57.319],
              [21.447, 57.315],
              [21.441, 57.31],
              [21.437, 57.305],
              [21.432, 57.3],
              [21.428, 57.294],
              [21.424, 57.289],
              [21.422, 57.283],
              [21.419, 57.277],
              [21.418, 57.271],
              [21.416, 57.264],
              [21.415, 57.257],
              [21.413, 57.244],
              [21.411, 57.223],
              [21.409, 57.203],
              [21.408, 57.189],
              [21.408, 57.169],
              [21.409, 57.162],
              [21.41, 57.148],
              [21.412, 57.127],
              [21.414, 57.113],
              [21.414, 57.086],
              [21.413, 57.079],
              [21.407, 57.061],
              [21.398, 57.043],
              [21.395, 57.038],
              [21.392, 57.032],
              [21.388, 57.026],
              [21.385, 57.021],
              [21.381, 57.015],
              [21.373, 57.005],
              [21.368, 57.001],
              [21.363, 56.996],
              [21.357, 56.992],
              [21.352, 56.988],
              [21.346, 56.984],
              [21.329, 56.973],
              [21.282, 56.943],
              [21.264, 56.932],
              [21.252, 56.925],
              [21.246, 56.921],
              [21.24, 56.918],
              [21.233, 56.915],
              [21.227, 56.913],
              [21.213, 56.908],
              [21.18, 56.896],
              [21.167, 56.891],
              [21.16, 56.888],
              [21.148, 56.883],
              [21.129, 56.874],
              [21.111, 56.864],
              [21.087, 56.852],
              [21.082, 56.848],
              [21.076, 56.845],
              [21.072, 56.841],
              [21.067, 56.837],
              [21.061, 56.827],
              [21.059, 56.821],
              [21.058, 56.814],
              [21.057, 56.808],
              [21.056, 56.801],
              [21.056, 56.795],
              [21.055, 56.781],
              [21.054, 56.732],
              [21.053, 56.711],
              [21.052, 56.697],
              [21.052, 56.69],
              [21.051, 56.683],
              [21.049, 56.677],
              [21.048, 56.67],
              [21.045, 56.664],
              [21.043, 56.657],
              [21.04, 56.651],
              [21.035, 56.638],
              [21.02, 56.607],
              [21.014, 56.594],
              [21.009, 56.582],
              [21.006, 56.575],
              [21.004, 56.569],
              [21.003, 56.563],
              [21.001, 56.557],
              [21, 56.546],
              [20.999, 56.541],
              [20.998, 56.537],
              [20.996, 56.533],
              [20.994, 56.527],
              [20.993, 56.525],
              [20.993, 56.524],
              [20.994, 56.523],
              [20.995, 56.521],
              [20.998, 56.52],
              [20.999, 56.519],
              [21.001, 56.518],
              [21.007, 56.516],
              [21.007, 56.515],
              [21.006, 56.515],
              [21.001, 56.514],
              [20.998, 56.514],
              [20.996, 56.513],
              [20.994, 56.511],
              [20.993, 56.508],
              [20.992, 56.504],
              [20.992, 56.494],
              [20.995, 56.47],
              [20.996, 56.464],
              [20.996, 56.457],
              [20.995, 56.45],
              [20.995, 56.443],
              [20.994, 56.436],
              [20.992, 56.429],
              [20.989, 56.415],
              [20.982, 56.387],
              [20.979, 56.373],
              [20.977, 56.366],
              [20.975, 56.352],
              [20.975, 56.339],
              [20.977, 56.327],
              [20.981, 56.302],
              [16.997, 56.298],
              [16.521, 56.299],
              [16.524, 56.302],
              [16.539, 56.325],
              [16.547, 56.337],
              [16.55, 56.343],
              [16.554, 56.348],
              [16.56, 56.36],
              [16.566, 56.378],
              [16.569, 56.39],
              [16.57, 56.396],
              [16.572, 56.402],
              [16.581, 56.42],
              [16.585, 56.425],
              [16.596, 56.443],
              [16.6, 56.448],
              [16.603, 56.454],
              [16.607, 56.46],
              [16.609, 56.466],
              [16.616, 56.484],
              [16.619, 56.49],
              [16.621, 56.496],
              [16.63, 56.512],
              [16.633, 56.518],
              [16.635, 56.523],
              [16.639, 56.534],
              [16.642, 56.54],
              [16.644, 56.545],
              [16.652, 56.555],
              [16.656, 56.559],
              [16.661, 56.563],
              [16.676, 56.576],
              [16.681, 56.58],
              [16.686, 56.585],
              [16.69, 56.59],
              [16.696, 56.6],
              [16.698, 56.605],
              [16.7, 56.611],
              [16.704, 56.629],
              [16.708, 56.641],
              [16.711, 56.646],
              [16.713, 56.652],
              [16.716, 56.658],
              [16.719, 56.663],
              [16.723, 56.669],
              [16.73, 56.679],
              [16.733, 56.684],
              [16.736, 56.69],
              [16.742, 56.705],
              [16.757, 56.73],
              [16.76, 56.736],
              [16.762, 56.742],
              [16.765, 56.748],
              [16.771, 56.767],
              [16.773, 56.773],
              [16.779, 56.785],
              [16.782, 56.79],
              [16.79, 56.798],
              [16.798, 56.804],
              [16.801, 56.805],
              [16.807, 56.808],
              [16.816, 56.813],
              [16.82, 56.814],
              [16.829, 56.817],
              [16.841, 56.822],
              [16.844, 56.824],
              [16.852, 56.83],
              [16.858, 56.838],
              [16.861, 56.843],
              [16.862, 56.848],
              [16.864, 56.854],
              [16.864, 56.86],
              [16.865, 56.872],
              [16.866, 56.878],
              [16.87, 56.888],
              [16.872, 56.892],
              [16.882, 56.904],
              [16.888, 56.914],
              [16.892, 56.924],
              [16.893, 56.928],
              [16.894, 56.939],
              [16.894, 56.949],
              [16.892, 56.954],
              [16.889, 56.962],
              [16.887, 56.97],
              [16.888, 56.973],
              [16.889, 56.975],
              [16.894, 56.98],
              [16.9, 56.983],
              [16.903, 56.985],
              [16.91, 56.988],
              [16.916, 56.992],
              [16.918, 56.994],
              [16.922, 56.999],
              [16.924, 57.001],
              [16.927, 57.003],
              [16.929, 57.006],
              [16.931, 57.008],
              [16.931, 57.013],
              [16.928, 57.019],
              [16.926, 57.021],
              [16.921, 57.023],
              [16.918, 57.026],
              [16.918, 57.032],
              [16.919, 57.034],
              [16.921, 57.035],
              [16.942, 57.041],
              [16.946, 57.042],
              [16.948, 57.043],
              [16.951, 57.046],
              [16.956, 57.048],
              [16.965, 57.057],
              [16.968, 57.058],
              [16.97, 57.06],
              [16.971, 57.062],
              [16.975, 57.068],
              [16.975, 57.07],
              [16.977, 57.077],
              [16.981, 57.085],
              [16.983, 57.087],
              [16.987, 57.092],
              [16.993, 57.101],
              [17.001, 57.11],
              [17.006, 57.114],
              [17.014, 57.122],
              [17.019, 57.126],
              [17.023, 57.13],
              [17.027, 57.137],
              [17.038, 57.148],
              [17.039, 57.15],
              [17.039, 57.153],
              [17.04, 57.155],
              [17.04, 57.156],
              [17.041, 57.159],
              [17.043, 57.161],
              [17.055, 57.169],
              [17.058, 57.17],
              [17.062, 57.172],
              [17.066, 57.173],
              [17.071, 57.173],
              [17.072, 57.178],
              [17.072, 57.184],
              [17.073, 57.191],
              [17.074, 57.199],
              [17.075, 57.208],
              [17.075, 57.226],
              [17.074, 57.234],
              [17.073, 57.24],
              [17.067, 57.25],
              [17.063, 57.26],
              [17.062, 57.266],
              [17.063, 57.271],
              [17.065, 57.276],
              [17.067, 57.28],
              [17.075, 57.288],
              [17.079, 57.291],
              [17.084, 57.295],
              [17.09, 57.298],
              [17.095, 57.3],
              [17.101, 57.303],
              [17.113, 57.307],
              [17.13, 57.312],
              [17.134, 57.313],
              [17.137, 57.315],
              [17.14, 57.318],
              [17.141, 57.321],
              [17.139, 57.329],
              [17.133, 57.341],
              [17.13, 57.345],
              [17.124, 57.349],
              [17.118, 57.349],
              [17.115, 57.347],
              [17.112, 57.346],
              [17.109, 57.344],
              [17.101, 57.344],
              [17.097, 57.345],
              [17.093, 57.348],
              [17.09, 57.35],
              [17.087, 57.353],
              [17.085, 57.356],
              [17.083, 57.361],
              [17.082, 57.362],
              [17.08, 57.363],
              [17.074, 57.363],
              [17.064, 57.361],
              [17.058, 57.359],
              [17.053, 57.357],
              [17.046, 57.355],
              [17.022, 57.343],
              [17.016, 57.339],
              [17.011, 57.336],
              [17.005, 57.331],
              [16.995, 57.323],
              [16.99, 57.318],
              [16.985, 57.314],
              [16.98, 57.309],
              [16.968, 57.294],
              [16.965, 57.289],
              [16.963, 57.283],
              [16.961, 57.276],
              [16.96, 57.27],
              [16.958, 57.257],
              [16.957, 57.251],
              [16.956, 57.244],
              [16.954, 57.239],
              [16.951, 57.233],
              [16.948, 57.228],
              [16.94, 57.22],
              [16.926, 57.209],
              [16.918, 57.201],
              [16.915, 57.197],
              [16.913, 57.193],
              [16.912, 57.188],
              [16.912, 57.183],
              [16.914, 57.167],
              [16.914, 57.162],
              [16.912, 57.15],
              [16.91, 57.143],
              [16.908, 57.137],
              [16.905, 57.131],
              [16.902, 57.126],
              [16.898, 57.12],
              [16.895, 57.114],
              [16.89, 57.109],
              [16.882, 57.099],
              [16.877, 57.095],
              [16.849, 57.067],
              [16.841, 57.057],
              [16.838, 57.052],
              [16.835, 57.046],
              [16.82, 57.021],
              [16.81, 57.011],
              [16.805, 57.007],
              [16.789, 56.994],
              [16.783, 56.989],
              [16.778, 56.985],
              [16.774, 56.98],
              [16.769, 56.974],
              [16.764, 56.969],
              [16.76, 56.964],
              [16.755, 56.958],
              [16.751, 56.953],
              [16.743, 56.941],
              [16.74, 56.936],
              [16.736, 56.93],
              [16.733, 56.924],
              [16.728, 56.912],
              [16.725, 56.906],
              [16.719, 56.896],
              [16.715, 56.892],
              [16.711, 56.89],
              [16.705, 56.888],
              [16.7, 56.887],
              [16.694, 56.886],
              [16.688, 56.886],
              [16.675, 56.885],
              [16.669, 56.885],
              [16.662, 56.884],
              [16.656, 56.883],
              [16.65, 56.881],
              [16.64, 56.877],
              [16.635, 56.874],
              [16.629, 56.87],
              [16.624, 56.866],
              [16.618, 56.861],
              [16.608, 56.851],
              [16.599, 56.84],
              [16.556, 56.792],
              [16.546, 56.781],
              [16.537, 56.77],
              [16.528, 56.76],
              [16.52, 56.748],
              [16.516, 56.743],
              [16.51, 56.731],
              [16.507, 56.726],
              [16.503, 56.721],
              [16.493, 56.706],
              [16.489, 56.701],
              [16.48, 56.686],
              [16.478, 56.68],
              [16.472, 56.663],
              [16.469, 56.658],
              [16.463, 56.646],
              [16.459, 56.64],
              [16.447, 56.625],
              [16.438, 56.616],
              [16.433, 56.613],
              [16.429, 56.61],
              [16.424, 56.607],
              [16.42, 56.605],
              [16.412, 56.602],
              [16.409, 56.601],
              [16.407, 56.599],
              [16.406, 56.596],
              [16.406, 56.583],
              [16.404, 56.578],
              [16.403, 56.573],
              [16.401, 56.568],
              [16.399, 56.562],
              [16.396, 56.557],
              [16.394, 56.551],
              [16.388, 56.541],
              [16.382, 56.532],
              [16.38, 56.528],
              [16.378, 56.523],
              [16.377, 56.52],
              [16.376, 56.516],
              [16.376, 56.511],
              [16.375, 56.507],
              [16.377, 56.489],
              [16.377, 56.471],
              [16.378, 56.459],
              [16.378, 56.453],
              [16.38, 56.441],
              [16.384, 56.431],
              [16.387, 56.427],
              [16.394, 56.419],
              [16.398, 56.415],
              [16.4, 56.412],
              [16.401, 56.408],
              [16.403, 56.396],
              [16.403, 56.376],
              [16.402, 56.362],
              [16.397, 56.327],
              [16.396, 56.313],
              [16.395, 56.305],
              [16.395, 56.299],
              [16.052, 56.299],
              [16.053, 56.303],
              [16.053, 56.314],
              [16.055, 56.32],
              [16.057, 56.323],
              [16.058, 56.326],
              [16.061, 56.329],
              [16.063, 56.332],
              [16.066, 56.334],
              [16.067, 56.337],
              [16.074, 56.35],
              [16.076, 56.353],
              [16.079, 56.362],
              [16.08, 56.366],
              [16.084, 56.373],
              [16.086, 56.377],
              [16.088, 56.38],
              [16.089, 56.383],
              [16.091, 56.387],
              [16.092, 56.392],
              [16.095, 56.403],
              [16.099, 56.413],
              [16.102, 56.417],
              [16.108, 56.424],
              [16.111, 56.428],
              [16.12, 56.439],
              [16.122, 56.442],
              [16.125, 56.445],
              [16.13, 56.449],
              [16.132, 56.451],
              [16.136, 56.459],
              [16.137, 56.463],
              [16.139, 56.466],
              [16.146, 56.475],
              [16.153, 56.482],
              [16.157, 56.485],
              [16.165, 56.493],
              [16.168, 56.497],
              [16.179, 56.511],
              [16.183, 56.516],
              [16.186, 56.52],
              [16.191, 56.523],
              [16.194, 56.526],
              [16.197, 56.528],
              [16.206, 56.532],
              [16.211, 56.535],
              [16.217, 56.543],
              [16.22, 56.548],
              [16.226, 56.563],
              [16.227, 56.569],
              [16.227, 56.572],
              [16.228, 56.584],
              [16.228, 56.586],
              [16.227, 56.593],
              [16.227, 56.596],
              [16.226, 56.597],
              [16.227, 56.599],
              [16.228, 56.603],
              [16.229, 56.605],
              [16.23, 56.606],
              [16.231, 56.608],
              [16.235, 56.611],
              [16.238, 56.613],
              [16.243, 56.623],
              [16.243, 56.625],
              [16.245, 56.626],
              [16.249, 56.63],
              [16.253, 56.632],
              [16.256, 56.634],
              [16.266, 56.638],
              [16.27, 56.641],
              [16.274, 56.643],
              [16.28, 56.649],
              [16.286, 56.653],
              [16.29, 56.654],
              [16.304, 56.654],
              [16.308, 56.652],
              [16.312, 56.651],
              [16.316, 56.649],
              [16.318, 56.647],
              [16.321, 56.643],
              [16.322, 56.642],
              [16.324, 56.642],
              [16.327, 56.643],
              [16.336, 56.649],
              [16.342, 56.652],
              [16.347, 56.655],
              [16.349, 56.657],
              [16.352, 56.659],
              [16.357, 56.664],
              [16.359, 56.667],
              [16.36, 56.669],
              [16.364, 56.678],
              [16.366, 56.681],
              [16.367, 56.686],
              [16.368, 56.69],
              [16.369, 56.691],
              [16.369, 56.696],
              [16.37, 56.7],
              [16.37, 56.705],
              [16.369, 56.706],
              [16.368, 56.708],
              [16.365, 56.711],
              [16.364, 56.715],
              [16.362, 56.717],
              [16.361, 56.719],
              [16.362, 56.72],
              [16.364, 56.721],
              [16.368, 56.724],
              [16.37, 56.725],
              [16.37, 56.732],
              [16.369, 56.737],
              [16.368, 56.74],
              [16.368, 56.744],
              [16.371, 56.753],
              [16.373, 56.757],
              [16.373, 56.763],
              [16.375, 56.764],
              [16.377, 56.766],
              [16.381, 56.769],
              [16.382, 56.77],
              [16.384, 56.773],
              [16.386, 56.773],
              [16.388, 56.774],
              [16.419, 56.774],
              [16.424, 56.773],
              [16.436, 56.771],
              [16.441, 56.769],
              [16.453, 56.769],
              [16.458, 56.77],
              [16.464, 56.771],
              [16.472, 56.775],
              [16.475, 56.778],
              [16.477, 56.781],
              [16.477, 56.784],
              [16.476, 56.788],
              [16.474, 56.791],
              [16.471, 56.793],
              [16.466, 56.795],
              [16.457, 56.795],
              [16.452, 56.794],
              [16.447, 56.792],
              [16.437, 56.789],
              [16.432, 56.788],
              [16.421, 56.786],
              [16.417, 56.785],
              [16.413, 56.785],
              [16.407, 56.787],
              [16.405, 56.788],
              [16.404, 56.79],
              [16.406, 56.796],
              [16.406, 56.799],
              [16.407, 56.804],
              [16.407, 56.807],
              [16.413, 56.813],
              [16.416, 56.818],
              [16.417, 56.82],
              [16.418, 56.821],
              [16.419, 56.825],
              [16.42, 56.828],
              [16.423, 56.834],
              [16.424, 56.837],
              [16.425, 56.843],
              [16.428, 56.849],
              [16.433, 56.858],
              [16.437, 56.868],
              [16.438, 56.873],
              [16.441, 56.883],
              [16.442, 56.888],
              [16.445, 56.894],
              [16.446, 56.898],
              [16.447, 56.9],
              [16.448, 56.901],
              [16.451, 56.901],
              [16.455, 56.9],
              [16.46, 56.9],
              [16.457, 56.902],
              [16.455, 56.903],
              [16.448, 56.908],
              [16.446, 56.91],
              [16.444, 56.914],
              [16.445, 56.916],
              [16.447, 56.918],
              [16.45, 56.92],
              [16.457, 56.925],
              [16.461, 56.929],
              [16.463, 56.933],
              [16.464, 56.938],
              [16.464, 56.943],
              [16.46, 56.953],
              [16.448, 56.973],
              [16.446, 56.978],
              [16.444, 56.982],
              [16.443, 56.987],
              [16.443, 56.994],
              [16.445, 57.002],
              [16.446, 57.005],
              [16.448, 57.009],
              [16.452, 57.013],
              [16.454, 57.013],
              [16.455, 57.012],
              [16.455, 57.01],
              [16.454, 57.008],
              [16.454, 57.001],
              [16.455, 56.997],
              [16.456, 56.994],
              [16.458, 56.989],
              [16.462, 56.985],
              [16.465, 56.981],
              [16.469, 56.978],
              [16.475, 56.976],
              [16.477, 56.978],
              [16.478, 56.98],
              [16.478, 56.983],
              [16.477, 56.985],
              [16.475, 56.99],
              [16.474, 56.993],
              [16.474, 56.998],
              [16.475, 57],
              [16.476, 57.004],
              [16.48, 57.01],
              [16.482, 57.012],
              [16.483, 57.016],
              [16.485, 57.02],
              [16.484, 57.021],
              [16.483, 57.023],
              [16.48, 57.025],
              [16.469, 57.031],
              [16.466, 57.033],
              [16.463, 57.036],
              [16.465, 57.037],
              [16.468, 57.036],
              [16.472, 57.036],
              [16.478, 57.035],
              [16.483, 57.034],
              [16.496, 57.031],
              [16.508, 57.029],
              [16.518, 57.026],
              [16.522, 57.025],
              [16.53, 57.025],
              [16.533, 57.026],
              [16.535, 57.027],
              [16.537, 57.029],
              [16.538, 57.033],
              [16.539, 57.036],
              [16.541, 57.038],
              [16.543, 57.039],
              [16.547, 57.042],
              [16.549, 57.043],
              [16.553, 57.043],
              [16.56, 57.044],
              [16.563, 57.045],
              [16.567, 57.046],
              [16.571, 57.05],
              [16.571, 57.052],
              [16.57, 57.054],
              [16.568, 57.056],
              [16.565, 57.058],
              [16.558, 57.062],
              [16.555, 57.064],
              [16.553, 57.066],
              [16.552, 57.068],
              [16.554, 57.072],
              [16.557, 57.074],
              [16.561, 57.077],
              [16.564, 57.08],
              [16.564, 57.086],
              [16.557, 57.093],
              [16.553, 57.096],
              [16.546, 57.101],
              [16.537, 57.107],
              [16.532, 57.11],
              [16.528, 57.112],
              [16.52, 57.115],
              [16.512, 57.121],
              [16.509, 57.125],
              [16.498, 57.137],
              [16.49, 57.145],
              [16.477, 57.157],
              [16.472, 57.161],
              [16.468, 57.165],
              [16.465, 57.169],
              [16.463, 57.173],
              [16.461, 57.178],
              [16.46, 57.182],
              [16.459, 57.185],
              [16.459, 57.191],
              [16.458, 57.196],
              [16.458, 57.198],
              [16.46, 57.199],
              [16.463, 57.2],
              [16.465, 57.2],
              [16.467, 57.202],
              [16.467, 57.203],
              [16.468, 57.204],
              [16.467, 57.206],
              [16.468, 57.206],
              [16.468, 57.207],
              [16.469, 57.208],
              [16.471, 57.209],
              [16.472, 57.21],
              [16.474, 57.214],
              [16.479, 57.219],
              [16.479, 57.221],
              [16.482, 57.227],
              [16.483, 57.227],
              [16.485, 57.228],
              [16.492, 57.229],
              [16.495, 57.229],
              [16.497, 57.23],
              [16.5, 57.232],
              [16.501, 57.233],
              [16.501, 57.236],
              [16.5, 57.24],
              [16.498, 57.243],
              [16.493, 57.248],
              [16.485, 57.255],
              [16.479, 57.259],
              [16.469, 57.264],
              [16.467, 57.266],
              [16.468, 57.267],
              [16.47, 57.268],
              [16.472, 57.27],
              [16.475, 57.272],
              [16.484, 57.281],
              [16.495, 57.29],
              [16.498, 57.292],
              [16.501, 57.296],
              [16.503, 57.297],
              [16.505, 57.299],
              [16.509, 57.3],
              [16.513, 57.302],
              [16.522, 57.304],
              [16.526, 57.306],
              [16.531, 57.308],
              [16.534, 57.309],
              [16.549, 57.311],
              [16.556, 57.313],
              [16.562, 57.314],
              [16.564, 57.315],
              [16.565, 57.316],
              [16.565, 57.317],
              [16.564, 57.32],
              [16.563, 57.322],
              [16.561, 57.325],
              [16.56, 57.328],
              [16.56, 57.331],
              [16.562, 57.337],
              [16.562, 57.343],
              [16.558, 57.352],
              [16.557, 57.355],
              [16.557, 57.358],
              [16.559, 57.366],
              [16.561, 57.37],
              [16.564, 57.371],
              [16.568, 57.373],
              [16.572, 57.373],
              [16.577, 57.374],
              [16.593, 57.374],
              [16.608, 57.371],
              [16.622, 57.371],
              [16.624, 57.373],
              [16.626, 57.374],
              [16.629, 57.38],
              [16.63, 57.381],
              [16.634, 57.389],
              [16.634, 57.391],
              [16.637, 57.396],
              [16.638, 57.398],
              [16.641, 57.401],
              [16.644, 57.403],
              [16.646, 57.404],
              [16.649, 57.406],
              [16.662, 57.409],
              [16.672, 57.414],
              [16.673, 57.416],
              [16.674, 57.417],
              [16.674, 57.419],
              [16.675, 57.42],
              [16.683, 57.424],
              [16.685, 57.426],
              [16.685, 57.427],
              [16.683, 57.427],
              [16.68, 57.428],
              [16.675, 57.428],
              [16.661, 57.426],
              [16.656, 57.426],
              [16.652, 57.427],
              [16.649, 57.428],
              [16.647, 57.43],
              [16.642, 57.434],
              [16.64, 57.436],
              [16.639, 57.438],
              [16.639, 57.44],
              [16.64, 57.441],
              [16.643, 57.442],
              [16.647, 57.443],
              [16.657, 57.444],
              [16.661, 57.445],
              [16.666, 57.447],
              [16.671, 57.448],
              [16.675, 57.449],
              [16.683, 57.453],
              [16.681, 57.455],
              [16.679, 57.456],
              [16.672, 57.457],
              [16.671, 57.458],
              [16.665, 57.461],
              [16.665, 57.462],
              [16.667, 57.464],
              [16.678, 57.467],
              [16.684, 57.469],
              [16.687, 57.471],
              [16.69, 57.472],
              [16.695, 57.477],
              [16.696, 57.48],
              [16.698, 57.482],
              [16.699, 57.485],
              [16.699, 57.488],
              [16.698, 57.49],
              [16.696, 57.492],
              [16.693, 57.494],
              [16.686, 57.498],
              [16.677, 57.504],
              [16.669, 57.508],
              [16.659, 57.512],
              [16.656, 57.514],
              [16.65, 57.52],
              [16.646, 57.525],
              [16.645, 57.528],
              [16.644, 57.53],
              [16.644, 57.531],
              [16.645, 57.533],
              [16.648, 57.534],
              [16.657, 57.536],
              [16.661, 57.538],
              [16.661, 57.541],
              [16.659, 57.542],
              [16.656, 57.544],
              [16.653, 57.545],
              [16.649, 57.546],
              [16.635, 57.548],
              [16.631, 57.549],
              [16.602, 57.549],
              [16.598, 57.548],
              [16.595, 57.547],
              [16.591, 57.546],
              [16.588, 57.545],
              [16.586, 57.545],
              [16.583, 57.546],
              [16.58, 57.549],
              [16.576, 57.551],
              [16.572, 57.554],
              [16.569, 57.556],
              [16.565, 57.558],
              [16.56, 57.559],
              [16.556, 57.56],
              [16.535, 57.562],
              [16.531, 57.562],
              [16.528, 57.563],
              [16.527, 57.564],
              [16.529, 57.564],
              [16.537, 57.566],
              [16.54, 57.567],
              [16.542, 57.568],
              [16.543, 57.569],
              [16.543, 57.571],
              [16.539, 57.575],
              [16.536, 57.576],
              [16.533, 57.578],
              [16.528, 57.58],
              [16.525, 57.581],
              [16.523, 57.582],
              [16.522, 57.585],
              [16.522, 57.587],
              [16.523, 57.589],
              [16.53, 57.594],
              [16.532, 57.597],
              [16.534, 57.599],
              [16.535, 57.602],
              [16.535, 57.606],
              [16.534, 57.611],
              [16.532, 57.614],
              [16.53, 57.616],
              [16.528, 57.619],
              [16.524, 57.622],
              [16.513, 57.629],
              [16.512, 57.63],
              [16.514, 57.63],
              [16.516, 57.629],
              [16.528, 57.624],
              [16.538, 57.62],
              [16.548, 57.618],
              [16.556, 57.616],
              [16.559, 57.615],
              [16.562, 57.613],
              [16.564, 57.611],
              [16.567, 57.606],
              [16.569, 57.604],
              [16.57, 57.601],
              [16.571, 57.599],
              [16.575, 57.597],
              [16.578, 57.596],
              [16.58, 57.596],
              [16.582, 57.597],
              [16.584, 57.599],
              [16.585, 57.603],
              [16.587, 57.604],
              [16.589, 57.608],
              [16.592, 57.612],
              [16.593, 57.614],
              [16.596, 57.614],
              [16.602, 57.608],
              [16.605, 57.606],
              [16.609, 57.605],
              [16.613, 57.603],
              [16.618, 57.603],
              [16.622, 57.602],
              [16.637, 57.602],
              [16.64, 57.603],
              [16.643, 57.603],
              [16.647, 57.607],
              [16.649, 57.61],
              [16.65, 57.613],
              [16.649, 57.616],
              [16.643, 57.624],
              [16.639, 57.629],
              [16.634, 57.633],
              [16.629, 57.636],
              [16.623, 57.64],
              [16.618, 57.642],
              [16.602, 57.648],
              [16.597, 57.65],
              [16.592, 57.655],
              [16.591, 57.657],
              [16.591, 57.658],
              [16.592, 57.659],
              [16.594, 57.66],
              [16.595, 57.66],
              [16.596, 57.659],
              [16.597, 57.657],
              [16.598, 57.656],
              [16.6, 57.653],
              [16.602, 57.653],
              [16.604, 57.652],
              [16.607, 57.651],
              [16.61, 57.651],
              [16.617, 57.652],
              [16.621, 57.652],
              [16.626, 57.653],
              [16.635, 57.659],
              [16.637, 57.662],
              [16.637, 57.668],
              [16.636, 57.67],
              [16.632, 57.674],
              [16.629, 57.676],
              [16.624, 57.678],
              [16.62, 57.68],
              [16.61, 57.684],
              [16.604, 57.686],
              [16.599, 57.687],
              [16.589, 57.693],
              [16.585, 57.697],
              [16.575, 57.705],
              [16.57, 57.708],
              [16.565, 57.712],
              [16.56, 57.715],
              [16.554, 57.718],
              [16.549, 57.72],
              [16.54, 57.724],
              [16.537, 57.725],
              [16.536, 57.726],
              [16.551, 57.726],
              [16.555, 57.725],
              [16.558, 57.725],
              [16.566, 57.723],
              [16.57, 57.721],
              [16.575, 57.716],
              [16.581, 57.711],
              [16.584, 57.707],
              [16.589, 57.703],
              [16.593, 57.7],
              [16.611, 57.691],
              [16.618, 57.689],
              [16.624, 57.687],
              [16.638, 57.683],
              [16.645, 57.682],
              [16.652, 57.682],
              [16.659, 57.681],
              [16.673, 57.681],
              [16.686, 57.682],
              [16.693, 57.683],
              [16.699, 57.683],
              [16.711, 57.681],
              [16.726, 57.679],
              [16.729, 57.678],
              [16.732, 57.679],
              [16.731, 57.681],
              [16.717, 57.688],
              [16.711, 57.692],
              [16.71, 57.693],
              [16.711, 57.695],
              [16.712, 57.695],
              [16.717, 57.697],
              [16.719, 57.698],
              [16.72, 57.7],
              [16.72, 57.701],
              [16.716, 57.709],
              [16.715, 57.713],
              [16.714, 57.714],
              [16.708, 57.717],
              [16.701, 57.721],
              [16.681, 57.726],
              [16.678, 57.727],
              [16.676, 57.727],
              [16.675, 57.729],
              [16.671, 57.735],
              [16.668, 57.738],
              [16.665, 57.742],
              [16.661, 57.746],
              [16.656, 57.749],
              [16.651, 57.753],
              [16.647, 57.755],
              [16.643, 57.758],
              [16.614, 57.774],
              [16.595, 57.784],
              [16.582, 57.792],
              [16.565, 57.803],
              [16.554, 57.81],
              [16.536, 57.819],
              [16.53, 57.821],
              [16.524, 57.824],
              [16.518, 57.826],
              [16.511, 57.828],
              [16.505, 57.83],
              [16.5, 57.832],
              [16.488, 57.835],
              [16.483, 57.836],
              [16.476, 57.839],
              [16.472, 57.84],
              [16.467, 57.84],
              [16.465, 57.839],
              [16.462, 57.838],
              [16.459, 57.838],
              [16.453, 57.84],
              [16.45, 57.842],
              [16.447, 57.845],
              [16.44, 57.853],
              [16.437, 57.857],
              [16.425, 57.87],
              [16.421, 57.874],
              [16.417, 57.882],
              [16.417, 57.891],
              [16.419, 57.893],
              [16.421, 57.892],
              [16.424, 57.89],
              [16.438, 57.876],
              [16.443, 57.873],
              [16.448, 57.869],
              [16.453, 57.866],
              [16.459, 57.863],
              [16.465, 57.861],
              [16.471, 57.858],
              [16.495, 57.85],
              [16.501, 57.849],
              [16.514, 57.846],
              [16.52, 57.845],
              [16.526, 57.843],
              [16.53, 57.841],
              [16.54, 57.835],
              [16.545, 57.833],
              [16.561, 57.825],
              [16.566, 57.822],
              [16.572, 57.819],
              [16.582, 57.813],
              [16.593, 57.806],
              [16.598, 57.802],
              [16.603, 57.799],
              [16.608, 57.795],
              [16.624, 57.782],
              [16.634, 57.774],
              [16.639, 57.771],
              [16.645, 57.769],
              [16.65, 57.767],
              [16.664, 57.763],
              [16.673, 57.761],
              [16.677, 57.759],
              [16.682, 57.757],
              [16.687, 57.754],
              [16.7, 57.746],
              [16.704, 57.744],
              [16.708, 57.743],
              [16.71, 57.742],
              [16.712, 57.743],
              [16.712, 57.746],
              [16.711, 57.749],
              [16.709, 57.752],
              [16.705, 57.757],
              [16.703, 57.758],
              [16.695, 57.764],
              [16.689, 57.767],
              [16.671, 57.775],
              [16.664, 57.778],
              [16.658, 57.781],
              [16.651, 57.785],
              [16.645, 57.788],
              [16.633, 57.796],
              [16.596, 57.819],
              [16.584, 57.826],
              [16.578, 57.829],
              [16.573, 57.832],
              [16.567, 57.835],
              [16.562, 57.837],
              [16.554, 57.84],
              [16.55, 57.841],
              [16.546, 57.845],
              [16.542, 57.85],
              [16.539, 57.854],
              [16.535, 57.858],
              [16.532, 57.862],
              [16.527, 57.865],
              [16.523, 57.869],
              [16.517, 57.872],
              [16.512, 57.875],
              [16.488, 57.887],
              [16.485, 57.889],
              [16.484, 57.89],
              [16.484, 57.892],
              [16.492, 57.896],
              [16.493, 57.896],
              [16.492, 57.898],
              [16.491, 57.899],
              [16.485, 57.904],
              [16.484, 57.906],
              [16.484, 57.907],
              [16.485, 57.907],
              [16.488, 57.906],
              [16.492, 57.906],
              [16.508, 57.903],
              [16.518, 57.901],
              [16.522, 57.9],
              [16.537, 57.896],
              [16.549, 57.894],
              [16.552, 57.893],
              [16.556, 57.891],
              [16.564, 57.888],
              [16.567, 57.886],
              [16.577, 57.884],
              [16.581, 57.883],
              [16.584, 57.884],
              [16.586, 57.885],
              [16.586, 57.888],
              [16.584, 57.892],
              [16.583, 57.896],
              [16.581, 57.901],
              [16.581, 57.903],
              [16.579, 57.906],
              [16.576, 57.911],
              [16.574, 57.915],
              [16.575, 57.916],
              [16.577, 57.917],
              [16.58, 57.919],
              [16.583, 57.922],
              [16.586, 57.928],
              [16.586, 57.931],
              [16.584, 57.934],
              [16.581, 57.936],
              [16.576, 57.938],
              [16.572, 57.94],
              [16.566, 57.942],
              [16.548, 57.949],
              [16.543, 57.951],
              [16.537, 57.954],
              [16.532, 57.956],
              [16.527, 57.959],
              [16.525, 57.961],
              [16.507, 57.973],
              [16.506, 57.975],
              [16.505, 57.976],
              [16.505, 57.978],
              [16.506, 57.98],
              [16.505, 57.986],
              [16.505, 57.99],
              [16.511, 57.992],
              [16.514, 57.992],
              [16.518, 57.99],
              [16.522, 57.989],
              [16.527, 57.986],
              [16.535, 57.98],
              [16.54, 57.977],
              [16.564, 57.965],
              [16.574, 57.961],
              [16.585, 57.957],
              [16.59, 57.955],
              [16.595, 57.952],
              [16.599, 57.949],
              [16.606, 57.943],
              [16.61, 57.939],
              [16.615, 57.936],
              [16.621, 57.933],
              [16.626, 57.93],
              [16.646, 57.92],
              [16.649, 57.918],
              [16.652, 57.915],
              [16.647, 57.915],
              [16.639, 57.917],
              [16.629, 57.92],
              [16.619, 57.922],
              [16.609, 57.922],
              [16.607, 57.921],
              [16.605, 57.919],
              [16.605, 57.913],
              [16.607, 57.91],
              [16.61, 57.906],
              [16.614, 57.903],
              [16.618, 57.899],
              [16.623, 57.896],
              [16.628, 57.892],
              [16.633, 57.89],
              [16.637, 57.888],
              [16.645, 57.885],
              [16.65, 57.883],
              [16.654, 57.881],
              [16.662, 57.879],
              [16.665, 57.879],
              [16.671, 57.878],
              [16.675, 57.878],
              [16.687, 57.881],
              [16.69, 57.883],
              [16.692, 57.885],
              [16.694, 57.886],
              [16.695, 57.888],
              [16.698, 57.89],
              [16.698, 57.893],
              [16.697, 57.895],
              [16.699, 57.897],
              [16.706, 57.897],
              [16.708, 57.896],
              [16.718, 57.889],
              [16.723, 57.885],
              [16.734, 57.878],
              [16.739, 57.875],
              [16.745, 57.871],
              [16.751, 57.868],
              [16.761, 57.864],
              [16.766, 57.863],
              [16.773, 57.863],
              [16.775, 57.864],
              [16.776, 57.864],
              [16.777, 57.865],
              [16.778, 57.867],
              [16.778, 57.868],
              [16.782, 57.87],
              [16.784, 57.872],
              [16.785, 57.874],
              [16.785, 57.876],
              [16.784, 57.879],
              [16.782, 57.883],
              [16.779, 57.886],
              [16.775, 57.889],
              [16.763, 57.896],
              [16.761, 57.898],
              [16.76, 57.9],
              [16.762, 57.901],
              [16.771, 57.901],
              [16.775, 57.903],
              [16.775, 57.904],
              [16.774, 57.905],
              [16.77, 57.907],
              [16.765, 57.909],
              [16.754, 57.913],
              [16.748, 57.915],
              [16.747, 57.917],
              [16.748, 57.919],
              [16.748, 57.92],
              [16.75, 57.921],
              [16.751, 57.921],
              [16.753, 57.92],
              [16.758, 57.918],
              [16.762, 57.917],
              [16.777, 57.914],
              [16.786, 57.914],
              [16.79, 57.915],
              [16.792, 57.916],
              [16.792, 57.918],
              [16.791, 57.92],
              [16.789, 57.922],
              [16.785, 57.925],
              [16.782, 57.928],
              [16.774, 57.933],
              [16.767, 57.94],
              [16.761, 57.952],
              [16.755, 57.96],
              [16.747, 57.966],
              [16.743, 57.968],
              [16.739, 57.969],
              [16.736, 57.97],
              [16.733, 57.969],
              [16.731, 57.969],
              [16.729, 57.967],
              [16.729, 57.964],
              [16.732, 57.961],
              [16.733, 57.959],
              [16.733, 57.955],
              [16.732, 57.954],
              [16.73, 57.954],
              [16.727, 57.955],
              [16.723, 57.957],
              [16.719, 57.958],
              [16.714, 57.96],
              [16.71, 57.963],
              [16.705, 57.965],
              [16.696, 57.97],
              [16.692, 57.973],
              [16.689, 57.975],
              [16.685, 57.976],
              [16.682, 57.976],
              [16.675, 57.975],
              [16.67, 57.975],
              [16.66, 57.977],
              [16.654, 57.978],
              [16.649, 57.979],
              [16.645, 57.98],
              [16.641, 57.982],
              [16.638, 57.983],
              [16.637, 57.983],
              [16.638, 57.984],
              [16.647, 57.985],
              [16.653, 57.987],
              [16.656, 57.989],
              [16.658, 57.992],
              [16.658, 57.999],
              [16.656, 58.007],
              [16.656, 58.022],
              [16.657, 58.027],
              [16.659, 58.035],
              [16.66, 58.037],
              [16.662, 58.038],
              [16.665, 58.035],
              [16.672, 58.023],
              [16.675, 58.018],
              [16.683, 58.01],
              [16.688, 58.007],
              [16.693, 58.005],
              [16.698, 58.002],
              [16.703, 58.001],
              [16.707, 57.999],
              [16.718, 57.999],
              [16.719, 58],
              [16.719, 58.001],
              [16.717, 58.002],
              [16.711, 58.003],
              [16.708, 58.005],
              [16.705, 58.006],
              [16.704, 58.008],
              [16.703, 58.009],
              [16.702, 58.011],
              [16.702, 58.016],
              [16.703, 58.017],
              [16.706, 58.018],
              [16.74, 58.018],
              [16.744, 58.017],
              [16.748, 58.015],
              [16.753, 58.014],
              [16.761, 58.012],
              [16.77, 58.012],
              [16.771, 58.014],
              [16.771, 58.016],
              [16.769, 58.022],
              [16.768, 58.026],
              [16.767, 58.028],
              [16.765, 58.03],
              [16.762, 58.032],
              [16.759, 58.035],
              [16.756, 58.037],
              [16.752, 58.039],
              [16.743, 58.042],
              [16.741, 58.043],
              [16.735, 58.045],
              [16.73, 58.046],
              [16.724, 58.047],
              [16.718, 58.047],
              [16.703, 58.048],
              [16.7, 58.049],
              [16.699, 58.049],
              [16.7, 58.049],
              [16.703, 58.05],
              [16.723, 58.051],
              [16.734, 58.051],
              [16.739, 58.052],
              [16.743, 58.052],
              [16.746, 58.053],
              [16.748, 58.054],
              [16.749, 58.055],
              [16.748, 58.056],
              [16.743, 58.058],
              [16.742, 58.059],
              [16.74, 58.062],
              [16.739, 58.063],
              [16.738, 58.065],
              [16.739, 58.066],
              [16.741, 58.067],
              [16.747, 58.069],
              [16.755, 58.069],
              [16.763, 58.067],
              [16.767, 58.065],
              [16.77, 58.063],
              [16.775, 58.058],
              [16.777, 58.055],
              [16.78, 58.053],
              [16.784, 58.051],
              [16.787, 58.05],
              [16.793, 58.05],
              [16.795, 58.051],
              [16.797, 58.053],
              [16.801, 58.056],
              [16.802, 58.057],
              [16.802, 58.059],
              [16.804, 58.061],
              [16.804, 58.063],
              [16.803, 58.065],
              [16.798, 58.07],
              [16.794, 58.073],
              [16.789, 58.075],
              [16.784, 58.078],
              [16.773, 58.084],
              [16.754, 58.093],
              [16.751, 58.095],
              [16.749, 58.097],
              [16.748, 58.099],
              [16.746, 58.1],
              [16.744, 58.102],
              [16.734, 58.109],
              [16.731, 58.11],
              [16.729, 58.112],
              [16.728, 58.114],
              [16.725, 58.118],
              [16.722, 58.12],
              [16.72, 58.121],
              [16.714, 58.123],
              [16.708, 58.124],
              [16.704, 58.125],
              [16.699, 58.126],
              [16.693, 58.128],
              [16.688, 58.13],
              [16.683, 58.133],
              [16.675, 58.137],
              [16.672, 58.139],
              [16.671, 58.141],
              [16.671, 58.143],
              [16.673, 58.144],
              [16.676, 58.144],
              [16.678, 58.143],
              [16.681, 58.143],
              [16.685, 58.142],
              [16.688, 58.141],
              [16.691, 58.138],
              [16.693, 58.137],
              [16.695, 58.135],
              [16.698, 58.134],
              [16.7, 58.133],
              [16.705, 58.133],
              [16.707, 58.134],
              [16.708, 58.135],
              [16.709, 58.135],
              [16.709, 58.136],
              [16.708, 58.138],
              [16.705, 58.141],
              [16.701, 58.143],
              [16.697, 58.146],
              [16.692, 58.15],
              [16.644, 58.178],
              [16.627, 58.188],
              [16.619, 58.194],
              [16.616, 58.196],
              [16.615, 58.197],
              [16.62, 58.197],
              [16.623, 58.195],
              [16.628, 58.193],
              [16.633, 58.19],
              [16.645, 58.184],
              [16.675, 58.164],
              [16.682, 58.161],
              [16.688, 58.157],
              [16.7, 58.151],
              [16.711, 58.146],
              [16.716, 58.143],
              [16.721, 58.141],
              [16.733, 58.132],
              [16.738, 58.13],
              [16.746, 58.125],
              [16.75, 58.123],
              [16.76, 58.117],
              [16.763, 58.116],
              [16.765, 58.115],
              [16.77, 58.115],
              [16.77, 58.117],
              [16.773, 58.12],
              [16.776, 58.12],
              [16.784, 58.121],
              [16.789, 58.123],
              [16.794, 58.124],
              [16.803, 58.128],
              [16.812, 58.131],
              [16.816, 58.132],
              [16.819, 58.135],
              [16.82, 58.137],
              [16.82, 58.142],
              [16.819, 58.147],
              [16.818, 58.15],
              [16.814, 58.156],
              [16.811, 58.159],
              [16.807, 58.161],
              [16.796, 58.167],
              [16.794, 58.169],
              [16.792, 58.17],
              [16.794, 58.172],
              [16.798, 58.174],
              [16.801, 58.177],
              [16.802, 58.177],
              [16.803, 58.178],
              [16.804, 58.178],
              [16.807, 58.177],
              [16.809, 58.177],
              [16.812, 58.175],
              [16.816, 58.173],
              [16.819, 58.172],
              [16.823, 58.17],
              [16.833, 58.17],
              [16.836, 58.171],
              [16.84, 58.172],
              [16.843, 58.174],
              [16.845, 58.176],
              [16.846, 58.178],
              [16.847, 58.187],
              [16.846, 58.189],
              [16.844, 58.191],
              [16.836, 58.195],
              [16.827, 58.198],
              [16.82, 58.199],
              [16.816, 58.201],
              [16.816, 58.204],
            ],
          ],
        ],
      },
      properties: {
        id: 49,
        name: 'Mellersta Östersjön',
        latlon: [57.175565, 19.422162],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [11.3, 55.979],
              [10.727, 56.164],
              [10.73, 56.17],
              [10.733, 56.175],
              [10.735, 56.181],
              [10.738, 56.187],
              [10.743, 56.205],
              [10.745, 56.211],
              [10.751, 56.221],
              [10.755, 56.226],
              [10.759, 56.23],
              [10.764, 56.233],
              [10.77, 56.237],
              [10.775, 56.24],
              [10.793, 56.25],
              [10.799, 56.253],
              [10.804, 56.257],
              [10.81, 56.261],
              [10.814, 56.264],
              [10.832, 56.28],
              [10.842, 56.288],
              [10.847, 56.291],
              [10.863, 56.301],
              [10.868, 56.305],
              [10.874, 56.309],
              [10.879, 56.313],
              [10.884, 56.318],
              [10.894, 56.326],
              [10.906, 56.341],
              [10.909, 56.346],
              [10.912, 56.352],
              [10.916, 56.364],
              [10.921, 56.389],
              [10.925, 56.399],
              [10.929, 56.408],
              [10.93, 56.41],
              [10.93, 56.411],
              [10.931, 56.415],
              [10.931, 56.416],
              [10.934, 56.422],
              [10.937, 56.427],
              [10.938, 56.429],
              [10.943, 56.435],
              [10.945, 56.438],
              [10.947, 56.442],
              [10.947, 56.444],
              [10.945, 56.45],
              [10.942, 56.454],
              [10.938, 56.457],
              [10.933, 56.46],
              [10.928, 56.464],
              [10.922, 56.467],
              [10.904, 56.477],
              [10.898, 56.48],
              [10.892, 56.484],
              [10.887, 56.487],
              [10.881, 56.492],
              [10.863, 56.51],
              [10.859, 56.515],
              [10.853, 56.519],
              [10.848, 56.522],
              [10.842, 56.526],
              [10.835, 56.528],
              [10.829, 56.531],
              [10.823, 56.532],
              [10.816, 56.534],
              [10.802, 56.536],
              [10.769, 56.536],
              [10.73, 56.533],
              [10.712, 56.532],
              [10.708, 56.532],
              [10.692, 56.53],
              [10.672, 56.527],
              [10.589, 56.518],
              [10.561, 56.516],
              [10.548, 56.515],
              [10.541, 56.514],
              [10.527, 56.514],
              [10.519, 56.515],
              [10.512, 56.515],
              [10.491, 56.517],
              [10.442, 56.524],
              [10.428, 56.528],
              [10.422, 56.53],
              [10.415, 56.532],
              [10.403, 56.538],
              [10.397, 56.542],
              [10.391, 56.545],
              [10.386, 56.548],
              [10.374, 56.556],
              [10.369, 56.56],
              [10.36, 56.569],
              [10.348, 56.583],
              [10.344, 56.588],
              [10.339, 56.591],
              [10.334, 56.595],
              [10.329, 56.597],
              [10.323, 56.599],
              [10.318, 56.6],
              [10.312, 56.601],
              [10.307, 56.6],
              [10.306, 56.599],
              [10.302, 56.597],
              [10.278, 56.58],
              [10.273, 56.576],
              [10.264, 56.567],
              [10.247, 56.551],
              [10.244, 56.547],
              [10.241, 56.544],
              [10.238, 56.54],
              [10.236, 56.535],
              [10.234, 56.529],
              [10.233, 56.524],
              [10.231, 56.512],
              [10.23, 56.492],
              [10.23, 56.488],
              [10.231, 56.485],
              [10.234, 56.482],
              [10.238, 56.48],
              [10.248, 56.476],
              [10.254, 56.475],
              [10.275, 56.471],
              [10.278, 56.47],
              [10.279, 56.47],
              [10.276, 56.469],
              [10.253, 56.469],
              [10.234, 56.471],
              [10.207, 56.471],
              [10.2, 56.47],
              [10.186, 56.467],
              [10.158, 56.462],
              [10.144, 56.46],
              [10.137, 56.46],
              [10.13, 56.459],
              [10.123, 56.459],
              [10.116, 56.46],
              [10.096, 56.461],
              [10.072, 56.461],
              [10.059, 56.46],
              [10.055, 56.46],
              [10.056, 56.46],
              [10.058, 56.461],
              [10.066, 56.462],
              [10.076, 56.464],
              [10.088, 56.464],
              [10.095, 56.463],
              [10.117, 56.461],
              [10.138, 56.461],
              [10.144, 56.462],
              [10.158, 56.464],
              [10.164, 56.466],
              [10.177, 56.469],
              [10.184, 56.471],
              [10.19, 56.472],
              [10.196, 56.475],
              [10.202, 56.477],
              [10.207, 56.48],
              [10.211, 56.484],
              [10.215, 56.489],
              [10.218, 56.493],
              [10.22, 56.499],
              [10.222, 56.504],
              [10.223, 56.51],
              [10.224, 56.517],
              [10.224, 56.536],
              [10.225, 56.542],
              [10.227, 56.548],
              [10.231, 56.556],
              [10.237, 56.563],
              [10.24, 56.568],
              [10.248, 56.576],
              [10.253, 56.579],
              [10.259, 56.582],
              [10.281, 56.594],
              [10.295, 56.603],
              [10.3, 56.606],
              [10.336, 56.624],
              [10.341, 56.627],
              [10.349, 56.635],
              [10.351, 56.639],
              [10.354, 56.643],
              [10.356, 56.653],
              [10.358, 56.662],
              [10.358, 56.671],
              [10.357, 56.676],
              [10.355, 56.68],
              [10.352, 56.685],
              [10.349, 56.689],
              [10.346, 56.691],
              [10.342, 56.694],
              [10.338, 56.695],
              [10.332, 56.697],
              [10.326, 56.698],
              [10.312, 56.698],
              [10.285, 56.696],
              [10.266, 56.696],
              [10.259, 56.695],
              [10.253, 56.695],
              [10.246, 56.694],
              [10.225, 56.69],
              [10.219, 56.689],
              [10.206, 56.689],
              [10.2, 56.69],
              [10.188, 56.694],
              [10.17, 56.701],
              [10.158, 56.705],
              [10.14, 56.708],
              [10.134, 56.708],
              [10.128, 56.707],
              [10.123, 56.706],
              [10.118, 56.704],
              [10.104, 56.696],
              [10.098, 56.693],
              [10.086, 56.689],
              [10.081, 56.688],
              [10.075, 56.687],
              [10.063, 56.686],
              [10.058, 56.686],
              [10.052, 56.684],
              [10.047, 56.683],
              [10.041, 56.68],
              [10.03, 56.675],
              [10, 56.665],
              [9.994, 56.662],
              [9.985, 56.659],
              [9.981, 56.657],
              [9.975, 56.655],
              [9.968, 56.654],
              [9.962, 56.653],
              [9.955, 56.652],
              [9.942, 56.65],
              [9.928, 56.649],
              [9.893, 56.646],
              [9.88, 56.645],
              [9.859, 56.642],
              [9.848, 56.64],
              [9.842, 56.639],
              [9.836, 56.639],
              [9.831, 56.638],
              [9.821, 56.638],
              [9.817, 56.639],
              [9.815, 56.639],
              [9.814, 56.64],
              [9.815, 56.641],
              [9.817, 56.642],
              [9.829, 56.646],
              [9.835, 56.647],
              [9.842, 56.647],
              [9.856, 56.649],
              [9.9, 56.653],
              [9.914, 56.654],
              [9.927, 56.656],
              [9.934, 56.657],
              [9.94, 56.658],
              [9.945, 56.66],
              [9.95, 56.661],
              [9.957, 56.665],
              [9.961, 56.667],
              [9.966, 56.669],
              [9.977, 56.672],
              [10.007, 56.682],
              [10.013, 56.685],
              [10.026, 56.691],
              [10.038, 56.695],
              [10.043, 56.696],
              [10.061, 56.699],
              [10.074, 56.7],
              [10.08, 56.7],
              [10.086, 56.702],
              [10.091, 56.703],
              [10.097, 56.705],
              [10.113, 56.711],
              [10.125, 56.715],
              [10.131, 56.716],
              [10.136, 56.716],
              [10.142, 56.717],
              [10.148, 56.717],
              [10.16, 56.715],
              [10.169, 56.712],
              [10.179, 56.71],
              [10.196, 56.71],
              [10.201, 56.712],
              [10.225, 56.716],
              [10.252, 56.716],
              [10.266, 56.715],
              [10.293, 56.712],
              [10.3, 56.712],
              [10.306, 56.711],
              [10.311, 56.712],
              [10.316, 56.712],
              [10.321, 56.713],
              [10.324, 56.715],
              [10.325, 56.718],
              [10.325, 56.723],
              [10.323, 56.727],
              [10.321, 56.732],
              [10.317, 56.736],
              [10.306, 56.75],
              [10.298, 56.76],
              [10.295, 56.766],
              [10.292, 56.771],
              [10.289, 56.777],
              [10.286, 56.782],
              [10.284, 56.787],
              [10.282, 56.793],
              [10.281, 56.798],
              [10.279, 56.805],
              [10.276, 56.812],
              [10.275, 56.818],
              [10.273, 56.824],
              [10.272, 56.831],
              [10.269, 56.844],
              [10.265, 56.872],
              [10.265, 56.9],
              [10.266, 56.906],
              [10.268, 56.912],
              [10.269, 56.918],
              [10.273, 56.93],
              [10.275, 56.935],
              [10.278, 56.941],
              [10.284, 56.95],
              [10.286, 56.955],
              [10.295, 56.973],
              [10.296, 56.977],
              [10.296, 56.98],
              [10.294, 56.981],
              [10.291, 56.983],
              [10.275, 56.983],
              [10.248, 56.982],
              [10.227, 56.982],
              [10.213, 56.984],
              [10.207, 56.985],
              [10.193, 56.989],
              [10.187, 56.991],
              [10.18, 56.994],
              [10.173, 56.996],
              [10.16, 57.002],
              [10.141, 57.012],
              [10.089, 57.037],
              [10.076, 57.043],
              [10.05, 57.056],
              [10.034, 57.066],
              [10.028, 57.069],
              [10.023, 57.071],
              [10.019, 57.073],
              [10.014, 57.073],
              [10.01, 57.074],
              [10.004, 57.074],
              [9.999, 57.073],
              [9.987, 57.071],
              [9.981, 57.069],
              [9.976, 57.067],
              [9.97, 57.065],
              [9.959, 57.06],
              [9.941, 57.054],
              [9.921, 57.054],
              [9.908, 57.055],
              [9.894, 57.055],
              [9.882, 57.053],
              [9.875, 57.052],
              [9.856, 57.049],
              [9.844, 57.047],
              [9.824, 57.047],
              [9.817, 57.048],
              [9.797, 57.049],
              [9.79, 57.05],
              [9.763, 57.05],
              [9.756, 57.049],
              [9.75, 57.048],
              [9.736, 57.047],
              [9.723, 57.044],
              [9.716, 57.043],
              [9.71, 57.041],
              [9.703, 57.04],
              [9.697, 57.038],
              [9.691, 57.035],
              [9.681, 57.029],
              [9.676, 57.025],
              [9.673, 57.021],
              [9.662, 57.01],
              [9.652, 57.002],
              [9.633, 56.986],
              [9.624, 56.979],
              [9.619, 56.976],
              [9.614, 56.972],
              [9.609, 56.969],
              [9.592, 56.961],
              [9.582, 56.955],
              [9.566, 56.939],
              [9.564, 56.938],
              [9.56, 56.938],
              [9.554, 56.942],
              [9.551, 56.945],
              [9.549, 56.951],
              [9.55, 56.954],
              [9.554, 56.958],
              [9.563, 56.961],
              [9.566, 56.963],
              [9.568, 56.965],
              [9.57, 56.969],
              [9.572, 56.975],
              [9.572, 56.978],
              [9.573, 56.982],
              [9.572, 56.985],
              [9.57, 56.988],
              [9.566, 56.991],
              [9.556, 56.996],
              [9.538, 57.002],
              [9.525, 57.006],
              [9.504, 57.012],
              [9.49, 57.014],
              [9.484, 57.015],
              [9.477, 57.016],
              [9.47, 57.016],
              [9.457, 57.017],
              [9.431, 57.017],
              [9.424, 57.016],
              [9.41, 57.015],
              [9.39, 57.013],
              [9.37, 57.01],
              [9.349, 57.007],
              [9.336, 57.005],
              [9.329, 57.004],
              [9.323, 57.002],
              [9.316, 57.001],
              [9.304, 56.997],
              [9.298, 56.994],
              [9.288, 56.988],
              [9.278, 56.981],
              [9.273, 56.977],
              [9.267, 56.974],
              [9.249, 56.966],
              [9.244, 56.963],
              [9.238, 56.96],
              [9.227, 56.952],
              [9.21, 56.941],
              [9.204, 56.937],
              [9.194, 56.929],
              [9.19, 56.924],
              [9.185, 56.919],
              [9.176, 56.904],
              [9.175, 56.9],
              [9.175, 56.895],
              [9.179, 56.887],
              [9.182, 56.883],
              [9.19, 56.876],
              [9.193, 56.872],
              [9.197, 56.868],
              [9.199, 56.863],
              [9.201, 56.859],
              [9.201, 56.851],
              [9.2, 56.846],
              [9.198, 56.84],
              [9.195, 56.835],
              [9.185, 56.821],
              [9.181, 56.811],
              [9.18, 56.806],
              [9.18, 56.801],
              [9.181, 56.796],
              [9.183, 56.791],
              [9.187, 56.782],
              [9.19, 56.777],
              [9.193, 56.773],
              [9.203, 56.768],
              [9.217, 56.762],
              [9.222, 56.76],
              [9.226, 56.757],
              [9.229, 56.754],
              [9.232, 56.75],
              [9.234, 56.742],
              [9.233, 56.737],
              [9.231, 56.732],
              [9.228, 56.727],
              [9.224, 56.722],
              [9.219, 56.718],
              [9.215, 56.714],
              [9.21, 56.71],
              [9.204, 56.706],
              [9.189, 56.694],
              [9.184, 56.691],
              [9.18, 56.688],
              [9.176, 56.684],
              [9.174, 56.681],
              [9.173, 56.678],
              [9.175, 56.674],
              [9.178, 56.673],
              [9.182, 56.672],
              [9.193, 56.672],
              [9.199, 56.674],
              [9.206, 56.675],
              [9.213, 56.677],
              [9.241, 56.686],
              [9.248, 56.689],
              [9.255, 56.691],
              [9.262, 56.692],
              [9.269, 56.694],
              [9.282, 56.694],
              [9.288, 56.693],
              [9.293, 56.692],
              [9.299, 56.69],
              [9.303, 56.687],
              [9.308, 56.683],
              [9.317, 56.668],
              [9.319, 56.656],
              [9.319, 56.65],
              [9.318, 56.644],
              [9.316, 56.637],
              [9.314, 56.631],
              [9.308, 56.619],
              [9.299, 56.606],
              [9.297, 56.602],
              [9.294, 56.597],
              [9.293, 56.591],
              [9.292, 56.586],
              [9.292, 56.58],
              [9.294, 56.57],
              [9.296, 56.566],
              [9.299, 56.563],
              [9.311, 56.557],
              [9.317, 56.557],
              [9.323, 56.556],
              [9.33, 56.557],
              [9.348, 56.558],
              [9.354, 56.559],
              [9.359, 56.559],
              [9.363, 56.558],
              [9.367, 56.556],
              [9.368, 56.554],
              [9.368, 56.549],
              [9.364, 56.543],
              [9.356, 56.539],
              [9.339, 56.536],
              [9.334, 56.534],
              [9.324, 56.531],
              [9.319, 56.529],
              [9.315, 56.528],
              [9.307, 56.528],
              [9.303, 56.53],
              [9.296, 56.534],
              [9.287, 56.539],
              [9.277, 56.545],
              [9.265, 56.557],
              [9.259, 56.565],
              [9.257, 56.57],
              [9.257, 56.578],
              [9.258, 56.582],
              [9.26, 56.586],
              [9.262, 56.589],
              [9.266, 56.593],
              [9.274, 56.6],
              [9.277, 56.603],
              [9.279, 56.607],
              [9.28, 56.61],
              [9.279, 56.614],
              [9.277, 56.617],
              [9.269, 56.621],
              [9.264, 56.623],
              [9.252, 56.625],
              [9.238, 56.627],
              [9.232, 56.627],
              [9.225, 56.628],
              [9.181, 56.628],
              [9.175, 56.629],
              [9.17, 56.63],
              [9.162, 56.634],
              [9.159, 56.636],
              [9.156, 56.639],
              [9.153, 56.643],
              [9.148, 56.648],
              [9.146, 56.649],
              [9.144, 56.649],
              [9.142, 56.647],
              [9.136, 56.638],
              [9.131, 56.632],
              [9.129, 56.629],
              [9.128, 56.627],
              [9.127, 56.624],
              [9.13, 56.621],
              [9.135, 56.618],
              [9.138, 56.617],
              [9.14, 56.613],
              [9.14, 56.611],
              [9.138, 56.609],
              [9.135, 56.607],
              [9.132, 56.606],
              [9.128, 56.605],
              [9.123, 56.604],
              [9.117, 56.603],
              [9.112, 56.601],
              [9.107, 56.598],
              [9.103, 56.595],
              [9.1, 56.591],
              [9.091, 56.578],
              [9.087, 56.573],
              [9.083, 56.569],
              [9.078, 56.566],
              [9.074, 56.564],
              [9.069, 56.563],
              [9.064, 56.563],
              [9.06, 56.564],
              [9.057, 56.566],
              [9.056, 56.567],
              [9.053, 56.573],
              [9.052, 56.578],
              [9.05, 56.583],
              [9.049, 56.589],
              [9.049, 56.601],
              [9.05, 56.607],
              [9.051, 56.611],
              [9.053, 56.616],
              [9.059, 56.624],
              [9.067, 56.632],
              [9.077, 56.638],
              [9.087, 56.643],
              [9.095, 56.649],
              [9.098, 56.652],
              [9.104, 56.661],
              [9.107, 56.664],
              [9.11, 56.666],
              [9.118, 56.671],
              [9.122, 56.675],
              [9.135, 56.685],
              [9.14, 56.689],
              [9.144, 56.692],
              [9.15, 56.695],
              [9.155, 56.698],
              [9.164, 56.703],
              [9.17, 56.707],
              [9.171, 56.709],
              [9.171, 56.711],
              [9.169, 56.714],
              [9.166, 56.717],
              [9.162, 56.72],
              [9.144, 56.735],
              [9.14, 56.739],
              [9.135, 56.743],
              [9.13, 56.749],
              [9.126, 56.754],
              [9.122, 56.76],
              [9.118, 56.765],
              [9.108, 56.779],
              [9.106, 56.783],
              [9.101, 56.787],
              [9.097, 56.79],
              [9.091, 56.793],
              [9.086, 56.795],
              [9.08, 56.797],
              [9.073, 56.799],
              [9.061, 56.801],
              [9.055, 56.801],
              [9.05, 56.8],
              [9.044, 56.8],
              [9.04, 56.799],
              [9.037, 56.798],
              [9.034, 56.796],
              [9.033, 56.794],
              [9.031, 56.793],
              [9.028, 56.792],
              [9.026, 56.791],
              [9.011, 56.791],
              [9.006, 56.792],
              [8.988, 56.795],
              [8.981, 56.796],
              [8.975, 56.796],
              [8.969, 56.797],
              [8.963, 56.796],
              [8.956, 56.795],
              [8.938, 56.789],
              [8.914, 56.779],
              [8.908, 56.777],
              [8.89, 56.77],
              [8.884, 56.768],
              [8.879, 56.766],
              [8.874, 56.763],
              [8.87, 56.76],
              [8.867, 56.757],
              [8.861, 56.748],
              [8.848, 56.73],
              [8.842, 56.722],
              [8.84, 56.718],
              [8.839, 56.715],
              [8.839, 56.712],
              [8.841, 56.711],
              [8.845, 56.71],
              [8.85, 56.71],
              [8.869, 56.709],
              [8.888, 56.709],
              [8.9, 56.706],
              [8.903, 56.705],
              [8.905, 56.704],
              [8.906, 56.702],
              [8.906, 56.701],
              [8.904, 56.699],
              [8.898, 56.697],
              [8.883, 56.697],
              [8.878, 56.696],
              [8.869, 56.695],
              [8.853, 56.694],
              [8.848, 56.693],
              [8.84, 56.692],
              [8.825, 56.69],
              [8.815, 56.688],
              [8.809, 56.686],
              [8.804, 56.683],
              [8.798, 56.68],
              [8.793, 56.676],
              [8.787, 56.672],
              [8.782, 56.668],
              [8.766, 56.656],
              [8.755, 56.647],
              [8.75, 56.643],
              [8.744, 56.64],
              [8.739, 56.636],
              [8.733, 56.633],
              [8.721, 56.629],
              [8.715, 56.628],
              [8.703, 56.625],
              [8.697, 56.624],
              [8.692, 56.623],
              [8.689, 56.621],
              [8.686, 56.618],
              [8.685, 56.615],
              [8.685, 56.612],
              [8.686, 56.609],
              [8.688, 56.607],
              [8.694, 56.6],
              [8.702, 56.592],
              [8.707, 56.588],
              [8.711, 56.584],
              [8.717, 56.58],
              [8.742, 56.565],
              [8.746, 56.562],
              [8.75, 56.556],
              [8.751, 56.553],
              [8.75, 56.548],
              [8.749, 56.544],
              [8.745, 56.533],
              [8.742, 56.528],
              [8.741, 56.522],
              [8.739, 56.516],
              [8.737, 56.504],
              [8.733, 56.492],
              [8.727, 56.484],
              [8.722, 56.481],
              [8.717, 56.479],
              [8.699, 56.473],
              [8.693, 56.472],
              [8.686, 56.471],
              [8.68, 56.47],
              [8.673, 56.47],
              [8.667, 56.469],
              [8.66, 56.47],
              [8.654, 56.47],
              [8.642, 56.472],
              [8.636, 56.474],
              [8.626, 56.478],
              [8.621, 56.482],
              [8.609, 56.491],
              [8.606, 56.492],
              [8.601, 56.495],
              [8.599, 56.497],
              [8.597, 56.498],
              [8.596, 56.5],
              [8.595, 56.503],
              [8.597, 56.509],
              [8.6, 56.514],
              [8.601, 56.517],
              [8.601, 56.52],
              [8.6, 56.523],
              [8.598, 56.526],
              [8.594, 56.53],
              [8.587, 56.538],
              [8.583, 56.542],
              [8.58, 56.547],
              [8.577, 56.551],
              [8.572, 56.559],
              [8.569, 56.563],
              [8.567, 56.565],
              [8.564, 56.567],
              [8.561, 56.567],
              [8.558, 56.566],
              [8.555, 56.564],
              [8.547, 56.559],
              [8.542, 56.557],
              [8.537, 56.554],
              [8.527, 56.55],
              [8.521, 56.549],
              [8.516, 56.548],
              [8.509, 56.547],
              [8.502, 56.548],
              [8.496, 56.549],
              [8.489, 56.55],
              [8.482, 56.552],
              [8.476, 56.553],
              [8.462, 56.557],
              [8.435, 56.565],
              [8.421, 56.569],
              [8.408, 56.573],
              [8.38, 56.577],
              [8.353, 56.577],
              [8.339, 56.575],
              [8.327, 56.573],
              [8.321, 56.571],
              [8.313, 56.567],
              [8.307, 56.563],
              [8.304, 56.562],
              [8.302, 56.561],
              [8.3, 56.562],
              [8.297, 56.564],
              [8.295, 56.567],
              [8.293, 56.571],
              [8.292, 56.574],
              [8.292, 56.581],
              [8.293, 56.583],
              [8.293, 56.588],
              [8.292, 56.59],
              [8.291, 56.591],
              [8.288, 56.593],
              [8.273, 56.599],
              [8.255, 56.603],
              [8.243, 56.607],
              [8.238, 56.609],
              [8.226, 56.618],
              [8.223, 56.619],
              [8.22, 56.623],
              [8.219, 56.624],
              [8.216, 56.626],
              [8.205, 56.631],
              [8.199, 56.635],
              [8.197, 56.638],
              [8.197, 56.643],
              [8.198, 56.646],
              [8.2, 56.649],
              [8.202, 56.651],
              [8.206, 56.656],
              [8.208, 56.658],
              [8.21, 56.661],
              [8.212, 56.666],
              [8.215, 56.67],
              [8.22, 56.676],
              [8.224, 56.682],
              [8.224, 56.684],
              [8.225, 56.687],
              [8.225, 56.691],
              [8.224, 56.693],
              [8.222, 56.696],
              [8.219, 56.698],
              [8.216, 56.699],
              [8.225, 56.722],
              [8.225, 56.721],
              [8.228, 56.718],
              [8.231, 56.716],
              [8.234, 56.715],
              [8.237, 56.713],
              [8.242, 56.713],
              [8.246, 56.719],
              [8.248, 56.724],
              [8.249, 56.73],
              [8.253, 56.749],
              [8.255, 56.755],
              [8.256, 56.76],
              [8.259, 56.764],
              [8.262, 56.767],
              [8.266, 56.768],
              [8.27, 56.768],
              [8.275, 56.767],
              [8.28, 56.765],
              [8.29, 56.759],
              [8.294, 56.754],
              [8.298, 56.75],
              [8.31, 56.73],
              [8.314, 56.724],
              [8.318, 56.719],
              [8.322, 56.713],
              [8.326, 56.708],
              [8.336, 56.698],
              [8.341, 56.694],
              [8.346, 56.689],
              [8.352, 56.685],
              [8.357, 56.682],
              [8.364, 56.679],
              [8.37, 56.677],
              [8.384, 56.673],
              [8.411, 56.666],
              [8.425, 56.662],
              [8.431, 56.66],
              [8.438, 56.657],
              [8.456, 56.648],
              [8.462, 56.644],
              [8.468, 56.641],
              [8.48, 56.633],
              [8.485, 56.629],
              [8.499, 56.615],
              [8.511, 56.601],
              [8.519, 56.593],
              [8.523, 56.59],
              [8.528, 56.587],
              [8.532, 56.585],
              [8.536, 56.584],
              [8.539, 56.583],
              [8.541, 56.582],
              [8.542, 56.583],
              [8.541, 56.585],
              [8.543, 56.589],
              [8.546, 56.591],
              [8.55, 56.593],
              [8.554, 56.594],
              [8.564, 56.597],
              [8.574, 56.601],
              [8.579, 56.604],
              [8.583, 56.607],
              [8.586, 56.611],
              [8.589, 56.616],
              [8.591, 56.621],
              [8.592, 56.626],
              [8.592, 56.631],
              [8.591, 56.636],
              [8.589, 56.64],
              [8.585, 56.649],
              [8.584, 56.653],
              [8.582, 56.657],
              [8.582, 56.678],
              [8.58, 56.681],
              [8.577, 56.684],
              [8.569, 56.686],
              [8.564, 56.686],
              [8.558, 56.685],
              [8.553, 56.685],
              [8.547, 56.683],
              [8.541, 56.682],
              [8.522, 56.677],
              [8.515, 56.675],
              [8.503, 56.673],
              [8.497, 56.673],
              [8.491, 56.674],
              [8.486, 56.675],
              [8.474, 56.678],
              [8.468, 56.679],
              [8.45, 56.679],
              [8.443, 56.678],
              [8.431, 56.676],
              [8.416, 56.676],
              [8.413, 56.677],
              [8.411, 56.678],
              [8.41, 56.679],
              [8.41, 56.68],
              [8.412, 56.682],
              [8.424, 56.686],
              [8.435, 56.689],
              [8.453, 56.692],
              [8.46, 56.692],
              [8.474, 56.69],
              [8.487, 56.688],
              [8.493, 56.688],
              [8.499, 56.687],
              [8.505, 56.687],
              [8.513, 56.689],
              [8.516, 56.692],
              [8.518, 56.696],
              [8.518, 56.698],
              [8.516, 56.7],
              [8.514, 56.704],
              [8.512, 56.705],
              [8.51, 56.707],
              [8.507, 56.709],
              [8.504, 56.71],
              [8.491, 56.715],
              [8.487, 56.716],
              [8.484, 56.718],
              [8.482, 56.721],
              [8.482, 56.729],
              [8.483, 56.733],
              [8.486, 56.743],
              [8.487, 56.749],
              [8.488, 56.754],
              [8.487, 56.759],
              [8.485, 56.763],
              [8.482, 56.772],
              [8.481, 56.777],
              [8.481, 56.781],
              [8.482, 56.784],
              [8.484, 56.787],
              [8.49, 56.793],
              [8.495, 56.795],
              [8.5, 56.798],
              [8.524, 56.806],
              [8.529, 56.809],
              [8.538, 56.813],
              [8.543, 56.814],
              [8.549, 56.816],
              [8.561, 56.819],
              [8.568, 56.82],
              [8.574, 56.822],
              [8.592, 56.831],
              [8.598, 56.835],
              [8.613, 56.847],
              [8.617, 56.852],
              [8.62, 56.856],
              [8.626, 56.866],
              [8.627, 56.871],
              [8.63, 56.882],
              [8.631, 56.887],
              [8.637, 56.902],
              [8.64, 56.907],
              [8.644, 56.911],
              [8.647, 56.915],
              [8.657, 56.927],
              [8.664, 56.935],
              [8.67, 56.941],
              [8.674, 56.944],
              [8.679, 56.947],
              [8.685, 56.948],
              [8.69, 56.949],
              [8.697, 56.95],
              [8.758, 56.95],
              [8.764, 56.951],
              [8.771, 56.952],
              [8.776, 56.953],
              [8.818, 56.967],
              [8.823, 56.969],
              [8.828, 56.972],
              [8.833, 56.974],
              [8.836, 56.977],
              [8.838, 56.98],
              [8.84, 56.985],
              [8.842, 56.988],
              [8.845, 56.989],
              [8.849, 56.99],
              [8.854, 56.991],
              [8.864, 56.991],
              [8.884, 56.987],
              [8.888, 56.985],
              [8.898, 56.983],
              [8.903, 56.983],
              [8.913, 56.987],
              [8.929, 56.996],
              [8.935, 56.999],
              [8.941, 57.001],
              [8.947, 57.002],
              [8.965, 57.008],
              [8.978, 57.012],
              [8.99, 57.016],
              [9.002, 57.018],
              [9.019, 57.018],
              [9.025, 57.016],
              [9.031, 57.015],
              [9.036, 57.014],
              [9.044, 57.014],
              [9.05, 57.015],
              [9.06, 57.017],
              [9.072, 57.023],
              [9.073, 57.023],
              [9.071, 57.023],
              [9.071, 57.024],
              [9.073, 57.024],
              [9.079, 57.027],
              [9.088, 57.029],
              [9.094, 57.031],
              [9.118, 57.035],
              [9.131, 57.035],
              [9.138, 57.034],
              [9.146, 57.031],
              [9.164, 57.025],
              [9.172, 57.021],
              [9.179, 57.017],
              [9.196, 57.008],
              [9.199, 57.006],
              [9.203, 57.004],
              [9.209, 57.002],
              [9.216, 57],
              [9.223, 56.997],
              [9.231, 56.995],
              [9.24, 56.994],
              [9.256, 56.994],
              [9.264, 56.995],
              [9.27, 56.996],
              [9.277, 56.998],
              [9.283, 57],
              [9.29, 57.002],
              [9.309, 57.01],
              [9.323, 57.014],
              [9.336, 57.018],
              [9.357, 57.022],
              [9.377, 57.027],
              [9.398, 57.031],
              [9.412, 57.033],
              [9.419, 57.035],
              [9.426, 57.035],
              [9.449, 57.038],
              [9.455, 57.039],
              [9.482, 57.043],
              [9.489, 57.043],
              [9.495, 57.044],
              [9.523, 57.044],
              [9.544, 57.043],
              [9.564, 57.043],
              [9.578, 57.045],
              [9.584, 57.046],
              [9.591, 57.047],
              [9.603, 57.051],
              [9.609, 57.054],
              [9.62, 57.058],
              [9.625, 57.06],
              [9.629, 57.063],
              [9.633, 57.065],
              [9.636, 57.068],
              [9.636, 57.07],
              [9.635, 57.071],
              [9.631, 57.073],
              [9.628, 57.076],
              [9.628, 57.078],
              [9.63, 57.082],
              [9.633, 57.084],
              [9.637, 57.086],
              [9.642, 57.088],
              [9.646, 57.089],
              [9.651, 57.091],
              [9.656, 57.092],
              [9.665, 57.092],
              [9.666, 57.091],
              [9.666, 57.089],
              [9.663, 57.086],
              [9.662, 57.083],
              [9.661, 57.081],
              [9.661, 57.079],
              [9.662, 57.077],
              [9.664, 57.075],
              [9.67, 57.073],
              [9.674, 57.071],
              [9.679, 57.07],
              [9.684, 57.068],
              [9.69, 57.067],
              [9.695, 57.065],
              [9.701, 57.065],
              [9.707, 57.064],
              [9.713, 57.064],
              [9.719, 57.065],
              [9.726, 57.065],
              [9.732, 57.066],
              [9.737, 57.068],
              [9.742, 57.069],
              [9.752, 57.073],
              [9.756, 57.076],
              [9.761, 57.079],
              [9.766, 57.083],
              [9.775, 57.09],
              [9.782, 57.096],
              [9.786, 57.099],
              [9.787, 57.1],
              [9.79, 57.101],
              [9.798, 57.101],
              [9.808, 57.099],
              [9.814, 57.098],
              [9.819, 57.096],
              [9.837, 57.09],
              [9.849, 57.084],
              [9.868, 57.075],
              [9.88, 57.069],
              [9.887, 57.067],
              [9.894, 57.064],
              [9.901, 57.063],
              [9.908, 57.061],
              [9.915, 57.06],
              [9.921, 57.059],
              [9.928, 57.058],
              [9.935, 57.058],
              [9.941, 57.059],
              [9.953, 57.063],
              [9.958, 57.066],
              [9.969, 57.073],
              [9.974, 57.076],
              [9.98, 57.079],
              [9.986, 57.081],
              [9.993, 57.083],
              [9.999, 57.084],
              [10.013, 57.084],
              [10.019, 57.083],
              [10.026, 57.081],
              [10.038, 57.077],
              [10.045, 57.074],
              [10.051, 57.071],
              [10.07, 57.062],
              [10.159, 57.019],
              [10.184, 57.007],
              [10.197, 57.001],
              [10.203, 56.999],
              [10.21, 56.996],
              [10.216, 56.994],
              [10.23, 56.99],
              [10.244, 56.988],
              [10.272, 56.988],
              [10.293, 56.99],
              [10.312, 56.992],
              [10.319, 56.993],
              [10.325, 56.994],
              [10.33, 56.996],
              [10.336, 56.999],
              [10.341, 57.002],
              [10.345, 57.007],
              [10.35, 57.012],
              [10.354, 57.017],
              [10.359, 57.022],
              [10.363, 57.028],
              [10.367, 57.033],
              [10.371, 57.039],
              [10.374, 57.045],
              [10.378, 57.051],
              [10.381, 57.057],
              [10.384, 57.064],
              [10.386, 57.07],
              [10.389, 57.077],
              [10.395, 57.097],
              [10.397, 57.103],
              [10.4, 57.11],
              [10.403, 57.116],
              [10.406, 57.121],
              [10.409, 57.127],
              [10.412, 57.132],
              [10.415, 57.136],
              [10.419, 57.14],
              [10.427, 57.149],
              [10.434, 57.158],
              [10.438, 57.163],
              [10.443, 57.167],
              [10.447, 57.171],
              [10.467, 57.187],
              [10.477, 57.193],
              [10.481, 57.196],
              [10.485, 57.198],
              [10.488, 57.199],
              [10.495, 57.201],
              [10.496, 57.202],
              [10.502, 57.204],
              [10.503, 57.204],
              [10.506, 57.207],
              [10.509, 57.209],
              [10.523, 57.216],
              [10.528, 57.219],
              [10.532, 57.222],
              [10.537, 57.226],
              [10.543, 57.236],
              [10.545, 57.241],
              [10.546, 57.247],
              [10.546, 57.259],
              [10.545, 57.265],
              [10.544, 57.272],
              [10.543, 57.278],
              [10.541, 57.285],
              [10.534, 57.31],
              [10.532, 57.316],
              [10.531, 57.322],
              [10.528, 57.337],
              [10.525, 57.347],
              [10.521, 57.359],
              [10.52, 57.365],
              [10.519, 57.372],
              [10.519, 57.391],
              [10.52, 57.397],
              [10.522, 57.403],
              [10.523, 57.408],
              [10.525, 57.414],
              [10.528, 57.418],
              [10.53, 57.422],
              [10.536, 57.428],
              [10.541, 57.431],
              [10.542, 57.432],
              [10.544, 57.436],
              [10.546, 57.437],
              [10.549, 57.438],
              [10.551, 57.44],
              [10.553, 57.441],
              [10.554, 57.441],
              [10.554, 57.446],
              [10.553, 57.448],
              [10.549, 57.452],
              [10.542, 57.461],
              [10.539, 57.464],
              [10.535, 57.467],
              [10.531, 57.471],
              [10.518, 57.481],
              [10.514, 57.484],
              [10.499, 57.499],
              [10.495, 57.502],
              [10.49, 57.506],
              [10.47, 57.52],
              [10.464, 57.524],
              [10.454, 57.532],
              [10.442, 57.547],
              [10.438, 57.553],
              [10.435, 57.558],
              [10.431, 57.57],
              [10.431, 57.576],
              [10.43, 57.581],
              [10.432, 57.593],
              [10.433, 57.598],
              [10.439, 57.61],
              [10.442, 57.615],
              [10.446, 57.621],
              [10.45, 57.626],
              [10.465, 57.641],
              [10.475, 57.649],
              [10.486, 57.658],
              [10.503, 57.671],
              [10.514, 57.679],
              [10.52, 57.683],
              [10.526, 57.686],
              [10.532, 57.69],
              [10.544, 57.696],
              [10.551, 57.699],
              [10.557, 57.702],
              [10.57, 57.708],
              [10.615, 57.726],
              [10.627, 57.731],
              [10.632, 57.734],
              [10.637, 57.736],
              [10.641, 57.739],
              [10.643, 57.741],
              [11.776, 57.971],
              [11.772, 57.968],
              [11.769, 57.966],
              [11.767, 57.963],
              [11.766, 57.961],
              [11.766, 57.956],
              [11.767, 57.954],
              [11.77, 57.951],
              [11.771, 57.949],
              [11.77, 57.948],
              [11.768, 57.947],
              [11.764, 57.944],
              [11.762, 57.942],
              [11.761, 57.939],
              [11.761, 57.937],
              [11.762, 57.936],
              [11.769, 57.933],
              [11.771, 57.931],
              [11.774, 57.929],
              [11.775, 57.928],
              [11.776, 57.926],
              [11.776, 57.925],
              [11.774, 57.923],
              [11.772, 57.922],
              [11.77, 57.92],
              [11.768, 57.919],
              [11.767, 57.917],
              [11.767, 57.916],
              [11.768, 57.914],
              [11.771, 57.909],
              [11.771, 57.906],
              [11.769, 57.905],
              [11.765, 57.904],
              [11.76, 57.903],
              [11.736, 57.9],
              [11.73, 57.899],
              [11.72, 57.897],
              [11.716, 57.894],
              [11.714, 57.892],
              [11.713, 57.889],
              [11.711, 57.884],
              [11.709, 57.881],
              [11.708, 57.878],
              [11.706, 57.875],
              [11.692, 57.861],
              [11.689, 57.859],
              [11.687, 57.856],
              [11.687, 57.853],
              [11.689, 57.852],
              [11.695, 57.85],
              [11.696, 57.849],
              [11.696, 57.848],
              [11.695, 57.847],
              [11.693, 57.843],
              [11.693, 57.84],
              [11.694, 57.838],
              [11.697, 57.835],
              [11.699, 57.834],
              [11.701, 57.832],
              [11.712, 57.827],
              [11.722, 57.822],
              [11.723, 57.82],
              [11.728, 57.815],
              [11.735, 57.807],
              [11.738, 57.805],
              [11.739, 57.803],
              [11.739, 57.798],
              [11.737, 57.794],
              [11.737, 57.793],
              [11.738, 57.791],
              [11.74, 57.79],
              [11.746, 57.79],
              [11.765, 57.792],
              [11.775, 57.794],
              [11.781, 57.794],
              [11.787, 57.795],
              [11.794, 57.794],
              [11.8, 57.794],
              [11.806, 57.793],
              [11.811, 57.793],
              [11.816, 57.792],
              [11.819, 57.791],
              [11.821, 57.789],
              [11.821, 57.788],
              [11.819, 57.786],
              [11.818, 57.784],
              [11.813, 57.781],
              [11.811, 57.779],
              [11.808, 57.778],
              [11.802, 57.774],
              [11.799, 57.773],
              [11.795, 57.769],
              [11.794, 57.767],
              [11.794, 57.765],
              [11.795, 57.762],
              [11.795, 57.758],
              [11.791, 57.754],
              [11.783, 57.75],
              [11.777, 57.748],
              [11.771, 57.747],
              [11.752, 57.743],
              [11.734, 57.737],
              [11.729, 57.735],
              [11.726, 57.733],
              [11.72, 57.728],
              [11.713, 57.721],
              [11.712, 57.718],
              [11.712, 57.716],
              [11.711, 57.711],
              [11.711, 57.709],
              [11.712, 57.707],
              [11.714, 57.704],
              [11.718, 57.702],
              [11.726, 57.7],
              [11.736, 57.698],
              [11.753, 57.694],
              [11.757, 57.693],
              [11.766, 57.693],
              [11.771, 57.695],
              [11.775, 57.696],
              [11.788, 57.696],
              [11.798, 57.694],
              [11.799, 57.693],
              [11.803, 57.693],
              [11.806, 57.694],
              [11.808, 57.695],
              [11.81, 57.694],
              [11.813, 57.693],
              [11.817, 57.691],
              [11.824, 57.686],
              [11.836, 57.68],
              [11.84, 57.677],
              [11.843, 57.675],
              [11.844, 57.672],
              [11.846, 57.668],
              [11.847, 57.665],
              [11.85, 57.662],
              [11.852, 57.658],
              [11.853, 57.653],
              [11.857, 57.647],
              [11.874, 57.63],
              [11.879, 57.623],
              [11.882, 57.62],
              [11.886, 57.618],
              [11.889, 57.617],
              [11.896, 57.617],
              [11.9, 57.619],
              [11.907, 57.623],
              [11.91, 57.624],
              [11.913, 57.624],
              [11.916, 57.622],
              [11.918, 57.622],
              [11.921, 57.619],
              [11.923, 57.616],
              [11.924, 57.613],
              [11.925, 57.609],
              [11.925, 57.601],
              [11.927, 57.593],
              [11.929, 57.586],
              [11.93, 57.583],
              [11.93, 57.569],
              [11.928, 57.563],
              [11.926, 57.555],
              [11.924, 57.552],
              [11.922, 57.545],
              [11.92, 57.539],
              [11.921, 57.536],
              [11.922, 57.534],
              [11.922, 57.533],
              [11.924, 57.531],
              [11.928, 57.528],
              [11.929, 57.527],
              [11.929, 57.523],
              [11.93, 57.522],
              [11.931, 57.52],
              [11.934, 57.518],
              [11.934, 57.517],
              [11.935, 57.514],
              [11.936, 57.513],
              [11.936, 57.512],
              [11.935, 57.511],
              [11.932, 57.509],
              [11.93, 57.508],
              [11.93, 57.505],
              [11.932, 57.504],
              [11.934, 57.504],
              [11.937, 57.503],
              [11.946, 57.501],
              [11.948, 57.5],
              [11.951, 57.499],
              [11.953, 57.497],
              [11.953, 57.495],
              [11.951, 57.493],
              [11.947, 57.491],
              [11.944, 57.49],
              [11.94, 57.489],
              [11.931, 57.488],
              [11.927, 57.488],
              [11.921, 57.486],
              [11.919, 57.485],
              [11.918, 57.484],
              [11.918, 57.483],
              [11.919, 57.48],
              [11.919, 57.479],
              [11.921, 57.478],
              [11.924, 57.476],
              [11.925, 57.475],
              [11.925, 57.473],
              [11.92, 57.468],
              [11.918, 57.465],
              [11.917, 57.463],
              [11.913, 57.453],
              [11.912, 57.451],
              [11.911, 57.446],
              [11.911, 57.44],
              [11.912, 57.437],
              [11.913, 57.433],
              [11.916, 57.43],
              [11.918, 57.427],
              [11.919, 57.424],
              [11.921, 57.42],
              [11.922, 57.417],
              [11.923, 57.413],
              [11.923, 57.406],
              [11.922, 57.402],
              [11.922, 57.397],
              [11.924, 57.395],
              [11.927, 57.394],
              [11.931, 57.393],
              [11.938, 57.392],
              [11.942, 57.391],
              [11.948, 57.389],
              [11.951, 57.387],
              [11.952, 57.386],
              [11.953, 57.384],
              [11.953, 57.375],
              [11.951, 57.369],
              [11.951, 57.367],
              [11.952, 57.365],
              [11.954, 57.364],
              [11.957, 57.363],
              [11.964, 57.363],
              [11.973, 57.365],
              [11.977, 57.366],
              [11.981, 57.365],
              [11.984, 57.365],
              [11.986, 57.364],
              [11.989, 57.361],
              [11.991, 57.361],
              [11.994, 57.359],
              [11.996, 57.358],
              [11.999, 57.352],
              [12.001, 57.35],
              [12.003, 57.35],
              [12.005, 57.351],
              [12.008, 57.353],
              [12.011, 57.356],
              [12.014, 57.36],
              [12.017, 57.365],
              [12.021, 57.375],
              [12.022, 57.38],
              [12.024, 57.391],
              [12.028, 57.401],
              [12.031, 57.406],
              [12.034, 57.412],
              [12.041, 57.422],
              [12.05, 57.438],
              [12.053, 57.442],
              [12.056, 57.447],
              [12.059, 57.45],
              [12.062, 57.452],
              [12.065, 57.453],
              [12.067, 57.453],
              [12.07, 57.452],
              [12.072, 57.451],
              [12.077, 57.447],
              [12.08, 57.445],
              [12.089, 57.44],
              [12.094, 57.437],
              [12.098, 57.434],
              [12.101, 57.43],
              [12.103, 57.426],
              [12.104, 57.422],
              [12.102, 57.414],
              [12.095, 57.407],
              [12.093, 57.403],
              [12.094, 57.401],
              [12.096, 57.399],
              [12.099, 57.398],
              [12.107, 57.395],
              [12.111, 57.394],
              [12.114, 57.392],
              [12.116, 57.389],
              [12.117, 57.386],
              [12.116, 57.382],
              [12.111, 57.377],
              [12.107, 57.375],
              [12.098, 57.37],
              [12.093, 57.367],
              [12.085, 57.361],
              [12.082, 57.357],
              [12.079, 57.354],
              [12.077, 57.35],
              [12.076, 57.347],
              [12.077, 57.345],
              [12.079, 57.343],
              [12.083, 57.342],
              [12.105, 57.342],
              [12.117, 57.34],
              [12.122, 57.339],
              [12.132, 57.335],
              [12.14, 57.333],
              [12.143, 57.332],
              [12.147, 57.33],
              [12.15, 57.328],
              [12.152, 57.326],
              [12.154, 57.322],
              [12.155, 57.316],
              [12.16, 57.306],
              [12.16, 57.3],
              [12.159, 57.296],
              [12.158, 57.293],
              [12.156, 57.29],
              [12.152, 57.287],
              [12.147, 57.284],
              [12.142, 57.282],
              [12.124, 57.275],
              [12.118, 57.273],
              [12.113, 57.27],
              [12.109, 57.268],
              [12.101, 57.262],
              [12.099, 57.259],
              [12.098, 57.257],
              [12.098, 57.255],
              [12.099, 57.253],
              [12.1, 57.252],
              [12.103, 57.251],
              [12.108, 57.25],
              [12.111, 57.249],
              [12.113, 57.248],
              [12.114, 57.246],
              [12.113, 57.245],
              [12.111, 57.241],
              [12.107, 57.239],
              [12.106, 57.237],
              [12.106, 57.234],
              [12.111, 57.229],
              [12.116, 57.227],
              [12.121, 57.224],
              [12.126, 57.222],
              [12.132, 57.22],
              [12.138, 57.219],
              [12.152, 57.217],
              [12.184, 57.217],
              [12.19, 57.218],
              [12.194, 57.217],
              [12.198, 57.217],
              [12.2, 57.215],
              [12.201, 57.213],
              [12.2, 57.211],
              [12.197, 57.209],
              [12.193, 57.207],
              [12.188, 57.205],
              [12.174, 57.199],
              [12.17, 57.197],
              [12.167, 57.195],
              [12.166, 57.193],
              [12.166, 57.192],
              [12.168, 57.19],
              [12.171, 57.189],
              [12.175, 57.188],
              [12.189, 57.186],
              [12.194, 57.185],
              [12.198, 57.184],
              [12.202, 57.182],
              [12.205, 57.179],
              [12.206, 57.177],
              [12.209, 57.173],
              [12.214, 57.166],
              [12.217, 57.163],
              [12.218, 57.16],
              [12.219, 57.158],
              [12.219, 57.156],
              [12.218, 57.153],
              [12.218, 57.146],
              [12.219, 57.144],
              [12.22, 57.141],
              [12.222, 57.139],
              [12.225, 57.137],
              [12.229, 57.135],
              [12.235, 57.133],
              [12.241, 57.132],
              [12.242, 57.131],
              [12.242, 57.13],
              [12.241, 57.129],
              [12.235, 57.127],
              [12.231, 57.126],
              [12.223, 57.126],
              [12.219, 57.125],
              [12.214, 57.124],
              [12.211, 57.123],
              [12.208, 57.121],
              [12.206, 57.12],
              [12.205, 57.118],
              [12.206, 57.117],
              [12.212, 57.115],
              [12.216, 57.114],
              [12.224, 57.114],
              [12.228, 57.115],
              [12.232, 57.115],
              [12.236, 57.113],
              [12.237, 57.112],
              [12.237, 57.111],
              [12.238, 57.11],
              [12.239, 57.105],
              [12.239, 57.103],
              [12.242, 57.094],
              [12.243, 57.09],
              [12.245, 57.087],
              [12.25, 57.081],
              [12.253, 57.078],
              [12.256, 57.072],
              [12.258, 57.07],
              [12.26, 57.067],
              [12.266, 57.064],
              [12.268, 57.061],
              [12.271, 57.059],
              [12.273, 57.056],
              [12.276, 57.053],
              [12.279, 57.049],
              [12.294, 57.04],
              [12.317, 57.028],
              [12.322, 57.024],
              [12.328, 57.021],
              [12.333, 57.017],
              [12.337, 57.013],
              [12.345, 57.003],
              [12.348, 56.997],
              [12.35, 56.991],
              [12.352, 56.986],
              [12.353, 56.98],
              [12.353, 56.959],
              [12.354, 56.954],
              [12.354, 56.948],
              [12.356, 56.938],
              [12.357, 56.934],
              [12.358, 56.931],
              [12.362, 56.925],
              [12.365, 56.923],
              [12.373, 56.919],
              [12.386, 56.914],
              [12.4, 56.909],
              [12.404, 56.908],
              [12.41, 56.906],
              [12.433, 56.901],
              [12.445, 56.898],
              [12.455, 56.894],
              [12.462, 56.892],
              [12.464, 56.891],
              [12.478, 56.891],
              [12.483, 56.892],
              [12.486, 56.892],
              [12.486, 56.889],
              [12.488, 56.887],
              [12.499, 56.882],
              [12.503, 56.88],
              [12.518, 56.871],
              [12.527, 56.867],
              [12.531, 56.865],
              [12.539, 56.859],
              [12.547, 56.852],
              [12.551, 56.849],
              [12.561, 56.845],
              [12.571, 56.84],
              [12.576, 56.838],
              [12.586, 56.832],
              [12.596, 56.824],
              [12.599, 56.82],
              [12.602, 56.815],
              [12.608, 56.8],
              [12.611, 56.795],
              [12.621, 56.774],
              [12.625, 56.764],
              [12.628, 56.754],
              [12.632, 56.744],
              [12.634, 56.741],
              [12.637, 56.737],
              [12.646, 56.728],
              [12.654, 56.722],
              [12.659, 56.719],
              [12.667, 56.713],
              [12.672, 56.709],
              [12.675, 56.705],
              [12.681, 56.695],
              [12.684, 56.691],
              [12.688, 56.687],
              [12.692, 56.684],
              [12.707, 56.675],
              [12.711, 56.673],
              [12.715, 56.67],
              [12.721, 56.662],
              [12.727, 56.655],
              [12.731, 56.652],
              [12.734, 56.649],
              [12.739, 56.647],
              [12.744, 56.646],
              [12.749, 56.646],
              [12.755, 56.645],
              [12.767, 56.646],
              [12.78, 56.646],
              [12.792, 56.648],
              [12.797, 56.649],
              [12.811, 56.654],
              [12.817, 56.656],
              [12.827, 56.658],
              [12.839, 56.658],
              [12.845, 56.656],
              [12.847, 56.655],
              [12.848, 56.654],
              [12.849, 56.652],
              [12.849, 56.651],
              [12.85, 56.65],
              [12.852, 56.649],
              [12.854, 56.649],
              [12.858, 56.648],
              [12.867, 56.647],
              [12.873, 56.645],
              [12.878, 56.644],
              [12.883, 56.641],
              [12.887, 56.638],
              [12.892, 56.634],
              [12.9, 56.626],
              [12.905, 56.622],
              [12.908, 56.617],
              [12.912, 56.612],
              [12.918, 56.604],
              [12.922, 56.599],
              [12.931, 56.588],
              [12.935, 56.583],
              [12.938, 56.578],
              [12.946, 56.554],
              [12.946, 56.536],
              [12.943, 56.518],
              [12.937, 56.5],
              [12.934, 56.494],
              [12.931, 56.489],
              [12.928, 56.483],
              [12.924, 56.478],
              [12.921, 56.473],
              [12.913, 56.463],
              [12.908, 56.459],
              [12.902, 56.454],
              [12.897, 56.45],
              [12.891, 56.446],
              [12.879, 56.44],
              [12.874, 56.438],
              [12.868, 56.436],
              [12.856, 56.434],
              [12.851, 56.434],
              [12.844, 56.435],
              [12.838, 56.436],
              [12.831, 56.438],
              [12.825, 56.44],
              [12.812, 56.444],
              [12.773, 56.459],
              [12.766, 56.461],
              [12.76, 56.463],
              [12.753, 56.465],
              [12.746, 56.466],
              [12.74, 56.468],
              [12.733, 56.468],
              [12.727, 56.469],
              [12.721, 56.469],
              [12.714, 56.468],
              [12.708, 56.468],
              [12.701, 56.466],
              [12.695, 56.464],
              [12.676, 56.457],
              [12.663, 56.453],
              [12.657, 56.451],
              [12.651, 56.448],
              [12.646, 56.445],
              [12.641, 56.441],
              [12.637, 56.438],
              [12.633, 56.434],
              [12.63, 56.429],
              [12.628, 56.425],
              [12.626, 56.42],
              [12.626, 56.411],
              [12.627, 56.407],
              [12.629, 56.402],
              [12.636, 56.395],
              [12.646, 56.389],
              [12.652, 56.387],
              [12.659, 56.384],
              [12.665, 56.382],
              [12.692, 56.375],
              [12.698, 56.372],
              [12.705, 56.37],
              [12.711, 56.368],
              [12.723, 56.362],
              [12.733, 56.354],
              [12.741, 56.344],
              [12.752, 56.327],
              [12.76, 56.317],
              [12.765, 56.312],
              [12.77, 56.308],
              [12.775, 56.305],
              [12.787, 56.299],
              [12.806, 56.291],
              [12.812, 56.288],
              [12.817, 56.285],
              [12.825, 56.279],
              [12.827, 56.275],
              [12.829, 56.272],
              [12.83, 56.268],
              [12.83, 56.264],
              [12.828, 56.259],
              [12.825, 56.255],
              [12.821, 56.25],
              [12.812, 56.241],
              [12.797, 56.229],
              [12.791, 56.226],
              [12.785, 56.224],
              [12.78, 56.223],
              [12.766, 56.223],
              [12.748, 56.226],
              [12.732, 56.227],
              [12.701, 56.227],
              [12.695, 56.229],
              [12.69, 56.231],
              [12.684, 56.234],
              [12.679, 56.238],
              [12.668, 56.245],
              [12.662, 56.249],
              [12.65, 56.255],
              [12.643, 56.258],
              [12.637, 56.26],
              [12.63, 56.262],
              [12.617, 56.267],
              [12.59, 56.274],
              [12.555, 56.284],
              [12.535, 56.289],
              [12.521, 56.293],
              [12.513, 56.294],
              [12.499, 56.297],
              [12.493, 56.298],
              [12.48, 56.299],
              [12.468, 56.3],
              [12.46, 56.3],
              [12.46, 56.299],
              [12.224, 56.118],
              [12.21, 56.115],
              [12.197, 56.112],
              [12.183, 56.108],
              [12.177, 56.106],
              [12.17, 56.103],
              [12.164, 56.101],
              [12.145, 56.093],
              [12.043, 56.047],
              [12.024, 56.038],
              [12.004, 56.03],
              [11.991, 56.025],
              [11.972, 56.017],
              [11.951, 56.01],
              [11.891, 55.989],
              [11.884, 55.986],
              [11.878, 55.984],
              [11.866, 55.978],
              [11.861, 55.975],
              [11.854, 55.968],
              [11.852, 55.964],
              [11.851, 55.96],
              [11.852, 55.957],
              [11.855, 55.953],
              [11.858, 55.95],
              [11.866, 55.946],
              [11.874, 55.944],
              [11.895, 55.944],
              [11.902, 55.945],
              [11.908, 55.946],
              [11.922, 55.948],
              [11.928, 55.95],
              [11.935, 55.952],
              [11.941, 55.954],
              [11.964, 55.961],
              [11.97, 55.963],
              [11.976, 55.964],
              [11.98, 55.965],
              [11.985, 55.966],
              [12.003, 55.966],
              [12.005, 55.965],
              [12.008, 55.964],
              [12.009, 55.964],
              [12.018, 55.957],
              [12.021, 55.954],
              [12.025, 55.949],
              [12.028, 55.945],
              [12.032, 55.94],
              [12.038, 55.928],
              [12.041, 55.923],
              [12.049, 55.902],
              [12.054, 55.892],
              [12.058, 55.882],
              [12.059, 55.878],
              [12.059, 55.869],
              [12.058, 55.866],
              [12.056, 55.862],
              [12.055, 55.858],
              [12.053, 55.854],
              [12.052, 55.851],
              [12.052, 55.844],
              [12.053, 55.84],
              [12.056, 55.836],
              [12.068, 55.816],
              [12.071, 55.81],
              [12.073, 55.805],
              [12.076, 55.799],
              [12.08, 55.789],
              [12.086, 55.777],
              [12.089, 55.772],
              [12.091, 55.767],
              [12.097, 55.751],
              [12.099, 55.746],
              [12.101, 55.742],
              [12.103, 55.739],
              [12.108, 55.731],
              [12.109, 55.729],
              [12.109, 55.724],
              [12.108, 55.72],
              [12.104, 55.71],
              [12.103, 55.706],
              [12.094, 55.697],
              [12.092, 55.694],
              [12.088, 55.689],
              [12.08, 55.681],
              [12.079, 55.678],
              [12.079, 55.676],
              [12.08, 55.674],
              [12.081, 55.668],
              [12.081, 55.664],
              [12.079, 55.662],
              [12.078, 55.66],
              [12.072, 55.658],
              [12.068, 55.658],
              [12.065, 55.659],
              [12.055, 55.664],
              [12.052, 55.666],
              [12.047, 55.668],
              [12.043, 55.669],
              [12.037, 55.67],
              [12.027, 55.671],
              [12.022, 55.672],
              [12.014, 55.674],
              [12.012, 55.676],
              [12.01, 55.68],
              [12.011, 55.681],
              [12.013, 55.682],
              [12.016, 55.683],
              [12.031, 55.683],
              [12.034, 55.684],
              [12.036, 55.685],
              [12.037, 55.686],
              [12.037, 55.687],
              [12.035, 55.689],
              [12.032, 55.691],
              [12.029, 55.692],
              [12.009, 55.697],
              [12.003, 55.7],
              [11.998, 55.7],
              [11.995, 55.699],
              [11.993, 55.698],
              [11.991, 55.696],
              [11.989, 55.693],
              [11.986, 55.685],
              [11.985, 55.683],
              [11.979, 55.679],
              [11.975, 55.677],
              [11.965, 55.674],
              [11.961, 55.671],
              [11.957, 55.669],
              [11.953, 55.666],
              [11.95, 55.664],
              [11.947, 55.661],
              [11.944, 55.66],
              [11.941, 55.658],
              [11.939, 55.658],
              [11.938, 55.659],
              [11.938, 55.662],
              [11.942, 55.67],
              [11.946, 55.674],
              [11.949, 55.679],
              [11.957, 55.69],
              [11.981, 55.72],
              [11.988, 55.727],
              [11.992, 55.729],
              [11.995, 55.73],
              [12.006, 55.73],
              [12.014, 55.728],
              [12.027, 55.728],
              [12.031, 55.729],
              [12.036, 55.731],
              [12.041, 55.732],
              [12.045, 55.734],
              [12.049, 55.735],
              [12.053, 55.737],
              [12.056, 55.74],
              [12.057, 55.743],
              [12.059, 55.751],
              [12.061, 55.763],
              [12.061, 55.767],
              [12.06, 55.771],
              [12.059, 55.774],
              [12.055, 55.789],
              [12.053, 55.795],
              [12.049, 55.8],
              [12.048, 55.802],
              [12.047, 55.805],
              [12.046, 55.811],
              [12.04, 55.829],
              [12.039, 55.831],
              [12.035, 55.838],
              [12.032, 55.842],
              [12.029, 55.845],
              [12.017, 55.856],
              [12.014, 55.859],
              [12.011, 55.863],
              [12.009, 55.867],
              [12.008, 55.871],
              [12.008, 55.876],
              [12.009, 55.88],
              [12.011, 55.884],
              [12.017, 55.895],
              [12.018, 55.898],
              [12.018, 55.901],
              [12.017, 55.903],
              [12.015, 55.906],
              [12.012, 55.908],
              [12.002, 55.912],
              [11.991, 55.916],
              [11.985, 55.918],
              [11.968, 55.925],
              [11.963, 55.928],
              [11.956, 55.93],
              [11.944, 55.932],
              [11.937, 55.933],
              [11.931, 55.934],
              [11.926, 55.934],
              [11.916, 55.932],
              [11.913, 55.93],
              [11.91, 55.927],
              [11.909, 55.923],
              [11.909, 55.919],
              [11.911, 55.914],
              [11.913, 55.908],
              [11.916, 55.903],
              [11.924, 55.891],
              [11.936, 55.874],
              [11.94, 55.868],
              [11.943, 55.863],
              [11.946, 55.857],
              [11.948, 55.852],
              [11.948, 55.842],
              [11.946, 55.838],
              [11.94, 55.83],
              [11.936, 55.826],
              [11.931, 55.824],
              [11.926, 55.821],
              [11.92, 55.819],
              [11.913, 55.817],
              [11.9, 55.814],
              [11.888, 55.81],
              [11.883, 55.807],
              [11.879, 55.803],
              [11.871, 55.793],
              [11.868, 55.787],
              [11.865, 55.782],
              [11.863, 55.776],
              [11.859, 55.765],
              [11.857, 55.761],
              [11.856, 55.756],
              [11.856, 55.752],
              [11.857, 55.748],
              [11.859, 55.742],
              [11.862, 55.737],
              [11.862, 55.731],
              [11.86, 55.728],
              [11.855, 55.72],
              [11.847, 55.707],
              [11.844, 55.702],
              [11.835, 55.69],
              [11.829, 55.686],
              [11.825, 55.683],
              [11.816, 55.676],
              [11.812, 55.672],
              [11.807, 55.669],
              [11.803, 55.666],
              [11.798, 55.664],
              [11.793, 55.663],
              [11.786, 55.663],
              [11.784, 55.664],
              [11.784, 55.666],
              [11.785, 55.668],
              [11.789, 55.672],
              [11.792, 55.674],
              [11.8, 55.678],
              [11.802, 55.68],
              [11.803, 55.682],
              [11.803, 55.685],
              [11.804, 55.687],
              [11.803, 55.689],
              [11.802, 55.693],
              [11.8, 55.697],
              [11.797, 55.702],
              [11.793, 55.706],
              [11.79, 55.71],
              [11.782, 55.718],
              [11.777, 55.72],
              [11.773, 55.722],
              [11.769, 55.723],
              [11.761, 55.724],
              [11.738, 55.724],
              [11.709, 55.721],
              [11.695, 55.72],
              [11.688, 55.719],
              [11.676, 55.719],
              [11.671, 55.72],
              [11.668, 55.721],
              [11.665, 55.724],
              [11.665, 55.726],
              [11.666, 55.728],
              [11.668, 55.73],
              [11.672, 55.731],
              [11.677, 55.733],
              [11.682, 55.734],
              [11.688, 55.735],
              [11.695, 55.736],
              [11.701, 55.737],
              [11.729, 55.74],
              [11.747, 55.743],
              [11.752, 55.745],
              [11.756, 55.746],
              [11.759, 55.748],
              [11.76, 55.75],
              [11.76, 55.752],
              [11.759, 55.754],
              [11.758, 55.757],
              [11.756, 55.759],
              [11.754, 55.762],
              [11.754, 55.77],
              [11.752, 55.774],
              [11.75, 55.777],
              [11.744, 55.783],
              [11.741, 55.785],
              [11.737, 55.787],
              [11.727, 55.789],
              [11.721, 55.79],
              [11.715, 55.789],
              [11.708, 55.788],
              [11.702, 55.787],
              [11.695, 55.785],
              [11.674, 55.78],
              [11.667, 55.778],
              [11.661, 55.777],
              [11.654, 55.776],
              [11.648, 55.775],
              [11.638, 55.775],
              [11.633, 55.776],
              [11.629, 55.777],
              [11.626, 55.778],
              [11.624, 55.78],
              [11.623, 55.782],
              [11.624, 55.784],
              [11.629, 55.789],
              [11.643, 55.797],
              [11.652, 55.803],
              [11.656, 55.805],
              [11.661, 55.808],
              [11.666, 55.81],
              [11.671, 55.811],
              [11.677, 55.811],
              [11.684, 55.812],
              [11.696, 55.811],
              [11.702, 55.812],
              [11.707, 55.812],
              [11.713, 55.813],
              [11.721, 55.817],
              [11.724, 55.819],
              [11.726, 55.822],
              [11.727, 55.826],
              [11.728, 55.828],
              [11.727, 55.832],
              [11.725, 55.838],
              [11.722, 55.843],
              [11.719, 55.847],
              [11.707, 55.859],
              [11.702, 55.863],
              [11.687, 55.874],
              [11.683, 55.877],
              [11.679, 55.881],
              [11.676, 55.885],
              [11.674, 55.89],
              [11.673, 55.894],
              [11.673, 55.898],
              [11.674, 55.902],
              [11.676, 55.905],
              [11.68, 55.908],
              [11.684, 55.909],
              [11.689, 55.91],
              [11.695, 55.91],
              [11.7, 55.909],
              [11.706, 55.908],
              [11.713, 55.907],
              [11.718, 55.906],
              [11.724, 55.905],
              [11.73, 55.906],
              [11.735, 55.907],
              [11.74, 55.909],
              [11.745, 55.912],
              [11.748, 55.915],
              [11.751, 55.919],
              [11.759, 55.932],
              [11.762, 55.936],
              [11.77, 55.944],
              [11.78, 55.953],
              [11.782, 55.956],
              [11.782, 55.961],
              [11.78, 55.964],
              [11.777, 55.967],
              [11.774, 55.968],
              [11.77, 55.969],
              [11.764, 55.969],
              [11.759, 55.968],
              [11.747, 55.964],
              [11.74, 55.962],
              [11.72, 55.956],
              [11.714, 55.954],
              [11.7, 55.95],
              [11.694, 55.948],
              [11.687, 55.947],
              [11.674, 55.945],
              [11.668, 55.944],
              [11.661, 55.943],
              [11.655, 55.942],
              [11.636, 55.942],
              [11.629, 55.943],
              [11.623, 55.945],
              [11.617, 55.946],
              [11.611, 55.948],
              [11.6, 55.952],
              [11.595, 55.954],
              [11.59, 55.955],
              [11.583, 55.956],
              [11.577, 55.957],
              [11.563, 55.957],
              [11.535, 55.955],
              [11.515, 55.955],
              [11.508, 55.956],
              [11.482, 55.959],
              [11.469, 55.961],
              [11.455, 55.962],
              [11.408, 55.966],
              [11.395, 55.967],
              [11.374, 55.97],
              [11.36, 55.974],
              [11.346, 55.977],
              [11.332, 55.982],
              [11.318, 55.986],
              [11.312, 55.988],
              [11.306, 55.991],
              [11.291, 55.998],
              [11.288, 55.999],
              [11.286, 55.999],
              [11.285, 55.997],
              [11.286, 55.995],
              [11.29, 55.989],
              [11.293, 55.985],
              [11.296, 55.982],
              [11.3, 55.979],
            ],
          ],
        ],
      },
      properties: { id: 56, name: 'Kattegatt', latlon: [57.108209, 11.381362] },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [11.051, 54.926],
              [10.723, 54.74],
              [10.407, 54.821],
              [10.051, 54.876],
              [9.893, 54.922],
              [9.766, 54.907],
              [9.768, 54.91],
              [9.769, 54.912],
              [9.769, 54.916],
              [9.768, 54.919],
              [9.761, 54.933],
              [9.759, 54.938],
              [9.754, 54.954],
              [9.752, 54.959],
              [9.746, 54.969],
              [9.743, 54.973],
              [9.735, 54.981],
              [9.73, 54.983],
              [9.724, 54.985],
              [9.718, 54.986],
              [9.712, 54.988],
              [9.7, 54.99],
              [9.693, 54.991],
              [9.687, 54.992],
              [9.681, 54.994],
              [9.674, 54.996],
              [9.662, 55],
              [9.656, 55.003],
              [9.649, 55.005],
              [9.643, 55.008],
              [9.638, 55.011],
              [9.626, 55.017],
              [9.609, 55.029],
              [9.603, 55.032],
              [9.593, 55.036],
              [9.588, 55.037],
              [9.578, 55.037],
              [9.57, 55.035],
              [9.546, 55.028],
              [9.52, 55.022],
              [9.514, 55.02],
              [9.507, 55.019],
              [9.501, 55.018],
              [9.487, 55.016],
              [9.473, 55.016],
              [9.459, 55.018],
              [9.453, 55.019],
              [9.447, 55.021],
              [9.442, 55.022],
              [9.438, 55.025],
              [9.434, 55.027],
              [9.432, 55.03],
              [9.431, 55.033],
              [9.431, 55.036],
              [9.433, 55.038],
              [9.436, 55.04],
              [9.439, 55.041],
              [9.448, 55.043],
              [9.459, 55.045],
              [9.465, 55.045],
              [9.484, 55.047],
              [9.49, 55.048],
              [9.496, 55.048],
              [9.514, 55.054],
              [9.529, 55.063],
              [9.534, 55.067],
              [9.537, 55.07],
              [9.54, 55.074],
              [9.542, 55.078],
              [9.543, 55.083],
              [9.542, 55.087],
              [9.54, 55.091],
              [9.537, 55.095],
              [9.529, 55.101],
              [9.519, 55.107],
              [9.514, 55.109],
              [9.509, 55.112],
              [9.504, 55.113],
              [9.498, 55.115],
              [9.488, 55.117],
              [9.475, 55.118],
              [9.471, 55.12],
              [9.471, 55.121],
              [9.475, 55.125],
              [9.478, 55.126],
              [9.482, 55.127],
              [9.487, 55.128],
              [9.503, 55.132],
              [9.505, 55.133],
              [9.506, 55.135],
              [9.506, 55.145],
              [9.508, 55.153],
              [9.511, 55.157],
              [9.515, 55.16],
              [9.52, 55.164],
              [9.538, 55.173],
              [9.544, 55.175],
              [9.551, 55.178],
              [9.557, 55.181],
              [9.578, 55.187],
              [9.584, 55.189],
              [9.591, 55.19],
              [9.608, 55.19],
              [9.614, 55.189],
              [9.622, 55.187],
              [9.625, 55.185],
              [9.627, 55.184],
              [9.629, 55.182],
              [9.631, 55.181],
              [9.632, 55.18],
              [9.634, 55.179],
              [9.642, 55.179],
              [9.647, 55.18],
              [9.653, 55.181],
              [9.665, 55.185],
              [9.671, 55.188],
              [9.676, 55.191],
              [9.682, 55.195],
              [9.686, 55.199],
              [9.689, 55.203],
              [9.698, 55.218],
              [9.705, 55.228],
              [9.708, 55.233],
              [9.711, 55.242],
              [9.711, 55.25],
              [9.71, 55.254],
              [9.707, 55.258],
              [9.703, 55.262],
              [9.699, 55.265],
              [9.693, 55.268],
              [9.688, 55.27],
              [9.682, 55.273],
              [9.675, 55.275],
              [9.669, 55.276],
              [9.663, 55.278],
              [9.656, 55.279],
              [9.65, 55.28],
              [9.637, 55.28],
              [9.625, 55.278],
              [9.619, 55.276],
              [9.608, 55.272],
              [9.602, 55.27],
              [9.597, 55.268],
              [9.592, 55.265],
              [9.584, 55.26],
              [9.579, 55.257],
              [9.575, 55.255],
              [9.57, 55.253],
              [9.565, 55.252],
              [9.558, 55.251],
              [9.552, 55.25],
              [9.545, 55.249],
              [9.504, 55.249],
              [9.506, 55.249],
              [9.514, 55.251],
              [9.538, 55.252],
              [9.544, 55.252],
              [9.55, 55.253],
              [9.557, 55.254],
              [9.563, 55.255],
              [9.569, 55.257],
              [9.574, 55.259],
              [9.579, 55.262],
              [9.593, 55.269],
              [9.611, 55.276],
              [9.628, 55.284],
              [9.633, 55.286],
              [9.638, 55.287],
              [9.641, 55.288],
              [9.644, 55.288],
              [9.65, 55.289],
              [9.654, 55.289],
              [9.657, 55.29],
              [9.659, 55.292],
              [9.659, 55.293],
              [9.658, 55.296],
              [9.653, 55.301],
              [9.65, 55.303],
              [9.647, 55.306],
              [9.64, 55.309],
              [9.637, 55.311],
              [9.636, 55.313],
              [9.636, 55.316],
              [9.638, 55.322],
              [9.64, 55.326],
              [9.64, 55.333],
              [9.639, 55.337],
              [9.637, 55.341],
              [9.634, 55.344],
              [9.63, 55.347],
              [9.627, 55.35],
              [9.623, 55.353],
              [9.615, 55.358],
              [9.61, 55.363],
              [9.609, 55.367],
              [9.609, 55.371],
              [9.611, 55.38],
              [9.611, 55.39],
              [9.609, 55.4],
              [9.607, 55.405],
              [9.606, 55.409],
              [9.605, 55.414],
              [9.605, 55.418],
              [9.607, 55.421],
              [9.61, 55.424],
              [9.613, 55.426],
              [9.618, 55.429],
              [9.63, 55.433],
              [9.643, 55.437],
              [9.65, 55.439],
              [9.656, 55.441],
              [9.661, 55.444],
              [9.666, 55.446],
              [9.671, 55.449],
              [9.675, 55.452],
              [9.678, 55.455],
              [9.68, 55.458],
              [9.681, 55.462],
              [9.68, 55.465],
              [9.677, 55.469],
              [9.669, 55.475],
              [9.664, 55.479],
              [9.646, 55.488],
              [9.634, 55.492],
              [9.627, 55.494],
              [9.62, 55.495],
              [9.607, 55.495],
              [9.601, 55.494],
              [9.591, 55.492],
              [9.585, 55.491],
              [9.569, 55.491],
              [9.562, 55.49],
              [9.555, 55.49],
              [9.527, 55.487],
              [9.52, 55.486],
              [9.504, 55.486],
              [9.5, 55.487],
              [9.497, 55.488],
              [9.494, 55.488],
              [9.493, 55.489],
              [9.493, 55.491],
              [9.492, 55.491],
              [9.493, 55.492],
              [9.496, 55.493],
              [9.5, 55.495],
              [9.504, 55.496],
              [9.51, 55.497],
              [9.515, 55.498],
              [9.522, 55.498],
              [9.529, 55.499],
              [9.561, 55.499],
              [9.567, 55.5],
              [9.571, 55.501],
              [9.574, 55.502],
              [9.575, 55.505],
              [9.573, 55.509],
              [9.571, 55.511],
              [9.571, 55.513],
              [9.575, 55.515],
              [9.576, 55.516],
              [9.578, 55.517],
              [9.578, 55.52],
              [9.579, 55.521],
              [9.58, 55.521],
              [9.582, 55.522],
              [9.586, 55.521],
              [9.589, 55.521],
              [9.594, 55.52],
              [9.598, 55.519],
              [9.61, 55.515],
              [9.616, 55.514],
              [9.621, 55.513],
              [9.633, 55.513],
              [9.651, 55.516],
              [9.663, 55.519],
              [9.669, 55.521],
              [9.681, 55.523],
              [9.718, 55.523],
              [9.723, 55.524],
              [9.727, 55.525],
              [9.731, 55.527],
              [9.733, 55.53],
              [9.734, 55.533],
              [9.735, 55.541],
              [9.737, 55.545],
              [9.738, 55.548],
              [9.744, 55.554],
              [9.752, 55.558],
              [9.761, 55.561],
              [9.766, 55.564],
              [9.77, 55.567],
              [9.775, 55.57],
              [9.788, 55.583],
              [9.803, 55.595],
              [9.809, 55.599],
              [9.814, 55.602],
              [9.835, 55.614],
              [9.843, 55.618],
              [9.845, 55.62],
              [9.846, 55.622],
              [9.844, 55.623],
              [9.841, 55.624],
              [9.799, 55.624],
              [9.792, 55.625],
              [9.785, 55.625],
              [9.779, 55.626],
              [9.772, 55.627],
              [9.766, 55.629],
              [9.761, 55.631],
              [9.756, 55.634],
              [9.751, 55.638],
              [9.738, 55.65],
              [9.734, 55.654],
              [9.728, 55.657],
              [9.723, 55.66],
              [9.699, 55.672],
              [9.694, 55.675],
              [9.683, 55.681],
              [9.671, 55.687],
              [9.659, 55.691],
              [9.653, 55.692],
              [9.646, 55.692],
              [9.64, 55.693],
              [9.592, 55.693],
              [9.574, 55.696],
              [9.564, 55.7],
              [9.56, 55.701],
              [9.557, 55.704],
              [9.558, 55.705],
              [9.561, 55.706],
              [9.565, 55.707],
              [9.571, 55.707],
              [9.576, 55.708],
              [9.589, 55.708],
              [9.603, 55.709],
              [9.632, 55.71],
              [9.674, 55.71],
              [9.681, 55.709],
              [9.687, 55.708],
              [9.694, 55.706],
              [9.701, 55.705],
              [9.708, 55.702],
              [9.714, 55.7],
              [9.736, 55.689],
              [9.754, 55.683],
              [9.761, 55.681],
              [9.767, 55.68],
              [9.774, 55.679],
              [9.8, 55.676],
              [9.813, 55.674],
              [9.832, 55.674],
              [9.846, 55.676],
              [9.86, 55.679],
              [9.887, 55.685],
              [9.901, 55.688],
              [9.916, 55.691],
              [9.922, 55.692],
              [9.936, 55.694],
              [9.949, 55.695],
              [9.963, 55.697],
              [10.006, 55.701],
              [10.01, 55.701],
              [10.016, 55.703],
              [10.018, 55.704],
              [10.019, 55.706],
              [10.019, 55.708],
              [10.018, 55.71],
              [10.017, 55.713],
              [10.013, 55.718],
              [10.013, 55.723],
              [10.014, 55.725],
              [10.017, 55.727],
              [10.021, 55.73],
              [10.026, 55.732],
              [10.048, 55.74],
              [10.063, 55.745],
              [10.066, 55.747],
              [10.067, 55.748],
              [10.067, 55.749],
              [10.066, 55.75],
              [10.063, 55.752],
              [10.06, 55.753],
              [10.05, 55.756],
              [10.045, 55.757],
              [10.04, 55.759],
              [10.036, 55.762],
              [10.033, 55.764],
              [10.031, 55.766],
              [10.029, 55.769],
              [10.028, 55.772],
              [10.028, 55.775],
              [10.029, 55.778],
              [10.031, 55.782],
              [10.034, 55.786],
              [10.049, 55.801],
              [10.052, 55.805],
              [10.053, 55.809],
              [10.051, 55.815],
              [10.048, 55.818],
              [10.044, 55.82],
              [10.028, 55.824],
              [10.025, 55.825],
              [10.022, 55.827],
              [10.019, 55.832],
              [10.016, 55.833],
              [10.01, 55.833],
              [9.998, 55.83],
              [9.979, 55.83],
              [9.973, 55.831],
              [9.966, 55.831],
              [9.953, 55.833],
              [9.932, 55.836],
              [9.911, 55.84],
              [9.898, 55.842],
              [9.892, 55.844],
              [9.886, 55.845],
              [9.876, 55.848],
              [9.872, 55.85],
              [9.869, 55.851],
              [9.867, 55.852],
              [9.867, 55.853],
              [9.868, 55.854],
              [9.869, 55.854],
              [9.869, 55.855],
              [9.868, 55.856],
              [9.868, 55.857],
              [9.869, 55.858],
              [9.871, 55.858],
              [9.873, 55.859],
              [9.884, 55.861],
              [9.889, 55.862],
              [9.904, 55.862],
              [9.916, 55.86],
              [9.942, 55.86],
              [9.949, 55.861],
              [9.955, 55.863],
              [9.96, 55.865],
              [9.964, 55.867],
              [9.971, 55.871],
              [9.975, 55.873],
              [9.981, 55.875],
              [9.986, 55.876],
              [9.992, 55.877],
              [9.998, 55.877],
              [10.005, 55.878],
              [10.038, 55.878],
              [10.051, 55.88],
              [10.07, 55.882],
              [10.095, 55.882],
              [10.107, 55.88],
              [10.111, 55.878],
              [10.119, 55.876],
              [10.128, 55.873],
              [10.136, 55.869],
              [10.147, 55.859],
              [10.162, 55.85],
              [10.168, 55.848],
              [10.173, 55.846],
              [10.178, 55.845],
              [10.183, 55.845],
              [10.187, 55.846],
              [10.189, 55.847],
              [10.191, 55.85],
              [10.193, 55.852],
              [10.195, 55.856],
              [10.197, 55.861],
              [10.199, 55.865],
              [10.2, 55.873],
              [10.201, 55.877],
              [10.203, 55.881],
              [10.21, 55.888],
              [10.214, 55.891],
              [10.219, 55.894],
              [10.236, 55.903],
              [10.246, 55.909],
              [10.251, 55.913],
              [10.254, 55.917],
              [10.257, 55.922],
              [10.26, 55.928],
              [10.261, 55.934],
              [10.263, 55.94],
              [10.263, 55.946],
              [10.264, 55.953],
              [10.264, 55.959],
              [10.263, 55.966],
              [10.262, 55.978],
              [10.262, 55.99],
              [10.263, 55.995],
              [10.265, 56],
              [10.269, 56.012],
              [10.268, 56.015],
              [10.267, 56.016],
              [10.265, 56.017],
              [10.262, 56.018],
              [10.258, 56.017],
              [10.254, 56.017],
              [10.24, 56.014],
              [10.236, 56.013],
              [10.231, 56.013],
              [10.23, 56.014],
              [10.231, 56.015],
              [10.233, 56.016],
              [10.236, 56.018],
              [10.241, 56.02],
              [10.253, 56.026],
              [10.256, 56.028],
              [10.262, 56.034],
              [10.264, 56.042],
              [10.264, 56.048],
              [10.263, 56.054],
              [10.261, 56.06],
              [10.259, 56.067],
              [10.253, 56.079],
              [10.25, 56.086],
              [10.246, 56.092],
              [10.243, 56.097],
              [10.232, 56.112],
              [10.229, 56.117],
              [10.226, 56.121],
              [10.224, 56.125],
              [10.223, 56.129],
              [10.223, 56.133],
              [10.224, 56.136],
              [10.23, 56.142],
              [10.237, 56.146],
              [10.239, 56.148],
              [10.24, 56.15],
              [10.24, 56.151],
              [10.237, 56.151],
              [10.229, 56.15],
              [10.228, 56.15],
              [10.226, 56.151],
              [10.223, 56.154],
              [10.222, 56.154],
              [10.221, 56.155],
              [10.222, 56.158],
              [10.226, 56.164],
              [10.229, 56.168],
              [10.241, 56.18],
              [10.246, 56.183],
              [10.251, 56.187],
              [10.256, 56.19],
              [10.273, 56.199],
              [10.278, 56.203],
              [10.284, 56.206],
              [10.301, 56.219],
              [10.307, 56.222],
              [10.312, 56.226],
              [10.323, 56.232],
              [10.333, 56.238],
              [10.347, 56.252],
              [10.351, 56.257],
              [10.353, 56.26],
              [10.357, 56.264],
              [10.361, 56.267],
              [10.365, 56.269],
              [10.379, 56.278],
              [10.383, 56.281],
              [10.386, 56.283],
              [10.39, 56.286],
              [10.395, 56.288],
              [10.4, 56.289],
              [10.406, 56.291],
              [10.412, 56.292],
              [10.419, 56.292],
              [10.425, 56.293],
              [10.431, 56.293],
              [10.438, 56.292],
              [10.443, 56.292],
              [10.449, 56.29],
              [10.453, 56.288],
              [10.457, 56.287],
              [10.469, 56.281],
              [10.474, 56.279],
              [10.477, 56.278],
              [10.483, 56.277],
              [10.485, 56.276],
              [10.488, 56.275],
              [10.491, 56.273],
              [10.493, 56.272],
              [10.495, 56.269],
              [10.495, 56.267],
              [10.494, 56.265],
              [10.491, 56.262],
              [10.48, 56.254],
              [10.468, 56.242],
              [10.465, 56.238],
              [10.462, 56.235],
              [10.461, 56.231],
              [10.462, 56.228],
              [10.464, 56.226],
              [10.466, 56.223],
              [10.467, 56.219],
              [10.469, 56.216],
              [10.469, 56.213],
              [10.468, 56.21],
              [10.467, 56.208],
              [10.461, 56.204],
              [10.458, 56.203],
              [10.449, 56.203],
              [10.445, 56.204],
              [10.442, 56.205],
              [10.438, 56.207],
              [10.43, 56.215],
              [10.428, 56.216],
              [10.419, 56.216],
              [10.414, 56.215],
              [10.41, 56.214],
              [10.402, 56.211],
              [10.396, 56.21],
              [10.372, 56.204],
              [10.367, 56.202],
              [10.363, 56.201],
              [10.36, 56.198],
              [10.358, 56.197],
              [10.358, 56.194],
              [10.359, 56.191],
              [10.366, 56.184],
              [10.378, 56.175],
              [10.382, 56.173],
              [10.387, 56.171],
              [10.393, 56.169],
              [10.405, 56.167],
              [10.411, 56.167],
              [10.418, 56.168],
              [10.423, 56.169],
              [10.429, 56.17],
              [10.441, 56.173],
              [10.447, 56.175],
              [10.453, 56.176],
              [10.466, 56.176],
              [10.487, 56.173],
              [10.499, 56.171],
              [10.504, 56.169],
              [10.508, 56.168],
              [10.511, 56.166],
              [10.515, 56.162],
              [10.514, 56.158],
              [10.513, 56.155],
              [10.511, 56.152],
              [10.508, 56.149],
              [10.501, 56.144],
              [10.497, 56.141],
              [10.495, 56.138],
              [10.494, 56.135],
              [10.494, 56.131],
              [10.495, 56.126],
              [10.497, 56.121],
              [10.499, 56.117],
              [10.503, 56.112],
              [10.507, 56.108],
              [10.511, 56.105],
              [10.516, 56.102],
              [10.521, 56.101],
              [10.526, 56.101],
              [10.531, 56.102],
              [10.541, 56.106],
              [10.544, 56.109],
              [10.546, 56.112],
              [10.548, 56.116],
              [10.55, 56.121],
              [10.551, 56.126],
              [10.55, 56.132],
              [10.55, 56.137],
              [10.548, 56.143],
              [10.545, 56.153],
              [10.543, 56.163],
              [10.543, 56.168],
              [10.544, 56.172],
              [10.546, 56.177],
              [10.548, 56.181],
              [10.552, 56.186],
              [10.556, 56.19],
              [10.56, 56.195],
              [10.575, 56.207],
              [10.587, 56.215],
              [10.592, 56.218],
              [10.598, 56.221],
              [10.61, 56.225],
              [10.616, 56.226],
              [10.634, 56.226],
              [10.64, 56.225],
              [10.646, 56.223],
              [10.651, 56.221],
              [10.655, 56.219],
              [10.659, 56.216],
              [10.663, 56.212],
              [10.665, 56.208],
              [10.666, 56.204],
              [10.666, 56.201],
              [10.664, 56.197],
              [10.663, 56.194],
              [10.66, 56.191],
              [10.657, 56.189],
              [10.654, 56.186],
              [10.651, 56.184],
              [10.649, 56.181],
              [10.648, 56.178],
              [10.648, 56.174],
              [10.65, 56.17],
              [10.652, 56.167],
              [10.658, 56.161],
              [10.661, 56.159],
              [10.669, 56.154],
              [10.673, 56.153],
              [10.68, 56.151],
              [10.683, 56.15],
              [10.688, 56.147],
              [10.69, 56.146],
              [10.693, 56.145],
              [10.702, 56.145],
              [10.706, 56.146],
              [10.711, 56.149],
              [10.716, 56.151],
              [10.72, 56.155],
              [10.723, 56.16],
              [10.727, 56.164],
              [11.3, 55.979],
              [11.305, 55.976],
              [11.31, 55.974],
              [11.316, 55.972],
              [11.34, 55.966],
              [11.365, 55.959],
              [11.371, 55.957],
              [11.377, 55.956],
              [11.391, 55.954],
              [11.397, 55.953],
              [11.411, 55.952],
              [11.432, 55.951],
              [11.445, 55.95],
              [11.459, 55.948],
              [11.465, 55.947],
              [11.472, 55.946],
              [11.479, 55.944],
              [11.485, 55.942],
              [11.492, 55.939],
              [11.498, 55.937],
              [11.503, 55.934],
              [11.509, 55.93],
              [11.517, 55.922],
              [11.519, 55.916],
              [11.522, 55.911],
              [11.523, 55.905],
              [11.525, 55.9],
              [11.525, 55.895],
              [11.526, 55.89],
              [11.525, 55.885],
              [11.525, 55.883],
              [11.524, 55.88],
              [11.522, 55.878],
              [11.52, 55.875],
              [11.516, 55.872],
              [11.508, 55.864],
              [11.503, 55.861],
              [11.498, 55.857],
              [11.493, 55.854],
              [11.488, 55.852],
              [11.476, 55.848],
              [11.469, 55.847],
              [11.449, 55.845],
              [11.443, 55.844],
              [11.417, 55.839],
              [11.399, 55.836],
              [11.388, 55.836],
              [11.378, 55.837],
              [11.375, 55.837],
              [11.372, 55.836],
              [11.37, 55.835],
              [11.37, 55.829],
              [11.373, 55.82],
              [11.375, 55.815],
              [11.375, 55.809],
              [11.376, 55.803],
              [11.376, 55.798],
              [11.374, 55.786],
              [11.372, 55.781],
              [11.37, 55.777],
              [11.362, 55.769],
              [11.347, 55.76],
              [11.341, 55.758],
              [11.336, 55.757],
              [11.33, 55.755],
              [11.32, 55.753],
              [11.311, 55.751],
              [11.308, 55.75],
              [11.295, 55.75],
              [11.293, 55.749],
              [11.29, 55.748],
              [11.285, 55.744],
              [11.281, 55.742],
              [11.271, 55.738],
              [11.265, 55.736],
              [11.261, 55.735],
              [11.253, 55.735],
              [11.247, 55.736],
              [11.236, 55.738],
              [11.23, 55.739],
              [11.22, 55.739],
              [11.211, 55.738],
              [11.203, 55.738],
              [11.198, 55.739],
              [11.194, 55.741],
              [11.174, 55.749],
              [11.156, 55.752],
              [11.149, 55.752],
              [11.142, 55.751],
              [11.136, 55.751],
              [11.129, 55.75],
              [11.122, 55.748],
              [11.116, 55.747],
              [11.096, 55.741],
              [11.089, 55.739],
              [11.082, 55.738],
              [11.076, 55.736],
              [11.07, 55.735],
              [11.064, 55.735],
              [11.058, 55.734],
              [11.045, 55.734],
              [11.038, 55.735],
              [11.031, 55.735],
              [11.017, 55.737],
              [10.982, 55.744],
              [10.954, 55.748],
              [10.926, 55.748],
              [10.913, 55.747],
              [10.901, 55.746],
              [10.895, 55.746],
              [10.891, 55.745],
              [10.886, 55.744],
              [10.884, 55.743],
              [10.883, 55.742],
              [10.883, 55.741],
              [10.889, 55.737],
              [10.894, 55.736],
              [10.899, 55.734],
              [10.905, 55.733],
              [10.91, 55.731],
              [10.917, 55.73],
              [10.923, 55.729],
              [10.93, 55.729],
              [10.958, 55.727],
              [10.965, 55.726],
              [10.971, 55.725],
              [10.985, 55.723],
              [10.991, 55.72],
              [10.998, 55.718],
              [11.004, 55.714],
              [11.01, 55.711],
              [11.017, 55.708],
              [11.041, 55.693],
              [11.053, 55.686],
              [11.058, 55.683],
              [11.073, 55.677],
              [11.076, 55.677],
              [11.082, 55.676],
              [11.086, 55.676],
              [11.092, 55.674],
              [11.094, 55.673],
              [11.096, 55.671],
              [11.096, 55.67],
              [11.095, 55.668],
              [11.093, 55.667],
              [11.089, 55.666],
              [11.083, 55.665],
              [11.076, 55.664],
              [11.044, 55.664],
              [11.033, 55.665],
              [11.005, 55.668],
              [10.985, 55.67],
              [10.976, 55.67],
              [10.967, 55.671],
              [10.954, 55.671],
              [10.949, 55.67],
              [10.946, 55.669],
              [10.944, 55.668],
              [10.944, 55.665],
              [10.946, 55.664],
              [10.948, 55.662],
              [10.953, 55.661],
              [10.958, 55.659],
              [10.976, 55.656],
              [11.011, 55.652],
              [11.039, 55.648],
              [11.045, 55.646],
              [11.052, 55.645],
              [11.059, 55.643],
              [11.085, 55.633],
              [11.092, 55.631],
              [11.104, 55.625],
              [11.11, 55.621],
              [11.116, 55.618],
              [11.121, 55.614],
              [11.126, 55.609],
              [11.131, 55.605],
              [11.136, 55.6],
              [11.144, 55.59],
              [11.147, 55.585],
              [11.151, 55.575],
              [11.152, 55.57],
              [11.152, 55.565],
              [11.151, 55.56],
              [11.15, 55.556],
              [11.148, 55.552],
              [11.145, 55.548],
              [11.142, 55.545],
              [11.139, 55.543],
              [11.135, 55.541],
              [11.13, 55.538],
              [11.123, 55.536],
              [11.106, 55.532],
              [11.096, 55.528],
              [11.093, 55.526],
              [11.092, 55.523],
              [11.092, 55.521],
              [11.094, 55.519],
              [11.097, 55.518],
              [11.105, 55.518],
              [11.109, 55.519],
              [11.116, 55.521],
              [11.124, 55.523],
              [11.134, 55.521],
              [11.139, 55.519],
              [11.154, 55.51],
              [11.164, 55.502],
              [11.172, 55.492],
              [11.175, 55.488],
              [11.181, 55.478],
              [11.188, 55.466],
              [11.192, 55.461],
              [11.195, 55.455],
              [11.199, 55.443],
              [11.2, 55.437],
              [11.201, 55.425],
              [11.205, 55.405],
              [11.206, 55.401],
              [11.204, 55.393],
              [11.201, 55.389],
              [11.198, 55.386],
              [11.188, 55.38],
              [11.182, 55.378],
              [11.176, 55.375],
              [11.17, 55.373],
              [11.163, 55.372],
              [11.156, 55.37],
              [11.15, 55.369],
              [11.143, 55.367],
              [11.124, 55.364],
              [11.119, 55.363],
              [11.116, 55.362],
              [11.108, 55.358],
              [11.106, 55.356],
              [11.104, 55.35],
              [11.106, 55.348],
              [11.108, 55.347],
              [11.11, 55.345],
              [11.118, 55.341],
              [11.128, 55.337],
              [11.144, 55.337],
              [11.148, 55.338],
              [11.153, 55.339],
              [11.156, 55.341],
              [11.164, 55.345],
              [11.167, 55.347],
              [11.171, 55.348],
              [11.18, 55.348],
              [11.184, 55.347],
              [11.188, 55.345],
              [11.191, 55.344],
              [11.192, 55.342],
              [11.191, 55.339],
              [11.189, 55.336],
              [11.185, 55.334],
              [11.18, 55.332],
              [11.17, 55.33],
              [11.164, 55.33],
              [11.148, 55.329],
              [11.144, 55.328],
              [11.141, 55.328],
              [11.14, 55.327],
              [11.14, 55.325],
              [11.142, 55.323],
              [11.145, 55.321],
              [11.155, 55.315],
              [11.161, 55.313],
              [11.174, 55.307],
              [11.193, 55.3],
              [11.2, 55.297],
              [11.206, 55.295],
              [11.218, 55.289],
              [11.228, 55.281],
              [11.232, 55.277],
              [11.235, 55.272],
              [11.241, 55.263],
              [11.244, 55.258],
              [11.25, 55.252],
              [11.253, 55.25],
              [11.257, 55.249],
              [11.26, 55.247],
              [11.264, 55.246],
              [11.267, 55.245],
              [11.28, 55.245],
              [11.278, 55.243],
              [11.274, 55.241],
              [11.27, 55.24],
              [11.265, 55.24],
              [11.256, 55.239],
              [11.252, 55.239],
              [11.248, 55.238],
              [11.245, 55.237],
              [11.244, 55.234],
              [11.244, 55.228],
              [11.245, 55.221],
              [11.246, 55.217],
              [11.248, 55.213],
              [11.255, 55.206],
              [11.26, 55.203],
              [11.272, 55.199],
              [11.279, 55.197],
              [11.285, 55.196],
              [11.292, 55.195],
              [11.3, 55.194],
              [11.321, 55.192],
              [11.347, 55.189],
              [11.361, 55.189],
              [11.36, 55.19],
              [11.358, 55.19],
              [11.355, 55.191],
              [11.341, 55.194],
              [11.336, 55.195],
              [11.332, 55.197],
              [11.329, 55.199],
              [11.327, 55.2],
              [11.327, 55.203],
              [11.329, 55.204],
              [11.332, 55.205],
              [11.338, 55.204],
              [11.347, 55.205],
              [11.351, 55.205],
              [11.363, 55.204],
              [11.374, 55.204],
              [11.38, 55.205],
              [11.385, 55.206],
              [11.396, 55.207],
              [11.412, 55.21],
              [11.417, 55.211],
              [11.429, 55.213],
              [11.434, 55.214],
              [11.449, 55.214],
              [11.454, 55.213],
              [11.459, 55.211],
              [11.469, 55.208],
              [11.473, 55.207],
              [11.483, 55.204],
              [11.494, 55.201],
              [11.5, 55.199],
              [11.507, 55.198],
              [11.513, 55.197],
              [11.527, 55.195],
              [11.562, 55.192],
              [11.575, 55.191],
              [11.596, 55.188],
              [11.62, 55.183],
              [11.625, 55.182],
              [11.631, 55.181],
              [11.637, 55.181],
              [11.643, 55.182],
              [11.648, 55.183],
              [11.654, 55.185],
              [11.659, 55.188],
              [11.67, 55.194],
              [11.682, 55.2],
              [11.688, 55.202],
              [11.695, 55.205],
              [11.708, 55.209],
              [11.733, 55.216],
              [11.745, 55.22],
              [11.745, 55.219],
              [11.735, 55.214],
              [11.732, 55.212],
              [11.729, 55.209],
              [11.729, 55.207],
              [11.73, 55.205],
              [11.732, 55.204],
              [11.735, 55.203],
              [11.737, 55.202],
              [11.74, 55.201],
              [11.741, 55.201],
              [11.741, 55.198],
              [11.739, 55.194],
              [11.735, 55.19],
              [11.733, 55.186],
              [11.732, 55.183],
              [11.732, 55.181],
              [11.73, 55.177],
              [11.726, 55.172],
              [11.725, 55.169],
              [11.724, 55.167],
              [11.724, 55.165],
              [11.725, 55.162],
              [11.727, 55.16],
              [11.731, 55.158],
              [11.736, 55.156],
              [11.741, 55.155],
              [11.747, 55.155],
              [11.765, 55.154],
              [11.77, 55.153],
              [11.781, 55.151],
              [11.79, 55.15],
              [11.795, 55.149],
              [11.798, 55.148],
              [11.802, 55.147],
              [11.806, 55.143],
              [11.807, 55.14],
              [11.806, 55.138],
              [11.804, 55.136],
              [11.801, 55.135],
              [11.796, 55.133],
              [11.764, 55.125],
              [11.759, 55.123],
              [11.753, 55.122],
              [11.748, 55.121],
              [11.738, 55.12],
              [11.734, 55.12],
              [11.73, 55.118],
              [11.729, 55.117],
              [11.729, 55.112],
              [11.73, 55.109],
              [11.732, 55.106],
              [11.735, 55.103],
              [11.738, 55.101],
              [11.741, 55.098],
              [11.748, 55.094],
              [11.751, 55.092],
              [11.753, 55.09],
              [11.755, 55.087],
              [11.757, 55.085],
              [11.76, 55.083],
              [11.762, 55.082],
              [11.768, 55.08],
              [11.781, 55.08],
              [11.789, 55.078],
              [11.793, 55.076],
              [11.798, 55.074],
              [11.802, 55.072],
              [11.807, 55.069],
              [11.811, 55.066],
              [11.814, 55.063],
              [11.817, 55.059],
              [11.819, 55.056],
              [11.82, 55.054],
              [11.82, 55.052],
              [11.818, 55.051],
              [11.815, 55.05],
              [11.81, 55.05],
              [11.8, 55.052],
              [11.794, 55.053],
              [11.754, 55.062],
              [11.748, 55.063],
              [11.733, 55.066],
              [11.691, 55.072],
              [11.644, 55.078],
              [11.635, 55.079],
              [11.631, 55.079],
              [11.635, 55.078],
              [11.644, 55.077],
              [11.672, 55.073],
              [11.679, 55.071],
              [11.693, 55.068],
              [11.714, 55.063],
              [11.762, 55.051],
              [11.782, 55.045],
              [11.796, 55.041],
              [11.802, 55.039],
              [11.809, 55.036],
              [11.815, 55.034],
              [11.867, 55.01],
              [11.879, 55.004],
              [11.891, 55],
              [11.897, 54.999],
              [11.9, 54.998],
              [11.912, 54.998],
              [11.919, 55],
              [11.923, 55],
              [11.928, 54.999],
              [11.933, 54.999],
              [11.939, 54.998],
              [11.945, 54.996],
              [11.95, 54.994],
              [11.956, 54.992],
              [11.986, 54.977],
              [11.993, 54.974],
              [12.005, 54.97],
              [12.012, 54.968],
              [12.018, 54.967],
              [12.025, 54.966],
              [12.032, 54.966],
              [12.038, 54.965],
              [12.045, 54.966],
              [12.052, 54.966],
              [12.058, 54.968],
              [12.065, 54.97],
              [12.071, 54.972],
              [12.078, 54.974],
              [12.097, 54.982],
              [12.104, 54.984],
              [12.11, 54.987],
              [12.117, 54.989],
              [12.123, 54.991],
              [12.13, 54.992],
              [12.148, 54.995],
              [12.153, 54.996],
              [12.157, 54.998],
              [12.159, 55],
              [12.196, 54.934],
              [12.127, 54.873],
              [12.122, 54.877],
              [12.118, 54.881],
              [12.112, 54.884],
              [12.1, 54.888],
              [12.088, 54.89],
              [12.081, 54.891],
              [12.059, 54.891],
              [12.052, 54.892],
              [12.045, 54.892],
              [12.038, 54.893],
              [12.032, 54.894],
              [12.025, 54.895],
              [12.019, 54.897],
              [12.012, 54.898],
              [12.006, 54.901],
              [12, 54.903],
              [11.995, 54.906],
              [11.99, 54.91],
              [11.986, 54.914],
              [11.978, 54.923],
              [11.973, 54.927],
              [11.969, 54.93],
              [11.963, 54.933],
              [11.958, 54.934],
              [11.946, 54.936],
              [11.941, 54.936],
              [11.935, 54.935],
              [11.93, 54.933],
              [11.926, 54.931],
              [11.919, 54.927],
              [11.915, 54.926],
              [11.912, 54.925],
              [11.905, 54.925],
              [11.9, 54.926],
              [11.895, 54.928],
              [11.891, 54.93],
              [11.883, 54.936],
              [11.87, 54.949],
              [11.867, 54.951],
              [11.852, 54.957],
              [11.842, 54.959],
              [11.838, 54.959],
              [11.833, 54.958],
              [11.829, 54.957],
              [11.819, 54.95],
              [11.815, 54.948],
              [11.811, 54.947],
              [11.806, 54.946],
              [11.801, 54.946],
              [11.796, 54.947],
              [11.792, 54.948],
              [11.777, 54.954],
              [11.771, 54.955],
              [11.761, 54.957],
              [11.756, 54.957],
              [11.752, 54.956],
              [11.747, 54.956],
              [11.742, 54.954],
              [11.738, 54.952],
              [11.735, 54.95],
              [11.73, 54.947],
              [11.723, 54.942],
              [11.72, 54.94],
              [11.718, 54.938],
              [11.718, 54.936],
              [11.72, 54.934],
              [11.723, 54.932],
              [11.731, 54.928],
              [11.736, 54.926],
              [11.74, 54.923],
              [11.742, 54.92],
              [11.745, 54.917],
              [11.747, 54.909],
              [11.748, 54.9],
              [11.748, 54.895],
              [11.758, 54.87],
              [11.76, 54.866],
              [11.763, 54.862],
              [11.767, 54.858],
              [11.771, 54.855],
              [11.776, 54.852],
              [11.786, 54.848],
              [11.791, 54.845],
              [11.795, 54.842],
              [11.798, 54.839],
              [11.804, 54.83],
              [11.805, 54.827],
              [11.806, 54.823],
              [11.806, 54.816],
              [11.807, 54.812],
              [11.809, 54.809],
              [11.812, 54.806],
              [11.817, 54.802],
              [11.823, 54.798],
              [11.805, 54.796],
              [11.804, 54.797],
              [11.799, 54.801],
              [11.795, 54.805],
              [11.792, 54.81],
              [11.79, 54.813],
              [11.787, 54.821],
              [11.786, 54.824],
              [11.784, 54.827],
              [11.781, 54.83],
              [11.777, 54.833],
              [11.773, 54.835],
              [11.764, 54.84],
              [11.759, 54.842],
              [11.754, 54.845],
              [11.751, 54.848],
              [11.748, 54.852],
              [11.742, 54.858],
              [11.737, 54.865],
              [11.735, 54.868],
              [11.731, 54.871],
              [11.726, 54.873],
              [11.71, 54.879],
              [11.704, 54.882],
              [11.685, 54.89],
              [11.679, 54.892],
              [11.672, 54.895],
              [11.667, 54.896],
              [11.661, 54.898],
              [11.65, 54.898],
              [11.647, 54.895],
              [11.646, 54.892],
              [11.646, 54.877],
              [11.644, 54.869],
              [11.642, 54.865],
              [11.638, 54.862],
              [11.633, 54.859],
              [11.628, 54.857],
              [11.616, 54.853],
              [11.609, 54.853],
              [11.603, 54.852],
              [11.59, 54.852],
              [11.585, 54.851],
              [11.577, 54.849],
              [11.575, 54.847],
              [11.574, 54.845],
              [11.574, 54.842],
              [11.576, 54.839],
              [11.588, 54.83],
              [11.599, 54.823],
              [11.622, 54.809],
              [11.616, 54.812],
              [11.615, 54.813],
              [11.609, 54.816],
              [11.604, 54.817],
              [11.598, 54.819],
              [11.591, 54.821],
              [11.583, 54.822],
              [11.574, 54.823],
              [11.543, 54.827],
              [11.522, 54.83],
              [11.509, 54.832],
              [11.502, 54.834],
              [11.496, 54.835],
              [11.484, 54.839],
              [11.479, 54.842],
              [11.474, 54.844],
              [11.462, 54.853],
              [11.459, 54.856],
              [11.454, 54.858],
              [11.45, 54.86],
              [11.44, 54.863],
              [11.435, 54.865],
              [11.427, 54.869],
              [11.422, 54.871],
              [11.399, 54.88],
              [11.393, 54.882],
              [11.388, 54.885],
              [11.378, 54.89],
              [11.37, 54.896],
              [11.355, 54.911],
              [11.35, 54.914],
              [11.338, 54.92],
              [11.326, 54.925],
              [11.32, 54.928],
              [11.315, 54.931],
              [11.294, 54.943],
              [11.289, 54.946],
              [11.283, 54.948],
              [11.277, 54.951],
              [11.27, 54.952],
              [11.263, 54.954],
              [11.242, 54.957],
              [11.214, 54.959],
              [11.186, 54.959],
              [11.179, 54.958],
              [11.153, 54.954],
              [11.141, 54.952],
              [11.135, 54.95],
              [11.129, 54.949],
              [11.119, 54.945],
              [11.116, 54.944],
              [11.114, 54.943],
              [11.112, 54.941],
              [11.11, 54.94],
              [11.096, 54.94],
              [11.091, 54.939],
              [11.085, 54.939],
              [11.079, 54.938],
              [11.073, 54.936],
              [11.068, 54.934],
              [11.062, 54.932],
              [11.056, 54.929],
              [11.051, 54.926],
            ],
          ],
        ],
      },
      properties: { id: 54, name: 'Bälten', latlon: [55.461105, 10.922087] },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [12.951, 55.405],
              [12.45, 55.309],
              [12.45, 55.319],
              [12.448, 55.329],
              [12.446, 55.334],
              [12.443, 55.34],
              [12.44, 55.345],
              [12.436, 55.35],
              [12.422, 55.364],
              [12.416, 55.368],
              [12.411, 55.372],
              [12.405, 55.375],
              [12.4, 55.379],
              [12.382, 55.388],
              [12.364, 55.394],
              [12.357, 55.396],
              [12.351, 55.397],
              [12.337, 55.399],
              [12.317, 55.401],
              [12.296, 55.404],
              [12.29, 55.405],
              [12.283, 55.407],
              [12.277, 55.408],
              [12.251, 55.416],
              [12.239, 55.42],
              [12.233, 55.423],
              [12.227, 55.425],
              [12.221, 55.429],
              [12.216, 55.432],
              [12.206, 55.44],
              [12.203, 55.444],
              [12.197, 55.45],
              [12.196, 55.453],
              [12.196, 55.457],
              [12.198, 55.465],
              [12.199, 55.473],
              [12.201, 55.481],
              [12.207, 55.495],
              [12.208, 55.497],
              [12.207, 55.497],
              [12.204, 55.493],
              [12.203, 55.492],
              [12.202, 55.492],
              [12.202, 55.496],
              [12.203, 55.498],
              [12.207, 55.504],
              [12.208, 55.506],
              [12.21, 55.509],
              [12.217, 55.515],
              [12.227, 55.526],
              [12.231, 55.531],
              [12.235, 55.535],
              [12.24, 55.539],
              [12.244, 55.543],
              [12.249, 55.546],
              [12.254, 55.55],
              [12.26, 55.553],
              [12.266, 55.557],
              [12.272, 55.56],
              [12.279, 55.563],
              [12.292, 55.568],
              [12.305, 55.574],
              [12.338, 55.586],
              [12.354, 55.592],
              [12.364, 55.595],
              [12.369, 55.597],
              [12.373, 55.599],
              [12.378, 55.6],
              [12.384, 55.604],
              [12.387, 55.607],
              [12.386, 55.609],
              [12.386, 55.61],
              [12.388, 55.611],
              [12.389, 55.611],
              [12.392, 55.612],
              [12.399, 55.612],
              [12.405, 55.613],
              [12.41, 55.613],
              [12.417, 55.612],
              [12.423, 55.612],
              [12.43, 55.611],
              [12.442, 55.609],
              [12.45, 55.607],
              [12.457, 55.606],
              [12.469, 55.604],
              [12.475, 55.605],
              [12.481, 55.605],
              [12.486, 55.607],
              [12.492, 55.611],
              [12.497, 55.616],
              [12.5, 55.623],
              [12.502, 55.626],
              [12.505, 55.628],
              [12.507, 55.631],
              [12.51, 55.632],
              [12.512, 55.633],
              [12.532, 55.638],
              [12.534, 55.638],
              [12.542, 55.642],
              [12.547, 55.647],
              [12.552, 55.651],
              [12.555, 55.654],
              [12.56, 55.658],
              [12.564, 55.661],
              [12.577, 55.673],
              [12.586, 55.681],
              [12.59, 55.684],
              [12.592, 55.688],
              [12.595, 55.692],
              [12.596, 55.696],
              [12.599, 55.703],
              [12.6, 55.705],
              [12.603, 55.709],
              [12.605, 55.71],
              [12.606, 55.711],
              [12.613, 55.714],
              [12.618, 55.715],
              [12.621, 55.716],
              [12.623, 55.718],
              [12.625, 55.719],
              [12.625, 55.72],
              [12.624, 55.721],
              [12.606, 55.721],
              [12.598, 55.719],
              [12.595, 55.719],
              [12.592, 55.72],
              [12.59, 55.722],
              [12.589, 55.724],
              [12.588, 55.725],
              [12.587, 55.727],
              [12.587, 55.73],
              [12.588, 55.733],
              [12.589, 55.737],
              [12.593, 55.751],
              [12.595, 55.756],
              [12.596, 55.761],
              [12.596, 55.768],
              [12.594, 55.78],
              [12.592, 55.787],
              [12.588, 55.797],
              [12.583, 55.808],
              [12.581, 55.814],
              [12.578, 55.82],
              [12.574, 55.834],
              [12.572, 55.84],
              [12.569, 55.847],
              [12.566, 55.853],
              [12.558, 55.865],
              [12.555, 55.87],
              [12.542, 55.887],
              [12.538, 55.893],
              [12.535, 55.898],
              [12.531, 55.904],
              [12.529, 55.91],
              [12.527, 55.915],
              [12.526, 55.921],
              [12.526, 55.927],
              [12.527, 55.933],
              [12.529, 55.938],
              [12.531, 55.944],
              [12.537, 55.956],
              [12.541, 55.962],
              [12.544, 55.967],
              [12.548, 55.973],
              [12.552, 55.978],
              [12.557, 55.983],
              [12.561, 55.988],
              [12.567, 55.993],
              [12.572, 55.998],
              [12.577, 56.002],
              [12.593, 56.015],
              [12.598, 56.019],
              [12.606, 56.027],
              [12.609, 56.031],
              [12.611, 56.035],
              [12.612, 56.038],
              [12.61, 56.041],
              [12.608, 56.045],
              [12.604, 56.048],
              [12.599, 56.051],
              [12.593, 56.054],
              [12.588, 56.057],
              [12.582, 56.059],
              [12.569, 56.065],
              [12.556, 56.07],
              [12.543, 56.076],
              [12.53, 56.081],
              [12.516, 56.085],
              [12.51, 56.086],
              [12.503, 56.088],
              [12.489, 56.09],
              [12.476, 56.091],
              [12.428, 56.096],
              [12.415, 56.098],
              [12.408, 56.099],
              [12.402, 56.1],
              [12.388, 56.104],
              [12.382, 56.106],
              [12.375, 56.108],
              [12.355, 56.115],
              [12.349, 56.118],
              [12.342, 56.119],
              [12.328, 56.123],
              [12.307, 56.126],
              [12.3, 56.126],
              [12.293, 56.127],
              [12.279, 56.127],
              [12.273, 56.126],
              [12.245, 56.122],
              [12.224, 56.118],
              [12.46, 56.299],
              [12.461, 56.299],
              [12.463, 56.297],
              [12.48, 56.288],
              [12.486, 56.285],
              [12.491, 56.282],
              [12.497, 56.278],
              [12.502, 56.274],
              [12.517, 56.259],
              [12.521, 56.254],
              [12.529, 56.242],
              [12.533, 56.232],
              [12.537, 56.221],
              [12.541, 56.211],
              [12.544, 56.205],
              [12.551, 56.194],
              [12.554, 56.189],
              [12.556, 56.183],
              [12.563, 56.166],
              [12.566, 56.16],
              [12.572, 56.15],
              [12.575, 56.146],
              [12.599, 56.122],
              [12.604, 56.118],
              [12.609, 56.113],
              [12.615, 56.109],
              [12.62, 56.105],
              [12.648, 56.085],
              [12.654, 56.081],
              [12.659, 56.076],
              [12.664, 56.072],
              [12.674, 56.062],
              [12.678, 56.057],
              [12.682, 56.051],
              [12.685, 56.046],
              [12.696, 56.028],
              [12.7, 56.022],
              [12.708, 56.012],
              [12.713, 56.008],
              [12.719, 56.004],
              [12.735, 55.992],
              [12.74, 55.988],
              [12.744, 55.984],
              [12.748, 55.979],
              [12.76, 55.959],
              [12.764, 55.954],
              [12.767, 55.949],
              [12.771, 55.945],
              [12.775, 55.94],
              [12.788, 55.926],
              [12.796, 55.916],
              [12.805, 55.901],
              [12.81, 55.89],
              [12.812, 55.885],
              [12.815, 55.881],
              [12.818, 55.876],
              [12.822, 55.873],
              [12.829, 55.866],
              [12.833, 55.864],
              [12.835, 55.862],
              [12.838, 55.861],
              [12.842, 55.86],
              [12.847, 55.859],
              [12.858, 55.858],
              [12.864, 55.858],
              [12.87, 55.857],
              [12.875, 55.855],
              [12.881, 55.853],
              [12.886, 55.851],
              [12.892, 55.848],
              [12.902, 55.842],
              [12.91, 55.834],
              [12.914, 55.829],
              [12.917, 55.824],
              [12.92, 55.818],
              [12.924, 55.808],
              [12.926, 55.802],
              [12.926, 55.791],
              [12.925, 55.786],
              [12.917, 55.766],
              [12.915, 55.762],
              [12.914, 55.758],
              [12.914, 55.754],
              [12.915, 55.751],
              [12.917, 55.749],
              [12.92, 55.747],
              [12.926, 55.745],
              [12.935, 55.744],
              [12.94, 55.744],
              [12.945, 55.743],
              [12.95, 55.741],
              [12.953, 55.739],
              [12.961, 55.735],
              [12.971, 55.731],
              [12.99, 55.727],
              [12.996, 55.726],
              [13.002, 55.723],
              [13.009, 55.721],
              [13.021, 55.715],
              [13.033, 55.707],
              [13.038, 55.704],
              [13.043, 55.7],
              [13.047, 55.695],
              [13.05, 55.692],
              [13.053, 55.688],
              [13.058, 55.68],
              [13.06, 55.678],
              [13.061, 55.676],
              [13.061, 55.671],
              [13.06, 55.667],
              [13.059, 55.664],
              [13.058, 55.66],
              [13.056, 55.657],
              [13.054, 55.653],
              [13.051, 55.65],
              [13.048, 55.648],
              [13.044, 55.645],
              [13.04, 55.643],
              [13.03, 55.64],
              [13.026, 55.638],
              [13.021, 55.637],
              [13.012, 55.635],
              [13.004, 55.633],
              [13.002, 55.632],
              [13, 55.63],
              [13, 55.629],
              [13.001, 55.627],
              [13.004, 55.626],
              [13.007, 55.626],
              [13.018, 55.624],
              [13.021, 55.623],
              [13.022, 55.623],
              [13.022, 55.622],
              [13.021, 55.622],
              [13.02, 55.621],
              [13.016, 55.622],
              [13.009, 55.622],
              [13.006, 55.621],
              [13.004, 55.621],
              [13.002, 55.62],
              [13, 55.618],
              [12.994, 55.615],
              [12.992, 55.615],
              [12.989, 55.614],
              [12.982, 55.613],
              [12.978, 55.612],
              [12.975, 55.611],
              [12.967, 55.608],
              [12.963, 55.606],
              [12.943, 55.599],
              [12.939, 55.598],
              [12.932, 55.595],
              [12.927, 55.593],
              [12.923, 55.591],
              [12.919, 55.587],
              [12.915, 55.584],
              [12.913, 55.582],
              [12.906, 55.574],
              [12.902, 55.568],
              [12.901, 55.565],
              [12.901, 55.56],
              [12.903, 55.553],
              [12.903, 55.549],
              [12.904, 55.545],
              [12.904, 55.537],
              [12.902, 55.529],
              [12.9, 55.526],
              [12.899, 55.524],
              [12.899, 55.522],
              [12.901, 55.52],
              [12.904, 55.519],
              [12.912, 55.516],
              [12.916, 55.514],
              [12.921, 55.511],
              [12.925, 55.508],
              [12.928, 55.504],
              [12.941, 55.49],
              [12.95, 55.48],
              [12.958, 55.47],
              [12.961, 55.465],
              [12.963, 55.46],
              [12.964, 55.456],
              [12.963, 55.452],
              [12.962, 55.449],
              [12.958, 55.447],
              [12.955, 55.447],
              [12.951, 55.445],
              [12.949, 55.442],
              [12.948, 55.439],
              [12.946, 55.426],
              [12.945, 55.421],
              [12.944, 55.417],
              [12.945, 55.413],
              [12.946, 55.41],
              [12.948, 55.407],
              [12.951, 55.405],
            ],
          ],
        ],
      },
      properties: { id: 55, name: 'Öresund', latlon: [55.464219, 12.585727] },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [12.851, 55.335],
              [13.425, 54.677],
              [13.422, 54.68],
              [13.418, 54.681],
              [13.408, 54.683],
              [13.395, 54.683],
              [13.388, 54.682],
              [13.374, 54.681],
              [13.352, 54.68],
              [13.331, 54.678],
              [13.317, 54.676],
              [13.309, 54.676],
              [13.302, 54.675],
              [13.295, 54.673],
              [13.289, 54.672],
              [13.282, 54.67],
              [13.276, 54.669],
              [13.27, 54.666],
              [13.258, 54.662],
              [13.252, 54.659],
              [13.242, 54.653],
              [13.237, 54.649],
              [13.229, 54.641],
              [13.226, 54.637],
              [13.223, 54.631],
              [13.22, 54.626],
              [13.216, 54.614],
              [13.213, 54.608],
              [13.21, 54.603],
              [13.206, 54.598],
              [13.202, 54.594],
              [13.192, 54.586],
              [13.182, 54.579],
              [13.178, 54.576],
              [13.175, 54.573],
              [13.172, 54.571],
              [13.171, 54.569],
              [13.172, 54.567],
              [13.177, 54.567],
              [13.181, 54.568],
              [13.196, 54.574],
              [13.202, 54.577],
              [13.207, 54.58],
              [13.213, 54.583],
              [13.218, 54.587],
              [13.222, 54.59],
              [13.226, 54.594],
              [13.228, 54.599],
              [13.23, 54.603],
              [13.233, 54.612],
              [13.234, 54.617],
              [13.236, 54.621],
              [13.239, 54.625],
              [13.243, 54.628],
              [13.253, 54.634],
              [13.263, 54.638],
              [13.271, 54.638],
              [13.275, 54.637],
              [13.277, 54.635],
              [13.279, 54.629],
              [13.279, 54.625],
              [13.277, 54.621],
              [13.275, 54.616],
              [13.272, 54.61],
              [13.263, 54.594],
              [13.257, 54.584],
              [13.256, 54.578],
              [13.255, 54.574],
              [13.255, 54.57],
              [13.256, 54.567],
              [13.259, 54.565],
              [13.268, 54.565],
              [13.273, 54.566],
              [13.279, 54.567],
              [13.285, 54.569],
              [13.291, 54.57],
              [13.297, 54.572],
              [13.304, 54.575],
              [13.31, 54.577],
              [13.315, 54.58],
              [13.321, 54.583],
              [13.333, 54.592],
              [13.337, 54.596],
              [13.341, 54.598],
              [13.346, 54.601],
              [13.356, 54.605],
              [13.366, 54.605],
              [13.374, 54.601],
              [13.378, 54.598],
              [13.382, 54.594],
              [13.352, 54.543],
              [13.35, 54.545],
              [13.349, 54.547],
              [13.349, 54.55],
              [13.35, 54.552],
              [13.354, 54.557],
              [13.356, 54.56],
              [13.359, 54.569],
              [13.358, 54.571],
              [13.356, 54.573],
              [13.353, 54.574],
              [13.345, 54.572],
              [13.34, 54.571],
              [13.334, 54.569],
              [13.319, 54.56],
              [13.315, 54.556],
              [13.311, 54.553],
              [13.307, 54.545],
              [13.306, 54.541],
              [13.306, 54.533],
              [13.305, 54.529],
              [13.304, 54.527],
              [13.302, 54.525],
              [13.299, 54.525],
              [13.296, 54.526],
              [13.294, 54.527],
              [13.292, 54.53],
              [13.29, 54.532],
              [13.288, 54.535],
              [13.285, 54.537],
              [13.282, 54.54],
              [13.277, 54.542],
              [13.273, 54.545],
              [13.267, 54.547],
              [13.262, 54.549],
              [13.244, 54.552],
              [13.237, 54.553],
              [13.21, 54.553],
              [13.196, 54.552],
              [13.183, 54.551],
              [13.171, 54.549],
              [13.166, 54.547],
              [13.161, 54.546],
              [13.157, 54.544],
              [13.155, 54.541],
              [13.155, 54.538],
              [13.156, 54.534],
              [13.158, 54.529],
              [13.16, 54.525],
              [13.168, 54.517],
              [13.178, 54.511],
              [13.183, 54.51],
              [13.188, 54.508],
              [13.194, 54.507],
              [13.199, 54.506],
              [13.21, 54.505],
              [13.216, 54.505],
              [13.22, 54.504],
              [13.228, 54.5],
              [13.237, 54.491],
              [13.24, 54.489],
              [13.248, 54.485],
              [13.254, 54.481],
              [13.256, 54.48],
              [13.256, 54.477],
              [13.254, 54.475],
              [13.246, 54.47],
              [13.244, 54.469],
              [13.242, 54.466],
              [13.238, 54.464],
              [13.234, 54.463],
              [13.209, 54.458],
              [13.201, 54.455],
              [13.197, 54.454],
              [13.185, 54.452],
              [13.177, 54.45],
              [13.173, 54.448],
              [13.165, 54.442],
              [13.161, 54.436],
              [13.161, 54.433],
              [13.162, 54.43],
              [13.164, 54.428],
              [13.168, 54.427],
              [13.173, 54.426],
              [13.178, 54.426],
              [13.19, 54.425],
              [13.196, 54.425],
              [13.202, 54.424],
              [13.207, 54.423],
              [13.212, 54.421],
              [13.216, 54.418],
              [13.221, 54.415],
              [13.225, 54.412],
              [13.228, 54.41],
              [13.231, 54.407],
              [13.234, 54.403],
              [13.24, 54.394],
              [13.249, 54.385],
              [13.249, 54.383],
              [13.246, 54.38],
              [13.242, 54.378],
              [13.238, 54.377],
              [13.232, 54.375],
              [13.227, 54.374],
              [13.168, 54.374],
              [13.161, 54.373],
              [13.155, 54.372],
              [13.148, 54.371],
              [13.136, 54.367],
              [13.132, 54.364],
              [13.128, 54.36],
              [13.125, 54.356],
              [13.123, 54.346],
              [13.123, 54.341],
              [13.124, 54.337],
              [13.127, 54.332],
              [13.131, 54.328],
              [13.136, 54.324],
              [13.146, 54.318],
              [13.162, 54.309],
              [13.166, 54.307],
              [13.168, 54.304],
              [13.17, 54.303],
              [13.169, 54.301],
              [13.167, 54.3],
              [13.16, 54.299],
              [13.154, 54.297],
              [13.152, 54.295],
              [13.151, 54.293],
              [13.15, 54.292],
              [13.15, 54.29],
              [13.152, 54.289],
              [13.154, 54.287],
              [13.168, 54.287],
              [13.184, 54.288],
              [13.188, 54.288],
              [13.192, 54.287],
              [13.196, 54.285],
              [13.197, 54.284],
              [13.184, 54.261],
              [13.178, 54.262],
              [13.173, 54.263],
              [13.168, 54.262],
              [13.164, 54.262],
              [13.158, 54.261],
              [13.156, 54.261],
              [13.156, 54.262],
              [13.157, 54.263],
              [13.159, 54.264],
              [13.163, 54.267],
              [13.164, 54.268],
              [13.164, 54.269],
              [13.163, 54.27],
              [13.16, 54.271],
              [13.144, 54.271],
              [13.134, 54.273],
              [13.128, 54.275],
              [13.124, 54.277],
              [13.119, 54.28],
              [13.115, 54.283],
              [13.112, 54.287],
              [13.11, 54.29],
              [13.109, 54.294],
              [13.107, 54.298],
              [13.106, 54.302],
              [13.103, 54.306],
              [13.096, 54.318],
              [13.092, 54.323],
              [13.09, 54.326],
              [13.088, 54.33],
              [13.084, 54.34],
              [13.084, 54.36],
              [13.082, 54.368],
              [13.076, 54.374],
              [13.071, 54.377],
              [13.066, 54.379],
              [13.056, 54.382],
              [13.051, 54.385],
              [13.046, 54.387],
              [13.042, 54.39],
              [13.038, 54.394],
              [13.034, 54.397],
              [13.031, 54.401],
              [13.029, 54.405],
              [13.028, 54.408],
              [13.027, 54.412],
              [13.026, 54.42],
              [13.024, 54.426],
              [13.022, 54.429],
              [13.019, 54.431],
              [13.015, 54.432],
              [13.005, 54.432],
              [12.999, 54.431],
              [12.981, 54.426],
              [12.954, 54.42],
              [12.94, 54.416],
              [12.934, 54.414],
              [12.927, 54.412],
              [12.921, 54.41],
              [12.916, 54.407],
              [12.91, 54.404],
              [12.905, 54.401],
              [12.901, 54.397],
              [12.896, 54.393],
              [12.884, 54.378],
              [12.875, 54.369],
              [12.87, 54.366],
              [12.865, 54.362],
              [12.86, 54.359],
              [12.854, 54.357],
              [12.849, 54.355],
              [12.843, 54.353],
              [12.837, 54.352],
              [12.821, 54.352],
              [12.818, 54.353],
              [12.814, 54.354],
              [12.811, 54.356],
              [12.807, 54.359],
              [12.801, 54.367],
              [12.797, 54.371],
              [12.787, 54.38],
              [12.785, 54.382],
              [12.783, 54.383],
              [12.78, 54.383],
              [12.777, 54.382],
              [12.769, 54.379],
              [12.761, 54.377],
              [12.745, 54.377],
              [12.738, 54.376],
              [12.735, 54.376],
              [12.727, 54.378],
              [12.724, 54.379],
              [12.72, 54.382],
              [12.714, 54.387],
              [12.71, 54.389],
              [12.707, 54.389],
              [12.705, 54.39],
              [12.702, 54.389],
              [12.698, 54.387],
              [12.695, 54.385],
              [12.688, 54.378],
              [12.686, 54.378],
              [12.686, 54.38],
              [12.691, 54.387],
              [12.693, 54.393],
              [12.695, 54.395],
              [12.699, 54.401],
              [12.701, 54.403],
              [12.701, 54.406],
              [12.699, 54.407],
              [12.696, 54.408],
              [12.692, 54.408],
              [12.677, 54.405],
              [12.669, 54.401],
              [12.667, 54.399],
              [12.665, 54.396],
              [12.659, 54.39],
              [12.655, 54.387],
              [12.65, 54.385],
              [12.645, 54.382],
              [12.64, 54.38],
              [12.634, 54.378],
              [12.629, 54.376],
              [12.623, 54.374],
              [12.607, 54.369],
              [12.603, 54.368],
              [12.596, 54.365],
              [12.59, 54.363],
              [12.584, 54.363],
              [12.581, 54.364],
              [12.579, 54.366],
              [12.576, 54.367],
              [12.574, 54.369],
              [12.572, 54.37],
              [12.569, 54.371],
              [12.566, 54.371],
              [12.563, 54.372],
              [12.557, 54.372],
              [12.555, 54.371],
              [12.554, 54.371],
              [12.551, 54.369],
              [12.549, 54.368],
              [12.547, 54.366],
              [12.545, 54.365],
              [12.544, 54.362],
              [12.544, 54.359],
              [12.543, 54.357],
              [12.541, 54.355],
              [12.54, 54.353],
              [12.538, 54.35],
              [12.53, 54.344],
              [12.525, 54.341],
              [12.52, 54.339],
              [12.496, 54.331],
              [12.486, 54.327],
              [12.482, 54.324],
              [12.478, 54.32],
              [12.473, 54.313],
              [12.47, 54.309],
              [12.465, 54.306],
              [12.461, 54.303],
              [12.455, 54.3],
              [12.438, 54.293],
              [12.432, 54.29],
              [12.424, 54.284],
              [12.421, 54.281],
              [12.419, 54.275],
              [12.419, 54.271],
              [12.421, 54.267],
              [12.424, 54.263],
              [12.427, 54.26],
              [12.435, 54.256],
              [12.441, 54.252],
              [12.443, 54.251],
              [12.444, 54.25],
              [12.443, 54.249],
              [12.44, 54.248],
              [12.425, 54.248],
              [12.407, 54.251],
              [12.402, 54.253],
              [12.39, 54.257],
              [12.385, 54.259],
              [12.377, 54.265],
              [12.375, 54.268],
              [12.374, 54.27],
              [12.374, 54.273],
              [12.373, 54.28],
              [12.373, 54.284],
              [12.371, 54.291],
              [12.37, 54.295],
              [12.37, 54.299],
              [12.372, 54.305],
              [12.374, 54.308],
              [12.383, 54.317],
              [12.385, 54.32],
              [12.391, 54.332],
              [12.393, 54.335],
              [12.396, 54.338],
              [12.399, 54.34],
              [12.406, 54.343],
              [12.411, 54.348],
              [12.413, 54.352],
              [12.418, 54.359],
              [12.42, 54.363],
              [12.424, 54.366],
              [12.428, 54.37],
              [12.433, 54.372],
              [12.438, 54.375],
              [12.444, 54.377],
              [12.456, 54.379],
              [12.463, 54.38],
              [12.469, 54.38],
              [12.476, 54.381],
              [12.489, 54.381],
              [12.496, 54.38],
              [12.507, 54.379],
              [12.517, 54.379],
              [12.535, 54.382],
              [12.546, 54.385],
              [12.558, 54.387],
              [12.563, 54.388],
              [12.578, 54.389],
              [12.581, 54.389],
              [12.583, 54.39],
              [12.585, 54.39],
              [12.587, 54.392],
              [12.588, 54.394],
              [12.588, 54.398],
              [12.59, 54.4],
              [12.596, 54.404],
              [12.605, 54.407],
              [12.61, 54.409],
              [12.614, 54.412],
              [12.617, 54.414],
              [12.625, 54.42],
              [12.628, 54.422],
              [12.63, 54.426],
              [12.629, 54.428],
              [12.626, 54.43],
              [12.623, 54.433],
              [12.615, 54.437],
              [12.604, 54.442],
              [12.601, 54.444],
              [12.597, 54.445],
              [12.6, 54.445],
              [12.634, 54.428],
              [12.643, 54.423],
              [12.647, 54.421],
              [12.652, 54.419],
              [12.657, 54.418],
              [12.662, 54.418],
              [12.665, 54.419],
              [12.669, 54.42],
              [12.677, 54.423],
              [12.683, 54.425],
              [12.688, 54.426],
              [12.693, 54.428],
              [12.711, 54.428],
              [12.723, 54.426],
              [12.728, 54.425],
              [12.737, 54.422],
              [12.742, 54.42],
              [12.748, 54.419],
              [12.755, 54.418],
              [12.767, 54.416],
              [12.78, 54.416],
              [12.797, 54.414],
              [12.809, 54.414],
              [12.815, 54.415],
              [12.828, 54.417],
              [12.834, 54.418],
              [12.846, 54.418],
              [12.865, 54.417],
              [12.877, 54.417],
              [12.883, 54.418],
              [12.89, 54.419],
              [12.896, 54.42],
              [12.901, 54.421],
              [12.906, 54.423],
              [12.91, 54.425],
              [12.914, 54.428],
              [12.916, 54.43],
              [12.916, 54.433],
              [12.915, 54.436],
              [12.913, 54.439],
              [12.909, 54.441],
              [12.904, 54.443],
              [12.898, 54.443],
              [12.884, 54.445],
              [12.856, 54.445],
              [12.726, 54.442],
              [12.69, 54.442],
              [12.676, 54.443],
              [12.669, 54.443],
              [12.655, 54.444],
              [12.635, 54.446],
              [12.608, 54.449],
              [12.587, 54.452],
              [12.581, 54.453],
              [12.567, 54.455],
              [12.549, 54.461],
              [12.543, 54.464],
              [12.538, 54.466],
              [12.53, 54.472],
              [12.529, 54.474],
              [12.525, 54.479],
              [12.522, 54.482],
              [12.518, 54.482],
              [12.516, 54.481],
              [12.514, 54.479],
              [12.51, 54.476],
              [12.507, 54.472],
              [12.503, 54.468],
              [12.499, 54.463],
              [12.482, 54.442],
              [12.474, 54.431],
              [12.464, 54.421],
              [12.46, 54.416],
              [12.455, 54.412],
              [12.45, 54.407],
              [12.444, 54.403],
              [12.423, 54.387],
              [12.408, 54.375],
              [12.388, 54.355],
              [12.365, 54.329],
              [12.356, 54.319],
              [12.351, 54.314],
              [12.346, 54.31],
              [12.341, 54.305],
              [12.336, 54.301],
              [12.33, 54.297],
              [12.318, 54.291],
              [12.311, 54.288],
              [12.305, 54.285],
              [12.292, 54.279],
              [12.245, 54.261],
              [12.225, 54.253],
              [12.211, 54.247],
              [12.199, 54.241],
              [12.192, 54.238],
              [12.186, 54.234],
              [12.181, 54.23],
              [12.169, 54.221],
              [12.147, 54.204],
              [12.135, 54.196],
              [12.13, 54.192],
              [12.118, 54.186],
              [12.113, 54.185],
              [12.107, 54.184],
              [12.102, 54.183],
              [12.09, 54.182],
              [12.085, 54.182],
              [12.063, 54.18],
              [12.056, 54.179],
              [12.025, 54.177],
              [12.018, 54.177],
              [12.012, 54.176],
              [12.005, 54.176],
              [11.998, 54.175],
              [11.984, 54.172],
              [11.97, 54.17],
              [11.949, 54.165],
              [11.908, 54.156],
              [11.887, 54.152],
              [11.859, 54.148],
              [11.852, 54.148],
              [11.845, 54.147],
              [11.838, 54.147],
              [11.831, 54.148],
              [11.817, 54.149],
              [11.774, 54.153],
              [11.76, 54.154],
              [11.746, 54.154],
              [11.732, 54.155],
              [11.718, 54.154],
              [11.711, 54.154],
              [11.705, 54.153],
              [11.691, 54.151],
              [11.685, 54.15],
              [11.678, 54.147],
              [11.672, 54.145],
              [11.665, 54.141],
              [11.653, 54.135],
              [11.628, 54.12],
              [11.622, 54.117],
              [11.615, 54.113],
              [11.609, 54.11],
              [11.602, 54.107],
              [11.59, 54.103],
              [11.572, 54.096],
              [11.554, 54.09],
              [11.549, 54.087],
              [11.541, 54.081],
              [11.533, 54.073],
              [11.533, 54.067],
              [11.534, 54.064],
              [11.535, 54.062],
              [11.537, 54.061],
              [11.541, 54.061],
              [11.545, 54.062],
              [11.555, 54.068],
              [11.561, 54.071],
              [11.579, 54.082],
              [11.584, 54.086],
              [11.596, 54.092],
              [11.601, 54.094],
              [11.61, 54.094],
              [11.613, 54.093],
              [11.615, 54.091],
              [11.617, 54.088],
              [11.617, 54.085],
              [11.616, 54.081],
              [11.614, 54.078],
              [11.61, 54.075],
              [11.607, 54.072],
              [11.599, 54.066],
              [11.594, 54.063],
              [11.591, 54.06],
              [11.588, 54.056],
              [11.582, 54.049],
              [11.574, 54.041],
              [11.568, 54.037],
              [11.563, 54.034],
              [11.559, 54.033],
              [11.554, 54.031],
              [11.55, 54.03],
              [11.545, 54.029],
              [11.538, 54.029],
              [11.534, 54.028],
              [11.531, 54.027],
              [11.529, 54.026],
              [11.527, 54.024],
              [11.524, 54.019],
              [11.522, 54.016],
              [11.519, 54.013],
              [11.508, 54.004],
              [11.501, 53.997],
              [11.499, 53.993],
              [11.497, 53.99],
              [11.495, 53.986],
              [11.494, 53.983],
              [11.492, 53.981],
              [11.49, 53.978],
              [11.481, 53.969],
              [11.481, 53.967],
              [11.48, 53.965],
              [11.48, 53.962],
              [11.481, 53.959],
              [11.481, 53.956],
              [11.48, 53.952],
              [11.48, 53.947],
              [11.479, 53.943],
              [11.478, 53.938],
              [11.476, 53.934],
              [11.473, 53.929],
              [11.462, 53.918],
              [11.459, 53.914],
              [11.457, 53.911],
              [11.456, 53.909],
              [11.455, 53.906],
              [11.453, 53.904],
              [11.451, 53.903],
              [11.448, 53.902],
              [11.44, 53.904],
              [11.435, 53.906],
              [11.43, 53.909],
              [11.424, 53.912],
              [11.414, 53.918],
              [11.41, 53.922],
              [11.406, 53.925],
              [11.396, 53.931],
              [11.391, 53.933],
              [11.385, 53.935],
              [11.373, 53.938],
              [11.361, 53.942],
              [11.35, 53.946],
              [11.345, 53.948],
              [11.34, 53.949],
              [11.329, 53.949],
              [11.323, 53.948],
              [11.293, 53.938],
              [11.281, 53.936],
              [11.275, 53.936],
              [11.27, 53.937],
              [11.26, 53.941],
              [11.254, 53.947],
              [11.25, 53.955],
              [11.25, 53.969],
              [11.248, 53.977],
              [11.245, 53.98],
              [11.242, 53.982],
              [11.237, 53.984],
              [11.221, 53.989],
              [11.216, 53.991],
              [11.21, 53.994],
              [11.192, 54.004],
              [11.186, 54.007],
              [11.18, 54.009],
              [11.173, 54.011],
              [11.167, 54.012],
              [11.16, 54.012],
              [11.153, 54.013],
              [11.139, 54.013],
              [11.097, 54.01],
              [11.076, 54.009],
              [11.034, 54.003],
              [11.027, 54.001],
              [11.014, 53.997],
              [10.994, 53.99],
              [10.947, 53.973],
              [10.933, 53.968],
              [10.927, 53.966],
              [10.92, 53.964],
              [10.908, 53.962],
              [10.902, 53.962],
              [10.894, 53.964],
              [10.89, 53.966],
              [10.886, 53.969],
              [10.879, 53.976],
              [10.874, 53.98],
              [10.869, 53.983],
              [10.863, 53.986],
              [10.851, 53.99],
              [10.844, 53.991],
              [10.838, 53.992],
              [10.81, 53.996],
              [10.803, 53.998],
              [10.796, 53.999],
              [10.79, 54.002],
              [10.78, 54.008],
              [10.775, 54.012],
              [10.767, 54.02],
              [10.761, 54.03],
              [10.759, 54.04],
              [10.759, 54.046],
              [10.761, 54.051],
              [10.764, 54.056],
              [10.768, 54.061],
              [10.777, 54.07],
              [10.787, 54.078],
              [10.797, 54.087],
              [10.801, 54.09],
              [10.806, 54.093],
              [10.81, 54.095],
              [10.815, 54.095],
              [10.82, 54.094],
              [10.826, 54.093],
              [10.831, 54.092],
              [10.843, 54.09],
              [10.856, 54.09],
              [10.862, 54.091],
              [10.869, 54.091],
              [10.887, 54.097],
              [10.893, 54.1],
              [10.898, 54.104],
              [10.91, 54.111],
              [10.927, 54.122],
              [10.938, 54.129],
              [10.944, 54.133],
              [10.956, 54.139],
              [10.962, 54.143],
              [10.969, 54.146],
              [10.982, 54.151],
              [11.002, 54.16],
              [11.042, 54.176],
              [11.055, 54.181],
              [11.067, 54.187],
              [11.072, 54.191],
              [11.078, 54.194],
              [11.082, 54.198],
              [11.088, 54.208],
              [11.09, 54.22],
              [11.09, 54.227],
              [11.089, 54.234],
              [11.089, 54.241],
              [11.087, 54.255],
              [11.085, 54.276],
              [11.082, 54.298],
              [11.079, 54.312],
              [11.077, 54.325],
              [11.076, 54.33],
              [11.074, 54.336],
              [11.069, 54.346],
              [11.069, 54.35],
              [11.071, 54.351],
              [11.073, 54.353],
              [11.076, 54.353],
              [11.081, 54.354],
              [11.083, 54.354],
              [11.087, 54.355],
              [11.097, 54.359],
              [11.107, 54.365],
              [11.112, 54.369],
              [11.116, 54.372],
              [11.119, 54.376],
              [11.12, 54.379],
              [11.121, 54.381],
              [11.121, 54.384],
              [11.12, 54.387],
              [11.117, 54.389],
              [11.111, 54.391],
              [11.103, 54.391],
              [11.098, 54.39],
              [11.088, 54.386],
              [11.077, 54.382],
              [11.071, 54.38],
              [11.065, 54.377],
              [11.058, 54.376],
              [11.051, 54.374],
              [11.037, 54.372],
              [11.031, 54.371],
              [11.013, 54.371],
              [11.008, 54.372],
              [11.003, 54.372],
              [10.997, 54.374],
              [10.996, 54.375],
              [10.997, 54.376],
              [10.999, 54.377],
              [11.006, 54.379],
              [11.006, 54.38],
              [11.005, 54.38],
              [11.002, 54.381],
              [10.992, 54.381],
              [10.98, 54.382],
              [10.967, 54.382],
              [10.96, 54.381],
              [10.946, 54.381],
              [10.939, 54.38],
              [10.932, 54.378],
              [10.925, 54.377],
              [10.919, 54.374],
              [10.912, 54.372],
              [10.905, 54.369],
              [10.899, 54.366],
              [10.88, 54.357],
              [10.841, 54.337],
              [10.822, 54.328],
              [10.809, 54.322],
              [10.803, 54.319],
              [10.789, 54.315],
              [10.783, 54.313],
              [10.776, 54.311],
              [10.762, 54.309],
              [10.749, 54.308],
              [10.735, 54.307],
              [10.708, 54.307],
              [10.702, 54.308],
              [10.697, 54.31],
              [10.691, 54.311],
              [10.686, 54.314],
              [10.681, 54.316],
              [10.675, 54.32],
              [10.67, 54.323],
              [10.665, 54.327],
              [10.649, 54.338],
              [10.643, 54.342],
              [10.638, 54.345],
              [10.632, 54.349],
              [10.625, 54.352],
              [10.619, 54.355],
              [10.612, 54.358],
              [10.606, 54.36],
              [10.599, 54.363],
              [10.593, 54.365],
              [10.586, 54.366],
              [10.573, 54.37],
              [10.559, 54.373],
              [10.506, 54.385],
              [10.493, 54.389],
              [10.479, 54.392],
              [10.473, 54.394],
              [10.46, 54.399],
              [10.446, 54.403],
              [10.42, 54.414],
              [10.407, 54.419],
              [10.4, 54.421],
              [10.394, 54.423],
              [10.38, 54.427],
              [10.373, 54.428],
              [10.367, 54.429],
              [10.346, 54.432],
              [10.339, 54.432],
              [10.332, 54.433],
              [10.326, 54.433],
              [10.319, 54.432],
              [10.313, 54.432],
              [10.303, 54.43],
              [10.298, 54.428],
              [10.29, 54.426],
              [10.282, 54.422],
              [10.281, 54.422],
              [10.277, 54.421],
              [10.272, 54.42],
              [10.254, 54.416],
              [10.247, 54.415],
              [10.241, 54.414],
              [10.235, 54.412],
              [10.223, 54.406],
              [10.213, 54.398],
              [10.209, 54.394],
              [10.197, 54.379],
              [10.191, 54.37],
              [10.186, 54.361],
              [10.183, 54.357],
              [10.181, 54.353],
              [10.179, 54.348],
              [10.176, 54.338],
              [10.175, 54.336],
              [10.174, 54.331],
              [10.173, 54.329],
              [10.171, 54.328],
              [10.164, 54.326],
              [10.152, 54.321],
              [10.148, 54.32],
              [10.144, 54.32],
              [10.143, 54.322],
              [10.144, 54.324],
              [10.147, 54.333],
              [10.148, 54.337],
              [10.148, 54.341],
              [10.147, 54.348],
              [10.147, 54.352],
              [10.15, 54.364],
              [10.153, 54.37],
              [10.156, 54.372],
              [10.165, 54.381],
              [10.171, 54.385],
              [10.176, 54.389],
              [10.179, 54.391],
              [10.181, 54.394],
              [10.183, 54.396],
              [10.184, 54.401],
              [10.184, 54.405],
              [10.183, 54.41],
              [10.181, 54.421],
              [10.18, 54.427],
              [10.18, 54.432],
              [10.181, 54.436],
              [10.183, 54.44],
              [10.186, 54.448],
              [10.187, 54.451],
              [10.186, 54.455],
              [10.185, 54.458],
              [10.182, 54.461],
              [10.178, 54.463],
              [10.168, 54.469],
              [10.163, 54.471],
              [10.157, 54.473],
              [10.151, 54.476],
              [10.145, 54.478],
              [10.139, 54.479],
              [10.132, 54.481],
              [10.126, 54.482],
              [10.119, 54.483],
              [10.105, 54.483],
              [10.098, 54.482],
              [10.084, 54.481],
              [10.063, 54.479],
              [9.979, 54.469],
              [9.966, 54.467],
              [9.952, 54.465],
              [9.94, 54.463],
              [9.93, 54.461],
              [9.915, 54.455],
              [9.909, 54.454],
              [9.904, 54.453],
              [9.898, 54.452],
              [9.891, 54.451],
              [9.873, 54.451],
              [9.867, 54.452],
              [9.861, 54.454],
              [9.856, 54.456],
              [9.852, 54.459],
              [9.846, 54.465],
              [9.845, 54.468],
              [9.844, 54.469],
              [9.844, 54.471],
              [9.845, 54.472],
              [9.847, 54.473],
              [9.85, 54.473],
              [9.852, 54.474],
              [9.866, 54.475],
              [9.871, 54.476],
              [9.88, 54.477],
              [9.897, 54.482],
              [9.917, 54.488],
              [9.93, 54.491],
              [9.943, 54.495],
              [9.949, 54.498],
              [9.956, 54.5],
              [9.962, 54.502],
              [9.968, 54.505],
              [9.973, 54.508],
              [9.979, 54.511],
              [9.984, 54.514],
              [9.99, 54.517],
              [10, 54.525],
              [10.004, 54.529],
              [10.009, 54.533],
              [10.017, 54.543],
              [10.023, 54.553],
              [10.025, 54.56],
              [10.027, 54.566],
              [10.03, 54.587],
              [10.031, 54.601],
              [10.033, 54.65],
              [10.033, 54.653],
              [10.031, 54.656],
              [10.03, 54.658],
              [10.028, 54.659],
              [10.028, 54.661],
              [10.029, 54.662],
              [10.033, 54.664],
              [10.034, 54.666],
              [10.034, 54.673],
              [10.033, 54.677],
              [10.032, 54.68],
              [10.03, 54.684],
              [10.027, 54.689],
              [10.023, 54.693],
              [10.018, 54.697],
              [10.003, 54.711],
              [9.993, 54.721],
              [9.989, 54.726],
              [9.981, 54.738],
              [9.97, 54.755],
              [9.962, 54.767],
              [9.958, 54.772],
              [9.953, 54.777],
              [9.949, 54.78],
              [9.944, 54.784],
              [9.939, 54.786],
              [9.934, 54.789],
              [9.919, 54.792],
              [9.915, 54.791],
              [9.912, 54.79],
              [9.909, 54.788],
              [9.905, 54.782],
              [9.903, 54.78],
              [9.9, 54.774],
              [9.898, 54.771],
              [9.895, 54.769],
              [9.887, 54.764],
              [9.883, 54.762],
              [9.877, 54.76],
              [9.872, 54.758],
              [9.866, 54.757],
              [9.861, 54.757],
              [9.849, 54.759],
              [9.844, 54.761],
              [9.837, 54.764],
              [9.832, 54.767],
              [9.808, 54.783],
              [9.79, 54.792],
              [9.784, 54.794],
              [9.778, 54.795],
              [9.752, 54.801],
              [9.725, 54.807],
              [9.65, 54.825],
              [9.637, 54.828],
              [9.624, 54.832],
              [9.619, 54.833],
              [9.614, 54.835],
              [9.609, 54.838],
              [9.603, 54.844],
              [9.601, 54.848],
              [9.6, 54.852],
              [9.6, 54.856],
              [9.601, 54.86],
              [9.601, 54.864],
              [9.602, 54.868],
              [9.6, 54.872],
              [9.593, 54.872],
              [9.589, 54.871],
              [9.585, 54.869],
              [9.565, 54.856],
              [9.559, 54.853],
              [9.554, 54.851],
              [9.542, 54.845],
              [9.531, 54.84],
              [9.518, 54.835],
              [9.502, 54.828],
              [9.49, 54.824],
              [9.472, 54.82],
              [9.467, 54.818],
              [9.461, 54.815],
              [9.456, 54.812],
              [9.451, 54.81],
              [9.446, 54.807],
              [9.44, 54.802],
              [9.438, 54.801],
              [9.435, 54.801],
              [9.433, 54.802],
              [9.432, 54.803],
              [9.432, 54.806],
              [9.431, 54.809],
              [9.43, 54.816],
              [9.429, 54.82],
              [9.429, 54.823],
              [9.43, 54.826],
              [9.433, 54.83],
              [9.437, 54.832],
              [9.441, 54.835],
              [9.447, 54.837],
              [9.453, 54.84],
              [9.472, 54.846],
              [9.478, 54.849],
              [9.484, 54.851],
              [9.491, 54.854],
              [9.497, 54.858],
              [9.515, 54.868],
              [9.522, 54.871],
              [9.528, 54.873],
              [9.534, 54.876],
              [9.551, 54.881],
              [9.557, 54.883],
              [9.562, 54.886],
              [9.57, 54.892],
              [9.577, 54.898],
              [9.581, 54.901],
              [9.591, 54.908],
              [9.593, 54.91],
              [9.598, 54.914],
              [9.601, 54.917],
              [9.605, 54.918],
              [9.619, 54.924],
              [9.622, 54.926],
              [9.626, 54.927],
              [9.631, 54.927],
              [9.637, 54.926],
              [9.647, 54.924],
              [9.652, 54.922],
              [9.656, 54.92],
              [9.658, 54.918],
              [9.659, 54.916],
              [9.658, 54.915],
              [9.652, 54.913],
              [9.637, 54.913],
              [9.622, 54.91],
              [9.618, 54.908],
              [9.615, 54.907],
              [9.614, 54.905],
              [9.615, 54.903],
              [9.617, 54.9],
              [9.62, 54.897],
              [9.633, 54.889],
              [9.637, 54.886],
              [9.644, 54.879],
              [9.645, 54.876],
              [9.647, 54.869],
              [9.649, 54.866],
              [9.652, 54.863],
              [9.656, 54.861],
              [9.661, 54.859],
              [9.667, 54.858],
              [9.673, 54.856],
              [9.693, 54.852],
              [9.723, 54.842],
              [9.728, 54.841],
              [9.734, 54.841],
              [9.738, 54.842],
              [9.742, 54.844],
              [9.746, 54.847],
              [9.748, 54.849],
              [9.749, 54.853],
              [9.75, 54.856],
              [9.749, 54.86],
              [9.747, 54.865],
              [9.741, 54.873],
              [9.736, 54.877],
              [9.732, 54.881],
              [9.728, 54.884],
              [9.72, 54.888],
              [9.718, 54.891],
              [9.716, 54.893],
              [9.716, 54.896],
              [9.72, 54.898],
              [9.728, 54.9],
              [9.733, 54.9],
              [9.744, 54.901],
              [9.749, 54.901],
              [9.759, 54.903],
              [9.763, 54.905],
              [9.766, 54.907],
              [9.893, 54.922],
              [10.051, 54.876],
              [10.407, 54.821],
              [10.723, 54.74],
              [11.051, 54.926],
              [11.041, 54.92],
              [11.033, 54.912],
              [11.03, 54.908],
              [11.026, 54.9],
              [11.026, 54.891],
              [11.027, 54.887],
              [11.031, 54.879],
              [11.034, 54.877],
              [11.036, 54.875],
              [11.042, 54.871],
              [11.045, 54.87],
              [11.054, 54.864],
              [11.063, 54.857],
              [11.08, 54.844],
              [11.084, 54.841],
              [11.089, 54.839],
              [11.095, 54.837],
              [11.1, 54.836],
              [11.116, 54.833],
              [11.12, 54.832],
              [11.123, 54.832],
              [11.125, 54.83],
              [11.125, 54.829],
              [11.123, 54.829],
              [11.114, 54.826],
              [11.102, 54.82],
              [11.098, 54.819],
              [11.093, 54.817],
              [11.089, 54.816],
              [11.082, 54.815],
              [11.079, 54.814],
              [11.076, 54.812],
              [11.072, 54.808],
              [11.069, 54.806],
              [11.061, 54.804],
              [11.052, 54.804],
              [11.047, 54.805],
              [11.043, 54.806],
              [11.036, 54.809],
              [11.03, 54.811],
              [11.025, 54.813],
              [11.019, 54.814],
              [11.009, 54.816],
              [10.999, 54.816],
              [10.999, 54.812],
              [11, 54.81],
              [10.999, 54.808],
              [10.995, 54.804],
              [10.991, 54.803],
              [10.988, 54.802],
              [10.984, 54.802],
              [10.98, 54.803],
              [10.976, 54.805],
              [10.973, 54.807],
              [10.967, 54.816],
              [10.966, 54.82],
              [10.966, 54.822],
              [10.967, 54.825],
              [10.967, 54.827],
              [10.968, 54.828],
              [10.969, 54.83],
              [10.971, 54.831],
              [10.968, 54.831],
              [10.966, 54.83],
              [10.964, 54.828],
              [10.962, 54.825],
              [10.962, 54.815],
              [10.964, 54.811],
              [10.966, 54.806],
              [10.969, 54.801],
              [10.977, 54.791],
              [10.982, 54.786],
              [10.987, 54.782],
              [10.992, 54.777],
              [11.002, 54.769],
              [11.014, 54.763],
              [11.021, 54.76],
              [11.035, 54.756],
              [11.048, 54.752],
              [11.069, 54.748],
              [11.161, 54.728],
              [11.202, 54.719],
              [11.223, 54.714],
              [11.244, 54.708],
              [11.25, 54.706],
              [11.256, 54.703],
              [11.263, 54.701],
              [11.269, 54.698],
              [11.281, 54.691],
              [11.31, 54.675],
              [11.322, 54.668],
              [11.334, 54.662],
              [11.34, 54.66],
              [11.346, 54.657],
              [11.357, 54.653],
              [11.363, 54.651],
              [11.375, 54.646],
              [11.446, 54.616],
              [11.466, 54.608],
              [11.472, 54.605],
              [11.478, 54.603],
              [11.485, 54.601],
              [11.49, 54.599],
              [11.505, 54.596],
              [11.509, 54.596],
              [11.512, 54.595],
              [11.515, 54.595],
              [11.516, 54.596],
              [11.514, 54.596],
              [11.503, 54.598],
              [11.493, 54.6],
              [11.483, 54.604],
              [11.479, 54.607],
              [11.476, 54.609],
              [11.475, 54.612],
              [11.475, 54.615],
              [11.477, 54.618],
              [11.483, 54.624],
              [11.488, 54.627],
              [11.498, 54.632],
              [11.503, 54.634],
              [11.509, 54.635],
              [11.527, 54.64],
              [11.539, 54.644],
              [11.55, 54.649],
              [11.562, 54.654],
              [11.568, 54.656],
              [11.572, 54.658],
              [11.577, 54.659],
              [11.591, 54.661],
              [11.594, 54.661],
              [11.6, 54.662],
              [11.612, 54.662],
              [11.637, 54.661],
              [11.656, 54.661],
              [11.666, 54.662],
              [11.678, 54.662],
              [11.689, 54.661],
              [11.695, 54.66],
              [11.711, 54.658],
              [11.72, 54.658],
              [11.725, 54.657],
              [11.729, 54.656],
              [11.739, 54.654],
              [11.745, 54.652],
              [11.75, 54.651],
              [11.776, 54.647],
              [11.782, 54.646],
              [11.805, 54.646],
              [11.81, 54.647],
              [11.814, 54.648],
              [11.818, 54.65],
              [11.822, 54.651],
              [11.824, 54.653],
              [11.826, 54.654],
              [11.829, 54.658],
              [11.831, 54.66],
              [11.838, 54.665],
              [11.841, 54.667],
              [11.842, 54.669],
              [11.845, 54.673],
              [11.846, 54.675],
              [11.846, 54.677],
              [11.847, 54.681],
              [11.849, 54.685],
              [11.849, 54.689],
              [11.842, 54.696],
              [11.838, 54.698],
              [11.829, 54.702],
              [11.824, 54.704],
              [11.821, 54.707],
              [11.818, 54.709],
              [11.817, 54.711],
              [11.817, 54.718],
              [11.819, 54.723],
              [11.82, 54.726],
              [11.822, 54.728],
              [11.824, 54.729],
              [11.825, 54.729],
              [11.836, 54.731],
              [11.841, 54.732],
              [11.845, 54.733],
              [11.849, 54.735],
              [11.853, 54.738],
              [11.855, 54.741],
              [11.857, 54.745],
              [11.857, 54.753],
              [11.855, 54.757],
              [11.852, 54.762],
              [11.848, 54.766],
              [11.838, 54.774],
              [11.832, 54.778],
              [11.815, 54.789],
              [11.809, 54.793],
              [11.805, 54.796],
              [11.823, 54.798],
              [11.849, 54.782],
              [11.859, 54.775],
              [11.862, 54.774],
              [11.864, 54.772],
              [11.866, 54.769],
              [11.868, 54.765],
              [11.871, 54.76],
              [11.873, 54.755],
              [11.875, 54.749],
              [11.878, 54.738],
              [11.88, 54.733],
              [11.883, 54.729],
              [11.886, 54.726],
              [11.892, 54.722],
              [11.897, 54.717],
              [11.897, 54.71],
              [11.895, 54.706],
              [11.892, 54.702],
              [11.885, 54.692],
              [11.881, 54.687],
              [11.879, 54.681],
              [11.876, 54.676],
              [11.874, 54.664],
              [11.875, 54.659],
              [11.876, 54.653],
              [11.878, 54.648],
              [11.881, 54.642],
              [11.889, 54.632],
              [11.901, 54.616],
              [11.905, 54.611],
              [11.909, 54.605],
              [11.912, 54.6],
              [11.918, 54.588],
              [11.921, 54.583],
              [11.925, 54.578],
              [11.929, 54.575],
              [11.939, 54.569],
              [11.944, 54.567],
              [11.949, 54.566],
              [11.958, 54.566],
              [11.961, 54.568],
              [11.964, 54.571],
              [11.965, 54.575],
              [11.966, 54.581],
              [11.966, 54.593],
              [11.965, 54.606],
              [11.964, 54.627],
              [11.963, 54.634],
              [11.963, 54.648],
              [11.966, 54.666],
              [11.97, 54.678],
              [11.972, 54.683],
              [11.975, 54.689],
              [11.978, 54.693],
              [11.983, 54.698],
              [11.987, 54.703],
              [11.993, 54.708],
              [12.009, 54.72],
              [12.014, 54.725],
              [12.019, 54.729],
              [12.029, 54.739],
              [12.044, 54.753],
              [12.054, 54.763],
              [12.059, 54.767],
              [12.064, 54.772],
              [12.069, 54.776],
              [12.075, 54.78],
              [12.087, 54.786],
              [12.104, 54.796],
              [12.11, 54.799],
              [12.116, 54.803],
              [12.126, 54.811],
              [12.145, 54.827],
              [12.149, 54.83],
              [12.152, 54.834],
              [12.153, 54.838],
              [12.153, 54.842],
              [12.151, 54.846],
              [12.148, 54.85],
              [12.144, 54.855],
              [12.14, 54.859],
              [12.136, 54.864],
              [12.127, 54.873],
              [12.196, 54.934],
              [12.159, 55],
              [12.16, 55.001],
              [12.162, 55.007],
              [12.161, 55.011],
              [12.159, 55.015],
              [12.156, 55.019],
              [12.153, 55.024],
              [12.142, 55.04],
              [12.14, 55.042],
              [12.131, 55.052],
              [12.123, 55.064],
              [12.117, 55.076],
              [12.113, 55.081],
              [12.113, 55.084],
              [12.119, 55.084],
              [12.134, 55.083],
              [12.146, 55.083],
              [12.152, 55.085],
              [12.156, 55.087],
              [12.161, 55.09],
              [12.165, 55.094],
              [12.171, 55.102],
              [12.172, 55.106],
              [12.172, 55.11],
              [12.171, 55.113],
              [12.169, 55.116],
              [12.166, 55.119],
              [12.163, 55.121],
              [12.153, 55.125],
              [12.148, 55.126],
              [12.136, 55.128],
              [12.118, 55.128],
              [12.106, 55.126],
              [12.087, 55.126],
              [12.079, 55.127],
              [12.07, 55.127],
              [12.061, 55.126],
              [12.056, 55.126],
              [12.052, 55.127],
              [12.049, 55.127],
              [12.045, 55.128],
              [12.039, 55.13],
              [12.036, 55.133],
              [12.033, 55.135],
              [12.027, 55.141],
              [12.023, 55.147],
              [12.022, 55.151],
              [12.024, 55.157],
              [12.027, 55.16],
              [12.031, 55.162],
              [12.034, 55.165],
              [12.039, 55.167],
              [12.043, 55.169],
              [12.049, 55.17],
              [12.056, 55.171],
              [12.062, 55.172],
              [12.072, 55.172],
              [12.077, 55.17],
              [12.08, 55.168],
              [12.082, 55.165],
              [12.084, 55.161],
              [12.085, 55.153],
              [12.086, 55.149],
              [12.088, 55.145],
              [12.09, 55.143],
              [12.093, 55.142],
              [12.097, 55.142],
              [12.1, 55.143],
              [12.102, 55.145],
              [12.105, 55.147],
              [12.109, 55.155],
              [12.112, 55.165],
              [12.114, 55.171],
              [12.12, 55.181],
              [12.133, 55.194],
              [12.138, 55.198],
              [12.144, 55.202],
              [12.149, 55.205],
              [12.155, 55.209],
              [12.167, 55.215],
              [12.173, 55.217],
              [12.18, 55.219],
              [12.186, 55.221],
              [12.193, 55.223],
              [12.206, 55.227],
              [12.22, 55.231],
              [12.233, 55.234],
              [12.247, 55.236],
              [12.253, 55.237],
              [12.267, 55.239],
              [12.287, 55.239],
              [12.314, 55.238],
              [12.334, 55.238],
              [12.352, 55.241],
              [12.357, 55.243],
              [12.371, 55.249],
              [12.383, 55.253],
              [12.402, 55.258],
              [12.408, 55.26],
              [12.42, 55.266],
              [12.425, 55.269],
              [12.431, 55.272],
              [12.436, 55.276],
              [12.444, 55.284],
              [12.447, 55.289],
              [12.448, 55.294],
              [12.449, 55.298],
              [12.45, 55.303],
              [12.45, 55.309],
              [12.812, 55.378],
              [12.851, 55.335],
            ],
          ],
        ],
      },
      properties: {
        id: 53,
        name: 'Sydvästra Östersjön',
        latlon: [54.664936, 12.262471],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [12.812, 55.378],
              [12.951, 55.405],
              [12.955, 55.403],
              [12.96, 55.401],
              [12.972, 55.398],
              [12.979, 55.397],
              [12.986, 55.395],
              [13, 55.392],
              [13.034, 55.381],
              [13.055, 55.375],
              [13.076, 55.372],
              [13.082, 55.371],
              [13.088, 55.371],
              [13.112, 55.372],
              [13.123, 55.372],
              [13.138, 55.37],
              [13.151, 55.369],
              [13.154, 55.369],
              [13.164, 55.367],
              [13.193, 55.364],
              [13.199, 55.363],
              [13.205, 55.361],
              [13.218, 55.358],
              [13.258, 55.348],
              [13.265, 55.347],
              [13.271, 55.346],
              [13.278, 55.344],
              [13.292, 55.343],
              [13.298, 55.342],
              [13.312, 55.34],
              [13.326, 55.339],
              [13.352, 55.339],
              [13.373, 55.342],
              [13.379, 55.344],
              [13.386, 55.346],
              [13.399, 55.35],
              [13.445, 55.366],
              [13.458, 55.371],
              [13.471, 55.375],
              [13.485, 55.379],
              [13.491, 55.38],
              [13.505, 55.382],
              [13.561, 55.386],
              [13.568, 55.387],
              [13.574, 55.388],
              [13.588, 55.39],
              [13.594, 55.392],
              [13.624, 55.407],
              [13.642, 55.413],
              [13.649, 55.414],
              [13.674, 55.418],
              [13.702, 55.423],
              [13.723, 55.426],
              [13.73, 55.426],
              [13.737, 55.427],
              [13.785, 55.427],
              [13.799, 55.426],
              [13.812, 55.426],
              [13.819, 55.425],
              [13.83, 55.424],
              [13.84, 55.424],
              [13.847, 55.425],
              [13.853, 55.426],
              [13.873, 55.43],
              [13.887, 55.432],
              [13.893, 55.433],
              [13.914, 55.433],
              [13.92, 55.432],
              [13.927, 55.432],
              [13.934, 55.43],
              [13.948, 55.428],
              [13.954, 55.426],
              [13.968, 55.422],
              [13.974, 55.42],
              [13.981, 55.417],
              [13.987, 55.414],
              [14, 55.408],
              [14.025, 55.396],
              [14.031, 55.394],
              [14.037, 55.391],
              [14.044, 55.389],
              [14.05, 55.387],
              [14.057, 55.385],
              [14.063, 55.384],
              [14.07, 55.384],
              [14.091, 55.383],
              [14.105, 55.382],
              [14.132, 55.379],
              [14.146, 55.379],
              [14.153, 55.378],
              [14.16, 55.379],
              [14.166, 55.379],
              [14.172, 55.38],
              [14.178, 55.382],
              [14.183, 55.383],
              [14.189, 55.385],
              [14.194, 55.388],
              [14.2, 55.391],
              [14.21, 55.399],
              [14.215, 55.404],
              [14.225, 55.413],
              [14.249, 55.438],
              [14.269, 55.458],
              [14.274, 55.462],
              [14.28, 55.466],
              [14.285, 55.47],
              [14.291, 55.474],
              [14.297, 55.477],
              [14.314, 55.486],
              [14.319, 55.489],
              [14.325, 55.493],
              [14.33, 55.496],
              [14.334, 55.5],
              [14.339, 55.504],
              [14.343, 55.509],
              [14.349, 55.519],
              [14.351, 55.524],
              [14.353, 55.53],
              [14.354, 55.535],
              [14.355, 55.541],
              [14.355, 55.546],
              [14.354, 55.551],
              [14.351, 55.556],
              [14.348, 55.562],
              [14.344, 55.567],
              [14.337, 55.577],
              [14.328, 55.586],
              [14.324, 55.591],
              [14.304, 55.607],
              [14.299, 55.612],
              [14.294, 55.616],
              [14.29, 55.621],
              [14.284, 55.631],
              [14.282, 55.637],
              [14.274, 55.654],
              [14.265, 55.669],
              [14.261, 55.673],
              [14.256, 55.677],
              [14.251, 55.68],
              [14.245, 55.683],
              [14.229, 55.693],
              [14.219, 55.699],
              [14.214, 55.703],
              [14.21, 55.707],
              [14.204, 55.717],
              [14.2, 55.729],
              [14.198, 55.741],
              [14.198, 55.754],
              [14.199, 55.76],
              [14.2, 55.767],
              [14.202, 55.774],
              [14.204, 55.78],
              [14.208, 55.793],
              [14.213, 55.806],
              [14.215, 55.813],
              [14.218, 55.819],
              [14.221, 55.826],
              [14.23, 55.844],
              [14.234, 55.849],
              [14.238, 55.855],
              [14.242, 55.86],
              [14.246, 55.866],
              [14.25, 55.871],
              [14.26, 55.881],
              [14.264, 55.886],
              [14.27, 55.89],
              [14.275, 55.894],
              [14.281, 55.898],
              [14.286, 55.901],
              [14.304, 55.911],
              [14.309, 55.914],
              [14.314, 55.918],
              [14.318, 55.921],
              [14.321, 55.925],
              [14.323, 55.929],
              [14.327, 55.936],
              [14.33, 55.941],
              [14.333, 55.945],
              [14.337, 55.948],
              [14.341, 55.952],
              [14.346, 55.954],
              [14.352, 55.957],
              [14.358, 55.959],
              [14.369, 55.962],
              [14.375, 55.964],
              [14.387, 55.97],
              [14.402, 55.975],
              [14.407, 55.977],
              [14.41, 55.979],
              [14.416, 55.984],
              [14.42, 55.986],
              [14.432, 55.993],
              [14.437, 55.997],
              [14.444, 56.001],
              [14.447, 56.003],
              [14.453, 56.009],
              [14.459, 56.014],
              [14.462, 56.017],
              [14.466, 56.022],
              [14.472, 56.028],
              [14.476, 56.03],
              [14.481, 56.032],
              [14.486, 56.033],
              [14.497, 56.035],
              [14.503, 56.036],
              [14.508, 56.038],
              [14.513, 56.039],
              [14.528, 56.045],
              [14.536, 56.049],
              [14.54, 56.05],
              [14.544, 56.05],
              [14.547, 56.049],
              [14.55, 56.047],
              [14.554, 56.045],
              [14.56, 56.039],
              [14.564, 56.037],
              [14.567, 56.036],
              [14.57, 56.036],
              [14.573, 56.037],
              [14.575, 56.038],
              [14.579, 56.039],
              [14.583, 56.042],
              [14.59, 56.047],
              [14.593, 56.049],
              [14.596, 56.05],
              [14.598, 56.051],
              [14.6, 56.051],
              [14.6, 56.05],
              [14.598, 56.046],
              [14.597, 56.043],
              [14.596, 56.038],
              [14.594, 56.031],
              [14.593, 56.028],
              [14.593, 56.025],
              [14.594, 56.022],
              [14.596, 56.02],
              [14.598, 56.017],
              [14.605, 56.013],
              [14.611, 56.007],
              [14.615, 56.004],
              [14.619, 56.003],
              [14.624, 56.002],
              [14.633, 56.001],
              [14.643, 55.999],
              [14.647, 55.998],
              [14.652, 55.998],
              [14.661, 55.997],
              [14.669, 55.997],
              [14.674, 55.998],
              [14.68, 55.999],
              [14.691, 56.002],
              [14.697, 56.003],
              [14.702, 56.004],
              [14.708, 56.003],
              [14.718, 56.002],
              [14.729, 56.002],
              [14.741, 56.006],
              [14.747, 56.009],
              [14.762, 56.018],
              [14.766, 56.022],
              [14.768, 56.026],
              [14.77, 56.029],
              [14.77, 56.032],
              [14.769, 56.035],
              [14.765, 56.041],
              [14.754, 56.052],
              [14.751, 56.054],
              [14.744, 56.059],
              [14.736, 56.065],
              [14.732, 56.069],
              [14.729, 56.073],
              [14.722, 56.087],
              [14.719, 56.091],
              [14.713, 56.097],
              [14.702, 56.105],
              [14.699, 56.108],
              [14.697, 56.111],
              [14.693, 56.116],
              [14.685, 56.123],
              [14.683, 56.126],
              [14.681, 56.13],
              [14.68, 56.134],
              [14.68, 56.139],
              [14.679, 56.144],
              [14.68, 56.148],
              [14.682, 56.151],
              [14.684, 56.155],
              [14.686, 56.157],
              [14.689, 56.159],
              [14.693, 56.16],
              [14.698, 56.161],
              [14.715, 56.161],
              [14.724, 56.159],
              [14.738, 56.157],
              [14.747, 56.155],
              [14.756, 56.155],
              [14.768, 56.158],
              [14.771, 56.158],
              [14.775, 56.157],
              [14.783, 56.157],
              [14.787, 56.156],
              [14.794, 56.155],
              [14.798, 56.155],
              [14.807, 56.156],
              [14.812, 56.157],
              [14.822, 56.156],
              [14.827, 56.155],
              [14.829, 56.155],
              [14.831, 56.154],
              [14.832, 56.153],
              [14.833, 56.15],
              [14.839, 56.144],
              [14.841, 56.143],
              [14.843, 56.143],
              [14.849, 56.145],
              [14.854, 56.15],
              [14.858, 56.157],
              [14.86, 56.16],
              [14.863, 56.162],
              [14.866, 56.163],
              [14.87, 56.163],
              [14.885, 56.159],
              [14.899, 56.159],
              [14.908, 56.16],
              [14.935, 56.16],
              [14.94, 56.161],
              [14.946, 56.161],
              [14.963, 56.164],
              [14.975, 56.166],
              [14.98, 56.166],
              [14.99, 56.164],
              [14.995, 56.162],
              [15.002, 56.159],
              [15.006, 56.157],
              [15.014, 56.155],
              [15.017, 56.154],
              [15.019, 56.155],
              [15.02, 56.156],
              [15.019, 56.157],
              [15.018, 56.159],
              [15.015, 56.161],
              [15.013, 56.165],
              [15.012, 56.166],
              [15.012, 56.168],
              [15.013, 56.169],
              [15.015, 56.17],
              [15.02, 56.17],
              [15.022, 56.171],
              [15.023, 56.172],
              [15.023, 56.173],
              [15.022, 56.175],
              [15.019, 56.18],
              [15.019, 56.182],
              [15.018, 56.184],
              [15.019, 56.185],
              [15.019, 56.186],
              [15.02, 56.187],
              [15.022, 56.187],
              [15.029, 56.185],
              [15.031, 56.184],
              [15.034, 56.184],
              [15.036, 56.185],
              [15.042, 56.187],
              [15.043, 56.187],
              [15.045, 56.188],
              [15.053, 56.187],
              [15.055, 56.188],
              [15.056, 56.188],
              [15.06, 56.186],
              [15.062, 56.183],
              [15.067, 56.179],
              [15.069, 56.175],
              [15.07, 56.172],
              [15.071, 56.17],
              [15.071, 56.164],
              [15.072, 56.161],
              [15.074, 56.16],
              [15.076, 56.158],
              [15.078, 56.157],
              [15.084, 56.155],
              [15.109, 56.155],
              [15.113, 56.156],
              [15.116, 56.158],
              [15.119, 56.159],
              [15.121, 56.161],
              [15.123, 56.162],
              [15.126, 56.163],
              [15.139, 56.163],
              [15.145, 56.161],
              [15.151, 56.157],
              [15.154, 56.156],
              [15.158, 56.155],
              [15.176, 56.155],
              [15.183, 56.157],
              [15.193, 56.157],
              [15.198, 56.156],
              [15.201, 56.156],
              [15.215, 56.157],
              [15.218, 56.157],
              [15.221, 56.158],
              [15.228, 56.16],
              [15.232, 56.161],
              [15.237, 56.163],
              [15.248, 56.167],
              [15.251, 56.169],
              [15.258, 56.172],
              [15.266, 56.174],
              [15.268, 56.175],
              [15.291, 56.175],
              [15.301, 56.176],
              [15.305, 56.177],
              [15.31, 56.177],
              [15.314, 56.175],
              [15.314, 56.174],
              [15.312, 56.17],
              [15.309, 56.161],
              [15.308, 56.157],
              [15.304, 56.153],
              [15.297, 56.148],
              [15.295, 56.146],
              [15.293, 56.142],
              [15.294, 56.139],
              [15.296, 56.137],
              [15.298, 56.136],
              [15.301, 56.134],
              [15.313, 56.134],
              [15.317, 56.136],
              [15.324, 56.139],
              [15.326, 56.14],
              [15.328, 56.14],
              [15.329, 56.139],
              [15.329, 56.134],
              [15.33, 56.132],
              [15.332, 56.131],
              [15.334, 56.131],
              [15.336, 56.13],
              [15.342, 56.129],
              [15.346, 56.128],
              [15.35, 56.128],
              [15.354, 56.129],
              [15.359, 56.131],
              [15.363, 56.134],
              [15.368, 56.138],
              [15.372, 56.141],
              [15.376, 56.145],
              [15.379, 56.149],
              [15.383, 56.157],
              [15.384, 56.161],
              [15.386, 56.164],
              [15.387, 56.166],
              [15.396, 56.172],
              [15.4, 56.174],
              [15.405, 56.176],
              [15.409, 56.177],
              [15.432, 56.177],
              [15.438, 56.176],
              [15.444, 56.174],
              [15.454, 56.17],
              [15.464, 56.165],
              [15.471, 56.162],
              [15.474, 56.16],
              [15.481, 56.16],
              [15.485, 56.161],
              [15.488, 56.163],
              [15.494, 56.169],
              [15.5, 56.171],
              [15.508, 56.173],
              [15.52, 56.174],
              [15.524, 56.175],
              [15.533, 56.181],
              [15.538, 56.183],
              [15.542, 56.186],
              [15.552, 56.19],
              [15.558, 56.191],
              [15.563, 56.193],
              [15.57, 56.196],
              [15.574, 56.198],
              [15.578, 56.199],
              [15.593, 56.202],
              [15.601, 56.2],
              [15.614, 56.195],
              [15.619, 56.193],
              [15.639, 56.189],
              [15.642, 56.189],
              [15.646, 56.188],
              [15.649, 56.186],
              [15.657, 56.182],
              [15.659, 56.18],
              [15.662, 56.178],
              [15.665, 56.174],
              [15.667, 56.173],
              [15.668, 56.172],
              [15.669, 56.172],
              [15.67, 56.173],
              [15.671, 56.176],
              [15.672, 56.177],
              [15.674, 56.178],
              [15.675, 56.179],
              [15.687, 56.179],
              [15.691, 56.178],
              [15.694, 56.177],
              [15.696, 56.175],
              [15.701, 56.171],
              [15.703, 56.169],
              [15.705, 56.168],
              [15.707, 56.168],
              [15.71, 56.167],
              [15.714, 56.167],
              [15.717, 56.166],
              [15.721, 56.165],
              [15.724, 56.163],
              [15.732, 56.159],
              [15.736, 56.158],
              [15.739, 56.157],
              [15.746, 56.156],
              [15.748, 56.156],
              [15.748, 56.154],
              [15.749, 56.151],
              [15.75, 56.15],
              [15.751, 56.148],
              [15.753, 56.147],
              [15.759, 56.145],
              [15.768, 56.145],
              [15.772, 56.146],
              [15.775, 56.147],
              [15.779, 56.148],
              [15.781, 56.149],
              [15.786, 56.152],
              [15.789, 56.153],
              [15.795, 56.158],
              [15.803, 56.162],
              [15.808, 56.163],
              [15.815, 56.163],
              [15.818, 56.162],
              [15.819, 56.16],
              [15.817, 56.154],
              [15.816, 56.15],
              [15.814, 56.147],
              [15.803, 56.136],
              [15.799, 56.131],
              [15.796, 56.127],
              [15.794, 56.122],
              [15.792, 56.114],
              [15.793, 56.11],
              [15.794, 56.107],
              [15.797, 56.104],
              [15.8, 56.102],
              [15.808, 56.098],
              [15.813, 56.096],
              [15.817, 56.093],
              [15.825, 56.088],
              [15.829, 56.085],
              [15.833, 56.083],
              [15.841, 56.081],
              [15.844, 56.082],
              [15.846, 56.083],
              [15.849, 56.085],
              [15.865, 56.096],
              [15.869, 56.1],
              [15.874, 56.104],
              [15.883, 56.113],
              [15.887, 56.118],
              [15.9, 56.135],
              [15.904, 56.14],
              [15.909, 56.145],
              [15.914, 56.149],
              [15.918, 56.153],
              [15.923, 56.157],
              [15.928, 56.16],
              [15.934, 56.164],
              [15.949, 56.176],
              [15.953, 56.18],
              [15.96, 56.188],
              [15.965, 56.192],
              [15.968, 56.195],
              [15.972, 56.197],
              [15.976, 56.2],
              [15.989, 56.205],
              [15.993, 56.207],
              [15.997, 56.211],
              [16.001, 56.214],
              [16.005, 56.218],
              [16.018, 56.236],
              [16.022, 56.241],
              [16.025, 56.244],
              [16.029, 56.247],
              [16.032, 56.25],
              [16.038, 56.255],
              [16.04, 56.257],
              [16.042, 56.263],
              [16.043, 56.27],
              [16.044, 56.275],
              [16.046, 56.28],
              [16.051, 56.294],
              [16.052, 56.299],
              [16.395, 56.299],
              [16.395, 56.278],
              [16.397, 56.266],
              [16.4, 56.256],
              [16.401, 56.25],
              [16.401, 56.238],
              [16.4, 56.232],
              [16.397, 56.216],
              [16.396, 56.211],
              [16.396, 56.208],
              [16.397, 56.206],
              [16.398, 56.205],
              [16.401, 56.203],
              [16.405, 56.201],
              [16.413, 56.203],
              [16.418, 56.204],
              [16.423, 56.207],
              [16.428, 56.209],
              [16.452, 56.221],
              [16.457, 56.225],
              [16.463, 56.229],
              [16.469, 56.232],
              [16.474, 56.237],
              [16.479, 56.241],
              [16.483, 56.246],
              [16.488, 56.252],
              [16.492, 56.257],
              [16.496, 56.263],
              [16.508, 56.28],
              [16.521, 56.299],
              [16.997, 56.298],
              [17, 54.639],
              [16.989, 54.633],
              [16.977, 54.626],
              [16.965, 54.62],
              [16.958, 54.616],
              [16.952, 54.614],
              [16.946, 54.611],
              [16.939, 54.608],
              [16.926, 54.604],
              [16.92, 54.602],
              [16.913, 54.6],
              [16.907, 54.598],
              [16.9, 54.596],
              [16.886, 54.594],
              [16.858, 54.591],
              [16.851, 54.59],
              [16.845, 54.589],
              [16.838, 54.588],
              [16.825, 54.585],
              [16.799, 54.578],
              [16.786, 54.575],
              [16.779, 54.574],
              [16.773, 54.573],
              [16.759, 54.571],
              [16.753, 54.57],
              [16.732, 54.57],
              [16.704, 54.569],
              [16.691, 54.569],
              [16.684, 54.568],
              [16.658, 54.566],
              [16.638, 54.563],
              [16.612, 54.559],
              [16.599, 54.556],
              [16.58, 54.552],
              [16.566, 54.549],
              [16.553, 54.546],
              [16.541, 54.542],
              [16.534, 54.54],
              [16.528, 54.537],
              [16.521, 54.535],
              [16.508, 54.529],
              [16.496, 54.522],
              [16.483, 54.515],
              [16.471, 54.509],
              [16.458, 54.502],
              [16.44, 54.49],
              [16.435, 54.486],
              [16.429, 54.482],
              [16.42, 54.474],
              [16.405, 54.461],
              [16.39, 54.449],
              [16.374, 54.439],
              [16.369, 54.435],
              [16.364, 54.43],
              [16.359, 54.426],
              [16.335, 54.403],
              [16.33, 54.399],
              [16.325, 54.394],
              [16.32, 54.39],
              [16.314, 54.386],
              [16.303, 54.378],
              [16.287, 54.366],
              [16.27, 54.355],
              [16.258, 54.348],
              [16.253, 54.344],
              [16.235, 54.334],
              [16.212, 54.321],
              [16.194, 54.311],
              [16.181, 54.305],
              [16.175, 54.302],
              [16.162, 54.297],
              [16.142, 54.289],
              [16.129, 54.285],
              [16.116, 54.28],
              [16.103, 54.276],
              [16.089, 54.272],
              [16.076, 54.269],
              [16.036, 54.261],
              [16.022, 54.259],
              [16.009, 54.256],
              [16.002, 54.255],
              [15.988, 54.254],
              [15.968, 54.252],
              [15.899, 54.246],
              [15.878, 54.244],
              [15.829, 54.237],
              [15.816, 54.234],
              [15.698, 54.207],
              [15.677, 54.202],
              [15.663, 54.2],
              [15.649, 54.197],
              [15.636, 54.195],
              [15.608, 54.191],
              [15.595, 54.19],
              [15.588, 54.189],
              [15.569, 54.188],
              [15.563, 54.187],
              [15.557, 54.187],
              [15.551, 54.185],
              [15.545, 54.184],
              [15.527, 54.178],
              [15.514, 54.174],
              [15.508, 54.173],
              [15.496, 54.17],
              [15.489, 54.168],
              [15.468, 54.165],
              [15.447, 54.163],
              [15.341, 54.154],
              [15.313, 54.151],
              [15.271, 54.145],
              [15.257, 54.142],
              [15.236, 54.137],
              [14.967, 54.071],
              [14.925, 54.061],
              [14.904, 54.057],
              [14.884, 54.053],
              [14.761, 54.03],
              [14.741, 54.025],
              [14.713, 54.019],
              [14.693, 54.014],
              [14.563, 53.98],
              [14.543, 53.975],
              [14.529, 53.971],
              [14.516, 53.967],
              [14.509, 53.965],
              [14.497, 53.959],
              [14.49, 53.957],
              [14.484, 53.953],
              [14.454, 53.938],
              [14.447, 53.935],
              [14.441, 53.932],
              [14.417, 53.924],
              [14.404, 53.92],
              [14.398, 53.919],
              [14.391, 53.917],
              [14.37, 53.914],
              [14.363, 53.914],
              [14.356, 53.913],
              [14.348, 53.913],
              [14.341, 53.914],
              [14.335, 53.914],
              [14.309, 53.917],
              [14.291, 53.917],
              [14.286, 53.916],
              [14.284, 53.915],
              [14.281, 53.913],
              [14.277, 53.911],
              [14.274, 53.908],
              [14.27, 53.905],
              [14.268, 53.902],
              [14.267, 53.899],
              [14.268, 53.896],
              [14.27, 53.893],
              [14.276, 53.886],
              [14.282, 53.878],
              [14.288, 53.872],
              [14.292, 53.87],
              [14.296, 53.869],
              [14.339, 53.869],
              [14.345, 53.868],
              [14.36, 53.864],
              [14.369, 53.864],
              [14.375, 53.866],
              [14.376, 53.868],
              [14.376, 53.871],
              [14.373, 53.875],
              [14.373, 53.877],
              [14.374, 53.878],
              [14.375, 53.88],
              [14.381, 53.886],
              [14.385, 53.889],
              [14.39, 53.89],
              [14.395, 53.892],
              [14.42, 53.892],
              [14.426, 53.893],
              [14.43, 53.893],
              [14.43, 53.892],
              [14.431, 53.89],
              [14.431, 53.887],
              [14.432, 53.88],
              [14.432, 53.876],
              [14.434, 53.873],
              [14.437, 53.871],
              [14.441, 53.869],
              [14.446, 53.867],
              [14.464, 53.864],
              [14.478, 53.863],
              [14.513, 53.861],
              [14.526, 53.859],
              [14.54, 53.857],
              [14.546, 53.856],
              [14.551, 53.854],
              [14.557, 53.852],
              [14.562, 53.85],
              [14.57, 53.844],
              [14.573, 53.841],
              [14.577, 53.833],
              [14.578, 53.827],
              [14.579, 53.823],
              [14.583, 53.817],
              [14.585, 53.815],
              [14.587, 53.815],
              [14.59, 53.816],
              [14.593, 53.818],
              [14.6, 53.824],
              [14.606, 53.828],
              [14.614, 53.833],
              [14.616, 53.834],
              [14.617, 53.834],
              [14.617, 53.831],
              [14.616, 53.829],
              [14.614, 53.823],
              [14.613, 53.819],
              [14.612, 53.814],
              [14.612, 53.808],
              [14.611, 53.796],
              [14.611, 53.79],
              [14.61, 53.784],
              [14.608, 53.778],
              [14.606, 53.774],
              [14.603, 53.77],
              [14.6, 53.767],
              [14.595, 53.764],
              [14.591, 53.762],
              [14.586, 53.76],
              [14.581, 53.759],
              [14.569, 53.756],
              [14.565, 53.754],
              [14.562, 53.752],
              [14.555, 53.745],
              [14.552, 53.74],
              [14.549, 53.734],
              [14.545, 53.722],
              [14.543, 53.71],
              [14.542, 53.703],
              [14.544, 53.691],
              [14.547, 53.685],
              [14.55, 53.68],
              [14.553, 53.676],
              [14.557, 53.672],
              [14.561, 53.669],
              [14.571, 53.663],
              [14.577, 53.661],
              [14.582, 53.66],
              [14.597, 53.656],
              [14.601, 53.655],
              [14.609, 53.652],
              [14.612, 53.651],
              [14.613, 53.65],
              [14.614, 53.648],
              [14.615, 53.647],
              [14.616, 53.644],
              [14.615, 53.642],
              [14.615, 53.64],
              [14.613, 53.634],
              [14.612, 53.632],
              [14.61, 53.629],
              [14.605, 53.623],
              [14.602, 53.62],
              [14.596, 53.608],
              [14.593, 53.605],
              [14.591, 53.602],
              [14.588, 53.601],
              [14.584, 53.601],
              [14.576, 53.603],
              [14.572, 53.605],
              [14.56, 53.617],
              [14.549, 53.632],
              [14.545, 53.637],
              [14.536, 53.646],
              [14.532, 53.649],
              [14.527, 53.653],
              [14.522, 53.655],
              [14.516, 53.658],
              [14.509, 53.66],
              [14.503, 53.662],
              [14.496, 53.664],
              [14.47, 53.67],
              [14.442, 53.675],
              [14.429, 53.678],
              [14.422, 53.679],
              [14.416, 53.681],
              [14.409, 53.683],
              [14.403, 53.685],
              [14.396, 53.687],
              [14.384, 53.693],
              [14.378, 53.697],
              [14.366, 53.704],
              [14.338, 53.723],
              [14.332, 53.727],
              [14.326, 53.73],
              [14.316, 53.736],
              [14.311, 53.737],
              [14.303, 53.739],
              [14.298, 53.739],
              [14.297, 53.738],
              [14.297, 53.735],
              [14.296, 53.734],
              [14.294, 53.73],
              [14.292, 53.728],
              [14.29, 53.724],
              [14.291, 53.722],
              [14.294, 53.717],
              [14.296, 53.714],
              [14.297, 53.711],
              [14.297, 53.709],
              [14.296, 53.707],
              [14.294, 53.704],
              [14.291, 53.702],
              [14.281, 53.698],
              [14.276, 53.697],
              [14.27, 53.696],
              [14.264, 53.696],
              [14.258, 53.695],
              [14.253, 53.696],
              [14.248, 53.696],
              [14.243, 53.697],
              [14.239, 53.698],
              [14.235, 53.7],
              [14.233, 53.702],
              [14.232, 53.704],
              [14.232, 53.706],
              [14.233, 53.709],
              [14.236, 53.712],
              [14.249, 53.722],
              [14.257, 53.73],
              [14.261, 53.738],
              [14.26, 53.742],
              [14.259, 53.745],
              [14.256, 53.749],
              [14.253, 53.751],
              [14.248, 53.754],
              [14.243, 53.755],
              [14.237, 53.756],
              [14.231, 53.756],
              [14.225, 53.755],
              [14.218, 53.753],
              [14.212, 53.751],
              [14.199, 53.746],
              [14.187, 53.742],
              [14.18, 53.741],
              [14.174, 53.74],
              [14.156, 53.741],
              [14.117, 53.741],
              [14.11, 53.742],
              [14.092, 53.745],
              [14.086, 53.747],
              [14.061, 53.753],
              [14.055, 53.755],
              [14.041, 53.758],
              [14.005, 53.765],
              [13.992, 53.769],
              [13.985, 53.77],
              [13.978, 53.772],
              [13.971, 53.775],
              [13.959, 53.781],
              [13.952, 53.784],
              [13.934, 53.794],
              [13.922, 53.8],
              [13.915, 53.802],
              [13.895, 53.81],
              [13.88, 53.819],
              [13.87, 53.827],
              [13.865, 53.83],
              [13.861, 53.833],
              [13.856, 53.836],
              [13.851, 53.838],
              [13.847, 53.839],
              [13.832, 53.844],
              [13.827, 53.845],
              [13.823, 53.847],
              [13.821, 53.85],
              [13.819, 53.852],
              [13.817, 53.855],
              [13.817, 53.857],
              [13.818, 53.86],
              [13.82, 53.863],
              [13.822, 53.867],
              [13.825, 53.87],
              [13.829, 53.873],
              [13.832, 53.875],
              [13.845, 53.882],
              [13.851, 53.886],
              [13.861, 53.893],
              [13.867, 53.897],
              [13.872, 53.9],
              [13.888, 53.908],
              [13.893, 53.91],
              [13.897, 53.913],
              [13.9, 53.916],
              [13.902, 53.919],
              [13.902, 53.926],
              [13.9, 53.93],
              [13.898, 53.933],
              [13.894, 53.937],
              [13.886, 53.943],
              [13.881, 53.946],
              [13.877, 53.948],
              [13.867, 53.952],
              [13.857, 53.958],
              [13.852, 53.963],
              [13.842, 53.971],
              [13.837, 53.976],
              [13.832, 53.98],
              [13.814, 53.989],
              [13.795, 53.998],
              [13.783, 54.004],
              [13.773, 54.01],
              [13.768, 54.014],
              [13.764, 54.017],
              [13.761, 54.02],
              [13.759, 54.024],
              [13.757, 54.027],
              [13.756, 54.03],
              [13.758, 54.033],
              [13.77, 54.045],
              [13.774, 54.048],
              [13.778, 54.054],
              [13.781, 54.059],
              [13.785, 54.066],
              [13.787, 54.069],
              [13.79, 54.074],
              [13.792, 54.084],
              [13.793, 54.09],
              [13.792, 54.095],
              [13.791, 54.099],
              [13.785, 54.107],
              [13.777, 54.113],
              [13.765, 54.121],
              [13.761, 54.123],
              [13.753, 54.131],
              [13.75, 54.133],
              [13.746, 54.135],
              [13.741, 54.136],
              [13.732, 54.139],
              [13.727, 54.14],
              [13.723, 54.142],
              [13.718, 54.144],
              [13.714, 54.147],
              [13.71, 54.149],
              [13.707, 54.152],
              [13.705, 54.156],
              [13.705, 54.162],
              [13.704, 54.163],
              [13.703, 54.165],
              [13.697, 54.167],
              [13.689, 54.167],
              [13.683, 54.166],
              [13.673, 54.164],
              [13.663, 54.16],
              [13.659, 54.158],
              [13.656, 54.156],
              [13.652, 54.153],
              [13.651, 54.152],
              [13.648, 54.151],
              [13.641, 54.149],
              [13.636, 54.148],
              [13.626, 54.144],
              [13.62, 54.142],
              [13.613, 54.14],
              [13.607, 54.139],
              [13.6, 54.137],
              [13.586, 54.135],
              [13.536, 54.128],
              [13.523, 54.126],
              [13.516, 54.124],
              [13.51, 54.123],
              [13.504, 54.121],
              [13.499, 54.119],
              [13.495, 54.117],
              [13.492, 54.114],
              [13.49, 54.11],
              [13.49, 54.106],
              [13.489, 54.098],
              [13.489, 54.095],
              [13.487, 54.092],
              [13.485, 54.091],
              [13.482, 54.09],
              [13.478, 54.09],
              [13.473, 54.091],
              [13.469, 54.092],
              [13.464, 54.094],
              [13.46, 54.097],
              [13.455, 54.1],
              [13.451, 54.104],
              [13.447, 54.109],
              [13.435, 54.123],
              [13.431, 54.128],
              [13.423, 54.136],
              [13.419, 54.139],
              [13.408, 54.147],
              [13.406, 54.148],
              [13.403, 54.149],
              [13.394, 54.151],
              [13.392, 54.151],
              [13.392, 54.152],
              [13.391, 54.154],
              [13.395, 54.162],
              [13.395, 54.164],
              [13.394, 54.166],
              [13.392, 54.168],
              [13.389, 54.17],
              [13.381, 54.172],
              [13.371, 54.172],
              [13.364, 54.171],
              [13.358, 54.17],
              [13.341, 54.167],
              [13.336, 54.166],
              [13.331, 54.166],
              [13.331, 54.169],
              [13.333, 54.173],
              [13.334, 54.176],
              [13.334, 54.178],
              [13.33, 54.184],
              [13.326, 54.188],
              [13.323, 54.192],
              [13.311, 54.206],
              [13.307, 54.211],
              [13.302, 54.216],
              [13.298, 54.221],
              [13.293, 54.225],
              [13.287, 54.229],
              [13.282, 54.231],
              [13.27, 54.235],
              [13.263, 54.236],
              [13.237, 54.241],
              [13.231, 54.243],
              [13.225, 54.244],
              [13.22, 54.247],
              [13.207, 54.253],
              [13.202, 54.255],
              [13.196, 54.258],
              [13.19, 54.26],
              [13.184, 54.261],
              [13.197, 54.284],
              [13.199, 54.282],
              [13.202, 54.28],
              [13.205, 54.277],
              [13.208, 54.276],
              [13.211, 54.274],
              [13.219, 54.272],
              [13.227, 54.269],
              [13.251, 54.261],
              [13.258, 54.26],
              [13.264, 54.258],
              [13.271, 54.257],
              [13.277, 54.257],
              [13.283, 54.256],
              [13.289, 54.257],
              [13.295, 54.257],
              [13.305, 54.259],
              [13.309, 54.26],
              [13.312, 54.261],
              [13.315, 54.263],
              [13.317, 54.265],
              [13.32, 54.267],
              [13.324, 54.269],
              [13.326, 54.269],
              [13.327, 54.268],
              [13.327, 54.267],
              [13.326, 54.264],
              [13.325, 54.262],
              [13.323, 54.259],
              [13.32, 54.256],
              [13.317, 54.254],
              [13.314, 54.253],
              [13.307, 54.251],
              [13.305, 54.249],
              [13.309, 54.245],
              [13.324, 54.239],
              [13.33, 54.237],
              [13.337, 54.236],
              [13.343, 54.235],
              [13.357, 54.232],
              [13.37, 54.23],
              [13.383, 54.229],
              [13.388, 54.228],
              [13.394, 54.228],
              [13.399, 54.229],
              [13.404, 54.231],
              [13.408, 54.234],
              [13.411, 54.237],
              [13.413, 54.241],
              [13.414, 54.244],
              [13.413, 54.247],
              [13.411, 54.25],
              [13.408, 54.253],
              [13.4, 54.257],
              [13.395, 54.258],
              [13.368, 54.258],
              [13.363, 54.256],
              [13.361, 54.256],
              [13.359, 54.258],
              [13.358, 54.261],
              [13.36, 54.265],
              [13.362, 54.268],
              [13.365, 54.269],
              [13.369, 54.271],
              [13.372, 54.272],
              [13.38, 54.274],
              [13.384, 54.274],
              [13.39, 54.276],
              [13.396, 54.279],
              [13.4, 54.282],
              [13.417, 54.296],
              [13.422, 54.299],
              [13.427, 54.303],
              [13.445, 54.313],
              [13.449, 54.316],
              [13.453, 54.318],
              [13.455, 54.321],
              [13.457, 54.323],
              [13.459, 54.327],
              [13.462, 54.33],
              [13.465, 54.331],
              [13.484, 54.336],
              [13.495, 54.339],
              [13.513, 54.342],
              [13.519, 54.342],
              [13.538, 54.343],
              [13.55, 54.343],
              [13.567, 54.346],
              [13.578, 54.346],
              [13.59, 54.344],
              [13.607, 54.34],
              [13.613, 54.339],
              [13.624, 54.339],
              [13.634, 54.341],
              [13.639, 54.343],
              [13.648, 54.346],
              [13.652, 54.347],
              [13.653, 54.348],
              [13.666, 54.348],
              [13.669, 54.347],
              [13.671, 54.346],
              [13.672, 54.345],
              [13.672, 54.344],
              [13.671, 54.342],
              [13.668, 54.34],
              [13.664, 54.337],
              [13.66, 54.335],
              [13.655, 54.333],
              [13.649, 54.33],
              [13.63, 54.323],
              [13.628, 54.322],
              [13.627, 54.321],
              [13.631, 54.321],
              [13.646, 54.324],
              [13.664, 54.327],
              [13.676, 54.327],
              [13.681, 54.326],
              [13.685, 54.325],
              [13.688, 54.324],
              [13.69, 54.322],
              [13.69, 54.32],
              [13.689, 54.318],
              [13.687, 54.315],
              [13.683, 54.312],
              [13.679, 54.31],
              [13.67, 54.305],
              [13.666, 54.302],
              [13.664, 54.3],
              [13.662, 54.297],
              [13.665, 54.294],
              [13.667, 54.293],
              [13.671, 54.292],
              [13.675, 54.292],
              [13.684, 54.291],
              [13.689, 54.29],
              [13.695, 54.288],
              [13.698, 54.285],
              [13.698, 54.284],
              [13.697, 54.282],
              [13.697, 54.28],
              [13.698, 54.279],
              [13.702, 54.277],
              [13.705, 54.276],
              [13.708, 54.277],
              [13.711, 54.277],
              [13.714, 54.279],
              [13.716, 54.281],
              [13.72, 54.289],
              [13.725, 54.305],
              [13.728, 54.311],
              [13.731, 54.316],
              [13.734, 54.322],
              [13.751, 54.339],
              [13.752, 54.342],
              [13.751, 54.344],
              [13.748, 54.347],
              [13.745, 54.349],
              [13.73, 54.358],
              [13.725, 54.362],
              [13.719, 54.365],
              [13.696, 54.382],
              [13.69, 54.386],
              [13.684, 54.389],
              [13.678, 54.393],
              [13.672, 54.395],
              [13.665, 54.397],
              [13.659, 54.398],
              [13.652, 54.399],
              [13.639, 54.401],
              [13.633, 54.402],
              [13.626, 54.403],
              [13.62, 54.405],
              [13.608, 54.411],
              [13.603, 54.415],
              [13.593, 54.425],
              [13.589, 54.431],
              [13.585, 54.439],
              [13.581, 54.446],
              [13.578, 54.453],
              [13.576, 54.46],
              [13.575, 54.467],
              [13.575, 54.478],
              [13.578, 54.479],
              [13.584, 54.48],
              [13.588, 54.482],
              [13.591, 54.483],
              [13.594, 54.485],
              [13.605, 54.492],
              [13.611, 54.496],
              [13.616, 54.499],
              [13.622, 54.502],
              [13.627, 54.504],
              [13.631, 54.506],
              [13.639, 54.509],
              [13.645, 54.51],
              [13.648, 54.511],
              [13.651, 54.513],
              [13.655, 54.515],
              [13.663, 54.521],
              [13.671, 54.529],
              [13.675, 54.539],
              [13.676, 54.544],
              [13.676, 54.549],
              [13.674, 54.559],
              [13.668, 54.567],
              [13.665, 54.57],
              [13.655, 54.576],
              [13.649, 54.579],
              [13.643, 54.581],
              [13.629, 54.583],
              [13.609, 54.583],
              [13.594, 54.582],
              [13.51, 54.574],
              [13.482, 54.572],
              [13.461, 54.572],
              [13.447, 54.574],
              [13.441, 54.575],
              [13.434, 54.577],
              [13.422, 54.581],
              [13.416, 54.584],
              [13.411, 54.588],
              [13.406, 54.591],
              [13.401, 54.595],
              [13.397, 54.599],
              [13.393, 54.604],
              [13.39, 54.608],
              [13.39, 54.609],
              [13.387, 54.615],
              [13.385, 54.621],
              [13.385, 54.633],
              [13.387, 54.637],
              [13.39, 54.642],
              [13.393, 54.646],
              [13.397, 54.65],
              [13.402, 54.653],
              [13.416, 54.661],
              [13.42, 54.664],
              [13.423, 54.667],
              [13.425, 54.67],
              [13.426, 54.672],
              [13.426, 54.675],
              [13.425, 54.677],
              [12.812, 55.378],
            ],
          ],
        ],
      },
      properties: {
        id: 52,
        name: 'Södra Östersjön',
        latlon: [55.232782, 15.315223],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [20.003, 60.243],
              [20.001, 60.245],
              [19.998, 60.249],
              [19.986, 60.262],
              [19.983, 60.266],
              [19.98, 60.271],
              [19.978, 60.275],
              [19.976, 60.281],
              [19.976, 60.285],
              [19.977, 60.284],
              [19.979, 60.281],
              [19.98, 60.278],
              [19.982, 60.276],
              [19.984, 60.275],
              [19.99, 60.271],
              [19.998, 60.267],
              [20.002, 60.266],
              [20.003, 60.266],
              [20.007, 60.265],
              [20.01, 60.265],
              [20.014, 60.266],
              [20.02, 60.272],
              [20.022, 60.275],
              [20.025, 60.28],
              [20.031, 60.286],
              [20.033, 60.289],
              [20.034, 60.292],
              [20.036, 60.294],
              [20.036, 60.296],
              [20.037, 60.299],
              [20.039, 60.304],
              [20.04, 60.308],
              [20.041, 60.309],
              [20.044, 60.309],
              [20.045, 60.308],
              [20.047, 60.304],
              [20.047, 60.302],
              [20.045, 60.294],
              [20.041, 60.286],
              [20.039, 60.281],
              [20.038, 60.278],
              [20.036, 60.276],
              [20.032, 60.27],
              [20.029, 60.267],
              [20.025, 60.259],
              [20.024, 60.255],
              [20.023, 60.252],
              [20.023, 60.248],
              [20.024, 60.245],
              [20.026, 60.243],
              [20.027, 60.241],
              [20.031, 60.237],
              [20.034, 60.233],
              [20.036, 60.23],
              [20.038, 60.225],
              [20.04, 60.218],
              [20.044, 60.212],
              [20.05, 60.208],
              [20.054, 60.207],
              [20.058, 60.207],
              [20.062, 60.208],
              [20.07, 60.212],
              [20.073, 60.214],
              [20.075, 60.217],
              [20.078, 60.219],
              [20.079, 60.219],
              [20.079, 60.214],
              [20.075, 60.202],
              [20.075, 60.199],
              [20.077, 60.196],
              [20.08, 60.193],
              [20.084, 60.191],
              [20.088, 60.19],
              [20.093, 60.189],
              [20.097, 60.188],
              [20.103, 60.189],
              [20.119, 60.189],
              [20.125, 60.188],
              [20.136, 60.185],
              [20.142, 60.183],
              [20.154, 60.181],
              [20.17, 60.181],
              [20.174, 60.182],
              [20.177, 60.184],
              [20.183, 60.187],
              [20.19, 60.19],
              [20.193, 60.192],
              [20.197, 60.195],
              [20.2, 60.197],
              [20.204, 60.198],
              [20.208, 60.2],
              [20.214, 60.201],
              [20.218, 60.202],
              [20.226, 60.206],
              [20.229, 60.208],
              [20.231, 60.211],
              [20.232, 60.213],
              [20.232, 60.219],
              [20.23, 60.221],
              [20.227, 60.227],
              [20.225, 60.23],
              [20.223, 60.236],
              [20.224, 60.238],
              [20.228, 60.24],
              [20.235, 60.242],
              [20.238, 60.243],
              [20.242, 60.245],
              [20.245, 60.248],
              [20.247, 60.251],
              [20.25, 60.254],
              [20.256, 60.266],
              [20.26, 60.273],
              [20.261, 60.277],
              [20.262, 60.28],
              [20.262, 60.283],
              [20.26, 60.285],
              [20.256, 60.288],
              [20.252, 60.29],
              [20.246, 60.292],
              [20.24, 60.293],
              [20.228, 60.296],
              [20.222, 60.298],
              [20.211, 60.3],
              [20.201, 60.3],
              [20.198, 60.299],
              [20.191, 60.296],
              [20.187, 60.296],
              [20.186, 60.297],
              [20.186, 60.298],
              [20.187, 60.301],
              [20.189, 60.304],
              [20.194, 60.311],
              [20.197, 60.315],
              [20.199, 60.318],
              [20.2, 60.322],
              [20.2, 60.327],
              [20.198, 60.33],
              [20.188, 60.339],
              [20.186, 60.341],
              [20.182, 60.344],
              [20.172, 60.346],
              [20.168, 60.347],
              [20.16, 60.347],
              [20.158, 60.345],
              [20.157, 60.343],
              [20.157, 60.341],
              [20.159, 60.335],
              [20.159, 60.331],
              [20.157, 60.331],
              [20.155, 60.332],
              [20.148, 60.336],
              [20.14, 60.34],
              [20.137, 60.342],
              [20.132, 60.347],
              [20.131, 60.347],
              [20.129, 60.348],
              [20.124, 60.349],
              [20.121, 60.35],
              [20.114, 60.352],
              [20.11, 60.354],
              [20.109, 60.354],
              [20.109, 60.357],
              [20.112, 60.36],
              [20.116, 60.362],
              [20.116, 60.364],
              [20.114, 60.366],
              [20.111, 60.367],
              [20.107, 60.369],
              [20.103, 60.37],
              [20.088, 60.373],
              [20.082, 60.373],
              [20.078, 60.372],
              [20.075, 60.371],
              [20.07, 60.368],
              [20.065, 60.368],
              [20.061, 60.369],
              [20.052, 60.369],
              [20.049, 60.37],
              [20.042, 60.372],
              [20.029, 60.372],
              [20.025, 60.371],
              [20.022, 60.37],
              [20.02, 60.368],
              [20.017, 60.364],
              [20.015, 60.363],
              [20.013, 60.363],
              [20.011, 60.364],
              [20.004, 60.367],
              [20.003, 60.368],
              [20.003, 60.521],
              [21.574, 60.522],
              [21.579, 60.509],
              [21.581, 60.503],
              [21.584, 60.501],
              [21.587, 60.5],
              [21.59, 60.498],
              [21.6, 60.498],
              [21.606, 60.499],
              [21.612, 60.501],
              [21.619, 60.503],
              [21.631, 60.507],
              [21.649, 60.516],
              [21.655, 60.52],
              [21.663, 60.528],
              [21.667, 60.533],
              [21.67, 60.537],
              [21.673, 60.542],
              [21.675, 60.547],
              [21.676, 60.551],
              [21.677, 60.556],
              [21.677, 60.565],
              [21.679, 60.57],
              [21.681, 60.574],
              [21.684, 60.579],
              [21.692, 60.585],
              [21.696, 60.587],
              [21.705, 60.592],
              [21.708, 60.594],
              [21.712, 60.597],
              [21.714, 60.598],
              [21.718, 60.598],
              [21.726, 60.597],
              [21.731, 60.596],
              [21.736, 60.596],
              [21.741, 60.597],
              [21.747, 60.598],
              [21.752, 60.599],
              [21.759, 60.601],
              [21.765, 60.604],
              [21.772, 60.607],
              [21.778, 60.61],
              [21.797, 60.62],
              [21.803, 60.623],
              [21.81, 60.626],
              [21.815, 60.628],
              [21.819, 60.629],
              [21.824, 60.631],
              [21.832, 60.631],
              [21.835, 60.63],
              [21.837, 60.628],
              [21.838, 60.626],
              [21.839, 60.623],
              [21.839, 60.62],
              [21.838, 60.616],
              [21.837, 60.613],
              [21.833, 60.603],
              [21.832, 60.6],
              [21.828, 60.594],
              [21.826, 60.59],
              [21.824, 60.582],
              [21.822, 60.572],
              [21.819, 60.56],
              [21.818, 60.552],
              [21.817, 60.548],
              [21.815, 60.543],
              [21.812, 60.538],
              [21.81, 60.533],
              [21.803, 60.523],
              [21.798, 60.514],
              [21.795, 60.511],
              [21.791, 60.509],
              [21.785, 60.507],
              [21.781, 60.507],
              [21.779, 60.508],
              [21.778, 60.509],
              [21.778, 60.512],
              [21.779, 60.515],
              [21.781, 60.518],
              [21.786, 60.526],
              [21.789, 60.53],
              [21.79, 60.534],
              [21.79, 60.538],
              [21.789, 60.542],
              [21.786, 60.545],
              [21.783, 60.547],
              [21.779, 60.548],
              [21.769, 60.55],
              [21.764, 60.55],
              [21.759, 60.549],
              [21.754, 60.547],
              [21.744, 60.541],
              [21.734, 60.534],
              [21.725, 60.528],
              [21.717, 60.522],
              [21.711, 60.514],
              [21.704, 60.5],
              [21.703, 60.497],
              [21.702, 60.493],
              [21.701, 60.49],
              [21.701, 60.474],
              [21.702, 60.47],
              [21.708, 60.466],
              [21.717, 60.466],
              [21.721, 60.467],
              [21.727, 60.471],
              [21.731, 60.475],
              [21.732, 60.478],
              [21.735, 60.483],
              [21.736, 60.486],
              [21.738, 60.488],
              [21.74, 60.489],
              [21.741, 60.49],
              [21.743, 60.489],
              [21.745, 60.487],
              [21.751, 60.485],
              [21.754, 60.483],
              [21.763, 60.483],
              [21.767, 60.484],
              [21.772, 60.485],
              [21.782, 60.489],
              [21.806, 60.493],
              [21.824, 60.495],
              [21.841, 60.495],
              [21.859, 60.492],
              [21.864, 60.491],
              [21.878, 60.487],
              [21.883, 60.486],
              [21.887, 60.485],
              [21.9, 60.485],
              [21.902, 60.486],
              [21.903, 60.487],
              [21.903, 60.489],
              [21.902, 60.491],
              [21.894, 60.499],
              [21.888, 60.507],
              [21.886, 60.511],
              [21.884, 60.514],
              [21.884, 60.517],
              [21.886, 60.521],
              [21.89, 60.524],
              [21.896, 60.53],
              [21.899, 60.532],
              [21.901, 60.534],
              [21.909, 60.534],
              [21.92, 60.532],
              [21.925, 60.531],
              [21.931, 60.531],
              [21.942, 60.53],
              [21.952, 60.528],
              [21.955, 60.527],
              [21.957, 60.525],
              [21.963, 60.516],
              [21.966, 60.514],
              [21.968, 60.512],
              [21.971, 60.51],
              [21.974, 60.509],
              [21.986, 60.506],
              [21.989, 60.504],
              [21.991, 60.502],
              [21.994, 60.497],
              [21.999, 60.492],
              [22.003, 60.49],
              [22.006, 60.489],
              [22.013, 60.487],
              [22.015, 60.486],
              [22.018, 60.485],
              [22.021, 60.482],
              [22.022, 60.48],
              [22.025, 60.476],
              [22.025, 60.473],
              [22.024, 60.472],
              [22.024, 60.469],
              [22.028, 60.465],
              [22.032, 60.463],
              [22.037, 60.461],
              [22.042, 60.46],
              [22.048, 60.458],
              [22.073, 60.453],
              [22.079, 60.452],
              [22.084, 60.451],
              [22.095, 60.451],
              [22.103, 60.453],
              [22.113, 60.458],
              [22.116, 60.46],
              [22.118, 60.46],
              [22.12, 60.459],
              [22.121, 60.458],
              [22.122, 60.456],
              [22.123, 60.453],
              [22.124, 60.451],
              [22.126, 60.45],
              [22.132, 60.445],
              [22.134, 60.444],
              [22.138, 60.444],
              [22.142, 60.443],
              [22.153, 60.443],
              [22.171, 60.444],
              [22.19, 60.444],
              [22.196, 60.443],
              [22.212, 60.439],
              [22.216, 60.437],
              [22.219, 60.436],
              [22.232, 60.429],
              [22.255, 60.418],
              [22.261, 60.415],
              [22.266, 60.412],
              [22.272, 60.408],
              [22.278, 60.405],
              [22.287, 60.398],
              [22.292, 60.394],
              [22.297, 60.392],
              [22.303, 60.39],
              [22.315, 60.388],
              [22.322, 60.388],
              [22.328, 60.389],
              [22.335, 60.389],
              [22.349, 60.391],
              [22.363, 60.392],
              [22.383, 60.396],
              [22.397, 60.398],
              [22.411, 60.401],
              [22.445, 60.409],
              [22.459, 60.412],
              [22.471, 60.414],
              [22.486, 60.414],
              [22.49, 60.412],
              [22.49, 60.409],
              [22.489, 60.406],
              [22.486, 60.4],
              [22.485, 60.397],
              [22.485, 60.394],
              [22.486, 60.391],
              [22.489, 60.389],
              [22.493, 60.387],
              [22.497, 60.386],
              [22.502, 60.385],
              [22.508, 60.384],
              [22.514, 60.384],
              [22.52, 60.383],
              [22.552, 60.383],
              [22.572, 60.382],
              [22.578, 60.382],
              [22.585, 60.383],
              [22.591, 60.384],
              [22.598, 60.386],
              [22.604, 60.388],
              [22.622, 60.395],
              [22.63, 60.397],
              [22.633, 60.397],
              [22.634, 60.396],
              [22.634, 60.394],
              [22.632, 60.391],
              [22.625, 60.384],
              [22.61, 60.372],
              [22.598, 60.364],
              [22.593, 60.361],
              [22.581, 60.355],
              [22.576, 60.353],
              [22.571, 60.35],
              [22.567, 60.347],
              [22.556, 60.336],
              [22.551, 60.333],
              [22.546, 60.329],
              [22.53, 60.319],
              [22.526, 60.316],
              [22.521, 60.313],
              [22.513, 60.305],
              [22.509, 60.302],
              [22.505, 60.3],
              [22.492, 60.292],
              [22.487, 60.289],
              [22.483, 60.286],
              [22.476, 60.279],
              [22.469, 60.27],
              [22.467, 60.268],
              [22.467, 60.265],
              [22.469, 60.263],
              [22.472, 60.261],
              [22.476, 60.259],
              [22.48, 60.258],
              [22.485, 60.257],
              [22.5, 60.257],
              [22.505, 60.258],
              [22.518, 60.261],
              [22.53, 60.263],
              [22.538, 60.266],
              [22.553, 60.269],
              [22.565, 60.273],
              [22.59, 60.283],
              [22.596, 60.285],
              [22.602, 60.286],
              [22.607, 60.287],
              [22.61, 60.288],
              [22.617, 60.288],
              [22.602, 60.285],
              [22.597, 60.283],
              [22.591, 60.281],
              [22.586, 60.278],
              [22.578, 60.272],
              [22.576, 60.269],
              [22.576, 60.266],
              [22.577, 60.264],
              [22.579, 60.262],
              [22.584, 60.259],
              [22.586, 60.257],
              [22.589, 60.253],
              [22.59, 60.252],
              [22.596, 60.249],
              [22.597, 60.248],
              [22.597, 60.247],
              [22.596, 60.246],
              [22.592, 60.244],
              [22.583, 60.242],
              [22.564, 60.237],
              [22.552, 60.233],
              [22.542, 60.229],
              [22.538, 60.226],
              [22.536, 60.224],
              [22.535, 60.221],
              [22.535, 60.219],
              [22.537, 60.218],
              [22.545, 60.216],
              [22.551, 60.216],
              [22.557, 60.217],
              [22.571, 60.219],
              [22.577, 60.22],
              [22.583, 60.222],
              [22.608, 60.23],
              [22.614, 60.231],
              [22.62, 60.233],
              [22.634, 60.235],
              [22.64, 60.236],
              [22.654, 60.238],
              [22.708, 60.242],
              [22.757, 60.249],
              [22.77, 60.252],
              [22.791, 60.258],
              [22.803, 60.262],
              [22.816, 60.267],
              [22.827, 60.272],
              [22.839, 60.278],
              [22.844, 60.281],
              [22.849, 60.283],
              [22.857, 60.289],
              [22.86, 60.292],
              [22.866, 60.296],
              [22.874, 60.3],
              [22.884, 60.304],
              [22.896, 60.307],
              [22.909, 60.31],
              [22.956, 60.323],
              [22.97, 60.327],
              [22.976, 60.328],
              [22.983, 60.33],
              [22.989, 60.331],
              [22.995, 60.331],
              [23.001, 60.332],
              [23.006, 60.332],
              [23.012, 60.333],
              [23.017, 60.335],
              [23.022, 60.338],
              [23.026, 60.341],
              [23.036, 60.348],
              [23.045, 60.355],
              [23.05, 60.358],
              [23.059, 60.367],
              [23.062, 60.369],
              [23.066, 60.371],
              [23.069, 60.372],
              [23.072, 60.372],
              [23.075, 60.371],
              [23.077, 60.369],
              [23.078, 60.367],
              [23.078, 60.365],
              [23.077, 60.363],
              [23.074, 60.361],
              [23.071, 60.358],
              [23.058, 60.348],
              [23.053, 60.344],
              [23.048, 60.339],
              [23.044, 60.334],
              [23.039, 60.329],
              [23.026, 60.313],
              [23.021, 60.308],
              [23.017, 60.303],
              [23.007, 60.295],
              [22.997, 60.289],
              [22.987, 60.285],
              [22.982, 60.282],
              [22.978, 60.28],
              [22.972, 60.275],
              [22.965, 60.271],
              [22.961, 60.269],
              [22.957, 60.266],
              [22.951, 60.258],
              [22.948, 60.255],
              [22.945, 60.251],
              [22.936, 60.242],
              [22.931, 60.238],
              [22.925, 60.234],
              [22.903, 60.219],
              [22.893, 60.211],
              [22.885, 60.203],
              [22.883, 60.199],
              [22.881, 60.191],
              [22.881, 60.186],
              [22.88, 60.182],
              [22.88, 60.178],
              [22.877, 60.172],
              [22.877, 60.169],
              [22.878, 60.167],
              [22.88, 60.162],
              [22.882, 60.158],
              [22.887, 60.153],
              [22.891, 60.151],
              [22.896, 60.148],
              [22.901, 60.146],
              [22.925, 60.138],
              [22.95, 60.132],
              [22.956, 60.13],
              [22.961, 60.129],
              [22.971, 60.124],
              [22.98, 60.116],
              [22.981, 60.115],
              [22.983, 60.114],
              [22.989, 60.114],
              [22.992, 60.115],
              [23, 60.117],
              [23.003, 60.119],
              [23.007, 60.121],
              [23.009, 60.123],
              [23.012, 60.125],
              [23.016, 60.127],
              [23.019, 60.128],
              [23.025, 60.128],
              [23.031, 60.127],
              [23.048, 60.127],
              [23.049, 60.126],
              [23.049, 60.125],
              [23.047, 60.123],
              [23.041, 60.119],
              [23.038, 60.116],
              [23.031, 60.11],
              [23.028, 60.108],
              [23.024, 60.105],
              [23.012, 60.097],
              [23.008, 60.089],
              [23.007, 60.088],
              [23.004, 60.087],
              [22.999, 60.083],
              [22.997, 60.082],
              [22.996, 60.08],
              [22.997, 60.077],
              [22.998, 60.075],
              [23.001, 60.072],
              [23.005, 60.069],
              [23.009, 60.068],
              [23.014, 60.066],
              [23.02, 60.065],
              [23.028, 60.064],
              [23.032, 60.064],
              [23.036, 60.063],
              [23.04, 60.061],
              [23.056, 60.055],
              [23.06, 60.053],
              [23.063, 60.05],
              [23.065, 60.049],
              [23.068, 60.049],
              [23.076, 60.05],
              [23.078, 60.05],
              [23.08, 60.049],
              [23.083, 60.047],
              [23.085, 60.047],
              [23.087, 60.046],
              [23.096, 60.046],
              [23.099, 60.047],
              [23.101, 60.049],
              [23.106, 60.053],
              [23.111, 60.055],
              [23.115, 60.058],
              [23.121, 60.06],
              [23.126, 60.061],
              [23.131, 60.063],
              [23.137, 60.064],
              [23.146, 60.065],
              [23.16, 60.068],
              [23.172, 60.07],
              [23.178, 60.07],
              [23.185, 60.071],
              [23.212, 60.071],
              [23.219, 60.07],
              [23.225, 60.069],
              [23.232, 60.068],
              [23.237, 60.066],
              [23.243, 60.065],
              [23.247, 60.064],
              [23.25, 60.062],
              [23.251, 60.06],
              [23.251, 60.058],
              [23.249, 60.057],
              [23.247, 60.055],
              [23.243, 60.053],
              [23.232, 60.048],
              [23.226, 60.046],
              [23.224, 60.046],
              [23.222, 60.048],
              [23.223, 60.052],
              [23.221, 60.056],
              [23.215, 60.059],
              [23.211, 60.059],
              [23.206, 60.06],
              [23.2, 60.06],
              [23.195, 60.061],
              [23.189, 60.061],
              [23.183, 60.06],
              [23.176, 60.06],
              [23.164, 60.058],
              [23.16, 60.056],
              [23.15, 60.053],
              [23.144, 60.05],
              [23.138, 60.048],
              [23.133, 60.045],
              [23.127, 60.042],
              [23.123, 60.039],
              [23.119, 60.035],
              [23.116, 60.031],
              [23.111, 60.023],
              [23.109, 60.02],
              [23.106, 60.018],
              [23.104, 60.017],
              [23.102, 60.017],
              [23.1, 60.016],
              [23.098, 60.017],
              [23.097, 60.017],
              [23.096, 60.018],
              [23.095, 60.02],
              [23.095, 60.029],
              [23.094, 60.032],
              [23.091, 60.034],
              [23.087, 60.036],
              [23.082, 60.038],
              [23.064, 60.041],
              [23.051, 60.043],
              [23.045, 60.043],
              [23.04, 60.044],
              [23.021, 60.044],
              [23.018, 60.043],
              [23.013, 60.043],
              [23.009, 60.041],
              [23.005, 60.04],
              [22.999, 60.036],
              [22.998, 60.034],
              [22.998, 60.031],
              [22.999, 60.029],
              [23.003, 60.025],
              [23.005, 60.024],
              [23.008, 60.022],
              [23.009, 60.019],
              [23.012, 60.013],
              [23.013, 60.009],
              [23.015, 60.007],
              [23.019, 60.002],
              [23.02, 59.998],
              [23.021, 59.995],
              [23.02, 59.992],
              [23.019, 59.99],
              [23.016, 59.988],
              [23.009, 59.984],
              [23.001, 59.98],
              [22.996, 59.979],
              [22.992, 59.977],
              [22.987, 59.977],
              [22.982, 59.976],
              [22.977, 59.977],
              [22.971, 59.977],
              [22.966, 59.978],
              [22.962, 59.98],
              [22.957, 59.981],
              [22.949, 59.985],
              [22.945, 59.986],
              [22.94, 59.986],
              [22.934, 59.987],
              [22.923, 59.987],
              [22.918, 59.985],
              [22.913, 59.984],
              [22.903, 59.98],
              [22.899, 59.979],
              [22.894, 59.978],
              [22.878, 59.977],
              [22.868, 59.975],
              [22.856, 59.975],
              [22.853, 59.977],
              [22.845, 59.982],
              [22.843, 59.983],
              [22.842, 59.985],
              [22.841, 59.986],
              [22.842, 59.99],
              [22.842, 59.992],
              [22.841, 59.994],
              [22.837, 59.998],
              [22.836, 60.001],
              [22.835, 60.003],
              [22.834, 60.006],
              [22.834, 60.013],
              [22.832, 60.015],
              [22.83, 60.016],
              [22.825, 60.016],
              [22.822, 60.015],
              [22.818, 60.011],
              [22.816, 60.007],
              [22.816, 59.998],
              [22.818, 59.988],
              [22.82, 59.984],
              [22.823, 59.979],
              [22.826, 59.976],
              [22.829, 59.972],
              [22.833, 59.969],
              [22.838, 59.965],
              [22.851, 59.956],
              [22.857, 59.95],
              [22.859, 59.947],
              [22.861, 59.941],
              [22.871, 59.931],
              [22.875, 59.928],
              [22.885, 59.922],
              [22.89, 59.92],
              [22.896, 59.918],
              [22.901, 59.917],
              [22.907, 59.915],
              [22.933, 59.91],
              [22.947, 59.908],
              [22.953, 59.907],
              [22.966, 59.907],
              [22.977, 59.908],
              [22.986, 59.909],
              [22.989, 59.91],
              [22.991, 59.91],
              [22.992, 59.911],
              [22.991, 59.911],
              [22.988, 59.912],
              [22.974, 59.913],
              [22.964, 59.914],
              [22.962, 59.914],
              [22.961, 59.915],
              [22.963, 59.917],
              [22.965, 59.918],
              [22.968, 59.918],
              [22.984, 59.921],
              [22.993, 59.922],
              [22.994, 59.922],
              [22.994, 59.923],
              [22.993, 59.925],
              [22.991, 59.927],
              [22.989, 59.928],
              [22.986, 59.93],
              [22.98, 59.933],
              [22.976, 59.937],
              [22.976, 59.939],
              [22.977, 59.94],
              [22.978, 59.942],
              [22.98, 59.943],
              [22.983, 59.943],
              [22.992, 59.941],
              [23, 59.94],
              [23.003, 59.939],
              [23.006, 59.939],
              [23.009, 59.938],
              [23.012, 59.932],
              [23.017, 59.927],
              [23.02, 59.925],
              [23.023, 59.922],
              [23.027, 59.92],
              [23.031, 59.919],
              [23.039, 59.919],
              [23.043, 59.92],
              [23.048, 59.921],
              [23.053, 59.923],
              [23.057, 59.925],
              [23.06, 59.928],
              [23.063, 59.932],
              [23.068, 59.938],
              [23.074, 59.944],
              [23.076, 59.948],
              [23.076, 59.95],
              [23.075, 59.951],
              [23.074, 59.953],
              [23.069, 59.955],
              [23.067, 59.957],
              [23.066, 59.959],
              [23.066, 59.973],
              [23.064, 59.976],
              [23.06, 59.978],
              [23.057, 59.979],
              [23.05, 59.979],
              [23.047, 59.98],
              [23.045, 59.981],
              [23.044, 59.983],
              [23.044, 59.984],
              [23.045, 59.985],
              [23.049, 59.987],
              [23.053, 59.988],
              [23.064, 59.991],
              [23.094, 60.001],
              [23.1, 60.002],
              [23.107, 60.004],
              [23.114, 60.005],
              [23.141, 60.01],
              [23.148, 60.011],
              [23.154, 60.012],
              [23.166, 60.016],
              [23.171, 60.018],
              [23.177, 60.02],
              [23.189, 60.025],
              [23.195, 60.028],
              [23.201, 60.029],
              [23.206, 60.031],
              [23.211, 60.031],
              [23.216, 60.032],
              [23.219, 60.031],
              [23.221, 60.03],
              [23.222, 60.029],
              [23.222, 60.028],
              [23.221, 60.026],
              [23.214, 60.019],
              [23.212, 60.016],
              [23.21, 60.014],
              [23.208, 60.011],
              [23.206, 60.004],
              [23.205, 60.003],
              [23.205, 60.002],
              [23.204, 60.001],
              [23.203, 60.001],
              [23.201, 60.002],
              [23.196, 60.006],
              [23.193, 60.008],
              [23.19, 60.009],
              [23.186, 60.01],
              [23.181, 60.011],
              [23.176, 60.011],
              [23.158, 60.008],
              [23.152, 60.006],
              [23.146, 60.005],
              [23.141, 60.003],
              [23.135, 60.001],
              [23.127, 59.997],
              [23.124, 59.995],
              [23.122, 59.993],
              [23.12, 59.99],
              [23.119, 59.988],
              [23.114, 59.984],
              [23.11, 59.98],
              [23.108, 59.976],
              [23.106, 59.971],
              [23.105, 59.966],
              [23.104, 59.962],
              [23.104, 59.957],
              [23.105, 59.953],
              [23.107, 59.951],
              [23.11, 59.949],
              [23.113, 59.948],
              [23.116, 59.948],
              [23.12, 59.949],
              [23.123, 59.95],
              [23.131, 59.954],
              [23.135, 59.955],
              [23.139, 59.957],
              [23.144, 59.958],
              [23.149, 59.958],
              [23.153, 59.957],
              [23.159, 59.955],
              [23.162, 59.953],
              [23.164, 59.952],
              [23.17, 59.952],
              [23.173, 59.953],
              [23.179, 59.957],
              [23.183, 59.962],
              [23.186, 59.964],
              [23.19, 59.966],
              [23.194, 59.967],
              [23.198, 59.967],
              [23.206, 59.965],
              [23.209, 59.964],
              [23.212, 59.962],
              [23.214, 59.961],
              [23.215, 59.96],
              [23.214, 59.958],
              [23.212, 59.956],
              [23.208, 59.954],
              [23.203, 59.952],
              [23.189, 59.947],
              [23.183, 59.945],
              [23.178, 59.943],
              [23.172, 59.941],
              [23.168, 59.939],
              [23.163, 59.936],
              [23.16, 59.933],
              [23.157, 59.931],
              [23.156, 59.928],
              [23.156, 59.926],
              [23.157, 59.923],
              [23.159, 59.921],
              [23.161, 59.92],
              [23.164, 59.918],
              [23.166, 59.917],
              [23.169, 59.916],
              [23.172, 59.916],
              [23.177, 59.917],
              [23.192, 59.923],
              [23.197, 59.926],
              [23.202, 59.928],
              [23.206, 59.931],
              [23.21, 59.933],
              [23.213, 59.936],
              [23.213, 59.938],
              [23.212, 59.94],
              [23.212, 59.941],
              [23.213, 59.941],
              [23.217, 59.943],
              [23.221, 59.944],
              [23.23, 59.946],
              [23.235, 59.948],
              [23.24, 59.949],
              [23.246, 59.952],
              [23.251, 59.954],
              [23.261, 59.96],
              [23.265, 59.963],
              [23.27, 59.967],
              [23.273, 59.971],
              [23.28, 59.979],
              [23.292, 59.991],
              [23.295, 59.995],
              [23.299, 60],
              [23.302, 60.005],
              [23.304, 60.011],
              [23.311, 60.027],
              [23.313, 60.031],
              [23.315, 60.034],
              [23.318, 60.036],
              [23.32, 60.037],
              [23.32, 60.036],
              [23.321, 60.035],
              [23.321, 60.032],
              [23.319, 60.024],
              [23.317, 60.018],
              [23.314, 60.013],
              [23.311, 60.007],
              [23.309, 60.001],
              [23.305, 59.996],
              [23.302, 59.99],
              [23.298, 59.984],
              [23.29, 59.974],
              [23.282, 59.966],
              [23.264, 59.95],
              [23.26, 59.947],
              [23.255, 59.944],
              [23.25, 59.942],
              [23.228, 59.931],
              [23.223, 59.928],
              [23.216, 59.924],
              [23.207, 59.92],
              [23.204, 59.919],
              [23.201, 59.917],
              [23.199, 59.916],
              [23.198, 59.914],
              [23.195, 59.911],
              [23.193, 59.91],
              [23.181, 59.906],
              [23.177, 59.904],
              [23.173, 59.901],
              [23.164, 59.895],
              [23.159, 59.893],
              [23.154, 59.89],
              [23.148, 59.889],
              [23.141, 59.887],
              [23.135, 59.886],
              [23.128, 59.886],
              [23.1, 59.883],
              [23.094, 59.882],
              [23.087, 59.881],
              [23.075, 59.879],
              [23.055, 59.871],
              [23.032, 59.865],
              [23.026, 59.864],
              [22.99, 59.852],
              [22.984, 59.851],
              [22.971, 59.849],
              [22.966, 59.848],
              [22.961, 59.846],
              [22.951, 59.844],
              [22.942, 59.841],
              [22.937, 59.839],
              [22.931, 59.837],
              [22.927, 59.835],
              [22.92, 59.83],
              [22.909, 59.823],
              [22.906, 59.821],
              [22.904, 59.819],
              [22.903, 59.817],
              [22.904, 59.815],
              [20.003, 59.819],
              [20.003, 60.105],
              [20.003, 60.104],
              [20.01, 60.103],
              [20.027, 60.103],
              [20.033, 60.104],
              [20.037, 60.106],
              [20.04, 60.109],
              [20.042, 60.112],
              [20.043, 60.114],
              [20.042, 60.117],
              [20.041, 60.119],
              [20.039, 60.122],
              [20.032, 60.128],
              [20.03, 60.131],
              [20.028, 60.133],
              [20.027, 60.135],
              [20.027, 60.142],
              [20.028, 60.146],
              [20.029, 60.149],
              [20.032, 60.156],
              [20.033, 60.16],
              [20.034, 60.165],
              [20.035, 60.169],
              [20.035, 60.18],
              [20.034, 60.182],
              [20.032, 60.185],
              [20.029, 60.187],
              [20.024, 60.189],
              [20.021, 60.19],
              [20.019, 60.191],
              [20.014, 60.196],
              [20.012, 60.2],
              [20.01, 60.208],
              [20.01, 60.227],
              [20.009, 60.232],
              [20.007, 60.236],
              [20.005, 60.241],
              [20.003, 60.243],
            ],
          ],
        ],
      },
      properties: {
        id: 46,
        name: 'Skärgårdshavet',
        latlon: [60.243083, 20.982335],
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [19.054, 59.821],
              [18.914, 59.821],
              [18.919, 59.826],
              [18.924, 59.83],
              [18.928, 59.835],
              [18.932, 59.841],
              [18.935, 59.846],
              [18.937, 59.852],
              [18.938, 59.857],
              [18.939, 59.863],
              [18.939, 59.868],
              [18.938, 59.873],
              [18.936, 59.876],
              [18.933, 59.878],
              [18.931, 59.88],
              [18.928, 59.881],
              [18.918, 59.881],
              [18.914, 59.883],
              [18.912, 59.887],
              [18.911, 59.888],
              [18.91, 59.89],
              [18.909, 59.891],
              [18.903, 59.894],
              [18.903, 59.902],
              [18.902, 59.904],
              [18.9, 59.907],
              [18.888, 59.915],
              [18.886, 59.918],
              [18.883, 59.92],
              [18.882, 59.923],
              [18.881, 59.925],
              [18.881, 59.927],
              [18.883, 59.928],
              [18.886, 59.928],
              [18.89, 59.927],
              [18.895, 59.926],
              [18.899, 59.924],
              [18.904, 59.923],
              [18.909, 59.921],
              [18.914, 59.918],
              [18.923, 59.912],
              [18.925, 59.91],
              [18.929, 59.907],
              [18.94, 59.896],
              [18.95, 59.888],
              [18.962, 59.881],
              [18.982, 59.865],
              [18.994, 59.852],
              [18.999, 59.848],
              [19.003, 59.844],
              [19.011, 59.84],
              [19.019, 59.838],
              [19.026, 59.837],
              [19.029, 59.836],
              [19.032, 59.834],
              [19.038, 59.829],
              [19.041, 59.827],
              [19.043, 59.825],
              [19.05, 59.821],
              [19.054, 59.821],
            ],
          ],
          [
            [
              [20.003, 60.521],
              [20.003, 60.368],
              [20, 60.369],
              [19.986, 60.374],
              [19.982, 60.376],
              [19.975, 60.379],
              [19.972, 60.38],
              [19.965, 60.38],
              [19.963, 60.378],
              [19.963, 60.375],
              [19.962, 60.374],
              [19.962, 60.373],
              [19.961, 60.372],
              [19.958, 60.37],
              [19.955, 60.369],
              [19.951, 60.367],
              [19.946, 60.363],
              [19.943, 60.362],
              [19.941, 60.361],
              [19.939, 60.363],
              [19.939, 60.372],
              [19.94, 60.374],
              [19.94, 60.376],
              [19.942, 60.378],
              [19.944, 60.381],
              [19.95, 60.386],
              [19.953, 60.388],
              [19.955, 60.392],
              [19.957, 60.398],
              [19.957, 60.4],
              [19.956, 60.401],
              [19.945, 60.401],
              [19.941, 60.402],
              [19.938, 60.403],
              [19.936, 60.404],
              [19.932, 60.408],
              [19.929, 60.41],
              [19.927, 60.412],
              [19.916, 60.418],
              [19.906, 60.422],
              [19.901, 60.423],
              [19.895, 60.424],
              [19.889, 60.424],
              [19.884, 60.425],
              [19.878, 60.424],
              [19.873, 60.424],
              [19.858, 60.421],
              [19.855, 60.42],
              [19.847, 60.418],
              [19.841, 60.415],
              [19.829, 60.411],
              [19.822, 60.412],
              [19.816, 60.41],
              [19.81, 60.406],
              [19.805, 60.401],
              [19.803, 60.398],
              [19.802, 60.395],
              [19.802, 60.389],
              [19.803, 60.386],
              [19.803, 60.382],
              [19.802, 60.38],
              [19.8, 60.378],
              [19.792, 60.373],
              [19.789, 60.371],
              [19.788, 60.369],
              [19.786, 60.366],
              [19.786, 60.361],
              [19.788, 60.354],
              [19.789, 60.347],
              [19.79, 60.344],
              [19.794, 60.338],
              [19.798, 60.336],
              [19.801, 60.335],
              [19.805, 60.334],
              [19.812, 60.334],
              [19.816, 60.336],
              [19.816, 60.338],
              [19.814, 60.344],
              [19.814, 60.346],
              [19.808, 60.352],
              [19.807, 60.354],
              [19.806, 60.357],
              [19.806, 60.358],
              [19.807, 60.359],
              [19.81, 60.359],
              [19.812, 60.358],
              [19.815, 60.356],
              [19.824, 60.347],
              [19.826, 60.343],
              [19.831, 60.336],
              [19.834, 60.333],
              [19.84, 60.329],
              [19.844, 60.328],
              [19.847, 60.328],
              [19.85, 60.327],
              [19.854, 60.327],
              [19.864, 60.329],
              [19.869, 60.332],
              [19.873, 60.334],
              [19.885, 60.343],
              [19.888, 60.345],
              [19.892, 60.345],
              [19.894, 60.343],
              [19.9, 60.334],
              [19.901, 60.331],
              [19.902, 60.329],
              [19.901, 60.326],
              [19.9, 60.324],
              [19.897, 60.319],
              [19.895, 60.314],
              [19.894, 60.312],
              [19.888, 60.31],
              [19.885, 60.311],
              [19.882, 60.311],
              [19.88, 60.313],
              [19.877, 60.314],
              [19.875, 60.316],
              [19.872, 60.318],
              [19.866, 60.318],
              [19.862, 60.317],
              [19.859, 60.316],
              [19.857, 60.315],
              [19.855, 60.313],
              [19.855, 60.312],
              [19.856, 60.31],
              [19.857, 60.307],
              [19.859, 60.305],
              [19.869, 60.3],
              [19.875, 60.296],
              [19.878, 60.295],
              [19.884, 60.294],
              [19.887, 60.294],
              [19.889, 60.292],
              [19.89, 60.29],
              [19.89, 60.287],
              [19.889, 60.283],
              [19.888, 60.281],
              [19.886, 60.278],
              [19.881, 60.273],
              [19.873, 60.267],
              [19.869, 60.263],
              [19.866, 60.259],
              [19.857, 60.25],
              [19.854, 60.248],
              [19.851, 60.247],
              [19.845, 60.247],
              [19.839, 60.249],
              [19.836, 60.251],
              [19.834, 60.253],
              [19.833, 60.256],
              [19.832, 60.26],
              [19.832, 60.264],
              [19.834, 60.272],
              [19.837, 60.279],
              [19.838, 60.282],
              [19.838, 60.291],
              [19.839, 60.294],
              [19.84, 60.301],
              [19.84, 60.307],
              [19.839, 60.309],
              [19.837, 60.311],
              [19.835, 60.312],
              [19.833, 60.314],
              [19.828, 60.314],
              [19.824, 60.312],
              [19.821, 60.31],
              [19.817, 60.308],
              [19.815, 60.306],
              [19.813, 60.303],
              [19.812, 60.3],
              [19.812, 60.292],
              [19.815, 60.283],
              [19.816, 60.278],
              [19.817, 60.274],
              [19.816, 60.27],
              [19.814, 60.26],
              [19.813, 60.256],
              [19.812, 60.244],
              [19.812, 60.241],
              [19.813, 60.238],
              [19.815, 60.235],
              [19.817, 60.233],
              [19.82, 60.231],
              [19.824, 60.227],
              [19.822, 60.223],
              [19.816, 60.212],
              [19.814, 60.21],
              [19.81, 60.21],
              [19.808, 60.211],
              [19.805, 60.213],
              [19.802, 60.217],
              [19.8, 60.221],
              [19.793, 60.234],
              [19.79, 60.239],
              [19.787, 60.242],
              [19.785, 60.245],
              [19.781, 60.249],
              [19.78, 60.251],
              [19.778, 60.254],
              [19.777, 60.258],
              [19.776, 60.261],
              [19.776, 60.265],
              [19.777, 60.27],
              [19.779, 60.275],
              [19.785, 60.285],
              [19.795, 60.299],
              [19.797, 60.304],
              [19.799, 60.308],
              [19.8, 60.312],
              [19.8, 60.314],
              [19.798, 60.318],
              [19.797, 60.319],
              [19.794, 60.321],
              [19.792, 60.323],
              [19.783, 60.326],
              [19.778, 60.327],
              [19.775, 60.328],
              [19.768, 60.329],
              [19.761, 60.331],
              [19.757, 60.332],
              [19.754, 60.331],
              [19.75, 60.329],
              [19.749, 60.327],
              [19.75, 60.324],
              [19.751, 60.314],
              [19.752, 60.311],
              [19.755, 60.305],
              [19.755, 60.302],
              [19.754, 60.3],
              [19.748, 60.294],
              [19.746, 60.293],
              [19.74, 60.291],
              [19.724, 60.291],
              [19.72, 60.29],
              [19.708, 60.284],
              [19.706, 60.281],
              [19.703, 60.278],
              [19.698, 60.272],
              [19.696, 60.269],
              [19.693, 60.267],
              [19.691, 60.266],
              [19.688, 60.266],
              [19.688, 60.267],
              [19.69, 60.271],
              [19.691, 60.274],
              [19.691, 60.279],
              [19.69, 60.282],
              [19.687, 60.285],
              [19.682, 60.287],
              [19.68, 60.288],
              [19.678, 60.29],
              [19.672, 60.294],
              [19.666, 60.296],
              [19.662, 60.297],
              [19.652, 60.297],
              [19.649, 60.295],
              [19.643, 60.292],
              [19.641, 60.29],
              [19.639, 60.289],
              [19.639, 60.288],
              [19.64, 60.287],
              [19.642, 60.286],
              [19.647, 60.286],
              [19.65, 60.285],
              [19.653, 60.282],
              [19.66, 60.267],
              [19.662, 60.262],
              [19.665, 60.254],
              [19.669, 60.246],
              [19.672, 60.242],
              [19.679, 60.233],
              [19.682, 60.229],
              [19.688, 60.219],
              [19.691, 60.213],
              [19.693, 60.206],
              [19.695, 60.2],
              [19.7, 60.181],
              [19.702, 60.174],
              [19.704, 60.168],
              [19.707, 60.162],
              [19.709, 60.157],
              [19.712, 60.152],
              [19.718, 60.143],
              [19.721, 60.139],
              [19.726, 60.133],
              [19.73, 60.128],
              [19.737, 60.118],
              [19.745, 60.108],
              [19.75, 60.104],
              [19.755, 60.101],
              [19.759, 60.099],
              [19.769, 60.097],
              [19.774, 60.097],
              [19.779, 60.098],
              [19.783, 60.099],
              [19.79, 60.101],
              [19.799, 60.103],
              [19.804, 60.105],
              [19.807, 60.106],
              [19.812, 60.106],
              [19.814, 60.104],
              [19.815, 60.102],
              [19.817, 60.1],
              [19.823, 60.096],
              [19.826, 60.095],
              [19.83, 60.094],
              [19.837, 60.093],
              [19.848, 60.093],
              [19.855, 60.094],
              [19.859, 60.095],
              [19.865, 60.097],
              [19.871, 60.103],
              [19.873, 60.103],
              [19.875, 60.104],
              [19.877, 60.103],
              [19.879, 60.103],
              [19.881, 60.102],
              [19.885, 60.099],
              [19.889, 60.097],
              [19.901, 60.092],
              [19.904, 60.09],
              [19.908, 60.088],
              [19.909, 60.087],
              [19.911, 60.087],
              [19.915, 60.089],
              [19.917, 60.091],
              [19.918, 60.093],
              [19.92, 60.098],
              [19.922, 60.102],
              [19.924, 60.102],
              [19.926, 60.101],
              [19.928, 60.099],
              [19.935, 60.086],
              [19.938, 60.082],
              [19.944, 60.076],
              [19.947, 60.074],
              [19.95, 60.073],
              [19.952, 60.073],
              [19.955, 60.074],
              [19.957, 60.077],
              [19.958, 60.081],
              [19.958, 60.089],
              [19.956, 60.097],
              [19.956, 60.104],
              [19.958, 60.106],
              [19.961, 60.108],
              [19.966, 60.109],
              [19.97, 60.109],
              [19.975, 60.108],
              [19.982, 60.106],
              [19.987, 60.106],
              [19.989, 60.107],
              [19.99, 60.109],
              [19.989, 60.11],
              [19.99, 60.109],
              [19.993, 60.108],
              [19.998, 60.106],
              [20.003, 60.105],
              [20.003, 59.819],
              [19.061, 59.821],
              [19.064, 59.821],
              [19.067, 59.823],
              [19.07, 59.826],
              [19.074, 59.832],
              [19.075, 59.836],
              [19.076, 59.839],
              [19.078, 59.853],
              [19.078, 59.86],
              [19.077, 59.87],
              [19.075, 59.876],
              [19.07, 59.881],
              [19.061, 59.884],
              [19.059, 59.885],
              [19.058, 59.885],
              [19.056, 59.886],
              [19.055, 59.888],
              [19.054, 59.889],
              [19.046, 59.889],
              [19.044, 59.888],
              [19.041, 59.887],
              [19.036, 59.882],
              [19.034, 59.881],
              [19.032, 59.881],
              [19.031, 59.882],
              [19.027, 59.885],
              [19.023, 59.889],
              [19.022, 59.891],
              [19.022, 59.897],
              [19.021, 59.899],
              [19.02, 59.9],
              [19.018, 59.901],
              [19.014, 59.902],
              [19.009, 59.903],
              [18.993, 59.906],
              [18.987, 59.908],
              [18.981, 59.909],
              [18.967, 59.913],
              [18.957, 59.916],
              [18.952, 59.917],
              [18.948, 59.918],
              [18.945, 59.92],
              [18.941, 59.924],
              [18.939, 59.925],
              [18.937, 59.927],
              [18.934, 59.928],
              [18.917, 59.928],
              [18.914, 59.929],
              [18.912, 59.93],
              [18.911, 59.931],
              [18.911, 59.934],
              [18.914, 59.938],
              [18.914, 59.941],
              [18.913, 59.944],
              [18.912, 59.948],
              [18.907, 59.956],
              [18.904, 59.964],
              [18.902, 59.967],
              [18.896, 59.975],
              [18.888, 59.982],
              [18.885, 59.985],
              [18.881, 59.99],
              [18.875, 60],
              [18.871, 60.004],
              [18.867, 60.009],
              [18.855, 60.023],
              [18.852, 60.028],
              [18.848, 60.033],
              [18.845, 60.038],
              [18.842, 60.044],
              [18.84, 60.05],
              [18.838, 60.055],
              [18.832, 60.072],
              [18.83, 60.078],
              [18.824, 60.09],
              [18.823, 60.093],
              [18.823, 60.099],
              [18.825, 60.105],
              [18.825, 60.11],
              [18.821, 60.114],
              [18.817, 60.116],
              [18.814, 60.117],
              [18.81, 60.118],
              [18.807, 60.119],
              [18.8, 60.119],
              [18.796, 60.118],
              [18.794, 60.117],
              [18.793, 60.115],
              [18.791, 60.114],
              [18.791, 60.109],
              [18.789, 60.107],
              [18.783, 60.106],
              [18.78, 60.105],
              [18.774, 60.101],
              [18.772, 60.098],
              [18.77, 60.094],
              [18.769, 60.089],
              [18.769, 60.078],
              [18.77, 60.072],
              [18.774, 60.058],
              [18.777, 60.052],
              [18.782, 60.038],
              [18.794, 60.012],
              [18.8, 60],
              [18.802, 59.995],
              [18.803, 59.991],
              [18.804, 59.988],
              [18.804, 59.986],
              [18.803, 59.986],
              [18.801, 59.987],
              [18.8, 59.989],
              [18.797, 59.992],
              [18.794, 59.996],
              [18.788, 60.006],
              [18.784, 60.012],
              [18.778, 60.024],
              [18.775, 60.031],
              [18.771, 60.043],
              [18.767, 60.057],
              [18.763, 60.07],
              [18.759, 60.088],
              [18.758, 60.094],
              [18.756, 60.099],
              [18.754, 60.103],
              [18.751, 60.108],
              [18.741, 60.116],
              [18.736, 60.118],
              [18.73, 60.12],
              [18.725, 60.121],
              [18.719, 60.122],
              [18.714, 60.123],
              [18.709, 60.123],
              [18.705, 60.122],
              [18.702, 60.122],
              [18.7, 60.121],
              [18.698, 60.119],
              [18.696, 60.118],
              [18.692, 60.118],
              [18.683, 60.121],
              [18.681, 60.123],
              [18.677, 60.128],
              [18.675, 60.13],
              [18.672, 60.131],
              [18.669, 60.133],
              [18.664, 60.135],
              [18.659, 60.136],
              [18.653, 60.137],
              [18.648, 60.138],
              [18.636, 60.14],
              [18.631, 60.141],
              [18.616, 60.141],
              [18.606, 60.14],
              [18.602, 60.139],
              [18.597, 60.138],
              [18.593, 60.137],
              [18.59, 60.135],
              [18.588, 60.132],
              [18.587, 60.129],
              [18.587, 60.117],
              [18.586, 60.109],
              [18.586, 60.093],
              [18.587, 60.078],
              [18.587, 60.074],
              [18.586, 60.071],
              [18.586, 60.07],
              [18.585, 60.07],
              [18.584, 60.073],
              [18.582, 60.076],
              [18.574, 60.096],
              [18.572, 60.102],
              [18.569, 60.107],
              [18.567, 60.111],
              [18.564, 60.115],
              [18.559, 60.121],
              [18.558, 60.124],
              [18.558, 60.13],
              [18.556, 60.134],
              [18.55, 60.14],
              [18.546, 60.143],
              [18.542, 60.145],
              [18.537, 60.147],
              [18.533, 60.149],
              [18.528, 60.151],
              [18.519, 60.152],
              [18.511, 60.154],
              [18.507, 60.156],
              [18.504, 60.157],
              [18.496, 60.162],
              [18.493, 60.164],
              [18.489, 60.166],
              [18.484, 60.167],
              [18.479, 60.169],
              [18.463, 60.173],
              [18.458, 60.174],
              [18.448, 60.179],
              [18.446, 60.183],
              [18.446, 60.187],
              [18.445, 60.189],
              [18.442, 60.193],
              [18.442, 60.198],
              [18.443, 60.199],
              [18.445, 60.199],
              [18.449, 60.197],
              [18.451, 60.197],
              [18.454, 60.196],
              [18.456, 60.196],
              [18.458, 60.197],
              [18.465, 60.199],
              [18.468, 60.2],
              [18.47, 60.202],
              [18.47, 60.203],
              [18.471, 60.205],
              [18.471, 60.209],
              [18.465, 60.212],
              [18.445, 60.223],
              [18.43, 60.232],
              [18.415, 60.243],
              [18.405, 60.249],
              [18.389, 60.257],
              [18.384, 60.26],
              [18.378, 60.264],
              [18.353, 60.279],
              [18.335, 60.292],
              [18.332, 60.295],
              [18.328, 60.298],
              [18.324, 60.304],
              [18.323, 60.307],
              [18.323, 60.308],
              [18.324, 60.309],
              [18.327, 60.309],
              [18.331, 60.308],
              [18.335, 60.306],
              [18.339, 60.305],
              [18.343, 60.302],
              [18.347, 60.3],
              [18.353, 60.294],
              [18.355, 60.291],
              [18.358, 60.288],
              [18.361, 60.286],
              [18.366, 60.283],
              [18.37, 60.281],
              [18.386, 60.275],
              [18.391, 60.272],
              [18.403, 60.266],
              [18.421, 60.255],
              [18.427, 60.252],
              [18.432, 60.249],
              [18.438, 60.246],
              [18.444, 60.244],
              [18.46, 60.237],
              [18.464, 60.235],
              [18.468, 60.234],
              [18.473, 60.229],
              [18.475, 60.226],
              [18.488, 60.216],
              [18.492, 60.213],
              [18.507, 60.204],
              [18.513, 60.201],
              [18.518, 60.199],
              [18.524, 60.197],
              [18.529, 60.195],
              [18.539, 60.193],
              [18.547, 60.193],
              [18.55, 60.194],
              [18.553, 60.196],
              [18.555, 60.197],
              [18.558, 60.198],
              [18.562, 60.199],
              [18.575, 60.199],
              [18.58, 60.198],
              [18.594, 60.195],
              [18.599, 60.194],
              [18.6, 60.194],
              [18.607, 60.193],
              [18.611, 60.194],
              [18.614, 60.194],
              [18.62, 60.196],
              [18.623, 60.199],
              [18.622, 60.2],
              [18.62, 60.201],
              [18.617, 60.203],
              [18.607, 60.207],
              [18.595, 60.209],
              [18.588, 60.21],
              [18.583, 60.21],
              [18.566, 60.211],
              [18.56, 60.211],
              [18.548, 60.213],
              [18.53, 60.218],
              [18.514, 60.222],
              [18.511, 60.224],
              [18.508, 60.224],
              [18.507, 60.225],
              [18.516, 60.225],
              [18.554, 60.223],
              [18.575, 60.223],
              [18.582, 60.224],
              [18.588, 60.224],
              [18.594, 60.226],
              [18.598, 60.227],
              [18.602, 60.229],
              [18.605, 60.231],
              [18.609, 60.237],
              [18.608, 60.24],
              [18.607, 60.244],
              [18.604, 60.247],
              [18.601, 60.249],
              [18.597, 60.25],
              [18.592, 60.252],
              [18.555, 60.264],
              [18.542, 60.268],
              [18.535, 60.269],
              [18.528, 60.271],
              [18.522, 60.272],
              [18.515, 60.274],
              [18.508, 60.275],
              [18.49, 60.277],
              [18.485, 60.278],
              [18.481, 60.278],
              [18.477, 60.28],
              [18.477, 60.281],
              [18.485, 60.283],
              [18.488, 60.284],
              [18.491, 60.286],
              [18.493, 60.288],
              [18.494, 60.29],
              [18.494, 60.293],
              [18.493, 60.297],
              [18.487, 60.303],
              [18.483, 60.305],
              [18.48, 60.307],
              [18.467, 60.314],
              [18.463, 60.316],
              [18.451, 60.32],
              [18.449, 60.321],
              [18.448, 60.322],
              [18.459, 60.322],
              [18.463, 60.324],
              [18.463, 60.326],
              [18.462, 60.328],
              [18.46, 60.331],
              [18.457, 60.333],
              [18.453, 60.335],
              [18.45, 60.336],
              [18.445, 60.337],
              [18.441, 60.338],
              [18.435, 60.339],
              [18.428, 60.339],
              [18.409, 60.338],
              [18.403, 60.338],
              [18.396, 60.339],
              [18.39, 60.34],
              [18.385, 60.341],
              [18.37, 60.346],
              [18.364, 60.347],
              [18.352, 60.35],
              [18.346, 60.351],
              [18.326, 60.359],
              [18.322, 60.361],
              [18.315, 60.361],
              [18.313, 60.36],
              [18.308, 60.358],
              [18.304, 60.357],
              [18.291, 60.353],
              [18.281, 60.349],
              [18.276, 60.346],
              [18.266, 60.341],
              [18.263, 60.339],
              [18.251, 60.335],
              [18.246, 60.335],
              [18.243, 60.336],
              [18.242, 60.338],
              [18.242, 60.34],
              [18.243, 60.342],
              [18.246, 60.345],
              [18.248, 60.349],
              [18.248, 60.354],
              [18.249, 60.356],
              [18.252, 60.358],
              [18.255, 60.361],
              [18.259, 60.363],
              [18.263, 60.364],
              [18.271, 60.367],
              [18.275, 60.369],
              [18.278, 60.37],
              [18.279, 60.371],
              [18.277, 60.375],
              [18.275, 60.377],
              [18.273, 60.38],
              [18.265, 60.384],
              [18.26, 60.385],
              [18.252, 60.387],
              [18.249, 60.387],
              [18.245, 60.389],
              [18.244, 60.39],
              [18.242, 60.391],
              [18.241, 60.392],
              [18.239, 60.392],
              [18.236, 60.393],
              [18.23, 60.393],
              [18.224, 60.394],
              [18.204, 60.399],
              [18.189, 60.4],
              [18.178, 60.401],
              [18.175, 60.401],
              [18.173, 60.402],
              [18.172, 60.402],
              [18.173, 60.403],
              [18.188, 60.406],
              [18.196, 60.408],
              [18.2, 60.408],
              [18.204, 60.41],
              [18.21, 60.412],
              [18.211, 60.413],
              [18.21, 60.415],
              [18.208, 60.416],
              [18.196, 60.425],
              [18.194, 60.426],
              [18.192, 60.426],
              [18.191, 60.425],
              [18.19, 60.423],
              [18.19, 60.421],
              [18.193, 60.415],
              [18.192, 60.413],
              [18.191, 60.412],
              [18.189, 60.411],
              [18.187, 60.411],
              [18.184, 60.41],
              [18.173, 60.41],
              [18.171, 60.411],
              [18.163, 60.413],
              [18.159, 60.415],
              [18.155, 60.416],
              [18.151, 60.418],
              [18.142, 60.423],
              [18.138, 60.426],
              [18.128, 60.431],
              [18.123, 60.434],
              [18.115, 60.44],
              [18.104, 60.452],
              [18.1, 60.455],
              [18.094, 60.46],
              [18.093, 60.462],
              [18.092, 60.463],
              [18.092, 60.466],
              [18.087, 60.471],
              [18.084, 60.472],
              [18.076, 60.475],
              [18.072, 60.479],
              [18.072, 60.481],
              [18.071, 60.487],
              [18.071, 60.49],
              [18.07, 60.492],
              [18.069, 60.493],
              [18.063, 60.493],
              [18.059, 60.495],
              [18.053, 60.497],
              [18.044, 60.497],
              [18.039, 60.498],
              [18.033, 60.499],
              [18.027, 60.501],
              [18.022, 60.502],
              [18.017, 60.504],
              [18.01, 60.507],
              [18.001, 60.51],
              [18, 60.51],
              [17.999, 60.511],
              [17.999, 60.513],
              [18.001, 60.515],
              [18.004, 60.517],
              [18.008, 60.52],
              [20.003, 60.521],
            ],
          ],
        ],
      },
      properties: {
        id: 45,
        name: 'Ålands hav',
        latlon: [60.166655, 19.335167],
      },
    },
  ],
};
